/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  /** The Upload scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

/** A brand (own brand or foreign) */
export type AbstractBrand = {
  /** The companies Global Location Number (GLN). */
  GLN?: Maybe<Scalars['String']['output']>;
  /** Array of address elements ordered based on the conventions of the particular country. */
  address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  biodynamicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The link to book wine experiences, hospitality, lifestyle and outdoor experiences. */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  /** The brand's id. */
  brandId: Scalars['ID']['output'];
  /** The city or village the brand is located at. */
  city?: Maybe<Scalars['String']['output']>;
  /** The people you can contact regarding this brand. */
  contacts?: Maybe<Array<BrandContact>>;
  /**
   * The level of content completeness a brand has.
   * It's mostly targeted towards the public profile.
   * The more complete a brand's content is, the more likely it is to be boosted in searches and lists.
   */
  contentLevel: Scalars['Int']['output'];
  /** The country of the profile. */
  country?: Maybe<Scalars['String']['output']>;
  /** A certain custom field, available on events and requests. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's value, available on events and requests.
   * This is a shortcut – If you need more, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields available on events and requests. */
  customFields?: Maybe<Array<CustomField>>;
  /**
   * A longer description of the brand.
   * For a shorter text, use shortDescription instead.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the brand's director.
   * @deprecated Use directorName instead.
   */
  director?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's director. */
  directorName?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently has distributors in. */
  distributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the distributor a brand currently has. */
  distributors?: Maybe<BrandDistributorConnection>;
  /** The brand's main contact email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The email to order products. */
  emailOrders?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage this producer is exporting to other countries.
   * @deprecated Use exportPercentageText instead. This will throw an error if the value entered was not an integer.
   */
  exportPercentage?: Maybe<Scalars['Int']['output']>;
  /** The percentage this producer is exporting to other countries, in text format (as entered). */
  exportPercentageText?: Maybe<Scalars['String']['output']>;
  /** The brand's facebook account or URL. */
  facebook?: Maybe<Scalars['String']['output']>;
  /** The year the brand was founded. */
  founded?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  /** Does this brand have a social compliance program? */
  hasSocialComplianceProgram?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a sustainability certification? */
  hasSustainabilityCertification?: Maybe<Scalars['Boolean']['output']>;
  /** The hospitality options this brand offers. */
  hospitalityOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use galleryImages instead. */
  imageGallery?: Maybe<Array<ImageGallery>>;
  /** The brand's instagram account or URL. */
  instagram?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  isPro?: Maybe<Scalars['Boolean']['output']>;
  /** The languages spoken at the brand's information desk. */
  languagesSpoken?: Maybe<Array<Scalars['String']['output']>>;
  /** The latitude of the profile address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The lifestyle amenities this brand offers. */
  lifestyleOfferings?: Maybe<Array<Scalars['String']['output']>>;
  logo?: Maybe<CloudinaryAsset>;
  /** The longitude of the profile address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The main image of the profile, often showing people or the location. */
  mainImage?: Maybe<CloudinaryAsset>;
  marketing?: Maybe<Array<MarketingActivity>>;
  marketingActivityTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The name shown in the profile. */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Most values are not used any more. */
  offeringTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the brand's online shop. */
  onlineShop?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar shops where you can buy products of this brand. */
  onlineShops?: Maybe<Array<OnlineShop>>;
  /** The times that the business is open. */
  openingHours?: Maybe<Array<OpeningHoursSpecification>>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  organicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The outdoor experiences this brand offers. */
  outdoorExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * A brand's owner.
   * @deprecated Not ready for primetime yet. This will be renamed to company soon.
   */
  owner?: Maybe<CompanyProfile>;
  /** The name of the profile's owner. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar Wine shops where you can buy products of this brand. */
  physicalShops?: Maybe<Array<PhysicalShop>>;
  /** The post code of the city the brand is located at. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /**
   * A part at the beginning of the brand's name that is not meant to distinguish it from other brands, e.g. "Bodega".
   * It is used to boost the rest of the name in searches.
   * It can also be displayed on a separate line when displaying the winery name.
   * This is completely optional.
   * @deprecated Use custom fields instead.
   */
  prefix?: Maybe<Scalars['String']['output']>;
  /** The price ranges the profile's brand or company offers. */
  priceRanges?: Maybe<Array<PriceRange>>;
  /** @deprecated Use brandId instead. */
  profileId: Scalars['ID']['output'];
  /** The region this company or brand belongs to. */
  region?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently seeking distributors for. */
  seekingDistributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** A short description of the brand. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** @deprecated Used for Bottlebooks Classic only. Use socialCompliancePrograms instead. */
  socialCompliance?: Maybe<Array<SocialComplianceProgram>>;
  /** The list of social compliance programs. */
  socialCompliancePrograms?: Maybe<Array<SocialComplianceProgram>>;
  /**
   * The text to be used for sorting the brand in a list.
   * The name is also used for catalog indexes,
   * so a winery called "Bodegas Juan Carlos" could have a sortName of "Carlos, Juan, Bodegas" or "Carlos Juan".
   */
  sortName?: Maybe<Scalars['String']['output']>;
  /** The state/province of the profile. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** The street the brand is located in. */
  street?: Maybe<Scalars['String']['output']>;
  /**
   * A part at the end of the brand's name that is not meant to distinguish it from other brands, e.g. "Winery".
   * It is used to boost the rest of the name in searches.
   * It can also be displayed on a separate line when displaying the winery name.
   * This is completely optional.
   * @deprecated Use custom fields instead.
   */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The list of social compliance programs. */
  sustainabilityCertifications?: Maybe<Array<SustainabilityCertification>>;
  /** The phone number of the profile. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The telephone number to order products. */
  telephoneOrders?: Maybe<Scalars['String']['output']>;
  /** The brand's twitter account or URL. */
  twitter?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Video>>;
  /** The brand's main website. */
  website?: Maybe<Scalars['String']['output']>;
  /** The wine experiences this brand offers. */
  wineExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use winemakerName instead. */
  winemaker?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's winemaker. */
  winemakerName?: Maybe<Scalars['String']['output']>;
  /** The brand's youtube account or URL. */
  youtube?: Maybe<Scalars['String']['output']>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandGlnArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandBiodynamicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandCityArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandCustomFieldArgs = {
  key: Scalars['String']['input'];
};


/** A brand (own brand or foreign) */
export type AbstractBrandCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


/** A brand (own brand or foreign) */
export type AbstractBrandDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandDirectorArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandDirectorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandDistributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BrandDistributorFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandDistributorSortInput>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandEmailArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandEmailOrdersArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandExportPercentageTextArgs = {
  format?: TextFormat;
};


/** A brand (own brand or foreign) */
export type AbstractBrandFacebookArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandFoundedArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandHospitalityOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandInstagramArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandLanguagesSpokenArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandLifestyleOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandOrganicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandOutdoorExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandOwnerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandPostalCodeArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandSeekingDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandShortDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandSlugArgs = {
  format?: InputMaybe<SlugFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandSortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandStateProvinceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandStreetArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandTelephoneArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandTelephoneOrdersArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandTwitterArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandWineExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandWinemakerArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandWinemakerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type AbstractBrandYoutubeArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** A list of brands that is sortable, filterable and can be paginated. */
export type AbstractBrandConnection = {
  edges: Array<AbstractBrandEdge>;
  nodes: Array<AbstractBrand>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AbstractBrandEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<AbstractBrand>;
  node: AbstractBrand;
  previous?: Maybe<AbstractBrand>;
};

/** An activity within Bottlebooks. */
export type Activity = {
  /** The ID of the activity. */
  activityId: Scalars['ID']['output'];
  /** The type of change made. */
  activityType: ActivityType;
  /** If the activity happened within a collection, this returns the collection. */
  collection?: Maybe<Collection>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The company that changed the field. */
  company: CompanyProfile;
  /** The ISO date that this field was changed at. */
  date: Scalars['String']['output'];
  /** The ID of the operation. Used to group a communnication sent for multiple people. */
  operationId: Scalars['String']['output'];
  /** The user who changed the field. */
  user: UserProfile;
};

export type ActivityConnection = {
  edges: Array<ActivityEdge>;
  /** Groups the activities by product or registration. */
  group: Array<ActivityGroupConnection>;
  nodes: Array<Activity>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type ActivityConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: ActivityField;
  filter?: InputMaybe<ActivityFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivityEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<Activity>;
  node: Activity;
  previous?: Maybe<Activity>;
};

export type ActivityField =
  | 'activityType'
  | 'companyId'
  | 'productId'
  | 'registrationId'
  | 'userId';

export type ActivityFilterInput = {
  activityId?: InputMaybe<IdQueryOperatorInput>;
  activityType?: InputMaybe<ActivityTypeQueryOperatorInput>;
  companyId?: InputMaybe<IdQueryOperatorInput>;
};

export type ActivityGroupConnection = {
  edges: Array<ActivityEdge>;
  fieldName: ActivityField;
  fieldValue?: Maybe<Scalars['String']['output']>;
  /** Groups the activities by product, registration or other fields. */
  group: Array<ActivityGroupConnection>;
  nodes: Array<Activity>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type ActivityGroupConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: ActivityField;
  filter?: InputMaybe<ActivityFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivityType =
  | 'PRODUCT_ADD_TO_COLLECTION'
  | 'PRODUCT_CHANGE'
  | 'PRODUCT_REMOVE_FROM_COLLECTION'
  /** The collector added the registration. */
  | 'REGISTRATION_ADDED'
  /** The collector changed a registration (for example they set the progress to completed). */
  | 'REGISTRATION_CHANGE_BY_COLLECTOR'
  /** The registration communication. */
  | 'REGISTRATION_COMMUNICATION'
  /** The exhibitor started the registration. */
  | 'REGISTRATION_STARTED';

/** Filters on the activityType. */
export type ActivityTypeQueryOperatorInput = {
  eq?: InputMaybe<ActivityType>;
  in?: InputMaybe<Array<InputMaybe<ActivityType>>>;
  ne?: InputMaybe<ActivityType>;
  nin?: InputMaybe<Array<InputMaybe<ActivityType>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityUser = {
  brandId?: Maybe<Scalars['ID']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type AddBrandsToGroupInput = {
  /** The ids of the brands to be added to the group. */
  brandIds: Array<Scalars['ID']['input']>;
  /** The id of the group to add the brand. */
  groupId: Scalars['ID']['input'];
};

export type AddBrandsToGroupResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddCompaniesRegistrationInput = {
  /** The id of the collection to add the companies. */
  collectionId: Scalars['ID']['input'];
  /** The the companies to be added to the collection. */
  companies: Array<CompanyInput>;
  /** The message to send if contacts are provided. */
  message?: InputMaybe<Scalars['String']['input']>;
};

export type AddCompaniesRegistrationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  registrations?: Maybe<Array<Maybe<Registration>>>;
  success: Scalars['Boolean']['output'];
};

export type AddCompanyRegistrationInput = {
  /** The collection where the registration is made. */
  collectionId: Scalars['ID']['input'];
  /** The company whose registration the products should be added to */
  companyId: Scalars['ID']['input'];
};

export type AddCompanyRegistrationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The id of the registration */
  registration: Registration;
  success: Scalars['Boolean']['output'];
};

export type AddExternalAssetInput = {
  /** The file content type. */
  contentType: FileContentType;
  /** The name of the external file. */
  filename: Scalars['String']['input'];
  /** The languages used in the file. */
  languages: Array<Scalars['String']['input']>;
  /** The id of the node relationship (productId). */
  nodeId: Scalars['ID']['input'];
  /** The url of the external file. */
  url: Scalars['String']['input'];
};

export type AddExternalAssetResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The file if successful. */
  file?: Maybe<File>;
  message: Scalars['String']['output'];
  /**
   * The node the file is added to.
   * You can query the files field there to get the new order.
   */
  node?: Maybe<Item>;
  success: Scalars['Boolean']['output'];
};

export type AddProductsToProductListInput = {
  productIds: Array<Scalars['ID']['input']>;
  productListId: Scalars['ID']['input'];
};

export type AddProductsToProductListResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  productList?: Maybe<ShareList>;
  productListId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddProductsToRegistrationInput = {
  /** The collection where the registration is made. */
  collectionId: Scalars['ID']['input'];
  /** The company whose registration the products should be added to */
  companyId: Scalars['ID']['input'];
  /** The products to add */
  productIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type AddProductsToRegistrationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The Collection object */
  collection: Collection;
  /** The Collection object */
  event: Event;
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The Registration object */
  registration: Registration;
  /** The id of the registration */
  registrationId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddRequestToRegisteredProductInput = {
  collectionId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
};

export type AddRequestToRegisteredProductResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The id of the requestedProduct */
  productRequestId: Scalars['ID']['output'];
  /** The newly created requested product. */
  requestedProduct: Unstable_RequestedProduct;
  success: Scalars['Boolean']['output'];
};

export type AddRequestedProductToRegistrationInput = {
  collectionId: Scalars['ID']['input'];
  productExternalId?: InputMaybe<Scalars['ID']['input']>;
  productRequestExternalId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
  requestedBottleGTIN?: InputMaybe<Scalars['String']['input']>;
  requestedName: Scalars['String']['input'];
  requestedVintage?: InputMaybe<Scalars['String']['input']>;
};

export type AddRequestedProductToRegistrationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The id of the requestedProduct */
  productRequestId: Scalars['ID']['output'];
  /** The newly created requested product. */
  requestedProduct: Unstable_RequestedProduct;
  success: Scalars['Boolean']['output'];
};

export type AddUserToWorkspaceInput = {
  /** The roles the user should be added to. */
  roles: Array<WorkspaceUserRole>;
  /** The id of the user to be added. If none is provided, the the logged in user is added. */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the workspace to add the user to. */
  workspaceId: Scalars['ID']['input'];
};

export type AddUserToWorkspaceResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  workspaceUser?: Maybe<WorkspaceUser>;
};

export type AddVisitorInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  linkedInURL?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type Alias = {
  name?: Maybe<Scalars['String']['output']>;
};

export type AliasImportOptionsInput = {
  newRequests?: InputMaybe<Scalars['Boolean']['input']>;
  updateRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiToken = {
  /** Number of API invocations using this token. */
  callCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type AppointmentInput = {
  /** The description of availability. */
  description: Scalars['String']['input'];
  /** Specific times requested. Currently not used. */
  suggestedTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The array of products returned may have nulls in the list. */
export type ArchiveMultipleProductsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<Product>>>;
  success: Scalars['Boolean']['output'];
};

export type ArchiveProductResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  product?: Maybe<Product>;
  success: Scalars['Boolean']['output'];
};

export type AttachFileInput = {
  /**
   * The id of the file to attach it before.
   * If left empty, the file will be put to the end of the list.
   */
  beforeFileId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the file to attach. */
  fileId: Scalars['ID']['input'];
  /**
   * The node id to which the file will be attached, such as the productId.
   * If the file is already attached to the product, it will be reordered to the new position within the attachments.
   */
  nodeId: Scalars['ID']['input'];
  /** The node's typename (e.g. Product or Brand). */
  nodeType?: Scalars['String']['input'];
};

export type AttachFileResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The attached file if successful. */
  file?: Maybe<File>;
  message: Scalars['String']['output'];
  /**
   * The node the file is added to.
   * You can query the files field there to get the new order.
   */
  node?: Maybe<Item>;
  success: Scalars['Boolean']['output'];
};

export type AttachedNodeConnection = Connection & {
  edges: Array<Edge>;
  nodes: Array<Item>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Beer = ExtendedProduct & Item & Product & {
  /**
   * The GTIN of the product.
   *
   * Returns the GTIN of the first product variant.
   */
  GTIN?: Maybe<Scalars['String']['output']>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_childProducts: Array<Unstable_CoreProduct>;
  /**
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_packaging: Array<ProductPackaging>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_parentProduct?: Maybe<Unstable_CoreProduct>;
  /** @deprecated Don't use - will be deleted soon! */
  _unstable_parentProductDifferences: Array<ProductVersionChange>;
  /**
   * A list of private workspace-owned events.
   *
   * This can be used to get all the field configurations for a product to edit.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioConfigurations: Array<Event>;
  /**
   * A list of registeredProduct entries.
   * This can be used for collection-based Portfolio.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioRegisteredProducts: RegisteredProductConnection;
  /**
   * The primary packaging (typically a bottle).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_primaryPackaging?: Maybe<PrimaryProductPackaging>;
  /**
   * The secondary packaging (typically a case).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_secondaryPackaging?: Maybe<SecondaryProductPackaging>;
  /**
   * The tertiary packaging (typically a pallet).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_tertiaryPackaging?: Maybe<TertiaryProductPackaging>;
  /**
   * A product's workspace.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_workspace: Workspace;
  /** The measurement method of the total acidity. */
  acidityUnit?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage of alcohol actually measured.
   * This is the analytical value measured in the lab.
   * This value is normally not communicated, only for some professional tastings.
   */
  actualAlcohol?: Maybe<Scalars['Float']['output']>;
  /**
   * The percentage of alcohol as displayed on the label.
   * This is often rounded according to local regulations.
   */
  alcohol?: Maybe<Scalars['Float']['output']>;
  /** Utility function to get all allergens as a single line of text. */
  allergensText?: Maybe<Scalars['String']['output']>;
  animalProducts?: Maybe<Scalars['Boolean']['output']>;
  /** The color of the product. */
  apparentColor?: Maybe<Scalars['String']['output']>;
  /** The appearance description for this product. */
  appearanceDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity of the appearance. */
  appearanceIntensity?: Maybe<Scalars['String']['output']>;
  /** Floral hints on the aroma. */
  aromaFloral?: Maybe<Scalars['String']['output']>;
  /** Fruity notes on the aroma. */
  aromaFruit?: Maybe<Scalars['String']['output']>;
  /** The intensity of the aroma. */
  aromaIntensity?: Maybe<Scalars['String']['output']>;
  /** Spicy aspects of the aroma. */
  aromaSpice?: Maybe<Scalars['String']['output']>;
  /** Wooden scents on that product. */
  aromaWood?: Maybe<Scalars['String']['output']>;
  awards?: Maybe<Array<BeerAward>>;
  backLabelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use backLabelImage { url } instead. */
  backLabelImageUrl?: Maybe<Scalars['String']['output']>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  /** @deprecated Use biodynamicCertificate instead */
  biodynamicCertificateUrl?: Maybe<Scalars['String']['output']>;
  bottleImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use bottleImage { url } instead. */
  bottleImageUrl?: Maybe<Scalars['String']['output']>;
  bottleVariants?: Maybe<Array<ProductBottleVariant>>;
  /**
   * The bottles per case.
   *
   * Returns the bottles per case of the first packaging variant.
   */
  bottlesPerCase?: Maybe<Scalars['Int']['output']>;
  bottlingDate?: Maybe<Scalars['String']['output']>;
  /** The sugars per 100ml in grams. */
  carbohydrateSugars?: Maybe<Scalars['Float']['output']>;
  /** The carbohydrate per 100ml in grams. */
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  /**
   * The GTIN of the product case.
   *
   * Returns the GTIN of the first packaging variant.
   */
  caseGTIN?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<ProductCertification>>;
  characteristics?: Maybe<Array<Maybe<ProductCharacteristicEnum>>>;
  /** The profile of the importer, retailer or company behind the product. */
  companyProfile?: Maybe<CompanyProfile>;
  /** The product description target consumers. */
  consumerDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the consumer product variant (typically the vintage of a wine or any other information).
   * @deprecated Experimental - use at your own risk.
   */
  consumerProductVariant?: Maybe<Scalars['String']['output']>;
  containsCelery?: Maybe<Scalars['Boolean']['output']>;
  containsCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  containsEggs?: Maybe<Scalars['Boolean']['output']>;
  containsFish?: Maybe<Scalars['Boolean']['output']>;
  containsGluten?: Maybe<Scalars['Boolean']['output']>;
  containsLupin?: Maybe<Scalars['Boolean']['output']>;
  containsMilk?: Maybe<Scalars['Boolean']['output']>;
  containsMolluscs?: Maybe<Scalars['Boolean']['output']>;
  containsMustard?: Maybe<Scalars['Boolean']['output']>;
  containsNuts?: Maybe<Scalars['Boolean']['output']>;
  containsPeanuts?: Maybe<Scalars['Boolean']['output']>;
  containsSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  containsSoybeans?: Maybe<Scalars['Boolean']['output']>;
  containsSulfites?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A number describing the product's content completeness.
   * The guiding principle is that those pieces of content must be valuable to the majority of visitors.
   * Currently bottle image, alcohol, wine description, webshop, food pairing description
   * and product videos are fields that each raise the content level.
   * The content level calculation will change and mature over time, similar to the Google PageRank.
   */
  contentLevel: Scalars['Int']['output'];
  /** The country the product was produced in. */
  country?: Maybe<Scalars['String']['output']>;
  /** A certain custom field, available on events and requests. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's raw text.
   * This is the shortest path to a custom field's value and always returns the raw text.
   * If you need to get typed values and more metadata, use customField instead.
   */
  customFieldText?: Maybe<Scalars['String']['output']>;
  /**
   * A certain custom field's value, available on events and requests.
   * This is a shortcut – If you need more, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields available on events and requests. */
  customFields?: Maybe<Array<CustomField>>;
  /** The customized name of the region. */
  customRegion?: Maybe<Scalars['String']['output']>;
  /** The customized name of the subregion. */
  customSubregion?: Maybe<Scalars['String']['output']>;
  /**
   * An Excel document containing all the product data in a printable format,
   * also enabling data extraction and reuse.
   */
  dataFile?: Maybe<ProductDataFile>;
  /**
   * The name of the denomination. This extends the logic of regionName and
   * uses custom logic for specific regions such as Spain and Austria.
   */
  denomination?: Maybe<Scalars['String']['output']>;
  /** The product description for the trade. */
  description?: Maybe<Scalars['String']['output']>;
  /** The product's related e-labels. */
  eLabels: ELabelConnection;
  /** The energy value in kcal per 100ml. */
  energyKcal?: Maybe<Scalars['Float']['output']>;
  /** The energy value in kJ per 100ml. */
  energyKj?: Maybe<Scalars['Float']['output']>;
  /** The exhibitor presenting a product at an event. */
  exhibitor?: Maybe<Exhibitor>;
  /** The ID of an exhibitor presenting the product at an event. */
  exhibitorId?: Maybe<Scalars['ID']['output']>;
  /** The fat per 100ml in grams. */
  fat?: Maybe<Scalars['Float']['output']>;
  /** A list of content features that make this product more valuable to visitors than other products. */
  featuredContentTypes?: Maybe<Array<FeaturedProductContentType>>;
  fileLibrary?: Maybe<Array<ProductFileAttachment>>;
  /** Shows files attached to this product. */
  files?: Maybe<FileConnection>;
  /**
   * The list of fining agents used.
   * If null, the fining agents are not known.
   * If an empty array, there were no fining agents used.
   */
  finingAgents?: Maybe<Array<Scalars['String']['output']>>;
  /** The finish description for this product. */
  finishDescription?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  history?: Maybe<Array<Maybe<HistoryEntry>>>;
  /** A printable product info sheet as a PDF. */
  infoSheet?: Maybe<ProductInfoSheet>;
  ingredients?: Maybe<Array<ProductIngredient>>;
  /** Utility function to get all ingredients as a string. */
  ingredientsText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryAromas instead. */
  intenseAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryFlavors instead. */
  intenseFlavors?: Maybe<Array<Scalars['String']['output']>>;
  internationalCertifications?: Maybe<Array<InternationalProductCertification>>;
  /**
   * The inventory ID specific to the company.
   * @deprecated Use productExternalId instead.
   */
  inventoryId?: Maybe<Scalars['String']['output']>;
  /**
   * The secondary inventory ID specific to the company.
   * @deprecated Use productExternalId2 instead.
   */
  inventoryId2?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCelery instead. */
  isCelery?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCrustaceans instead. */
  isCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsEggs instead. */
  isEggs?: Maybe<Scalars['Boolean']['output']>;
  isFairtrade?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsFish instead. */
  isFish?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsGluten instead. */
  isGluten?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is this product free of genetically modified organisms?
   * "Not sure", "not asked" and "not answered" all resolve to null.
   */
  isGmoFree?: Maybe<Scalars['Boolean']['output']>;
  isKosher?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsLupin instead. */
  isLupin?: Maybe<Scalars['Boolean']['output']>;
  isMevushal?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMilk instead. */
  isMilk?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMolluscs instead. */
  isMolluscs?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMustard instead. */
  isMustard?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsNuts instead. */
  isNuts?: Maybe<Scalars['Boolean']['output']>;
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsPeanuts instead. */
  isPeanuts?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSesameSeeds instead. */
  isSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSoybeans instead. */
  isSoybeans?: Maybe<Scalars['Boolean']['output']>;
  isSustainable?: Maybe<Scalars['Boolean']['output']>;
  isVegan?: Maybe<Scalars['Boolean']['output']>;
  isVegetarian?: Maybe<Scalars['Boolean']['output']>;
  labelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use labelImage { url } instead. */
  labelImageUrl?: Maybe<Scalars['String']['output']>;
  localCertifications?: Maybe<Array<LocalProductCertification>>;
  /** Low / no alcohol statement. */
  lowNoAlcoholStatement?: Maybe<Scalars['String']['output']>;
  lwinId?: Maybe<Scalars['String']['output']>;
  /**
   * The amount of malic acid in grams/liter.
   * This value is not commonly communicated.
   */
  malicAcid?: Maybe<Scalars['Float']['output']>;
  /** Notes on how to market this wine. */
  marketingNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryAromas instead. */
  mildAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryFlavors instead. */
  mildFlavors?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  /** The nose description for this product. */
  noseDescription?: Maybe<Scalars['String']['output']>;
  onlineShop?: Maybe<Scalars['String']['output']>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  /** Awards not in the list of recognized awards. Free text. */
  otherAwards?: Maybe<Scalars['String']['output']>;
  /** All sustainability certifications not covered in localCertifications and internationalCertifications can be added as free text. */
  otherSustainabilityCertifications?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use productRange instead. */
  ownClassification?: Maybe<Scalars['String']['output']>;
  /** The packaging gas used. This is automatically included in ingredientsText. */
  packagingGasesFunction?: Maybe<Scalars['String']['output']>;
  packagingVariants?: Maybe<Array<ProductPackagingVariant>>;
  /** The food pairing description for this product. */
  pairingDescription?: Maybe<Scalars['String']['output']>;
  /** Food pairings that match well with the product. */
  pairings?: Maybe<Array<Scalars['String']['output']>>;
  /** The color of the product. */
  palateAcidity?: Maybe<Scalars['String']['output']>;
  /** The body of the product. */
  palateBody?: Maybe<Scalars['String']['output']>;
  /** The palate description for this product. */
  palateDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity on the palate. */
  palateIntensity?: Maybe<Scalars['String']['output']>;
  /** The tannins of the product. */
  palateTannins?: Maybe<Scalars['String']['output']>;
  /**
   * The GTIN of the pallet.
   *
   * Returns the pallet GTIN of the first packaging variant.
   */
  palletGTIN?: Maybe<Scalars['String']['output']>;
  /**
   * The list of permissions on the product.
   * @deprecated We're considering to replace the list of strings with particular fields to reduce the data load when you just need a few permissions.
   */
  permissionList?: Maybe<Array<ProductRolesEnum>>;
  permissions: ProductPermissions;
  pressAnecdotes?: Maybe<Scalars['String']['output']>;
  /**
   * A price for this product.
   * @deprecated Use registeredProduct.pricing instead.
   */
  pricing?: Maybe<ProductPrice>;
  /** A list of primary aromas in the nose. */
  primaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of primary flavors on the palate. */
  primaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  /** The product's producer. */
  producer?: Maybe<Producer>;
  productCategory?: Maybe<ProductCategory>;
  /** productExternalId Should represent unique product ID specific to the company. Former inventoryId */
  productExternalId?: Maybe<Scalars['String']['output']>;
  /** productExternalId2 Should represent additional product ID specific to the company. Former inventoryId2 */
  productExternalId2?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productRange?: Maybe<Scalars['String']['output']>;
  productType: ProductType;
  /** The protein per 100ml in grams. */
  protein?: Maybe<Scalars['Float']['output']>;
  /**
   * The name that the customer is using internally to refer to this product.
   * @deprecated Experimental - use at your own risk.
   */
  referenceName?: Maybe<Scalars['String']['output']>;
  /**
   * The region the product was produced in.
   * This is one of the officialy recognized regions of the country.
   * Regions are often subdivided into subregions - that value can be found on Product.subregion.
   */
  region?: Maybe<Scalars['String']['output']>;
  /** The region hierarchy of a product, starting with country. */
  regionHierarchy?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The name of the subregion, region or country – whichever has a value:
   * - For products with subregion, the subregion is returned.
   * - For products with region only, the region is returned.
   * - For products with country, the country is returned.
   * - For products using custom names, the custom name is returned.
   */
  regionName?: Maybe<Scalars['String']['output']>;
  /** The sugar in grams/liter. */
  residualSugar?: Maybe<Scalars['Float']['output']>;
  /** The salt per 100ml in grams. */
  salt?: Maybe<Scalars['Float']['output']>;
  /** The saturates per 100ml in grams. */
  saturatedFat?: Maybe<Scalars['Float']['output']>;
  /** A list of secondary aromas in the nose. */
  secondaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of secondary flavors on the palate. */
  secondaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  shortName: Scalars['String']['output'];
  /**
   * A list of content features that make this product more valuable to visitors than other products.
   * The useIdOnly flag is deprecated, use format=ID instead.
   */
  slug: Scalars['String']['output'];
  /** A stand on an event. */
  stand?: Maybe<Stand>;
  status?: Maybe<ProductStatus>;
  /**
   * The product name in a structured format.
   * @deprecated Used internally only and not ready for production - use name instead.
   */
  structuredName?: Maybe<StructuredProductName>;
  style?: Maybe<Scalars['String']['output']>;
  /**
   * The subregion the product was produced in.
   * This is one of the officialy recognized subregions of the region.
   */
  subregion?: Maybe<Scalars['String']['output']>;
  suggestedCategory?: Maybe<ProductCategory>;
  sulfurAdded?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use otherSustainabilityCertifications instead. */
  sustainabilityCertificatesOther?: Maybe<Scalars['String']['output']>;
  sustainabilityId?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tastingNotes?: Maybe<Array<ProductTastingNote>>;
  /** The total acidity in grams/liter. */
  totalAcidity?: Maybe<Scalars['Float']['output']>;
  /** An ISO date when the product was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Shows the collections this product is used in. */
  usedIn?: Maybe<ProductUsedInConnection>;
  /** Shows the e-labels where this product is used in. */
  usedInELabels?: Maybe<ProductUsedInELabelsConnection>;
  /**
   * The name of the product variant (bottle size, closure or other differentiating factor?
   * @deprecated Experimental - use at your own risk.
   */
  variantName?: Maybe<Scalars['String']['output']>;
  /** Product videos (Youtube, Vimeo, Instagram, Facebook etc.) */
  videos?: Maybe<Array<Maybe<Video>>>;
  /** The volume of each portion. */
  volumeOfPortion?: Maybe<Scalars['Float']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type BeerGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type Beer_Unstable_ChildProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Beer_Unstable_PackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Beer_Unstable_ParentProductArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Beer_Unstable_ParentProductDifferencesArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Beer_Unstable_PortfolioConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Beer_Unstable_PortfolioRegisteredProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Beer_Unstable_PrimaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Beer_Unstable_SecondaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Beer_Unstable_TertiaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Beer_Unstable_WorkspaceArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type BeerAcidityUnitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerApparentColorArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerAppearanceDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type BeerAppearanceIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerAromaFloralArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerAromaFruitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerAromaIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerAromaSpiceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerAromaWoodArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerBottlingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BeerCaseGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type BeerConsumerDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type BeerConsumerProductVariantArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type BeerCustomFieldArgs = {
  key: Scalars['String']['input'];
};


export type BeerCustomFieldTextArgs = {
  key: Scalars['String']['input'];
};


export type BeerCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


export type BeerCustomRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerCustomSubregionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerDataFileArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type BeerDenominationArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type BeerDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type BeerELabelsArgs = {
  filter?: InputMaybe<ELabelFilterInput>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type BeerFilesArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
  filter?: InputMaybe<ProductFileFilterInput>;
};


export type BeerFiningAgentsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerFinishDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type BeerHistoryArgs = {
  filter?: InputMaybe<ProductHistoryFilterInput>;
};


export type BeerInfoSheetArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<ContentLocale>;
};


export type BeerIngredientsTextArgs = {
  format?: InputMaybe<IngredientsTextFormat>;
};


export type BeerIntenseAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerIntenseFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerInventoryIdArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerInventoryId2Args = {
  format?: InputMaybe<TextFormat>;
};


export type BeerMildAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerMildFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerNameArgs = {
  format?: InputMaybe<TextFormat>;
  includeProducer?: InputMaybe<IncludeProducer>;
};


export type BeerNoseDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type BeerOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type BeerOtherAwardsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type BeerOtherSustainabilityCertificationsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type BeerPackagingGasesFunctionArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerPairingDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type BeerPairingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerPalateAcidityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerPalateBodyArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerPalateDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type BeerPalateIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerPalateTanninsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerPalletGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type BeerPressAnecdotesArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerPrimaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerPrimaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerProductCategoryArgs = {
  withSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BeerProductExternalIdArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerProductExternalId2Args = {
  format?: InputMaybe<TextFormat>;
};


export type BeerProductRangeArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerReferenceNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerRegionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type BeerRegionHierarchyArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type BeerRegionNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type BeerSecondaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerSecondaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerShortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerSlugArgs = {
  format?: InputMaybe<SlugFormat>;
  useIdOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BeerStructuredNameArgs = {
  algorithm?: InputMaybe<Scalars['String']['input']>;
};


export type BeerStyleArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BeerSubregionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type BeerTaglineArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerUsedInArgs = {
  filter?: InputMaybe<ProductUsedInFilterInput>;
};


export type BeerVariantNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BeerWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** An award given to a particular beer. */
export type BeerAward = ProductAward & {
  award?: Maybe<Scalars['String']['output']>;
  medal?: Maybe<Scalars['String']['output']>;
};


/** An award given to a particular beer. */
export type BeerAwardAwardArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** An award given to a particular beer. */
export type BeerAwardMedalArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type BlockTimeslotInput = {
  /** The start date and time of the meeting. */
  start: Scalars['String']['input'];
};

export type BlockTimeslotResponse = MutationResponse & {
  code: Scalars['String']['output'];
  meeting?: Maybe<Meeting>;
  message: Scalars['String']['output'];
  organizerToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * A filter input type for boolean fields.
 * Use to show deleted collections for example.
 */
export type BooleanQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BottlebooksFunction =
  | 'ADD_PRODUCT'
  | 'ADD_TO_SHARE_LIST'
  | 'ARCHIVE_PRODUCTS'
  | 'DOWNLOAD_DATA_FILE'
  | 'DOWNLOAD_INFO_SHEET'
  | 'DUPLICATE_PRODUCTS'
  | 'EXPORT_PRODUCTS'
  | 'MERGE_PRODUCTS'
  | 'PRODUCT_LIFECYCLE'
  | 'ROLL_OVER_VINTAGES'
  | 'SHARE';

export type BottlebooksObject =
  | 'ALIAS'
  | 'ELABEL'
  | 'PARTNER'
  | 'PRODUCT'
  | 'PRODUCT_REQUEST'
  | 'PROFILE'
  | 'REGISTRATION';

/** A brand (own brand or foreign) */
export type Brand = AbstractBrand & Item & Profile & {
  /** The companies Global Location Number (GLN). */
  GLN?: Maybe<Scalars['String']['output']>;
  /** Array of address elements ordered based on the conventions of the particular country. */
  address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  biodynamicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The link to book wine experiences, hospitality, lifestyle and outdoor experiences. */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['ID']['output'];
  /** The city or village the brand is located at. */
  city?: Maybe<Scalars['String']['output']>;
  /** A single event, request, product list or share list. */
  collection?: Maybe<Collection>;
  /** The list of events, requests, product lists and share lists of the brand. */
  collections: CollectionConnection;
  configuration?: Maybe<WorkspaceConfiguration>;
  /** The people you can contact regarding this brand. */
  contacts?: Maybe<Array<BrandContact>>;
  /**
   * The level of content completeness a brand has.
   * It's mostly targeted towards the public profile.
   * The more complete a brand's content is, the more likely it is to be boosted in searches and lists.
   */
  contentLevel: Scalars['Int']['output'];
  /** The country of the profile. */
  country?: Maybe<Scalars['String']['output']>;
  /** A certain custom field, available on events and requests. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's value, available on events and requests.
   * This is a shortcut – If you need more, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields available on events and requests. */
  customFields?: Maybe<Array<CustomField>>;
  /** A data import. */
  dataImport?: Maybe<DataImport>;
  /**
   * Shows brand imports.
   * Filters aren't implemented yet.
   */
  dataImports: DataImportConnection;
  /**
   * A longer description of the brand.
   * For a shorter text, use shortDescription instead.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the brand's director.
   * @deprecated Use directorName instead.
   */
  director?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's director. */
  directorName?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently has distributors in. */
  distributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the distributor a brand currently has. */
  distributors?: Maybe<BrandDistributorConnection>;
  /** The brand's main contact email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The email to order products. */
  emailOrders?: Maybe<Scalars['String']['output']>;
  /** The list of filds that should be included in the export */
  exportConfigurations: Array<Maybe<ExportConfiguration>>;
  /**
   * The percentage this producer is exporting to other countries.
   * @deprecated Use exportPercentageText instead. This will throw an error if the value entered was not an integer.
   */
  exportPercentage?: Maybe<Scalars['Int']['output']>;
  /** The percentage this producer is exporting to other countries, in text format (as entered). */
  exportPercentageText?: Maybe<Scalars['String']['output']>;
  /** The brand's facebook account or URL. */
  facebook?: Maybe<Scalars['String']['output']>;
  /** The SaaS features a brand has enabled. */
  features?: Maybe<Array<CompanyFeatures>>;
  /** Shows files attached to this product. */
  file?: Maybe<File>;
  /**
   * Shows files attached to this brand.
   * Filters aren't implemented yet.
   */
  files?: Maybe<FileConnection>;
  /** The year the brand was founded. */
  founded?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  /** Returns a specific group */
  group?: Maybe<Group>;
  groups: GroupConnection;
  /** Does this brand have a social compliance program? */
  hasSocialComplianceProgram?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a sustainability certification? */
  hasSustainabilityCertification?: Maybe<Scalars['Boolean']['output']>;
  history?: Maybe<Array<Maybe<HistoryEntry>>>;
  /** The hospitality options this brand offers. */
  hospitalityOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use galleryImages instead. */
  imageGallery?: Maybe<Array<ImageGallery>>;
  impportToolPartners: PartnerConnection;
  /** The brand's instagram account or URL. */
  instagram?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  isPro?: Maybe<Scalars['Boolean']['output']>;
  /** The languages spoken at the brand's information desk. */
  languagesSpoken?: Maybe<Array<Scalars['String']['output']>>;
  /** The latitude of the profile address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The lifestyle amenities this brand offers. */
  lifestyleOfferings?: Maybe<Array<Scalars['String']['output']>>;
  logo?: Maybe<CloudinaryAsset>;
  /** The longitude of the profile address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  mainImage?: Maybe<CloudinaryAsset>;
  marketing?: Maybe<Array<MarketingActivity>>;
  marketingActivityTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Registrations to groups (foreign or also own events). */
  myGroupRegistrations?: Maybe<SingleRegistrationConnection>;
  /** The brands that this company works with. */
  myPartners: PartnerConnection;
  /** The name shown in the profile. */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Most values are not used any more. */
  offeringTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the brand's online shop. */
  onlineShop?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar shops where you can buy products of this brand. */
  onlineShops?: Maybe<Array<OnlineShop>>;
  /** The times that the business is open. */
  openingHours?: Maybe<Array<OpeningHoursSpecification>>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  organicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The outdoor experiences this brand offers. */
  outdoorExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** A brand that this company owns. */
  ownBrand?: Maybe<Brand>;
  /** The brands that this company owns. */
  ownBrands: BrandConnection;
  /**
   * A brand's owner.
   * @deprecated Not ready for primetime yet. This will be renamed to company soon.
   */
  owner?: Maybe<CompanyProfile>;
  /** The name of the profile's owner. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** A brand that this company works with. */
  partner?: Maybe<Brand>;
  /** The brands that this company works with. */
  partners: BrandConnection;
  /** Brick-and-mortar Wine shops where you can buy products of this brand. */
  physicalShops?: Maybe<Array<PhysicalShop>>;
  /** The post code of the city the brand is located at. */
  postalCode?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  /** The price ranges the profile's brand or company offers. */
  priceRanges?: Maybe<Array<PriceRange>>;
  /** A producer that this company works with. */
  producer?: Maybe<Brand>;
  /** The producers that this company works with. */
  producers: ProducerConnection;
  /** A single product from a company's portfolio. */
  product?: Maybe<Product>;
  /** A single product list. */
  productList?: Maybe<ProductList>;
  /** The list of product lists of the brand. */
  productLists: ProductListConnection;
  /** The list of products in the company's portfolio. */
  products: ProductConnection;
  /** @deprecated Use brandId instead. */
  profileId: Scalars['ID']['output'];
  /** The region this company or brand belongs to. */
  region?: Maybe<Scalars['String']['output']>;
  /** Registration of this brand. */
  registration?: Maybe<Registration>;
  /** Registrations to events (foreign or also own events). */
  registrations?: Maybe<MixedRegistrationConnection>;
  roles: Array<BrandRolesEnum>;
  /** Returns the countries that the brand currently seeking distributors for. */
  seekingDistributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** A single share list. */
  shareList?: Maybe<ShareList>;
  /** The list of share lists of the brand. */
  shareLists: ShareListConnection;
  /** A short description of the brand. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** @deprecated Used for Bottlebooks Classic only. Use socialCompliancePrograms instead. */
  socialCompliance?: Maybe<Array<SocialComplianceProgram>>;
  /** The list of social compliance programs. */
  socialCompliancePrograms?: Maybe<Array<SocialComplianceProgram>>;
  /**
   * The text to be used for sorting the brand in a list.
   * The name is also used for catalog indexes,
   * so a winery called "Bodegas Juan Carlos" could have a sortName of "Carlos, Juan, Bodegas" or "Carlos Juan".
   */
  sortName?: Maybe<Scalars['String']['output']>;
  /** The state/province of the profile. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** The street the brand is located in. */
  street?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  /** The list of social compliance programs. */
  sustainabilityCertifications?: Maybe<Array<SustainabilityCertification>>;
  /** The phone number of the profile. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The telephone number to order products. */
  telephoneOrders?: Maybe<Scalars['String']['output']>;
  /** The brand's twitter account or URL. */
  twitter?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<BrandUser>>>;
  videos?: Maybe<Array<Video>>;
  /** The brand's main website. */
  website?: Maybe<Scalars['String']['output']>;
  /** The wine experiences this brand offers. */
  wineExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use winemakerName instead. */
  winemaker?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's winemaker. */
  winemakerName?: Maybe<Scalars['String']['output']>;
  /** The brand's youtube account or URL. */
  youtube?: Maybe<Scalars['String']['output']>;
};


/** A brand (own brand or foreign) */
export type BrandGlnArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandBiodynamicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** A brand (own brand or foreign) */
export type BrandCityArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandCollectionArgs = {
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
};


/** A brand (own brand or foreign) */
export type BrandCollectionsArgs = {
  filter?: InputMaybe<CollectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<ContentLocale>;
};


/** A brand (own brand or foreign) */
export type BrandCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type BrandCustomFieldArgs = {
  key: Scalars['String']['input'];
};


/** A brand (own brand or foreign) */
export type BrandCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


/** A brand (own brand or foreign) */
export type BrandDataImportArgs = {
  filter?: InputMaybe<ImportFilterInput>;
  importId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandDataImportsArgs = {
  filter?: InputMaybe<DataImportFilterInput>;
};


/** A brand (own brand or foreign) */
export type BrandDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandDirectorArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandDirectorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type BrandDistributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BrandDistributorFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandDistributorSortInput>;
};


/** A brand (own brand or foreign) */
export type BrandEmailArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type BrandEmailOrdersArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type BrandExportPercentageTextArgs = {
  format?: TextFormat;
};


/** A brand (own brand or foreign) */
export type BrandFacebookArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type BrandFileArgs = {
  fileId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandFilesArgs = {
  filter?: InputMaybe<BrandFileFilterInput>;
};


/** A brand (own brand or foreign) */
export type BrandFoundedArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandGroupArgs = {
  groupId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandGroupsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A brand (own brand or foreign) */
export type BrandHistoryArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A brand (own brand or foreign) */
export type BrandHospitalityOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type BrandImpportToolPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MyPartnerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A brand (own brand or foreign) */
export type BrandInstagramArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type BrandLanguagesSpokenArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type BrandLifestyleOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type BrandMyGroupRegistrationsArgs = {
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegistrationSortInput>;
};


/** A brand (own brand or foreign) */
export type BrandMyPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MyPartnerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A brand (own brand or foreign) */
export type BrandNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type BrandOrganicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** A brand (own brand or foreign) */
export type BrandOutdoorExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type BrandOwnBrandArgs = {
  brandId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandOwnBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A brand (own brand or foreign) */
export type BrandOwnerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandPartnerArgs = {
  brandId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartnerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A brand (own brand or foreign) */
export type BrandPostalCodeArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandProducerArgs = {
  brandId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandProducersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProducerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProducerSortInput>;
};


/** A brand (own brand or foreign) */
export type BrandProductArgs = {
  productId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandProductListArgs = {
  productListId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
  useNext?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A brand (own brand or foreign) */
export type BrandRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandRegistrationsArgs = {
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegistrationSortInput>;
};


/** A brand (own brand or foreign) */
export type BrandSeekingDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type BrandShareListArgs = {
  shareListId: Scalars['ID']['input'];
};


/** A brand (own brand or foreign) */
export type BrandShortDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandSlugArgs = {
  format?: InputMaybe<SlugFormat>;
};


/** A brand (own brand or foreign) */
export type BrandSortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandStateProvinceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type BrandStreetArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandTelephoneArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** A brand (own brand or foreign) */
export type BrandTelephoneOrdersArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** A brand (own brand or foreign) */
export type BrandTwitterArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type BrandWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A brand (own brand or foreign) */
export type BrandWineExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A brand (own brand or foreign) */
export type BrandWinemakerArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandWinemakerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A brand (own brand or foreign) */
export type BrandYoutubeArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** A list of brands that is sortable, filterable and can be paginated. */
export type BrandConnection = AbstractBrandConnection & {
  edges: Array<AbstractBrandEdge>;
  nodes: Array<AbstractBrand>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A contact person for a brand. */
export type BrandContact = Item & {
  /** The person's email address. */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * The URL to book a meeting with this person.
   * Could be a link to Calendly, B2Match, Brella or other services.
   */
  meetingBookingUrl?: Maybe<Scalars['String']['output']>;
  /** The person's mobile phone number. */
  mobile?: Maybe<Scalars['String']['output']>;
  /** The person's given and family name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The person's office phone number. */
  office?: Maybe<Scalars['String']['output']>;
  /** The person's skype Id. */
  skypeId?: Maybe<Scalars['String']['output']>;
  /** The person's job title. */
  title?: Maybe<Scalars['String']['output']>;
};


/** A contact person for a brand. */
export type BrandContactMeetingBookingUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};

export type BrandDistributor = Item & {
  country?: Maybe<Scalars['String']['output']>;
  /** @deprecated Unused */
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type BrandDistributorCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type BrandDistributorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type BrandDistributorUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** A list of distributors for a brand that is sortable, filterable and can be paginated. */
export type BrandDistributorConnection = Connection & {
  distinct: Array<Maybe<Scalars['String']['output']>>;
  edges: Array<BrandDistributorEdge>;
  group: Array<BrandDistributorGroupConnection>;
  nodes: Array<BrandDistributor>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A list of distributors for a brand that is sortable, filterable and can be paginated. */
export type BrandDistributorConnectionDistinctArgs = {
  field: BrandDistributorGroupField;
};


/** A list of distributors for a brand that is sortable, filterable and can be paginated. */
export type BrandDistributorConnectionGroupArgs = {
  field: BrandDistributorGroupField;
  filter?: InputMaybe<BrandDistributorGroupFilterInput>;
  sort?: InputMaybe<GroupConnectionSortInput>;
};

export type BrandDistributorEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<BrandDistributor>;
  node: BrandDistributor;
  previous?: Maybe<BrandDistributor>;
};

/** The filter on brand distributors. */
export type BrandDistributorFilterInput = {
  country?: InputMaybe<CountryQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
};

/** A list of brand distributors, grouped by a certain field. */
export type BrandDistributorGroupConnection = Connection & {
  distinct: Array<Maybe<Scalars['String']['output']>>;
  edges: Array<BrandDistributorEdge>;
  field: BrandDistributorGroupField;
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<BrandDistributorGroupConnection>;
  nodes: Array<BrandDistributor>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A list of brand distributors, grouped by a certain field. */
export type BrandDistributorGroupConnectionDistinctArgs = {
  field: BrandDistributorGroupField;
};


/** A list of brand distributors, grouped by a certain field. */
export type BrandDistributorGroupConnectionGroupArgs = {
  field: BrandDistributorGroupField;
  filter?: InputMaybe<BrandDistributorGroupFilterInput>;
  sort?: InputMaybe<GroupConnectionSortInput>;
};


/** A list of brand distributors, grouped by a certain field. */
export type BrandDistributorGroupConnectionNodesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
};

/** The fields to group distributors by. */
export type BrandDistributorGroupField =
  | 'country'
  | 'name'
  | 'url';

/** The filter on grouped brand distributors. */
export type BrandDistributorGroupFilterInput = {
  country?: InputMaybe<CountryQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  totalCount?: InputMaybe<IntQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
};

/** The fields to sort brand distributors by. */
export type BrandDistributorSortField =
  /** Sort by country. */
  | 'country'
  /** Sort by distributor name. */
  | 'name'
  /** The original sort order as edited. */
  | 'sortOrder';

/** The sort order of the brand distributors. */
export type BrandDistributorSortInput = {
  fields?: InputMaybe<Array<BrandDistributorSortField>>;
  order?: InputMaybe<Array<SortOrder>>;
};

export type BrandFileFilterInput = {
  contentType?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
};

/** The search criteria for brands. */
export type BrandFilterInput = {
  addFuzzyResults?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<StringQueryOperatorInput>;
  brandType?: InputMaybe<BrandTypeQueryOperatorInput>;
  country?: InputMaybe<StringQueryOperatorInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<StringQueryOperatorInput>;
};

/** The public profile of a brand. */
export type BrandProfile = Item & Node & Profile & {
  /** The companies Global Location Number (GLN). */
  GLN?: Maybe<Scalars['String']['output']>;
  /** Array of address elements ordered based on the conventions of the particular country. */
  address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The number of bottles of sparkling produced per year. */
  annualProductionSparkling?: Maybe<Scalars['Int']['output']>;
  /** The number of bottles of sparkling produced per year, formatted as a number if possible. */
  annualProductionSparklingText?: Maybe<Scalars['String']['output']>;
  /** The number of bottles of wine produced per year. */
  annualProductionWine?: Maybe<Scalars['Int']['output']>;
  /** The number of bottles of wine produced per year, formatted as a number if possible. */
  annualProductionWineText?: Maybe<Scalars['String']['output']>;
  /** The associations the profile is part of. */
  associations?: Maybe<Scalars['String']['output']>;
  /** The average yield. */
  averageYield?: Maybe<Scalars['Int']['output']>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  biodynamicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The link to book wine experiences, hospitality, lifestyle and outdoor experiences. */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  /** The brand's ID. */
  brandId: Scalars['ID']['output'];
  /** The producer certifications. */
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  /** The city or village the brand is located at. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the profile. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * A longer description of the brand.
   * For a shorter text, use shortDescription instead.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's director. */
  directorName?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently has distributors in. */
  distributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the distributor a brand currently has. */
  distributors?: Maybe<BrandDistributorConnection>;
  /** The brand's main contact email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The email to order products. */
  emailOrders?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage this producer is exporting to other countries.
   * @deprecated Use exportPercentageText instead. This will throw an error if the value entered was not an integer.
   */
  exportPercentage?: Maybe<Scalars['Int']['output']>;
  /** The percentage this producer is exporting to other countries, in text format (as entered). */
  exportPercentageText?: Maybe<Scalars['String']['output']>;
  /** The brand's facebook account or URL. */
  facebook?: Maybe<Scalars['String']['output']>;
  /** The year the brand was founded. */
  founded?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  hasAccommodation?: Maybe<Scalars['Boolean']['output']>;
  hasDiningFacilities?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a social compliance program? */
  hasSocialComplianceProgram?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a sustainability certification? */
  hasSustainabilityCertification?: Maybe<Scalars['Boolean']['output']>;
  /** The hospitality options this brand offers. */
  hospitalityOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The globally unique Node id. Used to be able to load the node via the top-level node resolver. */
  id: Scalars['ID']['output'];
  /** The brand's instagram account or URL. */
  instagram?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** The languages spoken at the brand's information desk. */
  languagesSpoken?: Maybe<Array<Scalars['String']['output']>>;
  /** The latitude of the profile address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The lifestyle amenities this brand offers. */
  lifestyleOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The profile logo. */
  logo?: Maybe<CloudinaryAsset>;
  /** The longitude of the profile address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The main image of the profile, often showing people or the location. */
  mainImage?: Maybe<CloudinaryAsset>;
  /** The name shown in the profile. */
  name?: Maybe<Scalars['String']['output']>;
  /** The URL to the brand's online shop. */
  onlineShop?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar shops where you can buy products of this brand. */
  onlineShops?: Maybe<Array<OnlineShop>>;
  /** The times that the business is open. */
  openingHours?: Maybe<Array<OpeningHoursSpecification>>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  organicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The outdoor experiences this brand offers. */
  outdoorExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the profile's owner. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar Wine shops where you can buy products of this brand. */
  physicalShops?: Maybe<Array<PhysicalShop>>;
  /** The planted area in hectares. */
  plantedArea?: Maybe<Scalars['Int']['output']>;
  /** The post code of the city the brand is located at. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The price ranges the profile's brand or company offers. */
  priceRanges?: Maybe<Array<PriceRange>>;
  /** The profile ID. Different from the brandId. In the future, we'll possibly support multiple profiles per brand. */
  profileId: Scalars['ID']['output'];
  /** The region this company or brand belongs to. */
  region?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently seeking distributors for. */
  seekingDistributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** A short description of the profile. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Used for Bottlebooks Classic only. Use socialCompliancePrograms instead. */
  socialCompliance?: Maybe<Array<SocialComplianceProgram>>;
  /** The list of social compliance programs. */
  socialCompliancePrograms?: Maybe<Array<SocialComplianceProgram>>;
  /** The description of the typical soil type. */
  soilType?: Maybe<Scalars['String']['output']>;
  /**
   * The text to be used for sorting the brand in a list.
   * The name is also used for catalog indexes,
   * so a winery called "Bodegas Juan Carlos" could have a sortName of "Carlos, Juan, Bodegas" or "Carlos Juan".
   */
  sortName?: Maybe<Scalars['String']['output']>;
  /** The state/province of the profile. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** The street the brand is located in. */
  street?: Maybe<Scalars['String']['output']>;
  /** The list of social compliance programs. */
  sustainabilityCertifications?: Maybe<Array<SustainabilityCertification>>;
  /** The phone number of the profile. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The telephone number to order products. */
  telephoneOrders?: Maybe<Scalars['String']['output']>;
  /** The brand's twitter account or URL. */
  twitter?: Maybe<Scalars['String']['output']>;
  /** The list of typical varieties planted. */
  typicalVarieties?: Maybe<Array<Scalars['String']['output']>>;
  videos?: Maybe<Array<Video>>;
  /** The brand's main website. */
  website?: Maybe<Scalars['String']['output']>;
  /** The wine experiences this brand offers. */
  wineExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the profile's winemaker. */
  winemakerName?: Maybe<Scalars['String']['output']>;
  /** The brand's youtube account or URL. */
  youtube?: Maybe<Scalars['String']['output']>;
};


/** The public profile of a brand. */
export type BrandProfileGlnArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileAnnualProductionSparklingTextArgs = {
  allowInvalidNumbers?: Scalars['Boolean']['input'];
  asEntered?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<NumberFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** The public profile of a brand. */
export type BrandProfileAnnualProductionWineTextArgs = {
  allowInvalidNumbers?: Scalars['Boolean']['input'];
  asEntered?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<NumberFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** The public profile of a brand. */
export type BrandProfileAssociationsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileBiodynamicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** The public profile of a brand. */
export type BrandProfileCertificationsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileCityArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileDirectorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileDistributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BrandDistributorFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandDistributorSortInput>;
};


/** The public profile of a brand. */
export type BrandProfileEmailArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a brand. */
export type BrandProfileEmailOrdersArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a brand. */
export type BrandProfileExportPercentageTextArgs = {
  format?: TextFormat;
};


/** The public profile of a brand. */
export type BrandProfileFacebookArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a brand. */
export type BrandProfileFoundedArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileHospitalityOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileInstagramArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a brand. */
export type BrandProfileLanguagesSpokenArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileLifestyleOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a brand. */
export type BrandProfileOrganicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** The public profile of a brand. */
export type BrandProfileOutdoorExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileOwnerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfilePostalCodeArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileSeekingDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileShortDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileSortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileStateProvinceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileStreetArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileTelephoneArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** The public profile of a brand. */
export type BrandProfileTelephoneOrdersArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** The public profile of a brand. */
export type BrandProfileTwitterArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a brand. */
export type BrandProfileTypicalVarietiesArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a brand. */
export type BrandProfileWineExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a brand. */
export type BrandProfileWinemakerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a brand. */
export type BrandProfileYoutubeArgs = {
  format?: InputMaybe<UrlFormat>;
};

export type BrandRolesEnum =
  | 'ARCHIVE'
  | 'CREATE'
  | 'DELETE'
  | 'EDIT'
  | 'EDIT_PRODUCT_LIST'
  | 'READ'
  | 'SHARE_PRODUCT';

export type BrandSortFields =
  | 'brandId'
  | 'city'
  | 'country'
  | 'name'
  | 'postalCode'
  | 'region';

export type BrandSortInput = {
  fields?: InputMaybe<Array<InputMaybe<BrandSortFields>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrder>>>;
};

export type BrandType =
  | 'ASSOCIATION'
  | 'IMPORTER'
  | 'PRODUCER';

export type BrandTypeQueryOperatorInput = {
  eq?: InputMaybe<BrandType>;
  in?: InputMaybe<Array<InputMaybe<BrandType>>>;
  ne?: InputMaybe<BrandType>;
  nin?: InputMaybe<Array<InputMaybe<BrandType>>>;
};

export type BrandUser = {
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  /** The locale of the user interface. Might be different from the user's language because we don't support it yet. */
  interfaceLocale?: Maybe<InterfaceLocale>;
  /**
   * The user's language.
   * @deprecated Use interfaceLocale instead. We may reintroduce language if there's a need for it.
   */
  language?: Maybe<Scalars['String']['output']>;
  /** The logged-in user roles. */
  roles: Array<UserRoles>;
  userId: Scalars['ID']['output'];
};

export type BulkProductData = {
  input?: InputMaybe<ProductData>;
  productId: Scalars['ID']['input'];
};

export type BulkSaveProductDataResponse = MutationResponse & {
  code: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CacheControlScope =
  | 'PRIVATE'
  | 'PUBLIC';

export type CaloriesCalculationStrategy =
  | 'CALCULATOR'
  | 'MANUAL';

export type CaloriesSource = {
  alcohol?: Maybe<Scalars['Float']['output']>;
  glycerin?: Maybe<Scalars['Float']['output']>;
  residualSugar?: Maybe<Scalars['Float']['output']>;
  strategy?: Maybe<CaloriesCalculationStrategy>;
  totalAcidity?: Maybe<Scalars['Float']['output']>;
  useStandardEnergyConversionFactor?: Maybe<Scalars['Boolean']['output']>;
  wineStyle?: Maybe<Scalars['String']['output']>;
};

export type CaloriesSourceInput = {
  alcohol?: InputMaybe<Scalars['Float']['input']>;
  glycerin?: InputMaybe<Scalars['Float']['input']>;
  residualSugar?: InputMaybe<Scalars['Float']['input']>;
  strategy?: InputMaybe<CaloriesCalculationStrategy>;
  totalAcidity?: InputMaybe<Scalars['Float']['input']>;
  useStandardEnergyConversionFactor?: InputMaybe<Scalars['Boolean']['input']>;
  wineStyle?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogConfiguration = {
  /** The unique id of the catalog configuration. */
  catalogConfigurationId: Scalars['ID']['output'];
  /** The collection this catalog is attached to. */
  collection?: Maybe<Collection>;
  /** The collection Id of this catalog configuration. */
  collectionId: Scalars['ID']['output'];
  /**
   * The registrations, ordered in the catalog configuration order.
   * This is a shortcut to 'catalog { sections { registration } }', filtered on registrations.
   */
  registrations: SingleRegistrationConnection;
  /**
   * The catalog sections.
   * Can be a registration, and uploaded PDF,
   * or (in the future) a placeholder, a contents section or index section.
   * Use an inline fragment ('... on RegistrationCatalogSection {…}') to get the fields you need.
   */
  sections: Array<CatalogSection>;
  /** The unique template identifier of the catalog. */
  templateId?: Maybe<Scalars['String']['output']>;
};


export type CatalogConfigurationRegistrationsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<RegistrationFilterInput>;
  registrationId?: InputMaybe<Scalars['ID']['input']>;
};


export type CatalogConfigurationSectionsArgs = {
  filter?: InputMaybe<CatalogSectionFilterInput>;
};

export type CatalogSection = {
  /**
   * The type of section.
   * Use an inline fragment ('... on RegistrationCatalogSection {…}') to get the data for each section type.
   */
  sectionType: CatalogSectionType;
};

export type CatalogSectionFilterInput = {
  position?: InputMaybe<CatalogSectionPositionFilterInput>;
  registration?: InputMaybe<RegistrationFilterInput>;
  sectionType?: InputMaybe<CatalogSectionTypeQueryOperatorInput>;
};

/** The kind of positioning within the catalog sections. */
export type CatalogSectionPosition =
  /** This section was appended to the end automatically. */
  | 'AUTO'
  /** The collection owner has positioned this section manually. */
  | 'MANUAL';

export type CatalogSectionPositionFilterInput = {
  eq?: InputMaybe<CatalogSectionPosition>;
  in?: InputMaybe<Array<InputMaybe<CatalogSectionPosition>>>;
  ne?: InputMaybe<CatalogSectionPosition>;
  nin?: InputMaybe<Array<InputMaybe<CatalogSectionPosition>>>;
  regex?: InputMaybe<CatalogSectionPosition>;
};

export type CatalogSectionType =
  | 'REGISTRATION'
  | 'UPLOADED_FILE';

export type CatalogSectionTypeQueryOperatorInput = {
  eq?: InputMaybe<CatalogSectionType>;
  in?: InputMaybe<Array<InputMaybe<CatalogSectionType>>>;
  ne?: InputMaybe<CatalogSectionType>;
  nin?: InputMaybe<Array<InputMaybe<CatalogSectionType>>>;
  regex?: InputMaybe<CatalogSectionType>;
};

/** Someone changed a field from one value to another. */
export type ChangeFieldChange = FieldChange & {
  /** The collection this field was changed in. */
  collection?: Maybe<Collection>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The ISO date that this field was changed at. */
  date: Scalars['String']['output'];
  /** The field that was changed. */
  field: ChangedField;
  /** The unique id of the field change. */
  fieldChangeId: Scalars['ID']['output'];
  /** The type of change made. */
  fieldChangeType: FieldChangeType;
  /** The original value. */
  from: FieldValue;
  /** The product on which the change was made. */
  product: Product;
  /** The new value it was set to. */
  to: FieldValue;
  /** The user and brand who changed the field. */
  user: ChangedBy;
};

export type ChangedBy = {
  brandId?: Maybe<Scalars['ID']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** A field involved in a FieldChange. */
export type ChangedField = Field & {
  /**
   * The path to the field in the changed object.
   * It identifies the field uniquely.
   */
  fieldId: Scalars['String']['output'];
  /**
   * The interface label for that field.
   * The locale parameter will allow for fetching the label in a particular UI language,
   * but that's not implemented yet - it's an experimental suggestion only.
   */
  label?: Maybe<Scalars['String']['output']>;
  type: ChangedFieldType;
};


/** A field involved in a FieldChange. */
export type ChangedFieldLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ChangedFieldType =
  | 'CHANGEOVER'
  | 'DATE'
  | 'IMAGE'
  | 'TEXT';

export type ChangeoverFieldValue = FieldValue & {
  /** The raw text as in the database. */
  rawText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use value instead. */
  text?: Maybe<Scalars['String']['output']>;
  /** The formatted changeover month. */
  value?: Maybe<Scalars['String']['output']>;
};


export type ChangeoverFieldValueTextArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeoverFieldValueValueArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type Cider = ExtendedProduct & Item & Product & {
  /**
   * The GTIN of the product.
   *
   * Returns the GTIN of the first product variant.
   */
  GTIN?: Maybe<Scalars['String']['output']>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_childProducts: Array<Unstable_CoreProduct>;
  /**
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_packaging: Array<ProductPackaging>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_parentProduct?: Maybe<Unstable_CoreProduct>;
  /** @deprecated Don't use - will be deleted soon! */
  _unstable_parentProductDifferences: Array<ProductVersionChange>;
  /**
   * A list of private workspace-owned events.
   *
   * This can be used to get all the field configurations for a product to edit.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioConfigurations: Array<Event>;
  /**
   * A list of registeredProduct entries.
   * This can be used for collection-based Portfolio.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioRegisteredProducts: RegisteredProductConnection;
  /**
   * The primary packaging (typically a bottle).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_primaryPackaging?: Maybe<PrimaryProductPackaging>;
  /**
   * The secondary packaging (typically a case).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_secondaryPackaging?: Maybe<SecondaryProductPackaging>;
  /**
   * The tertiary packaging (typically a pallet).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_tertiaryPackaging?: Maybe<TertiaryProductPackaging>;
  /**
   * A product's workspace.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_workspace: Workspace;
  /** The measurement method of the total acidity. */
  acidityUnit?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage of alcohol actually measured.
   * This is the analytical value measured in the lab.
   * This value is normally not communicated, only for some professional tastings.
   */
  actualAlcohol?: Maybe<Scalars['Float']['output']>;
  /**
   * The percentage of alcohol as displayed on the label.
   * This is often rounded according to local regulations.
   */
  alcohol?: Maybe<Scalars['Float']['output']>;
  /** Utility function to get all allergens as a single line of text. */
  allergensText?: Maybe<Scalars['String']['output']>;
  animalProducts?: Maybe<Scalars['Boolean']['output']>;
  /** The color of the product. */
  apparentColor?: Maybe<Scalars['String']['output']>;
  /** The appearance description for this product. */
  appearanceDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity of the appearance. */
  appearanceIntensity?: Maybe<Scalars['String']['output']>;
  /** Floral hints on the aroma. */
  aromaFloral?: Maybe<Scalars['String']['output']>;
  /** Fruity notes on the aroma. */
  aromaFruit?: Maybe<Scalars['String']['output']>;
  /** The intensity of the aroma. */
  aromaIntensity?: Maybe<Scalars['String']['output']>;
  /** Spicy aspects of the aroma. */
  aromaSpice?: Maybe<Scalars['String']['output']>;
  /** Wooden scents on that product. */
  aromaWood?: Maybe<Scalars['String']['output']>;
  awards?: Maybe<Array<CiderAward>>;
  backLabelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use backLabelImage { url } instead. */
  backLabelImageUrl?: Maybe<Scalars['String']['output']>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  /** @deprecated Use biodynamicCertificate instead */
  biodynamicCertificateUrl?: Maybe<Scalars['String']['output']>;
  bottleImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use bottleImage { url } instead. */
  bottleImageUrl?: Maybe<Scalars['String']['output']>;
  bottleVariants?: Maybe<Array<ProductBottleVariant>>;
  /**
   * The bottles per case.
   *
   * Returns the bottles per case of the first packaging variant.
   */
  bottlesPerCase?: Maybe<Scalars['Int']['output']>;
  bottlingDate?: Maybe<Scalars['String']['output']>;
  /** The sugars per 100ml in grams. */
  carbohydrateSugars?: Maybe<Scalars['Float']['output']>;
  /** The carbohydrate per 100ml in grams. */
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  /**
   * The GTIN of the product case.
   *
   * Returns the GTIN of the first packaging variant.
   */
  caseGTIN?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<ProductCertification>>;
  characteristics?: Maybe<Array<Maybe<ProductCharacteristicEnum>>>;
  /** The profile of the importer, retailer or company behind the product. */
  companyProfile?: Maybe<CompanyProfile>;
  /** The product description target consumers. */
  consumerDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the consumer product variant (typically the vintage of a wine or any other information).
   * @deprecated Experimental - use at your own risk.
   */
  consumerProductVariant?: Maybe<Scalars['String']['output']>;
  containsCelery?: Maybe<Scalars['Boolean']['output']>;
  containsCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  containsEggs?: Maybe<Scalars['Boolean']['output']>;
  containsFish?: Maybe<Scalars['Boolean']['output']>;
  containsGluten?: Maybe<Scalars['Boolean']['output']>;
  containsLupin?: Maybe<Scalars['Boolean']['output']>;
  containsMilk?: Maybe<Scalars['Boolean']['output']>;
  containsMolluscs?: Maybe<Scalars['Boolean']['output']>;
  containsMustard?: Maybe<Scalars['Boolean']['output']>;
  containsNuts?: Maybe<Scalars['Boolean']['output']>;
  containsPeanuts?: Maybe<Scalars['Boolean']['output']>;
  containsSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  containsSoybeans?: Maybe<Scalars['Boolean']['output']>;
  containsSulfites?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A number describing the product's content completeness.
   * The guiding principle is that those pieces of content must be valuable to the majority of visitors.
   * Currently bottle image, alcohol, wine description, webshop, food pairing description
   * and product videos are fields that each raise the content level.
   * The content level calculation will change and mature over time, similar to the Google PageRank.
   */
  contentLevel: Scalars['Int']['output'];
  /** The country the product was produced in. */
  country?: Maybe<Scalars['String']['output']>;
  /** A certain custom field, available on events and requests. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's raw text.
   * This is the shortest path to a custom field's value and always returns the raw text.
   * If you need to get typed values and more metadata, use customField instead.
   */
  customFieldText?: Maybe<Scalars['String']['output']>;
  /**
   * A certain custom field's value, available on events and requests.
   * This is a shortcut – If you need more, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields available on events and requests. */
  customFields?: Maybe<Array<CustomField>>;
  /** The customized name of the region. */
  customRegion?: Maybe<Scalars['String']['output']>;
  /** The customized name of the subregion. */
  customSubregion?: Maybe<Scalars['String']['output']>;
  /**
   * An Excel document containing all the product data in a printable format,
   * also enabling data extraction and reuse.
   */
  dataFile?: Maybe<ProductDataFile>;
  /**
   * The name of the denomination. This extends the logic of regionName and
   * uses custom logic for specific regions such as Spain and Austria.
   */
  denomination?: Maybe<Scalars['String']['output']>;
  /** The product description for the trade. */
  description?: Maybe<Scalars['String']['output']>;
  /** The product's related e-labels. */
  eLabels: ELabelConnection;
  /** The energy value in kcal per 100ml. */
  energyKcal?: Maybe<Scalars['Float']['output']>;
  /** The energy value in kJ per 100ml. */
  energyKj?: Maybe<Scalars['Float']['output']>;
  /** The exhibitor presenting a product at an event. */
  exhibitor?: Maybe<Exhibitor>;
  /** The ID of an exhibitor presenting the product at an event. */
  exhibitorId?: Maybe<Scalars['ID']['output']>;
  /** The fat per 100ml in grams. */
  fat?: Maybe<Scalars['Float']['output']>;
  /** A list of content features that make this product more valuable to visitors than other products. */
  featuredContentTypes?: Maybe<Array<FeaturedProductContentType>>;
  fileLibrary?: Maybe<Array<ProductFileAttachment>>;
  /** Shows files attached to this product. */
  files?: Maybe<FileConnection>;
  /**
   * The list of fining agents used.
   * If null, the fining agents are not known.
   * If an empty array, there were no fining agents used.
   */
  finingAgents?: Maybe<Array<Scalars['String']['output']>>;
  /** The finish description for this product. */
  finishDescription?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  history?: Maybe<Array<Maybe<HistoryEntry>>>;
  /** A printable product info sheet as a PDF. */
  infoSheet?: Maybe<ProductInfoSheet>;
  ingredients?: Maybe<Array<ProductIngredient>>;
  /** Utility function to get all ingredients as a string. */
  ingredientsText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryAromas instead. */
  intenseAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryFlavors instead. */
  intenseFlavors?: Maybe<Array<Scalars['String']['output']>>;
  internationalCertifications?: Maybe<Array<InternationalProductCertification>>;
  /**
   * The inventory ID specific to the company.
   * @deprecated Use productExternalId instead.
   */
  inventoryId?: Maybe<Scalars['String']['output']>;
  /**
   * The secondary inventory ID specific to the company.
   * @deprecated Use productExternalId2 instead.
   */
  inventoryId2?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCelery instead. */
  isCelery?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCrustaceans instead. */
  isCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsEggs instead. */
  isEggs?: Maybe<Scalars['Boolean']['output']>;
  isFairtrade?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsFish instead. */
  isFish?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsGluten instead. */
  isGluten?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is this product free of genetically modified organisms?
   * "Not sure", "not asked" and "not answered" all resolve to null.
   */
  isGmoFree?: Maybe<Scalars['Boolean']['output']>;
  isKosher?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsLupin instead. */
  isLupin?: Maybe<Scalars['Boolean']['output']>;
  isMevushal?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMilk instead. */
  isMilk?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMolluscs instead. */
  isMolluscs?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMustard instead. */
  isMustard?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsNuts instead. */
  isNuts?: Maybe<Scalars['Boolean']['output']>;
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsPeanuts instead. */
  isPeanuts?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSesameSeeds instead. */
  isSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSoybeans instead. */
  isSoybeans?: Maybe<Scalars['Boolean']['output']>;
  isSustainable?: Maybe<Scalars['Boolean']['output']>;
  isVegan?: Maybe<Scalars['Boolean']['output']>;
  isVegetarian?: Maybe<Scalars['Boolean']['output']>;
  labelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use labelImage { url } instead. */
  labelImageUrl?: Maybe<Scalars['String']['output']>;
  localCertifications?: Maybe<Array<LocalProductCertification>>;
  /** Low / no alcohol statement. */
  lowNoAlcoholStatement?: Maybe<Scalars['String']['output']>;
  lwinId?: Maybe<Scalars['String']['output']>;
  /**
   * The amount of malic acid in grams/liter.
   * This value is not commonly communicated.
   */
  malicAcid?: Maybe<Scalars['Float']['output']>;
  /** Notes on how to market this wine. */
  marketingNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryAromas instead. */
  mildAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryFlavors instead. */
  mildFlavors?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  /** The nose description for this product. */
  noseDescription?: Maybe<Scalars['String']['output']>;
  onlineShop?: Maybe<Scalars['String']['output']>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  /** Awards not in the list of recognized awards. Free text. */
  otherAwards?: Maybe<Scalars['String']['output']>;
  /** All sustainability certifications not covered in localCertifications and internationalCertifications can be added as free text. */
  otherSustainabilityCertifications?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use productRange instead. */
  ownClassification?: Maybe<Scalars['String']['output']>;
  /** The packaging gas used. This is automatically included in ingredientsText. */
  packagingGasesFunction?: Maybe<Scalars['String']['output']>;
  packagingVariants?: Maybe<Array<ProductPackagingVariant>>;
  /** The food pairing description for this product. */
  pairingDescription?: Maybe<Scalars['String']['output']>;
  /** Food pairings that match well with the product. */
  pairings?: Maybe<Array<Scalars['String']['output']>>;
  /** The color of the product. */
  palateAcidity?: Maybe<Scalars['String']['output']>;
  /** The body of the product. */
  palateBody?: Maybe<Scalars['String']['output']>;
  /** The palate description for this product. */
  palateDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity on the palate. */
  palateIntensity?: Maybe<Scalars['String']['output']>;
  /** The tannins of the product. */
  palateTannins?: Maybe<Scalars['String']['output']>;
  /**
   * The GTIN of the pallet.
   *
   * Returns the pallet GTIN of the first packaging variant.
   */
  palletGTIN?: Maybe<Scalars['String']['output']>;
  /**
   * The list of permissions on the product.
   * @deprecated We're considering to replace the list of strings with particular fields to reduce the data load when you just need a few permissions.
   */
  permissionList?: Maybe<Array<ProductRolesEnum>>;
  permissions: ProductPermissions;
  pressAnecdotes?: Maybe<Scalars['String']['output']>;
  /**
   * A price for this product.
   * @deprecated Use registeredProduct.pricing instead.
   */
  pricing?: Maybe<ProductPrice>;
  /** A list of primary aromas in the nose. */
  primaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of primary flavors on the palate. */
  primaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  /** The product's producer. */
  producer?: Maybe<Producer>;
  productCategory?: Maybe<ProductCategory>;
  /** productExternalId Should represent unique product ID specific to the company. Former inventoryId */
  productExternalId?: Maybe<Scalars['String']['output']>;
  /** productExternalId2 Should represent additional product ID specific to the company. Former inventoryId2 */
  productExternalId2?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productRange?: Maybe<Scalars['String']['output']>;
  productType: ProductType;
  /** The protein per 100ml in grams. */
  protein?: Maybe<Scalars['Float']['output']>;
  /**
   * The name that the customer is using internally to refer to this product.
   * @deprecated Experimental - use at your own risk.
   */
  referenceName?: Maybe<Scalars['String']['output']>;
  /**
   * The region the product was produced in.
   * This is one of the officialy recognized regions of the country.
   * Regions are often subdivided into subregions - that value can be found on Product.subregion.
   */
  region?: Maybe<Scalars['String']['output']>;
  /** The region hierarchy of a product, starting with country. */
  regionHierarchy?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The name of the subregion, region or country – whichever has a value:
   * - For products with subregion, the subregion is returned.
   * - For products with region only, the region is returned.
   * - For products with country, the country is returned.
   * - For products using custom names, the custom name is returned.
   */
  regionName?: Maybe<Scalars['String']['output']>;
  /** The sugar in grams/liter. */
  residualSugar?: Maybe<Scalars['Float']['output']>;
  /** The salt per 100ml in grams. */
  salt?: Maybe<Scalars['Float']['output']>;
  /** The saturates per 100ml in grams. */
  saturatedFat?: Maybe<Scalars['Float']['output']>;
  /** A list of secondary aromas in the nose. */
  secondaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of secondary flavors on the palate. */
  secondaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  shortName: Scalars['String']['output'];
  /**
   * A list of content features that make this product more valuable to visitors than other products.
   * The useIdOnly flag is deprecated, use format=ID instead.
   */
  slug: Scalars['String']['output'];
  /** A stand on an event. */
  stand?: Maybe<Stand>;
  status?: Maybe<ProductStatus>;
  /**
   * The product name in a structured format.
   * @deprecated Used internally only and not ready for production - use name instead.
   */
  structuredName?: Maybe<StructuredProductName>;
  /**
   * The subregion the product was produced in.
   * This is one of the officialy recognized subregions of the region.
   */
  subregion?: Maybe<Scalars['String']['output']>;
  suggestedCategory?: Maybe<ProductCategory>;
  sulfurAdded?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use otherSustainabilityCertifications instead. */
  sustainabilityCertificatesOther?: Maybe<Scalars['String']['output']>;
  sustainabilityId?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tastingNotes?: Maybe<Array<ProductTastingNote>>;
  /** The total acidity in grams/liter. */
  totalAcidity?: Maybe<Scalars['Float']['output']>;
  /** An ISO date when the product was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Shows the collections this product is used in. */
  usedIn?: Maybe<ProductUsedInConnection>;
  /** Shows the e-labels where this product is used in. */
  usedInELabels?: Maybe<ProductUsedInELabelsConnection>;
  /**
   * The name of the product variant (bottle size, closure or other differentiating factor?
   * @deprecated Experimental - use at your own risk.
   */
  variantName?: Maybe<Scalars['String']['output']>;
  /** Product videos (Youtube, Vimeo, Instagram, Facebook etc.) */
  videos?: Maybe<Array<Maybe<Video>>>;
  /** The volume of each portion. */
  volumeOfPortion?: Maybe<Scalars['Float']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type CiderGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type Cider_Unstable_ChildProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Cider_Unstable_PackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Cider_Unstable_ParentProductArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Cider_Unstable_ParentProductDifferencesArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Cider_Unstable_PortfolioConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Cider_Unstable_PortfolioRegisteredProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Cider_Unstable_PrimaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Cider_Unstable_SecondaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Cider_Unstable_TertiaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Cider_Unstable_WorkspaceArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type CiderAcidityUnitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderApparentColorArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderAppearanceDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type CiderAppearanceIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderAromaFloralArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderAromaFruitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderAromaIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderAromaSpiceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderAromaWoodArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderBottlingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type CiderCaseGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type CiderConsumerDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type CiderConsumerProductVariantArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type CiderCustomFieldArgs = {
  key: Scalars['String']['input'];
};


export type CiderCustomFieldTextArgs = {
  key: Scalars['String']['input'];
};


export type CiderCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


export type CiderCustomRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderCustomSubregionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderDataFileArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type CiderDenominationArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type CiderDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type CiderELabelsArgs = {
  filter?: InputMaybe<ELabelFilterInput>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type CiderFilesArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
  filter?: InputMaybe<ProductFileFilterInput>;
};


export type CiderFiningAgentsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderFinishDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type CiderHistoryArgs = {
  filter?: InputMaybe<ProductHistoryFilterInput>;
};


export type CiderInfoSheetArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<ContentLocale>;
};


export type CiderIngredientsTextArgs = {
  format?: InputMaybe<IngredientsTextFormat>;
};


export type CiderIntenseAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderIntenseFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderInventoryIdArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderInventoryId2Args = {
  format?: InputMaybe<TextFormat>;
};


export type CiderMildAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderMildFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderNameArgs = {
  format?: InputMaybe<TextFormat>;
  includeProducer?: InputMaybe<IncludeProducer>;
};


export type CiderNoseDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type CiderOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type CiderOtherAwardsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type CiderOtherSustainabilityCertificationsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type CiderPackagingGasesFunctionArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderPairingDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type CiderPairingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderPalateAcidityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderPalateBodyArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderPalateDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type CiderPalateIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderPalateTanninsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderPalletGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type CiderPressAnecdotesArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderPrimaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderPrimaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderProductCategoryArgs = {
  withSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CiderProductExternalIdArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderProductExternalId2Args = {
  format?: InputMaybe<TextFormat>;
};


export type CiderProductRangeArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderReferenceNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderRegionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type CiderRegionHierarchyArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type CiderRegionNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type CiderSecondaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderSecondaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type CiderShortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderSlugArgs = {
  format?: InputMaybe<SlugFormat>;
  useIdOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CiderStructuredNameArgs = {
  algorithm?: InputMaybe<Scalars['String']['input']>;
};


export type CiderSubregionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type CiderTaglineArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderUsedInArgs = {
  filter?: InputMaybe<ProductUsedInFilterInput>;
};


export type CiderVariantNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type CiderWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** An award given to a particular cider. */
export type CiderAward = ProductAward & {
  award?: Maybe<Scalars['String']['output']>;
  medal?: Maybe<Scalars['String']['output']>;
};


/** An award given to a particular cider. */
export type CiderAwardAwardArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** An award given to a particular cider. */
export type CiderAwardMedalArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

/**
 * The Bottlebooks Classic configuration for a single field.
 *
 * Used to render a Classic Form.
 */
export type ClassicField = {
  /**
   * An optional description of the field, sometimes specific to the collection or output.
   * Very few fields have descriptions.
   */
  description?: Maybe<Scalars['String']['output']>;
  field: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  /** @deprecated Use isRequired instead where possible. */
  req?: Maybe<Scalars['String']['output']>;
};


/**
 * The Bottlebooks Classic configuration for a single field.
 *
 * Used to render a Classic Form.
 */
export type ClassicFieldDescriptionArgs = {
  locale: InterfaceLocale;
};

export type ClassicFieldInput = {
  field: Scalars['ID']['input'];
  req?: InputMaybe<Scalars['String']['input']>;
};

export type ClassicFormType =
  | 'beer'
  | 'importer'
  | 'producer'
  | 'spirit'
  | 'wine';

export type ClassicValidValue = {
  label: Scalars['String']['output'];
  listKey: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ClassicValidValueList = {
  key: Scalars['ID']['output'];
  validValues: Array<ClassicValidValue>;
};

export type CloudinaryAsset = CloudinaryResource & {
  cloudName?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<FileContentType>;
  fileId?: Maybe<Scalars['ID']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  fixed?: Maybe<CloudinaryFixed>;
  fluid?: Maybe<CloudinaryFluid>;
  height?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type CloudinaryAssetFixedArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  raw_transformation?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type CloudinaryAssetFluidArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  raw_transformation?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Scalars['String']['input']>;
};


export type CloudinaryAssetSourceUrlArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
};

export type CloudinaryCropType =
  /**
   * Used to extract a given width & height out of the original image.
   * The original proportions are retained and so is the size of the graphics.
   */
  | 'CROP'
  /**
   * Create an image with the exact given width and height without distorting the image.
   * This option first scales as much as needed to at least fill both of the given dimensions.
   * If the requested aspect ratio is different than the original, cropping will occur
   * on the dimension that exceeds the requested size after scaling.
   */
  | 'FILL'
  /**
   * The image is resized so that it takes up as much space as possible
   * within a bounding box defined by the given width and height parameters.
   * The original aspect ratio is retained and all of the original image is visible.
   */
  | 'FIT'
  | 'NO_CHANGE'
  /**
   * Resize the image to fill the given width and height while retaining the original aspect ratio.
   * If the proportions of the original image do not match the given width and height,
   * padding is added to the image to reach the required size.
   */
  | 'PAD'
  /**
   * Change the size of the image exactly to the given width and height
   * without necessarily retaining the original aspect ratio:
   * all original image parts are visible but might be stretched or shrunk.
   */
  | 'SCALE'
  /** Generate a thumbnail using face detection in combination with the 'face' or 'faces' gravity. */
  | 'THUMB';

export type CloudinaryFetchFormat =
  | 'AUTO'
  | 'JPG'
  | 'NO_CHANGE'
  | 'PNG'
  | 'WEBP';

export type CloudinaryFixed = {
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  base64?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  srcSet?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use srcSet with fetch_format:'auto' instead. */
  srcSetWebp?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use src with fetch_format:'auto' instead. */
  srcWebp?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type CloudinaryFixedBase64Args = {
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CloudinaryFluid = {
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  base64?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  sizes?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  srcSet?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use srcSet with fetch_format:'auto' instead. */
  srcSetWebp?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use src with fetch_format:'auto' instead. */
  srcWebp?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type CloudinaryFluidBase64Args = {
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CloudinaryGravity =
  | 'AUTO'
  | 'BODY'
  | 'BODY_FACE'
  | 'CENTER'
  | 'EAST'
  | 'FACE'
  | 'FACES'
  | 'FACES_AUTO'
  | 'FACES_CENTER'
  | 'FACE_AUTO'
  | 'FACE_CENTER'
  | 'NORTH'
  | 'NORTH_EAST'
  | 'NORTH_WEST'
  | 'SOUTH'
  | 'SOUTH_EAST'
  | 'SOUTH_WEST'
  | 'WEST';

export type CloudinaryQuality =
  | 'AUTO'
  | 'BEST'
  | 'ECO'
  | 'GOOD'
  | 'LOW';

export type CloudinaryResource = {
  cloudName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** A named collection of partners with additional data, stored in registrations. */
export type Collection = {
  /** @deprecated Experimental - might be removed or changed without notice. Use at your own risk. */
  _unstable_allOutputConfigurations: Array<CollectionOutputConfiguration>;
  /**
   * Returns if adding products to a registration via QR code is allowed.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_allowAddViaQrCode: Scalars['Boolean']['output'];
  /**
   * The Bottlebooks Classic fields configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_classicFields: Array<ClassicField>;
  /**
   * Collection configuration data.
   * @deprecated For debugging only
   */
  _unstable_data: Scalars['JSON']['output'];
  /**
   * The product requests that don't have a matching product.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_missingProducts: Array<Unstable_MissingProduct>;
  /**
   * The tasting lists for this collection for a specific user.
   * @deprecated Experimental - might change of be dropped!
   */
  _unstable_myTastingLists: Array<TastingList>;
  /**
   * Outputs for a collection
   * @deprecated Experimental, will be removed. Use _unstable_outputConfigurations instead.
   */
  _unstable_outputs: Array<CollectionOutputConfiguration>;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_product: Unstable_CollectionProductEdge;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_products: Unstable_CollectionProductConnection;
  /**
   * The Bottlebooks Classic fields recommended to be configured based on outputs.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_recommendedClassicFields: Array<RecommendedClassicField>;
  /**
   * collectionIds that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollectionIds: Scalars['ID']['output'];
  /**
   * Access collections that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollections: CollectionConnection;
  /** @deprecated Experimental. Use at your own risk! */
  _unstable_requestedProducts: Unstable_RequestedProductConnection;
  /**
   * The products registered for a collection that have not been requested by the organizer.
   * @deprecated Experimental and unstable. Use at your own risk!
   */
  _unstable_unrequestedProducts: RegisteredProductConnection;
  /** @deprecated Experimental. Don't use yet. */
  _unstable_useNewForms: Scalars['Boolean']['output'];
  /** @deprecated Experimental. Don't use yet. */
  _unstable_validValueLists: Unstable_ValidValueLists;
  /** The default catalog. */
  catalog?: Maybe<CatalogConfiguration>;
  collectionId: Scalars['ID']['output'];
  collectionType: CollectionType;
  /** The collection name. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the collection was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /**
   * All the deleted registrations for a collection.
   * @deprecated Experimental
   */
  deletedRegistrations: Array<Registration>;
  /** The public description of the collection. */
  description?: Maybe<Scalars['String']['output']>;
  /** The collection steps. */
  enabledSteps: Array<RegistrationStep>;
  /** General instructions for exhibitors. */
  exhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /**
   * A particular form for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  form: Form;
  /**
   * The allowed form types for this collection.
   * @deprecated Experimental - use at your own risk!
   */
  formTypes: Array<FormType>;
  /**
   * All the forms for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  forms: Array<Form>;
  /** This collection has a product master list that specifies which products suppliers or exhibitors must register. */
  hasProductMasterList: Scalars['Boolean']['output'];
  /** This collection has an overall sorting for the products with optional flighting details. These events are often referred to as 'product-led events' where there are no exhibitors. sortIndex, flightName, and productLabel are null when this is false. */
  isProductSortingEnabled: Scalars['Boolean']['output'];
  /** @deprecated This resolver is under development and is not stable. */
  list?: Maybe<CollectionList>;
  /** @deprecated This resolver is under development and is not stable. */
  lists: CollectionListConnection;
  /** All the configured locales of the event. */
  locales: Array<Scalars['String']['output']>;
  /** Instructions for exhibitors after login. */
  loggedInExhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /** The collection logo. Often this is the collection owner's logo. */
  logo?: Maybe<CloudinaryAsset>;
  mainImage?: Maybe<CloudinaryAsset>;
  /** The maximum products of the collection per registration. */
  maximumProducts?: Maybe<Scalars['Int']['output']>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingAvailabilities: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingTimeslots: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  myMeetingTimeslots: Array<MeetingTimeslot>;
  /**
   * All the company registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  myRegistrations: RegistrationConnection;
  /** The collection name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The contacts that get notifications from the organizer regarding their registrations. */
  notificationContacts?: Maybe<Array<Maybe<Contact>>>;
  /** The brand owning the collection. */
  owner: Brand;
  permissions: CollectionPermissions;
  /** Exhibitor instructions for adding products. */
  productInstructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated This resolver uses an older schema and will not be further developed. Use registeredProducts to get access to newer features. */
  products: ProductConnection;
  /**
   * The questions configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  questions?: Maybe<Array<Question>>;
  /**
   * The brands producing products that have been registered at a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registeredBrands: RegisteredBrandConnection;
  /**
   * A product registered for a collection.
   * Because the same product might be added my multiple different partners,
   * you need to look at the registrations property to get the necessary details for each registration.
   * Not all types of collections support registeredProducts.
   */
  registeredProductVersion: RegisteredProduct;
  /** The products registered for a collection. */
  registeredProducts: RegisteredProductConnection;
  /** A particular registration. */
  registration?: Maybe<Registration>;
  /**
   * All the registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registrations: RegistrationConnection;
  /**
   * The representative profiles of all registrations.
   * @deprecated Experimental. Use at your own risk!
   */
  representatives: Array<SiteUserProfile>;
  /** The default site of the collection. */
  site?: Maybe<SiteConfiguration>;
  /** An ISO date when the collection was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The user profiles.
   * @deprecated Use visitors or representatives instead.
   */
  userProfiles: Array<SiteUserProfile>;
  visibilityStatus: VisibilityStatusType;
  /**
   * The visitor profiles of a collection. These are the registered and approved visitors.
   * @deprecated Experimental. Use at your own risk!
   */
  visitors: Array<SiteUserProfile>;
  workspaceId: Scalars['ID']['output'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_AllOutputConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_AllowAddViaQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_ClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_MissingProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_MyTastingListsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  sort?: InputMaybe<TastingListSortInput>;
  uid: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_OutputsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_ProductArgs = {
  experimentalKey: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_ProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_RecommendedClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_RelatedCollectionIdsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_RelatedCollectionsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_RequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_UnrequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  versionTag?: InputMaybe<DataVersionTag>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_UseNewFormsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type Collection_Unstable_ValidValueListsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionFormArgs = {
  type: FormType;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionListArgs = {
  collectionListId: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionLocalesArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<InterfaceLocale>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionLoggedInExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionMeetingAvailabilitiesArgs = {
  attendeeId: Scalars['String']['input'];
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  organizerId: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionMyMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionMyRegistrationsArgs = {
  companyId: Scalars['ID']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionProductInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionQuestionsArgs = {
  group: QuestionGroup;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionRegisteredBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredBrandFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredBrandSortInput>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionRegisteredProductVersionArgs = {
  productVersionId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionRegisteredProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  useNext?: InputMaybe<Scalars['Boolean']['input']>;
  versionTag?: InputMaybe<DataVersionTag>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegistrationSortInput>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionRepresentativesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionUserProfilesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  roles: Array<SiteUserRole>;
  token: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};


/** A named collection of partners with additional data, stored in registrations. */
export type CollectionVisitorsArgs = {
  experimentalKey: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};

/** A list of product collections that is sortable, filterable and can be paginated. */
export type CollectionConnection = {
  edges: Array<CollectionEdge>;
  group: Array<CollectionGroupConnection>;
  nodes: Array<Collection>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A list of product collections that is sortable, filterable and can be paginated. */
export type CollectionConnectionGroupArgs = {
  field: CollectionGroupField;
};

export type CollectionEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<Collection>;
  node: Collection;
  previous?: Maybe<Collection>;
};

export type CollectionFilterInput = {
  collectionType?: InputMaybe<StringQueryOperatorInput>;
  /** Defaults to {ne: true} */
  isDeleted?: InputMaybe<BooleanQueryOperatorInput>;
  visibilityStatus?: InputMaybe<VisibilityStatusQueryOperatorInput>;
};

/** A list of grouped collections. */
export type CollectionGroupConnection = {
  edges: Array<CollectionEdge>;
  field: CollectionGroupField;
  fieldValue?: Maybe<Scalars['String']['output']>;
  nodes: Array<Collection>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CollectionGroupField =
  | 'collectionType';

/**
 * A list of items from a collection.
 * This can be products, structured via headings.
 */
export type CollectionList = Item & {
  collectionListId: Scalars['ID']['output'];
  /** The localized list description. */
  description?: Maybe<Scalars['String']['output']>;
  /** When the master class ends. */
  endTime?: Maybe<Scalars['String']['output']>;
  items: CollectionListItemConnection;
  /** The location of the master class. */
  location?: Maybe<Scalars['String']['output']>;
  /** The logo for the list. */
  logo?: Maybe<CloudinaryAsset>;
  /** The main image for the list. */
  mainImage?: Maybe<CloudinaryAsset>;
  /** The list name. Currently not localized. */
  name: Scalars['String']['output'];
  registeredProducts: RegisteredProductConnection;
  /** When the master class starts. */
  startTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CollectionListType>;
};


/**
 * A list of items from a collection.
 * This can be products, structured via headings.
 */
export type CollectionListDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale: ContentLocale;
};


/**
 * A list of items from a collection.
 * This can be products, structured via headings.
 */
export type CollectionListEndTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A list of items from a collection.
 * This can be products, structured via headings.
 */
export type CollectionListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A list of items from a collection.
 * This can be products, structured via headings.
 */
export type CollectionListNameArgs = {
  format?: InputMaybe<TextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/**
 * A list of items from a collection.
 * This can be products, structured via headings.
 */
export type CollectionListRegisteredProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A list of items from a collection.
 * This can be products, structured via headings.
 */
export type CollectionListStartTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** A list of collectionLists that is sortable, filterable and can be paginated. */
export type CollectionListConnection = Connection & {
  edges: Array<CollectionListEdge>;
  nodes: Array<CollectionList>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CollectionListEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<CollectionList>;
  node: CollectionList;
  previous?: Maybe<CollectionList>;
};

/** A heading in a Collection list. */
export type CollectionListHeading = {
  title?: Maybe<Scalars['String']['output']>;
};


/** A heading in a Collection list. */
export type CollectionListHeadingTitleArgs = {
  format?: InputMaybe<TextFormat>;
  locale: ContentLocale;
};

/**
 * An item in a collection.
 * This can be products, structured via headings.
 */
export type CollectionListItem = CollectionListHeading | RegisteredProduct;

/** A list of collectionLists that is sortable, filterable and can be paginated. */
export type CollectionListItemConnection = {
  edges: Array<CollectionListItemEdge>;
  nodes: Array<CollectionListItem>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CollectionListItemEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<CollectionListItem>;
  node: CollectionListItem;
  previous?: Maybe<CollectionListItem>;
};

export type CollectionListType =
  /** A master class, using products from the collection. */
  | 'MASTER_CLASS'
  /**
   * A list that defines the sort order of the registered products.
   * Products not in this list will be added to the end of this list.
   */
  | 'PRODUCT_SORTING';

export type CollectionOutputConfiguration = {
  classicFields: Array<ClassicField>;
  collection: Collection;
  collectionId: Scalars['String']['output'];
  /** The output's description in the user interface. */
  description: Scalars['String']['output'];
  /** The form configuration for the output. */
  formConfiguration: FormConfiguration;
  integration?: Maybe<SftpIntegration>;
  integrationId?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates that the output is still configured using legacy approaches.
   * @deprecated Will be removed after transition to new outputs configuration approach.
   */
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The key is used to uniquely identify an item in an array.
   * It's guaranteed to be unique in the list, similar to a cursor, and it's somewhat stable over time, while not guaranteed to stay the same forever.
   * Don't use it to link to this configuration, and also don't interpret its content.
   * Instead just use it for determining if this is the same item as you had before, even if you change some attributes.
   */
  key: Scalars['String']['output'];
  /** @deprecated Not used any more. Can be removed in July 2024 at the latest. */
  missingClassicFields: Array<ClassicField>;
  /** The output's name in the user interface. */
  name: Scalars['String']['output'];
  /** The output configuration's unique ID. */
  outputConfigurationId: Scalars['ID']['output'];
  outputType: CollectionOutputType;
  /**
   * The template used to generate the output.
   * @deprecated Don't use directly.
   */
  templateId?: Maybe<Scalars['String']['output']>;
  vars: Array<ConfigurationVariable>;
  visibleTo: Array<OutputVisibility>;
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};


export type CollectionOutputConfigurationDescriptionArgs = {
  locale?: InputMaybe<ContentLocale>;
};


export type CollectionOutputConfigurationNameArgs = {
  locale?: InputMaybe<ContentLocale>;
};

export type CollectionOutputType =
  /** A PDF catalog of the collection. */
  | 'CATALOG'
  /** A product e-label landing page for nutritional information and ingredients. */
  | 'ELABEL'
  /** A product information sheet PDF. */
  | 'INFOSHEET'
  /** An integration with a third-party service. */
  | 'INTEGRATION'
  /** A manual task that may be dependent on combination or one or more fields of brand/product data. */
  | 'MANUAL'
  /** All product data in a collection as defined by the form configuration. */
  | 'PRODUCTDATA'
  /** A product marketing landing page. */
  | 'PRODUCTPAGE'
  /** All profile data in a collection as defined by the form configuration. */
  | 'PROFILEDATA'
  /** A QR code pointing to a product's e-label or marketing landing page. */
  | 'QRCODE'
  /** A PDF registration sheet. Could be a summary or a stand display. */
  | 'REGISTRATIONSHEET'
  /** A collection site, such as an event directory. */
  | 'WEBSITE';

/** The permissions the current user has on a collection. */
export type CollectionPermissions = {
  /** Is the user allowed to view and manage the collection? */
  manage: Scalars['Boolean']['output'];
  /** @deprecated Use manage instead. */
  manageGroup: Scalars['Boolean']['output'];
};

export type CollectionType =
  | 'COMPANY_GROUP'
  | 'EVENT'
  | 'EVENT_GROUP'
  | 'IMPORT_PRODUCTLIST'
  | 'MASTERLIST'
  | 'PRODUCTLIST'
  | 'REQUEST'
  | 'SHARELIST';

export type CollectionTypeQueryOperatorInput = {
  eq?: InputMaybe<CollectionType>;
  in?: InputMaybe<Array<InputMaybe<CollectionType>>>;
  ne?: InputMaybe<CollectionType>;
  nin?: InputMaybe<Array<InputMaybe<CollectionType>>>;
};

/** A legal entity owning brands. */
export type Company = Item & {
  activities: Array<Activity>;
  brandId: Scalars['ID']['output'];
  /** A single event, request, product list or share list. */
  collection?: Maybe<Collection>;
  /** The list of events, requests, product lists and share lists of the brand. */
  collections: CollectionConnection;
  companyId: Scalars['ID']['output'];
  /** The SaaS features a company has paid for. */
  features: Array<BottlebooksFunction>;
  /**
   * Shows files attached to this company.
   * Filters aren't implemented yet.
   */
  files?: Maybe<FileConnection>;
  /** @deprecated Use activities instead. */
  history?: Maybe<Array<Maybe<HistoryEntry>>>;
  name?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Brand>;
  /** A single product from the companies's portfolio. */
  product?: Maybe<Product>;
  /** A single product list. */
  productList?: Maybe<ProductList>;
  /** The list of product lists of the brand. */
  productLists: ProductListConnection;
  /** The list of products in the company's portfolio. */
  products: ProductConnection;
  profileId: Scalars['ID']['output'];
  /** Registrations to events (foreign or also own events). */
  registrations?: Maybe<RegistrationConnection>;
  /** A single share list. */
  shareList?: Maybe<ShareList>;
  /** The list of share lists of the brand. */
  shareLists: ShareListConnection;
};


/** A legal entity owning brands. */
export type CompanyActivitiesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A legal entity owning brands. */
export type CompanyCollectionArgs = {
  collectionId: Scalars['ID']['input'];
};


/** A legal entity owning brands. */
export type CompanyFilesArgs = {
  filter?: InputMaybe<BrandFileFilterInput>;
};


/** A legal entity owning brands. */
export type CompanyHistoryArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A legal entity owning brands. */
export type CompanyNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A legal entity owning brands. */
export type CompanyPartnerArgs = {
  brandId: Scalars['ID']['input'];
};


/** A legal entity owning brands. */
export type CompanyProductArgs = {
  productId: Scalars['ID']['input'];
};


/** A legal entity owning brands. */
export type CompanyProductListArgs = {
  productListId: Scalars['ID']['input'];
};


/** A legal entity owning brands. */
export type CompanyProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};


/** A legal entity owning brands. */
export type CompanyRegistrationsArgs = {
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegistrationSortInput>;
};


/** A legal entity owning brands. */
export type CompanyShareListArgs = {
  shareListId: Scalars['ID']['input'];
};

export type CompanyFeatures =
  | 'ADD_ELABEL'
  | 'ADD_PRODUCT'
  | 'ADD_TO_SHARE_LIST'
  | 'ARCHIVE_PRODUCTS'
  | 'DOWNLOAD_DATA_FILE'
  | 'DOWNLOAD_INFO_SHEET'
  | 'DUPLICATE_PRODUCTS'
  | 'EXPORT_PRODUCTS'
  | 'MERGE_PRODUCTS'
  | 'PRODUCT_LIFECYCLE'
  | 'ROLL_OVER_VINTAGES'
  | 'SHARE';

/** The search criteria for companies. */
export type CompanyFilterInput = {
  addFuzzyResults?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  companyType?: InputMaybe<CompanyType>;
  country?: InputMaybe<StringQueryOperatorInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Enforce that individual attributes must match exactly. */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Business name. Used for exact search. */
  name?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyInput = {
  /** The ID of the registration where the contact should be edited. */
  companyId: Scalars['ID']['input'];
  /** The contacts data. */
  notificationContacts?: InputMaybe<Array<InputMaybe<NotificationContactInput>>>;
};

/** The public profile of a company. */
export type CompanyProfile = Item & Node & Profile & {
  /** The companies Global Location Number (GLN). */
  GLN?: Maybe<Scalars['String']['output']>;
  /** Array of address elements ordered based on the conventions of the particular country. */
  address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  biodynamicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The link to book wine experiences, hospitality, lifestyle and outdoor experiences. */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  /** The city or village the brand is located at. */
  city?: Maybe<Scalars['String']['output']>;
  /** The company's ID. */
  companyId: Scalars['ID']['output'];
  /** The country of the profile. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * A longer description of the brand.
   * For a shorter text, use shortDescription instead.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's director. */
  directorName?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently has distributors in. */
  distributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the distributor a brand currently has. */
  distributors?: Maybe<BrandDistributorConnection>;
  /** The brand's main contact email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The email to order products. */
  emailOrders?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage this producer is exporting to other countries.
   * @deprecated Use exportPercentageText instead. This will throw an error if the value entered was not an integer.
   */
  exportPercentage?: Maybe<Scalars['Int']['output']>;
  /** The percentage this producer is exporting to other countries, in text format (as entered). */
  exportPercentageText?: Maybe<Scalars['String']['output']>;
  /** The brand's facebook account or URL. */
  facebook?: Maybe<Scalars['String']['output']>;
  /** The year the brand was founded. */
  founded?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  /** Does this brand have a social compliance program? */
  hasSocialComplianceProgram?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a sustainability certification? */
  hasSustainabilityCertification?: Maybe<Scalars['Boolean']['output']>;
  /** The hospitality options this brand offers. */
  hospitalityOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The globally unique Node id. Used to be able to load the node via the top-level node resolver. */
  id: Scalars['ID']['output'];
  /** The brand's instagram account or URL. */
  instagram?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** The languages spoken at the brand's information desk. */
  languagesSpoken?: Maybe<Array<Scalars['String']['output']>>;
  /** The latitude of the profile address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The lifestyle amenities this brand offers. */
  lifestyleOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The profile logo. */
  logo?: Maybe<CloudinaryAsset>;
  /** The longitude of the profile address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The main image of the profile, often showing people or the location. */
  mainImage?: Maybe<CloudinaryAsset>;
  /** The name shown in the profile. */
  name?: Maybe<Scalars['String']['output']>;
  /** The URL to the brand's online shop. */
  onlineShop?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar shops where you can buy products of this brand. */
  onlineShops?: Maybe<Array<OnlineShop>>;
  /** The times that the business is open. */
  openingHours?: Maybe<Array<OpeningHoursSpecification>>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  organicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The outdoor experiences this brand offers. */
  outdoorExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the profile's owner. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar Wine shops where you can buy products of this brand. */
  physicalShops?: Maybe<Array<PhysicalShop>>;
  /** The post code of the city the brand is located at. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The price ranges the profile's brand or company offers. */
  priceRanges?: Maybe<Array<PriceRange>>;
  /** The profile ID. Different from the companyId. In the future, we'll possibly support multiple profiles per company. */
  profileId: Scalars['ID']['output'];
  /** The region this company or brand belongs to. */
  region?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently seeking distributors for. */
  seekingDistributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** A short description of the profile. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Used for Bottlebooks Classic only. Use socialCompliancePrograms instead. */
  socialCompliance?: Maybe<Array<SocialComplianceProgram>>;
  /** The list of social compliance programs. */
  socialCompliancePrograms?: Maybe<Array<SocialComplianceProgram>>;
  /**
   * The text to be used for sorting the brand in a list.
   * The name is also used for catalog indexes,
   * so a winery called "Bodegas Juan Carlos" could have a sortName of "Carlos, Juan, Bodegas" or "Carlos Juan".
   */
  sortName?: Maybe<Scalars['String']['output']>;
  /** The state/province of the profile. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** The street the brand is located in. */
  street?: Maybe<Scalars['String']['output']>;
  /** The list of social compliance programs. */
  sustainabilityCertifications?: Maybe<Array<SustainabilityCertification>>;
  /** The phone number of the profile. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The telephone number to order products. */
  telephoneOrders?: Maybe<Scalars['String']['output']>;
  /** The brand's twitter account or URL. */
  twitter?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Video>>;
  /** The brand's main website. */
  website?: Maybe<Scalars['String']['output']>;
  /** The wine experiences this brand offers. */
  wineExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the profile's winemaker. */
  winemakerName?: Maybe<Scalars['String']['output']>;
  /** The brand's youtube account or URL. */
  youtube?: Maybe<Scalars['String']['output']>;
};


/** The public profile of a company. */
export type CompanyProfileGlnArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileBiodynamicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** The public profile of a company. */
export type CompanyProfileCityArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a company. */
export type CompanyProfileDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileDirectorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a company. */
export type CompanyProfileDistributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BrandDistributorFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandDistributorSortInput>;
};


/** The public profile of a company. */
export type CompanyProfileEmailArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a company. */
export type CompanyProfileEmailOrdersArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a company. */
export type CompanyProfileExportPercentageTextArgs = {
  format?: TextFormat;
};


/** The public profile of a company. */
export type CompanyProfileFacebookArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a company. */
export type CompanyProfileFoundedArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileHospitalityOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a company. */
export type CompanyProfileInstagramArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a company. */
export type CompanyProfileLanguagesSpokenArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a company. */
export type CompanyProfileLifestyleOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a company. */
export type CompanyProfileNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a company. */
export type CompanyProfileOrganicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** The public profile of a company. */
export type CompanyProfileOutdoorExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a company. */
export type CompanyProfileOwnerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfilePostalCodeArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileSeekingDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a company. */
export type CompanyProfileShortDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileSortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileStateProvinceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a company. */
export type CompanyProfileStreetArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileTelephoneArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** The public profile of a company. */
export type CompanyProfileTelephoneOrdersArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** The public profile of a company. */
export type CompanyProfileTwitterArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a company. */
export type CompanyProfileWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile of a company. */
export type CompanyProfileWineExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile of a company. */
export type CompanyProfileWinemakerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile of a company. */
export type CompanyProfileYoutubeArgs = {
  format?: InputMaybe<UrlFormat>;
};

export type CompanyType =
  | 'importer'
  | 'wine';

export type ConfigurationVariable = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** A list of items that is sortable, filterable and can be paginated. */
export type Connection = {
  edges: Array<Edge>;
  nodes: Array<Item>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Contact = {
  /** Whether the contact can access registration. Checks if contact has write access to workspace of the registration. */
  canAccessRegistration?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not yet implemented. */
  companyProfile?: Maybe<CompanyProfile>;
  contactId: Scalars['ID']['output'];
  /**
   * The types that each contact person represents.
   * Only used for collection registrations.
   */
  contactTypes?: Maybe<Array<ContactType>>;
  email?: Maybe<Scalars['String']['output']>;
  /** The full name of the contact person (given name and family name). */
  fullName?: Maybe<Scalars['String']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use telephone instead. */
  phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Unsupported for now. */
  phoneAlt?: Maybe<Scalars['String']['output']>;
  /** @deprecated Experimental. Use at your own risk! */
  profile?: Maybe<SiteUserProfile>;
  /**
   * Returns the update token needed for updating the profile.
   * This is only available to organizers.
   * @deprecated Experimental. Use at your own risk!
   */
  profileUpdateToken: Scalars['String']['output'];
  /** The registration that this contact is associated with */
  registrationId?: Maybe<Scalars['ID']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  /** The job title of the contact. */
  title?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type ContactCompanyNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ContactEmailArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ContactFullNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ContactProfileArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type ContactProfileUpdateTokenArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type ContactTelephoneArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


export type ContactTitleArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ContactWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};

export type ContactDataInput = {
  /** The contact IDs that will receive the message. */
  contactIds: Array<Scalars['ID']['input']>;
  /** The registration where the message was triggered. */
  registrationId: Scalars['ID']['input'];
};

export type ContactFilterInput = {
  contactTypes?: InputMaybe<ContactTypeQueryOperatorInput>;
};

export type ContactType =
  | 'ATTENDING'
  | 'DISTRIBUTION'
  | 'MANAGEMENT'
  | 'PRIMARY';

/**
 * A filter input type for ContactType fields.
 * Use to filter contacts.
 */
export type ContactTypeQueryOperatorInput = {
  eq?: InputMaybe<ContactType>;
  in?: InputMaybe<Array<InputMaybe<ContactType>>>;
  ne?: InputMaybe<ContactType>;
  nin?: InputMaybe<Array<InputMaybe<ContactType>>>;
};

export type ContentDisposition =
  | 'attachment'
  | 'inline';

export type ContentLocale =
  | 'cn'
  | 'de'
  | 'en'
  | 'es'
  | 'fr'
  | 'it'
  | 'ja'
  | 'ms'
  | 'nl'
  | 'pt'
  | 'sk'
  | 'th'
  | 'zh';

/** The code for a package's content as defined in GS1 standards. */
export type ContentUnitCode =
  /** Centilitre */
  | 'CLT'
  /** Square centimetre */
  | 'CMK'
  /** Cubic centimetre */
  | 'CMQ'
  /** Centimetre */
  | 'CMT'
  /** Decilitre */
  | 'DLT'
  /** Square decimetre */
  | 'DMK'
  /** Cubic decimetre */
  | 'DMQ'
  /** Decimetre */
  | 'DMT'
  /** Dose */
  | 'E27'
  /** Use */
  | 'E55'
  /** Each */
  | 'EA'
  /** Gram */
  | 'GRM'
  /** Piece */
  | 'H87'
  /** Hectolitre */
  | 'HLT'
  /** Kilogram */
  | 'KGM'
  /** Kilometre */
  | 'KMT'
  /** Kit */
  | 'KT'
  /** Litre */
  | 'LTR'
  /** Milligram */
  | 'MGM'
  /** Millilitre */
  | 'MLT'
  /** Square millimetre */
  | 'MMK'
  /** Cubic millimetre */
  | 'MMQ'
  /** Millimetre */
  | 'MMT'
  /** Square metre */
  | 'MTK'
  /** Cubic metre */
  | 'MTQ'
  /** Metre */
  | 'MTR'
  /** Pair */
  | 'PR'
  /** Portion */
  | 'PTN'
  /** Set */
  | 'SET'
  /** Tonne */
  | 'TNE'
  /** Tablet */
  | 'U2'
  /** Roll */
  | 'XRO'
  /** Count */
  | '_1N';

/** A content value including unit. */
export type ContentValue = {
  /** The content in a specific locale. */
  formattedValue: Scalars['String']['output'];
  unit: ContentUnitCode;
  value: Scalars['Float']['output'];
};


/** A content value including unit. */
export type ContentValueFormattedValueArgs = {
  format?: InputMaybe<NumberFormat>;
  locale: ContentLocale;
};

export type CopyFormConfigurationInput = {
  /** The ID of the collection to copy data from. */
  sourceCollectionId: Scalars['ID']['input'];
  /** The ID of the collection to copy data to. */
  targetCollectionId: Scalars['ID']['input'];
};

export type CopyFormConfigurationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  collection?: Maybe<Collection>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CoreELabelProduct = {
  /** The bottle image. */
  bottleImage?: Maybe<CloudinaryAsset>;
  /** The bottlebooks ID. */
  productId?: Maybe<Scalars['ID']['output']>;
  /** The name without the vintage. */
  shortName?: Maybe<Scalars['String']['output']>;
  /** The vintage. */
  vintage?: Maybe<Scalars['String']['output']>;
};

export type Country =
  /** Andorra */
  | 'ad'
  /** United Arab Emirates */
  | 'ae'
  /** Afghanistan */
  | 'af'
  /** Antigua */
  | 'ag'
  /** Albania */
  | 'al'
  /** Armenia */
  | 'am'
  /** Angola */
  | 'ao'
  /** Argentina */
  | 'ar'
  /** Austria */
  | 'at'
  /** Australia */
  | 'au'
  /** Azerbaijan */
  | 'az'
  /** Bosnia and Herzegovina */
  | 'ba'
  /** Barbados */
  | 'bb'
  /** Belgium */
  | 'be'
  /** Burkina Faso */
  | 'bf'
  /** Bulgaria */
  | 'bg'
  /** Bahrain */
  | 'bh'
  /** Bermuda */
  | 'bm'
  /** Brunei */
  | 'bn'
  /** Bolivia */
  | 'bo'
  /** Brazil */
  | 'br'
  /** Botswana */
  | 'bw'
  /** Belarus */
  | 'by'
  /** Belize */
  | 'bz'
  /** Canada */
  | 'ca'
  /** Democratic Republic of Congo */
  | 'cd'
  /** Switzerland */
  | 'ch'
  /** Ivory Coast */
  | 'ci'
  /** Chile */
  | 'cl'
  /** Cameroon */
  | 'cm'
  /** China */
  | 'cn'
  /** Colombia */
  | 'co'
  /** Costa Rica */
  | 'cr'
  /** Cuba */
  | 'cu'
  /** Cyprus */
  | 'cy'
  /** Czech Republic */
  | 'cz'
  /** Germany */
  | 'de'
  /** Denmark */
  | 'dk'
  /** Dominican Republic */
  | 'do'
  /** Ecuador */
  | 'ec'
  /** Estonia */
  | 'ee'
  /** Egypt */
  | 'eg'
  /** Spain */
  | 'es'
  /** Ethiopia */
  | 'et'
  /** Finland */
  | 'fi'
  /** France */
  | 'fr'
  /** United Kingdom */
  | 'gb'
  /** England */
  | 'gb_eng'
  /** Northern Ireland */
  | 'gb_nir'
  /** Scotland */
  | 'gb_sct'
  /** Wales */
  | 'gb_wls'
  /** Grenada */
  | 'gd'
  /** Georgia */
  | 'ge'
  /** Ghana */
  | 'gh'
  /** Guadeloupe */
  | 'gp'
  /** Greece */
  | 'gr'
  /** Guatemala */
  | 'gt'
  /** Guyana */
  | 'gy'
  /** Hong Kong */
  | 'hk'
  /** Honduras */
  | 'hn'
  /** Croatia */
  | 'hr'
  /** Haiti */
  | 'ht'
  /** Hungary */
  | 'hu'
  /** Indonesia */
  | 'id'
  /** Ireland */
  | 'ie'
  /** Israel */
  | 'il'
  /** India */
  | 'in'
  /** Iraq */
  | 'iq'
  /** Iran */
  | 'ir'
  /** Iceland */
  | 'is'
  /** Italy */
  | 'it'
  /** Jamaica */
  | 'jm'
  /** Jordan */
  | 'jo'
  /** Japan */
  | 'jp'
  /** Kenya */
  | 'ke'
  /** Kyrgyzstan */
  | 'kg'
  /** Cambodia */
  | 'kh'
  /** Saint Kitts */
  | 'kn'
  /** South Korea */
  | 'kr'
  /** Kuwait */
  | 'kw'
  /** Kazakhstan */
  | 'kz'
  /** Laos */
  | 'la'
  /** Lebanon */
  | 'lb'
  /** Saint Lucia */
  | 'lc'
  /** Sri Lanka */
  | 'lk'
  /** Luxemburg */
  | 'lu'
  /** Latvia */
  | 'lv'
  /** Lybia */
  | 'ly'
  /** Morocco */
  | 'ma'
  /** Moldova */
  | 'md'
  /** Montenegro */
  | 'me'
  /** Madagascar */
  | 'mg'
  /** Macedonia */
  | 'mk'
  /** Mali */
  | 'ml'
  /** Myanmar */
  | 'mm'
  /** Mongolia */
  | 'mn'
  /** Martinique */
  | 'mq'
  /** Malta */
  | 'mt'
  /** Mauritius */
  | 'mu'
  /** Maldives */
  | 'mv'
  /** Mexico */
  | 'mx'
  /** Malaysia */
  | 'my'
  /** Mozambique */
  | 'mz'
  /** Nigeria */
  | 'ng'
  /** Nicaragua */
  | 'ni'
  /** Netherlands */
  | 'nl'
  /** Norway */
  | 'no'
  /** Nepal */
  | 'np'
  /** New Zealand */
  | 'nz'
  /** Panama */
  | 'pa'
  /** Peru */
  | 'pe'
  /** Philippines */
  | 'ph'
  /** Poland */
  | 'pl'
  /** Puerto Rico */
  | 'pr'
  /** Portugal */
  | 'pt'
  /** Paraguay */
  | 'py'
  /** Romania */
  | 'ro'
  /** Serbia */
  | 'rs'
  /** Russia */
  | 'ru'
  /** Sudan */
  | 'sd'
  /** Sweden */
  | 'se'
  /** Singapore */
  | 'sg'
  /** Slovenia */
  | 'si'
  /** Slovakia */
  | 'sk'
  /** San Marino */
  | 'sm'
  /** Senegal */
  | 'sn'
  /** Suriname */
  | 'sr'
  /** Syria */
  | 'sy'
  /** Thailand */
  | 'th'
  /** Tunisia */
  | 'tn'
  /** Turkey */
  | 'tr'
  /** Trinidad and Tobago */
  | 'tt'
  /** Taiwan */
  | 'tw'
  /** Tanzania */
  | 'tz'
  /** Ukraine */
  | 'ua'
  /** Uganda */
  | 'ug'
  /** USA */
  | 'us'
  /** Uruguay */
  | 'uy'
  /** Uzbekistan */
  | 'uz'
  /** Vietnam */
  | 'vn'
  /** Kosovo */
  | 'xk'
  /** Venezuela */
  | 'yv'
  /** South Africa */
  | 'za'
  /** Algeria */
  | 'zd'
  /** Zambia */
  | 'zm'
  /** Zimbabwe */
  | 'zw';

/**
 * A filter input type for Country.
 * Use to filter distributor by country for example.
 */
export type CountryQueryOperatorInput = {
  eq?: InputMaybe<Country>;
  in?: InputMaybe<Array<InputMaybe<Country>>>;
  ne?: InputMaybe<Country>;
  nin?: InputMaybe<Array<InputMaybe<Country>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDataFileJobResponse = MutationResponse & {
  code: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateELabelInput = {
  /** The description of the eLabel. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The languages selected for the eLabel. */
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The target market for this eLabel */
  market?: InputMaybe<Scalars['String']['input']>;
  /** The name of the eLabel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The eLabel producer information. */
  producer?: InputMaybe<ELabelProducerInput>;
  /** The eLabel product information. */
  product?: InputMaybe<ELabelProductInput>;
  /** The eLabel prouct type. */
  productType?: InputMaybe<Scalars['String']['input']>;
  /** The data source from where the qr-code is created. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the workspace adding the e-label. */
  workspaceId: Scalars['ID']['input'];
};

export type CreateELabelResponse = MutationResponse & {
  code: Scalars['String']['output'];
  eLabel?: Maybe<ELabel>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};


export type CreateELabelResponseELabelArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type CreateELabelsAnalyticsJobInput = {
  /** The e-label ID's to be exported. */
  elabelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the workspace exporting the e-labels. */
  workspaceId: Scalars['ID']['input'];
};

export type CreateELabelsIngredientsStatementExportJobInput = {
  /** The e-label ID's to be exported. */
  elabelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the workspace exporting the e-labels. */
  workspaceId: Scalars['ID']['input'];
};

export type CreateELabelsListJobInput = {
  /** The e-label ID's to be exported. */
  elabelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the workspace exporting the e-labels. */
  workspaceId: Scalars['ID']['input'];
};

export type CreateExportConfigurationResponse = {
  code: Scalars['String']['output'];
  configuration?: Maybe<ExportConfiguration>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateGroupInput = {
  /** The name of the group. */
  name: Scalars['String']['input'];
};

export type CreateGroupResponse = MutationResponse & {
  code: Scalars['String']['output'];
  groupId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateImagesDownloadResponse = MutationResponse & {
  code: Scalars['String']['output'];
  jobId?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateInfoSheetsJobResponse = MutationResponse & {
  code: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateNotificationContactInput = {
  /** If true, the user is added and the message is not sent. */
  ignoreMessage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this contact locked? */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** The message to send. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The contact data. */
  notificationContact: NotificationContactInput;
  /** The ID of the registration where the contact should be edited. */
  registrationId: Scalars['ID']['input'];
};

export type CreateNotificationContactsInput = {
  /** If true, the user is added and the message is not sent. */
  ignoreMessage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this contact locked? */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** The message to send. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The contacts data. */
  notificationContacts: Array<NotificationContactInput>;
  /** The ID of the registration where the contacts should be added. */
  registrationId: Scalars['ID']['input'];
};

export type CreateNotificationContactsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  contacts: Array<Contact>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateOrUpdateEventAreaInput = {
  collectionId: Scalars['ID']['input'];
  currentWorkspaceId: Scalars['ID']['input'];
  data: Scalars['JSONObject']['input'];
  slug: Scalars['String']['input'];
};

export type CreateOrUpdateEventAreaResponse = MutationResponse & {
  area?: Maybe<EventArea>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreatePartnerInput = {
  /** The related Bottlebooks brand id when partner is not defined yet. */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** The import id where the supplier was matched. */
  importId: Scalars['ID']['input'];
  /** The imported data related with supplier. */
  supplier: Scalars['String']['input'];
};

export type CreateProductListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateProductListJobResponse = MutationResponse & {
  code: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateProductListResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  productList?: Maybe<ShareList>;
  productListId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateQrCodeAssetInput = {
  /** Collection id that this QR Code is associated with */
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  /** E-label id that this QR Code is associated with */
  elabelId?: InputMaybe<Scalars['ID']['input']>;
  /** QR Code error correction level */
  errorCorrectionLevel?: InputMaybe<QrCodeErrorCorrectionLevel>;
  /** Ovelays info icon on QR Code */
  overlayInfoIcon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Product id that this QR Code is associated with */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** URL to be encoded */
  qrCodeUrl: Scalars['String']['input'];
  /** Registration id that this QR Code is associated with */
  registrationId?: InputMaybe<Scalars['ID']['input']>;
  /** Short code encoded in the QR code (the string following the domain) */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  /** Display title of the QR Code */
  title: Scalars['String']['input'];
  /** Workspace id that this QR Code is associated with */
  workspaceId: Scalars['ID']['input'];
};

export type CreateQrCodeAssetResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The QR code that was created. */
  qrCode: QrCodeAsset;
  success: Scalars['Boolean']['output'];
};

export type CreateQrCodeDownloadJobInput = {
  /** ID of event */
  eventId: Scalars['ID']['input'];
  /** Exhibitor ids to generate codes for */
  exhibitorIds: Array<Scalars['ID']['input']>;
};

export type CreateQrCodeDownloadJobResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The id of the job */
  jobId?: Maybe<Scalars['Int']['output']>;
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Deprecated - Use createQrCodeAsset instead */
export type CreateQrCodeInput = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  elabelId?: InputMaybe<Scalars['ID']['input']>;
  errorCorrectionLevel?: InputMaybe<QrCodeErrorCorrectionLevel>;
  overlayInfoIcon?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  qrCodeUrl: Scalars['String']['input'];
  registrationId?: InputMaybe<Scalars['ID']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/** Deprecated - Use createQrCodeAsset instead */
export type CreateQrCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode: QrCodeAsset;
  success: Scalars['Boolean']['output'];
};

export type CreateStripeCheckoutSessionInput = {
  businessName: Scalars['String']['input'];
  cancelUrl: Scalars['String']['input'];
  country: Scalars['String']['input'];
  packageKey: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
  vatId?: InputMaybe<Scalars['String']['input']>;
  /** The workspace ID. */
  workspaceId: Scalars['ID']['input'];
};

export type CreateStripeCheckoutSessionResponse = MutationResponse & {
  checkoutData?: Maybe<StripeCheckoutData>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreatedOutput = {
  configuration: CollectionOutputConfiguration;
  configurationId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: UserProfile;
  files: Array<FileOutput>;
  outputId: Scalars['ID']['output'];
  outputState: OutputState;
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type CreatedProductOutput = CreatedOutput & ProductOutput & Unstable_CollectionOutputInterface & Unstable_ProductOutputInterface & {
  collection: Collection;
  collectionId: Scalars['String']['output'];
  configuration: CollectionOutputConfiguration;
  configurationId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: UserProfile;
  files: Array<FileOutput>;
  /**
   * The key is used to uniquely identify an item in an array.
   * It's guaranteed to be unique in the list, similar to a cursor, and it's somewhat stable over time, while not guaranteed to stay the same forever.
   * Don't use it to link to this output, and also don't interpret its content.
   * Instead just use it for determining if this is the same item as you had before, even if you change some attributes.
   */
  key: Scalars['String']['output'];
  /** The output's unique ID. */
  outputId: Scalars['ID']['output'];
  outputState: OutputState;
  product: Product;
  productId: Scalars['String']['output'];
  /** The output's unique ID. Identical to the outputId. */
  productOutputId: Scalars['ID']['output'];
  /** The specific product version that was used to create this output. */
  productVersion: ProductVersionDetails;
  productVersionId: Scalars['String']['output'];
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type CreatedReason =
  | 'CREATED_PRODUCT'
  | 'CREATED_VERSION'
  | 'CREATED_VINTAGE'
  | 'DUPLICATED'
  | 'IMPORTED'
  | 'MIGRATED'
  | 'REQUESTED';

/** A custom field for collections. */
export type CustomField = Field & {
  /** The custom field's id. */
  customFieldId: Scalars['ID']['output'];
  /**
   * The path to the field in the changed object.
   * It identifies the field uniquely.
   */
  fieldId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  /**
   * The interface label for that field.
   * The locale parameter will allow for fetching the label in a particular UI language,
   * but that's not implemented yet - it's an experimental suggestion only.
   */
  label?: Maybe<Scalars['String']['output']>;
  type: CustomFieldType;
  /** The field's value. Could be a text, a number, date, image or others. */
  value: FieldValue;
};


/** A custom field for collections. */
export type CustomFieldLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldType =
  | 'DATE'
  | 'FILE'
  | 'IMAGE'
  | 'MULTISELECT'
  | 'SELECT'
  | 'TEXT'
  | 'YES_NO';

/** Deprecated - use ELabelFieldValue instead. */
export type CustomMultipleField = {
  key: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<LocalizedText>;
};

export type DataImport = Item & {
  /** The list of the destination fields in Bottlebooks. */
  bottlebooksFields?: Maybe<Array<DataImportBottlebooksField>>;
  childProductCreationImportId?: Maybe<Scalars['String']['output']>;
  /** The collection the data is import to. */
  collection?: Maybe<Collection>;
  /** The ID of the collection where the data will be imported. */
  collectionId?: Maybe<Scalars['ID']['output']>;
  /** An ISO date when the event was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<BrandUser>;
  /**
   * The index where the data starts.
   * @deprecated Use source.dataRowIndex instead.
   */
  dataRowIndex?: Maybe<Scalars['Int']['output']>;
  /**
   * The original filename.
   * @deprecated Use source.filename instead.
   */
  filename?: Maybe<Scalars['String']['output']>;
  /**
   * The row index of the header.
   * @deprecated Use source.headerRowIndex instead.
   */
  headerRowIndex?: Maybe<Scalars['Int']['output']>;
  /** The list of the fields that identifies the row. */
  identifierFields?: Maybe<Array<DataImportBottlebooksField>>;
  /** The unique ID of the import. */
  importId: Scalars['ID']['output'];
  /** The list of import options defined by the user. */
  importOptions?: Maybe<Scalars['JSON']['output']>;
  importValidation?: Maybe<DataImportValidation>;
  /** The name of the import. */
  name?: Maybe<Scalars['String']['output']>;
  /** When the import generates a file to be downloaded. */
  outputUrl?: Maybe<Scalars['String']['output']>;
  /** Preview of changes to be made by the import. */
  preview?: Maybe<Array<DataImportResult>>;
  /** The ID of the product list that is created when the import is finalized. */
  productListId?: Maybe<Scalars['ID']['output']>;
  /** The raw imported data. Can be tabular, CSV, binary or structured. */
  rawData?: Maybe<Scalars['JSON']['output']>;
  /** Results of changes made by the import. */
  results?: Maybe<Array<DataImportResult>>;
  /** The rows of the import source. This is a shortcut into source.rows. */
  rows?: Maybe<DataImportSourceRowConnection>;
  /** The source data of the import. */
  source: DataImportSource;
  /**
   * The list of the source fields.
   * @deprecated Use source.fields instead.
   */
  sourceFields?: Maybe<Array<DataImportSourceField>>;
  /** The current state the import is in. */
  state: StateField;
  /** The list of suppliers and the related bottlebooks partner id. */
  suppliers?: Maybe<Array<Maybe<SupplierMap>>>;
  /** The type of imported data (products, master list of product requests, external IDs etc.) */
  type: DataImportType;
  /** The list of the validation errors per field. */
  validationErrors?: Maybe<Array<DataImportValidationError>>;
  /** The owner of the imported file. */
  workspaceId: Scalars['ID']['output'];
};


export type DataImportCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type DataImportRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataImportSourceRowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DataImportAffectedObject = Exhibitor;

export type DataImportAffectedObjectConnection = {
  edges: Array<DataImportAffectedObjectEdge>;
  nodes: Array<DataImportAffectedObject>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DataImportAffectedObjectEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<DataImportAffectedObject>;
  node: DataImportAffectedObject;
  previous?: Maybe<DataImportAffectedObject>;
};

export type DataImportBottlebooksField = {
  /** The field in Bottlebooks. */
  bottlebooksFieldName: Scalars['String']['output'];
  /** @deprecated Will be removed soon. Use dataImport.validationErrors instead. */
  errors?: Maybe<Array<Maybe<ImportFieldError>>>;
  /** The field name in the data import. */
  importFieldName: Scalars['String']['output'];
};

export type DataImportBottlebooksFieldInput = {
  /** The field in Bottlebooks. */
  bottlebooksFieldName: Scalars['String']['input'];
  /** The field name in the data import. */
  importFieldName: Scalars['String']['input'];
};

export type DataImportBottlebooksValueMappingsInput = {
  /** The field in Bottlebooks. */
  bottlebooksFieldName: Scalars['String']['input'];
  /** The bottlebooks valid value of this field for this importedFieldValue. */
  bottlebooksFieldValue: Scalars['String']['input'];
  /** The value of this field in the data import. */
  importedFieldValue: Scalars['String']['input'];
  /** When true, the value will be null (skipped). */
  isValueMappedToNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataImportConnection = Connection & {
  edges: Array<DataImportEdge>;
  nodes: Array<DataImport>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DataImportEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<DataImport>;
  node: DataImport;
  previous?: Maybe<DataImport>;
};

export type DataImportFilterInput = {
  importId?: InputMaybe<IdQueryOperatorInput>;
  state?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};

export type DataImportResult = {
  added?: Maybe<DataImportAffectedObjectConnection>;
  /** How many objects of this type will be added. */
  addedCount?: Maybe<Scalars['Int']['output']>;
  changes?: Maybe<Array<Maybe<ImportChange>>>;
  deleted?: Maybe<DataImportAffectedObjectConnection>;
  /** How many objects of this type will be deleted. */
  deletedCount?: Maybe<Scalars['Int']['output']>;
  /** The type of object modified. */
  object?: Maybe<BottlebooksObject>;
  unchanged?: Maybe<DataImportAffectedObjectConnection>;
  /** How many objects of this type will be unchanged. */
  unchangedCount?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<DataImportAffectedObjectConnection>;
  /** How many objects of this type will be updated. */
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type DataImportSource = {
  /** The list of the source fields. */
  fields?: Maybe<Array<DataImportSourceField>>;
  /** The original filename (for uploaded files). */
  filename?: Maybe<Scalars['String']['output']>;
  /** The format of the source data. */
  format: DataImportSourceFormat;
  /**
   * The raw imported data. Can be tabular, CSV, binary or structured.
   * @deprecated The returned data might be very large - use with caution.
   */
  rawData?: Maybe<Scalars['JSON']['output']>;
  /** The full rows of the import with all the fields. */
  rows?: Maybe<DataImportSourceRowConnection>;
  /** The URL of this source (if downloaded via the web). */
  url?: Maybe<Scalars['String']['output']>;
  /** The owner of the imported file. */
  workspaceId: Scalars['ID']['output'];
};


export type DataImportSourceRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataImportSourceRowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DataImportSourceField = {
  /** The name of a bottlebooks field that this field is mapped to. */
  bottlebooksFieldName?: Maybe<Scalars['String']['output']>;
  /** The source name of the field. */
  name?: Maybe<Scalars['String']['output']>;
  /** The raw text values of this field. */
  rawTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The values that can be used in this field. */
  validValues?: Maybe<Array<Maybe<DataImportValidValue>>>;
  /** The values of this field. */
  values?: Maybe<Array<Maybe<DataImportSourceValue>>>;
};


export type DataImportSourceFieldRawTextsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type DataImportSourceFieldValidValuesArgs = {
  locale?: InputMaybe<ContentLocale>;
};


export type DataImportSourceFieldValuesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type DataImportSourceFormat =
  | 'JSON'
  | 'TABULAR'
  | 'XML';

export type DataImportSourceRow = Item & {
  /** The values of a particular mapped bottlebooks field. */
  bottlebooksFieldValue?: Maybe<DataImportSourceValue>;
  /** The values of the mapped bottlebooks fields. */
  bottlebooksFieldValues?: Maybe<Array<DataImportSourceValue>>;
  /** @deprecated only needed for the Item interface. */
  name?: Maybe<Scalars['String']['output']>;
  /** The unique key of the row. This might be the row index or a path to the row in the source file. */
  rowKey: Scalars['ID']['output'];
  /** A single field of the imported data. */
  value?: Maybe<DataImportSourceValue>;
  /** The imported data as values. */
  values?: Maybe<Array<DataImportSourceValue>>;
};


export type DataImportSourceRowBottlebooksFieldValueArgs = {
  name: Scalars['String']['input'];
};


export type DataImportSourceRowValueArgs = {
  name: Scalars['String']['input'];
};


export type DataImportSourceRowValuesArgs = {
  filter?: InputMaybe<ImportColumnFilterInput>;
};

export type DataImportSourceRowConnection = Connection & {
  edges: Array<DataImportSourceRowEdge>;
  nodes: Array<DataImportSourceRow>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DataImportSourceRowEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<DataImportSourceRow>;
  node: DataImportSourceRow;
  previous?: Maybe<DataImportSourceRow>;
};

export type DataImportSourceRowFilter = {
  /** Filter on a mapped bottlebooksField's values. */
  bottlebooksFieldValues?: InputMaybe<DataImportSourceValuesFieldQueryOperatorInput>;
  /** Filter on a source field's values. */
  values?: InputMaybe<DataImportSourceValuesFieldQueryOperatorInput>;
};

export type DataImportSourceTabular = DataImportSource & {
  /** The index where the data starts. */
  dataRowIndex?: Maybe<Scalars['Int']['output']>;
  /** The list of the source fields. */
  fields?: Maybe<Array<DataImportSourceField>>;
  /** The original filename (for uploaded files). */
  filename?: Maybe<Scalars['String']['output']>;
  /** The format of the source data. */
  format: DataImportSourceFormat;
  /** The row index of the header. */
  headerRowIndex?: Maybe<Scalars['Int']['output']>;
  /**
   * The raw imported data.
   * For tabular data this returns an array of rows, which are arrays of values.
   * @deprecated The returned data might be very large - use with caution.
   */
  rawData?: Maybe<Scalars['JSON']['output']>;
  rawRows: Array<Array<Maybe<Scalars['JSON']['output']>>>;
  /** The full rows of the import with all the fields. */
  rows?: Maybe<DataImportSourceRowConnection>;
  /** The URL of this source (if downloaded via the web). */
  url?: Maybe<Scalars['String']['output']>;
  /** The owner of the imported file. */
  workspaceId: Scalars['ID']['output'];
};


export type DataImportSourceTabularRawRowsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type DataImportSourceTabularRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataImportSourceRowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The value of a field in a row. */
export type DataImportSourceValue = {
  /**
   * The name of the mapped bottlebooks field.
   * This is only set when querying bottlebooksFieldValues.
   */
  bottlebooksFieldName?: Maybe<Scalars['String']['output']>;
  /** The flag that indicates if the value is mapped to null (skipped). */
  isValueMappedToNull?: Maybe<Scalars['Boolean']['output']>;
  /** The source name of the field. */
  name?: Maybe<Scalars['String']['output']>;
  /** The raw content of the field. */
  rawText?: Maybe<Scalars['String']['output']>;
  /** The suggested values. */
  suggestedValues?: Maybe<Array<Maybe<DataImportSuggestedValue>>>;
  /** The value based on values mapped by the user. */
  value?: Maybe<Scalars['String']['output']>;
};


/** The value of a field in a row. */
export type DataImportSourceValueSuggestedValuesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type DataImportSourceValueFieldQueryOperatorInput = {
  bottlebooksFieldName?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  rawText?: InputMaybe<StringQueryOperatorInput>;
};

/**
 * A filter input type for an array of DataImportSourceValues.
 * Use to filter on dataImport.values or dataImport.bottlebooksFields.
 */
export type DataImportSourceValuesFieldQueryOperatorInput = {
  elemMatch?: InputMaybe<DataImportSourceValueFieldQueryOperatorInput>;
};

export type DataImportState =
  | 'COMPLETED'
  | 'ERROR'
  | 'JOB_IN_PROGRESS'
  | 'STARTED';

/** The suggested value of a cell. */
export type DataImportSuggestedValue = {
  /** The probability of the suggested value (0 - 1). */
  probability?: Maybe<Scalars['Float']['output']>;
  /** The suggested value. */
  value?: Maybe<Scalars['String']['output']>;
};

export type DataImportSuppliersMappingInput = {
  /** The related Bottlebooks brand id when partner is not defined yet. */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** The related Bottlebooks partner id. */
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  /** The imported data related with supplier. */
  supplier: Scalars['String']['input'];
};

export type DataImportType =
  | 'partnerAliasImport'
  | 'portfolioProductExternalIdImport'
  | 'productAllInOneImport'
  | 'productCreationImport'
  | 'productDataImport'
  | 'productExternalIdImport'
  | 'productImport'
  | 'productInternalIdImport'
  | 'productListImport'
  | 'productMasterListImport'
  | 'productMasterListSync'
  | 'profileDataImport';

export type DataImportUpdateInput = {
  /** The ID of the data import that will be updated. */
  importId: Scalars['ID']['input'];
  patch: DataImportUpdatePatchInput;
};

export type DataImportUpdatePatchInput = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The valid value of a field. */
export type DataImportValidValue = {
  /** The key of the field. */
  key?: Maybe<Scalars['String']['output']>;
  /** The label of the field. */
  label?: Maybe<Scalars['String']['output']>;
};

export type DataImportValidation = {
  bottlebooksFields?: Maybe<Array<Maybe<DataImportBottlebooksField>>>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type DataImportValidationError = {
  /** The field in Bottlebooks. */
  bottlebooksFieldName: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<ImportFieldError>>>;
  /** The field name in the data import. */
  importFieldName: Scalars['String']['output'];
};

export type DataSource = {
  date?: Maybe<Scalars['String']['output']>;
  elabel?: Maybe<ELabel>;
  product?: Maybe<Product>;
  user?: Maybe<UserProfile>;
};


export type DataSourceDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type DataSourceInput = {
  elabelId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type DataVersionTag =
  /** All items with the latest data */
  | 'ALL'
  /** The latest released version of the data. */
  | 'RELEASED'
  /** The latest submitted version of the data */
  | 'SUBMITTED';

export type DateFieldValue = FieldValue & {
  /** The raw date as stored in the database. */
  rawText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use value instead. */
  text?: Maybe<Scalars['String']['output']>;
  /** The formatted date. */
  value?: Maybe<Scalars['String']['output']>;
};


export type DateFieldValueTextArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type DateFieldValueValueArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A filter input type for date fields.
 * Use to filter products on last update for example.
 */
export type DateQueryOperatorInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteELabelInput = {
  deleteQrCodes?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the eLabel to be deleted. */
  elabelId: Scalars['ID']['input'];
};

export type DeleteELabelResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteEventAreaInput = {
  collectionId: Scalars['ID']['input'];
  currentWorkspaceId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
};

export type DeleteEventAreaResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteExportConfigurationResponse = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteMultipleProductsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  failed?: Maybe<Array<Scalars['ID']['output']>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteProductResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteRequestedProductInput = {
  collectionId: Scalars['ID']['input'];
  productRequestId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
};

export type DeleteRequestedProductResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteVisitorResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Denomination = {
  countryCode?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  regionCode?: Maybe<Scalars['String']['output']>;
  subregionCode?: Maybe<Scalars['String']['output']>;
};

export type Designation =
  | 'brut'
  | 'brut_nature'
  | 'demi_sec'
  | 'dry'
  | 'extra_brut'
  | 'extra_dry'
  | 'feinherb'
  | 'lieblich'
  | 'semi'
  | 'sweet';

export type DetachFileInput = {
  /** The id of the file to detach. */
  fileId: Scalars['ID']['input'];
  /** The node id to which the file will be detached. */
  nodeId: Scalars['ID']['input'];
};

export type DetachFileResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DiscardELabelDraftChangesInput = {
  elabelId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DiscardELabelDraftChangesResponse = MutationResponse & {
  code: Scalars['String']['output'];
  draft?: Maybe<ELabel>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DraftOutput = {
  configuration: CollectionOutputConfiguration;
  configurationId: Scalars['ID']['output'];
  outputState: OutputState;
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type DraftProductOutput = DraftOutput & ProductOutput & Unstable_CollectionOutputInterface & Unstable_ProductOutputInterface & {
  collection: Collection;
  collectionId: Scalars['String']['output'];
  configuration: CollectionOutputConfiguration;
  configurationId: Scalars['ID']['output'];
  /**
   * The key is used to uniquely identify an item in an array.
   * It's guaranteed to be unique in the list, similar to a cursor, and it's somewhat stable over time, while not guaranteed to stay the same forever.
   * Don't use it to link to this output, and also don't interpret its content.
   * Instead just use it for determining if this is the same item as you had before, even if you change some attributes.
   */
  key: Scalars['String']['output'];
  outputState: OutputState;
  product: Product;
  productId: Scalars['String']['output'];
  /** The temporary identifier derived from the output configuration. */
  productOutputId: Scalars['ID']['output'];
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type DuplicateProductResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type ELabel = ELabelBase & Item & {
  /** Internal data version */
  _dmv: Scalars['String']['output'];
  /** The e-label QR codes. */
  _unstable_qrCodes: Unstable_QrCodeConnection;
  analytics: ELabelAnalyticsConnection;
  /** The target countries of the eLabel. */
  countries?: Maybe<Array<ELabelCountryLocale>>;
  /** The date the eLabel was created. */
  createdAt: Scalars['String']['output'];
  /** The user who created the elabel. */
  createdBy: UserProfile;
  /** The current step on the elabel creation process. */
  creationStep: ELabelCreationStep;
  /** The eLabel custom product type. */
  customProductType?: Maybe<Scalars['String']['output']>;
  /** E-label's connection to Portfolio */
  dataSource?: Maybe<DataSource>;
  /** The description of the eLabel. */
  description?: Maybe<Scalars['String']['output']>;
  /** Bottlebooks ID of the eLabel. */
  elabelId: Scalars['ID']['output'];
  /**
   * The url to the e-label.
   * @deprecated Will be decomissioned. Use url instead.
   */
  elabelUrl: Scalars['String']['output'];
  /** The fields with errors. */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** External data regarding the e-label. */
  external?: Maybe<ELabelExternal>;
  /** The eLabel food business operator. */
  foodBusinessOperators: Array<Maybe<ELabelFoodBusinessOperator>>;
  /** The eLabel in the form version. */
  form?: Maybe<ELabelForm>;
  /** The background color hex code to be used in the elabel. */
  headerBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The imprint. */
  imprint?: Maybe<Scalars['String']['output']>;
  /** Indicates if the e-label is a legacy e-label. */
  isLegacy: Scalars['Boolean']['output'];
  /** The additional languages selected for the eLabel. */
  languages: Array<ELabelLocale>;
  /** The date the eLabel was updated. */
  lastUpdate: Scalars['String']['output'];
  /** The user who last updated the elabel. */
  lastUpdatedBy: UserProfile;
  /** The target market for this eLabel. */
  market?: Maybe<ELabelMarket>;
  /** The name of the eLabel. */
  name: Scalars['String']['output'];
  /** The eLabel producer data. */
  producer?: Maybe<ELabelProducer>;
  /** The eLabel product data. */
  product?: Maybe<ELabelProduct>;
  /** The eLabel product type. */
  productType?: Maybe<Scalars['String']['output']>;
  /** The e-label QR code. */
  qrCode?: Maybe<Unstable_QrCode>;
  /** @deprecated Use qrCodes.images in the next version. */
  qrCodeAssets: Array<Maybe<QrCodeAsset>>;
  /** @deprecated use qrCode.image instead. */
  qrCodeImage?: Maybe<CloudinaryAsset>;
  /**
   * URL encoded in the QR code.
   * @deprecated eLabel can have multiple qrCodes, and we cannot guarantee a stable url - it could change between requests.
   */
  qrCodeUrl?: Maybe<Scalars['String']['output']>;
  /**
   * QR codes created by Bottlebooks for this e-label.
   * @deprecated Use qrCodes.images in the next version.
   */
  qrCodes: Array<Maybe<QrCodeAsset>>;
  /** The form language. */
  referenceLanguage?: Maybe<ELabelLocale>;
  /** Universal ID of the eLabel. */
  shortCode: Scalars['ID']['output'];
  /** The state of the elabel regarding the latest release. */
  status: ELabelStatus;
  /** The data source from where the qr code is created. */
  type: ELabelType;
  /** The eLabel rendering url. */
  url: Scalars['String']['output'];
  /** @deprecated Will be decomissioned in the future. Use url instead. */
  urlV2?: Maybe<Scalars['String']['output']>;
  /**
   * The user who created the elabel.
   * @deprecated Use 'createdBy' instead.
   */
  user: UserProfile;
  /** The current elabel version or the requested release. */
  version?: Maybe<ELabelVersion>;
  versionId: Scalars['ID']['output'];
  /** The elabel versions. */
  versions?: Maybe<ELabelVersionConnection>;
};


export type ELabel_Unstable_QrCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Unstable_QrCodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ELabelAnalyticsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type ELabelCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ELabelElabelUrlArgs = {
  format?: InputMaybe<UrlFormat>;
  locale?: InputMaybe<ELabelLocale>;
};


export type ELabelLastUpdateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ELabelProductTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type ELabelUrlArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<UrlFormat>;
  locale?: InputMaybe<ELabelLocale>;
};


export type ELabelUrlV2Args = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<UrlFormat>;
  urlVersion?: ELabelRenderingUrlVersion;
};


export type ELabelVersionArgs = {
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ELabelAnalyticsConnection = {
  edges: Array<ELabelAnalyticsEdge>;
  group: Array<ELabelAnalyticsGroupConnection>;
  nodes: Array<ELabelPageView>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};


export type ELabelAnalyticsConnectionGroupArgs = {
  field: ELabelAnalyticsField;
};

export type ELabelAnalyticsEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<ELabelPageView>;
  node: ELabelPageView;
  previous?: Maybe<ELabelPageView>;
};

export type ELabelAnalyticsField =
  | 'country'
  | 'day'
  | 'elabelId'
  | 'month'
  | 'week'
  | 'year';

export type ELabelAnalyticsGroup = {
  totalCount: Scalars['Int']['output'];
};

export type ELabelAnalyticsGroupConnection = {
  edges: Array<ELabelAnalyticsEdge>;
  endDate?: Maybe<Scalars['String']['output']>;
  field: ELabelAnalyticsField;
  fieldValue: Scalars['String']['output'];
  firstNode: ELabelPageView;
  group: Array<ELabelAnalyticsGroupConnection>;
  nodes: Array<ELabelPageView>;
  pageInfo: PageInfo;
  startDate?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type ELabelAnalyticsGroupConnectionGroupArgs = {
  field: ELabelAnalyticsField;
};


export type ELabelAnalyticsGroupConnectionNodesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ELabelAsset = {
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<LocalizedField>;
  key: Scalars['String']['output'];
  logo?: Maybe<CloudinaryAsset>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ELabelAssetType>;
};

export type ELabelAssetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<LocalizedInput>;
  key: Scalars['String']['input'];
  logo?: InputMaybe<FileUrlInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ELabelAssetType>;
};

export type ELabelAssetType =
  | 'custom'
  | 'standard';

export type ELabelBase = {
  /** The target countries of the eLabel. */
  countries?: Maybe<Array<ELabelCountryLocale>>;
  /** The date the eLabel was created. */
  createdAt: Scalars['String']['output'];
  /** The current step on the elabel creation process. */
  creationStep: ELabelCreationStep;
  /** Save the user choice of the eLabel datasource. */
  dataSource?: Maybe<DataSource>;
  /** The description of the eLabel. */
  description?: Maybe<Scalars['String']['output']>;
  /** Bottlebooks ID of the eLabel. */
  elabelId: Scalars['ID']['output'];
  /** The fields with errors. */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** External data regarding the e-label. */
  external?: Maybe<ELabelExternal>;
  /** The additional languages selected for the eLabel. */
  languages: Array<ELabelLocale>;
  /** The date the eLabel was updated. */
  lastUpdate: Scalars['String']['output'];
  /** The target market for this eLabel. */
  market?: Maybe<ELabelMarket>;
  /** The name of the eLabel. */
  name: Scalars['String']['output'];
  /** The form language. */
  referenceLanguage?: Maybe<ELabelLocale>;
  /** The state of the elabel regarding the latest release. */
  status: ELabelStatus;
  /** The data source from where the qr code is created. */
  type: ELabelType;
  /**
   * The eLabel url.
   * @deprecated Currently this is not used. Might get deleted
   */
  url: Scalars['String']['output'];
  /** The user who created the elabel. */
  user: UserProfile;
  /** The current elabel version or the requested release. */
  version?: Maybe<ELabelVersion>;
  /** The elabel versions. */
  versions?: Maybe<ELabelVersionConnection>;
};


export type ELabelBaseCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ELabelBaseLastUpdateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ELabelBaseVersionArgs = {
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ELabelConnection = {
  analytics: ELabelAnalyticsConnection;
  coreNodes: Array<Unstable_CoreELabel>;
  edges: Array<ELabelEdge>;
  nodes: Array<ELabel>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** The eLabel valid values options. */
  validValues?: Maybe<ValidValues>;
};


export type ELabelConnectionAnalyticsArgs = {
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type ELabelConnectionValidValuesArgs = {
  elabelId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<ELabelLocale>;
};

export type ELabelCountryLocale =
  | 'at'
  | 'be'
  | 'bg'
  | 'cy'
  | 'cz'
  | 'de'
  | 'dk'
  | 'ee'
  | 'es'
  | 'fi'
  | 'fr'
  | 'gb'
  | 'gr'
  | 'hr'
  | 'hu'
  | 'ie'
  | 'it'
  | 'lt'
  | 'lu'
  | 'lv'
  | 'mt'
  | 'nl'
  | 'pl'
  | 'pt'
  | 'ro'
  | 'se'
  | 'si'
  | 'sk';

export type ELabelCreationStep =
  /** The eLabel is not yet created and shows a basic placeholder page */
  | 'PARKED'
  /** Data has been selected for the elabel */
  | 'data'
  /** Datasource should be selected next */
  | 'dataSource'
  /** Basic e-labels settings should be selected next */
  | 'elabel'
  /** QR code is ready for download. This is the same as being PARKED. */
  | 'qrcode';

export type ELabelCustomOptionInput = {
  key: Scalars['String']['input'];
  translations?: InputMaybe<LocalizedTextInput>;
  type?: InputMaybe<ELabelAssetType>;
};

export type ELabelCustomOptionType = {
  key: Scalars['String']['output'];
  translations?: Maybe<LocalizedText>;
  type: ELabelAssetType;
  value: Scalars['String']['output'];
};

export type ELabelDataImportOptionsInput = {
  updateELabels?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ELabelEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<ELabel>;
  node: ELabel;
  previous?: Maybe<ELabel>;
};

export type ELabelExternal = {
  externalPreviewId?: Maybe<Scalars['String']['output']>;
  externalReleaseId?: Maybe<Scalars['String']['output']>;
};

/** A customizable value from a list. */
export type ELabelFieldValue = {
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};


/** A customizable value from a list. */
export type ELabelFieldValueLabelArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type ELabelFilterInput = {
  elabelId?: InputMaybe<IdQueryOperatorInput>;
  productType?: InputMaybe<ELabelProductTypeQueryOperatorInput>;
  status?: InputMaybe<ELabelStatusQueryOperatorInput>;
};

export type ELabelFoodBusinessOperator = Item & {
  /** The address info of the food business operator. */
  address?: Maybe<Scalars['String']['output']>;
  /** The country of the food business operator. */
  country?: Maybe<Scalars['String']['output']>;
  /** The index of this product within the registration's products. */
  foodBusinessOperatorType?: Maybe<Scalars['String']['output']>;
  /** The name of the food business operator. */
  name?: Maybe<Scalars['String']['output']>;
};


export type ELabelFoodBusinessOperatorCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelFoodBusinessOperatorFoodBusinessOperatorTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type ELabelFoodBusinessOperatorForm = {
  address: Scalars['String']['output'];
  country: SingleSelectionField;
  foodBusinessOperatorType: SingleSelectionField;
  name: Scalars['String']['output'];
};

export type ELabelFoodBusinessOperatorInput = {
  address: Scalars['String']['input'];
  country: SingleSelectionInput;
  foodBusinessOperatorType: SingleSelectionInput;
  name: Scalars['String']['input'];
};

export type ELabelForm = ELabelBase & Item & {
  /** The target countries of the eLabel. */
  countries?: Maybe<Array<ELabelCountryLocale>>;
  /** The date the eLabel was created. */
  createdAt: Scalars['String']['output'];
  /** The current step on the elabel creation process. */
  creationStep: ELabelCreationStep;
  /** The eLabel custom product type. */
  customProductType?: Maybe<LocalizedText>;
  /** Save the user choice of the eLabel datasource. */
  dataSource?: Maybe<DataSource>;
  /** The description of the eLabel. */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the eLabel. */
  elabelId: Scalars['ID']['output'];
  /** The fields with errors. */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** External data regarding the e-label. */
  external?: Maybe<ELabelExternal>;
  /** The food business operators data. */
  foodBusinessOperators: Array<Maybe<ELabelFoodBusinessOperatorForm>>;
  /** The background color hex code to be used in the elabel. */
  headerBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The imprint. */
  imprint?: Maybe<Scalars['String']['output']>;
  /** The additional languages selected for the eLabel. */
  languages: Array<ELabelLocale>;
  /** The date the eLabel was updated. */
  lastUpdate: Scalars['String']['output'];
  /** The target market for this eLabel. */
  market?: Maybe<ELabelMarket>;
  name: Scalars['String']['output'];
  /** The eLabel producer data. */
  producer?: Maybe<ELabelProducerForm>;
  /** The eLabel product data. */
  product?: Maybe<ELabelProductForm>;
  /** The eLabel product type. */
  productType?: Maybe<ELabelProductType>;
  /** The form language. */
  referenceLanguage?: Maybe<ELabelLocale>;
  /** The state of the elabel regarding the latest version. */
  status: ELabelStatus;
  /** The elabel type. */
  type: ELabelType;
  /**
   * The eLabel url.
   * @deprecated Currently this is not used. Might get deleted
   */
  url: Scalars['String']['output'];
  /** The user who created the elabel. */
  user: UserProfile;
  validValues: ValidValues;
  /** The current elabel version or the requested versionId. */
  version?: Maybe<ELabelVersion>;
  /** The elabel versions. */
  versions?: Maybe<ELabelVersionConnection>;
};


export type ELabelFormCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ELabelFormLastUpdateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ELabelFormVersionArgs = {
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ELabelFruitVarietyOptionInput = {
  key: Scalars['String']['input'];
  type?: InputMaybe<ELabelAssetType>;
  value: Scalars['String']['input'];
};

export type ELabelFruitVarietyOptionType = {
  key: Scalars['String']['output'];
  type: ELabelAssetType;
  value: Scalars['String']['output'];
};

export type ELabelJobExportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ELabelLocale =
  | 'bg'
  | 'cs'
  | 'da'
  | 'de'
  | 'ee'
  | 'el'
  | 'en'
  | 'es'
  | 'et'
  | 'fi'
  | 'fr'
  | 'ga'
  | 'hr'
  | 'hu'
  | 'it'
  | 'ka'
  | 'lt'
  | 'lv'
  | 'mt'
  | 'nl'
  | 'pl'
  | 'pt'
  | 'ro'
  | 'se'
  | 'si'
  | 'sk'
  | 'sl'
  | 'sv';

export type ELabelLocalizedAsset = {
  category?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  logo?: Maybe<CloudinaryAsset>;
  translations?: Maybe<LocalizedText>;
};

export type ELabelLocalizedAssetInput = {
  key: Scalars['String']['input'];
  logo?: InputMaybe<FileUrlInput>;
};

/** A customized, multilingual text. */
export type ELabelLocalizedTextFieldValue = ELabelFieldValue & {
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  translations?: Maybe<LocalizedText>;
  type?: Maybe<Scalars['String']['output']>;
};


/** A customized, multilingual text. */
export type ELabelLocalizedTextFieldValueLabelArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type ELabelMarket =
  | 'EU'
  | 'UK';

export type ELabelMaterial = {
  category?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<CloudinaryAsset>;
  translations?: Maybe<LocalizedText>;
};


export type ELabelMaterialLabelArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type ELabelMaterialInput = {
  key: Scalars['String']['input'];
  logo?: InputMaybe<FileUrlInput>;
};

export type ELabelPageView = {
  /** The country where the e-label was viewed. */
  country: Scalars['String']['output'];
  /** When the e-label was viewed. */
  date: Scalars['String']['output'];
  /** The viewed e-label. */
  eLabel: ELabel;
  /** The viewed e-label IDs. */
  elabelId: Scalars['ID']['output'];
};


export type ELabelPageViewDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ELabelProducer = {
  /** The producer logo. */
  logo?: Maybe<CloudinaryAsset>;
  /** The name of the eLabel producer. */
  name?: Maybe<Scalars['String']['output']>;
  producerId?: Maybe<Scalars['ID']['output']>;
  /** The producer website. */
  website?: Maybe<Scalars['String']['output']>;
};

export type ELabelProducerForm = {
  /** The producer logo. */
  logo?: Maybe<CloudinaryAsset>;
  /** The name of the eLabel producer. */
  name?: Maybe<Scalars['String']['output']>;
  producerId?: Maybe<Scalars['ID']['output']>;
  validValues: ValidValues;
  /** The producer website. */
  website?: Maybe<Scalars['String']['output']>;
};

export type ELabelProducerInput = {
  /** The producer logo. */
  logo?: InputMaybe<FileUrlInput>;
  /** The name of the eLabel producer. */
  name?: InputMaybe<Scalars['String']['input']>;
  producerId?: InputMaybe<Scalars['ID']['input']>;
  /** The producer website. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ELabelProduct = {
  /** The GTIN. */
  GTIN?: Maybe<Scalars['String']['output']>;
  /** The actual alcohol. */
  actualAlcohol?: Maybe<Scalars['Float']['output']>;
  /** The alcohol. */
  alcohol?: Maybe<Scalars['Float']['output']>;
  /** Beer style. */
  beerStyle?: Maybe<Scalars['String']['output']>;
  /** The bottle image. */
  bottleImage?: Maybe<CloudinaryAsset>;
  /** The calories per 100ml / 5oz. */
  calories?: Maybe<Scalars['Float']['output']>;
  caloriesSource?: Maybe<CaloriesSource>;
  /** The carbohydrate sugars in grams per 100ml / 5oz. */
  carbohydrateSugars?: Maybe<Scalars['Float']['output']>;
  /** The carbohydrates in grams per 100ml / 5oz. */
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  /** The cider color. */
  ciderColor?: Maybe<Scalars['String']['output']>;
  /** The cider style. */
  ciderStyle?: Maybe<Scalars['String']['output']>;
  /** The country. */
  country?: Maybe<Scalars['String']['output']>;
  /** The custom denomination. */
  customDenomination?: Maybe<Scalars['String']['output']>;
  /** Aka wine style. */
  designation?: Maybe<Scalars['String']['output']>;
  /** The eLabel certifications. */
  eLabelCertifications?: Maybe<Array<Maybe<ELabelAsset>>>;
  /** The Kj per 100ml / 5oz. */
  energyKj?: Maybe<Scalars['Float']['output']>;
  /** The fat in grams per 100ml / 5oz. */
  fat?: Maybe<Scalars['Float']['output']>;
  /** Uses negligible amounts strategy if true. */
  fatIsNegligible?: Maybe<Scalars['Boolean']['output']>;
  /** The cider fruit varieties. */
  fruitVarieties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The grape varieties. */
  grapeVarieties?: Maybe<Array<Maybe<ELabelProductGrapeVariety>>>;
  /** The product ingredients. */
  ingredients?: Maybe<Array<Scalars['String']['output']>>;
  /** A text representation of an ingredient list. */
  ingredientsText?: Maybe<Scalars['String']['output']>;
  /** The net quantity in milliliters. */
  netQuantity?: Maybe<Scalars['String']['output']>;
  /** The packaging certifications. */
  packagingCertifications?: Maybe<Array<Maybe<ELabelAsset>>>;
  /** The packaging gas used. */
  packagingGasesFunction?: Maybe<Scalars['String']['output']>;
  primaryPackaging?: Maybe<PrimaryPackaging>;
  /** The bottlebooks ID. */
  productId?: Maybe<Scalars['ID']['output']>;
  /** The production method. */
  productionMethod?: Maybe<Scalars['String']['output']>;
  /** The proteins per 100ml in grams. */
  protein?: Maybe<Scalars['Float']['output']>;
  /** Uses negligible amounts strategy if true. */
  proteinIsNegligible?: Maybe<Scalars['Boolean']['output']>;
  /** The region. */
  region?: Maybe<Scalars['String']['output']>;
  /** The residual sugar. */
  residualSugar?: Maybe<Scalars['Float']['output']>;
  /** The responsible consumption logos. */
  responsibleConsumptionLogos?: Maybe<Array<Maybe<ELabelAsset>>>;
  /** The responsible consumption message. */
  responsibleConsumptionMessage?: Maybe<Scalars['String']['output']>;
  /** The salt per 100ml in grams. */
  salt?: Maybe<Scalars['Float']['output']>;
  /** Uses negligible amounts strategy if true. */
  saltIsNegligible?: Maybe<Scalars['Boolean']['output']>;
  /** The saturated fat per 100ml in grams. */
  saturatedFat?: Maybe<Scalars['Float']['output']>;
  /** Uses negligible amounts strategy if true. */
  saturatedFatIsNegligible?: Maybe<Scalars['Boolean']['output']>;
  secondaryPackaging?: Maybe<SecondaryPackaging>;
  /** The name without the vintage. */
  shortName?: Maybe<Scalars['String']['output']>;
  /** When true the simplified table will be shown. */
  showSimplifiedTable?: Maybe<Scalars['Boolean']['output']>;
  /** An HTML text describing simplified nutritional declaration in case showSimplifiedTable=true. */
  simplifiedDeclaration?: Maybe<Scalars['String']['output']>;
  /** The subregion. */
  subregion?: Maybe<Scalars['String']['output']>;
  /** The sustainability logos. */
  sustainabilityLogos?: Maybe<Array<Maybe<CloudinaryAsset>>>;
  /** The sustainability message. */
  sustainabilityMessage?: Maybe<Scalars['String']['output']>;
  /** The total acidity. */
  totalAcidity?: Maybe<Scalars['Float']['output']>;
  /** When true the custom denomination will be used in the e-label page. */
  useCustomDenomination?: Maybe<Scalars['Boolean']['output']>;
  /** The vintage. */
  vintage?: Maybe<Scalars['String']['output']>;
  /** The volume of each portion. */
  volumeOfPortion?: Maybe<Scalars['Float']['output']>;
  /** The wine color. */
  wineColor?: Maybe<Scalars['String']['output']>;
  /** The percentage of wine used in the aromatised wine. */
  winePercentage?: Maybe<Scalars['Float']['output']>;
};


export type ELabelProductBeerStyleArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductCaloriesArgs = {
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductCarbohydrateSugarsArgs = {
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductCarbohydratesArgs = {
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductCiderColorArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductCiderStyleArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductDesignationArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductEnergyKjArgs = {
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductFatArgs = {
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductIngredientsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductIngredientsTextArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ELabelLocale>;
};


export type ELabelProductNetQuantityArgs = {
  format?: InputMaybe<ValidValueFormat>;
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductPackagingGasesFunctionArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductProductionMethodArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductProteinArgs = {
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductRegionArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductResponsibleConsumptionMessageArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ELabelProductSaltArgs = {
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductSaturatedFatArgs = {
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductSubregionArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ELabelProductSustainabilityMessageArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ELabelProductVolumeOfPortionArgs = {
  measurementSystem?: InputMaybe<MeasurementSystem>;
};


export type ELabelProductWineColorArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type ELabelProductForm = {
  /** The GTIN. */
  GTIN?: Maybe<Scalars['String']['output']>;
  /** The actual alcohol. */
  actualAlcohol?: Maybe<Scalars['Float']['output']>;
  /** The alcohol. */
  alcohol?: Maybe<Scalars['Float']['output']>;
  /** Beer style. */
  beerStyle?: Maybe<SingleSelectionField>;
  /** The bottle image. */
  bottleImage?: Maybe<CloudinaryAsset>;
  /** The calories of the product (kcal). */
  calories?: Maybe<Scalars['Float']['output']>;
  caloriesSource?: Maybe<CaloriesSource>;
  /** The carbohydrate sugars per 100ml in grams. */
  carbohydrateSugars?: Maybe<Scalars['Float']['output']>;
  /** The carbohydrates per 100ml in grams. */
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  /** The cider color. */
  ciderColor?: Maybe<ELabelCustomOptionType>;
  /** The cider style. */
  ciderStyle?: Maybe<ELabelCustomOptionType>;
  /** The country. */
  country?: Maybe<SingleSelectionField>;
  /** The custom denomination. */
  customDenomination?: Maybe<Scalars['String']['output']>;
  /** Aka wine style. */
  designation?: Maybe<SingleSelectionField>;
  /** The eLabel certifications. */
  eLabelCertifications?: Maybe<Array<Maybe<ELabelAsset>>>;
  energyKj?: Maybe<Scalars['Float']['output']>;
  /** The fat in grams. */
  fat?: Maybe<Scalars['Float']['output']>;
  /** Uses negligible amounts strategy if true. */
  fatIsNegligible?: Maybe<Scalars['Boolean']['output']>;
  /** The cider apple varieties. */
  fruitVarieties?: Maybe<Array<Maybe<ELabelFruitVarietyOptionType>>>;
  /** The grape varieties. */
  grapeVarieties?: Maybe<Array<Maybe<ELabelProductGrapeVariety>>>;
  /** The product ingredients. */
  ingredients?: Maybe<Array<ELabelLocalizedTextFieldValue>>;
  /** The net quantity in milliliters. */
  netQuantity?: Maybe<Scalars['String']['output']>;
  /** The packaging certifications. */
  packagingCertifications?: Maybe<Array<Maybe<ELabelAsset>>>;
  /** The packaging gas used. */
  packagingGasesFunction?: Maybe<SingleSelectionField>;
  primaryPackaging?: Maybe<PrimaryPackagingForm>;
  /** The bottlebooks ID. */
  productId?: Maybe<Scalars['ID']['output']>;
  /** The production method. */
  productionMethod?: Maybe<SingleSelectionField>;
  /** The proteins per 100ml in grams. */
  protein?: Maybe<Scalars['Float']['output']>;
  /** Uses negligible amounts strategy if true. */
  proteinIsNegligible?: Maybe<Scalars['Boolean']['output']>;
  /** The region. */
  region?: Maybe<SingleSelectionField>;
  /** The residual sugar. */
  residualSugar?: Maybe<Scalars['Float']['output']>;
  /** The responsible consumption logos. */
  responsibleConsumptionLogos?: Maybe<Array<Maybe<ELabelAsset>>>;
  /** The responsible consumption message. */
  responsibleConsumptionMessage?: Maybe<LocalizedText>;
  /** The salt per 100ml in grams. */
  salt?: Maybe<Scalars['Float']['output']>;
  /** Uses negligible amounts strategy if true. */
  saltIsNegligible?: Maybe<Scalars['Boolean']['output']>;
  /** The saturated fat per 100ml in grams. */
  saturatedFat?: Maybe<Scalars['Float']['output']>;
  /** Uses negligible amounts strategy if true. */
  saturatedFatIsNegligible?: Maybe<Scalars['Boolean']['output']>;
  secondaryPackaging?: Maybe<SecondaryPackagingForm>;
  /** The name without the vintage. */
  shortName?: Maybe<Scalars['String']['output']>;
  /** When true the simplified table will be shown. */
  showSimplifiedTable?: Maybe<Scalars['Boolean']['output']>;
  /** Spirit type. */
  spiritType?: Maybe<SingleSelectionField>;
  /** The subregion. */
  subregion?: Maybe<SingleSelectionField>;
  /** The sustainability logos. */
  sustainabilityLogos?: Maybe<Array<Maybe<CloudinaryAsset>>>;
  /** The sustainability message. */
  sustainabilityMessage?: Maybe<LocalizedText>;
  /** The total acidity. */
  totalAcidity?: Maybe<Scalars['Float']['output']>;
  /** When true the custom denomination will be used in the e-label page. */
  useCustomDenomination?: Maybe<Scalars['Boolean']['output']>;
  validValues: ValidValues;
  /** The vintage. */
  vintage?: Maybe<SingleSelectionField>;
  /** The volume of each portion. */
  volumeOfPortion?: Maybe<Scalars['Float']['output']>;
  /** The wine color. */
  wineColor?: Maybe<SingleSelectionField>;
  /** The grapevine products ingredients. */
  wineIngredients?: Maybe<Array<ELabelLocalizedTextFieldValue>>;
  /** The percentage of wine used in the aromatised wine. */
  winePercentage?: Maybe<Scalars['Float']['output']>;
  /** The wine type. */
  wineType?: Maybe<SingleSelectionField>;
};

export type ELabelProductGrapeVariety = {
  /**
   * The percentage of this variety.
   * If it's unset, it usually means that this product consists of least 85% of this variety (regional regulations may require stricter limits though).
   * If it's set to 100%, the product must consist of this grape only.
   */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** The name of the grape variety. */
  varietyName?: Maybe<Scalars['String']['output']>;
};


export type ELabelProductGrapeVarietyVarietyNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type ELabelProductInput = {
  GTIN?: InputMaybe<Scalars['String']['input']>;
  actualAlcohol?: InputMaybe<Scalars['Float']['input']>;
  alcohol?: InputMaybe<Scalars['Float']['input']>;
  allergens?: InputMaybe<Array<InputMaybe<MultipleFieldInput>>>;
  beerStyle?: InputMaybe<SingleSelectionInput>;
  bottleImage?: InputMaybe<FileUrlInput>;
  /** The calories of the product (kcal). */
  calories?: InputMaybe<Scalars['Float']['input']>;
  caloriesSource?: InputMaybe<CaloriesSourceInput>;
  carbohydrateSugars?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates?: InputMaybe<Scalars['Float']['input']>;
  ciderColor?: InputMaybe<ELabelCustomOptionInput>;
  ciderStyle?: InputMaybe<ELabelCustomOptionInput>;
  country?: InputMaybe<SingleSelectionInput>;
  customDenomination?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<SingleSelectionInput>;
  eLabelCertifications?: InputMaybe<Array<InputMaybe<ELabelAssetInput>>>;
  energyKj?: InputMaybe<Scalars['Float']['input']>;
  energyPerPortion?: InputMaybe<YesNo>;
  fat?: InputMaybe<Scalars['Float']['input']>;
  fatIsNegligible?: InputMaybe<Scalars['Boolean']['input']>;
  fruitVarieties?: InputMaybe<Array<InputMaybe<ELabelFruitVarietyOptionInput>>>;
  grapeVarieties?: InputMaybe<Array<InputMaybe<ProductGrapeVarietyInput>>>;
  ingredients?: InputMaybe<Array<InputMaybe<MultipleCustomFieldInput>>>;
  netQuantity?: InputMaybe<Scalars['String']['input']>;
  packagingCertifications?: InputMaybe<Array<InputMaybe<ELabelAssetInput>>>;
  packagingGasesFunction?: InputMaybe<SingleSelectionInput>;
  primaryPackaging?: InputMaybe<PrimaryPackagingInput>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productionMethod?: InputMaybe<SingleSelectionInput>;
  protein?: InputMaybe<Scalars['Float']['input']>;
  proteinIsNegligible?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<SingleSelectionInput>;
  residualSugar?: InputMaybe<Scalars['Float']['input']>;
  responsibleConsumptionLogos?: InputMaybe<Array<InputMaybe<ELabelAssetInput>>>;
  responsibleConsumptionMessage?: InputMaybe<LocalizedTextInput>;
  salt?: InputMaybe<Scalars['Float']['input']>;
  saltIsNegligible?: InputMaybe<Scalars['Boolean']['input']>;
  saturatedFat?: InputMaybe<Scalars['Float']['input']>;
  saturatedFatIsNegligible?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryPackaging?: InputMaybe<SecondaryPackagingInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  showSimplifiedTable?: InputMaybe<Scalars['Boolean']['input']>;
  spiritType?: InputMaybe<SingleSelectionInput>;
  subregion?: InputMaybe<SingleSelectionInput>;
  sustainabilityLogos?: InputMaybe<Array<InputMaybe<FileUrlInput>>>;
  sustainabilityMessage?: InputMaybe<LocalizedTextInput>;
  totalAcidity?: InputMaybe<Scalars['Float']['input']>;
  useCustomDenomination?: InputMaybe<Scalars['Boolean']['input']>;
  vintage?: InputMaybe<SingleSelectionInput>;
  volumeOfPortion?: InputMaybe<Scalars['Float']['input']>;
  wineColor?: InputMaybe<SingleSelectionInput>;
  wineIngredients?: InputMaybe<Array<InputMaybe<MultipleCustomFieldInput>>>;
  winePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type ELabelProductType =
  | 'beer'
  | 'cider'
  | 'other_drink'
  | 'spirit_absinthe'
  | 'spirit_anise'
  | 'spirit_aquavit'
  | 'spirit_arak'
  | 'spirit_armagnac'
  | 'spirit_asianspirit'
  | 'spirit_bitter'
  | 'spirit_cachaca'
  | 'spirit_calvados'
  | 'spirit_cocktail'
  | 'spirit_cognac'
  | 'spirit_fruitspirit'
  | 'spirit_genever'
  | 'spirit_gin'
  | 'spirit_gin_distilled'
  | 'spirit_grainspirit'
  | 'spirit_grapebrandy'
  | 'spirit_grappa'
  | 'spirit_liqueur'
  | 'spirit_marc'
  | 'spirit_mezcal'
  | 'spirit_miscspririt'
  | 'spirit_ouzo'
  | 'spirit_pastis'
  | 'spirit_pisco'
  | 'spirit_raki'
  | 'spirit_rum'
  | 'spirit_sambuca'
  | 'spirit_schnaps'
  | 'spirit_shochu'
  | 'spirit_tequila'
  | 'spirit_vermouth'
  | 'spirit_vodka'
  | 'spirit_whiskey'
  | 'spirit_whisky'
  | 'wine_aeratedsemisparkling'
  | 'wine_aeratedsparkling'
  | 'wine_aromatised'
  | 'wine_aromatised_aromatizovanyDezert'
  | 'wine_aromatised_bitter'
  | 'wine_aromatised_bitterSoda'
  | 'wine_aromatised_clarea'
  | 'wine_aromatised_eggBased'
  | 'wine_aromatised_fortifiedWineBasedDrink'
  | 'wine_aromatised_gluhwein'
  | 'wine_aromatised_kalteEnte'
  | 'wine_aromatised_maitrank'
  | 'wine_aromatised_maiwein'
  | 'wine_aromatised_pelin'
  | 'wine_aromatised_sangria'
  | 'wine_aromatised_semiSparklingGrapeBasedCocktail'
  | 'wine_aromatised_sparklingWineCocktail'
  | 'wine_aromatised_vakevaViiniglogi'
  | 'wine_aromatised_vermouth'
  | 'wine_aromatised_viiniglogiVingloggKarstasVynas'
  | 'wine_aromatised_wineBasedAperitif'
  | 'wine_aromatised_wineBasedCocktail'
  | 'wine_aromatised_wineBasedDrink'
  | 'wine_aromatised_wineProductCocktail'
  | 'wine_aromatised_winoZiolowe'
  | 'wine_aromatised_zurra'
  | 'wine_fortified'
  | 'wine_liqueur'
  | 'wine_partially_fermented_grape_must'
  | 'wine_pearlwine'
  | 'wine_qualityaromaticsparkling'
  | 'wine_qualitysparkling'
  | 'wine_semisparkling'
  | 'wine_sparkling'
  | 'wine_stillwine';

export type ELabelProductTypeQueryOperatorInput = {
  eq?: InputMaybe<ELabelProductType>;
  in?: InputMaybe<Array<InputMaybe<ELabelProductType>>>;
  ne?: InputMaybe<ELabelProductType>;
  nin?: InputMaybe<Array<InputMaybe<ELabelProductType>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type ELabelRenderingUrlVersion =
  | 'ANGULAR'
  | 'NEXTJS';

export type ELabelStatus =
  /** The e-label has been deleted */
  | 'DELETED'
  /** The e-label is not connected to any QR code. */
  | 'DISCONNECTED'
  /** Already published e-label has draft changes that have not yet been published */
  | 'DRAFT'
  /** The e-label has never been published */
  | 'NOTPUBLISHED'
  /** The e-label is not yet created and shows a basic placeholder page */
  | 'PARKED'
  /** The e-label has been published at least once */
  | 'PUBLISHED'
  /** E-label is redirected. */
  | 'REDIRECTED';

export type ELabelStatusQueryOperatorInput = {
  eq?: InputMaybe<ELabelStatus>;
  in?: InputMaybe<Array<InputMaybe<ELabelStatus>>>;
  ne?: InputMaybe<ELabelStatus>;
  nin?: InputMaybe<Array<InputMaybe<ELabelStatus>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type ELabelSubscription = {
  expirationDate?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trial?: Maybe<Scalars['Boolean']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

/** A system-defined value. */
export type ELabelSystemFieldValue = ELabelFieldValue & {
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};


/** A system-defined value. */
export type ELabelSystemFieldValueLabelArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type ELabelType =
  /** An eLabel created and hosted on Bottlebooks. */
  | 'ELABEL'
  /** This eLabel is not yet created and shows a basic placeholder page */
  | 'PARKED'
  /** A redirect to a custom domain. */
  | 'REDIRECT';

/** Deprecated - use ELabel instead. */
export type ELabelVersion = {
  /** The date the release was created. */
  createdAt: Scalars['String']['output'];
  /** The user who created the release. */
  createdBy: UserProfile;
  /** The eLabel. */
  eLabel: ELabel;
  /** The  release note provided by the user */
  note?: Maybe<Scalars['String']['output']>;
  /**
   * The user who created the release.
   * @deprecated Use 'createdBy' instead.
   */
  user: UserProfile;
  /** The ID of the eLabel version. */
  versionId: Scalars['ID']['output'];
};


/** Deprecated - use ELabel instead. */
export type ELabelVersionCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Deprecated - use ELabelConnection instead. */
export type ELabelVersionConnection = {
  edges: Array<ELabelVersionEdge>;
  nodes: Array<ELabelVersion>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** The eLabel valid values options. */
  validValues?: Maybe<ValidValues>;
};


/** Deprecated - use ELabelConnection instead. */
export type ELabelVersionConnectionValidValuesArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

/** Deprecated - use ELabelEdge instead. */
export type ELabelVersionEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<ELabelVersion>;
  node: ELabelVersion;
  previous?: Maybe<ELabelVersion>;
};

export type Edge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<Item>;
  node: Item;
  previous?: Maybe<Item>;
};

export type EditAssetInput = {
  /** The id of the asset. */
  assetId: Scalars['ID']['input'];
  /** The name of the external file. */
  filename: Scalars['String']['input'];
  /** The languages used in the file. */
  languages: Array<Scalars['String']['input']>;
};

export type EditAssetResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The file if successful. */
  file?: Maybe<File>;
  message: Scalars['String']['output'];
  /**
   * The node the file is added to.
   * You can query the files field there to get the new order.
   */
  node?: Maybe<Item>;
  success: Scalars['Boolean']['output'];
};

export type EditContactResponse = MutationResponse & {
  code: Scalars['String']['output'];
  contact?: Maybe<Contact>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EditNotificationContactInput = {
  /** The message to send. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The contact data. */
  notificationContact: NotificationContactInput;
  /** The ID of the registration where the contact should be edited. */
  registrationId: Scalars['ID']['input'];
};

export type Event = Collection & Item & List & {
  /** @deprecated For debugging only */
  _raw: Scalars['JSON']['output'];
  /** @deprecated For debugging only */
  _rawAnnotations?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Experimental - might be removed or changed without notice. Use at your own risk. */
  _unstable_allOutputConfigurations: Array<CollectionOutputConfiguration>;
  /**
   * Returns if adding products to a registration via QR code is allowed.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_allowAddViaQrCode: Scalars['Boolean']['output'];
  /**
   * The Bottlebooks Classic fields configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_classicFields: Array<ClassicField>;
  /**
   * Collection configuration data.
   * @deprecated For debugging only
   */
  _unstable_data: Scalars['JSON']['output'];
  /**
   * The product requests that don't have a matching product.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_missingProducts: Array<Unstable_MissingProduct>;
  /**
   * The tasting lists for this collection for a specific user.
   * @deprecated Experimental - might change of be dropped!
   */
  _unstable_myTastingLists: Array<TastingList>;
  /**
   * Outputs for a collection
   * @deprecated Experimental, will be removed. Use _unstable_outputConfigurations instead.
   */
  _unstable_outputs: Array<CollectionOutputConfiguration>;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_product: Unstable_CollectionProductEdge;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_products: Unstable_CollectionProductConnection;
  /**
   * The Bottlebooks Classic fields recommended to be configured based on outputs.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_recommendedClassicFields: Array<RecommendedClassicField>;
  /**
   * collectionIds that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollectionIds: Scalars['ID']['output'];
  /**
   * Access collections that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollections: CollectionConnection;
  /** @deprecated Experimental. Use at your own risk! */
  _unstable_requestedProducts: Unstable_RequestedProductConnection;
  /**
   * The products registered for a collection that have not been requested by the organizer.
   * @deprecated Experimental and unstable. Use at your own risk!
   */
  _unstable_unrequestedProducts: RegisteredProductConnection;
  /** @deprecated Experimental. Don't use yet. */
  _unstable_useNewForms: Scalars['Boolean']['output'];
  /** @deprecated Experimental. Don't use yet. */
  _unstable_validValueLists: Unstable_ValidValueLists;
  /** An area within an event. Can be a stand, room or floor. */
  area: EventArea;
  /**
   * All areas for the event.
   * Can be stands, rooms or floors.
   *
   * If you only need top-level areas, you can filter on 'parentType:{ eq:null }'.
   */
  areas: EventAreaConnection;
  /** The default catalog. */
  catalog?: Maybe<CatalogConfiguration>;
  /** An alias for eventId. */
  collectionId: Scalars['ID']['output'];
  collectionType: CollectionType;
  /** The email of contact in the event. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the collection was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The registration deadline, as an ISO date string. */
  deadline?: Maybe<Scalars['String']['output']>;
  /**
   * All the deleted registrations for a collection.
   * @deprecated Experimental
   */
  deletedRegistrations: Array<Registration>;
  /** The public description of the collection. */
  description?: Maybe<Scalars['String']['output']>;
  /** The collection steps. */
  enabledSteps: Array<RegistrationStep>;
  eventId: Scalars['ID']['output'];
  exhibitor?: Maybe<Exhibitor>;
  /** General instructions for exhibitors. */
  exhibitorInstructions?: Maybe<Scalars['String']['output']>;
  exhibitors: ExhibitorConnection;
  /** Shows files attached to this product. */
  files?: Maybe<FileConnection>;
  /**
   * A particular form for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  form: Form;
  /**
   * The allowed form types for this collection.
   * @deprecated Experimental - use at your own risk!
   */
  formTypes: Array<FormType>;
  /**
   * All the forms for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  forms: Array<Form>;
  /** This collection has a product master list that specifies which products suppliers or exhibitors must register. */
  hasProductMasterList: Scalars['Boolean']['output'];
  /** This collection has an overall sorting for the products with optional flighting details. These events are often referred to as 'product-led events' where there are no exhibitors. sortIndex, flightName, and productLabel are null when this is false. */
  isProductSortingEnabled: Scalars['Boolean']['output'];
  /** @deprecated This resolver is under development and is not stable. */
  list?: Maybe<CollectionList>;
  /** @deprecated Use eventId or collectionId instead. */
  listId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated This resolver is under development and is not stable. */
  lists: CollectionListConnection;
  /** All the configured locales of the event. */
  locales: Array<Scalars['String']['output']>;
  /** Instructions for exhibitors after login. */
  loggedInExhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /** The collection logo. Often this is the collection owner's logo. */
  logo?: Maybe<CloudinaryAsset>;
  mainImage?: Maybe<CloudinaryAsset>;
  /** The maximum products of the collection per registration. */
  maximumProducts?: Maybe<Scalars['Int']['output']>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingAvailabilities: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingTimeslots: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  myMeetingTimeslots: Array<MeetingTimeslot>;
  /** Single registration for the current logged in brand */
  myRegistration?: Maybe<Registration>;
  /**
   * All the company registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  myRegistrations: RegistrationConnection;
  /** The collection name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The contacts that get notifications from the organizer regarding their registrations. */
  notificationContacts?: Maybe<Array<Maybe<Contact>>>;
  /** The brand organizing the event. */
  owner: Brand;
  permissions: CollectionPermissions;
  /** The pricing configuration for the event. */
  pricing?: Maybe<EventPricing>;
  /**
   * A producer on an event.
   * The exhibitorId is needed because a producer can be represented multiple times on an event.
   */
  producer?: Maybe<Producer>;
  producers: ProducerConnection;
  /**
   * A single product registered for an event.
   * To uniquely identify it, you need to provide the exhibitorId and the productId.
   */
  product?: Maybe<Product>;
  /** Exhibitor instructions for adding products. */
  productInstructions?: Maybe<Scalars['String']['output']>;
  /** The products registered for the event. */
  products: ProductConnection;
  /**
   * The questions configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  questions?: Maybe<Array<Question>>;
  /**
   * The brands producing products that have been registered at a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registeredBrands: RegisteredBrandConnection;
  /**
   * A product registered for a collection.
   * Because the same product might be added my multiple different partners,
   * you need to look at the registrations property to get the necessary details for each registration.
   * Not all types of collections support registeredProducts.
   */
  registeredProductVersion: RegisteredProduct;
  /** The products registered for a collection. */
  registeredProducts: RegisteredProductConnection;
  /** A particular registration. */
  registration?: Maybe<SingleRegistration>;
  /** The link to register for that event. */
  registrationLink?: Maybe<Scalars['String']['output']>;
  /** All the registrations for an Event. */
  registrations: SingleRegistrationConnection;
  /**
   * The representative profiles of all registrations.
   * @deprecated Experimental. Use at your own risk!
   */
  representatives: Array<SiteUserProfile>;
  /** The default site of the collection. */
  site?: Maybe<SiteConfiguration>;
  slug?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use areas instead */
  stands?: Maybe<Array<Stand>>;
  /** A short subtitle to display on the public event page. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the collection was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The user profiles.
   * @deprecated Use visitors or representatives instead.
   */
  userProfiles: Array<SiteUserProfile>;
  /** Product videos (Youtube, Vimeo, Instagram, Facebook etc.) */
  videos?: Maybe<Array<Video>>;
  visibilityStatus: VisibilityStatusType;
  /**
   * The visitor profiles of a collection. These are the registered and approved visitors.
   * @deprecated Experimental. Use at your own risk!
   */
  visitors: Array<SiteUserProfile>;
  /** The workspace the event belongs to. */
  workspaceId: Scalars['ID']['output'];
};


export type Event_Unstable_AllOutputConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Event_Unstable_AllowAddViaQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Event_Unstable_ClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


export type Event_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Event_Unstable_MissingProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Event_Unstable_MyTastingListsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  sort?: InputMaybe<TastingListSortInput>;
  uid: Scalars['String']['input'];
};


export type Event_Unstable_OutputsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Event_Unstable_ProductArgs = {
  experimentalKey: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


export type Event_Unstable_ProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


export type Event_Unstable_RecommendedClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


export type Event_Unstable_RelatedCollectionIdsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Event_Unstable_RelatedCollectionsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Event_Unstable_RequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type Event_Unstable_UnrequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  versionTag?: InputMaybe<DataVersionTag>;
};


export type Event_Unstable_UseNewFormsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Event_Unstable_ValidValueListsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventAreaArgs = {
  slug: Scalars['String']['input'];
};


export type EventAreasArgs = {
  filter?: InputMaybe<EventAreaFilterInput>;
};


export type EventDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventExhibitorArgs = {
  exhibitorId: Scalars['ID']['input'];
  returnNullWhenNotFound?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventExhibitorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ExhibitorSortInput>;
};


export type EventFilesArgs = {
  filter?: InputMaybe<ProductFileFilterInput>;
};


export type EventFormArgs = {
  type: FormType;
};


export type EventListArgs = {
  collectionListId: Scalars['String']['input'];
};


export type EventListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocalesArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<InterfaceLocale>;
};


export type EventLoggedInExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventMeetingAvailabilitiesArgs = {
  attendeeId: Scalars['String']['input'];
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  organizerId: Scalars['String']['input'];
};


export type EventMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type EventMyMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type EventMyRegistrationsArgs = {
  companyId: Scalars['ID']['input'];
};


export type EventNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type EventProducerArgs = {
  exhibitorId: Scalars['ID']['input'];
  producerId: Scalars['ID']['input'];
  returnNullWhenNotFound?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventProducersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProducerSortInput>;
};


export type EventProductArgs = {
  exhibitorId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  returnNullWhenNotFound?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventProductInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};


export type EventQuestionsArgs = {
  group: QuestionGroup;
};


export type EventRegisteredBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredBrandFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredBrandSortInput>;
};


export type EventRegisteredProductVersionArgs = {
  productVersionId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
};


export type EventRegisteredProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  useNext?: InputMaybe<Scalars['Boolean']['input']>;
  versionTag?: InputMaybe<DataVersionTag>;
};


export type EventRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


export type EventRegistrationLinkArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type EventRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegistrationSortInput>;
};


export type EventRepresentativesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type EventSlugArgs = {
  format?: SlugFormat;
};


export type EventSubtitleArgs = {
  format?: InputMaybe<TextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventUserProfilesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  roles: Array<SiteUserRole>;
  token: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};


export type EventVisitorsArgs = {
  experimentalKey: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};

export type EventArea = {
  areaType: EventAreaType;
  areas: EventAreaConnection;
  /** A summary of the child areas of this area. Typically the stand number range. */
  areasSummary: Scalars['String']['output'];
  collection: Collection;
  collectionId: Scalars['ID']['output'];
  /** The color that contrasts the primary color. Typically either black or white. */
  contrastColor?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  event: Event;
  eventId: Scalars['ID']['output'];
  floor?: Maybe<EventArea>;
  /** @deprecated Unstable - can change without notice. */
  form: EventAreaForm;
  id: Scalars['ID']['output'];
  /** The localized name of the area. Typically the stand name or room name. */
  name: Scalars['String']['output'];
  parent?: Maybe<EventArea>;
  parentSlug?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<FloorPlan>;
  /** The primary color assigned to this area. */
  primaryColor?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<SingleRegistration>;
  registrationId?: Maybe<Scalars['ID']['output']>;
  room?: Maybe<EventArea>;
  slug: Scalars['String']['output'];
  sortIndex: Scalars['Int']['output'];
  stand?: Maybe<EventArea>;
  /** A subtitle for the area. Typically the names of the regions, associations or exhibitors found in this area. */
  subtitle: Scalars['String']['output'];
};


export type EventAreaAreasArgs = {
  filter?: InputMaybe<EventAreaFilterInput>;
};


export type EventAreaAreasSummaryArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};


export type EventAreaDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};


export type EventAreaNameArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventAreaSubtitleArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};

export type EventAreaConnection = {
  edges: Array<EventAreaEdge>;
  nodes: Array<EventArea>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventAreaEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<EventArea>;
  node: EventArea;
  previous?: Maybe<EventArea>;
};

export type EventAreaFilterInput = {
  areaType?: InputMaybe<EventAreaTypeQueryOperatorInput>;
  parentSlug?: InputMaybe<StringQueryOperatorInput>;
};

/** The form data for an event area. */
export type EventAreaForm = {
  data: Scalars['JSONObject']['output'];
};

export type EventAreaSortInput = {
  name?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  parent?: InputMaybe<EventAreaSortInput>;
};

export type EventAreaType =
  | 'FLOOR'
  | 'ROOM'
  | 'STAND';

export type EventAreaTypeQueryOperatorInput = {
  eq?: InputMaybe<EventAreaType>;
  in?: InputMaybe<Array<EventAreaType>>;
  ne?: InputMaybe<EventAreaType>;
  nin?: InputMaybe<Array<EventAreaType>>;
};

/** A list of events that is sortable, filterable and can be paginated. */
export type EventConnection = Connection & {
  edges: Array<EventEdge>;
  nodes: Array<Event>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EventEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<Event>;
  node: Event;
  previous?: Maybe<Event>;
};

export type EventFieldsEnum =
  | 'eventId'
  | 'name';

export type EventFilter = {
  status?: InputMaybe<StringQueryOperatorInput>;
};

export type EventGroup = Collection & Item & {
  /** @deprecated Experimental - might be removed or changed without notice. Use at your own risk. */
  _unstable_allOutputConfigurations: Array<CollectionOutputConfiguration>;
  /**
   * Returns if adding products to a registration via QR code is allowed.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_allowAddViaQrCode: Scalars['Boolean']['output'];
  /**
   * The Bottlebooks Classic fields configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_classicFields: Array<ClassicField>;
  /**
   * Collection configuration data.
   * @deprecated For debugging only
   */
  _unstable_data: Scalars['JSON']['output'];
  /**
   * The product requests that don't have a matching product.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_missingProducts: Array<Unstable_MissingProduct>;
  /**
   * The tasting lists for this collection for a specific user.
   * @deprecated Experimental - might change of be dropped!
   */
  _unstable_myTastingLists: Array<TastingList>;
  /**
   * Outputs for a collection
   * @deprecated Experimental, will be removed. Use _unstable_outputConfigurations instead.
   */
  _unstable_outputs: Array<CollectionOutputConfiguration>;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_product: Unstable_CollectionProductEdge;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_products: Unstable_CollectionProductConnection;
  /**
   * The Bottlebooks Classic fields recommended to be configured based on outputs.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_recommendedClassicFields: Array<RecommendedClassicField>;
  /**
   * collectionIds that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollectionIds: Scalars['ID']['output'];
  /**
   * Access collections that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollections: CollectionConnection;
  /** @deprecated Experimental. Use at your own risk! */
  _unstable_requestedProducts: Unstable_RequestedProductConnection;
  /**
   * The products registered for a collection that have not been requested by the organizer.
   * @deprecated Experimental and unstable. Use at your own risk!
   */
  _unstable_unrequestedProducts: RegisteredProductConnection;
  /** @deprecated Experimental. Don't use yet. */
  _unstable_useNewForms: Scalars['Boolean']['output'];
  /** @deprecated Experimental. Don't use yet. */
  _unstable_validValueLists: Unstable_ValidValueLists;
  /** The default catalog. */
  catalog?: Maybe<CatalogConfiguration>;
  /** An alias for groupId. */
  collectionId: Scalars['ID']['output'];
  collectionType: CollectionType;
  /** The email of contact in the group. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the collection was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /**
   * All the deleted registrations for a collection.
   * @deprecated Experimental
   */
  deletedRegistrations: Array<Registration>;
  /** The public description of the collection. */
  description?: Maybe<Scalars['String']['output']>;
  /** The collection steps. */
  enabledSteps: Array<RegistrationStep>;
  /**
   * The events of this group.
   * Only active brands can see the group events.
   */
  events?: Maybe<EventConnection>;
  /** General instructions for exhibitors. */
  exhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /**
   * A particular form for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  form: Form;
  /**
   * The allowed form types for this collection.
   * @deprecated Experimental - use at your own risk!
   */
  formTypes: Array<FormType>;
  /**
   * All the forms for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  forms: Array<Form>;
  groupId: Scalars['ID']['output'];
  /** This collection has a product master list that specifies which products suppliers or exhibitors must register. */
  hasProductMasterList: Scalars['Boolean']['output'];
  /** This collection has an overall sorting for the products with optional flighting details. These events are often referred to as 'product-led events' where there are no exhibitors. sortIndex, flightName, and productLabel are null when this is false. */
  isProductSortingEnabled: Scalars['Boolean']['output'];
  /** @deprecated This resolver is under development and is not stable. */
  list?: Maybe<CollectionList>;
  /** @deprecated This resolver is under development and is not stable. */
  lists: CollectionListConnection;
  /** All the configured locales of the event. */
  locales: Array<Scalars['String']['output']>;
  /** Instructions for exhibitors after login. */
  loggedInExhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /** The collection logo. Often this is the collection owner's logo. */
  logo?: Maybe<CloudinaryAsset>;
  mainImage?: Maybe<CloudinaryAsset>;
  /** The maximum products of the collection per registration. */
  maximumProducts?: Maybe<Scalars['Int']['output']>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingAvailabilities: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingTimeslots: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  myMeetingTimeslots: Array<MeetingTimeslot>;
  /**
   * All the company registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  myRegistrations: RegistrationConnection;
  name: Scalars['String']['output'];
  /** The contacts that get notifications from the organizer regarding their registrations. */
  notificationContacts?: Maybe<Array<Maybe<Contact>>>;
  owner: Brand;
  permissions: CollectionPermissions;
  /** Exhibitor instructions for adding products. */
  productInstructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated This resolver uses an older schema and will not be further developed. Use registeredProducts to get access to newer features. */
  products: ProductConnection;
  /**
   * The questions configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  questions?: Maybe<Array<Question>>;
  /**
   * The brands producing products that have been registered at a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registeredBrands: RegisteredBrandConnection;
  /**
   * A product registered for a collection.
   * Because the same product might be added my multiple different partners,
   * you need to look at the registrations property to get the necessary details for each registration.
   * Not all types of collections support registeredProducts.
   */
  registeredProductVersion: RegisteredProduct;
  /**
   * The products registered for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registeredProducts: RegisteredProductConnection;
  /** A particular registration. */
  registration?: Maybe<Registration>;
  /**
   * All the registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registrations: RegistrationConnection;
  /**
   * The representative profiles of all registrations.
   * @deprecated Experimental. Use at your own risk!
   */
  representatives: Array<SiteUserProfile>;
  /** The default site of the collection. */
  site?: Maybe<SiteConfiguration>;
  /** An ISO date when the collection was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The user profiles.
   * @deprecated Use visitors or representatives instead.
   */
  userProfiles: Array<SiteUserProfile>;
  visibilityStatus: VisibilityStatusType;
  /**
   * The visitor profiles of a collection. These are the registered and approved visitors.
   * @deprecated Experimental. Use at your own risk!
   */
  visitors: Array<SiteUserProfile>;
  workspaceId: Scalars['ID']['output'];
};


export type EventGroup_Unstable_AllOutputConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventGroup_Unstable_AllowAddViaQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventGroup_Unstable_ClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


export type EventGroup_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventGroup_Unstable_MissingProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventGroup_Unstable_MyTastingListsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  sort?: InputMaybe<TastingListSortInput>;
  uid: Scalars['String']['input'];
};


export type EventGroup_Unstable_OutputsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventGroup_Unstable_ProductArgs = {
  experimentalKey: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


export type EventGroup_Unstable_ProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


export type EventGroup_Unstable_RecommendedClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


export type EventGroup_Unstable_RelatedCollectionIdsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventGroup_Unstable_RelatedCollectionsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventGroup_Unstable_RequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EventGroup_Unstable_UnrequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  versionTag?: InputMaybe<DataVersionTag>;
};


export type EventGroup_Unstable_UseNewFormsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventGroup_Unstable_ValidValueListsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type EventGroupDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventGroupEventsArgs = {
  filter?: InputMaybe<EventFilter>;
};


export type EventGroupExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventGroupFormArgs = {
  type: FormType;
};


export type EventGroupListArgs = {
  collectionListId: Scalars['String']['input'];
};


export type EventGroupListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EventGroupLocalesArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<InterfaceLocale>;
};


export type EventGroupLoggedInExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventGroupMeetingAvailabilitiesArgs = {
  attendeeId: Scalars['String']['input'];
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  organizerId: Scalars['String']['input'];
};


export type EventGroupMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type EventGroupMyMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type EventGroupMyRegistrationsArgs = {
  companyId: Scalars['ID']['input'];
};


export type EventGroupNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type EventGroupProductInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type EventGroupProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};


export type EventGroupQuestionsArgs = {
  group: QuestionGroup;
};


export type EventGroupRegisteredBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredBrandFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredBrandSortInput>;
};


export type EventGroupRegisteredProductVersionArgs = {
  productVersionId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
};


export type EventGroupRegisteredProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  useNext?: InputMaybe<Scalars['Boolean']['input']>;
  versionTag?: InputMaybe<DataVersionTag>;
};


export type EventGroupRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


export type EventGroupRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegistrationSortInput>;
};


export type EventGroupRepresentativesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type EventGroupUserProfilesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  roles: Array<SiteUserRole>;
  token: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};


export type EventGroupVisitorsArgs = {
  experimentalKey: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};

/** A list of groups that is sortable, filterable and can be paginated. */
export type EventGroupConnection = Connection & {
  edges: Array<EventGroupEdge>;
  nodes: Array<EventGroup>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EventGroupEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<Group>;
  node: EventGroup;
  previous?: Maybe<Group>;
};

export type EventGroupFieldsEnum =
  | 'createdAt'
  | 'groupId'
  | 'name'
  | 'updatedAt';

export type EventGroupSortInput = {
  fields?: InputMaybe<Array<InputMaybe<EventGroupFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrder>>>;
};

/** Pricing settings for an event or collection. */
export type EventPricing = {
  /** The collection for the pricing settings. */
  collectionId: Scalars['ID']['output'];
  /** The currency of the price. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Price range image that explains what the 5 options mean for this event or collection. */
  priceRangeImage?: Maybe<CloudinaryAsset>;
  /** The price ranges for the event or collection. */
  priceRanges?: Maybe<Array<PriceRange>>;
  /** The price strategy for this collection. */
  priceStrategy?: Maybe<PriceStrategy>;
  /** The type of price. */
  priceType?: Maybe<Scalars['String']['output']>;
  /** Related to priceRangeImage. This is an optional additional price range image that is optimized for public consumption, e.g. on a website. */
  publicPriceRangeImage?: Maybe<CloudinaryAsset>;
};


/** Pricing settings for an event or collection. */
export type EventPricingCurrencyArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** Pricing settings for an event or collection. */
export type EventPricingPriceTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type EventSortInput = {
  fields?: InputMaybe<Array<InputMaybe<EventFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrder>>>;
};

export type Exhibitor = AbstractBrand & Item & Profile & {
  /** The companies Global Location Number (GLN). */
  GLN?: Maybe<Scalars['String']['output']>;
  /** Array of address elements ordered based on the conventions of the particular country. */
  address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  biodynamicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The link to book wine experiences, hospitality, lifestyle and outdoor experiences. */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['ID']['output'];
  /** The city or village the brand is located at. */
  city?: Maybe<Scalars['String']['output']>;
  /** The people you can contact regarding this brand. */
  contacts?: Maybe<Array<BrandContact>>;
  /**
   * The level of content completeness a brand has.
   * It's mostly targeted towards the public profile.
   * The more complete a brand's content is, the more likely it is to be boosted in searches and lists.
   */
  contentLevel: Scalars['Int']['output'];
  /** The country of the profile. */
  country?: Maybe<Scalars['String']['output']>;
  /** A certain custom field, available on events and requests. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's value, available on events and requests.
   * This is a shortcut – If you need more, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields available on events and requests. */
  customFields?: Maybe<Array<CustomField>>;
  /**
   * A longer description of the brand.
   * For a shorter text, use shortDescription instead.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the brand's director.
   * @deprecated Use directorName instead.
   */
  director?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's director. */
  directorName?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently has distributors in. */
  distributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the distributor a brand currently has. */
  distributors?: Maybe<BrandDistributorConnection>;
  /** The brand's main contact email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The email to order products. */
  emailOrders?: Maybe<Scalars['String']['output']>;
  exhibitorId: Scalars['ID']['output'];
  exportConfigurations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The percentage this producer is exporting to other countries.
   * @deprecated Use exportPercentageText instead. This will throw an error if the value entered was not an integer.
   */
  exportPercentage?: Maybe<Scalars['Int']['output']>;
  /** The percentage this producer is exporting to other countries, in text format (as entered). */
  exportPercentageText?: Maybe<Scalars['String']['output']>;
  /** The brand's facebook account or URL. */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   * Files attached to this exhibitor, such as logo and main brand image.
   * Filters aren't implemented yet.
   */
  files?: Maybe<FileConnection>;
  /** The year the brand was founded. */
  founded?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  /**
   * Does the exhibitor have any notification contacts defined?
   * This can be used to display a warning in the UI
   * if you're trying to send notifications to this exhibitors.
   * @deprecated use registrations.managingContacts.totalCount instead (unimplemented yet)
   */
  hasNotificationContacts?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a social compliance program? */
  hasSocialComplianceProgram?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a sustainability certification? */
  hasSustainabilityCertification?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use mainImage instead. */
  headerImage?: Maybe<CloudinaryAsset>;
  /** The hospitality options this brand offers. */
  hospitalityOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use galleryImages instead. */
  imageGallery?: Maybe<Array<ImageGallery>>;
  /** The brand's instagram account or URL. */
  instagram?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  isPro?: Maybe<Scalars['Boolean']['output']>;
  /** The languages spoken at the brand's information desk. */
  languagesSpoken?: Maybe<Array<Scalars['String']['output']>>;
  /** The latitude of the profile address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The lifestyle amenities this brand offers. */
  lifestyleOfferings?: Maybe<Array<Scalars['String']['output']>>;
  logo?: Maybe<CloudinaryAsset>;
  /** The longitude of the profile address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The main image of the profile, often showing people or the location. */
  mainImage?: Maybe<CloudinaryAsset>;
  marketing?: Maybe<Array<MarketingActivity>>;
  marketingActivityTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** A link to book meetings with the exhibitor. */
  meetingBookingUrl?: Maybe<Scalars['String']['output']>;
  /** The name shown in the profile. */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Most values are not used any more. */
  offeringTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the brand's online shop. */
  onlineShop?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar shops where you can buy products of this brand. */
  onlineShops?: Maybe<Array<OnlineShop>>;
  /** The times that the business is open. */
  openingHours?: Maybe<Array<OpeningHoursSpecification>>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  organicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The outdoor experiences this brand offers. */
  outdoorExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * A brand's owner.
   * @deprecated Not ready for primetime yet. This will be renamed to company soon.
   */
  owner?: Maybe<CompanyProfile>;
  /** The name of the profile's owner. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar Wine shops where you can buy products of this brand. */
  physicalShops?: Maybe<Array<PhysicalShop>>;
  /** The post code of the city the brand is located at. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /**
   * A part at the beginning of the exhibitor's name that is not meant to distinguish it from other exhibitors, e.g. "Bodega".
   * It is used to boost the rest of the name in searches.
   * It can also be displayed on a separate line when displaying the winery name.
   * This is completely optional.
   */
  prefix?: Maybe<Scalars['String']['output']>;
  /** The price ranges the profile's brand or company offers. */
  priceRanges?: Maybe<Array<PriceRange>>;
  producer?: Maybe<Producer>;
  producers: ProducerConnection;
  products: ProductConnection;
  profileId: Scalars['ID']['output'];
  /** The region this company or brand belongs to. */
  region?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently seeking distributors for. */
  seekingDistributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** A short description of the brand. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The slug for the exhibitor.
   * The name is used to generate the slug.
   * While the name is still in flux (for example for previews),
   * set the 'format' arg to ID to use the exhibitorId.
   * useIdOnly is deprecated.
   */
  slug: Scalars['String']['output'];
  /** @deprecated Used for Bottlebooks Classic only. Use socialCompliancePrograms instead. */
  socialCompliance?: Maybe<Array<SocialComplianceProgram>>;
  /** The list of social compliance programs. */
  socialCompliancePrograms?: Maybe<Array<SocialComplianceProgram>>;
  /**
   * The text to be used for sorting the brand in a list.
   * The name is also used for catalog indexes,
   * so a winery called "Bodegas Juan Carlos" could have a sortName of "Carlos, Juan, Bodegas" or "Carlos Juan".
   */
  sortName?: Maybe<Scalars['String']['output']>;
  /** The stand at an event. */
  stand?: Maybe<Stand>;
  /** The state/province of the profile. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** The street the brand is located in. */
  street?: Maybe<Scalars['String']['output']>;
  /**
   * A part at the end of the exhibitor's name that is not meant to distinguish it from other exhibitors, e.g. "Winery".
   * It is used to boost the rest of the name in searches.
   * It can also be displayed on a separate line when displaying the winery name.
   * This is completely optional.
   */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The list of social compliance programs. */
  sustainabilityCertifications?: Maybe<Array<SustainabilityCertification>>;
  /** The phone number of the profile. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The telephone number to order products. */
  telephoneOrders?: Maybe<Scalars['String']['output']>;
  /** The brand's twitter account or URL. */
  twitter?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Video>>;
  /** The brand's main website. */
  website?: Maybe<Scalars['String']['output']>;
  /** The wine experiences this brand offers. */
  wineExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use winemakerName instead. */
  winemaker?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's winemaker. */
  winemakerName?: Maybe<Scalars['String']['output']>;
  /** The brand's youtube account or URL. */
  youtube?: Maybe<Scalars['String']['output']>;
};


export type ExhibitorGlnArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorBiodynamicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ExhibitorCityArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ExhibitorCustomFieldArgs = {
  key: Scalars['String']['input'];
};


export type ExhibitorCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


export type ExhibitorDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type ExhibitorDirectorArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorDirectorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


export type ExhibitorDistributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BrandDistributorFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandDistributorSortInput>;
};


export type ExhibitorEmailArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ExhibitorEmailOrdersArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ExhibitorExportPercentageTextArgs = {
  format?: TextFormat;
};


export type ExhibitorFacebookArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ExhibitorFilesArgs = {
  filter?: InputMaybe<BrandFileFilterInput>;
};


export type ExhibitorFoundedArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorHospitalityOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ExhibitorInstagramArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ExhibitorLanguagesSpokenArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ExhibitorLifestyleOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ExhibitorMeetingBookingUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ExhibitorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ExhibitorOrganicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ExhibitorOutdoorExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ExhibitorOwnerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorPostalCodeArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorProducerArgs = {
  producerId: Scalars['ID']['input'];
};


export type ExhibitorProducersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProducerSortInput>;
};


export type ExhibitorProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};


export type ExhibitorRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorSeekingDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


export type ExhibitorShortDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type ExhibitorSlugArgs = {
  format?: InputMaybe<SlugFormat>;
  useIdOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExhibitorSortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorStateProvinceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ExhibitorStreetArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorTelephoneArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


export type ExhibitorTelephoneOrdersArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


export type ExhibitorTwitterArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ExhibitorWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ExhibitorWineExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ExhibitorWinemakerArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorWinemakerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ExhibitorYoutubeArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** A list of exhibitors that is sortable, filterable and can be paginated. */
export type ExhibitorConnection = AbstractBrandConnection & Connection & {
  edges: Array<ExhibitorEdge>;
  nodes: Array<Exhibitor>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExhibitorEdge = AbstractBrandEdge & Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<Exhibitor>;
  node: Exhibitor;
  previous?: Maybe<Exhibitor>;
};

export type ExhibitorFieldsEnum =
  | 'city'
  | 'country'
  | 'exhibitorId'
  | 'name'
  | 'postalCode'
  | 'region';

export type ExhibitorSortInput = {
  fields?: InputMaybe<Array<InputMaybe<ExhibitorFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrder>>>;
};

export type ExportConfiguration = {
  configurationId: Scalars['ID']['output'];
  fields: Array<Maybe<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
};

/** A product with some extensions unique to Sites. This is a temporary solution until we can unify the Product and ProductV1 resolvers. */
export type ExtendedProduct = {
  /** The exhibitor presenting a product at an event. */
  exhibitor?: Maybe<Exhibitor>;
  /** The ID of an exhibitor presenting the product at an event. */
  exhibitorId?: Maybe<Scalars['ID']['output']>;
  /**
   * A price for this product.
   * @deprecated Use registeredProduct.pricing instead.
   */
  pricing?: Maybe<ProductPrice>;
  productId: Scalars['ID']['output'];
  /** A stand on an event. */
  stand?: Maybe<Stand>;
};

export type FeaturedProductContentType =
  | 'PRICE'
  | 'VIDEOS'
  | 'WEBSHOP';

/** A field. */
export type Field = {
  /**
   * The path to the field.
   * It identifies the field uniquely.
   */
  fieldId: Scalars['String']['output'];
  /**
   * The interface label for that field.
   * The locale parameter will allow for fetching the label in a particular UI language,
   * but that's not implemented yet - it's an experimental suggestion only.
   */
  label?: Maybe<Scalars['String']['output']>;
};


/** A field. */
export type FieldLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Describes the change of a field. */
export type FieldChange = {
  /** If the field was changed within a collection, this describes the collection. */
  collection?: Maybe<Collection>;
  /** The name of the collection where this field was changed in. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The ISO date that this field was changed at. */
  date: Scalars['String']['output'];
  /** The field involved in the change. */
  field: ChangedField;
  /** The unique id of the field change. */
  fieldChangeId: Scalars['ID']['output'];
  /** The type of change made. */
  fieldChangeType: FieldChangeType;
  /** The product on which the change was made. */
  product: Product;
  /** The user and brand who changed the field. */
  user: ChangedBy;
};

export type FieldChangeHistoryEntry = FieldHistoryEntry & HistoryEntry & {
  changeId: Scalars['ID']['output'];
  /** The type of change made. */
  changeType?: Maybe<HistoryEntryType>;
  /** The ISO date that this field was changed at. */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** The user and brand who changed the field. */
  changedBy?: Maybe<ChangedBy>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The field that was changed. */
  field: HistoryField;
  /** The original value. */
  from: FieldValue;
  /** The new value it was set to. */
  to: FieldValue;
};

export type FieldChangeType =
  | 'FIELD_CHANGE'
  | 'FIELD_SET'
  | 'FIELD_UNSET';

export type FieldHistoryEntry = {
  changeId: Scalars['ID']['output'];
  /** The type of change made. */
  changeType?: Maybe<HistoryEntryType>;
  /** The ISO date that this field was changed at. */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** The user and brand who changed the field. */
  changedBy?: Maybe<ChangedBy>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The field involved in the history entry. */
  field: HistoryField;
};

export type FieldInputType =
  | 'TextInput';

export type FieldSetHistoryEntry = FieldHistoryEntry & HistoryEntry & {
  changeId: Scalars['ID']['output'];
  /** The type of change made. */
  changeType?: Maybe<HistoryEntryType>;
  /** The ISO date that this field was changed at. */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** The user and brand who changed the field. */
  changedBy?: Maybe<ChangedBy>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The field that was changed. */
  field: HistoryField;
  /** The new value it was set to. */
  to: FieldValue;
};

/** A field change that cannot be determined. Usually the from and to are both empty. */
export type FieldUnknownHistoryEntry = FieldHistoryEntry & HistoryEntry & {
  changeId: Scalars['ID']['output'];
  /** The type of change made. */
  changeType?: Maybe<HistoryEntryType>;
  /** The ISO date that this field was changed at. */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** The user and brand who changed the field. */
  changedBy?: Maybe<ChangedBy>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The field that was changed. */
  field: HistoryField;
  /** The original value that was unset. */
  from: FieldValue;
  /** The new value it was set to. */
  to: FieldValue;
};

/** Someone unset a field that was previously unset. */
export type FieldUnsetHistoryEntry = FieldHistoryEntry & HistoryEntry & {
  changeId: Scalars['ID']['output'];
  /** The type of change made. */
  changeType?: Maybe<HistoryEntryType>;
  /** The ISO date that this field was changed at. */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** The user and brand who changed the field. */
  changedBy?: Maybe<ChangedBy>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The field that was changed. */
  field: HistoryField;
  /** The original value that was unset. */
  from: FieldValue;
};

export type FieldValue = {
  rawText?: Maybe<Scalars['String']['output']>;
};

export type File = {
  /** The relations to products, brands or collections where this file is used in. */
  attachedNodes: AttachedNodeConnection;
  /** The name calculated from the first attached product or brand, or the manual name. */
  calculatedTitle: Scalars['String']['output'];
  /** The actual, semantic type of content, such as bottle image, infosheet etc. */
  contentType?: Maybe<FileContentType>;
  /** A description of the file in long text format. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The file's general dimensions. If the file contains different sections with varying formats, the section dimensions can be queried on 'pages'.
   * @deprecated Not yet supported.
   */
  dimensions: FileDimensions;
  /** The unique file id. */
  fileId?: Maybe<Scalars['ID']['output']>;
  /** The filename used when downloading the file, without the file extension. Can be modified. */
  filename: Scalars['String']['output'];
  /** A fixed-size image. */
  fixed?: Maybe<CloudinaryFixed>;
  /** A fluid image with optional constraints. */
  fluid?: Maybe<CloudinaryFluid>;
  /** Indicates if the file is a default file and cannot be deleted. */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated check for __typename instead. */
  isLive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The languages this file is in.
   * For images without language specific text, it may be empty.
   */
  languages?: Maybe<Array<Maybe<FileLanguage>>>;
  /** @deprecated Use the __typename instead. */
  linkedFile?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use title instead. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The version this file had before.
   * Currently we support only a single revision, so this is always null.
   */
  previousRevision?: Maybe<File>;
  publicId: Scalars['String']['output'];
  /** The status of the file (draft, released or archived). Only released files can be attached to other nodes. */
  releaseStatus: ReleaseStatus;
  /** "The URL to download the original file from." */
  sourceUrl: Scalars['String']['output'];
  /** A thumbnail with a predefined size. */
  thumbnail?: Maybe<CloudinaryFixed>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The manually set title. */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The URL to download the file.
   * This is often an optimized link served via a CDN or specialized service, such as Cloudinary.
   */
  url: Scalars['String']['output'];
};


export type FileDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type FileFixedArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  sizes?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type FileFluidArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  sizes?: InputMaybe<Scalars['String']['input']>;
};


export type FileThumbnailArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  sizes?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type FileTitleArgs = {
  format?: InputMaybe<TextFormat>;
};

export type FileConnection = {
  edges: Array<FileEdge>;
  group: Array<FileGroupConnection>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type FileConnectionGroupArgs = {
  field?: InputMaybe<FileGroupField>;
};

export type FileContentType =
  | 'backLabelImage'
  | 'bottleImage'
  | 'brandGalleryImage'
  | 'brandImage'
  | 'certificate'
  | 'dataFile'
  | 'gs1'
  | 'infoSheet'
  | 'labelImage'
  | 'logo'
  | 'other'
  | 'productGalleryImage'
  | 'productImage'
  | 'productList'
  | 'qrCode';

export type FileDimensions = {
  /** The depth in the default unit, or as the value converted to another unit. */
  depth?: Maybe<Scalars['Float']['output']>;
  /** The height in the default unit, or as the value converted to another unit. */
  height?: Maybe<Scalars['Float']['output']>;
  /** The default unit. */
  unit: FileLengthUnit;
  /** The with in the default unit, or as the value converted to another unit. */
  width?: Maybe<Scalars['Float']['output']>;
};


export type FileDimensionsDepthArgs = {
  unit?: InputMaybe<FileLengthUnit>;
};


export type FileDimensionsHeightArgs = {
  unit?: InputMaybe<FileLengthUnit>;
};


export type FileDimensionsWidthArgs = {
  unit?: InputMaybe<FileLengthUnit>;
};

export type FileEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<File>;
  node: File;
  previous?: Maybe<File>;
};

export type FileGroupConnection = {
  edges: Array<FileEdge>;
  field: FileGroupField;
  fieldValue?: Maybe<Scalars['String']['output']>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FileGroupField =
  | 'contentType'
  | 'contentTypeGroup';

export type FileLanguage = {
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};


export type FileLanguageNameArgs = {
  locale?: Scalars['String']['input'];
};

export type FileLanguageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type FileLengthUnit =
  | 'cm'
  | 'px';

export type FileOutput = {
  collection?: Maybe<Collection>;
  collectionId?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<CollectionOutputConfiguration>;
  createdAt: Scalars['String']['output'];
  createdBy: UserProfile;
  file: File;
  integrationId?: Maybe<Scalars['String']['output']>;
  outputConfigurationId?: Maybe<Scalars['String']['output']>;
  outputId: Scalars['ID']['output'];
  transfers: Array<FileTransfer>;
};

export type FileTransfer = {
  transferId: Scalars['ID']['output'];
  transferredAt: Scalars['String']['output'];
};

/** A URL to a file that was uploaded to a public CDN. */
export type FileUrlInput = {
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FinalizeAliasImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizePortfolioProductExternalIdImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: PortfolioProductExternalIdImportOptionsInput;
};

export type FinalizePortfolioProductExternalIdImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizeProductAllInOneImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: ProductAllInOneImportOptionsInput;
};

export type FinalizeProductAllInOneImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizeProductCreationImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: ProductCreationImportOptionsInput;
};

export type FinalizeProductCreationImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizeProductDataImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: ProductDataImportOptionsInput;
};

export type FinalizeProductDataImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizeProductExternalIdImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: ProductExternalIdImportOptionsInput;
};

export type FinalizeProductExternalIdImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizeProductInternalIdImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: ProductInternalIdImportOptionsInput;
};

export type FinalizeProductInternalIdImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizeProductListImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizeProfileDataImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: ProfileDataImportOptionsInput;
};

export type FinalizeProfileDataImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FloatFieldValue = FieldValue & {
  /** The raw number as stored in the database. */
  rawText?: Maybe<Scalars['String']['output']>;
  /** The formatted number. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** An event floor. */
export type Floor = EventArea & Item & Node & {
  allRooms: Array<Room>;
  allStands: Array<Stand>;
  /** The type of area. Always FLOOR. */
  areaType: EventAreaType;
  areas: EventAreaConnection;
  /** A summary of the sub-areas of this area. Typically the stand number range. */
  areasSummary: Scalars['String']['output'];
  collection: Collection;
  collectionId: Scalars['ID']['output'];
  /** The color that contrasts the primary color. Typically either black or white. */
  contrastColor?: Maybe<Scalars['String']['output']>;
  /** A longer description of the area. */
  description: Scalars['String']['output'];
  event: Event;
  eventId: Scalars['ID']['output'];
  floor?: Maybe<Floor>;
  /** @deprecated Unstable - can change without notice. */
  form: EventAreaForm;
  id: Scalars['ID']['output'];
  /** The localized name of the area. Typically the stand name or room name. */
  name: Scalars['String']['output'];
  parent?: Maybe<EventArea>;
  parentSlug?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<FloorPlan>;
  /** The primary color assigned to this area. */
  primaryColor?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<SingleRegistration>;
  registrationId?: Maybe<Scalars['ID']['output']>;
  room?: Maybe<Room>;
  slug: Scalars['String']['output'];
  sortIndex: Scalars['Int']['output'];
  stand?: Maybe<Stand>;
  /** A subtitle for the area. Typically the names of the regions, associations or exhibitors found in this area. */
  subtitle: Scalars['String']['output'];
};


/** An event floor. */
export type FloorAreasArgs = {
  filter?: InputMaybe<EventAreaFilterInput>;
};


/** An event floor. */
export type FloorAreasSummaryArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};


/** An event floor. */
export type FloorDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};


/** An event floor. */
export type FloorNameArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale?: InputMaybe<ContentLocale>;
};


/** An event floor. */
export type FloorSubtitleArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};

/** A floor plan for an event. */
export type FloorPlan = {
  allHotspots: Array<FloorPlanHotspot>;
  area: EventArea;
  areaType: EventAreaType;
  collection: Collection;
  collectionId: Scalars['ID']['output'];
  event: Event;
  eventId: Scalars['ID']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  image: CloudinaryAsset;
  slug: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type FloorPlanHotspot = {
  area?: Maybe<EventArea>;
  areaType?: Maybe<EventAreaType>;
  collection: Collection;
  collectionId: Scalars['ID']['output'];
  event: Event;
  eventId: Scalars['ID']['output'];
  floorPlan: FloorPlan;
  height: Scalars['Float']['output'];
  /**
   * The height of the hotspot in relation to the floor plan.
   * The values are between 0 and 100 so you can use them in CSS as percentage values.
   * 0 is no height, 100 is the full height of the floor plan.
   */
  heightPercentage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /**
   * The distance of the left edge of the hotspot to the edge of the floor plan.
   * The values are between 0 and 100 so you can use them in CSS as percentage values.
   * 0 is to the left, 100 is completely to the right.
   */
  leftPercentage: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  plan?: Maybe<FloorPlan>;
  slug: Scalars['String']['output'];
  /**
   * The distance of the top edge of the hotspot to the edge of the floor plan.
   * The values are between 0 and 100 so you can use them in CSS as percentage values.
   * 0 is to the top, 100 is completely to the bottom.
   */
  topPercentage: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  /**
   * The width of the hotspot in relation to the floor plan.
   * The values are between 0 and 100 so you can use them in CSS as percentage values.
   * 0 is no width, 100 is the full width of the floor plan.
   */
  widthPercentage: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type Form = {
  /** The completion state for the component. */
  completionState?: Maybe<FormCompletionState>;
  /** The form's sections. */
  sections: Array<FormSection>;
  /** The form type. */
  type: FormType;
};

export type FormCompletionState =
  /** The form is valid and complete. */
  | 'COMPLETE'
  /** The form is failing completeness checks. */
  | 'INCOMPLETE'
  /** The form is failing validation and cannot be published. */
  | 'INVALID'
  /** Data entry wasn't started yet. */
  | 'NOT_STARTED'
  /** This value has been marked as . */
  | 'REVIEW_REQUIRED';

export type FormComponent = {
  /** The completion state for the component. */
  completionState?: Maybe<FormCompletionState>;
  /** The component's configuration. Dependent on the component type. */
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  /**
   * The component description.
   * Optional.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The component's fields. */
  fields: Array<FormField>;
  /**
   * The hash over the component's value.
   * Only available for components that are queried on a particular data object.
   * Use this to determine if the value has changed.
   * Send it with a mutation to detect conflicts.
   */
  hash?: Maybe<Scalars['String']['output']>;
  /** The component's unique key. */
  key: Scalars['ID']['output'];
  /**
   * The component title.
   * Optional.
   */
  title?: Maybe<Scalars['String']['output']>;
  /** The component's type. */
  type: FormComponentType;
  /**
   * The raw JSON value for the component.
   * Only available for components that are queried on a particular data object.
   * Contains the field names and values. for example an alcohol component would return { alcohol: 12.5 }.
   */
  value?: Maybe<Scalars['JSONObject']['output']>;
};


export type FormComponentDescriptionArgs = {
  locale: InterfaceLocale;
};


export type FormComponentTitleArgs = {
  locale: InterfaceLocale;
};

export type FormComponentType =
  /**
   * A component for editing a product name.
   * Contains logic to check for name corrections vs. new products.
   */
  | 'ProductName'
  /** A component for a product's origin (country, region etc.) */
  | 'ProductOrigin'
  /** A  simple component without any further special treatment. */
  | 'SimpleComponent'
  /**
   * A component handling a wine name and vintage.
   * Contains logic to check for name corrections vs. new products.
   */
  | 'WineName'
  /** A component handling wine varieties. */
  | 'WineVarieties';

export type FormConfiguration = {
  description: Scalars['String']['output'];
  fields: Array<ClassicField>;
  locales: Array<ContentLocale>;
};


export type FormConfigurationDescriptionArgs = {
  locale?: InputMaybe<InterfaceLocale>;
};

export type FormField = {
  /** The completion state for the component. */
  completionState?: Maybe<FormCompletionState>;
  /** The field's configuration. Dependent on the field type. */
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  /** The field's description, if any. */
  description?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  /** The field's unique identifier. */
  key: Scalars['ID']['output'];
  /** The field's label. */
  label: Scalars['String']['output'];
  /** @deprecated Experimental. */
  name?: Maybe<Scalars['String']['output']>;
  /** The field's type. */
  type: FormFieldType;
};


export type FormFieldDescriptionArgs = {
  locale: InterfaceLocale;
};


export type FormFieldLabelArgs = {
  locale: InterfaceLocale;
};

export type FormFieldType =
  /** A field containing an integer. */
  | 'IntegerField'
  /** Multiple values from a list of valid values. */
  | 'MultiSelectField'
  /** A field containing a floating point number. */
  | 'NumberField'
  /** A single value from a list of valid values. */
  | 'SelectField'
  /** A field containing a single line of (non-localized) text. */
  | 'TextField';

export type FormSection = {
  /** The completion state for the form section. */
  completionState?: Maybe<FormCompletionState>;
  /** The section's components. */
  components: Array<FormComponent>;
  /** An optional description for this section. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for this section. */
  key: Scalars['ID']['output'];
  /** The section's title. */
  title: Scalars['String']['output'];
};


export type FormSectionDescriptionArgs = {
  locale: InterfaceLocale;
};


export type FormSectionTitleArgs = {
  locale: InterfaceLocale;
};

export type FormType =
  | 'BeerForm'
  | 'CiderForm'
  | 'CompanyProfileForm'
  | 'ProducerProfileForm'
  | 'SpiritForm'
  | 'WineForm';

export type GtinFormat =
  /** Trimmed and padded for a total length of 14 characters. */
  | 'GTIN14'
  | 'RAW';

export type Group = Collection & Item & {
  /** @deprecated Experimental - might be removed or changed without notice. Use at your own risk. */
  _unstable_allOutputConfigurations: Array<CollectionOutputConfiguration>;
  /**
   * Returns if adding products to a registration via QR code is allowed.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_allowAddViaQrCode: Scalars['Boolean']['output'];
  /**
   * The Bottlebooks Classic fields configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_classicFields: Array<ClassicField>;
  /**
   * Collection configuration data.
   * @deprecated For debugging only
   */
  _unstable_data: Scalars['JSON']['output'];
  /**
   * The product requests that don't have a matching product.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_missingProducts: Array<Unstable_MissingProduct>;
  /**
   * The tasting lists for this collection for a specific user.
   * @deprecated Experimental - might change of be dropped!
   */
  _unstable_myTastingLists: Array<TastingList>;
  /**
   * Outputs for a collection
   * @deprecated Experimental, will be removed. Use _unstable_outputConfigurations instead.
   */
  _unstable_outputs: Array<CollectionOutputConfiguration>;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_product: Unstable_CollectionProductEdge;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_products: Unstable_CollectionProductConnection;
  /**
   * The Bottlebooks Classic fields recommended to be configured based on outputs.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_recommendedClassicFields: Array<RecommendedClassicField>;
  /**
   * collectionIds that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollectionIds: Scalars['ID']['output'];
  /**
   * Access collections that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollections: CollectionConnection;
  /** @deprecated Experimental. Use at your own risk! */
  _unstable_requestedProducts: Unstable_RequestedProductConnection;
  /**
   * The products registered for a collection that have not been requested by the organizer.
   * @deprecated Experimental and unstable. Use at your own risk!
   */
  _unstable_unrequestedProducts: RegisteredProductConnection;
  /** @deprecated Experimental. Don't use yet. */
  _unstable_useNewForms: Scalars['Boolean']['output'];
  /** @deprecated Experimental. Don't use yet. */
  _unstable_validValueLists: Unstable_ValidValueLists;
  /** The default catalog. */
  catalog?: Maybe<CatalogConfiguration>;
  /** An alias for groupId. */
  collectionId: Scalars['ID']['output'];
  collectionType: CollectionType;
  /** The email of contact in the group. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the collection was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /**
   * All the deleted registrations for a collection.
   * @deprecated Experimental
   */
  deletedRegistrations: Array<Registration>;
  /** The public description of the collection. */
  description?: Maybe<Scalars['String']['output']>;
  /** The collection steps. */
  enabledSteps: Array<RegistrationStep>;
  /**
   * The events of this group.
   * Only active brands can see the group events.
   */
  events?: Maybe<EventConnection>;
  /** General instructions for exhibitors. */
  exhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /**
   * A particular form for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  form: Form;
  /**
   * The allowed form types for this collection.
   * @deprecated Experimental - use at your own risk!
   */
  formTypes: Array<FormType>;
  /**
   * All the forms for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  forms: Array<Form>;
  groupId: Scalars['ID']['output'];
  /** This collection has a product master list that specifies which products suppliers or exhibitors must register. */
  hasProductMasterList: Scalars['Boolean']['output'];
  /** This collection has an overall sorting for the products with optional flighting details. These events are often referred to as 'product-led events' where there are no exhibitors. sortIndex, flightName, and productLabel are null when this is false. */
  isProductSortingEnabled: Scalars['Boolean']['output'];
  /** @deprecated This resolver is under development and is not stable. */
  list?: Maybe<CollectionList>;
  /** @deprecated This resolver is under development and is not stable. */
  lists: CollectionListConnection;
  /** All the configured locales of the event. */
  locales: Array<Scalars['String']['output']>;
  /** Instructions for exhibitors after login. */
  loggedInExhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /** The collection logo. Often this is the collection owner's logo. */
  logo?: Maybe<CloudinaryAsset>;
  mainImage?: Maybe<CloudinaryAsset>;
  /** The maximum products of the collection per registration. */
  maximumProducts?: Maybe<Scalars['Int']['output']>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingAvailabilities: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingTimeslots: Array<MeetingTimeslot>;
  /**
   * The members of the group or null if you are not the group owner.
   * @deprecated Use registrations instead.
   */
  members?: Maybe<GroupMembershipConnection>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  myMeetingTimeslots: Array<MeetingTimeslot>;
  /** @deprecated Use currentBrand.registrations instead. */
  myMembership?: Maybe<GroupMembership>;
  /**
   * All the company registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  myRegistrations: RegistrationConnection;
  name: Scalars['String']['output'];
  /** The contacts that get notifications from the organizer regarding their registrations. */
  notificationContacts?: Maybe<Array<Maybe<Contact>>>;
  owner: Brand;
  permissions: CollectionPermissions;
  /** Exhibitor instructions for adding products. */
  productInstructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated This resolver uses an older schema and will not be further developed. Use registeredProducts to get access to newer features. */
  products: ProductConnection;
  /**
   * The questions configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  questions?: Maybe<Array<Question>>;
  /**
   * The brands producing products that have been registered at a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registeredBrands: RegisteredBrandConnection;
  /**
   * A product registered for a collection.
   * Because the same product might be added my multiple different partners,
   * you need to look at the registrations property to get the necessary details for each registration.
   * Not all types of collections support registeredProducts.
   */
  registeredProductVersion: RegisteredProduct;
  /**
   * The products registered for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registeredProducts: RegisteredProductConnection;
  /** A particular registration. */
  registration?: Maybe<Registration>;
  /**
   * All the registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registrations: RegistrationConnection;
  /**
   * The representative profiles of all registrations.
   * @deprecated Experimental. Use at your own risk!
   */
  representatives: Array<SiteUserProfile>;
  /** The default site of the collection. */
  site?: Maybe<SiteConfiguration>;
  /** An ISO date when the collection was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The user profiles.
   * @deprecated Use visitors or representatives instead.
   */
  userProfiles: Array<SiteUserProfile>;
  visibilityStatus: VisibilityStatusType;
  /**
   * The visitor profiles of a collection. These are the registered and approved visitors.
   * @deprecated Experimental. Use at your own risk!
   */
  visitors: Array<SiteUserProfile>;
  workspaceId: Scalars['ID']['output'];
};


export type Group_Unstable_AllOutputConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Group_Unstable_AllowAddViaQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Group_Unstable_ClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


export type Group_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Group_Unstable_MissingProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Group_Unstable_MyTastingListsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  sort?: InputMaybe<TastingListSortInput>;
  uid: Scalars['String']['input'];
};


export type Group_Unstable_OutputsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Group_Unstable_ProductArgs = {
  experimentalKey: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


export type Group_Unstable_ProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


export type Group_Unstable_RecommendedClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


export type Group_Unstable_RelatedCollectionIdsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Group_Unstable_RelatedCollectionsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Group_Unstable_RequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type Group_Unstable_UnrequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  versionTag?: InputMaybe<DataVersionTag>;
};


export type Group_Unstable_UseNewFormsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Group_Unstable_ValidValueListsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type GroupDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type GroupEventsArgs = {
  filter?: InputMaybe<EventFilter>;
};


export type GroupExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type GroupFormArgs = {
  type: FormType;
};


export type GroupListArgs = {
  collectionListId: Scalars['String']['input'];
};


export type GroupListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupLocalesArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<InterfaceLocale>;
};


export type GroupLoggedInExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type GroupMeetingAvailabilitiesArgs = {
  attendeeId: Scalars['String']['input'];
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  organizerId: Scalars['String']['input'];
};


export type GroupMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type GroupMyMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type GroupMyRegistrationsArgs = {
  companyId: Scalars['ID']['input'];
};


export type GroupNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type GroupProductInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type GroupProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};


export type GroupQuestionsArgs = {
  group: QuestionGroup;
};


export type GroupRegisteredBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredBrandFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredBrandSortInput>;
};


export type GroupRegisteredProductVersionArgs = {
  productVersionId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
};


export type GroupRegisteredProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  useNext?: InputMaybe<Scalars['Boolean']['input']>;
  versionTag?: InputMaybe<DataVersionTag>;
};


export type GroupRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


export type GroupRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegistrationSortInput>;
};


export type GroupRepresentativesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type GroupUserProfilesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  roles: Array<SiteUserRole>;
  token: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};


export type GroupVisitorsArgs = {
  experimentalKey: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};

/** A list of groups that is sortable, filterable and can be paginated. */
export type GroupConnection = Connection & {
  edges: Array<GroupEdge>;
  nodes: Array<Group>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** The fields to sort group connections by. */
export type GroupConnectionSortField =
  /** The field value grouped by. */
  | 'fieldValue'
  /** The original sort order. */
  | 'index'
  /** The total count of grouped values. */
  | 'totalCount';

/** The sort order of group connections. */
export type GroupConnectionSortInput = {
  fields?: InputMaybe<Array<GroupConnectionSortField>>;
  order?: InputMaybe<Array<SortOrder>>;
};

export type GroupEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<Group>;
  node: Group;
  previous?: Maybe<Group>;
};

export type GroupFieldsEnum =
  | 'createdAt'
  | 'groupId'
  | 'name'
  | 'updatedAt';

export type GroupMembership = Item & {
  brand: AbstractBrand;
  brandId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  group: Group;
  groupId: Scalars['ID']['output'];
  membershipId: Scalars['ID']['output'];
  /** @deprecated Needed to support the Item interface only. Will always be empty. */
  name?: Maybe<Scalars['String']['output']>;
  /** The contacts managing a registration. */
  notificationContacts?: Maybe<Array<Contact>>;
  status: GroupMembershipStatus;
};


export type GroupMembershipCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type GroupMembershipConnection = Connection & {
  edges: Array<GroupMembershipEdge>;
  nodes: Array<GroupMembership>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GroupMembershipEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<GroupMembership>;
  node: GroupMembership;
  previous?: Maybe<GroupMembership>;
};

export type GroupMembershipStatus =
  | 'ACTIVE'
  | 'INACTIVE';

export type GroupSortInput = {
  fields?: InputMaybe<Array<InputMaybe<GroupFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrder>>>;
};

export type GroupedRegistration = Item & Registration & {
  /** @deprecated Use company instead. */
  brand?: Maybe<Brand>;
  /** @deprecated use companyId instead. */
  brandId?: Maybe<Scalars['ID']['output']>;
  /** The collection that the brand registered for. */
  collection?: Maybe<Collection>;
  /** The ID of the collection this registration belongs to. */
  collectionId: Scalars['ID']['output'];
  /** The ID of the registering company. */
  companyId: Scalars['ID']['output'];
  /** The total number of completed collections. */
  completedCount?: Maybe<Scalars['Int']['output']>;
  /** The time when this registration was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Is the registration locked? */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** The collection group name. */
  name: Scalars['String']['output'];
  /** The contacts managing a registration. */
  notificationContacts?: Maybe<Array<Contact>>;
  /** The registering company's public profile for this collection. */
  profile?: Maybe<RegistrationProfile>;
  /** The total number of collections where the exhibitor is registered. */
  registeredCount?: Maybe<Scalars['Int']['output']>;
  /** The registration id. If missing on database, will be a built id. */
  registrationId: Scalars['ID']['output'];
  /** The type of registration. */
  registrationType: RegistrationType;
  /**
   * The registrations of the group. Just single registrations because we don't support
   * nested registrations.
   */
  registrations: Array<SingleRegistration>;
  workspaceId: Scalars['ID']['output'];
};


export type GroupedRegistrationNameArgs = {
  format?: InputMaybe<TextFormat>;
};

export type GroupedRegistrationConnection = RegistrationConnection & {
  edges: Array<GroupedRegistrationEdge>;
  /** Groups the registrations by a particular field. */
  group: Array<GroupedRegistrationGroupConnection>;
  nodes: Array<GroupedRegistration>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type GroupedRegistrationConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: RegistrationGroupField;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};

export type GroupedRegistrationEdge = Edge & RegistrationEdge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<GroupedRegistration>;
  node: GroupedRegistration;
  previous?: Maybe<GroupedRegistration>;
};

export type GroupedRegistrationGroupConnection = RegistrationGroupConnection & {
  edges: Array<GroupedRegistrationEdge>;
  fieldName: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  /** Groups the registrations by a particular field. */
  group: Array<GroupedRegistrationGroupConnection>;
  nodes: Array<GroupedRegistration>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type GroupedRegistrationGroupConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: RegistrationGroupField;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};

export type HistoryEntry = {
  changeId: Scalars['ID']['output'];
  /** The type of change made. */
  changeType?: Maybe<HistoryEntryType>;
  /** The ISO date that this field was changed at. */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** The user and brand who changed the field. */
  changedBy?: Maybe<ChangedBy>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
};

export type HistoryEntryQueryOperatorInput = {
  eq?: InputMaybe<HistoryEntryType>;
  in?: InputMaybe<Array<InputMaybe<HistoryEntryType>>>;
  ne?: InputMaybe<HistoryEntryType>;
  nin?: InputMaybe<Array<InputMaybe<HistoryEntryType>>>;
  regex?: InputMaybe<HistoryEntryType>;
};

export type HistoryEntryType =
  | 'FIELD_CHANGE'
  | 'FIELD_SET'
  | 'FIELD_UNSET'
  | 'PRODUCT_ADD_TO_COLLECTION'
  | 'PRODUCT_CHANGE'
  | 'PRODUCT_REMOVE_FROM_COLLECTION';

export type HistoryField = {
  /**
   * The path to the field in the changed object.
   * It identifies the field uniquely.
   */
  fieldId: Scalars['String']['output'];
  /**
   * The interface label for that field.
   * The locale parameter will allow for fetching the label in a particular UI language,
   * but that's not implemented yet - it's an experimental suggestion only.
   */
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ChangedFieldType>;
};


export type HistoryFieldLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A filter input type for ID fields.
 * Use to filter brands on brandId for example.
 */
export type IdQueryOperatorInput = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type Image = {
  height?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** A value rendered as an image. */
export type ImageFieldValue = FieldValue & {
  /** @deprecated Use value instead. */
  image?: Maybe<CloudinaryAsset>;
  /** The raw source URL of the image. */
  rawText?: Maybe<Scalars['String']['output']>;
  /** The image. */
  value?: Maybe<CloudinaryAsset>;
};

/** DEPRECATED - not used any more. */
export type ImageGallery = {
  /** The description displayed for the image. */
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use title instead. */
  name?: Maybe<Scalars['String']['output']>;
  /** The title displayed for the image. */
  title?: Maybe<Scalars['String']['output']>;
  /** The URL for the image. */
  url?: Maybe<Scalars['String']['output']>;
};


/** DEPRECATED - not used any more. */
export type ImageGalleryUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};

export type ImportChange = {
  changeCode: Scalars['String']['output'];
  changes?: Maybe<Array<Maybe<ImportChangeItem>>>;
  rowKey?: Maybe<Scalars['String']['output']>;
};

export type ImportChangeItem = {
  bottlebooksFieldName: Scalars['String']['output'];
  changeCode: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type ImportColumnFilterInput = {
  name?: InputMaybe<StringQueryOperatorInput>;
};

export type ImportFieldError = {
  code?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  relatedFields?: Maybe<Array<Maybe<ImportRelatedField>>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportFilterInput = {
  state?: InputMaybe<IdQueryOperatorInput>;
};

export type ImportRelatedField = {
  bottlebooksFieldName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IncludeProducer =
  /** Always adds the producer name to the product name, without checking if it is already in the product name. */
  | 'ALWAYS'
  /** Adds the producer name to the product name if it isn't already included. */
  | 'AUTO'
  /** Removes the producer name from the product name. */
  | 'NEVER'
  /** Doesn't change the product name. */
  | 'NO_CHANGE';

export type IncludeVintage =
  /** Adds the vintage or a nonVintage placeholder if it is set. */
  | 'AUTO'
  /** Always removes the vintage from the name. */
  | 'NEVER';

export type IngredientVisibility =
  /** The ingredient is only visible when searching for the particular term. */
  | 'ALTERNATIVE'
  /** The ingredient is deprecated. Don't return it in searches, but list it if it is already used in a product. */
  | 'DEPRECATED'
  /** The ingredient is always visible. It's a preferred ingredient. */
  | 'PREFERRED';

export type IngredientsTextFormat =
  /** Allergens are surrounded by <strong></strong> elements. */
  | 'HTML'
  /** Allergens are surrounded by <0></0> elements. */
  | 'RAW'
  /** Allergens are returned without any delimiters. */
  | 'TEXT';

export type IntFieldValue = FieldValue & {
  /** The raw number as stored in the database. */
  rawText?: Maybe<Scalars['String']['output']>;
  /** The formatted number. */
  value?: Maybe<Scalars['Int']['output']>;
};

/**
 * A filter input type for Int fields.
 * Use to filter totalCount for example.
 */
export type IntQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type IntegerField = FormField & {
  /** The completion state for the component. */
  completionState?: Maybe<FormCompletionState>;
  /** The field's configuration. Dependent on the field type. */
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  /** The field's description, if any. */
  description?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  /** The field's unique identifier. */
  key: Scalars['ID']['output'];
  /** The field's label. */
  label: Scalars['String']['output'];
  /** @deprecated Experimental. */
  name?: Maybe<Scalars['String']['output']>;
  /** The field's type. */
  type: FormFieldType;
};


export type IntegerFieldDescriptionArgs = {
  locale: InterfaceLocale;
};


export type IntegerFieldLabelArgs = {
  locale: InterfaceLocale;
};

export type InterfaceLocale =
  | 'de'
  | 'en'
  | 'es'
  | 'fr'
  | 'it'
  | 'pt'
  | 'sk';

export type InternationalProductCertification = {
  /** @deprecated Use name instead. */
  certification?: Maybe<Scalars['String']['output']>;
  file?: Maybe<File>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the certification. */
  name?: Maybe<Scalars['String']['output']>;
};


export type InternationalProductCertificationNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type InviteCompanyInput = {
  /** The ID of the collection. */
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of the company to be added. */
  companyType?: InputMaybe<CompanyType>;
  /** The company country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The company email. */
  email: Scalars['String']['input'];
  /** The name of the company. */
  name: Scalars['String']['input'];
  /** UserId to set as owner. Otherwise, uses account associated with 'email' */
  owner?: InputMaybe<Scalars['ID']['input']>;
  /** Used to force company creation, although there is companies that matches the name, email or website. */
  skipVerification?: InputMaybe<Scalars['Boolean']['input']>;
  /** The company website. */
  website: Scalars['String']['input'];
};

export type InviteCompanyResponse = MutationResponse & {
  code: Scalars['String']['output'];
  company?: Maybe<Brand>;
  message: Scalars['String']['output'];
  possibleDuplicates?: Maybe<Array<Maybe<Brand>>>;
  registrationId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Item = {
  name?: Maybe<Scalars['String']['output']>;
};

export type Job = {
  cancelUrl?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processName?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** Length unit as defined in GS1 standards. */
export type LengthUnitCode =
  /** Centimetre */
  | 'CMT'
  /** Millimetre */
  | 'MMT'
  /** Metre */
  | 'MTR';

/** A length value including unit. */
export type LengthValue = {
  /** The length in a specific locale. */
  formattedValue: Scalars['String']['output'];
  unit: LengthUnitCode;
  value: Scalars['Float']['output'];
};


/** A length value including unit. */
export type LengthValueFormattedValueArgs = {
  format?: InputMaybe<NumberFormat>;
  locale: ContentLocale;
};

export type LifecycleState =
  | 'ACTION_REQUIRED'
  | 'COMPLETED'
  | 'OPEN';

/** A named list of products. */
export type List = {
  /** The list's unique id. */
  listId?: Maybe<Scalars['ID']['output']>;
  products: ProductConnection;
};


/** A named list of products. */
export type ListProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};

export type LiveFileConfigurationFields = {
  analysis?: Maybe<Scalars['Boolean']['output']>;
  basicInfo?: Maybe<Scalars['Boolean']['output']>;
  ean?: Maybe<Scalars['Boolean']['output']>;
  grapeVarieties?: Maybe<Scalars['Boolean']['output']>;
  group_awards?: Maybe<Scalars['Boolean']['output']>;
  group_certificates?: Maybe<Scalars['Boolean']['output']>;
  pairingDescription?: Maybe<Scalars['Boolean']['output']>;
  quality?: Maybe<Scalars['Boolean']['output']>;
  shortDescription?: Maybe<Scalars['Boolean']['output']>;
  temperature?: Maybe<Scalars['Boolean']['output']>;
  vineyardInformation?: Maybe<Scalars['Boolean']['output']>;
  vinification?: Maybe<Scalars['Boolean']['output']>;
  viticulture?: Maybe<Scalars['Boolean']['output']>;
  wineDescription?: Maybe<Scalars['Boolean']['output']>;
};

export type LiveInfoSheet = File & Item & {
  /** The relations to products, brands or collections where this file is used in. */
  attachedNodes: AttachedNodeConnection;
  brn: Scalars['String']['output'];
  /** The name calculated from the first attached product or brand, or the manual name. */
  calculatedTitle: Scalars['String']['output'];
  configurationFields?: Maybe<LiveFileConfigurationFields>;
  configurationId?: Maybe<Scalars['ID']['output']>;
  /** The actual, semantic type of content, such as bottle image, infosheet etc. */
  contentType?: Maybe<FileContentType>;
  /** A description of the file in long text format. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The file's general dimensions. If the file contains different sections with varying formats, the section dimensions can be queried on 'pages'.
   * @deprecated Not yet supported.
   */
  dimensions: FileDimensions;
  fileExtension?: Maybe<Scalars['String']['output']>;
  /** The unique file id. */
  fileId?: Maybe<Scalars['ID']['output']>;
  /** The filename used when downloading the file, without the file extension. Can be modified. */
  filename: Scalars['String']['output'];
  /** A fixed-size image. */
  fixed?: Maybe<CloudinaryFixed>;
  /** A fluid image with optional constraints. */
  fluid?: Maybe<CloudinaryFluid>;
  /** Indicates if the file is a default file and cannot be deleted. */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates if file is generated on the fly
   * @deprecated isLive will only be defined on the LiveFile type. Use '... on LiveFile { isLive }' instead.
   */
  isLive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The languages this file is in.
   * For images without language specific text, it may be empty.
   */
  languages?: Maybe<Array<Maybe<FileLanguage>>>;
  /** @deprecated Use the __typename instead. */
  linkedFile?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use title instead. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The version this file had before.
   * Currently we support only a single revision, so this is always null.
   */
  previousRevision?: Maybe<File>;
  productId?: Maybe<Scalars['ID']['output']>;
  publicId: Scalars['String']['output'];
  /** The status of the file (draft, released or archived). Only released files can be attached to other nodes. */
  releaseStatus: ReleaseStatus;
  /** "The URL to download the original file from." */
  sourceUrl: Scalars['String']['output'];
  /** A thumbnail with a predefined size. */
  thumbnail?: Maybe<CloudinaryFixed>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The manually set title. */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The URL to download the file.
   * This is often an optimized link served via a CDN or specialized service, such as Cloudinary.
   */
  url: Scalars['String']['output'];
};


export type LiveInfoSheetDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type LiveInfoSheetFixedArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  sizes?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type LiveInfoSheetFluidArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  sizes?: InputMaybe<Scalars['String']['input']>;
};


export type LiveInfoSheetThumbnailArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  sizes?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type LiveInfoSheetTitleArgs = {
  format?: InputMaybe<TextFormat>;
};

export type LocalProductCertification = {
  /** @deprecated Use name instead. */
  certification?: Maybe<Scalars['String']['output']>;
  file?: Maybe<File>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the certification. */
  name?: Maybe<Scalars['String']['output']>;
};


export type LocalProductCertificationNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type LocalizedData = {
  locale?: InputMaybe<ContentLocale>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Deprecated - use LocalizedText instead. */
export type LocalizedField = {
  locales?: Maybe<Array<Maybe<LocalizedFieldLocales>>>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Deprecated - use LocalizedText instead. */
export type LocalizedFieldLocales = {
  locale?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LocalizedInput = {
  locales?: InputMaybe<LocalizedTextInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedText = {
  bg?: Maybe<Scalars['String']['output']>;
  cs?: Maybe<Scalars['String']['output']>;
  da?: Maybe<Scalars['String']['output']>;
  de?: Maybe<Scalars['String']['output']>;
  ee?: Maybe<Scalars['String']['output']>;
  el?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  et?: Maybe<Scalars['String']['output']>;
  fi?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  ga?: Maybe<Scalars['String']['output']>;
  hr?: Maybe<Scalars['String']['output']>;
  hu?: Maybe<Scalars['String']['output']>;
  it?: Maybe<Scalars['String']['output']>;
  lt?: Maybe<Scalars['String']['output']>;
  lv?: Maybe<Scalars['String']['output']>;
  mt?: Maybe<Scalars['String']['output']>;
  nl?: Maybe<Scalars['String']['output']>;
  pl?: Maybe<Scalars['String']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
  ro?: Maybe<Scalars['String']['output']>;
  se?: Maybe<Scalars['String']['output']>;
  si?: Maybe<Scalars['String']['output']>;
  sk?: Maybe<Scalars['String']['output']>;
  sl?: Maybe<Scalars['String']['output']>;
  sv?: Maybe<Scalars['String']['output']>;
};

export type LocalizedTextInput = {
  bg?: InputMaybe<Scalars['String']['input']>;
  cs?: InputMaybe<Scalars['String']['input']>;
  da?: InputMaybe<Scalars['String']['input']>;
  de?: InputMaybe<Scalars['String']['input']>;
  ee?: InputMaybe<Scalars['String']['input']>;
  el?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  et?: InputMaybe<Scalars['String']['input']>;
  fi?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  ga?: InputMaybe<Scalars['String']['input']>;
  hr?: InputMaybe<Scalars['String']['input']>;
  hu?: InputMaybe<Scalars['String']['input']>;
  it?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lv?: InputMaybe<Scalars['String']['input']>;
  mt?: InputMaybe<Scalars['String']['input']>;
  nl?: InputMaybe<Scalars['String']['input']>;
  pl?: InputMaybe<Scalars['String']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
  ro?: InputMaybe<Scalars['String']['input']>;
  se?: InputMaybe<Scalars['String']['input']>;
  si?: InputMaybe<Scalars['String']['input']>;
  sk?: InputMaybe<Scalars['String']['input']>;
  sl?: InputMaybe<Scalars['String']['input']>;
  sv?: InputMaybe<Scalars['String']['input']>;
};

export type LongTextFormat =
  | 'HTML'
  | 'MARKDOWN'
  | 'RAW'
  | 'TEXT';

export type MarkRegistrationsAsInput = {
  /** The ID of the collection. */
  collectionId: Scalars['ID']['input'];
  /** The locked state. */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** The registrations ID's. */
  registrationIds: Array<Scalars['ID']['input']>;
  /** The registration status */
  registrationStatus?: InputMaybe<RegistrationStatus>;
};

export type MarkRegistrationsAsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MarketingActivity = {
  /** A textual description of the activity. Plain text with possibly multiple paragraphs. */
  description?: Maybe<Scalars['String']['output']>;
  /** The end date and time of the activity. */
  endDate?: Maybe<Scalars['String']['output']>;
  /** The latitude for activities with a physical location. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** A text describing the location. */
  location?: Maybe<Scalars['String']['output']>;
  /** The longitude for activities with a physical location. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** A short title. */
  name?: Maybe<Scalars['String']['output']>;
  /** The start date and time of the activity. */
  startDate?: Maybe<Scalars['String']['output']>;
  /** The type of activity, such as 'virtualTasting', 'localEvent' or 'b2match'. */
  type?: Maybe<Scalars['String']['output']>;
  /** An external link to the activity details. */
  url?: Maybe<Scalars['String']['output']>;
};


export type MarketingActivityUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};

export type MaximumProductsFormat =
  /** Will return the event maximum products if the registration maximum products is not defined. */
  | 'DEFAULT'
  /** Will return the registration maximum products. */
  | 'RAW';

export type MaximumProductsInput = {
  /** The maximum products. */
  maximumProducts?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the registration. */
  registrationId: Scalars['ID']['input'];
};

export type MeasurementSystem =
  | 'IMPERIAL'
  | 'METRIC';

export type MediaAsset = {
  /** A date in ISO format (e.g. 2020-01-01T15:00:00.000Z). */
  createdAt?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Meeting = {
  /** The attendee's profile. */
  attendee: SiteUserProfile;
  /** The attendee's ID. */
  attendeeId: Scalars['ID']['output'];
  /** When the meeting was initially requested. */
  createdAt: Scalars['String']['output'];
  /** The meeting duration in minutes. */
  durationInMinutes: Scalars['Int']['output'];
  /** The meeting location. */
  location?: Maybe<Scalars['String']['output']>;
  /** The organizer's profile. */
  organizer: SiteUserProfile;
  /** The organizer's ID. */
  organizerId: Scalars['ID']['output'];
  /** The meeting start date and time. */
  start: Scalars['String']['output'];
  /** The status of the meeting. */
  status: MeetingStatus;
  /** The globally unique id of the meeting. */
  uid: Scalars['ID']['output'];
};

export type MeetingAttendee = {
  /** The collection of this profile. */
  collection?: Maybe<Collection>;
  /** The collection ID of this profile. */
  collectionId?: Maybe<Scalars['ID']['output']>;
  /**
   * The user's company ID.
   * This links the user to an exhibiting company they are representing.
   */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** The user's company name. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Describes how the user prefers to be contacted. */
  contactMeVia?: Maybe<Array<SiteUserContactType>>;
  /** The user's display name. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The user's job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** The linkedIn profile URL. */
  linkedInURL?: Maybe<Scalars['String']['output']>;
  /** The profile image. */
  profileImage?: Maybe<CloudinaryAsset>;
  /**
   * The profile image URL.
   * @deprecated Use profileImageUrl instead.
   */
  profileImageURL?: Maybe<Scalars['String']['output']>;
  /** The profile image URL. */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<SingleRegistration>;
  /** The user's registrationId. Links the user to a particular registration. */
  registrationId?: Maybe<Scalars['ID']['output']>;
  representative?: Maybe<Contact>;
  /**
   * The user's company representative ID.
   * This links the user to a particular company representative.
   */
  representativeId?: Maybe<Scalars['ID']['output']>;
  /** The unique id of the profile. */
  uid: Scalars['ID']['output'];
};

export type MeetingResponse = MutationResponse & {
  code: Scalars['String']['output'];
  meeting?: Maybe<Meeting>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MeetingStatus =
  | 'BLOCKED'
  | 'CANCELED'
  | 'CONFIRMED'
  | 'TENTATIVE';

/** A potential timeslot for a meeting. */
export type MeetingTimeslot = {
  /** The collection of this meeting timeslot. */
  collection: Collection;
  /** The id of the event for this meeting timeslot. */
  collectionId: Scalars['ID']['output'];
  /** The human-readable date for the timeslot in the event location's timezone, such as Tuesday, March 21, 2023. */
  dateLabel: Scalars['String']['output'];
  /** The timeslot duration in minutes. */
  durationInMinutes: Scalars['Int']['output'];
  /**
   * The user's availability for this timeslot.
   * If null, we don't know but assume he's available.
   * If true, the user is available.
   * If false, the user has a meeting at this timeslot.
   */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** The timeslot meeting location. */
  location?: Maybe<Scalars['String']['output']>;
  /** The meetings for this timeslot. */
  meetings?: Maybe<Array<Maybe<Meeting>>>;
  /** The profile of the user that owns this timeslot, if any. */
  profile?: Maybe<SiteUserProfile>;
  /** The profile id of the user that owns this timeslot, if any. */
  profileId?: Maybe<Scalars['ID']['output']>;
  /**
   * The timeslot start date and time.
   * This also contains the event location's timezone offset.
   *
   * ATTENTION: For displaying the date, you most probably want to use the dateLabel and timeslotLabel fields instead because they always return the correct time.
   */
  start: Scalars['String']['output'];
  /** The label for the timeslot in the event location's timezone, such as 9:00-9:30. */
  timeslotLabel: Scalars['String']['output'];
};

export type MenuItem = {
  /** The title of the menu item. */
  name?: Maybe<Scalars['String']['output']>;
  /** The order of the menu item. */
  type?: Maybe<MenuItemType>;
  /** The URL of the menu item. */
  url?: Maybe<Scalars['String']['output']>;
};

export type MenuItemType =
  | 'default'
  | 'exhibitors'
  | 'otherUrl'
  | 'producers'
  | 'products';

export type MergeProductToELabelInput = {
  /** The ID of the eLabel. */
  elabelId: Scalars['ID']['input'];
  /** The ID of the product that will be merged. */
  productId: Scalars['ID']['input'];
  /** The merge strategy */
  strategy: MergeStrategy;
  /** The ID of the workspace. */
  workspaceId: Scalars['ID']['input'];
};

export type MergeProductToELabelResponse = MutationResponse & {
  code: Scalars['String']['output'];
  eLabel?: Maybe<ELabel>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};


export type MergeProductToELabelResponseELabelArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type MergeStrategy =
  /** Merge the e-label data with product data. */
  | 'MERGE'
  /** Replace the e-label data with product data. */
  | 'REPLACE';

/** A communication within Bottlebooks. */
export type Message = {
  /** If the communication happened within a collection, this returns the collection. */
  collection?: Maybe<Collection>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The company that changed the field. */
  company: CompanyProfile;
  /** The ISO date that this field was changed at. */
  date: Scalars['String']['output'];
  /** The ID of the communication. */
  messageId: Scalars['ID']['output'];
  /** The ID of the operation. Used to group a message sent for multiple people. */
  operationId: Scalars['String']['output'];
  /** The user who changed the field. */
  user: UserProfile;
};

export type MessageConnection = {
  edges: Array<MessageEdge>;
  /** Groups the messages by product or registration. */
  group: Array<MessageGroupConnection>;
  nodes: Array<Message>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type MessageConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: MessageField;
  filter?: InputMaybe<MessageFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<Message>;
  node: Message;
  previous?: Maybe<Message>;
};

export type MessageField =
  | 'companyId'
  | 'productId'
  | 'registrationId'
  | 'userId';

export type MessageFilterInput = {
  companyId?: InputMaybe<IdQueryOperatorInput>;
  messageId?: InputMaybe<IdQueryOperatorInput>;
  messageType?: InputMaybe<MessageTypeQueryOperatorInput>;
};

export type MessageGroupConnection = {
  edges: Array<MessageEdge>;
  fieldName: MessageField;
  fieldValue?: Maybe<Scalars['String']['output']>;
  /** Groups the messages by product, registration or other fields. */
  group: Array<MessageGroupConnection>;
  nodes: Array<Message>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type MessageGroupConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: MessageField;
  filter?: InputMaybe<MessageFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters on the messageType. */
export type MessageTypeQueryOperatorInput = {
  eq?: InputMaybe<ActivityType>;
  in?: InputMaybe<Array<InputMaybe<ActivityType>>>;
  ne?: InputMaybe<ActivityType>;
  nin?: InputMaybe<Array<InputMaybe<ActivityType>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type MessageUser = {
  brandId?: Maybe<Scalars['ID']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type MixedRegistrationConnection = RegistrationConnection & {
  edges: Array<RegistrationEdge>;
  /** Groups the registrations by a particular field. */
  group: Array<MixedRegistrationGroupConnection>;
  nodes: Array<Registration>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type MixedRegistrationConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: RegistrationGroupField;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};

export type MixedRegistrationGroupConnection = RegistrationGroupConnection & {
  edges: Array<RegistrationEdge>;
  fieldName: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  /** Groups the registrations by a particular field. */
  group: Array<MixedRegistrationGroupConnection>;
  nodes: Array<Registration>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type MixedRegistrationGroupConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: RegistrationGroupField;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};

export type MultiSelectField = FormField & {
  /** The completion state for the component. */
  completionState?: Maybe<FormCompletionState>;
  /** The field's configuration. Dependent on the field type. */
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  /** The field's description, if any. */
  description?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  /** The field's unique identifier. */
  key: Scalars['ID']['output'];
  /** The field's label. */
  label: Scalars['String']['output'];
  /** @deprecated Experimental. */
  name?: Maybe<Scalars['String']['output']>;
  /** The field's select options. */
  options: Array<ValidValue>;
  /** The field's type. */
  type: FormFieldType;
};


export type MultiSelectFieldDescriptionArgs = {
  locale: InterfaceLocale;
};


export type MultiSelectFieldLabelArgs = {
  locale: InterfaceLocale;
};


export type MultiSelectFieldOptionsArgs = {
  locale?: InputMaybe<InterfaceLocale>;
};

export type MultiSelectFieldValue = FieldValue & {
  /** The text as stored in the database. */
  rawText?: Maybe<Scalars['String']['output']>;
  /** The value as a list of texts. */
  value?: Maybe<Array<Scalars['String']['output']>>;
  values?: Maybe<Array<SelectFieldValue>>;
};


export type MultiSelectFieldValueValueArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

/** Deprecated - use FieldValueInput instead. */
export type MultipleCustomFieldInput = {
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  translations?: InputMaybe<LocalizedTextInput>;
  type: ELabelAssetType;
};

/** Deprecated - use ELabelFieldValue instead. */
export type MultipleField = {
  key: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Deprecated - use FieldValueInput instead. */
export type MultipleFieldInput = {
  key: Scalars['String']['input'];
  type: ELabelAssetType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  /**
   * Updates the import name.
   * Previously updateDataImportName"
   */
  DataImportUpdate: UpdateDataImportResponse;
  /** @deprecated unused – just added because empty types are not allowed. */
  _mutateDummy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Experimental. Use at your own risk! */
  _unstable_addProductToRegistrationViaQrCode: Unstable_UpdateAddProductToRegistrationViaQrCodeResponse;
  /** @deprecated Experimental. Use at your own risk! */
  _unstable_addProweinProductsToRegistration: Unstable_UpdateAddProweinProductsToRegistrationResponse;
  /**
   * Adds a response to the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_addQrCodeELabelResponse: Unstable_AddQrCodeELabelResponse;
  /**
   * Creates an image for the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_addQrCodeImage: Unstable_AddQrCodeImageResponse;
  /**
   * Adds a response to the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_addQrCodeWebsiteResponse: Unstable_AddQrCodeWebsiteResponse;
  /**
   * Adds related collection.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_addRelatedCollection: Unstable_AddRelatedCollectionResponse;
  /**
   * Claims a QR code previously shared with you.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_claimQrCode: Unstable_ClaimQrCodeResponse;
  /**
   * Converts a QR code created with E-Label dashboard to an output visible in portfolio.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_convertQrCodeToOutput: Unstable_ConvertQrCodeToOutputResponse;
  /**
   * Creates an elabel for the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_createELabel: Unstable_CreateELabelCodeResponse;
  /**
   * Creates an elabel and a qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_createELabelAndQrCode: Unstable_CreateELabelAndQrCodeResponse;
  /**
   * Creates an output for a product using a configuration.
   * This can be a output, e-label, info sheet, etc.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_createProductOutput: Unstable_CreateProductOutputResponse;
  /**
   * Creates a product with a QR code.
   *
   * Used for API integrations with clients.
   * @deprecated Experimental. Only used for client API.
   */
  _unstable_createProductWithQrCode: Unstable_CreateProductWithQrCodeResponse;
  /**
   * Creates a new QR code.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_createQrCode: Unstable_CreateQrCodeResponse;
  /**
   * Creates a new QR code.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_createQrCodeAsOutput: Unstable_CreateQrCodeAsOutputResponse;
  /**
   * Deletes a qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_deleteQrCode: Unstable_DeleteQrCodeResponse;
  /**
   * Sets the qrCode link for non european scans.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_deleteQrCodeResponse: Unstable__DeleteQrCodeResponse;
  /**
   * Makes a qrCode shareable or locked.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_makeQrCodeShareable: Unstable_MakeQrCodeShareableResponse;
  /**
   * Publishes a qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_publishQrCode: Unstable_PublishQrCodeResponse;
  /**
   * Publishes multiple qrCodes.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_publishQrCodes: Unstable_PublishQrCodesResponse;
  /**
   * Removes related collection.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_removeRelatedCollection: Unstable_RemoveRelatedCollectionResponse;
  /** @deprecated This will change in future. */
  _unstable_restoreProductVersion?: Maybe<RestoreProductVersionResponse>;
  /**
   * Restores a qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_restoreQrCode: Unstable_RestoreQrCodeResponse;
  /**
   * Sets the qrCode link for non european scans.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_setNonEUQrCodeLink: Unstable_SetNonEuQrCodeLink;
  /**
   * Sets a product's task's state.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_setProductTaskState: Unstable_SetProductTaskStateResponse;
  /**
   * Updates the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_updateQrCode: Unstable_UpdateQrCodeResponse;
  /**
   * Updates a website response in the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_updateQrCodeDefaultResponse: Unstable_UpdateQrCodeDefaultResponse;
  /**
   * Updates a e-label response in the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_updateQrCodeELabelResponse: Unstable__UpdateQrCodeELabelResponse;
  /**
   * Updates a e-label response in the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_updateQrCodeResponse: Unstable_UpdateQrCodeResponse;
  /**
   * Updates the given e-label responses in the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_updateQrCodeResponsesCountries: Unstable__UpdateQrCodeResponsesCountries;
  /**
   * Updates a website response in the qrCode.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_updateQrCodeWebsiteResponse: Unstable__UpdateQrCodeWebsiteResponse;
  /**
   * Adds brands as members of a group.
   * @deprecated Use addCompaniesRegistration instead
   */
  addBrandsToGroup: AddBrandsToGroupResponse;
  /** Adds companies as exhibitors of a collection. */
  addCompaniesRegistration: AddCompaniesRegistrationResponse;
  /** Registers a company in a collection. */
  addCompanyRegistration: AddCompanyRegistrationResponse;
  /** Creates a new file to a product or brand from the given url. */
  addExternalAsset: AddExternalAssetResponse;
  /** Creates a partner. */
  addPartnerAlias: UpdatePartnerResponse;
  /** Adds products to an existing product list. */
  addProductsToProductList?: Maybe<AddProductsToProductListResponse>;
  /** Adds products to registrations. */
  addProductsToRegistration?: Maybe<AddProductsToRegistrationResponse>;
  /**
   * Adds products to an existing product list.
   * @deprecated Use addProductsToProductList instead
   */
  addProductsToShareList?: Maybe<CreateProductListResponse>;
  /** Add a request to an existing registered product. */
  addRequestToRegisteredProduct?: Maybe<AddRequestToRegisteredProductResponse>;
  /** Add a product request */
  addRequestedProductToRegistration?: Maybe<AddRequestedProductToRegistrationResponse>;
  /** @deprecated Use addProductsToProductList instead */
  addToShareList?: Maybe<CreateProductListResponse>;
  /** Adds user to workspace. */
  addUserToWorkspace: AddUserToWorkspaceResponse;
  /** Adds an visitor to a site so that they can book meetings. */
  addVisitor: SiteUserProfileResponse;
  /** @deprecated Use setStatusMultipleProducts instead with the status ACTIVE/INACTIVE. */
  archiveMultipleProducts?: Maybe<ArchiveMultipleProductsResponse>;
  /** @deprecated Use setStatusMultipleProducts instead with the status ACTIVE/INACTIVE. */
  archiveProduct?: Maybe<ArchiveProductResponse>;
  /** Attaches an already existing file to a product or brand. */
  attachFile: AttachFileResponse;
  /** Block a timeslot. */
  blockTimeslot?: Maybe<BlockTimeslotResponse>;
  /** Cancel a meeting. */
  cancelMeeting?: Maybe<MeetingResponse>;
  /**
   * Moves a file within the attachments of a product or brand.
   * This may change the priority of files, for example being used as the "primary" info sheet.
   */
  changeFileOrder: AttachFileResponse;
  claimRepresentativeProfile: SiteUserProfileResponse;
  /**
   * Confirm an existing meeting.
   * Can only be issued by the attendee.
   */
  confirmMeeting?: Maybe<MeetingResponse>;
  /** Copies from configuration from one collection to another. */
  copyFormConfiguration: CopyFormConfigurationResponse;
  createDataFileJob?: Maybe<CreateDataFileJobResponse>;
  /**
   * Creates a new eLabel to the current brand.
   * @deprecated This mutation is deprecated. Create a QR code instead.
   */
  createELabel: CreateELabelResponse;
  /** Exports excel file with elabels analytics data. */
  createELabelsAnalyticsExportJob?: Maybe<ELabelJobExportResponse>;
  /** Exports excel file with elabels data. */
  createELabelsExportJob?: Maybe<ELabelJobExportResponse>;
  /** Exports excel file with elabels data. */
  createELabelsIngredientsStatementExportJob?: Maybe<ELabelJobExportResponse>;
  /** Creates a new group to the current brand. */
  createGroup: CreateGroupResponse;
  /** @deprecated fields argument is temporary solution. We will probably create Enum to make API more robust */
  createImagesDownloadJob?: Maybe<CreateImagesDownloadResponse>;
  createInfoSheetsFromFileJob?: Maybe<CreateInfoSheetsJobResponse>;
  createInfoSheetsJob?: Maybe<CreateInfoSheetsJobResponse>;
  createNewVintage?: Maybe<CreateNewVintageResponse>;
  /** Creates a exhibitor notification contact in a group. */
  createNotificationContact: EditContactResponse;
  /** Creates multiple notification contacts in a collection. */
  createNotificationContacts: CreateNotificationContactsResponse;
  createOrUpdateEventArea: CreateOrUpdateEventAreaResponse;
  /** Creates a partner. */
  createPartner: UpdatePartnerResponse;
  /** Creates a list of products to use internally. */
  createProductList?: Maybe<CreateProductListResponse>;
  createProductListJob?: Maybe<CreateProductListJobResponse>;
  createProductListJobConfiguration?: Maybe<CreateExportConfigurationResponse>;
  /**
   * Creates a qrcode asset
   * @deprecated Use createQrCodeAsset instead.
   */
  createQrCode?: Maybe<CreateQrCodeResponse>;
  /** Download exhibitor QR Codes */
  createQrCodeAsset?: Maybe<CreateQrCodeAssetResponse>;
  /** Download exhibitor QR Codes */
  createQrCodeDownloadJob?: Maybe<CreateQrCodeDownloadJobResponse>;
  /** Starts a payment session. */
  createStripeCheckoutSession: CreateStripeCheckoutSessionResponse;
  /**
   * Decline a meeting.
   * This is executed by the attendee.
   * If the organizer wants to cancel, use 'cancelMeeting' instead.
   */
  declineMeeting?: Maybe<MeetingResponse>;
  /** Marks the import as deleted. */
  deleteDataImport: UpdateDataImportResponse;
  /** Deletes a eLabel from the current brand. */
  deleteELabel: DeleteELabelResponse;
  deleteEventArea: DeleteEventAreaResponse;
  /** Detaches the configuration from the brand. */
  deleteInfoSheetConfiguration: DeleteInfoSheetConfigurationResponse;
  deleteMultipleProducts?: Maybe<DeleteMultipleProductsResponse>;
  /**
   * Deletes a product from the current brand's portfolio.
   *
   * It can't be added to new collections and portfolios any more.
   * This will not affect other brands' portfolios and collections directly.
   * If the current brand is the product's producer,
   * other brands will see a warning in their portfolio that this product has been deleted by the producer.
   * If the product is used in a collection, it will continue to exist in that collection.
   */
  deleteProduct?: Maybe<DeleteProductResponse>;
  deleteProductListJobConfiguration?: Maybe<DeleteExportConfigurationResponse>;
  /** Deletes product request */
  deleteRequestedProduct?: Maybe<DeleteRequestedProductResponse>;
  /** Deletes a visitor to a site so that they can book meetings. Warning: this can have unintended consequences if meetings have already been scheduled. */
  deleteVisitor: DeleteVisitorResponse;
  /** Detaches a file from product or brand. */
  detachFile: DetachFileResponse;
  /** Discards the draft changes. */
  discardELabelDraftChanges: DiscardELabelDraftChangesResponse;
  disconnectRegistrationRepresentativeProfile: SiteUserProfileResponse;
  duplicateProduct?: Maybe<DuplicateProductResponse>;
  /** Creates a new file to a product or brand from the given url. */
  editAsset: EditAssetResponse;
  /** Edits a exhibitor notification contact in a group. */
  editNotificationContact: EditContactResponse;
  /** Saves the options and triggers the import. */
  finalizeELabelsUpdateImport: FinalizeELabelsUpdateImportResponse;
  /** Saves the options and triggers the import. */
  finalizePartnerAliasImport: FinalizeAliasImportResponse;
  /** Saves the options and triggers the import. */
  finalizePortfolioProductExternalIdImport: FinalizePortfolioProductExternalIdImportResponse;
  /** Saves the options and triggers the import. */
  finalizeProductAllInOneImport: FinalizeProductAllInOneImportResponse;
  /** Saves the options and triggers the import. */
  finalizeProductCreationImport: FinalizeProductCreationImportResponse;
  /** Saves the options and triggers the import. */
  finalizeProductDataImport: FinalizeProductDataImportResponse;
  /** Saves the options and triggers the import. */
  finalizeProductExternalIdImport: FinalizeProductExternalIdImportResponse;
  /** Saves the options and triggers the import. */
  finalizeProductInternalIdImport: FinalizeProductInternalIdImportResponse;
  /** Saves the options and triggers the import. */
  finalizeProductListImport: FinalizeProductListImportResponse;
  /** Saves the options and triggers the import. */
  finalizeProductMasterListImport: FinalizeProductMasterListImportResponse;
  /** Saves the options and triggers the import. */
  finalizeProductMasterListSync: FinalizeProductMasterListSyncResponse;
  /** Saves the options and triggers the import. */
  finalizeProfileDataImport: FinalizeProfileDataImportResponse;
  /** @deprecated use createDataFileJob instead. */
  getMultiProductDataFile?: Maybe<CreateDataFileJobResponse>;
  /** @deprecated use createInfoSheetsJob instead. */
  getMultipleInfoSheets?: Maybe<CreateInfoSheetsJobResponse>;
  /** @deprecated use createDataFileJob instead. */
  getMultipleSpecSheets?: Maybe<CreateDataFileJobResponse>;
  /** Invites a company. */
  inviteCompany: InviteCompanyResponse;
  /** Saves the registration status and state to the given registration. */
  markRegistrationsAs: MarkRegistrationsAsResponse;
  /** Merges product information to an eLabel. */
  mergeProductToELabel: MergeProductToELabelResponse;
  /** Publishes the current eLabel. */
  publishELabel: PublishELabelResponse;
  /** Publishes the current eLabel. */
  publishELabelAsOutput: PublishELabelAsOutputResponse;
  /** Publishes the provided (old) version. */
  publishVersion: PublishVersionResponse;
  /** Add a product request */
  rejectRequestedProduct?: Maybe<RejectRequestedProductResponse>;
  /** Marks products as released and immutable. */
  releaseProducts: ReleaseProductsResponse;
  /** Removes a brand from a group. */
  removeBrandFromGroup: RemoveBrandFromGroupResponse;
  /** Adds products to registrations. */
  removeCompanyRegistration?: Maybe<RemoveCompanyRegistrationResponse>;
  /** Removes a exhibitor notification contact from a group. */
  removeNotificationContact: RemoveContactResponse;
  /** Removes a list of products. */
  removeProductList?: Maybe<RemoveProductListResponse>;
  /** Remove products from an existing product list. */
  removeProductsFromProductList?: Maybe<RemoveProductsFromProductListResponse>;
  /** Adds products to registrations. */
  removeProductsFromRegistration?: Maybe<RemoveProductsFromRegistrationResponse>;
  /** Removes the registrations. */
  removeRegistrations?: Maybe<RemoveRegistrationsResponse>;
  /** Allows users to request access to workspace. */
  requestAccessToWorkspace: RequestAccessToWorkspaceResponse;
  requestChat?: Maybe<RequestChatResponse>;
  /** Sends a meeting request to a site user. */
  requestMeeting?: Maybe<RequestMeetingResponse>;
  /** Reschedule a meeting and suggest another date and time. */
  rescheduleMeeting?: Maybe<MeetingResponse>;
  /** Restores an e-label. */
  restoreELabel: RestoreELabelResponse;
  /** Creates a new file to a product or brand from the given url. */
  saveInfoSheetConfiguration: SaveInfoSheetConfigurationResponse;
  /** Saves the given maximum products for each registration. */
  saveMaximumProducts: SaveMaximumProductsResponse;
  /** @deprecated This will change in future. */
  saveMultipleProductData?: Maybe<BulkSaveProductDataResponse>;
  /** @deprecated This will change in future. */
  saveProductData?: Maybe<SaveProductDataResponse>;
  /** Saves the given stand numbers for each registration. */
  saveStands: SaveStandsResponse;
  /** Sends contact request to exhibitor. */
  sendContactRequest?: Maybe<SendContactRequestResponse>;
  /** Sends message to exhibitors. */
  sendMessage?: Maybe<SendMessageResponse>;
  /** Sends message to a notification contact. */
  sendMessageToContacts?: Maybe<SendMessageResponse>;
  /** Sends message to the provided notification contacts of each given registration. */
  sendMessageToMultipleRegistrationContacts?: Maybe<SendMessageResponse>;
  /** Sends message to support. */
  sendMessageToSupport?: Maybe<SendMessageToSupportResponse>;
  /** @deprecated Use shareProductList instead */
  sendProductList?: Maybe<SendProductListResponse>;
  /** Sends contact request to exhibitor. */
  sendSampleRequest?: Maybe<SendSampleRequestResponse>;
  /** Sets a brand active in a group. */
  setBrandsActiveInGroup: SetBrandsActiveInGroupResponse;
  /** Sets a brand inactive in a group. */
  setBrandsInactiveInGroup: SetBrandsInactiveInGroupResponse;
  /** Set a custom field for a registered product. */
  setRegisteredProductCustomField: SetRegisteredProductCustomFieldResponse;
  /** Set a custom field for a registration. */
  setRegistrationCustomField: SetRegistrationCustomFieldResponse;
  setStatusMultipleProducts?: Maybe<SetStatusMultipleProductsResponse>;
  /** Shares a list of products publicly. */
  shareProductList?: Maybe<ShareProductListResponse>;
  /** Creates a share list shared by link. */
  shareProductListByLink?: Maybe<ShareProductListByLinkResponse>;
  /** Shares some products publicly. */
  shareProducts?: Maybe<ShareProductsResponse>;
  /** Shares some products publicly by link. */
  shareProductsByLink?: Maybe<ShareProductsByLinkResponse>;
  /** Shares a list again that was already shared. */
  shareShareList?: Maybe<ShareShareListResponse>;
  /** Skips a registration. */
  skipRegistration: SkipRegistrationResponse;
  /** Starts a registration. */
  startRegistration: StartRegistrationResponse;
  /** Marks products as submitted and immutable. */
  submitProducts: SubmitProductsResponse;
  /** @deprecated use archiveProducts or unarchiveProducts instead */
  toggleArchiveMultipleProducts?: Maybe<ArchiveMultipleProductsResponse>;
  /** @deprecated use archiveProduct or unarchiveProduct instead */
  toggleArchiveProduct?: Maybe<ArchiveProductResponse>;
  /** Updates a notification contact isLocked state. */
  toggleNotificationContactLock: ToggleNotificationContactLockResponse;
  /** @deprecated Use setStatusMultipleProducts instead with the status ACTIVE/INACTIVE. */
  unarchiveMultipleProducts?: Maybe<ArchiveMultipleProductsResponse>;
  /** @deprecated Use setStatusMultipleProducts instead with the status ACTIVE/INACTIVE. */
  unarchiveProduct?: Maybe<ArchiveProductResponse>;
  /** Unblock timeslot. */
  unblockTimeslot?: Maybe<UnblockTimeslotResponse>;
  /** Undeletes registrations. */
  undeleteRegistrations?: Maybe<UndeleteRegistrationsResponse>;
  /** Updates profiles in Firebase. Attendees include any user that has logged into Firebase. They can be representatives, visitors, or basic attendees. */
  updateAttendeeProfile: SiteUserProfileResponse;
  updateAttendeeProfileOwner: SiteUserProfileResponse;
  /**
   * Updates the sourceField to Bottlebooks field mapping.
   * Mappings that are not sent will not be updated. (TODO discuss if we should keep this.)
   * If you want to remove a mapping set the bottlebooksFieldName to null.
   */
  updateDataImportBottlebooksFields: UpdateDataImportResponse;
  /** Updates the import header row and data row indexes. */
  updateDataImportHeaderAndDataRows: UpdateDataImportResponse;
  /**
   * Updates the sourceField to Bottlebooks field mapping that identifies each row.
   * Mappings that are not sent will not be updated. (TODO discuss if we should keep this.)
   * If you want to remove a mapping set the bottlebooksFieldName to null.
   */
  updateDataImportIdentifierFields: UpdateDataImportResponse;
  /** Updates the suppliersMapping. */
  updateDataImportSuppliersMappings: UpdateDataImportResponse;
  /** Updates the valueMappings, that maps import values to bottlebooks valid values. */
  updateDataImportValueMappings: UpdateDataImportResponse;
  /** Edits an eLabel. */
  updateELabel: UpdateELabelResponse;
  /** Edits the eLabel settings. */
  updateELabelSettings: UpdateELabelResponse;
  /** Copies from configuration from one collection to another. */
  updateFormConfiguration: UpdateFormConfigurationResponse;
  updateProductListJobConfiguration?: Maybe<SaveExportConfigurationResponse>;
  updateRegistrationRepresentativeProfile: SiteUserProfileResponse;
  /** Add a product request */
  updateRequestedProduct?: Maybe<UpdateRequestedProductResponse>;
  /** Add the product id to the requested product */
  updateRequestedProductWithProductId?: Maybe<UpdateRequestedProductWithProductIdResponse>;
  /** Updates a user property. */
  updateUserProperty: UpdateUserPropertyResponse;
  /** Adds an visitor to a site so that they can book meetings. */
  updateVisitorProfile: SiteUserProfileResponse;
  updateWorkspaceConfiguration: UpdateWorkspaceConfigurationResponse;
  /** Uploads a file for importing it. */
  uploadDataImportFile: UploadDataImportFileResponse;
  /** Uploads a file and attaches it to a product or brand. */
  uploadFile: UploadFileResponse;
  /** Uploads a file and attaches it to a product or brand. */
  uploadFiles: UploadFilesResponse;
  /** Validates a VAT ID. */
  validateVatId: ValidateVatIdResponse;
};


export type MutationDataImportUpdateArgs = {
  input: DataImportUpdateInput;
};


export type Mutation_Unstable_AddProductToRegistrationViaQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_AddProductToRegistrationViaQrCodeInput;
};


export type Mutation_Unstable_AddProweinProductsToRegistrationArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_AddProweinProductsToRegistrationInput;
};


export type Mutation_Unstable_AddQrCodeELabelResponseArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_AddQrCodeELabelResponseInput;
};


export type Mutation_Unstable_AddQrCodeImageArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_AddQrCodeImage;
};


export type Mutation_Unstable_AddQrCodeWebsiteResponseArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_AddQrCodeWebsiteResponseInput;
};


export type Mutation_Unstable_AddRelatedCollectionArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_AddRelatedCollectionInput;
};


export type Mutation_Unstable_ClaimQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_ClaimQrCodeInput;
};


export type Mutation_Unstable_ConvertQrCodeToOutputArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_ConvertQrCodeToOutput;
};


export type Mutation_Unstable_CreateELabelArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_CreateELabelInput;
};


export type Mutation_Unstable_CreateELabelAndQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_CreateELabelAndQrCodeInput;
};


export type Mutation_Unstable_CreateProductOutputArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_CreateProductOutputInput;
};


export type Mutation_Unstable_CreateProductWithQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_CreateProductWithQrCodeInput;
  locale: ELabelLocale;
};


export type Mutation_Unstable_CreateQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_CreateQrCodeInput;
};


export type Mutation_Unstable_CreateQrCodeAsOutputArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_CreateQrCodeAsOutputInput;
};


export type Mutation_Unstable_DeleteQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_DeleteQrCodeInput;
};


export type Mutation_Unstable_DeleteQrCodeResponseArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_DeleteQrCodeResponseInput;
};


export type Mutation_Unstable_MakeQrCodeShareableArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_MakeQrCodeShareableInput;
};


export type Mutation_Unstable_PublishQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_PublishQrCodeInput;
};


export type Mutation_Unstable_PublishQrCodesArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_PublishQrCodesInput;
};


export type Mutation_Unstable_RemoveRelatedCollectionArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_RemoveRelatedCollectionInput;
};


export type Mutation_Unstable_RestoreProductVersionArgs = {
  experimentalKey: Scalars['String']['input'];
  productVersionId: Scalars['ID']['input'];
};


export type Mutation_Unstable_RestoreQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_RestoreQrCodeInput;
};


export type Mutation_Unstable_SetNonEuQrCodeLinkArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_SetNonEuQrCodeLinkInput;
};


export type Mutation_Unstable_SetProductTaskStateArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_SetProductTaskStateInput;
};


export type Mutation_Unstable_UpdateQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_UpdateQrCode;
};


export type Mutation_Unstable_UpdateQrCodeDefaultResponseArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_UpdateQrCodeDefaultResponseInput;
};


export type Mutation_Unstable_UpdateQrCodeELabelResponseArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_UpdateQrCodeELabelResponseInput;
};


export type Mutation_Unstable_UpdateQrCodeResponseArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_UpdateQrCodeResponseInput;
};


export type Mutation_Unstable_UpdateQrCodeResponsesCountriesArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_UpdateQrCodeResponsesCountriesInput;
};


export type Mutation_Unstable_UpdateQrCodeWebsiteResponseArgs = {
  experimentalKey: Scalars['String']['input'];
  input: Unstable_UpdateQrCodeWebsiteResponseInput;
};


export type MutationAddBrandsToGroupArgs = {
  input: AddBrandsToGroupInput;
};


export type MutationAddCompaniesRegistrationArgs = {
  input: AddCompaniesRegistrationInput;
};


export type MutationAddCompanyRegistrationArgs = {
  input: AddCompanyRegistrationInput;
};


export type MutationAddExternalAssetArgs = {
  input: AddExternalAssetInput;
};


export type MutationAddPartnerAliasArgs = {
  input: AddPartnerAliasInput;
};


export type MutationAddProductsToProductListArgs = {
  input: AddProductsToProductListInput;
};


export type MutationAddProductsToRegistrationArgs = {
  input: AddProductsToRegistrationInput;
};


export type MutationAddProductsToShareListArgs = {
  input: AddProductsToProductListInput;
};


export type MutationAddRequestToRegisteredProductArgs = {
  input: AddRequestToRegisteredProductInput;
};


export type MutationAddRequestedProductToRegistrationArgs = {
  input: AddRequestedProductToRegistrationInput;
};


export type MutationAddToShareListArgs = {
  productIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationAddUserToWorkspaceArgs = {
  input: AddUserToWorkspaceInput;
};


export type MutationAddVisitorArgs = {
  collectionId: Scalars['ID']['input'];
  input: AddVisitorInput;
};


export type MutationArchiveMultipleProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationArchiveProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationAttachFileArgs = {
  input: AttachFileInput;
};


export type MutationBlockTimeslotArgs = {
  collectionId: Scalars['ID']['input'];
  input: BlockTimeslotInput;
  organizerId: Scalars['ID']['input'];
};


export type MutationCancelMeetingArgs = {
  attendeeId: Scalars['ID']['input'];
  cancelToken: Scalars['String']['input'];
  collectionId: Scalars['ID']['input'];
  locale: ContentLocale;
  meetingId: Scalars['ID']['input'];
};


export type MutationChangeFileOrderArgs = {
  input: AttachFileInput;
};


export type MutationClaimRepresentativeProfileArgs = {
  collectionId: Scalars['ID']['input'];
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  registrationId: Scalars['ID']['input'];
  representativeId: Scalars['ID']['input'];
  uid: Scalars['ID']['input'];
};


export type MutationConfirmMeetingArgs = {
  attendeeId: Scalars['ID']['input'];
  collectionId: Scalars['ID']['input'];
  confirmToken: Scalars['String']['input'];
  locale: ContentLocale;
  meetingId: Scalars['ID']['input'];
};


export type MutationCopyFormConfigurationArgs = {
  input: CopyFormConfigurationInput;
};


export type MutationCreateDataFileJobArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  lang: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateELabelArgs = {
  input: CreateELabelInput;
};


export type MutationCreateELabelsAnalyticsExportJobArgs = {
  input?: InputMaybe<CreateELabelsAnalyticsJobInput>;
};


export type MutationCreateELabelsExportJobArgs = {
  input?: InputMaybe<CreateELabelsListJobInput>;
};


export type MutationCreateELabelsIngredientsStatementExportJobArgs = {
  input?: InputMaybe<CreateELabelsIngredientsStatementExportJobInput>;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateImagesDownloadJobArgs = {
  fields: Array<Scalars['String']['input']>;
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateInfoSheetsFromFileJobArgs = {
  configurationId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateInfoSheetsJobArgs = {
  brn: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateNewVintageArgs = {
  fullCopy?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['ID']['input'];
};


export type MutationCreateNotificationContactArgs = {
  input: CreateNotificationContactInput;
};


export type MutationCreateNotificationContactsArgs = {
  input: CreateNotificationContactsInput;
};


export type MutationCreateOrUpdateEventAreaArgs = {
  input: CreateOrUpdateEventAreaInput;
};


export type MutationCreatePartnerArgs = {
  input: CreatePartnerInput;
};


export type MutationCreateProductListArgs = {
  input: CreateProductListInput;
};


export type MutationCreateProductListJobArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  lang: Scalars['String']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCreateProductListJobConfigurationArgs = {
  fields: Array<InputMaybe<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};


export type MutationCreateQrCodeArgs = {
  input: CreateQrCodeInput;
};


export type MutationCreateQrCodeAssetArgs = {
  input: CreateQrCodeAssetInput;
};


export type MutationCreateQrCodeDownloadJobArgs = {
  input: CreateQrCodeDownloadJobInput;
};


export type MutationCreateStripeCheckoutSessionArgs = {
  input: CreateStripeCheckoutSessionInput;
};


export type MutationDeclineMeetingArgs = {
  attendeeToken: Scalars['String']['input'];
  collectionId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
};


export type MutationDeleteDataImportArgs = {
  input: DeleteDataImportInput;
};


export type MutationDeleteELabelArgs = {
  input: DeleteELabelInput;
};


export type MutationDeleteEventAreaArgs = {
  input: DeleteEventAreaInput;
};


export type MutationDeleteInfoSheetConfigurationArgs = {
  input: DeleteInfoSheetConfigurationInput;
};


export type MutationDeleteMultipleProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationDeleteProductListJobConfigurationArgs = {
  configurationId: Scalars['ID']['input'];
};


export type MutationDeleteRequestedProductArgs = {
  input: DeleteRequestedProductInput;
};


export type MutationDeleteVisitorArgs = {
  collectionId: Scalars['ID']['input'];
  visitorId: Scalars['ID']['input'];
};


export type MutationDetachFileArgs = {
  input: DetachFileInput;
};


export type MutationDiscardELabelDraftChangesArgs = {
  input: DiscardELabelDraftChangesInput;
};


export type MutationDisconnectRegistrationRepresentativeProfileArgs = {
  collectionId: Scalars['ID']['input'];
  uid: Scalars['String']['input'];
  updateToken: Scalars['String']['input'];
};


export type MutationDuplicateProductArgs = {
  name: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  vintage?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditAssetArgs = {
  input: EditAssetInput;
};


export type MutationEditNotificationContactArgs = {
  input: EditNotificationContactInput;
};


export type MutationFinalizeELabelsUpdateImportArgs = {
  input: FinalizeELabelsUpdateImportInput;
};


export type MutationFinalizePartnerAliasImportArgs = {
  input: FinalizeAliasImportInput;
};


export type MutationFinalizePortfolioProductExternalIdImportArgs = {
  input: FinalizePortfolioProductExternalIdImportInput;
};


export type MutationFinalizeProductAllInOneImportArgs = {
  input: FinalizeProductAllInOneImportInput;
};


export type MutationFinalizeProductCreationImportArgs = {
  input: FinalizeProductCreationImportInput;
};


export type MutationFinalizeProductDataImportArgs = {
  input: FinalizeProductDataImportInput;
};


export type MutationFinalizeProductExternalIdImportArgs = {
  input: FinalizeProductExternalIdImportInput;
};


export type MutationFinalizeProductInternalIdImportArgs = {
  input: FinalizeProductInternalIdImportInput;
};


export type MutationFinalizeProductListImportArgs = {
  input: FinalizeProductListImportInput;
};


export type MutationFinalizeProductMasterListImportArgs = {
  input: FinalizeProductMasterListImportInput;
};


export type MutationFinalizeProductMasterListSyncArgs = {
  input: FinalizeProductMasterListSyncInput;
};


export type MutationFinalizeProfileDataImportArgs = {
  input: FinalizeProfileDataImportInput;
};


export type MutationGetMultiProductDataFileArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationGetMultipleInfoSheetsArgs = {
  brn: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationGetMultipleSpecSheetsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationInviteCompanyArgs = {
  input: InviteCompanyInput;
};


export type MutationMarkRegistrationsAsArgs = {
  input: MarkRegistrationsAsInput;
};


export type MutationMergeProductToELabelArgs = {
  input: MergeProductToELabelInput;
};


export type MutationPublishELabelArgs = {
  input: PublishELabelInput;
};


export type MutationPublishELabelAsOutputArgs = {
  input: PublishELabelAsOutputInput;
};


export type MutationPublishVersionArgs = {
  input: PublishVersionInput;
};


export type MutationRejectRequestedProductArgs = {
  input: RejectRequestedProductInput;
};


export type MutationReleaseProductsArgs = {
  input: ReleaseProductsInput;
};


export type MutationRemoveBrandFromGroupArgs = {
  input: RemoveBrandFromGroupInput;
};


export type MutationRemoveCompanyRegistrationArgs = {
  input: RemoveCompanyRegistrationInput;
};


export type MutationRemoveNotificationContactArgs = {
  input: RemoveNotificationContactInput;
};


export type MutationRemoveProductListArgs = {
  input: RemoveProductListInput;
};


export type MutationRemoveProductsFromProductListArgs = {
  input?: InputMaybe<RemoveProductsFromProductListInput>;
};


export type MutationRemoveProductsFromRegistrationArgs = {
  input: RemoveProductsFromRegistrationInput;
};


export type MutationRemoveRegistrationsArgs = {
  input: RemoveRegistrationsInput;
};


export type MutationRequestAccessToWorkspaceArgs = {
  input: RequestAccessToWorkspaceInput;
};


export type MutationRequestChatArgs = {
  collectionId: Scalars['ID']['input'];
  input: RequestChatInput;
  locale: ContentLocale;
  senderId: Scalars['ID']['input'];
  senderToken: Scalars['String']['input'];
  useTestMode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRequestMeetingArgs = {
  collectionId: Scalars['ID']['input'];
  input: RequestMeetingInput;
  locale: ContentLocale;
  organizerId: Scalars['ID']['input'];
  updateToken: Scalars['String']['input'];
  useTestMode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRescheduleMeetingArgs = {
  input: RescheduleMeetingInput;
};


export type MutationRestoreELabelArgs = {
  input: RestoreELabelInput;
};


export type MutationSaveInfoSheetConfigurationArgs = {
  input: SaveInfoSheetConfigurationInput;
};


export type MutationSaveMaximumProductsArgs = {
  input: SaveMaximumProductsInput;
};


export type MutationSaveMultipleProductDataArgs = {
  input?: InputMaybe<Array<InputMaybe<BulkProductData>>>;
};


export type MutationSaveProductDataArgs = {
  input?: InputMaybe<ProductData>;
  productId: Scalars['ID']['input'];
  registrationId?: InputMaybe<Scalars['ID']['input']>;
  stringified?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveStandsArgs = {
  input: SaveStandsInput;
};


export type MutationSendContactRequestArgs = {
  input: SendContactRequestInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendMessageToContactsArgs = {
  input: SendMessageToContactsInput;
};


export type MutationSendMessageToMultipleRegistrationContactsArgs = {
  input: SendMessageToMultipleRegistrationContactsInput;
};


export type MutationSendMessageToSupportArgs = {
  input: SendMessageToSupportInput;
};


export type MutationSendProductListArgs = {
  email: Scalars['String']['input'];
  listId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendSampleRequestArgs = {
  input: SendSampleRequestInput;
};


export type MutationSetBrandsActiveInGroupArgs = {
  input: SetBrandsActiveInGroupInput;
};


export type MutationSetBrandsInactiveInGroupArgs = {
  input: SetBrandsInactiveInGroupInput;
};


export type MutationSetRegisteredProductCustomFieldArgs = {
  input: SetRegisteredProductCustomFieldInput;
};


export type MutationSetRegistrationCustomFieldArgs = {
  input: SetRegistrationCustomFieldInput;
};


export type MutationSetStatusMultipleProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
};


export type MutationShareProductListArgs = {
  input: ShareProductListInput;
};


export type MutationShareProductListByLinkArgs = {
  input: ShareProductListByLinkInput;
};


export type MutationShareProductsArgs = {
  input: ShareProductsInput;
};


export type MutationShareProductsByLinkArgs = {
  input: ShareProductsByLinkInput;
};


export type MutationShareShareListArgs = {
  input: ShareShareListInput;
};


export type MutationSkipRegistrationArgs = {
  input: SkipRegistrationInput;
};


export type MutationStartRegistrationArgs = {
  input: StartRegistrationInput;
};


export type MutationSubmitProductsArgs = {
  input: SubmitProductsInput;
};


export type MutationToggleArchiveMultipleProductsArgs = {
  archive: Scalars['Boolean']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationToggleArchiveProductArgs = {
  archive: Scalars['Boolean']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationToggleNotificationContactLockArgs = {
  input: ToggleNotificationContactLockInput;
};


export type MutationUnarchiveMultipleProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationUnarchiveProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationUnblockTimeslotArgs = {
  collectionId: Scalars['ID']['input'];
  input: UnblockTimeslotInput;
  organizerId: Scalars['ID']['input'];
};


export type MutationUndeleteRegistrationsArgs = {
  input: UndeleteRegistrationsInput;
};


export type MutationUpdateAttendeeProfileArgs = {
  collectionId: Scalars['ID']['input'];
  input: SiteUserProfileInput;
};


export type MutationUpdateAttendeeProfileOwnerArgs = {
  attendeeProfileId: Scalars['ID']['input'];
  collectionId: Scalars['ID']['input'];
  input: SiteUserProfileInput;
  updateToken: Scalars['String']['input'];
};


export type MutationUpdateDataImportBottlebooksFieldsArgs = {
  input: UpdateDataImportBottlebooksFieldsInput;
};


export type MutationUpdateDataImportHeaderAndDataRowsArgs = {
  input: UpdateDataImportHeaderAndDataRowsInput;
};


export type MutationUpdateDataImportIdentifierFieldsArgs = {
  input: UpdateDataImportIdentifierFieldsInput;
};


export type MutationUpdateDataImportSuppliersMappingsArgs = {
  input: UpdateDataSuppliersMappingsInput;
};


export type MutationUpdateDataImportValueMappingsArgs = {
  input: UpdateDataImportValueMappingsInput;
};


export type MutationUpdateELabelArgs = {
  input: UpdateELabelInput;
};


export type MutationUpdateELabelSettingsArgs = {
  input: UpdateELabelSettingsInput;
};


export type MutationUpdateFormConfigurationArgs = {
  input: UpdateFormConfigurationInput;
};


export type MutationUpdateProductListJobConfigurationArgs = {
  configurationId: Scalars['ID']['input'];
  fields: Array<InputMaybe<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};


export type MutationUpdateRegistrationRepresentativeProfileArgs = {
  collectionId: Scalars['ID']['input'];
  input: SiteUserProfileInput;
  registrationId: Scalars['ID']['input'];
  representativeId: Scalars['ID']['input'];
  updateToken: Scalars['String']['input'];
};


export type MutationUpdateRequestedProductArgs = {
  input: UpdateRequestedProductInput;
};


export type MutationUpdateRequestedProductWithProductIdArgs = {
  input: UpdateRequestedProductWithProductIdInput;
};


export type MutationUpdateUserPropertyArgs = {
  property: UserPropertyName;
  value: Scalars['String']['input'];
};


export type MutationUpdateVisitorProfileArgs = {
  collectionId: Scalars['ID']['input'];
  input: UpdateVisitorProfileInput;
};


export type MutationUpdateWorkspaceConfigurationArgs = {
  input: UpdateWorkspaceConfigurationInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationUploadDataImportFileArgs = {
  input: UploadDataImportFileInput;
};


export type MutationUploadFileArgs = {
  input: UploadFileInput;
};


export type MutationUploadFilesArgs = {
  input: UploadFilesInput;
};


export type MutationValidateVatIdArgs = {
  input: ValidateVatIdInput;
};

/** The minimal response every mutation must supply. Every mutation will also return the mutated data. */
export type MutationResponse = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** The search criteria for myPartner. */
export type MyPartnerFilterInput = {
  companyType?: InputMaybe<CompanyType>;
  countryCode?: InputMaybe<StringQueryOperatorInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type Next_GroupConnectionSortInput = {
  field: GroupConnectionSortField;
  order?: InputMaybe<SortOrder>;
};

export type Next_PageInfo = {
  count: Scalars['Int']['output'];
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Next_RegisteredProductConnection = {
  edges: Array<RegisteredProductEdge>;
  group: Array<Next_RegisteredProductGroupConnection>;
  nodes: Array<RegisteredProduct>;
  pageInfo: Next_PageInfo;
  totalCount: Scalars['Int']['output'];
};


export type Next_RegisteredProductConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: Next_RegisteredProductGroupField;
  filter?: InputMaybe<Next_RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};


export type Next_RegisteredProductConnectionNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Next_RegisteredProductFilterInput = {
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IdQueryOperatorInput>;
  registrationId?: InputMaybe<IdQueryOperatorInput>;
};

export type Next_RegisteredProductGroupConnection = {
  edges: Array<RegisteredProductEdge>;
  fieldName: Next_RegisteredProductGroupField;
  fieldValue: Scalars['String']['output'];
  group?: Maybe<Next_RegisteredProductConnection>;
  nodes: Array<RegisteredProduct>;
  pageInfo: Next_PageInfo;
  totalCount: Scalars['Int']['output'];
};


export type Next_RegisteredProductGroupConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: Next_RegisteredProductGroupField;
  filter?: InputMaybe<Next_RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};


export type Next_RegisteredProductGroupConnectionNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Next_RegisteredProductGroupField =
  /** Group by the company ID. */
  | 'companyId'
  /** Group by producer ID. */
  | 'producerId'
  /** Group by producer name. */
  | 'producer___name'
  /** Group by product ID. */
  | 'productId'
  | 'product___denomination'
  | 'product___isBiodynamic'
  | 'product___isCertifiedOrganic'
  | 'product___isOrganic'
  | 'product___isSustainable'
  | 'product___isVegan'
  | 'product___isVegetarian'
  /** Group by product name (including vintage). */
  | 'product___name'
  | 'product___primaryVarietyName'
  | 'product___regionName'
  /** Group by product shortName (excluding vintage). */
  | 'product___shortName'
  /** Group by product vintage. */
  | 'product___vintage'
  /** Group by wine color. */
  | 'product___wineColor'
  /** Group by registration ID. */
  | 'registrationId';

export type Next_RegisteredProductSortField =
  /** Sort by producer name. */
  | 'producer___name'
  /** Sort by product name (including vintage). */
  | 'product___name'
  /** Sort by product shortName (excluding vintage). */
  | 'product___shortName'
  /** Sort by vintage. */
  | 'product___vintage'
  | 'registrationId'
  /** The order the partner has sorted the products. This is the default sorting. */
  | 'registrationOrder';

export type Next_RegisteredProductSortInput = {
  fields: Array<Next_RegisteredProductSortField>;
  order?: InputMaybe<Array<SortOrder>>;
};

/**
 * A single node with a globally unique ID.
 * This is the Node interface as defined in the [Relay specification](https://relay.dev/docs/guides/graphql-server-specification/#object-identification).
 */
export type Node = {
  /** The globally unique id. */
  id: Scalars['ID']['output'];
};

export type NotificationContactInput = {
  /** The contact ID. */
  contactId?: InputMaybe<Scalars['ID']['input']>;
  /** The contact email. */
  email: Scalars['String']['input'];
  /** Should the contact be locked? */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberField = FormField & {
  /** The completion state for the component. */
  completionState?: Maybe<FormCompletionState>;
  /** The field's configuration. Dependent on the field type. */
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  /** The field's description, if any. */
  description?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  /** The field's unique identifier. */
  key: Scalars['ID']['output'];
  /** The field's label. */
  label: Scalars['String']['output'];
  /** @deprecated Experimental. */
  name?: Maybe<Scalars['String']['output']>;
  /** The field's type. */
  type: FormFieldType;
  /** @deprecated Use the value field on the FormComponent instead. */
  value?: Maybe<TextFieldValue>;
};


export type NumberFieldDescriptionArgs = {
  locale: InterfaceLocale;
};


export type NumberFieldLabelArgs = {
  locale: InterfaceLocale;
};

export type NumberFormat = {
  maximumFractionDigits?: InputMaybe<Scalars['Int']['input']>;
  maximumSignificantDigits?: InputMaybe<Scalars['Int']['input']>;
  minimumFractionDigits?: InputMaybe<Scalars['Int']['input']>;
  minimumSignificantDigits?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<NumberFormatStyle>;
  useGrouping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberFormatStyle =
  | 'decimal'
  | 'unit';

export type OnlineShop = {
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type OnlineShopCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type OnlineShopUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** A single day's opening hours. */
export type OpeningHoursSpecification = {
  /** The local time the place is closing at. */
  closingTime?: Maybe<Scalars['String']['output']>;
  /** The week day of the opening hours. */
  dayOfWeek: Scalars['String']['output'];
  /** The local time the place is opening at. */
  openingTime?: Maybe<Scalars['String']['output']>;
};


/** A single day's opening hours. */
export type OpeningHoursSpecificationClosingTimeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A single day's opening hours. */
export type OpeningHoursSpecificationDayOfWeekArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A single day's opening hours. */
export type OpeningHoursSpecificationOpeningTimeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type OutputState =
  /** The output is no longer in use, so it has been archived and won't be included in views. */
  | 'ARCHIVED'
  /**
   * The output hasn't been created yet, and some of the base fields are invalid.
   * The next step is to edit the fields.
   */
  | 'DRAFT_INVALID'
  /**
   * The output hasn't been created yet, but all of the base fields are valid.
   * The output is ready to be created.
   */
  | 'DRAFT_VALID'
  /**
   * The output is in use: It was sent to a customer, printed on a label, or submitted via a registration.
   * This should be the final state for every output (other than being archived).
   */
  | 'IN_USE'
  /**
   * The output is in use: It was sent to a customer, printed on a label, or submitted via a registration. Some of the base fields have been updated since, so we should create another version of the output.
   * The next step is to update the output to the most recent version, then use that instead.
   */
  | 'IN_USE_OUT_OF_SYNC'
  /**
   * The output creation process hasn't started yet.
   * This is typically the case if a product is not part of a collection.
   */
  | 'NOT_STARTED'
  /**
   * Some outputs have been created, and some of the base fields are invalid.
   * This state is only used as a state for multiple outputs.
   */
  | 'PARTIAL_INVALID'
  /**
   * Some outputs have been created, but some of the base fields have updated content.
   * This state is only used as a state for multiple outputs.
   */
  | 'PARTIAL_OUT_OF_SYNC'
  /**
   * Some outputs have been created, but all of the base fields are valid.
   * This state is only used as a state for multiple outputs.
   */
  | 'PARTIAL_VALID'
  /**
   * The output has been created, and all of the base fields are valid. It is not in use yet.
   * The next step is to send it to a customer, print it on a label, or submit it via a registration, which marks it as in use.
   */
  | 'PRE_MARKET'
  /**
   * The output has been created, and some of the base fields are invalid. It is not in use yet.
   * Not sure if we need this state at all.
   */
  | 'PRE_MARKET_INVALID'
  /**
   * The output has been created, but some of the base fields have updated content. It is not in use yet.
   * The next step is to update the output to the most recent version, then use it.
   */
  | 'PRE_MARKET_OUT_OF_SYNC';

export type OutputVisibility =
  /** The output is visible to the public. */
  | 'PUBLIC'
  /** The output is visible only to the collection's members. */
  | 'REGISTRATION';

/** The package type as defined in GS1 standards. */
export type PackageTypeCode =
  /** Intermediate bulk container, rigid plastic (RIBC) */
  | 'AA'
  /** Aerosol */
  | 'AE'
  /** Ampoule */
  | 'AM'
  /** Barrel */
  | 'BA'
  /** Bag in Box */
  | 'BBG'
  /** Bag */
  | 'BG'
  /** Bucket */
  | 'BJ'
  /** Basket */
  | 'BK'
  /** Berlingot (tetrahedral packaging for liquids) */
  | 'BL'
  /** Bottle */
  | 'BO'
  /** Blister pack */
  | 'BPG'
  /** Brick */
  | 'BRI'
  /** Box */
  | 'BX'
  /** Cage */
  | 'CG'
  /** Chub */
  | 'CHB'
  /** Card */
  | 'CM'
  /** Clam Shell */
  | 'CMS'
  /** Can/Tin */
  | 'CNG'
  /** Capsule */
  | 'CP'
  /** Cartridge */
  | 'CQ'
  /** Crate */
  | 'CR'
  /** Case */
  | 'CS'
  /** Carton */
  | 'CT'
  /** CupTub */
  | 'CU'
  /** Cylinder */
  | 'CY'
  /** Envelope */
  | 'EN'
  /** Gable Top */
  | 'GTG'
  /** Hanger */
  | 'HG'
  /** Jug */
  | 'JG'
  /** Jar */
  | 'JR'
  /** Multipack */
  | 'MPG'
  /** Not packed */
  | 'NE'
  /** Net */
  | 'NT'
  /** Pallet Box */
  | 'PB'
  /** Peel Pack */
  | 'PLP'
  /** Pouch */
  | 'PO'
  /** Pot */
  | 'PT'
  /** Tray */
  | 'PU'
  /** Packed, unspecified */
  | 'PUG'
  /** Pallet */
  | 'PX'
  /** Rack */
  | 'RK'
  /** Reel */
  | 'RL'
  /** Roll */
  | 'RO'
  /** Syringe */
  | 'SG'
  /** Stretchwrapped */
  | 'STR'
  /** Shrinkwrapped */
  | 'SW'
  /** Sleeve */
  | 'SY'
  /** Tube */
  | 'TU'
  /** Wire */
  | 'WIRE'
  /** Wrapper */
  | 'WRP'
  /** Banded package */
  | 'X11'
  /** Flexible Intermediate Bulk Container */
  | 'ZU';

export type PackagingComponent = {
  /** The packaging material. */
  material?: Maybe<ELabelMaterial>;
  /** The packaging recicled percentage. */
  percentageRecycled?: Maybe<Scalars['Float']['output']>;
  /** The packaging recycling process. */
  recyclingProcess?: Maybe<Array<Maybe<PackagingRecyclingProcess>>>;
  /** The packaging weight. */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PackagingComponentForm = {
  /** The packaging material. */
  material?: Maybe<ELabelMaterial>;
  /** The packaging recicled percentage. */
  percentageRecycled?: Maybe<Scalars['Float']['output']>;
  /** The packaging recycling process. */
  recyclingProcess?: Maybe<Array<Maybe<PackagingRecyclingProcess>>>;
  /** The packaging weight. */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PackagingComponentInput = {
  material?: InputMaybe<ELabelMaterialInput>;
  percentageRecycled?: InputMaybe<Scalars['Float']['input']>;
  /** The packaging recycling process. */
  recyclingProcess?: InputMaybe<Array<InputMaybe<PackagingRecyclingProcess>>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type PackagingRecyclingProcess =
  | 'COMPOSTABLE'
  | 'ENERGY_RECOVERABLE'
  | 'NOT_RECYCLABLE'
  | 'RECYCLABLE'
  | 'REUSABLE';

export type PageInfo = {
  count: Scalars['Int']['output'];
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParsedTextFormat =
  /** Text with resolver-specific formatting. */
  | 'PARSED'
  /** Original text. */
  | 'RAW';

export type Partner = {
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  brand: Brand;
  companyId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partnerId: Scalars['ID']['output'];
};

export type PartnerConnection = {
  edges: Array<PartnerEdge>;
  nodes: Array<Partner>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PartnerEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<Partner>;
  node: Partner;
  previous?: Maybe<Partner>;
};

export type PartnerFilterInput = {
  brandId?: InputMaybe<IdQueryOperatorInput>;
  country?: InputMaybe<StringQueryOperatorInput>;
};

export type PhysicalShop = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type PhysicalShopCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type PhysicalShopUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};

export type PortfolioProductExternalIdImportOptionsInput = {
  newProducts?: InputMaybe<Scalars['Boolean']['input']>;
  updateProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Price range settings for an event or collection */
export type PriceRange = {
  /** The customized title for the price range. */
  customTitle?: Maybe<Scalars['String']['output']>;
  /** The upper boundary of the price range. */
  maximumPrice?: Maybe<Scalars['Float']['output']>;
  /** The lower boundary of the price range. */
  minimumPrice?: Maybe<Scalars['Float']['output']>;
  /** The id for the price range. */
  rangeId: Scalars['String']['output'];
  /** The standard localized title for the price range. */
  standardTitle: Scalars['String']['output'];
  /**
   * A short symbol for the price range, to be used on lists.
   * This is often a currency symbol repeated, like $$$ or €€.
   * @deprecated Not yet implemented.
   */
  symbol?: Maybe<Scalars['String']['output']>;
  /** The resolved title for the price range. This is the standard title if custom title is not set. */
  title: Scalars['String']['output'];
};


/** Price range settings for an event or collection */
export type PriceRangeStandardTitleArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** Price range settings for an event or collection */
export type PriceRangeTitleArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type PriceStrategy =
  /** Exact pricing is collected for products in this collection. */
  | 'BY_PRICE'
  /** Pricing is collected in ranges for products in this collection. */
  | 'BY_PRICE_RANGE'
  /** Pricing is disabled for this collection. */
  | 'PRICING_DISABLED';

export type PrimaryContainerInput = {
  primaryContainerColor?: InputMaybe<SingleSelectionInput>;
  primaryContainerType?: InputMaybe<SingleSelectionInput>;
};

export type PrimaryPackaging = {
  /** The primary packaging capsule. */
  capsule?: Maybe<Array<Maybe<PackagingComponent>>>;
  /** The primary packaging. */
  closure?: Maybe<Array<Maybe<PackagingComponent>>>;
  /** The packaging container color. */
  containerColor?: Maybe<Scalars['String']['output']>;
  /** The packaging container type. */
  containerType?: Maybe<Scalars['String']['output']>;
  /** The primary packaging gift box. */
  giftBox?: Maybe<Array<Maybe<PackagingComponent>>>;
  /** The primary packaging label. */
  label?: Maybe<Array<Maybe<PackagingComponent>>>;
  /** The primary packaging muselet. */
  muselet?: Maybe<Array<Maybe<PackagingComponent>>>;
  /** The primary packaging container. */
  primaryContainer?: Maybe<Array<Maybe<PackagingComponent>>>;
};


export type PrimaryPackagingContainerColorArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type PrimaryPackagingContainerTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type PrimaryPackagingForm = {
  /** The primary packaging capsule. */
  capsule?: Maybe<Array<Maybe<PackagingComponentForm>>>;
  /** The primary packaging. */
  closure?: Maybe<Array<Maybe<PackagingComponentForm>>>;
  /** The packaging container color. */
  containerColor?: Maybe<SingleSelectionField>;
  /** The packaging container type. */
  containerType?: Maybe<SingleSelectionField>;
  /** The primary packaging gift box. */
  giftBox?: Maybe<Array<Maybe<PackagingComponentForm>>>;
  /** The primary packaging label. */
  label?: Maybe<Array<Maybe<PackagingComponentForm>>>;
  /** The primary packaging muselet. */
  muselet?: Maybe<Array<Maybe<PackagingComponentForm>>>;
  /** The primary packaging container. */
  primaryContainer?: Maybe<Array<Maybe<PackagingComponentForm>>>;
};

export type PrimaryPackagingInput = {
  capsule?: InputMaybe<Array<InputMaybe<PackagingComponentInput>>>;
  closure?: InputMaybe<Array<InputMaybe<PackagingComponentInput>>>;
  containerColor?: InputMaybe<SingleSelectionInput>;
  containerType?: InputMaybe<SingleSelectionInput>;
  giftBox?: InputMaybe<Array<InputMaybe<PackagingComponentInput>>>;
  label?: InputMaybe<Array<InputMaybe<PackagingComponentInput>>>;
  muselet?: InputMaybe<Array<InputMaybe<PackagingComponentInput>>>;
  primaryContainer?: InputMaybe<Array<InputMaybe<PackagingComponentInput>>>;
};

export type PrimaryProductPackaging = ProductPackaging & {
  /** The GTIN of the packaging level. */
  GTIN?: Maybe<Scalars['String']['output']>;
  /** A list of all net content declarations given. */
  allNetContents?: Maybe<Array<ContentValue>>;
  /**
   * The net weight of the container.
   * This is an alias for packageNetWeight.
   */
  containerNetWeight?: Maybe<WeightValue>;
  /**
   * The type of container, typically BO for bottle.
   * This is an alias for packageTypeCode.
   */
  containerTypeCode?: Maybe<PackageTypeCode>;
  /** The depth of the packaging. */
  depth?: Maybe<LengthValue>;
  /** The gross weight of the package including all contents. */
  grossWeight?: Maybe<WeightValue>;
  /** The height of the packaging. */
  height?: Maybe<LengthValue>;
  /** The type of packaging. */
  hierarchyTypeCode: ProductPackagingHierarchyType;
  /** Returns true if this is the base unit. */
  isBaseUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the dispatchable unit. */
  isDispatchableUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is an invoice unit. */
  isInvoiceUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the orderable unit. */
  isOrderableUnit?: Maybe<Scalars['Boolean']['output']>;
  /** The level of the packaging as specified in GS1 standards. */
  level: Scalars['Int']['output'];
  /** The net content. For primary packaging this is the net volume. */
  netContent?: Maybe<ContentValue>;
  /** All net content values. */
  netContents?: Maybe<Array<ContentValue>>;
  /**
   * The net volume of the container, such as 750ml for a standard wine bottle.
   * If the container's content is given as a volume, this is the same as netContent.
   */
  netVolume?: Maybe<VolumeValue>;
  /**
   * The net weight of the package without the contents.
   * This is the bottle weight, the case material weight or the net pallet weight.
   */
  packageNetWeight?: Maybe<WeightValue>;
  /** The package type as defined in GS1 standards. Typically BO for bottle. */
  packageTypeCode?: Maybe<PackageTypeCode>;
  /** The net weight of product itself without packaging. */
  productNetWeight?: Maybe<WeightValue>;
  /** The quantity of layers in the packaging. Typically the number of layers of a pallet. */
  quantityOfLayers?: Maybe<Scalars['Int']['output']>;
  /**
   * The quantity of the next lower level per layer in the packaging hierarchy.
   * For a pallet, this is the number of cases per layer.
   */
  quantityOfNextLowerLevelPerLayer?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of items of the next lower level in the packaging hierarchy.
   * For a case, this is the number of bottles in the case.
   */
  totalQuantityOfNextLowerLevel?: Maybe<Scalars['Int']['output']>;
  /** The trade item unit type as defined in GS1 standards. */
  tradeItemUnit?: Maybe<TradeItemUnitDescriptorCode>;
  /** The width of the packaging. */
  width?: Maybe<LengthValue>;
};


export type PrimaryProductPackagingAllNetContentsArgs = {
  unit?: InputMaybe<ContentUnitCode>;
};


export type PrimaryProductPackagingContainerNetWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type PrimaryProductPackagingDepthArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};


export type PrimaryProductPackagingGrossWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type PrimaryProductPackagingHeightArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};


export type PrimaryProductPackagingNetContentArgs = {
  unit?: InputMaybe<ContentUnitCode>;
};


export type PrimaryProductPackagingNetContentsArgs = {
  unit?: InputMaybe<ContentUnitCode>;
};


export type PrimaryProductPackagingNetVolumeArgs = {
  unit?: InputMaybe<VolumeUnitCode>;
};


export type PrimaryProductPackagingPackageNetWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type PrimaryProductPackagingProductNetWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type PrimaryProductPackagingWidthArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};

export type Producer = AbstractBrand & Item & Profile & {
  /** The companies Global Location Number (GLN). */
  GLN?: Maybe<Scalars['String']['output']>;
  /** Array of address elements ordered based on the conventions of the particular country. */
  address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The number of bottles of sparkling produced per year. */
  annualProductionSparkling?: Maybe<Scalars['Int']['output']>;
  /** The number of bottles of sparkling produced per year, formatted as a number if possible. */
  annualProductionSparklingText?: Maybe<Scalars['String']['output']>;
  /** The number of bottles of wine produced per year. */
  annualProductionWine?: Maybe<Scalars['Int']['output']>;
  /** The number of bottles of wine produced per year, formatted as a number if possible. */
  annualProductionWineText?: Maybe<Scalars['String']['output']>;
  /** The associations the profile is part of. */
  associations?: Maybe<Scalars['String']['output']>;
  /** The average yield. */
  averageYield?: Maybe<Scalars['Int']['output']>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  biodynamicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The link to book wine experiences, hospitality, lifestyle and outdoor experiences. */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['ID']['output'];
  /** The producer certifications. */
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  /** The city or village the brand is located at. */
  city?: Maybe<Scalars['String']['output']>;
  /** The people you can contact regarding this brand. */
  contacts?: Maybe<Array<BrandContact>>;
  /**
   * The level of content completeness a brand has.
   * It's mostly targeted towards the public profile.
   * The more complete a brand's content is, the more likely it is to be boosted in searches and lists.
   */
  contentLevel: Scalars['Int']['output'];
  /** The country of the profile. */
  country?: Maybe<Scalars['String']['output']>;
  /** A certain custom field, available on events and requests. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's value, available on events and requests.
   * This is a shortcut – If you need more, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields available on events and requests. */
  customFields?: Maybe<Array<CustomField>>;
  /**
   * A longer description of the brand.
   * For a shorter text, use shortDescription instead.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the brand's director.
   * @deprecated Use directorName instead.
   */
  director?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's director. */
  directorName?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently has distributors in. */
  distributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the distributor a brand currently has. */
  distributors?: Maybe<BrandDistributorConnection>;
  /** The brand's main contact email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The email to order products. */
  emailOrders?: Maybe<Scalars['String']['output']>;
  /** The id of the exhibitor presenting this producer's products at an event. Only set when queried on an event. */
  exhibitorId?: Maybe<Scalars['ID']['output']>;
  /**
   * The percentage this producer is exporting to other countries.
   * @deprecated Use exportPercentageText instead. This will throw an error if the value entered was not an integer.
   */
  exportPercentage?: Maybe<Scalars['Int']['output']>;
  /** The percentage this producer is exporting to other countries, in text format (as entered). */
  exportPercentageText?: Maybe<Scalars['String']['output']>;
  /** The brand's facebook account or URL. */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   * Files attached to this producer, such as logo and main brand image.
   * Filters aren't implemented yet.
   */
  files?: Maybe<FileConnection>;
  /** The year the brand was founded. */
  founded?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  hasAccommodation?: Maybe<Scalars['Boolean']['output']>;
  hasDiningFacilities?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a social compliance program? */
  hasSocialComplianceProgram?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a sustainability certification? */
  hasSustainabilityCertification?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use mainImage instead. */
  headerImage?: Maybe<CloudinaryAsset>;
  /** The hospitality options this brand offers. */
  hospitalityOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use galleryImages instead. */
  imageGallery?: Maybe<Array<ImageGallery>>;
  /** The brand's instagram account or URL. */
  instagram?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  isPro?: Maybe<Scalars['Boolean']['output']>;
  /** The languages spoken at the brand's information desk. */
  languagesSpoken?: Maybe<Array<Scalars['String']['output']>>;
  /** The latitude of the profile address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The lifestyle amenities this brand offers. */
  lifestyleOfferings?: Maybe<Array<Scalars['String']['output']>>;
  logo?: Maybe<CloudinaryAsset>;
  /** The longitude of the profile address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The main image of the profile, often showing people or the location. */
  mainImage?: Maybe<CloudinaryAsset>;
  marketing?: Maybe<Array<MarketingActivity>>;
  marketingActivityTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The name shown in the profile. */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Most values are not used any more. */
  offeringTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the brand's online shop. */
  onlineShop?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar shops where you can buy products of this brand. */
  onlineShops?: Maybe<Array<OnlineShop>>;
  /** The times that the business is open. */
  openingHours?: Maybe<Array<OpeningHoursSpecification>>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  organicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The outdoor experiences this brand offers. */
  outdoorExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * A brand's owner.
   * @deprecated Not ready for primetime yet. This will be renamed to company soon.
   */
  owner?: Maybe<CompanyProfile>;
  /** The name of the profile's owner. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar Wine shops where you can buy products of this brand. */
  physicalShops?: Maybe<Array<PhysicalShop>>;
  /** The planted area in hectares. */
  plantedArea?: Maybe<Scalars['Int']['output']>;
  /** The post code of the city the brand is located at. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /**
   * A part at the beginning of the producer's name that is not meant to distinguish it from other producers, e.g. "Bodega".
   * It is used to boost the rest of the name in searches.
   * It can also be displayed on a separate line when displaying the winery name.
   * This is completely optional.
   */
  prefix?: Maybe<Scalars['String']['output']>;
  /** The price ranges the profile's brand or company offers. */
  priceRanges?: Maybe<Array<PriceRange>>;
  producerId: Scalars['ID']['output'];
  products: ProductConnection;
  profileId: Scalars['ID']['output'];
  /** The region this company or brand belongs to. */
  region?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently seeking distributors for. */
  seekingDistributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** A short description of the brand. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The slug for the producer.
   * The name is used to generate the slug.
   * While the name is still in flux (for example for previews),
   * set the 'format' arg to ID to use the producerId.
   * useIdOnly is deprecated.
   */
  slug: Scalars['String']['output'];
  /** @deprecated Used for Bottlebooks Classic only. Use socialCompliancePrograms instead. */
  socialCompliance?: Maybe<Array<SocialComplianceProgram>>;
  /** The list of social compliance programs. */
  socialCompliancePrograms?: Maybe<Array<SocialComplianceProgram>>;
  /** The description of the typical soil type. */
  soilType?: Maybe<Scalars['String']['output']>;
  /**
   * The text to be used for sorting the brand in a list.
   * The name is also used for catalog indexes,
   * so a winery called "Bodegas Juan Carlos" could have a sortName of "Carlos, Juan, Bodegas" or "Carlos Juan".
   */
  sortName?: Maybe<Scalars['String']['output']>;
  /** The stand at an event. */
  stand?: Maybe<Stand>;
  /** The state/province of the profile. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** The street the brand is located in. */
  street?: Maybe<Scalars['String']['output']>;
  /**
   * A part at the end of the producer's name that is not meant to distinguish it from other producers, e.g. "Winery".
   * It is used to boost the rest of the name in searches.
   * It can also be displayed on a separate line when displaying the winery name.
   * This is completely optional.
   */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The list of social compliance programs. */
  sustainabilityCertifications?: Maybe<Array<SustainabilityCertification>>;
  /** The phone number of the profile. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The telephone number to order products. */
  telephoneOrders?: Maybe<Scalars['String']['output']>;
  /** The brand's twitter account or URL. */
  twitter?: Maybe<Scalars['String']['output']>;
  /** The list of typical varieties planted. */
  typicalVarieties?: Maybe<Array<Scalars['String']['output']>>;
  videos?: Maybe<Array<Video>>;
  /** The brand's main website. */
  website?: Maybe<Scalars['String']['output']>;
  /** The wine experiences this brand offers. */
  wineExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use winemakerName instead. */
  winemaker?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's winemaker. */
  winemakerName?: Maybe<Scalars['String']['output']>;
  /** The brand's youtube account or URL. */
  youtube?: Maybe<Scalars['String']['output']>;
};


export type ProducerGlnArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerAnnualProductionSparklingTextArgs = {
  allowInvalidNumbers?: Scalars['Boolean']['input'];
  asEntered?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<NumberFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type ProducerAnnualProductionWineTextArgs = {
  allowInvalidNumbers?: Scalars['Boolean']['input'];
  asEntered?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<NumberFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type ProducerAssociationsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type ProducerBiodynamicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ProducerCertificationsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerCityArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerCustomFieldArgs = {
  key: Scalars['String']['input'];
};


export type ProducerCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


export type ProducerDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type ProducerDirectorArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerDirectorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerDistributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BrandDistributorFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandDistributorSortInput>;
};


export type ProducerEmailArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ProducerEmailOrdersArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ProducerExportPercentageTextArgs = {
  format?: TextFormat;
};


export type ProducerFacebookArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ProducerFilesArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
  filter?: InputMaybe<BrandFileFilterInput>;
};


export type ProducerFoundedArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerHospitalityOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerInstagramArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ProducerLanguagesSpokenArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerLifestyleOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ProducerOrganicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ProducerOutdoorExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerOwnerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerPostalCodeArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};


export type ProducerRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerSeekingDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerShortDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type ProducerSlugArgs = {
  format?: InputMaybe<SlugFormat>;
  useIdOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProducerSortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerStateProvinceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerStreetArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerTelephoneArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


export type ProducerTelephoneOrdersArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


export type ProducerTwitterArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ProducerTypicalVarietiesArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type ProducerWineExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProducerWinemakerArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerWinemakerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type ProducerYoutubeArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** A list of producers that is sortable, filterable and can be paginated. */
export type ProducerConnection = AbstractBrandConnection & Connection & {
  edges: Array<ProducerEdge>;
  nodes: Array<Producer>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProducerEdge = AbstractBrandEdge & Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<Producer>;
  node: Producer;
  previous?: Maybe<Producer>;
};

export type ProducerFieldsEnum =
  | 'city'
  | 'country'
  | 'name'
  | 'postalCode'
  | 'producerId'
  | 'region';

export type ProducerFilterInput = {
  producerId?: InputMaybe<IdQueryOperatorInput>;
};

export type ProducerSortInput = {
  fields?: InputMaybe<Array<InputMaybe<ProducerFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrder>>>;
};

/** A product. */
export type Product = {
  /**
   * The GTIN of the product.
   *
   * Returns the GTIN of the first product variant.
   */
  GTIN?: Maybe<Scalars['String']['output']>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_childProducts: Array<Unstable_CoreProduct>;
  /**
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_packaging: Array<ProductPackaging>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_parentProduct?: Maybe<Unstable_CoreProduct>;
  /** @deprecated Don't use - will be deleted soon! */
  _unstable_parentProductDifferences: Array<ProductVersionChange>;
  /**
   * A list of private workspace-owned events.
   *
   * This can be used to get all the field configurations for a product to edit.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioConfigurations: Array<Event>;
  /**
   * A list of registeredProduct entries.
   * This can be used for collection-based Portfolio.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioRegisteredProducts: RegisteredProductConnection;
  /**
   * The primary packaging (typically a bottle).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_primaryPackaging?: Maybe<PrimaryProductPackaging>;
  /**
   * The secondary packaging (typically a case).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_secondaryPackaging?: Maybe<SecondaryProductPackaging>;
  /**
   * The tertiary packaging (typically a pallet).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_tertiaryPackaging?: Maybe<TertiaryProductPackaging>;
  /**
   * A product's workspace.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_workspace: Workspace;
  /** The measurement method of the total acidity. */
  acidityUnit?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage of alcohol actually measured.
   * This is the analytical value measured in the lab.
   * This value is normally not communicated, only for some professional tastings.
   */
  actualAlcohol?: Maybe<Scalars['Float']['output']>;
  /**
   * The percentage of alcohol as displayed on the label.
   * This is often rounded according to local regulations.
   */
  alcohol?: Maybe<Scalars['Float']['output']>;
  /** Utility function to get all allergens as a single line of text. */
  allergensText?: Maybe<Scalars['String']['output']>;
  animalProducts?: Maybe<Scalars['Boolean']['output']>;
  /** The color of the product. */
  apparentColor?: Maybe<Scalars['String']['output']>;
  /** The appearance description for this product. */
  appearanceDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity of the appearance. */
  appearanceIntensity?: Maybe<Scalars['String']['output']>;
  /** Floral hints on the aroma. */
  aromaFloral?: Maybe<Scalars['String']['output']>;
  /** Fruity notes on the aroma. */
  aromaFruit?: Maybe<Scalars['String']['output']>;
  /** The intensity of the aroma. */
  aromaIntensity?: Maybe<Scalars['String']['output']>;
  /** Spicy aspects of the aroma. */
  aromaSpice?: Maybe<Scalars['String']['output']>;
  /** Wooden scents on that product. */
  aromaWood?: Maybe<Scalars['String']['output']>;
  awards?: Maybe<Array<ProductAward>>;
  backLabelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use backLabelImage { url } instead. */
  backLabelImageUrl?: Maybe<Scalars['String']['output']>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  /** @deprecated Use biodynamicCertificate instead */
  biodynamicCertificateUrl?: Maybe<Scalars['String']['output']>;
  bottleImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use bottleImage { url } instead. */
  bottleImageUrl?: Maybe<Scalars['String']['output']>;
  bottleVariants?: Maybe<Array<ProductBottleVariant>>;
  /**
   * The bottles per case.
   *
   * Returns the bottles per case of the first packaging variant.
   */
  bottlesPerCase?: Maybe<Scalars['Int']['output']>;
  bottlingDate?: Maybe<Scalars['String']['output']>;
  /** The sugars per 100ml in grams. */
  carbohydrateSugars?: Maybe<Scalars['Float']['output']>;
  /** The carbohydrate per 100ml in grams. */
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  /**
   * The GTIN of the product case.
   *
   * Returns the GTIN of the first packaging variant.
   */
  caseGTIN?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<ProductCertification>>;
  characteristics?: Maybe<Array<Maybe<ProductCharacteristicEnum>>>;
  /** The profile of the importer, retailer or company behind the product. */
  companyProfile?: Maybe<CompanyProfile>;
  /** The product description target consumers. */
  consumerDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the consumer product variant (typically the vintage of a wine or any other information).
   * @deprecated Experimental - use at your own risk.
   */
  consumerProductVariant?: Maybe<Scalars['String']['output']>;
  containsCelery?: Maybe<Scalars['Boolean']['output']>;
  containsCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  containsEggs?: Maybe<Scalars['Boolean']['output']>;
  containsFish?: Maybe<Scalars['Boolean']['output']>;
  containsGluten?: Maybe<Scalars['Boolean']['output']>;
  containsLupin?: Maybe<Scalars['Boolean']['output']>;
  containsMilk?: Maybe<Scalars['Boolean']['output']>;
  containsMolluscs?: Maybe<Scalars['Boolean']['output']>;
  containsMustard?: Maybe<Scalars['Boolean']['output']>;
  containsNuts?: Maybe<Scalars['Boolean']['output']>;
  containsPeanuts?: Maybe<Scalars['Boolean']['output']>;
  containsSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  containsSoybeans?: Maybe<Scalars['Boolean']['output']>;
  containsSulfites?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A number describing the product's content completeness.
   * The guiding principle is that those pieces of content must be valuable to the majority of visitors.
   * Currently bottle image, alcohol, wine description, webshop, food pairing description
   * and product videos are fields that each raise the content level.
   * The content level calculation will change and mature over time, similar to the Google PageRank.
   */
  contentLevel: Scalars['Int']['output'];
  /** The country the product was produced in. */
  country?: Maybe<Scalars['String']['output']>;
  /** A certain custom field, available on events and requests. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's raw text.
   * This is the shortest path to a custom field's value and always returns the raw text.
   * If you need to get typed values and more metadata, use customField instead.
   */
  customFieldText?: Maybe<Scalars['String']['output']>;
  /**
   * A certain custom field's value, available on events and requests.
   * This is a shortcut – If you need more, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields available on events and requests. */
  customFields?: Maybe<Array<CustomField>>;
  /** The customized name of the region. */
  customRegion?: Maybe<Scalars['String']['output']>;
  /** The customized name of the subregion. */
  customSubregion?: Maybe<Scalars['String']['output']>;
  /**
   * An Excel document containing all the product data in a printable format,
   * also enabling data extraction and reuse.
   */
  dataFile?: Maybe<ProductDataFile>;
  /**
   * The name of the denomination. This extends the logic of regionName and
   * uses custom logic for specific regions such as Spain and Austria.
   */
  denomination?: Maybe<Scalars['String']['output']>;
  /** The product description for the trade. */
  description?: Maybe<Scalars['String']['output']>;
  /** The product's related e-labels. */
  eLabels: ELabelConnection;
  /** The energy value in kcal per 100ml. */
  energyKcal?: Maybe<Scalars['Float']['output']>;
  /** The energy value in kJ per 100ml. */
  energyKj?: Maybe<Scalars['Float']['output']>;
  /** The fat per 100ml in grams. */
  fat?: Maybe<Scalars['Float']['output']>;
  /** A list of content features that make this product more valuable to visitors than other products. */
  featuredContentTypes?: Maybe<Array<FeaturedProductContentType>>;
  fileLibrary?: Maybe<Array<ProductFileAttachment>>;
  /** Shows files attached to this product. */
  files?: Maybe<FileConnection>;
  /**
   * The list of fining agents used.
   * If null, the fining agents are not known.
   * If an empty array, there were no fining agents used.
   */
  finingAgents?: Maybe<Array<Scalars['String']['output']>>;
  /** The finish description for this product. */
  finishDescription?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  history?: Maybe<Array<Maybe<HistoryEntry>>>;
  /** A printable product info sheet as a PDF. */
  infoSheet?: Maybe<ProductInfoSheet>;
  ingredients?: Maybe<Array<ProductIngredient>>;
  /** Utility function to get all ingredients as a string. */
  ingredientsText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryAromas instead. */
  intenseAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryFlavors instead. */
  intenseFlavors?: Maybe<Array<Scalars['String']['output']>>;
  internationalCertifications?: Maybe<Array<InternationalProductCertification>>;
  /**
   * The inventory ID specific to the company.
   * @deprecated Use productExternalId instead.
   */
  inventoryId?: Maybe<Scalars['String']['output']>;
  /**
   * The secondary inventory ID specific to the company.
   * @deprecated Use productExternalId2 instead.
   */
  inventoryId2?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCelery instead. */
  isCelery?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCrustaceans instead. */
  isCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsEggs instead. */
  isEggs?: Maybe<Scalars['Boolean']['output']>;
  isFairtrade?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsFish instead. */
  isFish?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsGluten instead. */
  isGluten?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is this product free of genetically modified organisms?
   * "Not sure", "not asked" and "not answered" all resolve to null.
   */
  isGmoFree?: Maybe<Scalars['Boolean']['output']>;
  isKosher?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsLupin instead. */
  isLupin?: Maybe<Scalars['Boolean']['output']>;
  isMevushal?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMilk instead. */
  isMilk?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMolluscs instead. */
  isMolluscs?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMustard instead. */
  isMustard?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsNuts instead. */
  isNuts?: Maybe<Scalars['Boolean']['output']>;
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsPeanuts instead. */
  isPeanuts?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSesameSeeds instead. */
  isSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSoybeans instead. */
  isSoybeans?: Maybe<Scalars['Boolean']['output']>;
  isSustainable?: Maybe<Scalars['Boolean']['output']>;
  isVegan?: Maybe<Scalars['Boolean']['output']>;
  isVegetarian?: Maybe<Scalars['Boolean']['output']>;
  labelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use labelImage { url } instead. */
  labelImageUrl?: Maybe<Scalars['String']['output']>;
  localCertifications?: Maybe<Array<LocalProductCertification>>;
  /** Low / no alcohol statement. */
  lowNoAlcoholStatement?: Maybe<Scalars['String']['output']>;
  lwinId?: Maybe<Scalars['String']['output']>;
  /**
   * The amount of malic acid in grams/liter.
   * This value is not commonly communicated.
   */
  malicAcid?: Maybe<Scalars['Float']['output']>;
  /** Notes on how to market this wine. */
  marketingNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryAromas instead. */
  mildAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryFlavors instead. */
  mildFlavors?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  /** The nose description for this product. */
  noseDescription?: Maybe<Scalars['String']['output']>;
  onlineShop?: Maybe<Scalars['String']['output']>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  /** Awards not in the list of recognized awards. Free text. */
  otherAwards?: Maybe<Scalars['String']['output']>;
  /** All sustainability certifications not covered in localCertifications and internationalCertifications can be added as free text. */
  otherSustainabilityCertifications?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use productRange instead. */
  ownClassification?: Maybe<Scalars['String']['output']>;
  /** The packaging gas used. This is automatically included in ingredientsText. */
  packagingGasesFunction?: Maybe<Scalars['String']['output']>;
  packagingVariants?: Maybe<Array<ProductPackagingVariant>>;
  /** The food pairing description for this product. */
  pairingDescription?: Maybe<Scalars['String']['output']>;
  /** Food pairings that match well with the product. */
  pairings?: Maybe<Array<Scalars['String']['output']>>;
  /** The color of the product. */
  palateAcidity?: Maybe<Scalars['String']['output']>;
  /** The body of the product. */
  palateBody?: Maybe<Scalars['String']['output']>;
  /** The palate description for this product. */
  palateDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity on the palate. */
  palateIntensity?: Maybe<Scalars['String']['output']>;
  /** The tannins of the product. */
  palateTannins?: Maybe<Scalars['String']['output']>;
  /**
   * The GTIN of the pallet.
   *
   * Returns the pallet GTIN of the first packaging variant.
   */
  palletGTIN?: Maybe<Scalars['String']['output']>;
  /**
   * The list of permissions on the product.
   * @deprecated We're considering to replace the list of strings with particular fields to reduce the data load when you just need a few permissions.
   */
  permissionList?: Maybe<Array<ProductRolesEnum>>;
  permissions: ProductPermissions;
  pressAnecdotes?: Maybe<Scalars['String']['output']>;
  /** A list of primary aromas in the nose. */
  primaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of primary flavors on the palate. */
  primaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  /** The product's producer. */
  producer?: Maybe<Producer>;
  productCategory?: Maybe<ProductCategory>;
  /** productExternalId Should represent unique product ID specific to the company. Former inventoryId */
  productExternalId?: Maybe<Scalars['String']['output']>;
  /** productExternalId2 Should represent additional product ID specific to the company. Former inventoryId2 */
  productExternalId2?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productRange?: Maybe<Scalars['String']['output']>;
  productType: ProductType;
  /** The protein per 100ml in grams. */
  protein?: Maybe<Scalars['Float']['output']>;
  /**
   * The name that the customer is using internally to refer to this product.
   * @deprecated Experimental - use at your own risk.
   */
  referenceName?: Maybe<Scalars['String']['output']>;
  /**
   * The region the product was produced in.
   * This is one of the officialy recognized regions of the country.
   * Regions are often subdivided into subregions - that value can be found on Product.subregion.
   */
  region?: Maybe<Scalars['String']['output']>;
  /** The region hierarchy of a product, starting with country. */
  regionHierarchy?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The name of the subregion, region or country – whichever has a value:
   * - For products with subregion, the subregion is returned.
   * - For products with region only, the region is returned.
   * - For products with country, the country is returned.
   * - For products using custom names, the custom name is returned.
   */
  regionName?: Maybe<Scalars['String']['output']>;
  /** The sugar in grams/liter. */
  residualSugar?: Maybe<Scalars['Float']['output']>;
  /** The salt per 100ml in grams. */
  salt?: Maybe<Scalars['Float']['output']>;
  /** The saturates per 100ml in grams. */
  saturatedFat?: Maybe<Scalars['Float']['output']>;
  /** A list of secondary aromas in the nose. */
  secondaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of secondary flavors on the palate. */
  secondaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  shortName: Scalars['String']['output'];
  /**
   * A list of content features that make this product more valuable to visitors than other products.
   * The useIdOnly flag is deprecated, use format=ID instead.
   */
  slug: Scalars['String']['output'];
  status?: Maybe<ProductStatus>;
  /**
   * The product name in a structured format.
   * @deprecated Used internally only and not ready for production - use name instead.
   */
  structuredName?: Maybe<StructuredProductName>;
  /**
   * The subregion the product was produced in.
   * This is one of the officialy recognized subregions of the region.
   */
  subregion?: Maybe<Scalars['String']['output']>;
  suggestedCategory?: Maybe<ProductCategory>;
  sulfurAdded?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use otherSustainabilityCertifications instead. */
  sustainabilityCertificatesOther?: Maybe<Scalars['String']['output']>;
  sustainabilityId?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tastingNotes?: Maybe<Array<ProductTastingNote>>;
  /** The total acidity in grams/liter. */
  totalAcidity?: Maybe<Scalars['Float']['output']>;
  /** An ISO date when the product was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Shows the collections this product is used in. */
  usedIn?: Maybe<ProductUsedInConnection>;
  /** Shows the e-labels where this product is used in. */
  usedInELabels?: Maybe<ProductUsedInELabelsConnection>;
  /**
   * The name of the product variant (bottle size, closure or other differentiating factor?
   * @deprecated Experimental - use at your own risk.
   */
  variantName?: Maybe<Scalars['String']['output']>;
  /** Product videos (Youtube, Vimeo, Instagram, Facebook etc.) */
  videos?: Maybe<Array<Maybe<Video>>>;
  /** The volume of each portion. */
  volumeOfPortion?: Maybe<Scalars['Float']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


/** A product. */
export type ProductGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


/** A product. */
export type Product_Unstable_ChildProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type Product_Unstable_PackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type Product_Unstable_ParentProductArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type Product_Unstable_ParentProductDifferencesArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type Product_Unstable_PortfolioConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type Product_Unstable_PortfolioRegisteredProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type Product_Unstable_PrimaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type Product_Unstable_SecondaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type Product_Unstable_TertiaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type Product_Unstable_WorkspaceArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A product. */
export type ProductAcidityUnitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductApparentColorArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductAppearanceDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A product. */
export type ProductAppearanceIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductAromaFloralArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductAromaFruitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductAromaIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductAromaSpiceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductAromaWoodArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductBottlingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** A product. */
export type ProductCaseGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


/** A product. */
export type ProductConsumerDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A product. */
export type ProductConsumerProductVariantArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A product. */
export type ProductCustomFieldArgs = {
  key: Scalars['String']['input'];
};


/** A product. */
export type ProductCustomFieldTextArgs = {
  key: Scalars['String']['input'];
};


/** A product. */
export type ProductCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


/** A product. */
export type ProductCustomRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductCustomSubregionArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductDataFileArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A product. */
export type ProductDenominationArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A product. */
export type ProductDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A product. */
export type ProductELabelsArgs = {
  filter?: InputMaybe<ELabelFilterInput>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


/** A product. */
export type ProductFilesArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
  filter?: InputMaybe<ProductFileFilterInput>;
};


/** A product. */
export type ProductFiningAgentsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductFinishDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A product. */
export type ProductHistoryArgs = {
  filter?: InputMaybe<ProductHistoryFilterInput>;
};


/** A product. */
export type ProductInfoSheetArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<ContentLocale>;
};


/** A product. */
export type ProductIngredientsTextArgs = {
  format?: InputMaybe<IngredientsTextFormat>;
};


/** A product. */
export type ProductIntenseAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductIntenseFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductInventoryIdArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductInventoryId2Args = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductMildAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductMildFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductNameArgs = {
  format?: InputMaybe<TextFormat>;
  includeProducer?: InputMaybe<IncludeProducer>;
};


/** A product. */
export type ProductNoseDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A product. */
export type ProductOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A product. */
export type ProductOtherAwardsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A product. */
export type ProductOtherSustainabilityCertificationsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A product. */
export type ProductPackagingGasesFunctionArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductPairingDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A product. */
export type ProductPairingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductPalateAcidityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductPalateBodyArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductPalateDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A product. */
export type ProductPalateIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductPalateTanninsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductPalletGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


/** A product. */
export type ProductPressAnecdotesArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductPrimaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductPrimaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductProductCategoryArgs = {
  withSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A product. */
export type ProductProductExternalIdArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductProductExternalId2Args = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductProductRangeArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductReferenceNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductRegionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A product. */
export type ProductRegionHierarchyArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A product. */
export type ProductRegionNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A product. */
export type ProductSecondaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductSecondaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A product. */
export type ProductShortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductSlugArgs = {
  format?: InputMaybe<SlugFormat>;
  useIdOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A product. */
export type ProductStructuredNameArgs = {
  algorithm?: InputMaybe<Scalars['String']['input']>;
};


/** A product. */
export type ProductSubregionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A product. */
export type ProductTaglineArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductUsedInArgs = {
  filter?: InputMaybe<ProductUsedInFilterInput>;
};


/** A product. */
export type ProductVariantNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A product. */
export type ProductWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** An activity on a product. */
export type ProductActivity = {
  /** The activity ID. */
  activityId: Scalars['ID']['output'];
  /** If the product was changed within a collection, this returns the collection. */
  collection?: Maybe<Collection>;
  /** The optional name of the collection where a product activity happened. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The product on which the activity was happening. */
  product: Product;
};

/** An activity describing a product was added to a collection. */
export type ProductAddToCollectionActivity = Activity & ProductActivity & RegistrationActivity & {
  /** The ID of the activity. */
  activityId: Scalars['ID']['output'];
  /** The type of activity. */
  activityType: ActivityType;
  /** The collection the product was added to. */
  collection: Collection;
  /** The name of the collection the product was added to. */
  collectionName: Scalars['String']['output'];
  /** The company that changed the field. */
  company: CompanyProfile;
  /** The ISO date that this product was added at. */
  date: Scalars['String']['output'];
  /** The ID of the operation. */
  operationId: Scalars['String']['output'];
  /**
   * The product that was added.
   * @deprecated Use registeredProduct instead (TODO implement).
   */
  product: Product;
  /** The registration on which the activity was happening. */
  registration: SingleRegistration;
  /** The user and brand who added the product. */
  user: UserProfile;
};

export type ProductAddToCollectionHistoryEntry = HistoryEntry & ProductHistoryEntry & {
  changeId: Scalars['ID']['output'];
  /** The type of change made. */
  changeType?: Maybe<HistoryEntryType>;
  /** The ISO date that this field was changed at. */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** The user and brand who changed the field. */
  changedBy?: Maybe<ChangedBy>;
  /** The name of the collection where this field was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The product that was added. */
  product: Product;
};

export type ProductAllInOneImportOptionsInput = {
  newProducts?: InputMaybe<Scalars['Boolean']['input']>;
  updateProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An award given to a product. */
export type ProductAward = {
  award?: Maybe<Scalars['String']['output']>;
  medal?: Maybe<Scalars['String']['output']>;
};


/** An award given to a product. */
export type ProductAwardAwardArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** An award given to a product. */
export type ProductAwardMedalArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type ProductBottleVariant = {
  GTIN?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<Scalars['String']['output']>;
  bottleDiameter?: Maybe<Scalars['Float']['output']>;
  bottleHeight?: Maybe<Scalars['Float']['output']>;
  bottleMaterial?: Maybe<Scalars['String']['output']>;
  bottleNetWeight?: Maybe<Scalars['Float']['output']>;
  bottleShape?: Maybe<Scalars['String']['output']>;
  bottleSize?: Maybe<Scalars['String']['output']>;
  bottleWeight?: Maybe<Scalars['Float']['output']>;
  capsuleMaterial?: Maybe<Scalars['String']['output']>;
  capsuleWeight?: Maybe<Scalars['Float']['output']>;
  closureType?: Maybe<Scalars['String']['output']>;
  closureWeight?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use GTIN instead. */
  eanBottle?: Maybe<Scalars['String']['output']>;
  euCommodityCode?: Maybe<Scalars['String']['output']>;
  giftPackagingMaterial?: Maybe<Scalars['String']['output']>;
  giftPackagingWeight?: Maybe<Scalars['Float']['output']>;
  internalId?: Maybe<Scalars['String']['output']>;
  labelMaterial?: Maybe<Scalars['String']['output']>;
  labelWeight?: Maybe<Scalars['Float']['output']>;
  museletWeight?: Maybe<Scalars['Float']['output']>;
  otherBottleNotes?: Maybe<Scalars['String']['output']>;
  productionSize?: Maybe<Scalars['String']['output']>;
};


export type ProductBottleVariantGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type ProductBottleVariantBottleSizeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProductBottleVariantClosureTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

/** A brand-specific categorization for product. */
export type ProductCategory = {
  description?: Maybe<Scalars['String']['output']>;
  isSuggested?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  productCategoryId?: Maybe<Scalars['ID']['output']>;
  sortOrder: Scalars['Int']['output'];
  status?: Maybe<ProductCategoryStatus>;
};

export type ProductCategoryStatus =
  /** Products are locked in position so they can't be accidentally removed or change position. Draft products can be added and moved however. */
  | 'ACTIVE'
  /** Products can be freely added and moved within the category. */
  | 'DRAFT'
  /** No products can be added or moved, but products can be removed from this category. */
  | 'INACTIVE';

export type ProductCertification = {
  /** @deprecated Use name instead. */
  certification?: Maybe<Scalars['String']['output']>;
  /** The certification's description. */
  description?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the certification. */
  name?: Maybe<Scalars['String']['output']>;
};


export type ProductCertificationNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

/** An activity describing a product change, possibly within a collection. */
export type ProductChangeActivity = Activity & ProductActivity & {
  /** The ID of the activity. */
  activityId: Scalars['ID']['output'];
  /** The type of change made. */
  activityType: ActivityType;
  /** The collection the product was changed at. */
  collection?: Maybe<Collection>;
  /** The name of the collection where this product was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The company that changed the field. */
  company: CompanyProfile;
  /** The ISO date that this product was changed at. */
  date: Scalars['String']['output'];
  /** The ID of the operation. */
  operationId: Scalars['String']['output'];
  /** The product that was changed. */
  product: Product;
  /** The user and brand who changed the product. */
  user: UserProfile;
};

export type ProductChangeHistoryEntry = HistoryEntry & ProductHistoryEntry & {
  changeId: Scalars['ID']['output'];
  /** The type of change made. */
  changeType?: Maybe<HistoryEntryType>;
  /** The ISO date that this product was changed at. */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** The user and brand who changed the product. */
  changedBy?: Maybe<ChangedBy>;
  /** The name of the collection where this product was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The product that was changed. */
  product: Product;
};

export type ProductCharacteristicEnum =
  | 'ACTIVE'
  | 'BIODYNAMIC'
  | 'DRAFT'
  | 'FORTIFIED'
  | 'INACTIVE'
  | 'KOSHER'
  | 'ORANGE'
  | 'ORGANIC'
  | 'PEARLWINE'
  | 'PRIVATE'
  | 'PUBLIC'
  | 'RED'
  | 'ROSE'
  | 'SPARKLING'
  | 'SUSTAINABLE'
  | 'VEGAN'
  | 'VEGETARIAN'
  | 'WHITE'
  | 'WINE';

/** A list of products that is sortable, filterable and can be paginated. */
export type ProductConnection = {
  edges: Array<ProductEdge>;
  group: Array<ProductGroupConnection>;
  nodes: Array<Product>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A list of products that is sortable, filterable and can be paginated. */
export type ProductConnectionGroupArgs = {
  field: ProductGroupField;
};

export type ProductCreationImportOptionsInput = {
  newProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductData = {
  appearanceDescription?: InputMaybe<Array<InputMaybe<LocalizedData>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  noseDescription?: InputMaybe<Array<InputMaybe<LocalizedData>>>;
  palateDescription?: InputMaybe<Array<InputMaybe<LocalizedData>>>;
  region?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<Scalars['String']['input']>;
  vintage?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDataFile = {
  /** A date in ISO format (e.g. 2020-01-01T15:00:00.000Z). */
  createdAt?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ProductDataImportOptionsInput = {
  updateProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductDataVersionDetailsInput = {
  isReleased?: InputMaybe<BooleanQueryOperatorInput>;
  isSubmitted?: InputMaybe<BooleanQueryOperatorInput>;
  /** Use ISO dates as the criteria (e.g. { gt: "2021-07-22T15:30:00.000Z" }). */
  releasedAt?: InputMaybe<DateQueryOperatorInput>;
  /** Use ISO dates as the criteria (e.g. { gt: "2021-07-22T15:30:00.000Z" }). */
  submittedAt?: InputMaybe<DateQueryOperatorInput>;
};

export type ProductEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<Product>;
  node: Product;
  previous?: Maybe<Product>;
};

export type ProductExternalIdImportOptionsInput = {
  newRequests?: InputMaybe<Scalars['Boolean']['input']>;
  updateRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductField = {
  key: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductFieldValidation = {
  errors?: Maybe<Array<Maybe<ProductUpdateError>>>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  originalValue?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProductFileAttachment = {
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductFileFilterInput = {
  contentType?: InputMaybe<StringQueryOperatorInput>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<StringQueryOperatorInput>;
};

export type ProductFilterInput = {
  producerId?: InputMaybe<IdQueryOperatorInput>;
  productId?: InputMaybe<IdQueryOperatorInput>;
  productType?: InputMaybe<ProductTypeQueryOperatorInput>;
  shortName?: InputMaybe<StringQueryOperatorInput>;
  status?: InputMaybe<ProductStatusQueryOperatorInput>;
  /**
   * Filters on the product's last update date.
   * Use ISO dates as the criteria (e.g. { gt: "2021-07-22T15:30:00.000Z" }).
   */
  updatedAt?: InputMaybe<DateQueryOperatorInput>;
  vintage?: InputMaybe<StringQueryOperatorInput>;
};

export type ProductGrapeVariety = {
  /**
   * The percentage of this variety.
   * If it's unset, it usually means that this product consists of least 85% of this variety (regional regulations may require stricter limits though).
   * If it's set to 100%, the product must consist of this grape only.
   */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** The name of the grape variety. */
  varietyName: Scalars['String']['output'];
};


export type ProductGrapeVarietyVarietyNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type ProductGrapeVarietyInput = {
  /**
   * The percentage of this variety.
   * If it's unset, it usually means that this product consists of least 85% of this variety (regional regulations may require stricter limits though).
   * If it's set to 100%, the product must consist of this grape only.
   */
  percentage?: InputMaybe<Scalars['Float']['input']>;
  /** The name of the grape variety. */
  varietyName?: InputMaybe<Scalars['String']['input']>;
};

/** A list of grouped products. */
export type ProductGroupConnection = {
  edges: Array<ProductEdge>;
  field: ProductGroupField;
  fieldValue?: Maybe<Scalars['String']['output']>;
  nodes: Array<Product>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductGroupField =
  | 'productType';

export type ProductHistoryEntry = {
  changeId: Scalars['ID']['output'];
  product: Product;
};

export type ProductHistoryFilterInput = {
  changeType?: InputMaybe<HistoryEntryQueryOperatorInput>;
};

/** The description of a product info sheet PDF. */
export type ProductInfoSheet = MediaAsset & {
  /** A date in ISO format (e.g. 2020-01-01T15:00:00.000Z). */
  createdAt?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ProductIngredient = {
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  translations?: Maybe<LocalizedText>;
  type?: Maybe<Scalars['String']['output']>;
};


export type ProductIngredientLabelArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type ProductInternalIdImportOptionsInput = {
  newRequests?: InputMaybe<Scalars['Boolean']['input']>;
  updateRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A list of products for internal use. */
export type ProductList = Collection & Item & List & {
  /** @deprecated Experimental - might be removed or changed without notice. Use at your own risk. */
  _unstable_allOutputConfigurations: Array<CollectionOutputConfiguration>;
  /**
   * Returns if adding products to a registration via QR code is allowed.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_allowAddViaQrCode: Scalars['Boolean']['output'];
  /**
   * The Bottlebooks Classic fields configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_classicFields: Array<ClassicField>;
  /**
   * Collection configuration data.
   * @deprecated For debugging only
   */
  _unstable_data: Scalars['JSON']['output'];
  /**
   * The product requests that don't have a matching product.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_missingProducts: Array<Unstable_MissingProduct>;
  /**
   * The tasting lists for this collection for a specific user.
   * @deprecated Experimental - might change of be dropped!
   */
  _unstable_myTastingLists: Array<TastingList>;
  /**
   * Outputs for a collection
   * @deprecated Experimental, will be removed. Use _unstable_outputConfigurations instead.
   */
  _unstable_outputs: Array<CollectionOutputConfiguration>;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_product: Unstable_CollectionProductEdge;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_products: Unstable_CollectionProductConnection;
  /**
   * The Bottlebooks Classic fields recommended to be configured based on outputs.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_recommendedClassicFields: Array<RecommendedClassicField>;
  /**
   * collectionIds that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollectionIds: Scalars['ID']['output'];
  /**
   * Access collections that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollections: CollectionConnection;
  /** @deprecated Experimental. Use at your own risk! */
  _unstable_requestedProducts: Unstable_RequestedProductConnection;
  /**
   * The products registered for a collection that have not been requested by the organizer.
   * @deprecated Experimental and unstable. Use at your own risk!
   */
  _unstable_unrequestedProducts: RegisteredProductConnection;
  /** @deprecated Experimental. Don't use yet. */
  _unstable_useNewForms: Scalars['Boolean']['output'];
  /** @deprecated Experimental. Don't use yet. */
  _unstable_validValueLists: Unstable_ValidValueLists;
  /** @deprecated use workspaceId instead. */
  brandId: Scalars['ID']['output'];
  /** The default catalog. */
  catalog?: Maybe<CatalogConfiguration>;
  /** An alias for productListId. */
  collectionId: Scalars['ID']['output'];
  collectionType: CollectionType;
  /** The collection name. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the collection was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /**
   * All the deleted registrations for a collection.
   * @deprecated Experimental
   */
  deletedRegistrations: Array<Registration>;
  /** The public description of the collection. */
  description?: Maybe<Scalars['String']['output']>;
  /** The collection steps. */
  enabledSteps: Array<RegistrationStep>;
  /** @deprecated use productListId instead. */
  eventId?: Maybe<Scalars['ID']['output']>;
  /** General instructions for exhibitors. */
  exhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /**
   * A particular form for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  form: Form;
  /**
   * The allowed form types for this collection.
   * @deprecated Experimental - use at your own risk!
   */
  formTypes: Array<FormType>;
  /**
   * All the forms for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  forms: Array<Form>;
  /** This collection has a product master list that specifies which products suppliers or exhibitors must register. */
  hasProductMasterList: Scalars['Boolean']['output'];
  /** This collection has an overall sorting for the products with optional flighting details. These events are often referred to as 'product-led events' where there are no exhibitors. sortIndex, flightName, and productLabel are null when this is false. */
  isProductSortingEnabled: Scalars['Boolean']['output'];
  /** @deprecated This resolver is under development and is not stable. */
  list?: Maybe<CollectionList>;
  /** @deprecated use productListId instead. */
  listId: Scalars['ID']['output'];
  /** @deprecated This resolver is under development and is not stable. */
  lists: CollectionListConnection;
  /** All the configured locales of the event. */
  locales: Array<Scalars['String']['output']>;
  /** Instructions for exhibitors after login. */
  loggedInExhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /** The collection logo. Often this is the collection owner's logo. */
  logo?: Maybe<CloudinaryAsset>;
  mainImage?: Maybe<CloudinaryAsset>;
  /** The maximum products of the collection per registration. */
  maximumProducts?: Maybe<Scalars['Int']['output']>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingAvailabilities: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingTimeslots: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  myMeetingTimeslots: Array<MeetingTimeslot>;
  /**
   * All the company registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  myRegistrations: RegistrationConnection;
  /** The collection name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The contacts that get notifications from the organizer regarding their registrations. */
  notificationContacts?: Maybe<Array<Maybe<Contact>>>;
  /** The brand owning the collection. */
  owner: Brand;
  permissions: CollectionPermissions;
  producer?: Maybe<Producer>;
  producers: ProducerConnection;
  product?: Maybe<Product>;
  /** Exhibitor instructions for adding products. */
  productInstructions?: Maybe<Scalars['String']['output']>;
  productListId: Scalars['ID']['output'];
  products: ProductConnection;
  /**
   * The questions configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  questions?: Maybe<Array<Question>>;
  /**
   * The brands producing products that have been registered at a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registeredBrands: RegisteredBrandConnection;
  /**
   * A product registered for a collection.
   * Because the same product might be added my multiple different partners,
   * you need to look at the registrations property to get the necessary details for each registration.
   * Not all types of collections support registeredProducts.
   */
  registeredProductVersion: RegisteredProduct;
  /** The products registered for a collection. */
  registeredProducts: RegisteredProductConnection;
  /** A particular registration. */
  registration?: Maybe<Registration>;
  /**
   * All the registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registrations: RegistrationConnection;
  /**
   * The representative profiles of all registrations.
   * @deprecated Experimental. Use at your own risk!
   */
  representatives: Array<SiteUserProfile>;
  /** The default site of the collection. */
  site?: Maybe<SiteConfiguration>;
  slug?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the collection was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The user profiles.
   * @deprecated Use visitors or representatives instead.
   */
  userProfiles: Array<SiteUserProfile>;
  visibilityStatus: VisibilityStatusType;
  /**
   * The visitor profiles of a collection. These are the registered and approved visitors.
   * @deprecated Experimental. Use at your own risk!
   */
  visitors: Array<SiteUserProfile>;
  /** The workspace the list belongs to. */
  workspaceId: Scalars['ID']['output'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_AllOutputConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_AllowAddViaQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_ClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


/** A list of products for internal use. */
export type ProductList_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_MissingProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_MyTastingListsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  sort?: InputMaybe<TastingListSortInput>;
  uid: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_OutputsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_ProductArgs = {
  experimentalKey: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


/** A list of products for internal use. */
export type ProductList_Unstable_ProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


/** A list of products for internal use. */
export type ProductList_Unstable_RecommendedClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


/** A list of products for internal use. */
export type ProductList_Unstable_RelatedCollectionIdsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_RelatedCollectionsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_RequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A list of products for internal use. */
export type ProductList_Unstable_UnrequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  versionTag?: InputMaybe<DataVersionTag>;
};


/** A list of products for internal use. */
export type ProductList_Unstable_UseNewFormsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductList_Unstable_ValidValueListsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductListDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A list of products for internal use. */
export type ProductListExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A list of products for internal use. */
export type ProductListFormArgs = {
  type: FormType;
};


/** A list of products for internal use. */
export type ProductListListArgs = {
  collectionListId: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductListListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A list of products for internal use. */
export type ProductListLocalesArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<InterfaceLocale>;
};


/** A list of products for internal use. */
export type ProductListLoggedInExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A list of products for internal use. */
export type ProductListMeetingAvailabilitiesArgs = {
  attendeeId: Scalars['String']['input'];
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  organizerId: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductListMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductListMyMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductListMyRegistrationsArgs = {
  companyId: Scalars['ID']['input'];
};


/** A list of products for internal use. */
export type ProductListNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A list of products for internal use. */
export type ProductListProducerArgs = {
  producerId: Scalars['ID']['input'];
};


/** A list of products for internal use. */
export type ProductListProducersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProducerSortInput>;
};


/** A list of products for internal use. */
export type ProductListProductArgs = {
  productId: Scalars['ID']['input'];
};


/** A list of products for internal use. */
export type ProductListProductInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A list of products for internal use. */
export type ProductListProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};


/** A list of products for internal use. */
export type ProductListQuestionsArgs = {
  group: QuestionGroup;
};


/** A list of products for internal use. */
export type ProductListRegisteredBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredBrandFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredBrandSortInput>;
};


/** A list of products for internal use. */
export type ProductListRegisteredProductVersionArgs = {
  productVersionId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
};


/** A list of products for internal use. */
export type ProductListRegisteredProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  useNext?: InputMaybe<Scalars['Boolean']['input']>;
  versionTag?: InputMaybe<DataVersionTag>;
};


/** A list of products for internal use. */
export type ProductListRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


/** A list of products for internal use. */
export type ProductListRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegistrationSortInput>;
};


/** A list of products for internal use. */
export type ProductListRepresentativesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


/** A list of products for internal use. */
export type ProductListSlugArgs = {
  format?: SlugFormat;
};


/** A list of products for internal use. */
export type ProductListUserProfilesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  roles: Array<SiteUserRole>;
  token: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};


/** A list of products for internal use. */
export type ProductListVisitorsArgs = {
  experimentalKey: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};

/** A list of product lists that is sortable, filterable and can be paginated. */
export type ProductListConnection = Connection & {
  edges: Array<ProductListEdge>;
  nodes: Array<ProductList>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductListEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<ProductList>;
  node: ProductList;
  previous?: Maybe<ProductList>;
};

export type ProductListFieldsEnum =
  | 'createdAt'
  | 'listId'
  | 'name'
  | 'updatedAt';

export type ProductListImportOptionsInput = {
  newRequests?: InputMaybe<Scalars['Boolean']['input']>;
  updateRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductListSortInput = {
  fields?: InputMaybe<Array<InputMaybe<ProductListFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrder>>>;
};

export type ProductMasterListImportInput = {
  newRequests?: InputMaybe<Scalars['Boolean']['input']>;
  updateRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductMasterListSyncImportInput = {
  newRequests?: InputMaybe<Scalars['Boolean']['input']>;
  removeProducts?: InputMaybe<Scalars['Boolean']['input']>;
  removeRequests?: InputMaybe<Scalars['Boolean']['input']>;
  removeSuppliers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductOutput = {
  collection: Collection;
  collectionId: Scalars['String']['output'];
  configuration: CollectionOutputConfiguration;
  configurationId: Scalars['ID']['output'];
  /**
   * The key is used to uniquely identify an item in an array.
   * It's guaranteed to be unique in the list, similar to a cursor, and it's somewhat stable over time, while not guaranteed to stay the same forever.
   * Don't use it to link to this output, and also don't interpret its content.
   * Instead just use it for determining if this is the same item as you had before, even if you change some attributes.
   */
  key: Scalars['String']['output'];
  outputState: OutputState;
  product: Product;
  productId: Scalars['String']['output'];
  /**
   * The output's unique ID.
   * In draft mode, this will be a temporary identifier derived from the output configuration.
   * For created outputs, this will be the outputId.
   */
  productOutputId: Scalars['ID']['output'];
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type ProductPackaging = {
  /** The GTIN of the packaging level. */
  GTIN?: Maybe<Scalars['String']['output']>;
  /** A list of all net content declarations given. */
  allNetContents?: Maybe<Array<ContentValue>>;
  /** The depth of the packaging. */
  depth?: Maybe<LengthValue>;
  /** The gross weight of the package including all contents. */
  grossWeight?: Maybe<WeightValue>;
  /** The height of the packaging. */
  height?: Maybe<LengthValue>;
  /** The type of packaging. */
  hierarchyTypeCode: ProductPackagingHierarchyType;
  /** Returns true if this is the base unit. */
  isBaseUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the dispatchable unit. */
  isDispatchableUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is an invoice unit. */
  isInvoiceUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the orderable unit. */
  isOrderableUnit?: Maybe<Scalars['Boolean']['output']>;
  /** The level of the packaging as specified in GS1 standards. */
  level: Scalars['Int']['output'];
  /** The net content. For primary packaging this is the volume. */
  netContent?: Maybe<ContentValue>;
  /**
   * The net weight of the package without the contents.
   * This is the bottle weight, the case material weight or the net pallet weight.
   */
  packageNetWeight?: Maybe<WeightValue>;
  /** The package type as defined in GS1 standards. */
  packageTypeCode?: Maybe<PackageTypeCode>;
  /** The net weight of product itself without packaging. */
  productNetWeight?: Maybe<WeightValue>;
  /** The quantity of layers in the packaging. Typically the number of layers of a pallet. */
  quantityOfLayers?: Maybe<Scalars['Int']['output']>;
  /**
   * The quantity of the next lower level per layer in the packaging hierarchy.
   * For a pallet, this is the number of cases per layer.
   */
  quantityOfNextLowerLevelPerLayer?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of items of the next lower level in the packaging hierarchy.
   * For a case, this is the number of bottles in the case.
   */
  totalQuantityOfNextLowerLevel?: Maybe<Scalars['Int']['output']>;
  /** The trade item unit type as defined in GS1 standards. */
  tradeItemUnit?: Maybe<TradeItemUnitDescriptorCode>;
  /** The width of the packaging. */
  width?: Maybe<LengthValue>;
};


export type ProductPackagingAllNetContentsArgs = {
  unit?: InputMaybe<ContentUnitCode>;
};


export type ProductPackagingDepthArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};


export type ProductPackagingGrossWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type ProductPackagingHeightArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};


export type ProductPackagingNetContentArgs = {
  unit?: InputMaybe<ContentUnitCode>;
};


export type ProductPackagingPackageNetWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type ProductPackagingProductNetWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type ProductPackagingWidthArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};

export type ProductPackagingHierarchyType =
  /** The primary packaging (typically a bottle). */
  | 'primary'
  /** The secondary packaging (typically a case). */
  | 'secondary'
  /** The tertiary packaging (typically a pallet). */
  | 'tertiary';

/** The platform type (mostly pallet type) that a product is transported on. */
export type ProductPackagingPlatformTypeCode =
  /** Slip Sheet */
  | '_9'
  /** Pallet 800 X 600 mm */
  | '_10'
  /** Pallet 800 X 1200 mm */
  | '_11'
  /** Pallet 1200 X 1000 mm */
  | '_12'
  /** Pallet 600 X 400 mm */
  | '_13'
  /** Pallet 400 X 300 mm */
  | '_14'
  /** Australian Pallet (1165 x 1165 mm), fits in the RACE container of Australian Railway */
  | '_25'
  /** Unspecified platform */
  | '_27'
  /** Pallet 1000 X 600 mm */
  | '_31'
  /** Block Pallet (pallet with blocks and stringer boards) */
  | '_32'
  /** Dolly (rigid platform on wheels or rollers) */
  | '_33'
  /** Pallet 1000 X 1200 mm */
  | '_35'
  /** Horizontal Drum Pallet */
  | '_38'
  /** IBC Pallet (RIBC) */
  | '_39'
  /** Pallet 1219 X 1016 mm */
  | '_40'
  /** Pallet 1067 X 1067 mm */
  | '_41'
  /** Pallet 1100 X 1100 mm */
  | '_42'
  /** Pallet 1140 X 1140 mm */
  | '_43'
  /** Skid (parallel wooden runners at the underside) */
  | '_44'
  /** Stringer Pallet (pallet with stringer boards) */
  | '_45'
  /** Vertical Drum Pallet */
  | '_46'
  /** Pallet 800 X 400 mm */
  | '_47'
  /** 1/2 ISO 3 Pallet (610 x 1016 mm / 24 x 40 In) */
  | '_48'
  /** 1/4 ISO 3 Pallet (610 x 508 mm / 24 x 20 In) */
  | '_49'
  /** Custom Platform */
  | '_50'
  /** Pallet 1000 x 1100 mm  */
  | '_51'
  /** Double mobilrack */
  | '_52'
  /** Single mobilrack */
  | '_53'
  /** Non-palletised goods */
  | '_98'
  | '_99';

export type ProductPackagingVariant = {
  GTIN?: Maybe<Scalars['String']['output']>;
  bottlesPerCase?: Maybe<Scalars['Int']['output']>;
  caseHeight?: Maybe<Scalars['Float']['output']>;
  caseLength?: Maybe<Scalars['Float']['output']>;
  caseMaterial?: Maybe<Scalars['String']['output']>;
  caseWeightGross?: Maybe<Scalars['Float']['output']>;
  caseWeightNet?: Maybe<Scalars['Float']['output']>;
  caseWidth?: Maybe<Scalars['Float']['output']>;
  casesPerPaletteLayer?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use GTIN instead. */
  eanCase?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use palletGTIN instead. */
  eanPallet?: Maybe<Scalars['String']['output']>;
  layersPerPalette?: Maybe<Scalars['Int']['output']>;
  packageBottleSize?: Maybe<Scalars['String']['output']>;
  palletGTIN?: Maybe<Scalars['String']['output']>;
  palletMaterial?: Maybe<Scalars['String']['output']>;
  palletStabilization?: Maybe<Scalars['String']['output']>;
  palletType?: Maybe<Scalars['String']['output']>;
  palletWeight?: Maybe<Scalars['Float']['output']>;
  palletWeightNet?: Maybe<Scalars['Float']['output']>;
  shrinkWrapWeight?: Maybe<Scalars['Float']['output']>;
};


export type ProductPackagingVariantGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type ProductPackagingVariantCaseMaterialArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type ProductPackagingVariantPalletGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type ProductPackagingVariantPalletTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

/** Experimental support for boolean permissions. */
export type ProductPermissions = {
  changeProductLifecycle: Scalars['Boolean']['output'];
  deleteProduct: Scalars['Boolean']['output'];
  editProduct: Scalars['Boolean']['output'];
};

/** The price of a particular product. */
export type ProductPrice = {
  /** The size of the bottle with that particular price. */
  bottleSize?: Maybe<Scalars['String']['output']>;
  /** The currency of the price. */
  currency?: Maybe<Scalars['String']['output']>;
  /** The price of the product. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The price range (from inexpensive to super-premium). */
  priceRange?: Maybe<Scalars['String']['output']>;
  /** The price strategy for this collection. */
  priceStrategy?: Maybe<PriceStrategy>;
  /** The type of price. */
  priceType?: Maybe<Scalars['String']['output']>;
  /** The product associated with the price. */
  product: Product;
  productId: Scalars['ID']['output'];
  /** Image that explains the price range structure. Prefers the public image if available. */
  publicPriceRangeImage?: Maybe<CloudinaryAsset>;
};


/** The price of a particular product. */
export type ProductPriceBottleSizeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The price of a particular product. */
export type ProductPriceCurrencyArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The price of a particular product. */
export type ProductPricePriceRangeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The price of a particular product. */
export type ProductPricePriceTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

/** An activity describing that a product was removed from a collection. */
export type ProductRemoveFromCollectionActivity = Activity & ProductActivity & RegistrationActivity & {
  /** The ID of the activity. */
  activityId: Scalars['ID']['output'];
  /** The type of change made. */
  activityType: ActivityType;
  /** The collection the product was removed from. */
  collection: Collection;
  /** The name of the collection where this product was removed from. */
  collectionName: Scalars['String']['output'];
  /** The company that changed the field. */
  company: CompanyProfile;
  /** The ISO date that this product was changed at. */
  date: Scalars['String']['output'];
  /** The ID of the operation. */
  operationId: Scalars['String']['output'];
  /**
   * The product that was removed.
   * @deprecated Use registeredProduct instead (TODO implement).
   */
  product: Product;
  /** The registration on which the activity was happening. */
  registration: SingleRegistration;
  /** The user and brand who changed the product. */
  user: UserProfile;
};

export type ProductRemoveFromCollectionHistoryEntry = HistoryEntry & ProductHistoryEntry & {
  changeId: Scalars['ID']['output'];
  /** The type of change made. */
  changeType?: Maybe<HistoryEntryType>;
  /** The ISO date that this product was changed at. */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** The user and brand who changed the product. */
  changedBy?: Maybe<ChangedBy>;
  /** The name of the collection where this product was changed at. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The product that was removed. */
  product: Product;
};

export type ProductRolesEnum =
  | 'ARCHIVE'
  | 'CREATE'
  | 'DELETE'
  | 'EDIT'
  | 'EDIT_PRODUCT_LIST'
  | 'READ'
  | 'SHARE_PRODUCT';

export type ProductSortField =
  | 'createdAt'
  | 'productId'
  | 'shortName'
  | 'status'
  | 'updatedAt'
  | 'vintage';

export type ProductSortInput = {
  /** The fields to sort products by. */
  fields: Array<ProductSortField>;
  /**
   * The orders to sort products by.
   * Supply the same number of orders as fields.
   * Defaults to ASC.
   */
  order?: InputMaybe<Array<SortOrder>>;
};

export type ProductStatus =
  | 'ACTIVE'
  | 'DRAFT'
  | 'INACTIVE';

export type ProductStatusQueryOperatorInput = {
  eq?: InputMaybe<ProductStatus>;
  in?: InputMaybe<Array<InputMaybe<ProductStatus>>>;
  ne?: InputMaybe<ProductStatus>;
  nin?: InputMaybe<Array<InputMaybe<ProductStatus>>>;
  regex?: InputMaybe<ProductStatus>;
};

export type ProductTask = Task & {
  collection?: Maybe<Collection>;
  collectionId?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<TaskConfiguration>;
  configurationId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: UserProfile;
  description?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId: Scalars['String']['output'];
  state: TaskState;
  taskId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

/** A free-form tasting note with text, publication and date. */
export type ProductTastingNote = {
  /** A link to a file showing the note. Might be a picture of a printed award or a PDF with the original text from a magazine. */
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  /** The author of that note. */
  author?: Maybe<Scalars['String']['output']>;
  /** A link to a page containing that note. */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** The full text of the tasting note. */
  note?: Maybe<Scalars['String']['output']>;
  /** The date when the note was written/published. */
  noteDate?: Maybe<Scalars['String']['output']>;
  /** The name and issue of the publisher of that note. */
  publication?: Maybe<Scalars['String']['output']>;
  /** The final rating. */
  rating?: Maybe<Scalars['String']['output']>;
};


/** A free-form tasting note with text, publication and date. */
export type ProductTastingNoteAttachmentUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A free-form tasting note with text, publication and date. */
export type ProductTastingNoteAuthorArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A free-form tasting note with text, publication and date. */
export type ProductTastingNoteExternalUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A free-form tasting note with text, publication and date. */
export type ProductTastingNoteNoteArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A free-form tasting note with text, publication and date. */
export type ProductTastingNoteNoteDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** A free-form tasting note with text, publication and date. */
export type ProductTastingNotePublicationArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A free-form tasting note with text, publication and date. */
export type ProductTastingNoteRatingArgs = {
  format?: InputMaybe<TextFormat>;
};

export type ProductType =
  | 'BEER'
  | 'CIDER'
  | 'OTHER'
  | 'SPIRIT'
  | 'WINE';

export type ProductTypeQueryOperatorInput = {
  eq?: InputMaybe<ProductTypeValues>;
  in?: InputMaybe<Array<InputMaybe<ProductTypeValues>>>;
  ne?: InputMaybe<ProductTypeValues>;
  nin?: InputMaybe<Array<InputMaybe<ProductTypeValues>>>;
  regex?: InputMaybe<ProductTypeValues>;
};

export type ProductTypeValidValues = {
  category: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ProductTypeValues =
  | 'BEER'
  | 'CIDER'
  | 'SPIRIT'
  | 'WINE';

export type ProductUpdateError = {
  code?: Maybe<Scalars['String']['output']>;
  fieldPath?: Maybe<Scalars['String']['output']>;
  relatedFieldPath?: Maybe<Scalars['String']['output']>;
  relatedFieldValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductUsedIn = Item & {
  /** The brand that has submitted the product to the collection. */
  brand?: Maybe<Brand>;
  /** The brand id that has submitted the product to the collection. */
  brandId?: Maybe<Scalars['ID']['output']>;
  /** The collection the product was submitted to. */
  collection?: Maybe<Event>;
  /** The collection id where this product is used. */
  collectionId?: Maybe<Scalars['ID']['output']>;
  /** The collection type where this product is used. */
  collectionType?: Maybe<CollectionType>;
  /** The product differences */
  diffProps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The name of the collection where this product is used. */
  name?: Maybe<Scalars['String']['output']>;
  /** Lists the product information as represented in the collection. */
  product?: Maybe<Product>;
  registrationId: Scalars['ID']['output'];
  /** The time when this product was last updated in that collection. */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ProductUsedInConnection = Connection & {
  edges: Array<ProductUsedInEdge>;
  group: Array<ProductUsedInGroupConnection>;
  nodes: Array<ProductUsedIn>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type ProductUsedInConnectionGroupArgs = {
  field?: InputMaybe<ProductUsedInGroupField>;
};

export type ProductUsedInELabels = Item & {
  /** The product differences */
  diffProps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The collection id where this product is used. */
  eLabel?: Maybe<ELabel>;
  /** The ID of the e-label where this product is used. */
  elabelId?: Maybe<Scalars['String']['output']>;
  /** The name of the e-label where this product is used. */
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductUsedInELabelsConnection = Connection & {
  edges: Array<ProductUsedInELabelsEdge>;
  group: Array<ProductUsedInELabelsGroupConnection>;
  nodes: Array<ProductUsedInELabels>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type ProductUsedInELabelsConnectionGroupArgs = {
  field?: InputMaybe<ProductUsedInELabelsGroupField>;
};

export type ProductUsedInELabelsEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<ProductUsedInELabels>;
  node: ProductUsedInELabels;
  previous?: Maybe<ProductUsedInELabels>;
};

export type ProductUsedInELabelsGroupConnection = Connection & {
  edges: Array<ProductUsedInELabelsEdge>;
  field: ProductUsedInELabelsGroupField;
  fieldValue?: Maybe<Scalars['String']['output']>;
  nodes: Array<ProductUsedInELabels>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductUsedInELabelsGroupField =
  | 'collectionType';

export type ProductUsedInEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<ProductUsedIn>;
  node: ProductUsedIn;
  previous?: Maybe<ProductUsedIn>;
};

export type ProductUsedInFilterInput = {
  collectionId?: InputMaybe<StringQueryOperatorInput>;
  collectionType?: InputMaybe<StringQueryOperatorInput>;
  diffProps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<StringQueryOperatorInput>;
};

export type ProductUsedInGroupConnection = Connection & {
  edges: Array<ProductUsedInEdge>;
  field: ProductUsedInGroupField;
  fieldValue?: Maybe<Scalars['String']['output']>;
  nodes: Array<ProductUsedIn>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductUsedInGroupField =
  | 'collectionType';

export type ProductVersionChange = {
  /** This will coerce all values to string, even if they are numbers */
  currentValue?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  previousValue?: Maybe<Scalars['String']['output']>;
};

export type ProductVersionDetails = Item & {
  /** @deprecated Experimental. This will change or be removed without notice. */
  _unstable_data: Scalars['JSONObject']['output'];
  _unstable_fileOutputs: Array<FileOutput>;
  changes: Array<ProductVersionChange>;
  createdAt: Scalars['String']['output'];
  /** The metadata about the creation of this product version. */
  createdBy: UserWorkspace;
  createdReason: CreatedReason;
  fields: Array<ProductField>;
  /** Date that the product was made immutable. */
  immutableAt?: Maybe<Scalars['String']['output']>;
  /** Indicates if a product was versioned due to auto-versioning rule. */
  isAutoVersioned: Scalars['Boolean']['output'];
  /** Indicates if a product is closed for further edits. Only the latest version in a workspace is mutable. */
  isImmutable: Scalars['Boolean']['output'];
  /** Indicates if a product has been released. */
  isReleased: Scalars['Boolean']['output'];
  /** Indicates if a product has been submitted. */
  isSubmitted: Scalars['Boolean']['output'];
  /** The ISO date when the product version was changed. */
  lastUpdatedAt: Scalars['String']['output'];
  /** The metadata about the last update of the product version. */
  lastUpdatedBy: UserWorkspace;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** The profile of the owning company. */
  owner: CompanyProfile;
  product: Product;
  productId: Scalars['ID']['output'];
  productVersionId: Scalars['ID']['output'];
  /** The ISO date when the product was released. */
  releasedAt?: Maybe<Scalars['String']['output']>;
  /** The metadata about the release of the product version. */
  releasedBy?: Maybe<UserWorkspace>;
  /** The product version id of the released data (if it has been released at least one time). */
  releasedProductVersionId?: Maybe<Scalars['String']['output']>;
  /** The ISO date when the product was submitted. */
  submittedAt?: Maybe<Scalars['String']['output']>;
  /** The metadata about the submission of the product version. */
  submittedBy?: Maybe<UserWorkspace>;
  /** The product version id of the submitted data (if it has been submitted at least one time). */
  submittedProductVersionId?: Maybe<Scalars['String']['output']>;
  /** List of metadata about users that have modified the product version. */
  updatedBy: Array<Maybe<UserWorkspace>>;
  workspaceId: Scalars['ID']['output'];
};


export type ProductVersionDetails_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
  v2_parse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductVersionDetails_Unstable_FileOutputsArgs = {
  experimentalKey: Scalars['String']['input'];
};

export type ProductionMethod =
  | 'barrelAged'
  | 'barrelFermented'
  | 'barrelMatured'
  | 'bottleFermented'
  | 'bottleFermentedTraditionalMethod'
  | 'caskAged'
  | 'caskFermented'
  | 'caskMatured'
  | 'classicalMethod'
  | 'classicalTraditionalMethod'
  | 'cremant'
  | 'traditionalMethod';

/** A profile of a brand or company. */
export type Profile = {
  /** The companies Global Location Number (GLN). */
  GLN?: Maybe<Scalars['String']['output']>;
  /** Array of address elements ordered based on the conventions of the particular country. */
  address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  biodynamicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The link to book wine experiences, hospitality, lifestyle and outdoor experiences. */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  /** The city or village the brand is located at. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the profile. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * A longer description of the brand.
   * For a shorter text, use shortDescription instead.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's director. */
  directorName?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently has distributors in. */
  distributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the distributor a brand currently has. */
  distributors?: Maybe<BrandDistributorConnection>;
  /** The brand's main contact email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The email to order products. */
  emailOrders?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage this producer is exporting to other countries.
   * @deprecated Use exportPercentageText instead. This will throw an error if the value entered was not an integer.
   */
  exportPercentage?: Maybe<Scalars['Int']['output']>;
  /** The percentage this producer is exporting to other countries, in text format (as entered). */
  exportPercentageText?: Maybe<Scalars['String']['output']>;
  /** The brand's facebook account or URL. */
  facebook?: Maybe<Scalars['String']['output']>;
  /** The year the brand was founded. */
  founded?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  /** Does this brand have a social compliance program? */
  hasSocialComplianceProgram?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a sustainability certification? */
  hasSustainabilityCertification?: Maybe<Scalars['Boolean']['output']>;
  /** The hospitality options this brand offers. */
  hospitalityOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The brand's instagram account or URL. */
  instagram?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** The languages spoken at the brand's information desk. */
  languagesSpoken?: Maybe<Array<Scalars['String']['output']>>;
  /** The latitude of the profile address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The lifestyle amenities this brand offers. */
  lifestyleOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The profile logo. */
  logo?: Maybe<CloudinaryAsset>;
  /** The longitude of the profile address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The main image of the profile, often showing people or the location. */
  mainImage?: Maybe<CloudinaryAsset>;
  /** The name shown in the profile. */
  name?: Maybe<Scalars['String']['output']>;
  /** The URL to the brand's online shop. */
  onlineShop?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar shops where you can buy products of this brand. */
  onlineShops?: Maybe<Array<OnlineShop>>;
  /** The times that the business is open. */
  openingHours?: Maybe<Array<OpeningHoursSpecification>>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  organicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The outdoor experiences this brand offers. */
  outdoorExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the profile's owner. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar Wine shops where you can buy products of this brand. */
  physicalShops?: Maybe<Array<PhysicalShop>>;
  /** The post code of the city the brand is located at. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The price ranges the profile's brand or company offers. */
  priceRanges?: Maybe<Array<PriceRange>>;
  profileId: Scalars['ID']['output'];
  /** The region this company or brand belongs to. */
  region?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently seeking distributors for. */
  seekingDistributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** A short description of the profile. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Used for Bottlebooks Classic only. Use socialCompliancePrograms instead. */
  socialCompliance?: Maybe<Array<SocialComplianceProgram>>;
  /** The list of social compliance programs. */
  socialCompliancePrograms?: Maybe<Array<SocialComplianceProgram>>;
  /**
   * The text to be used for sorting the brand in a list.
   * The name is also used for catalog indexes,
   * so a winery called "Bodegas Juan Carlos" could have a sortName of "Carlos, Juan, Bodegas" or "Carlos Juan".
   */
  sortName?: Maybe<Scalars['String']['output']>;
  /** The state/province of the profile. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** The street the brand is located in. */
  street?: Maybe<Scalars['String']['output']>;
  /** The list of social compliance programs. */
  sustainabilityCertifications?: Maybe<Array<SustainabilityCertification>>;
  /** The phone number of the profile. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The telephone number to order products. */
  telephoneOrders?: Maybe<Scalars['String']['output']>;
  /** The brand's twitter account or URL. */
  twitter?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Video>>;
  /** The brand's main website. */
  website?: Maybe<Scalars['String']['output']>;
  /** The wine experiences this brand offers. */
  wineExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the profile's winemaker. */
  winemakerName?: Maybe<Scalars['String']['output']>;
  /** The brand's youtube account or URL. */
  youtube?: Maybe<Scalars['String']['output']>;
};


/** A profile of a brand or company. */
export type ProfileGlnArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileBiodynamicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** A profile of a brand or company. */
export type ProfileCityArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A profile of a brand or company. */
export type ProfileDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A profile of a brand or company. */
export type ProfileDirectorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** A profile of a brand or company. */
export type ProfileDistributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BrandDistributorFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandDistributorSortInput>;
};


/** A profile of a brand or company. */
export type ProfileEmailArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A profile of a brand or company. */
export type ProfileEmailOrdersArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A profile of a brand or company. */
export type ProfileExportPercentageTextArgs = {
  format?: TextFormat;
};


/** A profile of a brand or company. */
export type ProfileFacebookArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A profile of a brand or company. */
export type ProfileFoundedArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileHospitalityOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A profile of a brand or company. */
export type ProfileInstagramArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A profile of a brand or company. */
export type ProfileLanguagesSpokenArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A profile of a brand or company. */
export type ProfileLifestyleOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A profile of a brand or company. */
export type ProfileNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A profile of a brand or company. */
export type ProfileOrganicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** A profile of a brand or company. */
export type ProfileOutdoorExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A profile of a brand or company. */
export type ProfileOwnerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfilePostalCodeArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileSeekingDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** A profile of a brand or company. */
export type ProfileShortDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** A profile of a brand or company. */
export type ProfileSortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileStateProvinceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A profile of a brand or company. */
export type ProfileStreetArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileTelephoneArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** A profile of a brand or company. */
export type ProfileTelephoneOrdersArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** A profile of a brand or company. */
export type ProfileTwitterArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A profile of a brand or company. */
export type ProfileWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** A profile of a brand or company. */
export type ProfileWineExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** A profile of a brand or company. */
export type ProfileWinemakerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A profile of a brand or company. */
export type ProfileYoutubeArgs = {
  format?: InputMaybe<UrlFormat>;
};

export type ProfileDataImportOptionsInput = {
  updateProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProweinExhibitor = Item & {
  hall: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stand: Scalars['String']['output'];
  standOrderNumber: Scalars['ID']['output'];
  targetCollectionId: Scalars['ID']['output'];
};

export type ProweinRegisteredProduct = {
  isManagedByBottlebooks: Scalars['Boolean']['output'];
  isOriginatedFromBottlebooks: Scalars['Boolean']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
  publishedProductVersionId?: Maybe<Scalars['ID']['output']>;
  standOrderNumber: Scalars['ID']['output'];
};

export type ProweinRegistration = Item & {
  approvedAt?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  approvedStandOrderNumber?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasPublishedProducts: Scalars['Boolean']['output'];
  isApproved: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The number of products that are not displayed on ProWein.com due to not having the required product categories. */
  productsWithInvalidCategoriesCount: Scalars['Int']['output'];
  publishedProducts?: Maybe<Array<Product>>;
  /** The product categories that the company has purchased in the ProWein OOS. */
  purchasedProductCategories: Array<Unstable_ProweinProductCategory>;
  registration?: Maybe<Registration>;
  registrationId?: Maybe<Scalars['ID']['output']>;
  /** The JSON object that is published to ProWein.com. Can be used to preview the data that will be published. */
  renderedProducts?: Maybe<Scalars['JSON']['output']>;
  requestedRegistrationId: Scalars['ID']['output'];
  /** The product categories that the company must have in order to have all wines visible on ProWein.com */
  requiredProductCategories: Array<Unstable_ProweinProductCategory>;
  stand?: Maybe<Scalars['String']['output']>;
  status: ProweinStatus;
  targetCollectionId: Scalars['ID']['output'];
};

export type ProweinStatus =
  | 'APPROVED'
  | 'CLAIMED'
  | 'UNCLAIMED';

export type PublishELabelAsOutputInput = {
  /** The ID of the collection to publish the e-label to. */
  collectionId: Scalars['ID']['input'];
  /** The ID of the eLabel to publish. */
  elabelId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the output configuration for the e-label output. */
  outputConfigurationId: Scalars['ID']['input'];
  /** The ID of the product to use as source data for the e-label. */
  productId: Scalars['ID']['input'];
  /** The workspace ID of the product to use as source data for the e-label. */
  workspaceId: Scalars['ID']['input'];
};

export type PublishELabelAsOutputResponse = MutationResponse & {
  code: Scalars['String']['output'];
  draft: ELabel;
  message: Scalars['String']['output'];
  published: ELabel;
  success: Scalars['Boolean']['output'];
};


export type PublishELabelAsOutputResponseDraftArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type PublishELabelInput = {
  /** The ID of the eLabel to publish. */
  elabelId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PublishELabelResponse = MutationResponse & {
  code: Scalars['String']['output'];
  draft: ELabel;
  message: Scalars['String']['output'];
  published: ELabel;
  success: Scalars['Boolean']['output'];
};


export type PublishELabelResponseDraftArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type PublishVersionInput = {
  elabelId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  /** The ID of the version to be publish. */
  versionId: Scalars['ID']['input'];
};

export type PublishVersionResponse = MutationResponse & {
  code: Scalars['String']['output'];
  draft?: Maybe<ELabel>;
  message: Scalars['String']['output'];
  published?: Maybe<ELabel>;
  success: Scalars['Boolean']['output'];
};

export type QrCodeAsset = MediaAsset & {
  /** Collection id that this QR Code is associated with */
  collectionId?: Maybe<Scalars['ID']['output']>;
  /** A date in ISO format (e.g. 2020-01-01T15:00:00.000Z). */
  createdAt?: Maybe<Scalars['String']['output']>;
  eLabel?: Maybe<ELabel>;
  /** E-label id that this QR Code is associated with */
  elabelId?: Maybe<Scalars['ID']['output']>;
  /** QR Code error correction level */
  errorCorrectionLevel?: Maybe<QrCodeErrorCorrectionLevel>;
  /** Locale of the QR Code */
  locale?: Maybe<Scalars['String']['output']>;
  /** Ovelays info icon on QR Code */
  overlayInfoIcon?: Maybe<Scalars['Boolean']['output']>;
  /** Product id that this QR Code is associated with */
  productId?: Maybe<Scalars['ID']['output']>;
  /** Registration id that this QR Code is associated with */
  registrationId?: Maybe<Scalars['ID']['output']>;
  /** Short code encoded in the QR code (the string following the domain) */
  shortCode: Scalars['ID']['output'];
  /** Display title of the QR Code */
  title: Scalars['String']['output'];
  /** URL to be encoded */
  url: Scalars['String']['output'];
};

export type QrCodeErrorCorrectionLevel =
  | 'H'
  | 'L'
  | 'M'
  | 'Q';

export type QrCodeResponseFilterInput = {
  context?: InputMaybe<IdQueryOperatorInput>;
};

export type QrCodeResponsesFilterInput = {
  context?: InputMaybe<IdQueryOperatorInput>;
  defaultContext?: InputMaybe<Scalars['Boolean']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  /**
   * The first registration to a collection by exhibitorId.
   * You need to be logged in and have read permission for this registration.
   *
   * This is a convenience method - it is possible that an exhibitor has multiple registrations.
   * Prefer using registration instead.
   * @deprecated Experimental - might be changed or deleted without notice!.
   */
  _unstable_firstRegistrationByExhibitorId: Registration;
  /**
   * The first single registration to a collection by exhibitorId.
   * You need to be logged in and have read permission for this registration.
   *
   * This is a convenience method - it is possible that an exhibitor has multiple registrations.
   * Prefer using singleRegistration instead.
   * @deprecated Experimental - might be changed or deleted without notice!.
   */
  _unstable_firstSingleRegistrationByExhibitorId: SingleRegistration;
  /** @deprecated Experimental! Will be deleted soon! */
  _unstable_qrCode: Unstable_QrCode;
  /**
   * A specific registration.
   * You need to be logged in and have read permissions for this registration.
   * @deprecated Experimental - might be changed or deleted without notice!.
   */
  _unstable_registration: Registration;
  /**
   * All registrations for a collection by an exhibitorId.
   * You need to be logged in and have read permission for the registrations.
   * @deprecated Experimental - might be changed or deleted without notice!.
   */
  _unstable_registrationsByExhibitorId: Array<Registration>;
  /**
   * A specific single registration.
   * You need to be logged in and have read permissions for this registration.
   * @deprecated Experimental - might be changed or deleted without notice!.
   */
  _unstable_singleRegistration: SingleRegistration;
  /**
   * All single registrations for a collection by exhibitorId.
   * You need to be logged in and have read permission for the registrations.
   * @deprecated Experimental - might be changed or deleted without notice!.
   */
  _unstable_singleRegistrationsByExhibitorId: Array<SingleRegistration>;
  /**
   * A brand.
   * @deprecated Not yet supported.
   */
  brand?: Maybe<Brand>;
  /** A list of brands. */
  brands: BrandConnection;
  /** A single collection. */
  collection?: Maybe<Collection>;
  /** A list of companies. */
  companies: BrandConnection;
  /** The company profile. */
  companyProfile: AbstractBrand;
  /** The company of the currently logged-in user. */
  currentBrand?: Maybe<Brand>;
  /** @deprecated use currentSession instead. */
  currentUser?: Maybe<BrandUser>;
  /** A single elabel. */
  eLabel?: Maybe<ELabel>;
  /** Public resolver to provide e-label information for rendering */
  eLabelVersion?: Maybe<ELabelVersion>;
  /** A single event. */
  event?: Maybe<Event>;
  job?: Maybe<Job>;
  /** The session of the currently logged-in user. */
  mySession?: Maybe<Session>;
  /**
   * The workspace of the currently logged-in user.
   * @deprecated Use workspace(workspaceId: <your workspace ID>) for a more predictable query instead.
   */
  myWorkspace?: Maybe<Workspace>;
  /** The server version. */
  serverVersion: Scalars['String']['output'];
  /**
   * A single list of publicly shared data.
   * @deprecated Not yet supported
   */
  shareList?: Maybe<ShareList>;
  /** The server status. */
  status: Scalars['String']['output'];
  /** The API version. */
  version: Scalars['String']['output'];
  /** A workspace the user is logged into. */
  workspace?: Maybe<Workspace>;
  /**
   * The list of workspace the logged-in user has access to.
   * @deprecated Use workspace(workspaceId: <your workspace ID>) for a more predictable query instead.
   */
  workspaces?: Maybe<Array<Workspace>>;
};


export type Query_Unstable_FirstRegistrationByExhibitorIdArgs = {
  collectionId: Scalars['ID']['input'];
  exhibitorId: Scalars['ID']['input'];
  experimentalKey: Scalars['String']['input'];
};


export type Query_Unstable_FirstSingleRegistrationByExhibitorIdArgs = {
  collectionId: Scalars['ID']['input'];
  exhibitorId: Scalars['ID']['input'];
  experimentalKey: Scalars['String']['input'];
};


export type Query_Unstable_QrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type Query_Unstable_RegistrationArgs = {
  experimentalKey: Scalars['String']['input'];
  registrationId: Scalars['ID']['input'];
};


export type Query_Unstable_RegistrationsByExhibitorIdArgs = {
  collectionId: Scalars['ID']['input'];
  exhibitorId: Scalars['ID']['input'];
  experimentalKey: Scalars['String']['input'];
};


export type Query_Unstable_SingleRegistrationArgs = {
  experimentalKey: Scalars['String']['input'];
  registrationId: Scalars['ID']['input'];
};


export type Query_Unstable_SingleRegistrationsByExhibitorIdArgs = {
  collectionId: Scalars['ID']['input'];
  exhibitorId: Scalars['ID']['input'];
  experimentalKey: Scalars['String']['input'];
};


export type QueryBrandArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: BrandFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<ContentLocale>;
};


export type QueryCollectionArgs = {
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: CompanyFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<ContentLocale>;
};


export type QueryCompanyProfileArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCurrentBrandArgs = {
  locale?: InputMaybe<ContentLocale>;
};


export type QueryELabelArgs = {
  checkExternal?: InputMaybe<Scalars['Boolean']['input']>;
  elabelId: Scalars['ID']['input'];
  locale?: InputMaybe<ELabelLocale>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryELabelVersionArgs = {
  locale?: InputMaybe<ELabelLocale>;
  versionId: Scalars['ID']['input'];
};


export type QueryEventArgs = {
  eventId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
};


export type QueryJobArgs = {
  jobId: Scalars['Int']['input'];
};


export type QueryMyWorkspaceArgs = {
  locale?: InputMaybe<ContentLocale>;
};


export type QueryShareListArgs = {
  locale?: InputMaybe<ContentLocale>;
  shareListId: Scalars['ID']['input'];
};


export type QueryWorkspaceArgs = {
  locale?: InputMaybe<ContentLocale>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryWorkspacesArgs = {
  locale?: InputMaybe<ContentLocale>;
};

/** The settings for a single form field in Bottlebooks. */
export type Question = {
  field: FormField;
  isEnabled: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  questionName: Scalars['ID']['output'];
};


/** The settings for a single form field in Bottlebooks. */
export type QuestionLabelArgs = {
  locale: InterfaceLocale;
};

export type QuestionGroup =
  | 'beer'
  | 'importer'
  | 'producer'
  | 'spirit'
  | 'wine';

export type RecommendedClassicField = {
  currentConfiguration?: Maybe<ClassicField>;
  field: Scalars['ID']['output'];
  isCustomField: Scalars['Boolean']['output'];
  req: Scalars['String']['output'];
};

/**
 * A producer that has been registered to a collection by a partner.
 * Data that is unique to that registration can be retrieved here,
 * such as distributor contacts, registered products and others
 */
export type RegisteredBrand = Item & {
  /** @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break. */
  _unstable_validation?: Maybe<Unstable_ValidationResult>;
  /**
   * The registered brand - typically a producer.
   * @deprecated Use profile instead.
   */
  brand: Brand;
  /** The id of the brand. */
  brandId: Scalars['ID']['output'];
  /** The collection this brand is registered for. */
  collection: Collection;
  /** The id of the collection. */
  collectionId: Scalars['ID']['output'];
  /**
   * The company that registered this brand.
   * @deprecated Use registration.profile instead.
   */
  company: CompanyProfile;
  /** The id of the company who registered the brand. */
  companyId: Scalars['ID']['output'];
  /**
   * The completion state that is shown for each registered brand.
   * @deprecated Experimental - use at your own risk!
   */
  completionState: RegisteredProductCompletionState;
  /** A certain custom field for a product. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's raw text.
   * This is the shortest path to a custom field's value and always returns the raw text.
   * If you need to get typed values and more metadata, use customField instead.
   */
  customFieldText?: Maybe<Scalars['String']['output']>;
  /**
   * A certain custom field's value.
   * This is a shortcut – If you need more details, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields for that product. */
  customFields?: Maybe<Array<CustomField>>;
  /** The distributor contact data for this brand. */
  distributionContacts?: Maybe<Array<Contact>>;
  /**
   * The exhibitor's id of an event registration - it's just an alias to companyId.
   * @deprecated Use companyId instead.
   */
  exhibitorId: Scalars['ID']['output'];
  /**
   * The form for this brand.
   * @deprecated Experimental - use at your own risk!
   */
  form: RegisteredBrandForm;
  /** Is the brand seeking distribution in the target market? */
  isSeekingDistribution?: Maybe<Scalars['Boolean']['output']>;
  /** The content locale. */
  locale: ContentLocale;
  /** The name of the registered brand. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The partner's ID – it's just an alias to companyId.
   * @deprecated Use companyId instead.
   */
  partnerId: Scalars['ID']['output'];
  /** The products that are registered for this brand. */
  products: RegisteredProductConnection;
  /** The profile of the registered brand. */
  profile?: Maybe<BrandProfile>;
  /** The registration that this brand is registered with. */
  registration: SingleRegistration;
  /** The id of the registration. */
  registrationId: Scalars['ID']['output'];
  /** The id of the workspace the brand data is stored in. */
  workspaceId: Scalars['ID']['output'];
};


/**
 * A producer that has been registered to a collection by a partner.
 * Data that is unique to that registration can be retrieved here,
 * such as distributor contacts, registered products and others
 */
export type RegisteredBrand_Unstable_ValidationArgs = {
  experimentalKey: Scalars['String']['input'];
};


/**
 * A producer that has been registered to a collection by a partner.
 * Data that is unique to that registration can be retrieved here,
 * such as distributor contacts, registered products and others
 */
export type RegisteredBrandCustomFieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * A producer that has been registered to a collection by a partner.
 * Data that is unique to that registration can be retrieved here,
 * such as distributor contacts, registered products and others
 */
export type RegisteredBrandCustomFieldTextArgs = {
  key: Scalars['String']['input'];
};


/**
 * A producer that has been registered to a collection by a partner.
 * Data that is unique to that registration can be retrieved here,
 * such as distributor contacts, registered products and others
 */
export type RegisteredBrandCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


/**
 * A producer that has been registered to a collection by a partner.
 * Data that is unique to that registration can be retrieved here,
 * such as distributor contacts, registered products and others
 */
export type RegisteredBrandFormArgs = {
  registrationId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A producer that has been registered to a collection by a partner.
 * Data that is unique to that registration can be retrieved here,
 * such as distributor contacts, registered products and others
 */
export type RegisteredBrandNameArgs = {
  format?: InputMaybe<TextFormat>;
};

/** A list of registered brands that is sortable, filterable and can be paginated. */
export type RegisteredBrandConnection = Connection & {
  edges: Array<RegisteredBrandEdge>;
  group: Array<RegisteredBrandGroupConnection>;
  nodes: Array<RegisteredBrand>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A list of registered brands that is sortable, filterable and can be paginated. */
export type RegisteredBrandConnectionGroupArgs = {
  field: RegisteredBrandGroupField;
};

export type RegisteredBrandEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<RegisteredBrand>;
  node: RegisteredBrand;
  previous?: Maybe<RegisteredBrand>;
};

export type RegisteredBrandFilterInput = {
  brandId?: InputMaybe<IdQueryOperatorInput>;
  companyId?: InputMaybe<IdQueryOperatorInput>;
  registrationId?: InputMaybe<IdQueryOperatorInput>;
};

/**
 * A form for a registered brand.
 * Used for editing the brand.
 */
export type RegisteredBrandForm = Form & {
  /** @deprecated Experimental. This will change or be removed without notice. */
  _unstable_data: Scalars['JSONObject']['output'];
  /**
   * The registered brand.
   * This returns the current draft of the brand.
   * Only valid if queried on an existing registeredProduct.
   */
  brand: RegisteredBrand;
  /** If queried on an existing registeredBrand, the ID of the brand. */
  brandId?: Maybe<Scalars['ID']['output']>;
  collectionId: Scalars['ID']['output'];
  /**
   * The completion state for the full form.
   * This only returns a value if queried in the context of a registration.
   */
  completionState?: Maybe<FormCompletionState>;
  registrationId: Scalars['ID']['output'];
  /** The form's sections. */
  sections: Array<FormSection>;
  /**
   * The update sequence of the registeredBrand.
   * Used for quickly checking update conflicts.
   */
  sequenceId: Scalars['String']['output'];
  /**
   * The type this form is for.
   * Will always be RegisteredBrandForm.
   */
  type: FormType;
  workspaceId: Scalars['ID']['output'];
};


/**
 * A form for a registered brand.
 * Used for editing the brand.
 */
export type RegisteredBrandForm_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
  v2_parse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisteredBrandGroupConnection = {
  edges: Array<RegisteredBrandEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  nodes: Array<RegisteredBrand>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RegisteredBrandGroupField =
  | 'brandId';

export type RegisteredBrandSortField =
  | 'name';

export type RegisteredBrandSortInput = {
  /** The fields to sort the registered brands. */
  fields?: Array<RegisteredBrandSortField>;
  order?: Array<SortOrder>;
};

/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProduct = Item & {
  /**
   * The product that is registered (limited to the core product data).
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_coreProduct: Unstable_CoreProduct;
  /**
   * The request for this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_request?: Maybe<Unstable_RequestedProduct>;
  /** @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break. */
  _unstable_validation?: Maybe<Unstable_ValidationResult>;
  /**
   * All product registrations.
   * Only accessible for own registrations.
   * @deprecated Experimental, use at your own risk!
   */
  allRegistrations?: Maybe<Next_RegisteredProductConnection>;
  /** The collection this product is registered for. */
  collection: Collection;
  /** The id of the collection. */
  collectionId: Scalars['ID']['output'];
  /** The id of the company who registered the oroduct. */
  companyId: Scalars['ID']['output'];
  /**
   * The completion state that is shown for each registered product.
   * @deprecated Experimental - use at your own risk!
   */
  completionState: RegisteredProductCompletionState;
  /** A certain custom field for a product. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's raw text.
   * This is the shortest path to a custom field's value and always returns the raw text.
   * If you need to get typed values and more metadata, use customField instead.
   */
  customFieldText?: Maybe<Scalars['String']['output']>;
  /**
   * A certain custom field's value.
   * This is a shortcut – If you need more details, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields for that product. */
  customFields?: Maybe<Array<CustomField>>;
  /** @deprecated Use companyId instead. */
  exhibitorId: Scalars['ID']['output'];
  /**
   * Returns the fields for this product.
   * @deprecated Experimental - use at your own risk!
   */
  fields?: Maybe<Array<RegisteredProductField>>;
  /** The flight that this product has been assigned to. If isProductSortingEnabled is false, this will be null. */
  flightName?: Maybe<Scalars['String']['output']>;
  /**
   * The form for this product.
   * @deprecated Experimental - use at your own risk!
   */
  form: RegisteredProductForm;
  /**
   * A printable product info sheet as a PDF based on data from this registration.
   * Unlike the standard info sheet, these info sheets must be implemented with an asCatalog variant and have access to event data such as contacts.
   */
  infoSheet?: Maybe<ProductInfoSheet>;
  /** The content locale. */
  locale: ContentLocale;
  /** @deprecated No value - just there because the Item interface needs it. */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use registration.profile instead. */
  partner: Brand;
  /** @deprecated Use companyId instead. */
  partnerId: Scalars['ID']['output'];
  /** The index of this product within the registration's products. */
  position: Scalars['Int']['output'];
  /** The pricing for this product. */
  pricing?: Maybe<ProductPrice>;
  /** The brand profile for this product's producer. Contains registration specific data. */
  producer?: Maybe<RegisteredBrand>;
  /** The ID of this product's producer. */
  producerId?: Maybe<Scalars['ID']['output']>;
  /** The product that is registered. */
  product: Product;
  /** The id of the product. */
  productId: Scalars['ID']['output'];
  /** The display label for this wine. This is typically used together with flights. If isProductSortingEnabled is false, this will be null. PARSED format returns a string in this order: productLabel, sortIndex, null. '-' causes this resolver to return null. */
  productLabel?: Maybe<Scalars['String']['output']>;
  /** Product request id. */
  productRequestId?: Maybe<Scalars['ID']['output']>;
  /** The id of the version of the product. */
  productVersionId: Scalars['ID']['output'];
  /** The registration where this product is registered. */
  registration: SingleRegistration;
  /** The id of the registration this product was added to. */
  registrationId: Scalars['ID']['output'];
  /** The sort index for this product (starts with 1). If isProductSortingEnabled is false, this will be null. */
  sortIndex?: Maybe<Scalars['Int']['output']>;
  /** Metadata about this product version */
  versionDetails: ProductVersionDetails;
  /** Versions of this registered product */
  versions: RegisteredProductConnection;
  /** The workspace the collection is in (the collection owner's workspace). */
  workspaceId: Scalars['ID']['output'];
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProduct_Unstable_CoreProductArgs = {
  experimentalKey: Scalars['String']['input'];
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProduct_Unstable_RequestArgs = {
  experimentalKey: Scalars['String']['input'];
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProduct_Unstable_ValidationArgs = {
  experimentalKey: Scalars['String']['input'];
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProductAllRegistrationsArgs = {
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProductCustomFieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProductCustomFieldTextArgs = {
  key: Scalars['String']['input'];
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProductCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProductFieldsArgs = {
  forRegistrationId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProductFormArgs = {
  registrationId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProductInfoSheetArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<ContentLocale>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A product that has been registered by a partner.
 * Data unique to that registration can be retrieved here, such as pricing,
 * a particular bottle size presented, the collection data, a stand number and others.
 */
export type RegisteredProductProductLabelArgs = {
  format?: InputMaybe<ParsedTextFormat>;
};

/** The overall status of a product in the registration process. */
export type RegisteredProductCompletionState =
  /** The product is valid and has been marked as complete. */
  | 'COMPLETE'
  /** The product is failing completeness checks. */
  | 'INCOMPLETE'
  /** The product is failing validation and cannot be published. */
  | 'INVALID'
  /** The product was added, but the data wasn't checked by the exhibitor. */
  | 'NOT_STARTED'
  /** This field or product needs a review by a team member. */
  | 'REVIEW_REQUIRED';

/** A list of registered products that is sortable, filterable and can be paginated. Grouping products is also supported. */
export type RegisteredProductConnection = Connection & {
  edges: Array<RegisteredProductEdge>;
  group: Array<RegisteredProductGroupConnection>;
  nodes: Array<RegisteredProduct>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A list of registered products that is sortable, filterable and can be paginated. Grouping products is also supported. */
export type RegisteredProductConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customFieldKey?: InputMaybe<Scalars['String']['input']>;
  field: RegisteredProductGroupField;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductGroupConnectionSortInput>;
};


/** A list of registered products that is sortable, filterable and can be paginated. Grouping products is also supported. */
export type RegisteredProductConnectionNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RegisteredProductEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<RegisteredProduct>;
  node: RegisteredProduct;
  previous?: Maybe<RegisteredProduct>;
};

/**
 * A field on a registered product.
 * Used for editing the product.
 */
export type RegisteredProductField = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  field: FormField;
  inputType: FieldInputType;
  isRequired: Scalars['Boolean']['output'];
  isValid?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  questionName: Scalars['ID']['output'];
  rawValue?: Maybe<Scalars['String']['output']>;
  registeredProduct: RegisteredProduct;
  registration: Registration;
  registrationId: Scalars['ID']['output'];
  value: FieldValue;
  warningMessage?: Maybe<Scalars['String']['output']>;
};


/**
 * A field on a registered product.
 * Used for editing the product.
 */
export type RegisteredProductFieldErrorMessageArgs = {
  locale: InterfaceLocale;
};


/**
 * A field on a registered product.
 * Used for editing the product.
 */
export type RegisteredProductFieldLabelArgs = {
  locale: InterfaceLocale;
};


/**
 * A field on a registered product.
 * Used for editing the product.
 */
export type RegisteredProductFieldWarningMessageArgs = {
  locale: InterfaceLocale;
};

/** A filter to allow you to drill down on specific products registered on a collection. */
export type RegisteredProductFilterInput = {
  /** The id of the collection. */
  collectionId?: InputMaybe<IdQueryOperatorInput>;
  /** The id of the company that registered that product. */
  companyId?: InputMaybe<IdQueryOperatorInput>;
  /** Deprecated - use companyId instead. */
  partnerId?: InputMaybe<IdQueryOperatorInput>;
  /** The id of the producer/brand that is associated with the product. */
  producerId?: InputMaybe<IdQueryOperatorInput>;
  /** The id of the product. */
  productId?: InputMaybe<IdQueryOperatorInput>;
  /** The id of the registration. */
  registrationId?: InputMaybe<IdQueryOperatorInput>;
  versionDetails?: InputMaybe<ProductDataVersionDetailsInput>;
};

/**
 * A form for a registered product.
 * Used for editing the product.
 */
export type RegisteredProductForm = Form & {
  /** @deprecated Experimental. This will change or be removed without notice. */
  _unstable_data: Scalars['JSONObject']['output'];
  collectionId: Scalars['ID']['output'];
  /**
   * The completion state for the full form.
   * @deprecated Unsupported – don't use currently.
   */
  completionState?: Maybe<FormCompletionState>;
  /** If queried on an existing registeredProduct, the ID of the product. */
  productId: Scalars['ID']['output'];
  /**
   * The registered product.
   * This returns the current draft of the product.
   * Only valid if queried on an existing registeredProduct.
   * @deprecated Unsupported – don't use currently.
   */
  registeredProduct: RegisteredProduct;
  registrationId: Scalars['ID']['output'];
  /**
   * The form's sections.
   * @deprecated Unsupported – don't use currently. The final API will probably be similar.
   */
  sections: Array<FormSection>;
  /**
   * The update sequence of the registeredProduct.
   * Used for quickly checking update conflicts.
   * @deprecated Unsupported – don't use currently.
   */
  sequenceId: Scalars['String']['output'];
  /**
   * The product type this form is for.
   * Matches the registeredProduct's productType: BeerForm for beer, WineForm for wine, etc.
   * @deprecated Not supported any more. Will probably be removed completely.
   */
  type: FormType;
  workspaceId: Scalars['ID']['output'];
};


/**
 * A form for a registered product.
 * Used for editing the product.
 */
export type RegisteredProductForm_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
  v2_parse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The registered products, grouped by a field. */
export type RegisteredProductGroupConnection = Connection & {
  edges: Array<RegisteredProductEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<RegisteredProductGroupConnection>;
  nodes: Array<RegisteredProduct>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** The registered products, grouped by a field. */
export type RegisteredProductGroupConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: RegisteredProductGroupField;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductGroupConnectionSortInput>;
};


/** The registered products, grouped by a field. */
export type RegisteredProductGroupConnectionNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RegisteredProductGroupConnectionSortField =
  | 'fieldValue'
  | 'totalCount';

export type RegisteredProductGroupConnectionSortInput = {
  fields?: InputMaybe<Array<RegisteredProductGroupConnectionSortField>>;
  order?: InputMaybe<Array<SortOrder>>;
};

export type RegisteredProductGroupField =
  | 'customField'
  | 'denomination'
  | 'isBiodynamic'
  | 'isCertifiedOrganic'
  | 'isOrganic'
  | 'isSustainable'
  | 'isVegan'
  | 'isVegetarian'
  | 'partnerId'
  | 'partnerName'
  | 'primaryVarietyName'
  | 'producerId'
  | 'producerName'
  | 'productId'
  | 'regionName'
  | 'wineColor';

export type RegisteredProductSortField =
  | 'name'
  | 'producer___name'
  | 'shortName'
  | 'vintage';

export type RegisteredProductSortInput = {
  /** The fields to sort the registered brands. */
  fields?: Array<RegisteredProductSortField>;
  order?: Array<SortOrder>;
};

export type RegisteredProductStatus =
  /** Already published product has draft changes that have not yet been published */
  | 'DRAFT'
  /** The product has never been published */
  | 'NOTPUBLISHED'
  /** The product is not versioned. This is most likely due to the product not being copied into the new products collection yet. */
  | 'NOTVERSIONED'
  /** The product has been published at least once */
  | 'PUBLISHED';

/** A company's registration for a collection, like an event or request. */
export type Registration = {
  /** @deprecated Use profile instead. */
  brand?: Maybe<Brand>;
  /** @deprecated use companyId instead. */
  brandId?: Maybe<Scalars['ID']['output']>;
  /** The collection that the brand registered for. */
  collection?: Maybe<Collection>;
  collectionId: Scalars['ID']['output'];
  /** The ID of the registering company. */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** Is the registration locked? */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the registration. */
  name?: Maybe<Scalars['String']['output']>;
  /** The contacts managing a registration. */
  notificationContacts?: Maybe<Array<Contact>>;
  /** The profile displayed for this registration. */
  profile?: Maybe<RegistrationProfile>;
  registrationId: Scalars['ID']['output'];
  /** The type of registration. */
  registrationType: RegistrationType;
  workspaceId: Scalars['ID']['output'];
};


/** A company's registration for a collection, like an event or request. */
export type RegistrationNameArgs = {
  format?: InputMaybe<TextFormat>;
};

/** An activity on a registration. */
export type RegistrationActivity = {
  /** The activity ID. */
  activityId: Scalars['ID']['output'];
  collection: Collection;
  /** The ISO date that this registration was changed at. TODO: this should be createdAt because it is a more common name */
  date: Scalars['String']['output'];
  /** The registration on which the activity was happening. */
  registration: SingleRegistration;
};

/** An activity describing that the collector added the registration. */
export type RegistrationAddedActivity = Activity & RegistrationActivity & {
  /** The ID of the activity. */
  activityId: Scalars['ID']['output'];
  /** The type of change made. */
  activityType: ActivityType;
  /** The collection the registration os part of. */
  collection: Collection;
  /** The name of the collection that this registration is part of. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The company that started the registration. */
  company: CompanyProfile;
  /** The ISO date that this registration was started at. */
  date: Scalars['String']['output'];
  /** The ID of the operation. */
  operationId: Scalars['String']['output'];
  /** The registration that was started. */
  registration: SingleRegistration;
  /** The user and company who started the registration. */
  user: UserProfile;
};

export type RegistrationCatalogSection = CatalogSection & {
  /** The ID of the company responsible for supplying the registration data. */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** The registration connected to this section. */
  registration: SingleRegistration;
  /** The registration's id. */
  registrationId: Scalars['ID']['output'];
  /** The type of section. */
  sectionType: CatalogSectionType;
};

/** An activity describing that a registration was changed by the organizer (typically they changed the progress to reviewed). */
export type RegistrationChangeByOrganizerActivity = Activity & RegistrationActivity & {
  /** The ID of the activity. */
  activityId: Scalars['ID']['output'];
  /** The type of change made. */
  activityType: ActivityType;
  affectedRegistrations: Array<SingleRegistration>;
  /** The field that was changed. */
  changedField: Scalars['String']['output'];
  /** The value of the field */
  changedTo?: Maybe<Scalars['String']['output']>;
  /** The collection the registration os part of. */
  collection: Collection;
  /** The name of the collection that this registration is part of. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The company that changed the field. */
  company: CompanyProfile;
  /** The ISO date that this registration was changed at. */
  date: Scalars['String']['output'];
  /** The ID of the operation. */
  operationId: Scalars['String']['output'];
  /** The registration that was changed. */
  registration: SingleRegistration;
  /** The user and company who changed the registration. */
  user: UserProfile;
};

/** An activity describing a registration communication activity. */
export type RegistrationCommunicationActivity = Activity & RegistrationActivity & {
  /** The ID of the activity. */
  activityId: Scalars['ID']['output'];
  /** The type of change made. */
  activityType: ActivityType;
  /** The collection the registration os part of. */
  collection: Collection;
  /** The name of the collection that this registration is part of. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The company that sent the notification. */
  company: CompanyProfile;
  /** The ISO date that this registration was changed at. */
  date: Scalars['String']['output'];
  /** The communication message. */
  message: Scalars['String']['output'];
  /** The ID of the operation. Used to group a communnication sent for multiple people. */
  operationId: Scalars['String']['output'];
  /** The recipient that received the communication. */
  recipient: RegistrationUser;
  /** The registration that was started. */
  registration: SingleRegistration;
  /** The communication subject. */
  subject: Scalars['String']['output'];
  /** The user that sent the communication. */
  user: UserProfile;
};

export type RegistrationConnection = {
  edges: Array<RegistrationEdge>;
  /** Groups the registrations by a particular field. */
  group: Array<RegistrationGroupConnection>;
  nodes: Array<Registration>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type RegistrationConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: RegistrationGroupField;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};

export type RegistrationEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<Registration>;
  node: Registration;
  previous?: Maybe<Registration>;
};

export type RegistrationFilterInput = {
  collection?: InputMaybe<CollectionFilterInput>;
  companyId?: InputMaybe<IdQueryOperatorInput>;
  registrationId?: InputMaybe<IdQueryOperatorInput>;
  /** . default: { ne: SKIPPED }. To include skipped, use {}. */
  registrationState?: InputMaybe<RegistrationStateQueryOperatorInput>;
  registrationStatus?: InputMaybe<RegistrationStatusQueryOperatorInput>;
};

export type RegistrationGroupConnection = {
  edges: Array<RegistrationEdge>;
  fieldName: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  /** Groups the registrations by a particular field. */
  group: Array<RegistrationGroupConnection>;
  nodes: Array<Registration>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type RegistrationGroupConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: RegistrationGroupField;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};

export type RegistrationGroupField =
  | 'registrationStatus';

/** A PDF download of the registration. */
export type RegistrationInfoSheet = MediaAsset & {
  /** A date in ISO format (e.g. 2020-01-01T15:00:00.000Z). */
  createdAt?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** An activity for a registration message. */
export type RegistrationMessage = Message & RegistrationActivity & {
  /** The activity ID of the message. */
  activityId: Scalars['ID']['output'];
  /** The type of change made. */
  activityType: ActivityType;
  /** The message content. */
  body: Scalars['String']['output'];
  /** The collection the registration os part of. */
  collection: Collection;
  /** The name of the collection that this registration is part of. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The company that sent the message. */
  company: CompanyProfile;
  /** The ISO date that this registration was changed at. */
  date: Scalars['String']['output'];
  /** The ID of the message. */
  messageId: Scalars['ID']['output'];
  /** The ID of the operation. Used to group a communnication sent for multiple people. */
  operationId: Scalars['String']['output'];
  /** The recipient that received the message. TODO: This should not be optional, but we have to make it work with legacy contacts */
  recipient?: Maybe<RegistrationUser>;
  /** The registration that was started. */
  registration: SingleRegistration;
  /** The message subject. */
  subject: Scalars['String']['output'];
  /** The user that sent the message. */
  user: UserProfile;
};

/** The public profile for a registration. */
export type RegistrationProfile = Item & Node & Profile & {
  /** The companies Global Location Number (GLN). */
  GLN?: Maybe<Scalars['String']['output']>;
  /** @deprecated For debugging only */
  _raw: Scalars['JSON']['output'];
  /** Legacy brand type */
  _unstable_brandType?: Maybe<BrandType>;
  /**
   * The profile's form.
   * @deprecated Experimental. Will change or be removed without notice!
   */
  _unstable_form?: Maybe<RegistrationProfileForm>;
  /** Array of address elements ordered based on the conventions of the particular country. */
  address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The number of bottles of sparkling produced per year. */
  annualProductionSparkling?: Maybe<Scalars['Int']['output']>;
  /** The number of bottles of sparkling produced per year, formatted as a number if possible. */
  annualProductionSparklingText?: Maybe<Scalars['String']['output']>;
  /** The number of bottles of wine produced per year. */
  annualProductionWine?: Maybe<Scalars['Int']['output']>;
  /** The number of bottles of wine produced per year, formatted as a number if possible. */
  annualProductionWineText?: Maybe<Scalars['String']['output']>;
  /** The associations the profile is part of. */
  associations?: Maybe<Scalars['String']['output']>;
  /** The average yield. */
  averageYield?: Maybe<Scalars['Int']['output']>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  biodynamicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The link to book wine experiences, hospitality, lifestyle and outdoor experiences. */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  /** The producer certifications. */
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  /** The city or village the brand is located at. */
  city?: Maybe<Scalars['String']['output']>;
  /** @deprecated For internal use only. */
  collectionSpecificField?: Maybe<Scalars['String']['output']>;
  /** The country of the profile. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * A longer description of the brand.
   * For a shorter text, use shortDescription instead.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the brand's director.
   * @deprecated Use directorName instead.
   */
  director?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's director. */
  directorName?: Maybe<Scalars['String']['output']>;
  /** Returns the countries that the brand currently has distributors in. */
  distributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the distributor a brand currently has. */
  distributors?: Maybe<BrandDistributorConnection>;
  /** The brand's main contact email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The email to order products. */
  emailOrders?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage this producer is exporting to other countries.
   * @deprecated Use exportPercentageText instead. This will throw an error if the value entered was not an integer.
   */
  exportPercentage?: Maybe<Scalars['Int']['output']>;
  /** The percentage this producer is exporting to other countries, in text format (as entered). */
  exportPercentageText?: Maybe<Scalars['String']['output']>;
  /** The brand's facebook account or URL. */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   * The form for this brand.
   * @deprecated Experimental - use at your own risk!
   */
  form: RegisteredBrandForm;
  /** The year the brand was founded. */
  founded?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  hasAccommodation?: Maybe<Scalars['Boolean']['output']>;
  hasDiningFacilities?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a social compliance program? */
  hasSocialComplianceProgram?: Maybe<Scalars['Boolean']['output']>;
  /** Does this brand have a sustainability certification? */
  hasSustainabilityCertification?: Maybe<Scalars['Boolean']['output']>;
  /** The hospitality options this brand offers. */
  hospitalityOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The globally unique Node id. Used to be able to load the node via the top-level node resolver. */
  id: Scalars['ID']['output'];
  /** The brand's instagram account or URL. */
  instagram?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** The languages spoken at the brand's information desk. */
  languagesSpoken?: Maybe<Array<Scalars['String']['output']>>;
  /** The latitude of the profile address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The lifestyle amenities this brand offers. */
  lifestyleOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The profile logo. */
  logo?: Maybe<CloudinaryAsset>;
  /** The longitude of the profile address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The main image of the profile, often showing people or the location. */
  mainImage?: Maybe<CloudinaryAsset>;
  /** The name shown in the profile. */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Most values are not used any more. */
  offeringTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the brand's online shop. */
  onlineShop?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar shops where you can buy products of this brand. */
  onlineShops?: Maybe<Array<OnlineShop>>;
  /** The times that the business is open. */
  openingHours?: Maybe<Array<OpeningHoursSpecification>>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  organicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** The outdoor experiences this brand offers. */
  outdoorExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the profile's owner. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Brick-and-mortar Wine shops where you can buy products of this brand. */
  physicalShops?: Maybe<Array<PhysicalShop>>;
  /** The planted area in hectares. */
  plantedArea?: Maybe<Scalars['Int']['output']>;
  /** The post code of the city the brand is located at. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The price ranges the profile's brand or company offers. */
  priceRanges?: Maybe<Array<PriceRange>>;
  /** The profile ID. */
  profileId: Scalars['ID']['output'];
  /** The region this company or brand belongs to. */
  region?: Maybe<Scalars['String']['output']>;
  /** The registration ID. */
  registrationId: Scalars['ID']['output'];
  /** Returns the countries that the brand currently seeking distributors for. */
  seekingDistributionInCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** A short description of the profile. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Used for Bottlebooks Classic only. Use socialCompliancePrograms instead. */
  socialCompliance?: Maybe<Array<SocialComplianceProgram>>;
  /** The list of social compliance programs. */
  socialCompliancePrograms?: Maybe<Array<SocialComplianceProgram>>;
  /** The description of the typical soil type. */
  soilType?: Maybe<Scalars['String']['output']>;
  /**
   * The text to be used for sorting the brand in a list.
   * The name is also used for catalog indexes,
   * so a winery called "Bodegas Juan Carlos" could have a sortName of "Carlos, Juan, Bodegas" or "Carlos Juan".
   */
  sortName?: Maybe<Scalars['String']['output']>;
  /** The state/province of the profile. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** The street the brand is located in. */
  street?: Maybe<Scalars['String']['output']>;
  /** The list of social compliance programs. */
  sustainabilityCertifications?: Maybe<Array<SustainabilityCertification>>;
  /** The phone number of the profile. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The telephone number to order products. */
  telephoneOrders?: Maybe<Scalars['String']['output']>;
  /** The brand's twitter account or URL. */
  twitter?: Maybe<Scalars['String']['output']>;
  /** The list of typical varieties planted. */
  typicalVarieties?: Maybe<Array<Scalars['String']['output']>>;
  videos?: Maybe<Array<Video>>;
  /** The brand's main website. */
  website?: Maybe<Scalars['String']['output']>;
  /** The wine experiences this brand offers. */
  wineExperienceOfferings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use winemakerName instead. */
  winemaker?: Maybe<Scalars['String']['output']>;
  /** The name of the profile's winemaker. */
  winemakerName?: Maybe<Scalars['String']['output']>;
  /** The brand's youtube account or URL. */
  youtube?: Maybe<Scalars['String']['output']>;
};


/** The public profile for a registration. */
export type RegistrationProfileGlnArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfile_Unstable_BrandTypeArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** The public profile for a registration. */
export type RegistrationProfile_Unstable_FormArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** The public profile for a registration. */
export type RegistrationProfileAnnualProductionSparklingTextArgs = {
  allowInvalidNumbers?: Scalars['Boolean']['input'];
  asEntered?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<NumberFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** The public profile for a registration. */
export type RegistrationProfileAnnualProductionWineTextArgs = {
  allowInvalidNumbers?: Scalars['Boolean']['input'];
  asEntered?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<NumberFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** The public profile for a registration. */
export type RegistrationProfileAssociationsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileBiodynamicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** The public profile for a registration. */
export type RegistrationProfileCertificationsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileCityArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileCollectionSpecificFieldArgs = {
  classicType?: InputMaybe<Scalars['String']['input']>;
  fieldName: Scalars['String']['input'];
};


/** The public profile for a registration. */
export type RegistrationProfileCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileDirectorArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileDirectorNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileDistributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BrandDistributorFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandDistributorSortInput>;
};


/** The public profile for a registration. */
export type RegistrationProfileEmailArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileEmailOrdersArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileExportPercentageTextArgs = {
  format?: TextFormat;
};


/** The public profile for a registration. */
export type RegistrationProfileFacebookArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileFormArgs = {
  registrationId?: InputMaybe<Scalars['ID']['input']>;
};


/** The public profile for a registration. */
export type RegistrationProfileFoundedArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileHospitalityOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileInstagramArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileLanguagesSpokenArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileLifestyleOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileOrganicCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** The public profile for a registration. */
export type RegistrationProfileOutdoorExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileOwnerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfilePostalCodeArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileSeekingDistributionInCountriesArgs = {
  filter?: InputMaybe<BrandDistributorFilterInput>;
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileShortDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileSortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileStateProvinceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileStreetArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileTelephoneArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileTelephoneOrdersArgs = {
  format?: InputMaybe<TelephoneFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileTwitterArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileTypicalVarietiesArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileWineExperienceOfferingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileWinemakerArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileWinemakerNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** The public profile for a registration. */
export type RegistrationProfileYoutubeArgs = {
  format?: InputMaybe<UrlFormat>;
};

/**
 * A form for a registration profile.
 * Used for editing the profile.
 */
export type RegistrationProfileForm = Form & {
  /**
   * The raw form data for this profile.
   * @deprecated Experimental. This will change or be removed without notice.
   */
  _unstable_data: Scalars['JSONObject']['output'];
  /** For brand registrations, the brandId of the profile. */
  brandId?: Maybe<Scalars['ID']['output']>;
  collectionId: Scalars['ID']['output'];
  /** The ID of the company that registered. */
  companyId: Scalars['ID']['output'];
  /**
   * The completion state for the full form.
   * This only returns a value if queried in the context of a registration.
   */
  completionState?: Maybe<FormCompletionState>;
  /**
   * The registration profile.
   * This returns the current draft of the profile.
   */
  profile?: Maybe<RegistrationProfile>;
  registrationId: Scalars['ID']['output'];
  /** The form's sections. */
  sections: Array<FormSection>;
  /**
   * The update sequence of the registeredProduct.
   * Used for quickly checking update conflicts.
   */
  sequenceId: Scalars['String']['output'];
  /**
   * The type of profile this form is for.
   * Matches the profile's type (company or brand).
   */
  type: FormType;
  workspaceId: Scalars['ID']['output'];
};


/**
 * A form for a registration profile.
 * Used for editing the profile.
 */
export type RegistrationProfileForm_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
};

export type RegistrationSortField =
  | 'deadline'
  | 'name'
  | 'registrationStatus';

export type RegistrationSortInput = {
  fields?: Array<RegistrationSortField>;
  order?: Array<SortOrder>;
};

/** An activity describing that the registration was started. */
export type RegistrationStartedActivity = Activity & RegistrationActivity & {
  /** The ID of the activity. */
  activityId: Scalars['ID']['output'];
  /** The type of change made. */
  activityType: ActivityType;
  /** The collection the registration os part of. */
  collection: Collection;
  /** The name of the collection that this registration is part of. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The company that started the registration. */
  company: CompanyProfile;
  /** The ISO date that this registration was started at. */
  date: Scalars['String']['output'];
  /** The ID of the operation. */
  operationId: Scalars['String']['output'];
  /** The registration that was started. */
  registration: SingleRegistration;
  /** The user and company who started the registration. */
  user: UserProfile;
};

export type RegistrationState =
  | 'ORGANIZER_REQUESTED_UPDATES'
  | 'ORGANIZER_REVIEWED'
  /** The company doesn't want to register for this collection. */
  | 'SKIPPED'
  | 'STEP_COMPLETED'
  | 'STEP_CONTACTS'
  | 'STEP_OVERVIEW'
  | 'STEP_PAYMENT'
  | 'STEP_PRICING'
  | 'STEP_PRODUCTS'
  | 'STEP_PROFILE'
  | 'STEP_REVIEW'
  | 'STEP_SHIPPING'
  | 'UPDATING';

/** Filters on the registration state. */
export type RegistrationStateQueryOperatorInput = {
  eq?: InputMaybe<RegistrationState>;
  in?: InputMaybe<Array<InputMaybe<RegistrationState>>>;
  ne?: InputMaybe<RegistrationState>;
  nin?: InputMaybe<Array<InputMaybe<RegistrationState>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationStatus =
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED'
  | 'ORGANIZER_REVIEWED'
  | 'REQUESTED_UPDATES'
  | 'SKIPPED';

export type RegistrationStatusQueryOperatorInput = {
  eq?: InputMaybe<RegistrationStatus>;
  in?: InputMaybe<Array<InputMaybe<RegistrationStatus>>>;
  ne?: InputMaybe<RegistrationStatus>;
  nin?: InputMaybe<Array<InputMaybe<RegistrationStatus>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationStep =
  | 'STEP_COMPLETED'
  | 'STEP_CONTACTS'
  | 'STEP_OVERVIEW'
  | 'STEP_PAYMENT'
  | 'STEP_PRICING'
  | 'STEP_PRODUCTS'
  | 'STEP_PROFILE'
  | 'STEP_REVIEW'
  | 'STEP_SHIPPING'
  | 'STEP_SKIPPED';

export type RegistrationType =
  | 'GROUPED_REGISTRATION'
  | 'SINGLE_REGISTRATION';

export type RegistrationTypeQueryOperatorInput = {
  eq?: InputMaybe<RegistrationType>;
  in?: InputMaybe<Array<InputMaybe<RegistrationType>>>;
  ne?: InputMaybe<RegistrationType>;
  nin?: InputMaybe<Array<InputMaybe<RegistrationType>>>;
};

export type RegistrationUser = {
  canAccessRegistration?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  registrationId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  userProfile?: Maybe<UserProfile>;
};

export type RejectRequestedProductInput = {
  collectionId: Scalars['ID']['input'];
  productRequestId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  reasonText?: InputMaybe<Scalars['String']['input']>;
  registrationId: Scalars['ID']['input'];
};

export type RejectRequestedProductResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The id of the requestedProduct */
  productRequestId: Scalars['ID']['output'];
  /** The newly created requested product. */
  requestedProduct: Unstable_RequestedProduct;
  success: Scalars['Boolean']['output'];
};

export type ReleaseProductsInput = {
  /** The id of the collection where the action is being performed. */
  collectionId: Scalars['ID']['input'];
  /** An optional note explaining the new release. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The product ID's. */
  productIds: Array<Scalars['ID']['input']>;
  /** The id of the registration where the action is being performed. */
  registrationId: Scalars['ID']['input'];
  /** The ID of the workspace. */
  workspaceId: Scalars['ID']['input'];
};

export type ReleaseProductsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ReleaseStatus =
  /** The object is archived. It might still be in use, but cannot be added to new nodes. */
  | 'ARCHIVED'
  /** The object is not ready to be released publicly. It cannot be shown as the default value for a field. */
  | 'DRAFT'
  /** The object is released and will be shown on public pages. */
  | 'RELEASED';

export type RemoveBrandFromGroupInput = {
  /** The id of the brand to be removed from the group. */
  brandId: Scalars['ID']['input'];
  /** The id of the group to remove the brand. */
  groupId: Scalars['ID']['input'];
};

export type RemoveBrandFromGroupResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveCompanyRegistrationInput = {
  /** The collection where the registration is made. */
  collectionId: Scalars['ID']['input'];
  /** The company whose registration should be removed. */
  companyId: Scalars['ID']['input'];
};

export type RemoveCompanyRegistrationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveContactResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveFromListResponse = MutationResponse & {
  code: Scalars['String']['output'];
  failed?: Maybe<Array<Scalars['ID']['output']>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveNotificationContactInput = {
  /** The id of the contact to remove. */
  contactId: Scalars['ID']['input'];
  /** The ID of the registration where the contact should be removed. */
  registrationId: Scalars['ID']['input'];
};

export type RemoveProductListInput = {
  productListId: Scalars['ID']['input'];
};

export type RemoveProductListResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveProductsFromProductListInput = {
  productIds: Array<Scalars['ID']['input']>;
  productListId: Scalars['ID']['input'];
};

export type RemoveProductsFromProductListResponse = {
  code: Scalars['String']['output'];
  failed?: Maybe<Array<Scalars['ID']['output']>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveProductsFromRegistrationInput = {
  /** The collection where the registration is made. */
  collectionId: Scalars['ID']['input'];
  /** The company whose registration the products should be added to */
  companyId: Scalars['ID']['input'];
  /** The products to add */
  productIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type RemoveProductsFromRegistrationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The id of the registration */
  registrationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveRegistrationsInput = {
  /** The registration ids to be removed. */
  registrationIds: Array<Scalars['ID']['input']>;
};

export type RemoveRegistrationsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RequestAccessToWorkspaceInput = {
  /** A message explaining why the user wants to get access. */
  message: Scalars['String']['input'];
  /** The id of the workspace to add the user to. */
  workspaceId: Scalars['ID']['input'];
};

export type RequestAccessToWorkspaceResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RequestChatInput = {
  /** Accept the terms. If not accepted, the chat request will not be sent. */
  acceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicate that the sender agrees to share their contact details with the recipient
   * and the owner of the website for the purpose of facilitating communication.
   */
  agreeToShareContactDetails: Scalars['Boolean']['input'];
  /** The sender's company name. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** The contact types that the recipient is supposed to contact the sender. */
  contactMeVia: Array<SiteUserContactType>;
  /** The sender's name, usually the profile displayName. */
  displayName: Scalars['String']['input'];
  /** The email that should be used to contact the sender. */
  email: Scalars['String']['input'];
  /** The sender's job title. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** The sender's company name. */
  linkedInURL?: InputMaybe<Scalars['String']['input']>;
  /** The sender's message. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** A new profile image. Use REST upload service to upload the image first, then use profileImageUrl. */
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
  /** A new profile image. Images must be uploaded to the CDN first using the REST service. */
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The recipient of the chat invitation. */
  recipientId: Scalars['ID']['input'];
  /** The telephone number that should be used to contact the sender. */
  telephone: Scalars['String']['input'];
};

export type RequestChatResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RequestMeetingInput = {
  /** Accept the terms. If not accepted, the meeting request will not be sent. */
  acceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  /** The organizer's company name. */
  companyName: Scalars['String']['input'];
  /** The organizer's name, usually the profile displayName. */
  displayName: Scalars['String']['input'];
  /** Do not use. This can no longer be configured and is determined by organizer settings. */
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The organizer's job title. */
  jobTitle: Scalars['String']['input'];
  /** The organizer's LinkedIn URL. */
  linkedInURL?: InputMaybe<Scalars['String']['input']>;
  /** The meeting location. */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Make the organizer's profile visible to representatives. */
  makeVisibleToRepresentatives?: InputMaybe<Scalars['Boolean']['input']>;
  /** The organizer's updated profile image. Use REST upload service to upload the image first, then use profileImageUrl. */
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
  /** The organizer's updated profile image. Images must be uploaded to the CDN first using the REST service. */
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The attendee invited to the meeting. */
  recipientId: Scalars['ID']['input'];
  /** The start date and time of the meeting. */
  start: Scalars['String']['input'];
  /** The organizer's telephone number. */
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type RequestMeetingResponse = MutationResponse & {
  code: Scalars['String']['output'];
  meeting?: Maybe<Meeting>;
  message: Scalars['String']['output'];
  organizerToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RequesterDetailsInput = {
  /** About the sender */
  about?: InputMaybe<Scalars['String']['input']>;
  /** The city to ship the samples. */
  city: Scalars['String']['input'];
  /** The company of the sender. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** The country to ship the samples. */
  country: Scalars['String']['input'];
  /** The email of the sender. */
  email: Scalars['String']['input'];
  /** The name of the sender. */
  name: Scalars['String']['input'];
  /** The street to ship the samples. */
  street: Scalars['String']['input'];
  /** The telephone number of the sender. */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** The zip code to ship the samples. */
  zipCode: Scalars['String']['input'];
};

export type RescheduleMeetingInput = {
  /** The userId of the attendee or organizer. */
  attendeeId: Scalars['ID']['input'];
  /** The collection the meeting is connected to. */
  collectionId: Scalars['ID']['input'];
  /** Do not use. This can no longer be configured and is determined by organizer settings. */
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The locale to send the notifications in. */
  locale: ContentLocale;
  /** The ID of the meeting that will be declined. */
  meetingId: Scalars['ID']['input'];
  /** The attendee's token to reschedule the meeting. */
  rescheduleToken: Scalars['String']['input'];
  /** The new meeting start date and time. */
  start: Scalars['String']['input'];
};

export type RestoreELabelInput = {
  /** The ID of the e-label to be restored. */
  elabelId: Scalars['ID']['input'];
  /** If true, the QR codes associated with the e-label will be restored as well. */
  restoreQrCodes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestoreELabelResponse = MutationResponse & {
  code: Scalars['String']['output'];
  eLabel?: Maybe<ELabel>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};


export type RestoreELabelResponseELabelArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type RestoreProductVersionResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  product?: Maybe<Product>;
  success: Scalars['Boolean']['output'];
};

/** The room an event stand is located in. */
export type Room = EventArea & Item & Node & {
  /** The type of area. Always FLOOR. */
  areaType: EventAreaType;
  areas: EventAreaConnection;
  /** A summary of the sub-areas of this area. Typically the stand number range. */
  areasSummary: Scalars['String']['output'];
  collection: Collection;
  collectionId: Scalars['ID']['output'];
  /** The color that contrasts the primary color. Typically either black or white. */
  contrastColor?: Maybe<Scalars['String']['output']>;
  /** A longer description of the area. */
  description: Scalars['String']['output'];
  event: Event;
  eventId: Scalars['ID']['output'];
  floor?: Maybe<Floor>;
  /** @deprecated Unstable - can change without notice. */
  form: EventAreaForm;
  id: Scalars['ID']['output'];
  /** The localized name of the area. Typically the stand name or room name. */
  name: Scalars['String']['output'];
  parent?: Maybe<EventArea>;
  parentSlug?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<FloorPlan>;
  /** The primary color assigned to this area. */
  primaryColor?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<SingleRegistration>;
  registrationId?: Maybe<Scalars['ID']['output']>;
  room?: Maybe<Room>;
  slug: Scalars['String']['output'];
  sortIndex: Scalars['Int']['output'];
  stand?: Maybe<Stand>;
  /** A subtitle for the area. Typically the names of the regions, associations or exhibitors found in this area. */
  subtitle: Scalars['String']['output'];
};


/** The room an event stand is located in. */
export type RoomAreasArgs = {
  filter?: InputMaybe<EventAreaFilterInput>;
};


/** The room an event stand is located in. */
export type RoomAreasSummaryArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};


/** The room an event stand is located in. */
export type RoomDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};


/** The room an event stand is located in. */
export type RoomNameArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale?: InputMaybe<ContentLocale>;
};


/** The room an event stand is located in. */
export type RoomSubtitleArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};

export type SaveExportConfigurationResponse = {
  code: Scalars['String']['output'];
  configuration?: Maybe<ExportConfiguration>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SaveMaximumProductsInput = {
  collectionId: Scalars['ID']['input'];
  /** The stands data. */
  maximumProducts: Array<MaximumProductsInput>;
};

export type SaveMaximumProductsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SaveProductDataResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  product?: Maybe<Product>;
  registeredProduct?: Maybe<RegisteredProduct>;
  success: Scalars['Boolean']['output'];
  validations?: Maybe<Array<Maybe<ProductFieldValidation>>>;
};

export type SaveStandsInput = {
  collectionId: Scalars['ID']['input'];
  /** The stands data. */
  stands: Array<StandInput>;
};

export type SaveStandsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SecondaryPackaging = {
  /** The secondary packaging case. */
  case?: Maybe<Array<Maybe<PackagingComponent>>>;
  /** The secondary packaging case divider. */
  caseDivider?: Maybe<Array<Maybe<PackagingComponent>>>;
};

export type SecondaryPackagingForm = {
  /** The secondary packaging case. */
  case?: Maybe<Array<Maybe<PackagingComponentForm>>>;
  /** The secondary packaging case divider. */
  caseDivider?: Maybe<Array<Maybe<PackagingComponentForm>>>;
};

export type SecondaryPackagingInput = {
  case?: InputMaybe<Array<InputMaybe<PackagingComponentInput>>>;
  caseDivider?: InputMaybe<Array<InputMaybe<PackagingComponentInput>>>;
};

export type SecondaryProductPackaging = ProductPackaging & {
  /** The GTIN of the packaging level. */
  GTIN?: Maybe<Scalars['String']['output']>;
  /** A list of all net content declarations given. */
  allNetContents?: Maybe<Array<ContentValue>>;
  /**
   * The number of articles per case.
   * This is an alias for totalQuantityOfNextLowerLevel.
   */
  articlesPerCase?: Maybe<Scalars['Int']['output']>;
  /**
   * The type of case, typically CS for case or CT for carton.
   * This is an alias for packageTypeCode.
   */
  caseTypeCode?: Maybe<PackageTypeCode>;
  /** The depth of the packaging. */
  depth?: Maybe<LengthValue>;
  /** The gross weight of the package including all contents. */
  grossWeight?: Maybe<WeightValue>;
  /** The height of the packaging. */
  height?: Maybe<LengthValue>;
  /** The type of packaging. */
  hierarchyTypeCode: ProductPackagingHierarchyType;
  /** Returns true if this is the base unit. */
  isBaseUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the dispatchable unit. */
  isDispatchableUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is an invoice unit. */
  isInvoiceUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the orderable unit. */
  isOrderableUnit?: Maybe<Scalars['Boolean']['output']>;
  /** The level of the packaging as specified in GS1 standards. */
  level: Scalars['Int']['output'];
  /** The net content. */
  netContent?: Maybe<ContentValue>;
  /**
   * The net weight of the package without the contents.
   * This is the bottle weight, the case material weight or the net pallet weight.
   */
  packageNetWeight?: Maybe<WeightValue>;
  /** The package type as defined in GS1 standards. */
  packageTypeCode?: Maybe<PackageTypeCode>;
  /** The net weight of product itself without packaging. */
  productNetWeight?: Maybe<WeightValue>;
  /** The quantity of layers in the packaging. Typically the number of layers of a pallet. */
  quantityOfLayers?: Maybe<Scalars['Int']['output']>;
  /**
   * The quantity of the next lower level per layer in the packaging hierarchy.
   * For a pallet, this is the number of cases per layer.
   */
  quantityOfNextLowerLevelPerLayer?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of items of the next lower level in the packaging hierarchy.
   * For a case, this is the number of bottles in the case.
   */
  totalQuantityOfNextLowerLevel?: Maybe<Scalars['Int']['output']>;
  /** The trade item unit type as defined in GS1 standards. */
  tradeItemUnit?: Maybe<TradeItemUnitDescriptorCode>;
  /** The width of the packaging. */
  width?: Maybe<LengthValue>;
};


export type SecondaryProductPackagingAllNetContentsArgs = {
  unit?: InputMaybe<ContentUnitCode>;
};


export type SecondaryProductPackagingDepthArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};


export type SecondaryProductPackagingGrossWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type SecondaryProductPackagingHeightArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};


export type SecondaryProductPackagingNetContentArgs = {
  unit?: InputMaybe<ContentUnitCode>;
};


export type SecondaryProductPackagingPackageNetWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type SecondaryProductPackagingProductNetWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type SecondaryProductPackagingWidthArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};

export type SelectField = FormField & {
  /** The completion state for the component. */
  completionState?: Maybe<FormCompletionState>;
  /** The field's configuration. Dependent on the field type. */
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  /** The field's description, if any. */
  description?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  /** The field's unique identifier. */
  key: Scalars['ID']['output'];
  /** The field's label. */
  label: Scalars['String']['output'];
  /** @deprecated Experimental. */
  name?: Maybe<Scalars['String']['output']>;
  /** The field's select options. */
  options: Array<ValidValue>;
  /** The field's type. */
  type: FormFieldType;
  /** @deprecated Use the value field on the FormComponent instead. */
  value?: Maybe<TextFieldValue>;
};


export type SelectFieldDescriptionArgs = {
  locale: InterfaceLocale;
};


export type SelectFieldLabelArgs = {
  locale: InterfaceLocale;
};


export type SelectFieldOptionsArgs = {
  locale?: InputMaybe<InterfaceLocale>;
};

export type SelectFieldValue = FieldValue & {
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  /** The text as stored in the database. */
  rawText?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};


export type SelectFieldValueValueArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type SendContactRequestInput = {
  /** The collection where the registration is made. */
  collectionId: Scalars['ID']['input'];
  /** The company whose registration the products should be added to */
  companyId: Scalars['ID']['input'];
  /** The contact who is being sent the request */
  contactId: Scalars['ID']['input'];
  /** The message body */
  message: Scalars['String']['input'];
  /** The products to request */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The registration for the collection */
  registrationId?: InputMaybe<Scalars['ID']['input']>;
  /** The email of the sender */
  sender: SenderInput;
  /** The availability of the sender to meet */
  suggestedAppointments?: InputMaybe<AppointmentInput>;
};

export type SendContactRequestResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SendProductListResponse = MutationResponse & {
  code: Scalars['String']['output'];
  failed?: Maybe<Array<Scalars['ID']['output']>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SenderInput = {
  /** About the sender */
  about?: InputMaybe<Scalars['String']['input']>;
  /** The city to ship the samples. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The name of the sender's company. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** The country to ship the samples. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the sender. */
  email: Scalars['String']['input'];
  /** The name of the sender. */
  name: Scalars['String']['input'];
  /** The street to ship the samples. */
  street?: InputMaybe<Scalars['String']['input']>;
  /** The telephone number of the sender. */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** The zip code to ship the samples. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** The currently logged-in user session. */
export type Session = {
  /** Special resolver for Bottlebooks Admins to see the last 10 workspaces they have supported. */
  _unstable_recentWorkspaces: Array<Workspace>;
  /**
   * The workspace the user is currently in.
   * This may be null if the user has already logged in, but hasn't selected any workspace yet.
   */
  currentWorkspace?: Maybe<Workspace>;
  /**
   * The id of the workspace the user is currently in.
   * Null if the user has already logged in, but hasn't selected any workspace yet.
   */
  currentWorkspaceId?: Maybe<Scalars['ID']['output']>;
  /** The user's settings in the current workspace. */
  currentWorkspaceUser?: Maybe<WorkspaceUser>;
  /** The locale of the user interface. */
  interfaceLocale?: Maybe<InterfaceLocale>;
  /** The logged-in user's id. */
  userId?: Maybe<Scalars['ID']['output']>;
  /**
   * The user profile.
   * Some users might not have a profile yet.
   */
  userProfile?: Maybe<UserProfile>;
  /** The ids of the workspaces this user can switch to. */
  workspaceIds: Array<Scalars['ID']['output']>;
  /** The list of workspaces this user can switch to. */
  workspaces: Array<Workspace>;
};


/** The currently logged-in user session. */
export type SessionCurrentWorkspaceArgs = {
  locale?: InputMaybe<ContentLocale>;
};


/** The currently logged-in user session. */
export type SessionWorkspacesArgs = {
  locale?: InputMaybe<ContentLocale>;
};

export type SetBrandsActiveInGroupInput = {
  /** The ids of the brands to set active in the group. */
  brandIds: Array<Scalars['ID']['input']>;
  /** The id of the event to set the brand active. */
  groupId: Scalars['ID']['input'];
};

export type SetBrandsActiveInGroupResponse = MutationResponse & {
  brands?: Maybe<Array<Brand>>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SetBrandsInactiveInGroupInput = {
  /** The ids of the brands to set inactive in the group. */
  brandIds: Array<Scalars['ID']['input']>;
  /** The id of the event to set the brand inactive. */
  groupId: Scalars['ID']['input'];
};

export type SetBrandsInactiveInGroupResponse = MutationResponse & {
  brands?: Maybe<Array<Brand>>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Someone set a field that was previously unset. */
export type SetFieldChange = FieldChange & {
  /** If the field was changed within a collection, this describes the collection. */
  collection?: Maybe<Collection>;
  /** The name of the collection where this field was changed in. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The ISO date that this field was changed at. */
  date: Scalars['String']['output'];
  /** The field involved in the change. */
  field: ChangedField;
  /** The unique id of the field change. */
  fieldChangeId: Scalars['ID']['output'];
  /** The type of change made. */
  fieldChangeType: FieldChangeType;
  /** The product on which the change was made. */
  product: Product;
  /** The new value it was set to. */
  to: FieldValue;
  /** The user and brand who changed the field. */
  user: ChangedBy;
};

export type SetRegisteredProductCustomFieldInput = {
  key: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
  value: SetRegisteredProductCustomFieldValueInput;
};

export type SetRegisteredProductCustomFieldResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  registeredProduct?: Maybe<RegisteredProduct>;
  success: Scalars['Boolean']['output'];
};


export type SetRegisteredProductCustomFieldResponseRegisteredProductArgs = {
  locale?: InputMaybe<ContentLocale>;
};

export type SetRegisteredProductCustomFieldValueInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetRegistrationCustomFieldInput = {
  key: Scalars['String']['input'];
  registrationId: Scalars['ID']['input'];
  value: SetRegistrationCustomFieldValueInput;
};

export type SetRegistrationCustomFieldResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  registration?: Maybe<SingleRegistration>;
  success: Scalars['Boolean']['output'];
};


export type SetRegistrationCustomFieldResponseRegistrationArgs = {
  locale?: InputMaybe<ContentLocale>;
};

export type SetRegistrationCustomFieldValueInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetStatusMultipleProductsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<Product>>>;
  success: Scalars['Boolean']['output'];
};

export type SftpIntegration = {
  fileName?: Maybe<Scalars['String']['output']>;
  fileTimestamp?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  port?: Maybe<Scalars['String']['output']>;
  remotePath?: Maybe<Scalars['String']['output']>;
  template: SftpIntegrationTemplate;
  templateId: Scalars['String']['output'];
  workspaceId: Scalars['ID']['output'];
};

export type SftpIntegrationTemplate = {
  fileExtension: SftpIntegrationTemplateFileExtension;
  fileName: Scalars['String']['output'];
  /** Location of the template to be used. */
  fileUrl: Scalars['String']['output'];
  /** Some templates may have a special templateId to be used for gift pack. */
  giftPackTemplateId?: Maybe<Scalars['ID']['output']>;
  templateId: Scalars['ID']['output'];
};

export type SftpIntegrationTemplateFileExtension =
  /** Excel 97-2003 Workbook. */
  | 'XLS'
  /** Excel Macro-Enabled Workbook. */
  | 'XLSM'
  /** Excel Workbook. */
  | 'XLSX'
  /** XML template */
  | 'XML';

/** A list of products to share publicly. */
export type ShareList = Collection & Item & List & {
  /** @deprecated Experimental - might be removed or changed without notice. Use at your own risk. */
  _unstable_allOutputConfigurations: Array<CollectionOutputConfiguration>;
  /**
   * Returns if adding products to a registration via QR code is allowed.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_allowAddViaQrCode: Scalars['Boolean']['output'];
  /**
   * The Bottlebooks Classic fields configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_classicFields: Array<ClassicField>;
  /**
   * Collection configuration data.
   * @deprecated For debugging only
   */
  _unstable_data: Scalars['JSON']['output'];
  /**
   * The product requests that don't have a matching product.
   * @deprecated Experimental. Use at your own risk!
   */
  _unstable_missingProducts: Array<Unstable_MissingProduct>;
  /**
   * The tasting lists for this collection for a specific user.
   * @deprecated Experimental - might change of be dropped!
   */
  _unstable_myTastingLists: Array<TastingList>;
  /**
   * Outputs for a collection
   * @deprecated Experimental, will be removed. Use _unstable_outputConfigurations instead.
   */
  _unstable_outputs: Array<CollectionOutputConfiguration>;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_product: Unstable_CollectionProductEdge;
  /** @deprecated Experimental. May be renamed or removed without notice! Use at your own risk. */
  _unstable_products: Unstable_CollectionProductConnection;
  /**
   * The Bottlebooks Classic fields recommended to be configured based on outputs.
   * @deprecated Experimental - might change or be dropped!
   */
  _unstable_recommendedClassicFields: Array<RecommendedClassicField>;
  /**
   * collectionIds that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollectionIds: Scalars['ID']['output'];
  /**
   * Access collections that are related to this one.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_relatedCollections: CollectionConnection;
  /** @deprecated Experimental. Use at your own risk! */
  _unstable_requestedProducts: Unstable_RequestedProductConnection;
  /**
   * The products registered for a collection that have not been requested by the organizer.
   * @deprecated Experimental and unstable. Use at your own risk!
   */
  _unstable_unrequestedProducts: RegisteredProductConnection;
  /** @deprecated Experimental. Don't use yet. */
  _unstable_useNewForms: Scalars['Boolean']['output'];
  /** @deprecated Experimental. Don't use yet. */
  _unstable_validValueLists: Unstable_ValidValueLists;
  /** The default catalog. */
  catalog?: Maybe<CatalogConfiguration>;
  /** An alias for shareListId. */
  collectionId: Scalars['ID']['output'];
  collectionType: CollectionType;
  /** The collection name. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the collection was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /**
   * All the deleted registrations for a collection.
   * @deprecated Experimental
   */
  deletedRegistrations: Array<Registration>;
  /** The public description of the collection. */
  description?: Maybe<Scalars['String']['output']>;
  /** The collection steps. */
  enabledSteps: Array<RegistrationStep>;
  /** @deprecated use shareListId instead. */
  eventId?: Maybe<Scalars['ID']['output']>;
  /** General instructions for exhibitors. */
  exhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /**
   * A particular form for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  form: Form;
  /**
   * The allowed form types for this collection.
   * @deprecated Experimental - use at your own risk!
   */
  formTypes: Array<FormType>;
  /**
   * All the forms for the collection.
   * @deprecated Experimental - use at your own risk!
   */
  forms: Array<Form>;
  /** This collection has a product master list that specifies which products suppliers or exhibitors must register. */
  hasProductMasterList: Scalars['Boolean']['output'];
  /** This collection has an overall sorting for the products with optional flighting details. These events are often referred to as 'product-led events' where there are no exhibitors. sortIndex, flightName, and productLabel are null when this is false. */
  isProductSortingEnabled: Scalars['Boolean']['output'];
  /** @deprecated This resolver is under development and is not stable. */
  list?: Maybe<CollectionList>;
  /** @deprecated use shareListId instead. */
  listId: Scalars['ID']['output'];
  /** @deprecated This resolver is under development and is not stable. */
  lists: CollectionListConnection;
  /** All the configured locales of the event. */
  locales: Array<Scalars['String']['output']>;
  /** Instructions for exhibitors after login. */
  loggedInExhibitorInstructions?: Maybe<Scalars['String']['output']>;
  /** The collection logo. Often this is the collection owner's logo. */
  logo?: Maybe<CloudinaryAsset>;
  mainImage?: Maybe<CloudinaryAsset>;
  /** The maximum products of the collection per registration. */
  maximumProducts?: Maybe<Scalars['Int']['output']>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingAvailabilities: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  meetingTimeslots: Array<MeetingTimeslot>;
  /**
   * The available timeslots for this collection.
   * The timeslots are sorted by start time and contain the timezone offets for the event's location.
   * Use this information to display the timeslots in the user's timezone.
   */
  myMeetingTimeslots: Array<MeetingTimeslot>;
  /**
   * All the company registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  myRegistrations: RegistrationConnection;
  /** The collection name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The contacts that get notifications from the organizer regarding their registrations. */
  notificationContacts?: Maybe<Array<Maybe<Contact>>>;
  /** The brand owning the collection. */
  owner: Brand;
  permissions: CollectionPermissions;
  producer?: Maybe<Producer>;
  producers: ProducerConnection;
  product?: Maybe<Product>;
  /** Exhibitor instructions for adding products. */
  productInstructions?: Maybe<Scalars['String']['output']>;
  products: ProductConnection;
  /**
   * The URL of the public view of the share list.
   * This is the link the share recipients will receive in the email.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The questions configured for this collection.
   * @deprecated Experimental - might change or be dropped!
   */
  questions?: Maybe<Array<Question>>;
  /**
   * The brands producing products that have been registered at a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registeredBrands: RegisteredBrandConnection;
  /**
   * A product registered for a collection.
   * Because the same product might be added my multiple different partners,
   * you need to look at the registrations property to get the necessary details for each registration.
   * Not all types of collections support registeredProducts.
   */
  registeredProductVersion: RegisteredProduct;
  /** The products registered for a collection. */
  registeredProducts: RegisteredProductConnection;
  /** A particular registration. */
  registration?: Maybe<Registration>;
  /**
   * All the registrations for a collection.
   * @deprecated Experimental - not yet fully supported everywhere. Use on the top-level queries only for now.
   */
  registrations: RegistrationConnection;
  /**
   * The representative profiles of all registrations.
   * @deprecated Experimental. Use at your own risk!
   */
  representatives: Array<SiteUserProfile>;
  shareListId: Scalars['ID']['output'];
  /** The emails and possibly names of users that this list was shared with. */
  sharedWith?: Maybe<Array<Maybe<ShareRecipient>>>;
  /** The default site of the collection. */
  site?: Maybe<SiteConfiguration>;
  slug?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the collection was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The user profiles.
   * @deprecated Use visitors or representatives instead.
   */
  userProfiles: Array<SiteUserProfile>;
  visibilityStatus: VisibilityStatusType;
  /**
   * The visitor profiles of a collection. These are the registered and approved visitors.
   * @deprecated Experimental. Use at your own risk!
   */
  visitors: Array<SiteUserProfile>;
  /** The workspace the list belongs to. */
  workspaceId: Scalars['ID']['output'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_AllOutputConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_AllowAddViaQrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_ClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


/** A list of products to share publicly. */
export type ShareList_Unstable_DataArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_MissingProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_MyTastingListsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  sort?: InputMaybe<TastingListSortInput>;
  uid: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_OutputsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_ProductArgs = {
  experimentalKey: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


/** A list of products to share publicly. */
export type ShareList_Unstable_ProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


/** A list of products to share publicly. */
export type ShareList_Unstable_RecommendedClassicFieldsArgs = {
  experimentalKey: Scalars['String']['input'];
  formType?: InputMaybe<ClassicFormType>;
};


/** A list of products to share publicly. */
export type ShareList_Unstable_RelatedCollectionIdsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_RelatedCollectionsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_RequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A list of products to share publicly. */
export type ShareList_Unstable_UnrequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  versionTag?: InputMaybe<DataVersionTag>;
};


/** A list of products to share publicly. */
export type ShareList_Unstable_UseNewFormsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareList_Unstable_ValidValueListsArgs = {
  experimentalKey: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareListDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A list of products to share publicly. */
export type ShareListExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A list of products to share publicly. */
export type ShareListFormArgs = {
  type: FormType;
};


/** A list of products to share publicly. */
export type ShareListListArgs = {
  collectionListId: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareListListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A list of products to share publicly. */
export type ShareListLocalesArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<InterfaceLocale>;
};


/** A list of products to share publicly. */
export type ShareListLoggedInExhibitorInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A list of products to share publicly. */
export type ShareListMeetingAvailabilitiesArgs = {
  attendeeId: Scalars['String']['input'];
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  organizerId: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareListMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareListMyMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareListMyRegistrationsArgs = {
  companyId: Scalars['ID']['input'];
};


/** A list of products to share publicly. */
export type ShareListNameArgs = {
  format?: InputMaybe<TextFormat>;
};


/** A list of products to share publicly. */
export type ShareListProducerArgs = {
  producerId: Scalars['ID']['input'];
};


/** A list of products to share publicly. */
export type ShareListProducersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProducerSortInput>;
};


/** A list of products to share publicly. */
export type ShareListProductArgs = {
  productId: Scalars['ID']['input'];
};


/** A list of products to share publicly. */
export type ShareListProductInstructionsArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


/** A list of products to share publicly. */
export type ShareListProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
};


/** A list of products to share publicly. */
export type ShareListQuestionsArgs = {
  group: QuestionGroup;
};


/** A list of products to share publicly. */
export type ShareListRegisteredBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredBrandFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredBrandSortInput>;
};


/** A list of products to share publicly. */
export type ShareListRegisteredProductVersionArgs = {
  productVersionId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
};


/** A list of products to share publicly. */
export type ShareListRegisteredProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  useNext?: InputMaybe<Scalars['Boolean']['input']>;
  versionTag?: InputMaybe<DataVersionTag>;
};


/** A list of products to share publicly. */
export type ShareListRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


/** A list of products to share publicly. */
export type ShareListRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegistrationSortInput>;
};


/** A list of products to share publicly. */
export type ShareListRepresentativesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


/** A list of products to share publicly. */
export type ShareListSlugArgs = {
  format?: SlugFormat;
};


/** A list of products to share publicly. */
export type ShareListUserProfilesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
  roles: Array<SiteUserRole>;
  token: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};


/** A list of products to share publicly. */
export type ShareListVisitorsArgs = {
  experimentalKey: Scalars['String']['input'];
  visibleToRoles: Array<SiteUserRole>;
};

/** A list of shareLists that is sortable, filterable and can be paginated. */
export type ShareListConnection = Connection & {
  edges: Array<ShareListEdge>;
  nodes: Array<ShareList>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ShareListEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<ShareList>;
  node: ShareList;
  previous?: Maybe<ShareList>;
};

export type ShareListFieldsEnum =
  | 'createdAt'
  | 'listId'
  | 'name'
  | 'updatedAt';

export type ShareListSortInput = {
  fields?: InputMaybe<Array<InputMaybe<ShareListFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrder>>>;
};

export type ShareProductListByLinkInput = {
  /** The internal description of the shared product list. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the share, defaulting to the product list itself. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The product list to share. */
  productListId: Scalars['ID']['input'];
};

export type ShareProductListByLinkResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The public URL to share with others. */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** The newly created share. */
  shareList?: Maybe<ShareList>;
  /** The id of the newly created share. */
  shareListId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ShareProductListInput = {
  /** The internal description of the share. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The message that is sent to the recipients via email. */
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The product list to share */
  productListId: Scalars['ID']['input'];
  /** The recipients that the product list is shared with. */
  sharedWith: Array<SharedWithInput>;
};

export type ShareProductListResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The newly created share. */
  shareList?: Maybe<ShareList>;
  /** The id of the newly created share. */
  shareListId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ShareProductsByLinkInput = {
  /** The internal description of this share. */
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** The products you want to generate a link for. */
  productIds: Array<Scalars['ID']['input']>;
};

export type ShareProductsByLinkResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The public URL that can be shared with others. */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** The newly created share. */
  shareList?: Maybe<ShareList>;
  /** The id of the newly created share. */
  shareListId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ShareProductsInput = {
  /** An optional internal description for the share. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The email message that is sent to the recipients. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The name of the share that is created. */
  name: Scalars['String']['input'];
  /** The products you want to share. */
  productIds: Array<Scalars['ID']['input']>;
  /** The list of recipients for this share. */
  sharedWith: Array<SharedWithInput>;
};

export type ShareProductsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The newly created share. */
  shareList?: Maybe<ShareList>;
  /** The id of the newly created share. */
  shareListId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ShareRecipient = {
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ShareShareListInput = {
  /** The message that is sent to the recipients via email. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The id of the share to add new recipients to. */
  shareListId: Scalars['ID']['input'];
  /** The recipients of the share email. */
  sharedWith: Array<SharedWithInput>;
};

export type ShareShareListResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The existing share list including the new recipients. */
  shareList?: Maybe<ShareList>;
  /** The id of the existing share list. Included to match other share mutation responses. */
  shareListId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SharedWithInput = {
  /** The email address of a recipient. */
  email: Scalars['String']['input'];
  /** The name of the recipient. Currently not used. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SingleRegistration = Item & Registration & {
  /** @deprecated For debugging only */
  _raw: Scalars['JSON']['output'];
  /**
   * The state of the brands step in the registration workflow.
   * @deprecated Experimental. Will be moved into a workflow field. Only works for the new forms.
   */
  _unstable_brandsState: _Unstable_RegistrationWorkflowState;
  /**
   * The state of the contacts step in the registration workflow.
   * @deprecated Experimental. Will be moved into a workflow field. Only works for the new forms.
   */
  _unstable_contactsState: _Unstable_RegistrationWorkflowState;
  /**
   * The state of the overview step in the registration workflow.
   * @deprecated Experimental. Will be moved into a workflow field. Only works for the new forms.
   */
  _unstable_overviewState: _Unstable_RegistrationWorkflowState;
  /**
   * Brands the registering company owns.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_ownBrands: BrandConnection;
  /**
   * Brands in the portfolio of the registering company.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_portfolioBrands: BrandConnection;
  /**
   * The state of the pricing step in the registration workflow.
   * @deprecated Experimental. Will be moved into a workflow field. Only works for the new forms.
   */
  _unstable_pricingState: _Unstable_RegistrationWorkflowState;
  /**
   * The state of the products step in the registration workflow.
   * @deprecated Experimental. Will be moved into a workflow field. Only works for the new forms.
   */
  _unstable_productsState: _Unstable_RegistrationWorkflowState;
  /**
   * The state of the profile step in the registration workflow.
   * @deprecated Experimental. Will be moved into a workflow field. Only works for the new forms.
   */
  _unstable_profileState: _Unstable_RegistrationWorkflowState;
  /**
   * Returns a token to register products via QR code.
   * Only available when logged in, and only applicable for this registration and the current user.
   * May be invalidated at any point in time.
   * @deprecated Experimental. Will possibly be deleted.
   */
  _unstable_registrationToken?: Maybe<_Unstable_RegistrationToken>;
  /** @deprecated Experimental. Use at your own risk! */
  _unstable_requestedProducts: Unstable_RequestedProductConnection;
  /**
   * The state of the review step in the registration workflow.
   * @deprecated Experimental. Will be moved into a workflow field. Only works for the new forms.
   */
  _unstable_reviewState: _Unstable_RegistrationWorkflowState;
  /**
   * The state of the shipping step in the registration workflow.
   * @deprecated Experimental. Will be moved into a workflow field. Only works for the new forms.
   */
  _unstable_shippingState: _Unstable_RegistrationWorkflowState;
  /**
   * The state of the submitted step in the registration workflow.
   * @deprecated Experimental. Will be moved into a workflow field. Only works for the new forms.
   */
  _unstable_submittedState: _Unstable_RegistrationWorkflowState;
  /**
   * The products that have been registered with this registration, but not requested by the organizer.
   * @deprecated Experimental and unstable. Use at your own risk!
   */
  _unstable_unrequestedProducts: Next_RegisteredProductConnection;
  /** @deprecated Experimental. Don't use yet. */
  _unstable_validValueLists: Unstable_ValidValueLists;
  /** The activities executed on this registration. This shows the complete editing history of the registration. */
  activities: ActivityConnection;
  /** The attending contacts for a collection (mostly used for events). */
  attendingContacts?: Maybe<Array<Contact>>;
  /** @deprecated Use profile instead. */
  brand?: Maybe<Brand>;
  /** @deprecated use companyId instead. */
  brandId?: Maybe<Scalars['ID']['output']>;
  /** Consolidated list of characteristcs of all registered products. Includes both Product and Wine characteristics */
  characteristicsSummary: Array<Maybe<Scalars['String']['output']>>;
  /** The collection that the brand registered for. */
  collection?: Maybe<Collection>;
  /** The ID of the collection this registration belongs to. */
  collectionId: Scalars['ID']['output'];
  /** @deprecated Use profile instead. */
  company?: Maybe<CompanyProfile>;
  /** The ID of the registering company. */
  companyId: Scalars['ID']['output'];
  /** The contacts for a collection. */
  contacts?: Maybe<Array<Contact>>;
  /** The time when this registration was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The step that the brand is currently on in the registration. */
  currentStep?: Maybe<RegistrationStep>;
  /** A certain custom field for a product. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's raw text.
   * This is the shortest path to a custom field's value and always returns the raw text.
   * If you need to get typed values and more metadata, use customField instead.
   */
  customFieldText?: Maybe<Scalars['String']['output']>;
  /**
   * A certain custom field's value.
   * This is a shortcut – If you need more details, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields for that product. */
  customFields?: Maybe<Array<CustomField>>;
  /** Was all the data filled out, and is everything valid? */
  dataIsValid?: Maybe<Scalars['Boolean']['output']>;
  /** Consolidated list of denominations of all registered products. Use regionSummary to include parent regions */
  denominationSummary: Array<Maybe<Scalars['String']['output']>>;
  /** The steps finished in the registration. */
  finishedSteps?: Maybe<Array<RegistrationStep>>;
  formTypes: Array<FormType>;
  /**
   * The registration history.
   * @deprecated Use activity instead. This will never go into production, so we can remove it.
   */
  history?: Maybe<Array<Maybe<HistoryEntry>>>;
  /** Is this registration locked? A event cannot be edited. A company group registration cannot be accessed. */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** The ISO date when the registration was changed. */
  lastUpdate?: Maybe<Scalars['String']['output']>;
  lifecycleState?: Maybe<LifecycleState>;
  /** The maximum number of products to register. */
  maximumProducts?: Maybe<Scalars['Int']['output']>;
  /** The messages exchanged on this registration. This shows the complete communication history of the registration. */
  messages: MessageConnection;
  /** The name of the company that is registering. */
  name: Scalars['String']['output'];
  /** The contacts managing a registration. */
  notificationContacts?: Maybe<Array<Contact>>;
  /**
   * A product that can be added to the registration.
   * For authenticated queries only.
   * @deprecated Experimental - might be changed or removed without notice!
   */
  possibleProduct?: Maybe<RegisteredProduct>;
  /**
   * Products that can be added to the registration.
   * For authenticated queries only.
   * @deprecated Experimental - might be changed or removed without notice!
   */
  possibleProducts: Next_RegisteredProductConnection;
  /** Consolidated list of price ranges of all registered products. */
  priceRangeSummary: Array<Maybe<Scalars['String']['output']>>;
  /** Consolidated list of price ranges of all registered products. */
  priceSummary: Array<Maybe<Scalars['Float']['output']>>;
  pricing?: Maybe<EventPricing>;
  /** The primary contacts for this registration. */
  primaryContacts?: Maybe<Array<Contact>>;
  /** Consolidated list of primary varieties of all registered products. */
  primaryVarietySummary: Array<Maybe<Scalars['String']['output']>>;
  /** @deprecated Experimental! Use at your own risk. */
  producerForm: RegisteredBrandForm;
  /** @deprecated Use registeredBrands instead. */
  producers: RegisteredBrandConnection;
  /** @deprecated Experimental! Use at your own risk. */
  productForm: RegisteredProductForm;
  /** Consolidated list of product types. */
  productTypeSummary: Array<Maybe<Scalars['String']['output']>>;
  /**
   * The products in this registration.
   * @deprecated Use registeredProducts instead.
   */
  products: RegisteredProductConnection;
  /** The registering company's public profile for this collection. */
  profile?: Maybe<RegistrationProfile>;
  /** @deprecated Experimental! Use at your own risk. */
  profileForm: RegistrationProfileForm;
  /**
   * Returns the update token needed for updating profiles.
   * This is only available to organizers.
   * @deprecated Experimental. Use at your own risk!
   */
  profileUpdateToken: Scalars['String']['output'];
  /**
   * Products that have been added to other registrations recently.
   * For authenticated queries only.
   * @deprecated Experimental - might be changed or removed without notice!
   */
  recentProducts: Next_RegisteredProductConnection;
  /** Consolidated list of regions of all registered products. */
  regionSummary: Array<Maybe<Scalars['String']['output']>>;
  /** A single brand producing products that have been added to a registration. */
  registeredBrand?: Maybe<RegisteredBrand>;
  /**
   * The brands producing products that have been registered at a collection.
   * This is calculated by grouping the registered products by producerId.
   * @deprecated Experimental - not yet fully supported.
   */
  registeredBrands: RegisteredBrandConnection;
  /** A single product that is registered in this registration. */
  registeredProduct?: Maybe<RegisteredProduct>;
  /**
   * The products that have been registered with this registration.
   * By default the products are returned in the order they have been registered.
   */
  registeredProducts: Next_RegisteredProductConnection;
  registrationId: Scalars['ID']['output'];
  registrationInfoSheet: RegistrationInfoSheet;
  /**
   * The current registration state.
   * Can be the step that the brand was ever on or organizer actions like request updates
   */
  registrationState?: Maybe<RegistrationState>;
  /** A field showing the high-level progress (not started, in progress, completed etc.). */
  registrationStatus?: Maybe<RegistrationStatus>;
  /** The type of registration. */
  registrationType: RegistrationType;
  /**
   * The representatives of a company.
   * @deprecated Experimental. Use at your own risk!
   */
  representatives?: Maybe<Array<SiteUserProfile>>;
  stand?: Maybe<Stand>;
  /**
   * A list of stands that this registration is associated with.
   * This is only available for a few select events.
   */
  stands?: Maybe<Array<Stand>>;
  /** The steps that contains valid data. */
  validSteps?: Maybe<Array<RegistrationStep>>;
  workspaceId: Scalars['ID']['output'];
};


export type SingleRegistration_Unstable_OwnBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  filter?: InputMaybe<BrandFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type SingleRegistration_Unstable_PortfolioBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  filter?: InputMaybe<BrandFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type SingleRegistration_Unstable_RegistrationTokenArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type SingleRegistration_Unstable_RequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleRegistration_Unstable_UnrequestedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Next_RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Next_RegisteredProductSortInput>;
  versionTag?: InputMaybe<DataVersionTag>;
};


export type SingleRegistration_Unstable_ValidValueListsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type SingleRegistrationActivitiesArgs = {
  filter?: InputMaybe<ActivityFilterInput>;
};


export type SingleRegistrationContactsArgs = {
  filter?: InputMaybe<ContactFilterInput>;
};


export type SingleRegistrationCustomFieldArgs = {
  key: Scalars['String']['input'];
};


export type SingleRegistrationCustomFieldTextArgs = {
  key: Scalars['String']['input'];
};


export type SingleRegistrationCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


export type SingleRegistrationHistoryArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleRegistrationMaximumProductsArgs = {
  format?: InputMaybe<MaximumProductsFormat>;
};


export type SingleRegistrationMessagesArgs = {
  filter?: InputMaybe<MessageFilterInput>;
};


export type SingleRegistrationNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SingleRegistrationPossibleProductArgs = {
  productId: Scalars['ID']['input'];
  registrationId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};


export type SingleRegistrationPossibleProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  producerId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
  useNext?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleRegistrationProducersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredBrandFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredBrandSortInput>;
};


export type SingleRegistrationProductFormArgs = {
  type: FormType;
};


export type SingleRegistrationProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
};


export type SingleRegistrationProfileUpdateTokenArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type SingleRegistrationRecentProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegisteredProductFilterInput>;
  first?: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RegisteredProductSortInput>;
};


export type SingleRegistrationRegisteredBrandArgs = {
  brandId: Scalars['ID']['input'];
};


export type SingleRegistrationRegisteredBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleRegistrationRegisteredProductArgs = {
  productId: Scalars['ID']['input'];
  versionTag?: InputMaybe<DataVersionTag>;
};


export type SingleRegistrationRegisteredProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Next_RegisteredProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Next_RegisteredProductSortInput>;
};


export type SingleRegistrationRegistrationInfoSheetArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<ContentLocale>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type SingleRegistrationRepresentativesArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};

export type SingleRegistrationConnection = RegistrationConnection & {
  edges: Array<SingleRegistrationEdge>;
  /** Groups the registrations by a particular field. */
  group: Array<SingleRegistrationGroupConnection>;
  nodes: Array<SingleRegistration>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type SingleRegistrationConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: RegistrationGroupField;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};

export type SingleRegistrationEdge = Edge & RegistrationEdge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<SingleRegistration>;
  node: SingleRegistration;
  previous?: Maybe<SingleRegistration>;
};

export type SingleRegistrationGroupConnection = RegistrationGroupConnection & {
  edges: Array<SingleRegistrationEdge>;
  fieldName: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  /** Groups the registrations by a particular field. */
  group: Array<SingleRegistrationGroupConnection>;
  nodes: Array<SingleRegistration>;
  pageInfo: Next_PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type SingleRegistrationGroupConnectionGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  field: RegistrationGroupField;
  filter?: InputMaybe<RegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Next_GroupConnectionSortInput>>;
};

export type SingleRegistrationSortInput = {
  name?: InputMaybe<SortOrder>;
  stand?: InputMaybe<EventAreaSortInput>;
};

export type SingleSelectionField = {
  key?: Maybe<Scalars['String']['output']>;
  translations?: Maybe<LocalizedText>;
};

export type SingleSelectionInput = {
  key?: InputMaybe<Scalars['String']['input']>;
};

export type SiteConfiguration = {
  collectionId: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  menuItems: Array<MenuItem>;
  /** The public facing URL of the site. */
  publicUrl: Scalars['String']['output'];
  /** The unique id of the site configuration. */
  siteConfigurationId: Scalars['ID']['output'];
};

export type SiteUserContactType =
  | 'EMAIL'
  | 'IMESSAGE'
  | 'LINKEDIN'
  | 'TELEPHONE'
  | 'WHATSAPP';

export type SiteUserProfile = {
  /** The roles the attendee accepts chats from. */
  acceptsChatsFrom: Array<SiteUserRole>;
  /** The  roles the attendees accepts meeting requests from. */
  acceptsMeetingsFrom: Array<SiteUserRole>;
  /**
   * The attendee's profile ID.
   * This links the attendee to a particular profile that has been pre-loaded into the networking feature.
   */
  attendeeProfileIds: Array<Maybe<Scalars['ID']['output']>>;
  /** The attendee's userId that claimed this representative. */
  claimedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Is this profile claimed by a user? */
  claimedState: SiteUserProfileClaimedState;
  /** The collection of this profile. */
  collection: Collection;
  /** The collection ID of this profile. */
  collectionId: Scalars['ID']['output'];
  /**
   * The attendee's company ID.
   * This links the attendee to an exhibiting company they are representing.
   */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** The attendee's company name. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Describes how the user prefers to be contacted. */
  contactMeVia: Array<SiteUserContactType>;
  /** The attendee's display name. */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * The attendee's email address.
   * Can only be read by the attendee themself or an admin.
   */
  email: Scalars['String']['output'];
  /** @deprecated Use uid instead. */
  id: Scalars['ID']['output'];
  /** The attendee's job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** The linkedIn profile URL. */
  linkedInURL?: Maybe<Scalars['String']['output']>;
  /**
   * If this is a representative user profile that has the same email as the .
   * @deprecated Not fully implemented.
   */
  mayClaim?: Maybe<Scalars['Boolean']['output']>;
  /** The meeting timeslots of this user. */
  meetingTimeslots: Array<MeetingTimeslot>;
  /** The profile image. */
  profileImage?: Maybe<CloudinaryAsset>;
  /**
   * The profile image URL.
   * @deprecated Use profileImageUrl instead (camel cased).
   */
  profileImageURL?: Maybe<Scalars['String']['output']>;
  /** The profile image URL. */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The attendee's registration.
   * This is only set if the attendee is a company representative.
   */
  registration?: Maybe<SingleRegistration>;
  /**
   * The attendee's registrationId.
   * Links the attendee to a particular registration.
   * This is only set if the attendee is a company representative.
   */
  registrationId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated We don't use contact for representatives - they are site user profiles instead. */
  representative?: Maybe<Contact>;
  /**
   * The attendee's company representative ID.
   * This links the attendee to a particular company representative.
   * @deprecated Use attendeeProfileIds instead.
   */
  representativeId?: Maybe<Scalars['ID']['output']>;
  /** The attendee's roles. */
  roles: Array<SiteUserRole>;
  /**
   * The attendee's phone number.
   * Can only be read by the attendee themself or an admin.
   */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The uniquw id of the profile. */
  uid: Scalars['ID']['output'];
  /** The roles of other attendees this profile is visible to. */
  visibleToRoles: Array<SiteUserRole>;
};


export type SiteUserProfileCompanyNameArgs = {
  format?: TextFormat;
};


export type SiteUserProfileDisplayNameArgs = {
  format?: TextFormat;
};


export type SiteUserProfileEmailArgs = {
  format?: UrlFormat;
};


export type SiteUserProfileJobTitleArgs = {
  format?: TextFormat;
};


export type SiteUserProfileLinkedInUrlArgs = {
  format?: UrlFormat;
};


export type SiteUserProfileMayClaimArgs = {
  userId: Scalars['ID']['input'];
};


export type SiteUserProfileMeetingTimeslotsArgs = {
  experiment: Scalars['String']['input'];
  experimentToken: Scalars['String']['input'];
};


export type SiteUserProfileProfileImageUrlArgs = {
  format?: UrlFormat;
};


export type SiteUserProfileTelephoneArgs = {
  format?: TelephoneFormat;
};

export type SiteUserProfileClaimedState =
  /** The profile is locked to the user currently connected. */
  | 'CLAIMED'
  /** This user can be claimed by another user. */
  | 'UNCLAIMED';

export type SiteUserProfileInput = {
  /** Which roles the user accepts chats from. */
  acceptsChatsFrom?: InputMaybe<Array<SiteUserRole>>;
  /** Which roles the user accepts meetings from. */
  acceptsMeetingsFrom?: InputMaybe<Array<SiteUserRole>>;
  /** The user's company name. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Describes how the user prefers to be contacted. */
  contactMeVia?: InputMaybe<Array<SiteUserContactType>>;
  /** The user's display name. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Determines if the user has accepted the terms of service. */
  hasAcceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's job title. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** The linkedIn profile URL. */
  linkedInURL?: InputMaybe<Scalars['String']['input']>;
  /** The new profile image. Use REST upload service to upload the image first, then use profileImageUrl. */
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
  /** The new profile image url. Images must be uploaded to the CDN first using the REST service. */
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The user's roles. */
  roles?: InputMaybe<Array<SiteUserRole>>;
  /**
   * The user's phone number.
   * Can only be read by the user themself or an admin.
   */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unique user ID.
   * Coming from the authentication provider.
   * This determines which user is being updated.
   * It can't be used to update the user profile.
   */
  uid: Scalars['ID']['input'];
  /** The user's visibility. */
  visibleToRoles?: InputMaybe<Array<SiteUserRole>>;
};

export type SiteUserProfileResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  profile?: Maybe<SiteUserProfile>;
  success: Scalars['Boolean']['output'];
};


export type SiteUserProfileResponseProfileArgs = {
  locale?: InputMaybe<ContentLocale>;
};

export type SiteUserProfileVisibility =
  /** The profile is visible to exhibitors' representatives. */
  | 'EXHIBITOR'
  /** The profile is publicly visible. */
  | 'PUBLIC'
  /** The profile is visible to authenticated visitors. */
  | 'VISITOR';

export type SiteUserRole =
  /** The user is anonymous or not logged in. */
  | 'ANONYMOUS'
  /** The user acts as a company representative. */
  | 'REPRESENTATIVE'
  /** The user is an authenticated visitor. */
  | 'VISITOR';

export type SkipRegistrationInput = {
  /** The ID of the collection. */
  collectionId: Scalars['ID']['input'];
  /** The ID of the company to skip. */
  companyId: Scalars['ID']['input'];
};

export type SkipRegistrationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  registration?: Maybe<Registration>;
  success: Scalars['Boolean']['output'];
};

export type SlugFormat =
  /** Only the id. It's not changing over time. */
  | 'ID'
  /** A slug without collisions, using the ID and the name. */
  | 'ID_SLASH_NAME'
  /**
   * A slug derived from the name.
   * It might have collisions with different objects and might change over time.
   */
  | 'NAME'
  /**
   * A slug without collisions. It's derived from the name and the first characters of a hash over the id.
   * While the name part might change, the hash is stable over time.
   */
  | 'NAME_AND_HASH';

export type SocialComplianceProgram = {
  certificate?: Maybe<CloudinaryAsset>;
  /** @deprecated Use certificate instead */
  certificateUrl?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
};


export type SocialComplianceProgramCertificateUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type SocialComplianceProgramLevelArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SocialComplianceProgramNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SocialComplianceProgramValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type SoilType = {
  percentage?: Maybe<Scalars['Float']['output']>;
  soilType: Scalars['String']['output'];
};


export type SoilTypeSoilTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type SortOrder =
  | 'ASC'
  | 'DESC';

export type Spirit = ExtendedProduct & Item & Product & {
  /**
   * The GTIN of the product.
   *
   * Returns the GTIN of the first product variant.
   */
  GTIN?: Maybe<Scalars['String']['output']>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_childProducts: Array<Unstable_CoreProduct>;
  /**
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_packaging: Array<ProductPackaging>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_parentProduct?: Maybe<Unstable_CoreProduct>;
  /** @deprecated Don't use - will be deleted soon! */
  _unstable_parentProductDifferences: Array<ProductVersionChange>;
  /**
   * A list of private workspace-owned events.
   *
   * This can be used to get all the field configurations for a product to edit.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioConfigurations: Array<Event>;
  /**
   * A list of registeredProduct entries.
   * This can be used for collection-based Portfolio.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioRegisteredProducts: RegisteredProductConnection;
  /**
   * The primary packaging (typically a bottle).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_primaryPackaging?: Maybe<PrimaryProductPackaging>;
  /**
   * The secondary packaging (typically a case).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_secondaryPackaging?: Maybe<SecondaryProductPackaging>;
  /**
   * The tertiary packaging (typically a pallet).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_tertiaryPackaging?: Maybe<TertiaryProductPackaging>;
  /**
   * A product's workspace.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_workspace: Workspace;
  /** The measurement method of the total acidity. */
  acidityUnit?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage of alcohol actually measured.
   * This is the analytical value measured in the lab.
   * This value is normally not communicated, only for some professional tastings.
   */
  actualAlcohol?: Maybe<Scalars['Float']['output']>;
  /** The age statement for this spirit, if appicable */
  ageStatement?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage of alcohol as displayed on the label.
   * This is often rounded according to local regulations.
   */
  alcohol?: Maybe<Scalars['Float']['output']>;
  /** Utility function to get all allergens as a single line of text. */
  allergensText?: Maybe<Scalars['String']['output']>;
  animalProducts?: Maybe<Scalars['Boolean']['output']>;
  /** The color of the product. */
  apparentColor?: Maybe<Scalars['String']['output']>;
  /** The appearance description for this product. */
  appearanceDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity of the appearance. */
  appearanceIntensity?: Maybe<Scalars['String']['output']>;
  /** Floral hints on the aroma. */
  aromaFloral?: Maybe<Scalars['String']['output']>;
  /** Fruity notes on the aroma. */
  aromaFruit?: Maybe<Scalars['String']['output']>;
  /** The intensity of the aroma. */
  aromaIntensity?: Maybe<Scalars['String']['output']>;
  /** Spicy aspects of the aroma. */
  aromaSpice?: Maybe<Scalars['String']['output']>;
  /** Wooden scents on that product. */
  aromaWood?: Maybe<Scalars['String']['output']>;
  awards?: Maybe<Array<SpiritAward>>;
  backLabelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use backLabelImage { url } instead. */
  backLabelImageUrl?: Maybe<Scalars['String']['output']>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  /** @deprecated Use biodynamicCertificate instead */
  biodynamicCertificateUrl?: Maybe<Scalars['String']['output']>;
  bottleImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use bottleImage { url } instead. */
  bottleImageUrl?: Maybe<Scalars['String']['output']>;
  bottleVariants?: Maybe<Array<ProductBottleVariant>>;
  /**
   * The bottles per case.
   *
   * Returns the bottles per case of the first packaging variant.
   */
  bottlesPerCase?: Maybe<Scalars['Int']['output']>;
  bottlingDate?: Maybe<Scalars['String']['output']>;
  /** The sugars per 100ml in grams. */
  carbohydrateSugars?: Maybe<Scalars['Float']['output']>;
  /** The carbohydrate per 100ml in grams. */
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  /**
   * The GTIN of the product case.
   *
   * Returns the GTIN of the first packaging variant.
   */
  caseGTIN?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<ProductCertification>>;
  characteristics?: Maybe<Array<Maybe<ProductCharacteristicEnum>>>;
  /** The profile of the importer, retailer or company behind the product. */
  companyProfile?: Maybe<CompanyProfile>;
  /** The product description target consumers. */
  consumerDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the consumer product variant (typically the vintage of a wine or any other information).
   * @deprecated Experimental - use at your own risk.
   */
  consumerProductVariant?: Maybe<Scalars['String']['output']>;
  containsCelery?: Maybe<Scalars['Boolean']['output']>;
  containsCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  containsEggs?: Maybe<Scalars['Boolean']['output']>;
  containsFish?: Maybe<Scalars['Boolean']['output']>;
  containsGluten?: Maybe<Scalars['Boolean']['output']>;
  containsLupin?: Maybe<Scalars['Boolean']['output']>;
  containsMilk?: Maybe<Scalars['Boolean']['output']>;
  containsMolluscs?: Maybe<Scalars['Boolean']['output']>;
  containsMustard?: Maybe<Scalars['Boolean']['output']>;
  containsNuts?: Maybe<Scalars['Boolean']['output']>;
  containsPeanuts?: Maybe<Scalars['Boolean']['output']>;
  containsSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  containsSoybeans?: Maybe<Scalars['Boolean']['output']>;
  containsSulfites?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A number describing the product's content completeness.
   * The guiding principle is that those pieces of content must be valuable to the majority of visitors.
   * Currently bottle image, alcohol, wine description, webshop, food pairing description
   * and product videos are fields that each raise the content level.
   * The content level calculation will change and mature over time, similar to the Google PageRank.
   */
  contentLevel: Scalars['Int']['output'];
  /** The country the product was produced in. */
  country?: Maybe<Scalars['String']['output']>;
  /** A certain custom field, available on events and requests. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's raw text.
   * This is the shortest path to a custom field's value and always returns the raw text.
   * If you need to get typed values and more metadata, use customField instead.
   */
  customFieldText?: Maybe<Scalars['String']['output']>;
  /**
   * A certain custom field's value, available on events and requests.
   * This is a shortcut – If you need more, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields available on events and requests. */
  customFields?: Maybe<Array<CustomField>>;
  /** The customized name of the region. */
  customRegion?: Maybe<Scalars['String']['output']>;
  /** The customized name of the subregion. */
  customSubregion?: Maybe<Scalars['String']['output']>;
  /**
   * An Excel document containing all the product data in a printable format,
   * also enabling data extraction and reuse.
   */
  dataFile?: Maybe<ProductDataFile>;
  /**
   * The name of the denomination. This extends the logic of regionName and
   * uses custom logic for specific regions such as Spain and Austria.
   */
  denomination?: Maybe<Scalars['String']['output']>;
  /** The product description for the trade. */
  description?: Maybe<Scalars['String']['output']>;
  /** The product's related e-labels. */
  eLabels: ELabelConnection;
  /** The energy value in kcal per 100ml. */
  energyKcal?: Maybe<Scalars['Float']['output']>;
  /** The energy value in kJ per 100ml. */
  energyKj?: Maybe<Scalars['Float']['output']>;
  /** The exhibitor presenting a product at an event. */
  exhibitor?: Maybe<Exhibitor>;
  /** The ID of an exhibitor presenting the product at an event. */
  exhibitorId?: Maybe<Scalars['ID']['output']>;
  /** The fat per 100ml in grams. */
  fat?: Maybe<Scalars['Float']['output']>;
  /** A list of content features that make this product more valuable to visitors than other products. */
  featuredContentTypes?: Maybe<Array<FeaturedProductContentType>>;
  fileLibrary?: Maybe<Array<ProductFileAttachment>>;
  /** Shows files attached to this product. */
  files?: Maybe<FileConnection>;
  /**
   * The list of fining agents used.
   * If null, the fining agents are not known.
   * If an empty array, there were no fining agents used.
   */
  finingAgents?: Maybe<Array<Scalars['String']['output']>>;
  /** The finish description for this product. */
  finishDescription?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  history?: Maybe<Array<Maybe<HistoryEntry>>>;
  /** A printable product info sheet as a PDF. */
  infoSheet?: Maybe<ProductInfoSheet>;
  ingredients?: Maybe<Array<ProductIngredient>>;
  /** Utility function to get all ingredients as a string. */
  ingredientsText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryAromas instead. */
  intenseAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryFlavors instead. */
  intenseFlavors?: Maybe<Array<Scalars['String']['output']>>;
  internationalCertifications?: Maybe<Array<InternationalProductCertification>>;
  /**
   * The inventory ID specific to the company.
   * @deprecated Use productExternalId instead.
   */
  inventoryId?: Maybe<Scalars['String']['output']>;
  /**
   * The secondary inventory ID specific to the company.
   * @deprecated Use productExternalId2 instead.
   */
  inventoryId2?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCelery instead. */
  isCelery?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** Has spirit been chill filtered? */
  isChillFiltered?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCrustaceans instead. */
  isCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsEggs instead. */
  isEggs?: Maybe<Scalars['Boolean']['output']>;
  isFairtrade?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsFish instead. */
  isFish?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsGluten instead. */
  isGluten?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is this product free of genetically modified organisms?
   * "Not sure", "not asked" and "not answered" all resolve to null.
   */
  isGmoFree?: Maybe<Scalars['Boolean']['output']>;
  isKosher?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsLupin instead. */
  isLupin?: Maybe<Scalars['Boolean']['output']>;
  isMevushal?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMilk instead. */
  isMilk?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMolluscs instead. */
  isMolluscs?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMustard instead. */
  isMustard?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsNuts instead. */
  isNuts?: Maybe<Scalars['Boolean']['output']>;
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsPeanuts instead. */
  isPeanuts?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSesameSeeds instead. */
  isSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSoybeans instead. */
  isSoybeans?: Maybe<Scalars['Boolean']['output']>;
  isSustainable?: Maybe<Scalars['Boolean']['output']>;
  isVegan?: Maybe<Scalars['Boolean']['output']>;
  isVegetarian?: Maybe<Scalars['Boolean']['output']>;
  labelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use labelImage { url } instead. */
  labelImageUrl?: Maybe<Scalars['String']['output']>;
  localCertifications?: Maybe<Array<LocalProductCertification>>;
  /** Low / no alcohol statement. */
  lowNoAlcoholStatement?: Maybe<Scalars['String']['output']>;
  lwinId?: Maybe<Scalars['String']['output']>;
  /**
   * The amount of malic acid in grams/liter.
   * This value is not commonly communicated.
   */
  malicAcid?: Maybe<Scalars['Float']['output']>;
  /** Notes on how to market this wine. */
  marketingNotes?: Maybe<Scalars['String']['output']>;
  maxTemp?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryAromas instead. */
  mildAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryFlavors instead. */
  mildFlavors?: Maybe<Array<Scalars['String']['output']>>;
  minTemp?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The nose description for this product. */
  noseDescription?: Maybe<Scalars['String']['output']>;
  onlineShop?: Maybe<Scalars['String']['output']>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  /** Awards not in the list of recognized awards. Free text. */
  otherAwards?: Maybe<Scalars['String']['output']>;
  /** All sustainability certifications not covered in localCertifications and internationalCertifications can be added as free text. */
  otherSustainabilityCertifications?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use productRange instead. */
  ownClassification?: Maybe<Scalars['String']['output']>;
  /** The packaging gas used. This is automatically included in ingredientsText. */
  packagingGasesFunction?: Maybe<Scalars['String']['output']>;
  packagingVariants?: Maybe<Array<ProductPackagingVariant>>;
  /** The food pairing description for this product. */
  pairingDescription?: Maybe<Scalars['String']['output']>;
  /** Food pairings that match well with the product. */
  pairings?: Maybe<Array<Scalars['String']['output']>>;
  /** The color of the product. */
  palateAcidity?: Maybe<Scalars['String']['output']>;
  /** The body of the product. */
  palateBody?: Maybe<Scalars['String']['output']>;
  /** The palate description for this product. */
  palateDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity on the palate. */
  palateIntensity?: Maybe<Scalars['String']['output']>;
  /** The tannins of the product. */
  palateTannins?: Maybe<Scalars['String']['output']>;
  /**
   * The GTIN of the pallet.
   *
   * Returns the pallet GTIN of the first packaging variant.
   */
  palletGTIN?: Maybe<Scalars['String']['output']>;
  /** The ideal way to enjoy this spirit. */
  perfectServe?: Maybe<Scalars['String']['output']>;
  /**
   * The list of permissions on the product.
   * @deprecated We're considering to replace the list of strings with particular fields to reduce the data load when you just need a few permissions.
   */
  permissionList?: Maybe<Array<ProductRolesEnum>>;
  permissions: ProductPermissions;
  pressAnecdotes?: Maybe<Scalars['String']['output']>;
  /**
   * A price for this product.
   * @deprecated Use registeredProduct.pricing instead.
   */
  pricing?: Maybe<ProductPrice>;
  /** A list of primary aromas in the nose. */
  primaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of primary flavors on the palate. */
  primaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  /** The product's producer. */
  producer?: Maybe<Producer>;
  productCategory?: Maybe<ProductCategory>;
  /** productExternalId Should represent unique product ID specific to the company. Former inventoryId */
  productExternalId?: Maybe<Scalars['String']['output']>;
  /** productExternalId2 Should represent additional product ID specific to the company. Former inventoryId2 */
  productExternalId2?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productRange?: Maybe<Scalars['String']['output']>;
  productType: ProductType;
  /** The protein per 100ml in grams. */
  protein?: Maybe<Scalars['Float']['output']>;
  /**
   * The name that the customer is using internally to refer to this product.
   * @deprecated Experimental - use at your own risk.
   */
  referenceName?: Maybe<Scalars['String']['output']>;
  /**
   * The region the product was produced in.
   * This is one of the officialy recognized regions of the country.
   * Regions are often subdivided into subregions - that value can be found on Product.subregion.
   */
  region?: Maybe<Scalars['String']['output']>;
  /** The region hierarchy of a product, starting with country. */
  regionHierarchy?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The name of the subregion, region or country – whichever has a value:
   * - For products with subregion, the subregion is returned.
   * - For products with region only, the region is returned.
   * - For products with country, the country is returned.
   * - For products using custom names, the custom name is returned.
   */
  regionName?: Maybe<Scalars['String']['output']>;
  /** The sugar in grams/liter. */
  residualSugar?: Maybe<Scalars['Float']['output']>;
  /** The salt per 100ml in grams. */
  salt?: Maybe<Scalars['Float']['output']>;
  /** The saturates per 100ml in grams. */
  saturatedFat?: Maybe<Scalars['Float']['output']>;
  /** A list of secondary aromas in the nose. */
  secondaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of secondary flavors on the palate. */
  secondaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  shortName: Scalars['String']['output'];
  /**
   * A list of content features that make this product more valuable to visitors than other products.
   * The useIdOnly flag is deprecated, use format=ID instead.
   */
  slug: Scalars['String']['output'];
  /** The subtype of spirit */
  spiritSubtype?: Maybe<Scalars['String']['output']>;
  /** The type of spirit */
  spiritType?: Maybe<Scalars['String']['output']>;
  /** A stand on an event. */
  stand?: Maybe<Stand>;
  status?: Maybe<ProductStatus>;
  /**
   * The product name in a structured format.
   * @deprecated Used internally only and not ready for production - use name instead.
   */
  structuredName?: Maybe<StructuredProductName>;
  /**
   * The subregion the product was produced in.
   * This is one of the officialy recognized subregions of the region.
   */
  subregion?: Maybe<Scalars['String']['output']>;
  suggestedCategory?: Maybe<ProductCategory>;
  sulfurAdded?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use otherSustainabilityCertifications instead. */
  sustainabilityCertificatesOther?: Maybe<Scalars['String']['output']>;
  sustainabilityId?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tastingNotes?: Maybe<Array<ProductTastingNote>>;
  /** The total acidity in grams/liter. */
  totalAcidity?: Maybe<Scalars['Float']['output']>;
  /** An ISO date when the product was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Shows the collections this product is used in. */
  usedIn?: Maybe<ProductUsedInConnection>;
  /** Shows the e-labels where this product is used in. */
  usedInELabels?: Maybe<ProductUsedInELabelsConnection>;
  /**
   * The name of the product variant (bottle size, closure or other differentiating factor?
   * @deprecated Experimental - use at your own risk.
   */
  variantName?: Maybe<Scalars['String']['output']>;
  /** Product videos (Youtube, Vimeo, Instagram, Facebook etc.) */
  videos?: Maybe<Array<Maybe<Video>>>;
  /** The volume of each portion. */
  volumeOfPortion?: Maybe<Scalars['Float']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type SpiritGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type Spirit_Unstable_ChildProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Spirit_Unstable_PackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Spirit_Unstable_ParentProductArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Spirit_Unstable_ParentProductDifferencesArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Spirit_Unstable_PortfolioConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Spirit_Unstable_PortfolioRegisteredProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Spirit_Unstable_PrimaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Spirit_Unstable_SecondaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Spirit_Unstable_TertiaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Spirit_Unstable_WorkspaceArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type SpiritAcidityUnitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritApparentColorArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritAppearanceDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type SpiritAppearanceIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritAromaFloralArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritAromaFruitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritAromaIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritAromaSpiceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritAromaWoodArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritBottlingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type SpiritCaseGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type SpiritConsumerDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type SpiritConsumerProductVariantArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type SpiritCustomFieldArgs = {
  key: Scalars['String']['input'];
};


export type SpiritCustomFieldTextArgs = {
  key: Scalars['String']['input'];
};


export type SpiritCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


export type SpiritCustomRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritCustomSubregionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritDataFileArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type SpiritDenominationArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type SpiritDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type SpiritELabelsArgs = {
  filter?: InputMaybe<ELabelFilterInput>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type SpiritFilesArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
  filter?: InputMaybe<ProductFileFilterInput>;
};


export type SpiritFiningAgentsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritFinishDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type SpiritHistoryArgs = {
  filter?: InputMaybe<ProductHistoryFilterInput>;
};


export type SpiritInfoSheetArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<ContentLocale>;
};


export type SpiritIngredientsTextArgs = {
  format?: InputMaybe<IngredientsTextFormat>;
};


export type SpiritIntenseAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritIntenseFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritInventoryIdArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritInventoryId2Args = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritMildAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritMildFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritNameArgs = {
  format?: InputMaybe<TextFormat>;
  includeProducer?: InputMaybe<IncludeProducer>;
};


export type SpiritNoseDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type SpiritOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type SpiritOtherAwardsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type SpiritOtherSustainabilityCertificationsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type SpiritPackagingGasesFunctionArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritPairingDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type SpiritPairingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritPalateAcidityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritPalateBodyArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritPalateDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type SpiritPalateIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritPalateTanninsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritPalletGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type SpiritPressAnecdotesArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritPrimaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritPrimaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritProductCategoryArgs = {
  withSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpiritProductExternalIdArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritProductExternalId2Args = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritProductRangeArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritReferenceNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritRegionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type SpiritRegionHierarchyArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type SpiritRegionNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type SpiritSecondaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritSecondaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SpiritShortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritSlugArgs = {
  format?: InputMaybe<SlugFormat>;
  useIdOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpiritStructuredNameArgs = {
  algorithm?: InputMaybe<Scalars['String']['input']>;
};


export type SpiritSubregionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type SpiritTaglineArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritUsedInArgs = {
  filter?: InputMaybe<ProductUsedInFilterInput>;
};


export type SpiritVariantNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type SpiritWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};

/** An award given to a particular spirit. */
export type SpiritAward = ProductAward & {
  award?: Maybe<Scalars['String']['output']>;
  medal?: Maybe<Scalars['String']['output']>;
};


/** An award given to a particular spirit. */
export type SpiritAwardAwardArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** An award given to a particular spirit. */
export type SpiritAwardMedalArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type Stand = EventArea & Item & Node & {
  /** The type of area. Always STAND. */
  areaType: EventAreaType;
  areas: EventAreaConnection;
  /** A summary of the sub-areas of this area. Typically the stand number range. */
  areasSummary: Scalars['String']['output'];
  collection: Collection;
  collectionId: Scalars['ID']['output'];
  /** The color that contrasts the primary color. Typically either black or white. */
  contrastColor?: Maybe<Scalars['String']['output']>;
  /** A longer description of the area. */
  description: Scalars['String']['output'];
  event: Event;
  eventId: Scalars['ID']['output'];
  /**
   * The floor.
   * Only available for a few select events.
   */
  floor?: Maybe<Floor>;
  /**
   * The name of the floor.
   *  Only available for a few select events.
   * @deprecated Use floor.name instead.
   */
  floorName?: Maybe<Scalars['String']['output']>;
  floorPlanHotspot?: Maybe<FloorPlanHotspot>;
  /** @deprecated Don't use - unsupported yet. */
  form: EventAreaForm;
  id: Scalars['ID']['output'];
  /** The stand name as entered by the organizer. */
  name: Scalars['String']['output'];
  /**
   * The cleansed stand number.
   * This is typically the same as the stand name, but for some events we strip out some common information and parse out the stand number.
   */
  number?: Maybe<Scalars['String']['output']>;
  /**
   * The parsed list of stand numbers.
   * If an exhibitor has a range of stands, this will be the parsed list of all the stand numbers in that range.
   */
  numbers?: Maybe<Array<Scalars['String']['output']>>;
  parent?: Maybe<EventArea>;
  parentSlug?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<FloorPlan>;
  planHotspot?: Maybe<FloorPlanHotspot>;
  /** The primary color assigned to this area. */
  primaryColor?: Maybe<Scalars['String']['output']>;
  registration: SingleRegistration;
  registrationId: Scalars['ID']['output'];
  /**
   * The room.
   * Only available for a few select events.
   */
  room?: Maybe<Room>;
  /**
   * The name of the room.
   *  Only available for a few select events.
   * @deprecated Use room.name instead.
   */
  roomName?: Maybe<Scalars['String']['output']>;
  roomPlanHotspot?: Maybe<FloorPlanHotspot>;
  /** The stand slug. */
  slug: Scalars['String']['output'];
  sortIndex: Scalars['Int']['output'];
  stand?: Maybe<Stand>;
  /** The type of stand, often the prefix of the stand name. */
  standTypeName?: Maybe<Scalars['String']['output']>;
  /** The stand information excluding room and floor. (i.e. Stand 19) */
  standTypeWithNumber?: Maybe<Scalars['String']['output']>;
  /** A subtitle for the area. Typically the names of the regions, associations or exhibitors found in this area. */
  subtitle: Scalars['String']['output'];
};


export type StandAreasArgs = {
  filter?: InputMaybe<EventAreaFilterInput>;
};


export type StandAreasSummaryArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};


export type StandDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};


export type StandFloorNameArgs = {
  locale?: InputMaybe<ContentLocale>;
};


export type StandNameArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale?: InputMaybe<ContentLocale>;
};


export type StandRoomNameArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale?: InputMaybe<ContentLocale>;
};


export type StandSubtitleArgs = {
  fallbackLocales?: InputMaybe<Array<ContentLocale>>;
  locale: ContentLocale;
};

export type StandInput = {
  /** The stand name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The registration id */
  registrationId: Scalars['ID']['input'];
};

export type StartRegistrationInput = {
  /** The ID of the collection. */
  collectionId: Scalars['ID']['input'];
  /** The ID of the company to register. */
  companyId: Scalars['ID']['input'];
};

export type StartRegistrationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  registration?: Maybe<Registration>;
  success: Scalars['Boolean']['output'];
};

/**
 * A filter input type for string fields.
 * Use to filter products on vintage for example.
 */
export type StringQueryOperatorInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type Stripe = {
  billingPortalUrl?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<StripeProduct>>>;
};


export type StripeBillingPortalUrlArgs = {
  productCategory?: InputMaybe<StripeProductCategory>;
};


export type StripeProductsArgs = {
  productCategory?: InputMaybe<StripeProductCategory>;
};

export type StripeCheckoutConfig = {
  pubKey: Scalars['String']['output'];
};

export type StripeCheckoutData = {
  checkoutSession?: Maybe<StripeCheckoutSession>;
  config?: Maybe<StripeCheckoutConfig>;
  euVAT?: Maybe<Scalars['String']['output']>;
};

export type StripeCheckoutSession = {
  id: Scalars['String']['output'];
};

export type StripeProduct = {
  currencyOptions?: Maybe<Array<Maybe<StripeProductPrice>>>;
  maxELabels: Scalars['String']['output'];
  name: Scalars['String']['output'];
  packageKey: Scalars['String']['output'];
  price?: Maybe<StripeProductPrice>;
};

export type StripeProductCategory =
  | 'eLabel';

export type StripeProductPrice = {
  currency?: Maybe<Scalars['String']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export type StructuredProductName = {
  algorithm: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parts: Array<StructuredProductNamePart>;
  variant: Scalars['String']['output'];
};


export type StructuredProductNameNameArgs = {
  format?: InputMaybe<TextFormat>;
};

export type StructuredProductNamePart = {
  /** A suggestion how to format the part. */
  format: StructuredProductNamePartFormat;
  name: Scalars['String']['output'];
  parts?: Maybe<Array<StructuredProductNamePart>>;
  type: StructuredProductNamePartType;
};


export type StructuredProductNamePartNameArgs = {
  format?: InputMaybe<TextFormat>;
};

export type StructuredProductNamePartFormat =
  /** Format this part in an emphasized style, and place it next to its siblings, separated by some space. */
  | 'EMPHASIZED'
  /**
   * Place this part in a separate line if possible.
   * You can assume that sibling parts are also in LINE format.
   */
  | 'LINE'
  /** Place this part next to its siblings, separated by some space. */
  | 'SPAN';

export type StructuredProductNamePartType =
  /** The official denomination of this product. */
  | 'DENOMINATION'
  /**
   * A text without any further meaning.
   * Child parts might divide it into more concrete types.
   */
  | 'TEXT'
  /**
   * The single vineyard this product was produced in.
   * For now, we also return the village in this part because we can't store it in a separate field.
   */
  | 'VINEYARD'
  /** The product vintage. */
  | 'VINTAGE';

export type SubmitProductsInput = {
  /** An optional note explaining the new release. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The product ID's. */
  productIds: Array<Scalars['ID']['input']>;
  /** The ID of the workspace. */
  workspaceId: Scalars['ID']['input'];
};

export type SubmitProductsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Subscription = {
  expirationDate?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trial?: Maybe<Scalars['Boolean']['output']>;
  usage?: Maybe<Scalars['Int']['output']>;
};

export type SugarContent =
  | 'dry'
  | 'mediumDry'
  | 'mediumSweet'
  | 'sweet';

export type SupplierMap = {
  /** The matched partner object. */
  partner?: Maybe<Partner>;
  /** The matched partner id value. */
  partnerId: Scalars['ID']['output'];
  /** The source name of the supplier. */
  supplier: Scalars['String']['output'];
};

export type SustainabilityCertification = {
  certificate?: Maybe<CloudinaryAsset>;
  /** @deprecated Use certificate instead */
  certificateUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
};


export type SustainabilityCertificationCertificateUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type SustainabilityCertificationNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type SustainabilityCertificationValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type Task = {
  createdAt: Scalars['String']['output'];
  createdBy: UserProfile;
  description?: Maybe<Scalars['String']['output']>;
  state: TaskState;
  taskId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type TaskConfiguration = {
  description?: Maybe<Scalars['String']['output']>;
  targetType: TaskConfigurationTargetType;
  taskConfigurationId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type TaskConfigurationTargetType =
  | 'COLLECTION'
  | 'PRODUCT'
  | 'REGISTRATION';

export type TaskState =
  | 'ARCHIVED'
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED'
  | 'PARTIAL'
  | 'REVIEW_REQUIRED';

export type TastingList = Item & {
  allItems: Array<TastingListItem>;
  collectionId: Scalars['ID']['output'];
  /** @deprecated Not implemented yet. Use allItems instead. */
  items: TastingListItemConnection;
  name: Scalars['String']['output'];
  /** @deprecated Use allItems instead. */
  products: Array<TastingListProduct>;
  tastingListId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type TastingListItem = {
  addedAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  registration: SingleRegistration;
  registrationId: Scalars['ID']['output'];
  tastingList: TastingList;
  tastingListId: Scalars['ID']['output'];
  tastingListItemId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};


export type TastingListItemAddedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type TastingListItemConnection = {
  edges: Array<TastingListItemEdge>;
  group: Array<TastingListItemGroupConnection>;
  nodes: Array<TastingListItem>;
  pageInfo: PageInfo;
  tastingList: TastingList;
  totalCount: Scalars['Int']['output'];
};


export type TastingListItemConnectionGroupArgs = {
  field: TastingListItemGroupField;
  sort?: InputMaybe<TastingListItemSortInput>;
};

export type TastingListItemEdge = {
  cursor: Scalars['String']['output'];
  next?: Maybe<TastingListItem>;
  node: TastingListItem;
  previous?: Maybe<TastingListItem>;
};

export type TastingListItemGroupConnection = {
  edges: Array<TastingListItemEdge>;
  fieldName: TastingListItemGroupField;
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<TastingListItemGroupConnection>;
  nodes: Array<TastingListItem>;
  pageInfo: PageInfo;
  registration?: Maybe<SingleRegistration>;
  tastingList: TastingList;
  totalCount: Scalars['Int']['output'];
};


export type TastingListItemGroupConnectionGroupArgs = {
  field: TastingListItemGroupField;
  sort?: InputMaybe<TastingListItemSortInput>;
};

export type TastingListItemGroupField =
  | 'registrationId';

export type TastingListItemSortInput = {
  addedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  registration?: InputMaybe<SingleRegistrationSortInput>;
  registrationId?: InputMaybe<SortOrder>;
};

export type TastingListProduct = Item & TastingListItem & {
  addedAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  registeredProduct: RegisteredProduct;
  registration: SingleRegistration;
  registrationId: Scalars['ID']['output'];
  tastingList: TastingList;
  tastingListId: Scalars['ID']['output'];
  tastingListItemId: Scalars['ID']['output'];
  tastingNote?: Maybe<TastingNote>;
  userId: Scalars['ID']['output'];
};


export type TastingListProductAddedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type TastingListRegistration = Item & TastingListItem & {
  addedAt: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  registration: SingleRegistration;
  registrationId: Scalars['ID']['output'];
  tastingList: TastingList;
  tastingListId: Scalars['ID']['output'];
  tastingListItemId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};


export type TastingListRegistrationAddedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Can be used to sort tasting lists. */
export type TastingListSortInput = {
  addedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type TastingNote = Item & {
  addedAt: Scalars['String']['output'];
  collectionId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};


export type TastingNoteAddedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type TastingNoteUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type TelephoneFormat =
  /** Includes country identifier. */
  | 'INTERNATIONAL'
  /** Without country identifier. */
  | 'NATIONAL'
  /** Original value. */
  | 'RAW'
  /** For backwards compatibility with older Gatsby directories. */
  | 'TEXT'
  /** As clickable link (tel:). */
  | 'URL';

export type TertiaryProductPackaging = ProductPackaging & {
  /** The GTIN of the packaging level. */
  GTIN?: Maybe<Scalars['String']['output']>;
  /** A list of all net content declarations given. */
  allNetContents?: Maybe<Array<ContentValue>>;
  /**
   * The number of cases per layer on the platform.
   * This is an alias for quantityOfNextLowerLevelPerLayer.
   */
  casesPerLayer?: Maybe<Scalars['Int']['output']>;
  /** The depth of the packaging. */
  depth?: Maybe<LengthValue>;
  /** The gross weight of the package including all contents. */
  grossWeight?: Maybe<WeightValue>;
  /** The height of the packaging. */
  height?: Maybe<LengthValue>;
  /** The type of packaging. */
  hierarchyTypeCode: ProductPackagingHierarchyType;
  /** Returns true if this is the base unit. */
  isBaseUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the dispatchable unit. */
  isDispatchableUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is an invoice unit. */
  isInvoiceUnit?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the orderable unit. */
  isOrderableUnit?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The number of layers in the packaging hierarchy.
   * This is an alias for quantityOfLayers.
   */
  layers?: Maybe<Scalars['Int']['output']>;
  /** The level of the packaging as specified in GS1 standards. */
  level: Scalars['Int']['output'];
  /** The net content. For primary packaging this is the volume. */
  netContent?: Maybe<ContentValue>;
  /**
   * The net weight of the package without the contents.
   * This is the bottle weight, the case material weight or the net pallet weight.
   */
  packageNetWeight?: Maybe<WeightValue>;
  /** The package type as defined in GS1 standards. */
  packageTypeCode?: Maybe<PackageTypeCode>;
  /** The platform type (mostly pallet type) that a product is transported on. */
  platformTypeCode?: Maybe<ProductPackagingPlatformTypeCode>;
  /** The platform type name that a product is transported on (typically the localized pallet type name). */
  platformTypeName?: Maybe<Scalars['String']['output']>;
  /** The net weight of product itself without packaging. */
  productNetWeight?: Maybe<WeightValue>;
  /** The quantity of layers in the packaging. Typically the number of layers of a pallet. */
  quantityOfLayers?: Maybe<Scalars['Int']['output']>;
  /**
   * The quantity of the next lower level per layer in the packaging hierarchy.
   * For a pallet, this is the number of cases per layer.
   */
  quantityOfNextLowerLevelPerLayer?: Maybe<Scalars['Int']['output']>;
  /**
   * The total number of cases in the packaging hierarchy.
   * This is an alias for totalQuantityOfNextLowerLevel.
   */
  totalCases?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of items of the next lower level in the packaging hierarchy.
   * For a case, this is the number of bottles in the case.
   */
  totalQuantityOfNextLowerLevel?: Maybe<Scalars['Int']['output']>;
  /** The trade item unit type as defined in GS1 standards. */
  tradeItemUnit?: Maybe<TradeItemUnitDescriptorCode>;
  /** The width of the packaging. */
  width?: Maybe<LengthValue>;
};


export type TertiaryProductPackagingAllNetContentsArgs = {
  unit?: InputMaybe<ContentUnitCode>;
};


export type TertiaryProductPackagingDepthArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};


export type TertiaryProductPackagingGrossWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type TertiaryProductPackagingHeightArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};


export type TertiaryProductPackagingNetContentArgs = {
  unit?: InputMaybe<ContentUnitCode>;
};


export type TertiaryProductPackagingPackageNetWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type TertiaryProductPackagingPlatformTypeNameArgs = {
  locale: ContentLocale;
};


export type TertiaryProductPackagingProductNetWeightArgs = {
  unit?: InputMaybe<WeightUnitCode>;
};


export type TertiaryProductPackagingWidthArgs = {
  unit?: InputMaybe<LengthUnitCode>;
};

export type TextField = FormField & {
  /** The completion state for the component. */
  completionState?: Maybe<FormCompletionState>;
  /** The field's configuration. Dependent on the field type. */
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  /** The field's description, if any. */
  description?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  /** The field's unique identifier. */
  key: Scalars['ID']['output'];
  /** The field's label. */
  label: Scalars['String']['output'];
  /** @deprecated Experimental. */
  name?: Maybe<Scalars['String']['output']>;
  /** The field's type. */
  type: FormFieldType;
  /** @deprecated Use the value field on the FormComponent instead. */
  value?: Maybe<TextFieldValue>;
};


export type TextFieldDescriptionArgs = {
  locale: InterfaceLocale;
};


export type TextFieldLabelArgs = {
  locale: InterfaceLocale;
};

export type TextFieldValue = FieldValue & {
  /** The text as stored in the database. */
  rawText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use value instead. */
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TextFormat =
  | 'RAW'
  | 'TRIMMED';

export type ToggleNotificationContactLockInput = {
  /** The id of the contact to remove. */
  contactId: Scalars['ID']['input'];
  /** The state to be set in the contact. */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the registration where the contact should be removed. */
  registrationId: Scalars['ID']['input'];
};

export type ToggleNotificationContactLockResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * The trade item unit type as defined in GS1 standards.
 *
 * The individual trade item units have been copied from GS1. Not all descriptors might be applicable to all products.
 */
export type TradeItemUnitDescriptorCode =
  /** The lowest level of the item hierarchy intended or labeled for individual resale. */
  | 'BASE_UNIT_OR_EACH'
  /** The standard shipping unit level. */
  | 'CASE'
  /**
   * A display or shipper is a special case item that includes both
   * consumer units and packaging materials to be assembled and used to display the product for sale.
   * May contain cases or consumer units.
   * It may be the orderable or dispatchable unit and may be shipped on a pallet.
   */
  | 'DISPLAY_SHIPPER'
  /** A 'mixed mod' or 'display ready pallet' that is not the normal 'turn' for ordering. */
  | 'MIXED_MODULE'
  /**
   * A logistical unit between case and each.
   * This may be a consumable innerpack (i.e. Carton of Cigarettes)
   * or it may be simply a logistical pack (i.e. Dozes of toothbrushes).
   */
  | 'PACK_OR_INNER_PACK'
  /** A unit load that contains a single or multiple GTINs Includes box pallet */
  | 'PALLET'
  /** The trade item above the pallet level used for transporting trade items. For example truck load, container, rail car, ship, etc. */
  | 'TRANSPORT_LOAD';

export type UnblockTimeslotInput = {
  /** The uid of the meeting. */
  meetingId: Scalars['String']['input'];
};

export type UnblockTimeslotResponse = MutationResponse & {
  code: Scalars['String']['output'];
  meeting?: Maybe<Meeting>;
  message: Scalars['String']['output'];
  organizerToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UndeleteRegistrationsInput = {
  /** The collection id of the registrations. */
  collectionId: Scalars['ID']['input'];
  /** The registration ids to be undeleted. */
  registrationIds: Array<Scalars['ID']['input']>;
};

export type UndeleteRegistrationsResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** A field change that cannot be determined. */
export type UnknownFieldChange = FieldChange & {
  /** If the field was changed within a collection, this describes the collection. */
  collection?: Maybe<Collection>;
  /** The name of the collection where this field was changed in. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The ISO date that this field was changed at. */
  date: Scalars['String']['output'];
  /** The field involved in the change. */
  field: ChangedField;
  /** The unique id of the field change. */
  fieldChangeId: Scalars['ID']['output'];
  /** The type of change made. */
  fieldChangeType: FieldChangeType;
  /** The product on which the change was made. */
  product: Product;
  /** The user and brand who changed the field. */
  user: ChangedBy;
};

/** Someone unset a field that was previously unset. */
export type UnsetFieldChange = FieldChange & {
  /** If the field was changed within a collection, this describes the collection. */
  collection?: Maybe<Collection>;
  /** The name of the collection where this field was changed in. */
  collectionName?: Maybe<Scalars['String']['output']>;
  /** The ISO date that this field was changed at. */
  date: Scalars['String']['output'];
  /** The field involved in the change. */
  field: ChangedField;
  fieldChangeId: Scalars['ID']['output'];
  /** The type of change made. */
  fieldChangeType: FieldChangeType;
  /** The original value that was unset. */
  from: FieldValue;
  /** The product on which the change was made. */
  product: Product;
  /** The user and brand who changed the field. */
  user: ChangedBy;
};

export type Unstable_AddProductToRegistrationViaQrCodeInput = {
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** The id of the registration. */
  registrationId: Scalars['ID']['input'];
  /** The token to validate the source. */
  token?: InputMaybe<Scalars['String']['input']>;
  /** The userId adding the product. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type Unstable_AddProweinProductsToRegistrationInput = {
  /** The id of the product to add */
  productIds: Array<Scalars['ID']['input']>;
  /** The id of the registration. */
  registrationId: Scalars['ID']['input'];
  /** The token to validate the source. */
  token?: InputMaybe<Scalars['String']['input']>;
  /** The userId adding the product. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type Unstable_AddQrCodeELabelResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_AddQrCodeELabelResponseInput = {
  /** The countries where the response is valid. */
  countries: Array<InputMaybe<Scalars['String']['input']>>;
  /** The id of the ELabel. */
  eLabelId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of the link. */
  linkType: Scalars['String']['input'];
  /** If true, will create a new ELabel. */
  newELabel?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_AddQrCodeImage = {
  errorCorrectionLevel?: InputMaybe<QrCodeErrorCorrectionLevel>;
  margin?: InputMaybe<Scalars['Int']['input']>;
  overlayInfoIcon?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
};

export type Unstable_AddQrCodeImageResponse = MutationResponse & {
  code: Scalars['String']['output'];
  eLabel?: Maybe<ELabel>;
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_AddQrCodeWebsiteResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_AddQrCodeWebsiteResponseInput = {
  /** The countries where the response is valid. */
  countries: Array<InputMaybe<Scalars['String']['input']>>;
  /** The link of the response to add. */
  link: Scalars['String']['input'];
  /** The type of the link. */
  linkType: Scalars['String']['input'];
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** If true, the bottlebooks landing page will be used. */
  useLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_AddRelatedCollectionInput = {
  /** The id of the collection. */
  collectionId: Scalars['ID']['input'];
  /** The id of the related collection to be added. */
  relatedCollectionId?: InputMaybe<Scalars['String']['input']>;
};

export type Unstable_AddRelatedCollectionResponse = MutationResponse & {
  code: Scalars['String']['output'];
  collection: Collection;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Unstable_ClaimQrCodeInput = {
  claimToken: Scalars['String']['input'];
  qrCodeId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_ClaimQrCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_CloudinaryImage = {
  /** The Cloudinary cloudName. */
  cloudName: Scalars['String']['output'];
  /** The Cloudinary publicId. */
  publicId: Scalars['String']['output'];
  /** The source URL of the image. */
  sourceUrl: Scalars['String']['output'];
};

export type Unstable_CollectionOutputInterface = {
  collection: Collection;
  collectionId: Scalars['String']['output'];
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type Unstable_CollectionProductConnection = {
  edges: Array<Unstable_CollectionProductEdge>;
  nodes: Array<Product>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Unstable_CollectionProductEdge = {
  allOutputs: Array<ProductOutput>;
  allRegisteredProducts: Array<RegisteredProduct>;
  allRegistrations: Array<SingleRegistration>;
  collection: Collection;
  collectionId: Scalars['ID']['output'];
  cursor: Scalars['String']['output'];
  data: Scalars['JSONObject']['output'];
  next?: Maybe<Product>;
  node: Product;
  /** The combined state of all outputs for this product. */
  outputState: OutputState;
  previous?: Maybe<Product>;
  product: Product;
  productId: Scalars['ID']['output'];
  productVersionId: Scalars['ID']['output'];
  /** This product edge in the related collections. */
  relatedCollectionProducts: Array<Unstable_CollectionProductEdge>;
  workspace: Workspace;
  workspaceId: Scalars['ID']['output'];
};

export type Unstable_ConvertQrCodeToOutput = {
  /** The collection where the QR code is created. */
  collectionId: Scalars['ID']['input'];
  /** The output configuration id of the output. */
  outputConfigurationId: Scalars['ID']['input'];
  /** ID of the linked product */
  productId: Scalars['ID']['input'];
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** The id of the workspace where the output is configured and the QR code file should be visible. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_ConvertQrCodeToOutputResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_CoreELabel = Item & {
  /** The e-label QR codes. */
  _unstable_qrCodes: Unstable_QrCodeConnection;
  /** The date the eLabel was created. */
  createdAt: Scalars['String']['output'];
  /** The user who created the elabel. */
  createdBy: UserProfile;
  /** The current step on the elabel creation process. */
  creationStep: ELabelCreationStep;
  /** The description of the eLabel. */
  description?: Maybe<Scalars['String']['output']>;
  /** Bottlebooks ID of the eLabel. */
  elabelId: Scalars['ID']['output'];
  /**
   * The url to the e-label.
   * @deprecated Will be decomissioned. Use url instead.
   */
  elabelUrl: Scalars['String']['output'];
  /** The date the eLabel was updated. */
  lastUpdate: Scalars['String']['output'];
  /** The user who last updated the elabel. */
  lastUpdatedBy: UserProfile;
  /** The name of the eLabel. */
  name: Scalars['String']['output'];
  /** The eLabel producer data. */
  producer?: Maybe<ELabelProducer>;
  /** The eLabel product core data. */
  product?: Maybe<CoreELabelProduct>;
  /** The eLabel product type. */
  productType?: Maybe<Scalars['String']['output']>;
  /** The state of the elabel regarding the latest release. */
  status: ELabelStatus;
  /** The data source from where the qr code is created. */
  type: ELabelType;
  /**
   * The user who created the elabel.
   * @deprecated Use 'createdBy' instead.
   */
  user: UserProfile;
  /** The current elabel version or the requested release. */
  version?: Maybe<ELabelVersion>;
  versionId: Scalars['ID']['output'];
  /** The elabel versions. */
  versions?: Maybe<ELabelVersionConnection>;
};


export type Unstable_CoreELabel_Unstable_QrCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Unstable_QrCodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type Unstable_CoreELabelCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type Unstable_CoreELabelElabelUrlArgs = {
  format?: InputMaybe<UrlFormat>;
  locale?: InputMaybe<ELabelLocale>;
};


export type Unstable_CoreELabelLastUpdateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type Unstable_CoreELabelProductTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type Unstable_CoreELabelVersionArgs = {
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type Unstable_CoreProduct = Item & {
  /**
   * The GTIN of the product.
   *
   * Returns the GTIN of the first product variant.
   */
  GTIN?: Maybe<Scalars['String']['output']>;
  /** @deprecated Don't use - will be deleted soon! */
  _unstable_parentProductDifferences: Array<ProductVersionChange>;
  bottleImage?: Maybe<CloudinaryAsset>;
  /** The country the product was produced in. */
  country?: Maybe<Scalars['String']['output']>;
  /** The customized name of the region. */
  customRegion?: Maybe<Scalars['String']['output']>;
  /** The customized name of the subregion. */
  customSubregion?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the denomination. This extends the logic of regionName and
   * uses custom logic for specific regions such as Spain and Austria.
   */
  denomination?: Maybe<Scalars['String']['output']>;
  /** The ISO date when the product version was changed. */
  lastUpdatedAt: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  producerId?: Maybe<Scalars['ID']['output']>;
  /** Producer name */
  producerName?: Maybe<Scalars['String']['output']>;
  producerProfileId: Scalars['ID']['output'];
  /** productExternalId Should represent unique product ID specific to the company. Former inventoryId */
  productExternalId?: Maybe<Scalars['String']['output']>;
  /** productExternalId2 Should represent additional product ID specific to the company. Former inventoryId2 */
  productExternalId2?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productVersionId: Scalars['ID']['output'];
  /**
   * The region the product was produced in.
   * This is one of the officialy recognized regions of the country.
   * Regions are often subdivided into subregions - that value can be found on Product.subregion.
   */
  region?: Maybe<Scalars['String']['output']>;
  /** The region hierarchy of a product, starting with country. */
  regionHierarchy?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The name of the subregion, region or country – whichever has a value:
   * - For products with subregion, the subregion is returned.
   * - For products with region only, the region is returned.
   * - For products with country, the country is returned.
   * - For products using custom names, the custom name is returned.
   */
  regionName?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  /**
   * The subregion the product was produced in.
   * This is one of the officialy recognized subregions of the region.
   */
  subregion?: Maybe<Scalars['String']['output']>;
  /** Supplier name */
  supplierName?: Maybe<Scalars['String']['output']>;
  vintage?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['ID']['output'];
};


export type Unstable_CoreProductGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type Unstable_CoreProduct_Unstable_ParentProductDifferencesArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Unstable_CoreProductCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type Unstable_CoreProductCustomRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type Unstable_CoreProductCustomSubregionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type Unstable_CoreProductDenominationArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type Unstable_CoreProductNameArgs = {
  format?: InputMaybe<TextFormat>;
  includeProducer?: InputMaybe<IncludeProducer>;
};


export type Unstable_CoreProductProductExternalIdArgs = {
  format?: InputMaybe<TextFormat>;
};


export type Unstable_CoreProductProductExternalId2Args = {
  format?: InputMaybe<TextFormat>;
};


export type Unstable_CoreProductRegionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type Unstable_CoreProductRegionHierarchyArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type Unstable_CoreProductRegionNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type Unstable_CoreProductShortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type Unstable_CoreProductSubregionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type Unstable_CoreProductVintageArgs = {
  nonVintage?: InputMaybe<Scalars['String']['input']>;
  removeNonVintage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Unstable_CreateELabelAndQrCodeInput = {
  /** The article number of the QR code. */
  articleNumber?: InputMaybe<Scalars['String']['input']>;
  /** The article version of the QR code. */
  articleVersion?: InputMaybe<Scalars['String']['input']>;
  /** A client-specific ID for the QR code. This will be stored with the QR code and can be read back later. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** The cpv of the QR code. */
  cpv?: InputMaybe<Scalars['String']['input']>;
  /** The customer name of the QR code. */
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** The customer number of the QR code. */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  /** The GTIN of the QR code. */
  gtin?: InputMaybe<Scalars['String']['input']>;
  /** Should the QR code be public immediately? */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should the QR code be shareable? */
  isShareable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The description of the QR code. */
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  /** The name of the QR code. */
  name: Scalars['String']['input'];
  /** The id of the product the QR code is associated with. */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** If set to true, the GTIN can be omitted. */
  skipGtin?: InputMaybe<Scalars['Boolean']['input']>;
  /** (Vanity) Short code requested manually. */
  vanityQrCodeId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the workspace adding the QR code. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_CreateELabelAndQrCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  cpvSuggestion?: Maybe<Scalars['String']['output']>;
  eLabel?: Maybe<ELabel>;
  existingQrCode?: Maybe<Unstable_QrCode>;
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
  workspaceConfiguration?: Maybe<WorkspaceConfiguration>;
};

export type Unstable_CreateELabelCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  eLabel?: Maybe<ELabel>;
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_CreateELabelInput = {
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_CreateProductOutputInput = {
  /** The collection where the output is created. */
  collectionId: Scalars['ID']['input'];
  /** The output configuration id of the output. */
  outputConfigurationId: Scalars['ID']['input'];
  /** The id of the product the output is associated with. */
  productId: Scalars['ID']['input'];
  /** The ID of the workspace adding the output. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_CreateProductOutputResponse = MutationResponse & {
  code: Scalars['String']['output'];
  collection?: Maybe<Collection>;
  message: Scalars['String']['output'];
  output?: Maybe<ProductOutput>;
  productEdge?: Maybe<Unstable_CollectionProductEdge>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_CreateProductWithQrCodeCompanyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  referenceCode: Scalars['String']['input'];
  referenceName?: InputMaybe<Scalars['String']['input']>;
};

export type Unstable_CreateProductWithQrCodeInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  collectionId: Scalars['ID']['input'];
  customer?: InputMaybe<Unstable_CreateProductWithQrCodeCompanyInput>;
  product: Unstable_CreateProductWithQrCodeProductInput;
  qrCode: Unstable_CreateProductWithQrCodeQrCodeInput;
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_CreateProductWithQrCodePackagingInput = {
  containerTypeCode?: InputMaybe<PackageTypeCode>;
  netVolume?: InputMaybe<VolumeValueInput>;
};

export type Unstable_CreateProductWithQrCodeProductInput = {
  consumerProductVariant?: InputMaybe<Scalars['String']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  isShareable?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPackaging?: InputMaybe<Unstable_CreateProductWithQrCodePackagingInput>;
  referenceCode: Scalars['String']['input'];
  referenceName?: InputMaybe<Scalars['String']['input']>;
  referenceVariantCode?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  vintage?: InputMaybe<Scalars['String']['input']>;
};

export type Unstable_CreateProductWithQrCodeQrCodeInput = {
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Unstable_CreateProductWithQrCodeResponse = {
  code: Scalars['String']['output'];
  customer?: Maybe<Company>;
  customerId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  qrCode?: Maybe<Unstable_QrCode>;
  qrCodeId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_CreateQrCodeAsOutputInput = {
  /** The collection where the QR code is created. */
  collectionId: Scalars['ID']['input'];
  /** The cpv of the QR code. */
  cpv?: InputMaybe<Scalars['String']['input']>;
  /** The GTIN of the QR code. */
  gtin?: InputMaybe<Scalars['String']['input']>;
  /** The description of the QR code. */
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  /** The name of the QR code. */
  name: Scalars['String']['input'];
  /** The output configuration id of the output. */
  outputConfigurationId: Scalars['ID']['input'];
  /** The id of the product the QR code is associated with. */
  productId: Scalars['ID']['input'];
  /** If set to true, the GTIN can be omitted. */
  skipGtin?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the workspace adding the QR code. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_CreateQrCodeAsOutputResponse = MutationResponse & {
  code: Scalars['String']['output'];
  cpvSuggestion?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_CreateQrCodeInput = {
  /** The article number of the QR code. */
  articleNumber?: InputMaybe<Scalars['String']['input']>;
  /** The article version of the QR code. */
  articleVersion?: InputMaybe<Scalars['String']['input']>;
  /** A client-specific ID for the QR code. This will be stored with the QR code and can be read back later. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** The cpv of the QR code. */
  cpv?: InputMaybe<Scalars['String']['input']>;
  /** The customer name of the QR code. */
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** The customer number of the QR code. */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the label adding the QR code. */
  eLabelId?: InputMaybe<Scalars['ID']['input']>;
  /** The GTIN of the QR code. */
  gtin?: InputMaybe<Scalars['String']['input']>;
  /** Should the QR code be public immediately? */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should the QR code be shareable? */
  isShareable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The description of the QR code. */
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  /** The name of the QR code. */
  name: Scalars['String']['input'];
  /** The id of the product the QR code is associated with. */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** If set to true, the GTIN can be omitted. */
  skipGtin?: InputMaybe<Scalars['Boolean']['input']>;
  /** (Vanity) Short code requested manually. */
  vanityQrCodeId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the workspace adding the QR code. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_CreateQrCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  cpvSuggestion?: Maybe<Scalars['String']['output']>;
  existingQrCode?: Maybe<Unstable_QrCode>;
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_DeleteQrCodeInput = {
  deleteELabels?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type Unstable_DeleteQrCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_DeleteQrCodeResponseInput = {
  /** The link of the response to delete. */
  link: Scalars['String']['input'];
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_GenericValidValue = Unstable_ValidValue & {
  /** The label of the valid value in the given interface locale. */
  label: Scalars['String']['output'];
  /** The key of the valid value list this valid value belongs to. */
  listKey: Scalars['String']['output'];
  /** The unique identifier for this valid value. */
  value: Scalars['String']['output'];
};


export type Unstable_GenericValidValueLabelArgs = {
  locale: InterfaceLocale;
};

export type Unstable_Ingredient = Unstable_ValidValue & {
  /** Alternative ingredient names that mean the same as this ingredient. */
  alternatives: Array<Unstable_Ingredient>;
  /**
   * Deprecated, it can occur in multiple groups. Use value instead.
   * @deprecated Use value instead.
   */
  ambiguousValue: Scalars['String']['output'];
  /** Explains how to upgrade a deprecated field. */
  deprecationMessage?: Maybe<Scalars['String']['output']>;
  /** A text describing the ingredient. */
  description?: Maybe<Scalars['String']['output']>;
  /** The group this ingredient belongs to. */
  group: Unstable_IngredientGroup;
  /** The label of the ingredient group in the given interface locale. A shortcut for group.label. */
  ingredientGroupLabel: Scalars['String']['output'];
  /** Indicates that a ingredient has been deprecated. Check the deprecationMessage to learn how to resolve. */
  isDeprecated: Scalars['Boolean']['output'];
  /** The label of the ingredient in the given interface locale. */
  label: Scalars['String']['output'];
  /** The key of the valid value list this ingredient belongs to. This is always 'ingredients'. */
  listKey: Scalars['String']['output'];
  /** Returns the preferred ingredient to use instead of this ingredient. */
  preferredIngredient?: Maybe<Unstable_Ingredient>;
  /** The product type this ingredient belongs to (if queried for a specific product type). */
  productType?: Maybe<ProductType>;
  /** All the product types this ingredient is valid for. */
  productTypes: Array<ProductType>;
  /** All the product sub-types this ingredient is valid for. */
  subTypes: Array<Scalars['String']['output']>;
  /** The unique identifier for this ingredient. */
  value: Scalars['String']['output'];
  /** Indicates if the ingredient should be hidden in the main list and only be visible when searching for the particular term. */
  visibility: IngredientVisibility;
};


export type Unstable_IngredientDeprecationMessageArgs = {
  locale: InterfaceLocale;
};


export type Unstable_IngredientDescriptionArgs = {
  locale: InterfaceLocale;
};


export type Unstable_IngredientIngredientGroupLabelArgs = {
  locale: InterfaceLocale;
  plural?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Unstable_IngredientLabelArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale: InterfaceLocale;
};

export type Unstable_IngredientGroup = Unstable_ValidValue & {
  /** The ingredients that belong to this group. */
  ingredients: Array<Unstable_Ingredient>;
  /** The label of the ingredient group in the given interface locale. */
  label: Scalars['String']['output'];
  /** The key of the valid value list this ingredient group belongs to. This is always 'ingredientGroups'. */
  listKey: Scalars['String']['output'];
  /** The unique identifier for this ingredient group. */
  value: Scalars['String']['output'];
};


export type Unstable_IngredientGroupIngredientsArgs = {
  productType: ProductType;
  sortByLocale?: InterfaceLocale;
  visibility?: InputMaybe<Array<IngredientVisibility>>;
};


export type Unstable_IngredientGroupLabelArgs = {
  locale: InterfaceLocale;
};

export type Unstable_MakeQrCodeShareableInput = {
  id: Scalars['ID']['input'];
  isShareable: Scalars['Boolean']['input'];
};

export type Unstable_MakeQrCodeShareableResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_MissingProduct = Item & {
  _unstable_validation?: Maybe<Unstable_MissingProductValidation>;
  collectionId: Scalars['ID']['output'];
  companyId: Scalars['ID']['output'];
  coreProduct: Unstable_MissingProductData;
  name: Scalars['String']['output'];
  productExternalId?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productRequestId: Scalars['ID']['output'];
  registration: SingleRegistration;
  registrationId: Scalars['ID']['output'];
  request: Unstable_RequestedProduct;
};

export type Unstable_MissingProductData = {
  GTIN?: Maybe<Scalars['String']['output']>;
  bottleImage?: Maybe<CloudinaryAsset>;
  lastUpdatedAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  producerName?: Maybe<Scalars['String']['output']>;
  productExternalId?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  supplierName: Scalars['String']['output'];
  vintage?: Maybe<Scalars['String']['output']>;
};

export type Unstable_MissingProductValidation = {
  success: Scalars['Boolean']['output'];
};

export type Unstable_Portfolio = {
  portfolioCollections: EventConnection;
  products: ProductConnection;
  /** @deprecated Use products instead. */
  registeredProducts: RegisteredProductConnection;
};


export type Unstable_PortfolioProductsArgs = {
  versionTag?: InputMaybe<DataVersionTag>;
};

export type Unstable_ProductOutputInterface = {
  product: Product;
  productId: Scalars['String']['output'];
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type Unstable_ProweinProductCategory = Unstable_ValidValue & {
  /** If this product category has been purchased by the user. */
  isPurchased?: Maybe<Scalars['Boolean']['output']>;
  /** If this product category has been already used in the registration. */
  isUsed?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the valid value in the given interface locale. */
  label: Scalars['String']['output'];
  /** The key of the valid value list this valid value belongs to. */
  listKey: Scalars['String']['output'];
  /** The unique identifier for this valid value. */
  value: Scalars['String']['output'];
};


export type Unstable_ProweinProductCategoryLabelArgs = {
  locale: InterfaceLocale;
};

export type Unstable_PublishQrCodeInput = {
  id: Scalars['ID']['input'];
};

export type Unstable_PublishQrCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_PublishQrCodesInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type Unstable_PublishQrCodesResponse = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCodes?: Maybe<Array<Unstable_QrCode>>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_QrCode = Item & {
  /** @deprecated Experimental - will be removed without notice! */
  _unstable_automaticResponses?: Maybe<Array<Unstable_QrCodeResponse>>;
  /** The article number. */
  articleNumber?: Maybe<Scalars['String']['output']>;
  /** The article version, such as a sub-variant of the same article. */
  articleVersion?: Maybe<Scalars['String']['output']>;
  /** The client ID that was supplied when creating the QR code. */
  clientId?: Maybe<Scalars['String']['output']>;
  /**
   * The Consumer Product Variant encoded in the GS1 Digital Link URI.
   * This is the GS1 Application Identifier 22.
   */
  cpv?: Maybe<Scalars['String']['output']>;
  /** The date when the QR code was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The user who created the QR code. */
  createdBy: UserProfile;
  /** The customer's name. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** The customer number. */
  customerNumber?: Maybe<Scalars['String']['output']>;
  /** The first linked e-label, if any. Bottlebooks only allows one e-label per QR code. */
  eLabel?: Maybe<ELabel>;
  /** The first linked e-label ID, if any. Bottlebooks only allows one e-label per QR code. */
  eLabelId?: Maybe<Scalars['String']['output']>;
  /** The URL that is embedded in the QR code. This is a convenience shortcut to image.embeddedUrl. */
  embeddedUrl: Scalars['String']['output'];
  /**
   * The GTIN encoded in the GS1 Digital Link URI.
   * This is the GS1 Application Identifier 01.
   */
  gtin?: Maybe<Scalars['String']['output']>;
  /** This is the id of the qrCode. It is the uri embedded in the images and follows the GS1 Digital Link standard. */
  id: Scalars['ID']['output'];
  image?: Maybe<Unstable_QrCodeImage>;
  images: Array<Unstable_QrCodeImage>;
  /** Returns whether the QR code has already been claimed. Only readable by the owner or creator. */
  isClaimed?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the QR code has been deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is this QR code public?
   * This is used for the workflow state DRAFT.
   */
  isPublic: Scalars['Boolean']['output'];
  /** Returns whether the QR code is shareable. */
  isShareable: Scalars['Boolean']['output'];
  /** The notes on the QR code. */
  itemDescription?: Maybe<Scalars['String']['output']>;
  /** The date when the QR code was updated. */
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use responseUrl instead. */
  link?: Maybe<Scalars['String']['output']>;
  linkType?: Maybe<Unstable_QrCodeLinkType>;
  /** The internal name that the user has given the qrCode. */
  name: Scalars['String']['output'];
  /** The linked product if available. */
  product?: Maybe<Product>;
  /** The linked product ID if available. */
  productId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use isPublic instead. */
  public: Scalars['Boolean']['output'];
  /** Same as id. Prefer id instead. */
  qrCodeId: Scalars['ID']['output'];
  /** Get the response for country where QR code is scanned. */
  response?: Maybe<Unstable_QrCodeResponse>;
  /** The response URL of this QR Code. This is a convenience shortcut to response.link. */
  responseUrl?: Maybe<Scalars['String']['output']>;
  /** All responses for this QR code. */
  responses: Array<Unstable_QrCodeResponse>;
  /** The URL to share this QR code with other workspaces. Only readable by the creator. */
  shareUrl?: Maybe<Scalars['String']['output']>;
  /** The company profile that the QR code was shared from. */
  sharedByCompanyProfile?: Maybe<CompanyProfile>;
  /** The user who shared the QR code. */
  sharedByUserProfile?: Maybe<UserProfile>;
  /** @deprecated Use qrCodeId instead. It's the actual uri and contains a leading slash. */
  shortCode: Scalars['String']['output'];
  /** The current workflow state of the QR code. */
  workflowState: Unstable_QrCodeWorkflowState;
  /** The workspace that owns the QR code. */
  workspace: Workspace;
  /** The ID of the workspace that owns the QR code. */
  workspaceId: Scalars['ID']['output'];
};


export type Unstable_QrCode_Unstable_AutomaticResponsesArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};


export type Unstable_QrCodeCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<ELabelLocale>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Unstable_QrCodeELabelArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type Unstable_QrCodeLastUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<ELabelLocale>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Unstable_QrCodeLinkArgs = {
  linkType?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};


export type Unstable_QrCodeProductArgs = {
  fallbackToDataSource?: InputMaybe<Scalars['Boolean']['input']>;
  locale: InterfaceLocale;
};


export type Unstable_QrCodeProductIdArgs = {
  fallbackToDataSource?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Unstable_QrCodeResponseArgs = {
  filter: QrCodeResponseFilterInput;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type Unstable_QrCodeResponseUrlArgs = {
  linkType?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};


export type Unstable_QrCodeResponsesArgs = {
  filter?: InputMaybe<QrCodeResponsesFilterInput>;
};


export type Unstable_QrCodeShareUrlArgs = {
  locale: ELabelLocale;
};

export type Unstable_QrCodeConnection = Connection & {
  edges: Array<Unstable_QrCodeEdge>;
  group: Array<Unstable_QrCodeGroupConnection>;
  nodes: Array<Unstable_QrCode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Unstable_QrCodeConnectionGroupArgs = {
  field: Unstable_QrCodeGroupField;
};

export type Unstable_QrCodeELabelResponseCountryInput = {
  /** The countries where the response is valid. */
  countries: Array<InputMaybe<Scalars['String']['input']>>;
  /** The ID - current link of the response to update. */
  id: Scalars['String']['input'];
};

export type Unstable_QrCodeEdge = Edge & {
  cursor: Scalars['String']['output'];
  next?: Maybe<Unstable_QrCode>;
  node: Unstable_QrCode;
  previous?: Maybe<Unstable_QrCode>;
};

export type Unstable_QrCodeFilterInput = {
  articleNumber?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Unstable_QrCodeGroupConnection = Connection & {
  edges: Array<Unstable_QrCodeEdge>;
  field: Unstable_QrCodeGroupField;
  fieldValue: Scalars['String']['output'];
  firstNode: Unstable_QrCode;
  group: Array<Unstable_QrCodeGroupConnection>;
  nodes: Array<Unstable_QrCode>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};


export type Unstable_QrCodeGroupConnectionGroupArgs = {
  field: Unstable_QrCodeGroupField;
};


export type Unstable_QrCodeGroupConnectionNodesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type Unstable_QrCodeGroupField =
  | 'articleNumber'
  | 'customerNumber'
  | 'orderNumber';

export type Unstable_QrCodeImage = {
  /** The Cloudinary cloudName. */
  cloudName: Scalars['String']['output'];
  /** The date when the image was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The user who created the image. */
  createdBy?: Maybe<UserProfile>;
  /** The QR code as a string representation. */
  data: Scalars['String']['output'];
  embeddedUrl: Scalars['String']['output'];
  /** The error correction level of the QR code. Defaults to Q. */
  errorCorrectionLevel: QrCodeErrorCorrectionLevel;
  /** The Cloudinary asset. Use it to generate transformations. */
  file: CloudinaryAsset;
  /** The JPG file of the QR code in the original size. */
  jpgUrl: Scalars['String']['output'];
  /** The count of margin modules the QR code is using. Defaults to 4. */
  margin: Scalars['Int']['output'];
  /** The number of modules the QR code is using. */
  modules: Scalars['Int']['output'];
  /** Does the QR code contain an overlay info icon? */
  overlayInfoIcon: Scalars['Boolean']['output'];
  /** The original PDF file of the QR code. */
  pdfUrl: Scalars['String']['output'];
  /** The Cloudinary publicId. */
  publicId: Scalars['String']['output'];
  /** The source URL of the image. */
  sourceUrl: Scalars['String']['output'];
  /** The version of the QR code. */
  version: Scalars['Int']['output'];
  /** The workspace that the image was created by. */
  workspace?: Maybe<Workspace>;
};


export type Unstable_QrCodeImageCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<ELabelLocale>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Unstable_QrCodeImageJpgUrlArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
};


export type Unstable_QrCodeImagePdfUrlArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
};

export type Unstable_QrCodeLinkType =
  /** The digital link contains a GTIN that can be scanned by an offline scanner. */
  | 'GS1_DIGITAL_LINK'
  /** The link contains an arbitrary string that doesn't follow GS1 standards. It's not scannable by offline scanners. */
  | 'PROPRIETARY';

export type Unstable_QrCodeResponse = {
  context?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  coreELabel?: Maybe<Unstable_CoreELabel>;
  defaultContext?: Maybe<Scalars['Boolean']['output']>;
  eLabel?: Maybe<ELabel>;
  eLabelId?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  linkType: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  previewImage?: Maybe<Unstable_CloudinaryImage>;
  public?: Maybe<Scalars['Boolean']['output']>;
  qrCodeId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  useLandingPage?: Maybe<Scalars['Boolean']['output']>;
};


export type Unstable_QrCodeResponseCoreELabelArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type Unstable_QrCodeResponseELabelArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type Unstable_QrCodeResponseLinkArgs = {
  fullUrl?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Unstable_QrCodeWorkflowState =
  /** The digital link is unpublished. */
  | 'DRAFT'
  /** The digital link redirects to an e-label. */
  | 'ELABEL'
  /** The digital link is marked as public, but no redirect has been set up yet. */
  | 'UNLINKED'
  /** The digital link redirects to a web page. */
  | 'WEB';

export type Unstable_RegistrationOutputInterface = {
  collection: Collection;
  collectionId: Scalars['String']['output'];
  registration: Registration;
  registrationId: Scalars['String']['output'];
  workspace: Workspace;
  workspaceId: Scalars['String']['output'];
};

export type Unstable_RemoveRelatedCollectionInput = {
  /** The id of the collection. */
  collectionId: Scalars['ID']['input'];
  /** The id of the related collection to be remove. */
  relatedCollectionId?: InputMaybe<Scalars['String']['input']>;
};

export type Unstable_RemoveRelatedCollectionResponse = MutationResponse & {
  code: Scalars['String']['output'];
  collection: Collection;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Unstable_RequestedProduct = Item & {
  /** @deprecated Use registration.name instead. */
  exhibitorName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use productRequestId instead. */
  id: Scalars['ID']['output'];
  /** @deprecated Use requestedName instead. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The identifier of the product in the organizer's system.
   * There may be duplicates in this field if multiple requests are mapped to the same product.
   */
  productExternalId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  /**
   * The identifier of the request in the organizer's system.
   * It must be unique within a collection so that imports won't create new requested products.
   */
  productRequestExternalId?: Maybe<Scalars['String']['output']>;
  productRequestId: Scalars['ID']['output'];
  registeredProduct?: Maybe<RegisteredProduct>;
  registration: Registration;
  registrationId: Scalars['ID']['output'];
  /** @deprecated Use productRequestId instead. */
  requestId: Scalars['ID']['output'];
  requestedAt: Scalars['String']['output'];
  requestedBottleGTIN?: Maybe<Scalars['String']['output']>;
  requestedBy: UserProfile;
  requestedName?: Maybe<Scalars['String']['output']>;
  requestedVintage?: Maybe<Scalars['String']['output']>;
};

export type Unstable_RequestedProductConnection = {
  /** The nodes of this connection. */
  nodes: Array<Unstable_RequestedProduct>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Unstable_RestoreQrCodeInput = {
  id: Scalars['ID']['input'];
  /** If true, the e-labels associated with the QR code will be restored as well. */
  restoreELabels?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Unstable_RestoreQrCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_SetNonEuQrCodeLink = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_SetNonEuQrCodeLinkInput = {
  /** The link to set. */
  link: Scalars['String']['input'];
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_SetProductTaskStateInput = {
  productId: Scalars['ID']['input'];
  state: TaskState;
  taskId: Scalars['ID']['input'];
};

export type Unstable_SetProductTaskStateResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Unstable_UpdateAddProductToRegistrationViaQrCodeResponse = MutationResponse & {
  /** The result code. Like HTTP status codes. */
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The updated qrCode. */
  qrCode?: Maybe<Unstable_QrCode>;
  /** The updated registration. */
  registration?: Maybe<Registration>;
  /** Whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type Unstable_UpdateAddProweinProductsToRegistrationResponse = MutationResponse & {
  /** The result code. Like HTTP status codes. */
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The new Bottlebooks Product Id. */
  productIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** The updated registration. */
  registration?: Maybe<Registration>;
  /** Whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type Unstable_UpdateQrCode = {
  admin?: InputMaybe<Unstable_UpdateQrCodeAdminInput>;
  articleNumber?: InputMaybe<Scalars['String']['input']>;
  articleVersion?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
};

export type Unstable_UpdateQrCodeAdminInput = {
  creatorWorkspaceId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
  workspaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Unstable_UpdateQrCodeDefaultResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_UpdateQrCodeDefaultResponseInput = {
  /** The link to be set in the response. */
  link: Scalars['String']['input'];
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** When true uses bottlebooks e-label rendering as landing page. */
  useLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_UpdateQrCodeELabelResponseInput = {
  /** The countries where the response is valid. */
  countries: Array<InputMaybe<Scalars['String']['input']>>;
  /** The ID of the e-label. */
  eLabelId: Scalars['ID']['input'];
  /** The ID - current link of the response to update. */
  id: Scalars['String']['input'];
  /** The type of the link. */
  linkType: Scalars['String']['input'];
  /** The public flag. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_UpdateQrCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable_UpdateQrCodeResponseInput = {
  /** The ID - current link of the response to update. */
  id: Scalars['String']['input'];
  /** The public flag. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_UpdateQrCodeResponsesCountriesInput = {
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** The responses to update. */
  responses: Array<Unstable_QrCodeELabelResponseCountryInput>;
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_UpdateQrCodeWebsiteResponseInput = {
  /** The countries where the response is valid. */
  countries: Array<InputMaybe<Scalars['String']['input']>>;
  /** The ID - current link of the response to update. */
  id: Scalars['String']['input'];
  /** The link to be set in the response. */
  link: Scalars['String']['input'];
  /** The type of the link. */
  linkType: Scalars['String']['input'];
  /** The id of the QR code. */
  qrCodeId: Scalars['ID']['input'];
  /** When true uses bottlebooks e-label rendering as landing page. */
  useLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The workspace id. */
  workspaceId: Scalars['ID']['input'];
};

export type Unstable_ValidValue = {
  /** The label of the valid value in the given interface locale. */
  label: Scalars['String']['output'];
  /** The key of the valid value list this valid value belongs to. */
  listKey: Scalars['String']['output'];
  /** The unique identifier for this valid value. */
  value: Scalars['String']['output'];
};


export type Unstable_ValidValueLabelArgs = {
  locale: InterfaceLocale;
};

export type Unstable_ValidValueLists = {
  /**
   * Older valid value lists, not migrated yet.
   * @deprecated Try to avoid - these are the old valid values from Bottlebooks Classic.
   */
  classicLists: Array<ClassicValidValueList>;
  /** The ingredients for a particular product type. */
  ingredients: Array<Unstable_Ingredient>;
  /** The packaging gases declarations. */
  packagingGases: Array<Unstable_GenericValidValue>;
  /**
   * The ProWein product categories. Specific to each registration.
   * @deprecated Internal use only.
   */
  proWeinProductCategories: Array<Unstable_ProweinProductCategory>;
};


export type Unstable_ValidValueListsClassicListsArgs = {
  locale: InterfaceLocale;
};


export type Unstable_ValidValueListsIngredientsArgs = {
  productType: ProductType;
  sortByLocale?: InterfaceLocale;
  visibility?: InputMaybe<Array<IngredientVisibility>>;
};


export type Unstable_ValidValueListsProWeinProductCategoriesArgs = {
  locale?: InputMaybe<InterfaceLocale>;
};

export type Unstable_ValidationError = {
  errors: Array<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type Unstable_ValidationResult = {
  errors?: Maybe<Array<Unstable_ValidationError>>;
  success: Scalars['Boolean']['output'];
};

export type Unstable__DeleteQrCodeResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable__UpdateQrCodeELabelResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable__UpdateQrCodeResponsesCountries = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type Unstable__UpdateQrCodeWebsiteResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qrCode?: Maybe<Unstable_QrCode>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDataImportBottlebooksFieldsInput = {
  /** The mapping of source fields to bottlebooks fields. */
  bottlebooksFields: Array<InputMaybe<DataImportBottlebooksFieldInput>>;
  /** The ID of the data import that will be updated. */
  importId: Scalars['ID']['input'];
};

export type UpdateDataImportHeaderAndDataRowsInput = {
  /** The index where the import data starts. */
  dataRowIndex: Scalars['Int']['input'];
  /** The index of the import header row. */
  headerRowIndex: Scalars['Int']['input'];
  /** The ID of the data import that will be updated. */
  importId: Scalars['ID']['input'];
};

/** The response of a data import mutation. */
export type UpdateDataImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The updated dataImport. */
  dataImport?: Maybe<DataImport>;
  /** The success or error message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateDataSuppliersMappingsInput = {
  /** The ID of the data import that will be updated. */
  importId: Scalars['ID']['input'];
  /** All supplier mapped to bottlebooks partner id. */
  suppliers: Array<DataImportSuppliersMappingInput>;
};

export type UpdateELabelDataInput = {
  /** The eLabel custom product type. */
  customProductType?: InputMaybe<LocalizedTextInput>;
  /** The description of the eLabel. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The food business operator data. */
  foodBusinessOperators?: InputMaybe<Array<InputMaybe<ELabelFoodBusinessOperatorInput>>>;
  /** The background color hex code to be used in the elabel. */
  headerBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** The imprint. */
  imprint?: InputMaybe<Scalars['String']['input']>;
  /** The target market for this eLabel */
  market?: InputMaybe<Scalars['String']['input']>;
  /** The name of the eLabel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The eLabel producer information. */
  producer?: InputMaybe<ELabelProducerInput>;
  /** The eLabel product information. */
  product?: InputMaybe<ELabelProductInput>;
  /** The e-label type. */
  type?: InputMaybe<ELabelType>;
};

export type UpdateELabelInput = {
  /** E-label draft data to update. */
  draft?: InputMaybe<UpdateELabelDataInput>;
  /** The ID of the eLabel to edit. */
  elabelId: Scalars['ID']['input'];
};

export type UpdateELabelResponse = MutationResponse & {
  code: Scalars['String']['output'];
  eLabel?: Maybe<ELabel>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};


export type UpdateELabelResponseELabelArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type UpdateELabelSettingsDataInput = {
  /** Target countries for eLabel. */
  countries?: InputMaybe<Array<ELabelCountryLocale>>;
  /** The current step on the elabel creation process. */
  creationStep?: InputMaybe<ELabelCreationStep>;
  /** Save the user choice of the eLabel datasource. */
  dataSource?: InputMaybe<DataSourceInput>;
  /** The languages selected for the eLabel. */
  languages?: InputMaybe<Array<ELabelLocale>>;
  /** The eLabel product type. */
  productType?: InputMaybe<ELabelProductType>;
  /** The eLabel main language. */
  referenceLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateELabelSettingsInput = {
  /** E-label draft data to update. */
  draft?: InputMaybe<UpdateELabelSettingsDataInput>;
  /** The ID of the eLabel to edit. */
  elabelId: Scalars['ID']['input'];
};

export type UpdateFormConfigurationInput = {
  /** The ID of the collection to copy data from. */
  collectionId: Scalars['ID']['input'];
  /** The fields to update. */
  fields: Array<ClassicFieldInput>;
};

export type UpdateFormConfigurationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  collection?: Maybe<Collection>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** The response of a data import mutation. */
export type UpdatePartnerResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The updated dataImport. */
  dataImport?: Maybe<DataImport>;
  /** The success or error message. */
  message: Scalars['String']['output'];
  /** The added partner. */
  partner?: Maybe<Partner>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRequestedProductInput = {
  collectionId: Scalars['ID']['input'];
  productExternalId?: InputMaybe<Scalars['ID']['input']>;
  productRequestExternalId?: InputMaybe<Scalars['ID']['input']>;
  productRequestId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
  requestedBottleGTIN?: InputMaybe<Scalars['String']['input']>;
  requestedName?: InputMaybe<Scalars['String']['input']>;
  requestedVintage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRequestedProductResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The id of the requestedProduct */
  productRequestId: Scalars['ID']['output'];
  /** The newly created requested product. */
  requestedProduct: Unstable_RequestedProduct;
  success: Scalars['Boolean']['output'];
};

export type UpdateRequestedProductWithProductIdInput = {
  collectionId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  productRequestId: Scalars['ID']['input'];
  registrationId: Scalars['ID']['input'];
};

export type UpdateRequestedProductWithProductIdResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  /** The id of the requestedProduct */
  productRequestId: Scalars['ID']['output'];
  /** The newly created requested product. */
  requestedProduct: Unstable_RequestedProduct;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserPropertyResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateVisitorProfileInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  linkedInURL?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** The visitors id. This is always a Bottlebooks ObjectID */
  visitorId: Scalars['ID']['input'];
};

export type UpdateWorkspaceConfigurationInput = {
  /** Show/hide all the ingredients as default. */
  showAllELabelIngredients?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWorkspaceConfigurationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UploadDataImportFileInput = {
  /** The file to upload. */
  file: Scalars['Upload']['input'];
  type: DataImportType;
  /** The workspace to upload the file to. */
  workspaceId: Scalars['ID']['input'];
};

export type UploadDataImportFileResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The uploaded file. */
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  /** The node the file was uploaded to. */
  node?: Maybe<Item>;
  success: Scalars['Boolean']['output'];
};

export type UploadFileInput = {
  /**
   * The id of the file to attach it before.
   * If not set, the new file will be put to the end of the list.
   */
  beforeFileId?: InputMaybe<Scalars['ID']['input']>;
  /** The file's content type. */
  contentType: FileContentType;
  /** The file to upload. */
  file: Scalars['Upload']['input'];
  /** The file's languages. Defaults to the language of the logged-in user. */
  languages?: InputMaybe<Array<InputMaybe<FileLanguageInput>>>;
  /** The node id to which the file will be uploaded. */
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  /** The typename of the node to which the file is uploaded (e.g. Product, Brand or others). */
  nodeType?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFileResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The uploaded file. */
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  /** The node the file was uploaded to. */
  node?: Maybe<Item>;
  success: Scalars['Boolean']['output'];
};

export type UploadFilesInput = {
  /**
   * The id of the file to attach it before.
   * If not set, the new file will be put to the end of the list.
   */
  beforeFileId?: InputMaybe<Scalars['ID']['input']>;
  /** The file's content type. */
  contentType: FileContentType;
  /** The files to upload. */
  files: Array<Scalars['Upload']['input']>;
  /** The file's languages. Defaults to the language of the logged-in user. */
  languages?: InputMaybe<Array<InputMaybe<FileLanguageInput>>>;
  /** The node id to which the file will be uploaded. */
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  /** The typename of the node to which the file is uploaded (e.g. Product, Brand or others). */
  nodeType?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFilesResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The uploaded file. */
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  /** The node the file was uploaded to. */
  node?: Maybe<Item>;
  success: Scalars['Boolean']['output'];
};

export type UploadedFile = File & Item & {
  /** The relations to products, brands or collections where this file is used in. */
  attachedNodes: AttachedNodeConnection;
  /** The name calculated from the first attached product or brand, or the manual name. */
  calculatedTitle: Scalars['String']['output'];
  /** The actual, semantic type of content, such as bottle image, infosheet etc. */
  contentType?: Maybe<FileContentType>;
  /** A description of the file in long text format. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The file's general dimensions. If the file contains different sections with varying formats, the section dimensions can be queried on 'pages'.
   * @deprecated Not yet supported.
   */
  dimensions: FileDimensions;
  fileExtension?: Maybe<Scalars['String']['output']>;
  /** The unique file id. */
  fileId?: Maybe<Scalars['ID']['output']>;
  /** The filename used when downloading the file, without the file extension. Can be modified. */
  filename: Scalars['String']['output'];
  /** A fixed-size image. */
  fixed?: Maybe<CloudinaryFixed>;
  /** A fluid image with optional constraints. */
  fluid?: Maybe<CloudinaryFluid>;
  /** Indicates if the file is a default file and cannot be deleted. */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates if file is generated on the fly
   * @deprecated isLive will only be defined on the LiveFile type. Use '... on LiveFile { isLive }' instead.
   */
  isLive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The languages this file is in.
   * For images without language specific text, it may be empty.
   */
  languages?: Maybe<Array<Maybe<FileLanguage>>>;
  /** @deprecated Use the __typename instead. */
  linkedFile?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use title instead. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The version this file had before.
   * Currently we support only a single revision, so this is always null.
   */
  previousRevision?: Maybe<File>;
  publicId: Scalars['String']['output'];
  /** The status of the file (draft, released or archived). Only released files can be attached to other nodes. */
  releaseStatus: ReleaseStatus;
  /** "The URL to download the original file from." */
  sourceUrl: Scalars['String']['output'];
  /** A thumbnail with a predefined size. */
  thumbnail?: Maybe<CloudinaryFixed>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The manually set title. */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The URL to download the file.
   * This is often an optimized link served via a CDN or specialized service, such as Cloudinary.
   */
  url: Scalars['String']['output'];
};


export type UploadedFileDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type UploadedFileFixedArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  sizes?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type UploadedFileFluidArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  sizes?: InputMaybe<Scalars['String']['input']>;
};


export type UploadedFileSourceUrlArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
};


export type UploadedFileThumbnailArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<CloudinaryCropType>;
  fetch_format?: InputMaybe<CloudinaryFetchFormat>;
  gravity?: InputMaybe<CloudinaryGravity>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<CloudinaryQuality>;
  sizes?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type UploadedFileTitleArgs = {
  format?: InputMaybe<TextFormat>;
};

export type UploadedFileCatalogSection = CatalogSection & {
  file: UploadedFile;
  filename: Scalars['String']['output'];
  /** The type of section. */
  sectionType: CatalogSectionType;
  sourceUrl: Scalars['String']['output'];
};

export type UrlFormat =
  | 'RAW'
  | 'TEXT'
  | 'URL';

/** The public user profile. */
export type UserProfile = Node & {
  /** The user's email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The user's family name. */
  familyName?: Maybe<Scalars['String']['output']>;
  /** The user's full name. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The user's given name (in many cultures this is the first name). */
  givenName?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the profile. */
  id: Scalars['ID']['output'];
  /** The value of the latest release note version the user has seen. */
  lastReleaseNoteVersion?: Maybe<Scalars['String']['output']>;
  /** The user's unique id. */
  userId: Scalars['ID']['output'];
};

export type UserPropertyName =
  /** The last release note versions the visitor has seen. */
  | 'lastReleaseNoteVersion';

export type UserRoles =
  | 'ADMIN'
  | 'READ_ONLY'
  | 'SUPER_ADMIN'
  | 'USER';

export type UserWorkspace = Item & {
  collection?: Maybe<Collection>;
  collectionId?: Maybe<Scalars['ID']['output']>;
  companyProfile: CompanyProfile;
  name?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Registration>;
  registrationId?: Maybe<Scalars['ID']['output']>;
  userId: Scalars['ID']['output'];
  userProfile: UserProfile;
  workspaceId: Scalars['ID']['output'];
};

export type ValidValue = {
  canBeMarkedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** Explains how to upgrade a deprecated field. */
  deprecationDescription?: Maybe<Scalars['String']['output']>;
  /** Indicates that a valid value has been deprecated. Check the deprecatedDescription to learn how to resolve. */
  isDeprecated: Scalars['Boolean']['output'];
  /** Indicates if the ingredient should be hidden in the main list and only be visible when searching for the particular term. */
  isHiddenInMainList?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier for this valid value. */
  key: Scalars['String']['output'];
  /** The label of the valid value in the given interface locale. */
  label: Scalars['String']['output'];
  styles?: Maybe<Array<Scalars['String']['output']>>;
  /** A text describing the preferred ingredient. */
  synonymDescription?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};


export type ValidValueLabelArgs = {
  locale?: InputMaybe<InterfaceLocale>;
};

export type ValidValueFormat =
  /** The user-friendly value in the English base language. */
  | 'ENGLISH'
  /** The user-friendly value in the current locale. */
  | 'LOCALIZED'
  /** The raw internal code. */
  | 'RAW';

export type ValidValues = Item & {
  beerStyle: Array<ValidValue>;
  containerColor: Array<ValidValue>;
  containerType: Array<ValidValue>;
  country: Array<ValidValue>;
  denomination: Array<Denomination>;
  designation: Array<ValidValue>;
  eLabelCertification: Array<ELabelCertificationValidValue>;
  foodBusinessOperatorType: Array<ValidValue>;
  ingredient: Array<ValidValue>;
  /**
   * The name of the workspace.
   * @deprecated Use owner.name instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  packagingCertification: Array<PackagingCertificationValidValue>;
  packagingGasesFunction: Array<ValidValue>;
  packagingMaterialType: Array<PackagingMaterialTypeValidValues>;
  productType: Array<ProductTypeValidValues>;
  productionMethod: Array<ValidValue>;
  region: Array<ValidValue>;
  responsibleConsumptionLogo: Array<ResponsibleConsumptionValidValues>;
  spiritType: Array<ValidValue>;
  subregion: Array<ValidValue>;
  varietyName: Array<ValidValue>;
  wineColor: Array<ValidValue>;
  wineType: Array<ValidValue>;
  /** The workspace id. */
  workspaceId: Scalars['ID']['output'];
};


export type ValidValuesBeerStyleArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesContainerColorArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesContainerTypeArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesCountryArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesDenominationArgs = {
  includeHierarchy?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesDesignationArgs = {
  locale?: InputMaybe<ELabelLocale>;
  productType?: InputMaybe<ELabelProductType>;
};


export type ValidValuesELabelCertificationArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesFoodBusinessOperatorTypeArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesIngredientArgs = {
  includeDeprecatedValues?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<ELabelLocale>;
  productType?: InputMaybe<ELabelProductType>;
};


export type ValidValuesPackagingCertificationArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesPackagingGasesFunctionArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesPackagingMaterialTypeArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesProductTypeArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesProductionMethodArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesRegionArgs = {
  country: Country;
};


export type ValidValuesResponsibleConsumptionLogoArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesSpiritTypeArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesSubregionArgs = {
  region: Scalars['String']['input'];
};


export type ValidValuesVarietyNameArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesWineColorArgs = {
  locale?: InputMaybe<ELabelLocale>;
};


export type ValidValuesWineTypeArgs = {
  locale?: InputMaybe<ELabelLocale>;
};

export type ValidateVatIdInput = {
  /** The country. */
  country: Country;
  /** The VAT ID. */
  vatId: Scalars['String']['input'];
};

export type ValidateVatIdResponse = MutationResponse & {
  code: Scalars['String']['output'];
  isValid?: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Video = {
  /** The title displayed for the video. */
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<VideoType>;
  /** The URL for the video. */
  url?: Maybe<Scalars['String']['output']>;
  videoId?: Maybe<Scalars['String']['output']>;
};


export type VideoUrlArgs = {
  format?: InputMaybe<UrlFormat>;
};

export type VideoType =
  | 'FACEBOOK'
  | 'INSTAGRAM'
  | 'POLYVIDEO'
  | 'VIMEO'
  | 'YOUTUBE';

export type VisibilityStatusQueryOperatorInput = {
  eq?: InputMaybe<VisibilityStatusType>;
  in?: InputMaybe<Array<InputMaybe<VisibilityStatusType>>>;
  ne?: InputMaybe<VisibilityStatusType>;
  nin?: InputMaybe<Array<InputMaybe<VisibilityStatusType>>>;
};

export type VisibilityStatusType =
  /** Registration has passed and no longer active. */
  | 'ARCHIVED'
  /** Registration is closed and no companies can start or modify their registration. */
  | 'CLOSED'
  /** Any company can start a registration. There are no visibility restrictions. */
  | 'OPEN'
  /** Is only visible to companies in the collection. Other companies can't see or start the registration. */
  | 'PRIVATE';

/** Volume measurement unit as defined in GS1 standards. */
export type VolumeUnitCode =
  /** Liter */
  | 'LTR'
  /** Milliliter */
  | 'MLT';

/** A volume value including unit. */
export type VolumeValue = {
  /** The volume in a specific locale. */
  formattedValue: Scalars['String']['output'];
  unit: VolumeUnitCode;
  value: Scalars['Float']['output'];
};


/** A volume value including unit. */
export type VolumeValueFormattedValueArgs = {
  format?: InputMaybe<NumberFormat>;
  locale: ContentLocale;
};

export type VolumeValueInput = {
  unit: VolumeUnitCode;
  value: Scalars['Float']['input'];
};

/** Weight unit as defined in GS1 standards. */
export type WeightUnitCode =
  /** Gram */
  | 'GRM'
  /** Kilogram */
  | 'KGM'
  /** Milligram */
  | 'MGM'
  /** Tonne */
  | 'TNE';

/** A weight value including unit. */
export type WeightValue = {
  /** The weight in a specific locale. */
  formattedValue: Scalars['String']['output'];
  unit: WeightUnitCode;
  value: Scalars['Float']['output'];
};


/** A weight value including unit. */
export type WeightValueFormattedValueArgs = {
  format?: InputMaybe<NumberFormat>;
  locale: ContentLocale;
};

export type Wine = ExtendedProduct & Item & Product & {
  /**
   * The GTIN of the product.
   *
   * Returns the GTIN of the first product variant.
   */
  GTIN?: Maybe<Scalars['String']['output']>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_childProducts: Array<Unstable_CoreProduct>;
  /**
   * The eLabels of the wine.
   * @deprecated This field is experimental and will change without notice.
   */
  _unstable_eLabels: ELabelConnection;
  /**
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_packaging: Array<ProductPackaging>;
  /**
   * The parent product of this product.
   * @deprecated Use at your own risk - will be renamed or changed without notice! Add your personal experimentalKey, or your code will break.
   */
  _unstable_parentProduct?: Maybe<Unstable_CoreProduct>;
  /** @deprecated Don't use - will be deleted soon! */
  _unstable_parentProductDifferences: Array<ProductVersionChange>;
  /**
   * A list of private workspace-owned events.
   *
   * This can be used to get all the field configurations for a product to edit.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioConfigurations: Array<Event>;
  /**
   * A list of registeredProduct entries.
   * This can be used for collection-based Portfolio.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_portfolioRegisteredProducts: RegisteredProductConnection;
  /**
   * The primary packaging (typically a bottle).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_primaryPackaging?: Maybe<PrimaryProductPackaging>;
  /**
   * The qr codes of the wine.
   * @deprecated This field is experimental and will change without notice.
   */
  _unstable_qrCodes: Unstable_QrCodeConnection;
  /**
   * The secondary packaging (typically a case).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_secondaryPackaging?: Maybe<SecondaryProductPackaging>;
  /**
   * The tertiary packaging (typically a pallet).
   * @deprecated We're transitioning to this field, but we're not ready yet.
   * Treat it as beta quality and use bottleVariants or packagingVariants for now.
   */
  _unstable_tertiaryPackaging?: Maybe<TertiaryProductPackaging>;
  /**
   * A product's workspace.
   * @deprecated Experimental - will be renamed in a future release!
   */
  _unstable_workspace: Workspace;
  /** The measurement method of the total acidity. */
  acidityUnit?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage of alcohol actually measured.
   * This is the analytical value measured in the lab.
   * This value is normally not communicated, only for some professional tastings.
   */
  actualAlcohol?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use agingPotential instead. */
  ageingPotential?: Maybe<Scalars['String']['output']>;
  /** The potential to store the wine. */
  agingPotential?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage of alcohol as displayed on the label.
   * This is often rounded according to local regulations.
   */
  alcohol?: Maybe<Scalars['Float']['output']>;
  /** Utility function to get all allergens as a single line of text. */
  allergensText?: Maybe<Scalars['String']['output']>;
  animalProducts?: Maybe<Scalars['Boolean']['output']>;
  /** The color of the product. */
  apparentColor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use appearanceDescription instead. */
  appearance?: Maybe<Scalars['String']['output']>;
  /** The appearance description for this product. */
  appearanceDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity of the appearance. */
  appearanceIntensity?: Maybe<Scalars['String']['output']>;
  /** Floral hints on the aroma. */
  aromaFloral?: Maybe<Scalars['String']['output']>;
  /** Fruity notes on the aroma. */
  aromaFruit?: Maybe<Scalars['String']['output']>;
  /** The intensity of the aroma. */
  aromaIntensity?: Maybe<Scalars['String']['output']>;
  /** Spicy aspects of the aroma. */
  aromaSpice?: Maybe<Scalars['String']['output']>;
  /** Wooden scents on that product. */
  aromaWood?: Maybe<Scalars['String']['output']>;
  awards?: Maybe<Array<WineAward>>;
  backLabelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use backLabelImage { url } instead. */
  backLabelImageUrl?: Maybe<Scalars['String']['output']>;
  barrelAge?: Maybe<Scalars['String']['output']>;
  barrelType?: Maybe<Scalars['String']['output']>;
  biodynamicAccreditation?: Maybe<Scalars['String']['output']>;
  biodynamicCertificate?: Maybe<CloudinaryAsset>;
  /** @deprecated Use biodynamicCertificate instead */
  biodynamicCertificateUrl?: Maybe<Scalars['String']['output']>;
  biodynamicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  bottleImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use bottleImage { url } instead. */
  bottleImageUrl?: Maybe<Scalars['String']['output']>;
  bottleVariants?: Maybe<Array<ProductBottleVariant>>;
  /**
   * The bottles per case.
   *
   * Returns the bottles per case of the first packaging variant.
   */
  bottlesPerCase?: Maybe<Scalars['Int']['output']>;
  bottlingDate?: Maybe<Scalars['String']['output']>;
  brix?: Maybe<Scalars['String']['output']>;
  canopyManagement?: Maybe<Scalars['String']['output']>;
  /** The sugars per 100ml in grams. */
  carbohydrateSugars?: Maybe<Scalars['Float']['output']>;
  /** The carbohydrate per 100ml in grams. */
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  /**
   * The GTIN of the product case.
   *
   * Returns the GTIN of the first packaging variant.
   */
  caseGTIN?: Maybe<Scalars['String']['output']>;
  /** The cellarmaster value. */
  cellarmaster?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<ProductCertification>>;
  characteristics?: Maybe<Array<Maybe<ProductCharacteristicEnum>>>;
  /** The classification value. */
  classification?: Maybe<Scalars['String']['output']>;
  clones?: Maybe<Scalars['String']['output']>;
  /** The profile of the importer, retailer or company behind the product. */
  companyProfile?: Maybe<CompanyProfile>;
  /** The product description target consumers. */
  consumerDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the consumer product variant (typically the vintage of a wine or any other information).
   * @deprecated Experimental - use at your own risk.
   */
  consumerProductVariant?: Maybe<Scalars['String']['output']>;
  /**
   * The consumer wine description.
   * @deprecated Prefer description because different descriptions for different target audiences are confusing.
   */
  consumerWineDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use description instead. */
  consumer_wineDescription?: Maybe<Scalars['String']['output']>;
  containsCelery?: Maybe<Scalars['Boolean']['output']>;
  containsCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  containsEggs?: Maybe<Scalars['Boolean']['output']>;
  containsFish?: Maybe<Scalars['Boolean']['output']>;
  containsGluten?: Maybe<Scalars['Boolean']['output']>;
  containsLupin?: Maybe<Scalars['Boolean']['output']>;
  containsMilk?: Maybe<Scalars['Boolean']['output']>;
  containsMolluscs?: Maybe<Scalars['Boolean']['output']>;
  containsMustard?: Maybe<Scalars['Boolean']['output']>;
  containsNuts?: Maybe<Scalars['Boolean']['output']>;
  containsPeanuts?: Maybe<Scalars['Boolean']['output']>;
  containsSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  containsSoybeans?: Maybe<Scalars['Boolean']['output']>;
  containsSulfites?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A number describing the product's content completeness.
   * The guiding principle is that those pieces of content must be valuable to the majority of visitors.
   * Currently bottle image, alcohol, wine description, webshop, food pairing description
   * and product videos are fields that each raise the content level.
   * The content level calculation will change and mature over time, similar to the Google PageRank.
   */
  contentLevel: Scalars['Int']['output'];
  /** The country the product was produced in. */
  country?: Maybe<Scalars['String']['output']>;
  cropLoad?: Maybe<Scalars['String']['output']>;
  /** A certain custom field, available on events and requests. */
  customField?: Maybe<CustomField>;
  /**
   * A certain custom field's raw text.
   * This is the shortest path to a custom field's value and always returns the raw text.
   * If you need to get typed values and more metadata, use customField instead.
   */
  customFieldText?: Maybe<Scalars['String']['output']>;
  /**
   * A certain custom field's value, available on events and requests.
   * This is a shortcut – If you need more, use customField instead.
   */
  customFieldValue?: Maybe<FieldValue>;
  /** The custom fields available on events and requests. */
  customFields?: Maybe<Array<CustomField>>;
  /** The customized name of the region. */
  customRegion?: Maybe<Scalars['String']['output']>;
  /** The customized name of the subregion. */
  customSubregion?: Maybe<Scalars['String']['output']>;
  /**
   * An Excel document containing all the product data in a printable format,
   * also enabling data extraction and reuse.
   */
  dataFile?: Maybe<ProductDataFile>;
  /**
   * The name of the denomination. This extends the logic of regionName and
   * uses custom logic for specific regions such as Spain and Austria.
   */
  denomination?: Maybe<Scalars['String']['output']>;
  /** The product description for the trade. */
  description?: Maybe<Scalars['String']['output']>;
  /** Designation aka wineStyle (Wine style) */
  designation?: Maybe<Scalars['String']['output']>;
  drinkAfter?: Maybe<Scalars['String']['output']>;
  drinkBefore?: Maybe<Scalars['String']['output']>;
  /** The product's related e-labels. */
  eLabels: ELabelConnection;
  /** The energy value in kcal per 100ml. */
  energyKcal?: Maybe<Scalars['Float']['output']>;
  /** The energy value in kJ per 100ml. */
  energyKj?: Maybe<Scalars['Float']['output']>;
  /** The exhibitor presenting a product at an event. */
  exhibitor?: Maybe<Exhibitor>;
  /** The ID of an exhibitor presenting the product at an event. */
  exhibitorId?: Maybe<Scalars['ID']['output']>;
  extract?: Maybe<Scalars['Float']['output']>;
  extractionProcess?: Maybe<Scalars['String']['output']>;
  fairtradeAccreditation?: Maybe<Scalars['String']['output']>;
  /** The fat per 100ml in grams. */
  fat?: Maybe<Scalars['Float']['output']>;
  /** A list of content features that make this product more valuable to visitors than other products. */
  featuredContentTypes?: Maybe<Array<FeaturedProductContentType>>;
  /** The fermentation process. */
  fermentation?: Maybe<Scalars['String']['output']>;
  /** Type of fermentation (native, innoculated, or both) */
  fermentationType?: Maybe<Scalars['String']['output']>;
  /**
   * The list of fermentation vessel types used.
   * If null, the fermentation vessel types are not known.
   * If an empty array, there were no fermentation vessel types used.
   */
  fermentationVesselTypes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The fermentation vessel material.
   * @deprecated Use fermentationVesselTypes instead.
   */
  fermentationVessels?: Maybe<Scalars['String']['output']>;
  fileLibrary?: Maybe<Array<ProductFileAttachment>>;
  /** Shows files attached to this product. */
  files?: Maybe<FileConnection>;
  filtering?: Maybe<Scalars['String']['output']>;
  /**
   * The list of fining agents used.
   * If null, the fining agents are not known.
   * If an empty array, there were no fining agents used.
   */
  finingAgents?: Maybe<Array<Scalars['String']['output']>>;
  finish?: Maybe<Scalars['String']['output']>;
  /** The finish description for this product. */
  finishDescription?: Maybe<Scalars['String']['output']>;
  /** Fortified type for wines */
  fortifiedType?: Maybe<Scalars['String']['output']>;
  fruitSorting?: Maybe<Scalars['String']['output']>;
  /** The brand's gallery images, showcasing their brand. */
  galleryImages?: Maybe<Array<File>>;
  /**
   * The grape varieties used in the product.
   * By industry convention, these are ordered descending by percentage, but this is never enforced by Bottlebooks.
   * It's the users' responsibility to add the varieties in the correct order.
   */
  grapeVarieties?: Maybe<Array<ProductGrapeVariety>>;
  greenHarvest?: Maybe<Scalars['String']['output']>;
  harvest?: Maybe<Scalars['String']['output']>;
  /** Description of the wine's harvest. */
  harvestNotes?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<Maybe<HistoryEntry>>>;
  /** A printable product info sheet as a PDF. */
  infoSheet?: Maybe<ProductInfoSheet>;
  ingredients?: Maybe<Array<ProductIngredient>>;
  /** Utility function to get all ingredients as a string. */
  ingredientsText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryAromas instead. */
  intenseAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use primaryFlavors instead. */
  intenseFlavors?: Maybe<Array<Scalars['String']['output']>>;
  internationalCertifications?: Maybe<Array<InternationalProductCertification>>;
  /**
   * The inventory ID specific to the company.
   * @deprecated Use productExternalId instead.
   */
  inventoryId?: Maybe<Scalars['String']['output']>;
  /**
   * The secondary inventory ID specific to the company.
   * @deprecated Use productExternalId2 instead.
   */
  inventoryId2?: Maybe<Scalars['String']['output']>;
  irrigation?: Maybe<Scalars['String']['output']>;
  isBiodynamic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCelery instead. */
  isCelery?: Maybe<Scalars['Boolean']['output']>;
  isCertifiedOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsCrustaceans instead. */
  isCrustaceans?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsEggs instead. */
  isEggs?: Maybe<Scalars['Boolean']['output']>;
  isFairtrade?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsFish instead. */
  isFish?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsGluten instead. */
  isGluten?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is this product free of genetically modified organisms?
   * "Not sure", "not asked" and "not answered" all resolve to null.
   */
  isGmoFree?: Maybe<Scalars['Boolean']['output']>;
  isKosher?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsLupin instead. */
  isLupin?: Maybe<Scalars['Boolean']['output']>;
  isMevushal?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMilk instead. */
  isMilk?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMolluscs instead. */
  isMolluscs?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsMustard instead. */
  isMustard?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsNuts instead. */
  isNuts?: Maybe<Scalars['Boolean']['output']>;
  /** Is this wine from old vines? */
  isOldVines?: Maybe<Scalars['Boolean']['output']>;
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsPeanuts instead. */
  isPeanuts?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSesameSeeds instead. */
  isSesameSeeds?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use containsSoybeans instead. */
  isSoybeans?: Maybe<Scalars['Boolean']['output']>;
  isSustainable?: Maybe<Scalars['Boolean']['output']>;
  isVegan?: Maybe<Scalars['Boolean']['output']>;
  isVegetarian?: Maybe<Scalars['Boolean']['output']>;
  labelImage?: Maybe<CloudinaryAsset>;
  /** @deprecated Needed to support Bottlebooks Classic. Use labelImage { url } instead. */
  labelImageUrl?: Maybe<Scalars['String']['output']>;
  localCertifications?: Maybe<Array<LocalProductCertification>>;
  /** Low / no alcohol statement. */
  lowNoAlcoholStatement?: Maybe<Scalars['String']['output']>;
  lwinId?: Maybe<Scalars['String']['output']>;
  /** Describes the wine's maceration (skin contact, temperature control…). */
  maceration?: Maybe<Scalars['String']['output']>;
  /**
   * The amount of malic acid in grams/liter.
   * This value is not commonly communicated.
   */
  malicAcid?: Maybe<Scalars['Float']['output']>;
  /** Description of the malolactic fermentation process. */
  malolacticFermentation?: Maybe<Scalars['String']['output']>;
  /** Notes on how to market this wine. */
  marketingNotes?: Maybe<Scalars['String']['output']>;
  /** Describes the wine's maturation process. */
  maturation?: Maybe<Scalars['String']['output']>;
  maturity?: Maybe<Scalars['String']['output']>;
  maxTemp?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryAromas instead. */
  mildAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Needed to support Bottlebooks Classic. Use secondaryFlavors instead. */
  mildFlavors?: Maybe<Array<Scalars['String']['output']>>;
  minTemp?: Maybe<Scalars['String']['output']>;
  monthsInBarrel?: Maybe<Scalars['String']['output']>;
  monthsInBottle?: Maybe<Scalars['String']['output']>;
  /** The number of months this wine has been aged on lees. */
  monthsOnLees?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Was this wine fermented exclusively with native yeast? */
  nativeFermentation?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use noseDescription instead. */
  nose?: Maybe<Scalars['String']['output']>;
  /** The nose description for this product. */
  noseDescription?: Maybe<Scalars['String']['output']>;
  /** Description of the influence of oak on the wine. */
  oakInfluence?: Maybe<Scalars['String']['output']>;
  officialRegistrationNumber?: Maybe<Scalars['String']['output']>;
  onlineShop?: Maybe<Scalars['String']['output']>;
  organicAccreditation?: Maybe<Scalars['String']['output']>;
  organicCertificate?: Maybe<CloudinaryAsset>;
  organicCertificateUrl?: Maybe<Scalars['String']['output']>;
  organicCertificationValidUntil?: Maybe<Scalars['String']['output']>;
  /** Awards not in the list of recognized awards. Free text. */
  otherAwards?: Maybe<Scalars['String']['output']>;
  /** All sustainability certifications not covered in localCertifications and internationalCertifications can be added as free text. */
  otherSustainabilityCertifications?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use productRange instead. */
  ownClassification?: Maybe<Scalars['String']['output']>;
  /** The pH value. */
  pH?: Maybe<Scalars['Float']['output']>;
  /** The packaging gas used. This is automatically included in ingredientsText. */
  packagingGasesFunction?: Maybe<Scalars['String']['output']>;
  packagingVariants?: Maybe<Array<ProductPackagingVariant>>;
  /** The food pairing description for this product. */
  pairingDescription?: Maybe<Scalars['String']['output']>;
  /** Food pairings that match well with the product. */
  pairings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use palateDescription instead. */
  palate?: Maybe<Scalars['String']['output']>;
  /** The color of the product. */
  palateAcidity?: Maybe<Scalars['String']['output']>;
  /** The body of the product. */
  palateBody?: Maybe<Scalars['String']['output']>;
  /** The palate description for this product. */
  palateDescription?: Maybe<Scalars['String']['output']>;
  /** The intensity on the palate. */
  palateIntensity?: Maybe<Scalars['String']['output']>;
  /** The tannins of the product. */
  palateTannins?: Maybe<Scalars['String']['output']>;
  /**
   * The GTIN of the pallet.
   *
   * Returns the pallet GTIN of the first packaging variant.
   */
  palletGTIN?: Maybe<Scalars['String']['output']>;
  /**
   * The list of permissions on the product.
   * @deprecated We're considering to replace the list of strings with particular fields to reduce the data load when you just need a few permissions.
   */
  permissionList?: Maybe<Array<ProductRolesEnum>>;
  permissions: ProductPermissions;
  predominantYeast?: Maybe<Scalars['String']['output']>;
  pressAnecdotes?: Maybe<Scalars['String']['output']>;
  pressing?: Maybe<Scalars['String']['output']>;
  previousVintage?: Maybe<Scalars['String']['output']>;
  /**
   * A price for this product.
   * @deprecated Use registeredProduct.pricing instead.
   */
  pricing?: Maybe<ProductPrice>;
  /** A list of primary aromas in the nose. */
  primaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of primary flavors on the palate. */
  primaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The primary variety of the wine.
   * This is the first in the list of varieties.
   */
  primaryVariety?: Maybe<ProductGrapeVariety>;
  /**
   * The name of the primary variety of the wine.
   * This is a shortcut to 'grapeVarieties[0].varietyName'
   */
  primaryVarietyName?: Maybe<Scalars['String']['output']>;
  /** The product's producer. */
  producer?: Maybe<Producer>;
  productCategory?: Maybe<ProductCategory>;
  /** productExternalId Should represent unique product ID specific to the company. Former inventoryId */
  productExternalId?: Maybe<Scalars['String']['output']>;
  /** productExternalId2 Should represent additional product ID specific to the company. Former inventoryId2 */
  productExternalId2?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productRange?: Maybe<Scalars['String']['output']>;
  productType: ProductType;
  /** The protein per 100ml in grams. */
  protein?: Maybe<Scalars['Float']['output']>;
  pruning?: Maybe<Scalars['String']['output']>;
  qualityControlCertificates?: Maybe<Scalars['String']['output']>;
  /** Describes the product range. */
  rangeDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The name that the customer is using internally to refer to this product.
   * @deprecated Experimental - use at your own risk.
   */
  referenceName?: Maybe<Scalars['String']['output']>;
  /**
   * The region the product was produced in.
   * This is one of the officialy recognized regions of the country.
   * Regions are often subdivided into subregions - that value can be found on Product.subregion.
   */
  region?: Maybe<Scalars['String']['output']>;
  /** The region hierarchy of a product, starting with country. */
  regionHierarchy?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The name of the subregion, region or country – whichever has a value:
   * - For products with subregion, the subregion is returned.
   * - For products with region only, the region is returned.
   * - For products with country, the country is returned.
   * - For products using custom names, the custom name is returned.
   */
  regionName?: Maybe<Scalars['String']['output']>;
  /** The sugar in grams/liter. */
  residualSugar?: Maybe<Scalars['Float']['output']>;
  rootstock?: Maybe<Scalars['String']['output']>;
  /** The salt per 100ml in grams. */
  salt?: Maybe<Scalars['Float']['output']>;
  /** The saturates per 100ml in grams. */
  saturatedFat?: Maybe<Scalars['Float']['output']>;
  /** A list of secondary aromas in the nose. */
  secondaryAromas?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of secondary flavors on the palate. */
  secondaryFlavors?: Maybe<Array<Scalars['String']['output']>>;
  shortName: Scalars['String']['output'];
  /**
   * A list of content features that make this product more valuable to visitors than other products.
   * The useIdOnly flag is deprecated, use format=ID instead.
   */
  slug: Scalars['String']['output'];
  /** The vineyard's soil type description. */
  soilType?: Maybe<Scalars['String']['output']>;
  /** The different types of soil. */
  soilTypes?: Maybe<Array<SoilType>>;
  /** The specialClassification value. */
  specialClassification?: Maybe<Scalars['String']['output']>;
  /** A stand on an event. */
  stand?: Maybe<Stand>;
  status?: Maybe<ProductStatus>;
  /**
   * The product name in a structured format.
   * @deprecated Used internally only and not ready for production - use name instead.
   */
  structuredName?: Maybe<StructuredProductName>;
  /**
   * The subregion the product was produced in.
   * This is one of the officialy recognized subregions of the region.
   */
  subregion?: Maybe<Scalars['String']['output']>;
  suggestedCategory?: Maybe<ProductCategory>;
  sulfurAdded?: Maybe<Scalars['Boolean']['output']>;
  sustainabilityCertificateUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Needed to support Bottlebooks Classic. Use otherSustainabilityCertifications instead. */
  sustainabilityCertificatesOther?: Maybe<Scalars['String']['output']>;
  sustainabilityId?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tastingNotes?: Maybe<Array<ProductTastingNote>>;
  /** The total acidity in grams/liter. */
  totalAcidity?: Maybe<Scalars['Float']['output']>;
  totalSulphur?: Maybe<Scalars['Float']['output']>;
  /** The vine training system used, like Guyot or Lyre. */
  training?: Maybe<Scalars['String']['output']>;
  /** An ISO date when the product was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Shows the collections this product is used in. */
  usedIn?: Maybe<ProductUsedInConnection>;
  /** Shows the e-labels where this product is used in. */
  usedInELabels?: Maybe<ProductUsedInELabelsConnection>;
  /**
   * The name of the product variant (bottle size, closure or other differentiating factor?
   * @deprecated Experimental - use at your own risk.
   */
  variantName?: Maybe<Scalars['String']['output']>;
  /** Product videos (Youtube, Vimeo, Instagram, Facebook etc.) */
  videos?: Maybe<Array<Maybe<Video>>>;
  /** The vine density in free text form. */
  vineDensity?: Maybe<Scalars['String']['output']>;
  /** The vineyard name. */
  vineyard?: Maybe<Scalars['String']['output']>;
  /** The age of the vineyard. */
  vineyardAge?: Maybe<Scalars['String']['output']>;
  /** The vineyard elevation. */
  vineyardElevation?: Maybe<Scalars['String']['output']>;
  /** The vineyard description. */
  vineyardInformation?: Maybe<Scalars['String']['output']>;
  vineyardSpacing?: Maybe<Scalars['String']['output']>;
  /** The vinification description as a multi-line text. */
  vinification?: Maybe<Scalars['String']['output']>;
  vintage?: Maybe<Scalars['String']['output']>;
  vintageChangeover?: Maybe<Scalars['String']['output']>;
  /** The vintageReport value. */
  vintageReport?: Maybe<Scalars['String']['output']>;
  /** The viticulture description. */
  viticulture?: Maybe<Scalars['String']['output']>;
  /** The volume of each portion. */
  volumeOfPortion?: Maybe<Scalars['Float']['output']>;
  webshop?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wholeClusterPercent?: Maybe<Scalars['String']['output']>;
  wineColor?: Maybe<Scalars['String']['output']>;
  /**
   * The wine description.
   * @deprecated Use description instead.
   */
  wineDescription?: Maybe<Scalars['String']['output']>;
  wineType?: Maybe<Scalars['String']['output']>;
  /** The name of this wine's winemaker. */
  winemaker?: Maybe<Scalars['String']['output']>;
  yeastAssimilableNitrogen?: Maybe<Scalars['String']['output']>;
  /** The crop yield. */
  yield?: Maybe<Scalars['String']['output']>;
};


export type WineGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type Wine_Unstable_ChildProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_ELabelsArgs = {
  experimentalKey: Scalars['String']['input'];
  versionTag?: InputMaybe<Scalars['String']['input']>;
};


export type Wine_Unstable_PackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_ParentProductArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_ParentProductDifferencesArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_PortfolioConfigurationsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_PortfolioRegisteredProductsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_PrimaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_QrCodesArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_SecondaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_TertiaryPackagingArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Wine_Unstable_WorkspaceArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type WineAcidityUnitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineApparentColorArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineAppearanceDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineAppearanceIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineAromaFloralArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineAromaFruitArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineAromaIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineAromaSpiceArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineAromaWoodArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineBottlingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type WineCaseGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type WineClassificationArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineConsumerDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineConsumerProductVariantArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineCountryArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineCustomFieldArgs = {
  key: Scalars['String']['input'];
};


export type WineCustomFieldTextArgs = {
  key: Scalars['String']['input'];
};


export type WineCustomFieldValueArgs = {
  key: Scalars['String']['input'];
};


export type WineCustomRegionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineCustomSubregionArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineDataFileArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type WineDenominationArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineDesignationArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineELabelsArgs = {
  filter?: InputMaybe<ELabelFilterInput>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type WineFermentationArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineFermentationTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineFermentationVesselTypesArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineFermentationVesselsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineFilesArgs = {
  contentDisposition?: InputMaybe<ContentDisposition>;
  filter?: InputMaybe<ProductFileFilterInput>;
};


export type WineFiningAgentsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineFinishDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineFortifiedTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineHarvestNotesArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineHistoryArgs = {
  filter?: InputMaybe<ProductHistoryFilterInput>;
};


export type WineInfoSheetArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineIngredientsTextArgs = {
  format?: InputMaybe<IngredientsTextFormat>;
};


export type WineIntenseAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineIntenseFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineInventoryIdArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineInventoryId2Args = {
  format?: InputMaybe<TextFormat>;
};


export type WineMacerationArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineMalolacticFermentationArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineMaturationArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineMildAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineMildFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineNameArgs = {
  format?: InputMaybe<TextFormat>;
  includeProducer?: InputMaybe<IncludeProducer>;
  includeVintage?: InputMaybe<IncludeVintage>;
  nonVintage?: InputMaybe<Scalars['String']['input']>;
};


export type WineNoseDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineOakInfluenceArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineOnlineShopArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type WineOtherAwardsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineOtherSustainabilityCertificationsArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WinePackagingGasesFunctionArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WinePairingDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WinePairingsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WinePalateAcidityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WinePalateBodyArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WinePalateDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WinePalateIntensityArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WinePalateTanninsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WinePalletGtinArgs = {
  format?: InputMaybe<GtinFormat>;
};


export type WinePressAnecdotesArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WinePrimaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WinePrimaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WinePrimaryVarietyNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineProductCategoryArgs = {
  withSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WineProductExternalIdArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineProductExternalId2Args = {
  format?: InputMaybe<TextFormat>;
};


export type WineProductRangeArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineRangeDescriptionArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineReferenceNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineRegionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineRegionHierarchyArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineRegionNameArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineSecondaryAromasArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineSecondaryFlavorsArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineShortNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineSlugArgs = {
  format?: InputMaybe<SlugFormat>;
  useIdOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WineSoilTypeArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineSpecialClassificationArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineStructuredNameArgs = {
  algorithm?: InputMaybe<Scalars['String']['input']>;
};


export type WineSubregionArgs = {
  format?: InputMaybe<ValidValueFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineTaglineArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineTrainingArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineUsedInArgs = {
  filter?: InputMaybe<ProductUsedInFilterInput>;
};


export type WineVariantNameArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineVineyardArgs = {
  format?: InputMaybe<TextFormat>;
};


export type WineVineyardAgeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineVineyardInformationArgs = {
  format?: InputMaybe<LongTextFormat>;
};


export type WineVinificationArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineVintageArgs = {
  nonVintage?: InputMaybe<Scalars['String']['input']>;
  removeNonVintage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WineVintageChangeoverArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type WineViticultureArgs = {
  format?: InputMaybe<LongTextFormat>;
  locale?: InputMaybe<ContentLocale>;
};


export type WineWebsiteArgs = {
  format?: InputMaybe<UrlFormat>;
};


export type WineWineColorArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineWineTypeArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


export type WineWinemakerArgs = {
  format?: InputMaybe<TextFormat>;
};

/** An award given to a particular wine. */
export type WineAward = ProductAward & {
  award?: Maybe<Scalars['String']['output']>;
  medal?: Maybe<Scalars['String']['output']>;
};


/** An award given to a particular wine. */
export type WineAwardAwardArgs = {
  format?: InputMaybe<ValidValueFormat>;
};


/** An award given to a particular wine. */
export type WineAwardMedalArgs = {
  format?: InputMaybe<ValidValueFormat>;
};

export type WineColor =
  | 'orange'
  | 'red'
  | 'rose'
  | 'white';

export type WineType =
  | 'fortified'
  | 'pearlwine'
  | 'sparkling'
  | 'wine';

export type Workspace = Item & {
  /**
   * The list of validValues.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_classicValidValues: Array<ClassicValidValueList>;
  /** @deprecated Experimental. Don't use yet. */
  _unstable_elabelValidValues: ValidValues;
  /**
   * Outputs configurations that can be added to a collection
   * @deprecated Experimental - might be removed or changed without notice. Use at your own risk.
   */
  _unstable_outputConfigurationOptions: Array<CollectionOutputConfiguration>;
  /** @deprecated Do not use - will change or be deleted without notice! */
  _unstable_portfolio?: Maybe<Unstable_Portfolio>;
  /**
   * The product versions for a given product.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_productVersions: Array<ProductVersionDetails>;
  /**
   * The product versions for a given product that have been shared with partners.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_productVersionsSharedWithPartners: Array<ProductVersionDetails>;
  _unstable_proweinExhibitor?: Maybe<ProweinExhibitor>;
  _unstable_proweinProducts: Array<Product>;
  _unstable_proweinPublishedProducts: Array<ProweinRegisteredProduct>;
  _unstable_proweinRegistrations?: Maybe<Array<ProweinRegistration>>;
  _unstable_qrCode: Unstable_QrCode;
  _unstable_qrCodes: Unstable_QrCodeConnection;
  /**
   * A particular registration of this workspace. Will be reomved in February 2024 at the latest.
   * @deprecated Use top-level registration instead. This resolver will be removed in February 2024 at the latest.
   */
  _unstable_registration: Registration;
  /**
   * The list of registrations of this workspace.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_registrations: RegistrationConnection;
  /**
   * A particular single registration of this workspace. Will be reomved in February 2024 at the latest.
   * @deprecated Use top-level singleRegistration instead. This resolver will be removed in February 2024 at the latest.
   */
  _unstable_singleRegistration: SingleRegistration;
  /**
   * The list of single registrations of this workspace.
   * @deprecated Experimental. Don't use yet.
   */
  _unstable_singleRegistrations: SingleRegistrationConnection;
  /** @deprecated Don't use - will be deleted soon! */
  _unstable_validValueLists: Unstable_ValidValueLists;
  /**
   * A single event, request, product list or share list.
   * @deprecated Not yet supported.
   */
  collection?: Maybe<Collection>;
  /**
   * The list of events, requests, product lists and share lists of the brand.
   * @deprecated Not yet supported.
   */
  collections: CollectionConnection;
  /** The configuration of the custom fields for the workspace. */
  configuration?: Maybe<WorkspaceConfiguration>;
  /** A data import. */
  dataImport?: Maybe<DataImport>;
  /** Show workspace data imports. */
  dataImports: DataImportConnection;
  /** A single elabel. */
  eLabel?: Maybe<ELabel>;
  /** The elabel subscription of the workspace. */
  eLabelSubscription?: Maybe<ELabelSubscription>;
  eLabels: ELabelConnection;
  /** The workspace partners. */
  importToolPartners: PartnerConnection;
  /**
   * Is this company an agency.
   * @deprecated Experimental. Use at your own risk!
   */
  isAgency?: Maybe<Scalars['Boolean']['output']>;
  /** The workspace partners. */
  myPartners: PartnerConnection;
  /**
   * The name of the workspace.
   * @deprecated Use owner.name instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** The profile of the owning company. */
  owner?: Maybe<CompanyProfile>;
  /** A single product in this workspace owner's portfolio. */
  product?: Maybe<Product>;
  /** The list of products in this workspace owner's portfolio. */
  products: ProductConnection;
  /** The workspace stripe data. */
  stripe?: Maybe<Stripe>;
  /** The saas subscriptions of the workspace. */
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  /**
   * The integration tokens to access Bottlebooks API.
   * @deprecated Currently in beta. Bottlebooks internal use only.
   */
  tokens?: Maybe<Array<Maybe<ApiToken>>>;
  /** The company type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The workspace id. */
  workspaceId: Scalars['ID']['output'];
};


export type Workspace_Unstable_ClassicValidValuesArgs = {
  experimentalKey: Scalars['String']['input'];
  locale: InterfaceLocale;
};


export type Workspace_Unstable_ElabelValidValuesArgs = {
  experimentalKey: Scalars['String']['input'];
  locale: ELabelLocale;
};


export type Workspace_Unstable_OutputConfigurationOptionsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Workspace_Unstable_PortfolioArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type Workspace_Unstable_ProductVersionsArgs = {
  experimentalKey: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};


export type Workspace_Unstable_ProductVersionsSharedWithPartnersArgs = {
  experimentalKey: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};


export type Workspace_Unstable_ProweinExhibitorArgs = {
  experimentalKey: Scalars['String']['input'];
  standOrderNumber: Scalars['ID']['input'];
};


export type Workspace_Unstable_ProweinProductsArgs = {
  experimentalKey: Scalars['String']['input'];
  standOrderNumber: Scalars['ID']['input'];
};


export type Workspace_Unstable_ProweinPublishedProductsArgs = {
  experimentalKey: Scalars['String']['input'];
  standOrderNumber?: InputMaybe<Scalars['ID']['input']>;
};


export type Workspace_Unstable_ProweinRegistrationsArgs = {
  experimentalKey: Scalars['String']['input'];
  registrationId?: InputMaybe<Scalars['ID']['input']>;
  standOrderNumber?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ProweinStatus>;
};


export type Workspace_Unstable_QrCodeArgs = {
  experimentalKey: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type Workspace_Unstable_QrCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  experimentalKey: Scalars['String']['input'];
  filter?: InputMaybe<Unstable_QrCodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type Workspace_Unstable_RegistrationArgs = {
  experimentalKey: Scalars['String']['input'];
  registrationId: Scalars['ID']['input'];
};


export type Workspace_Unstable_RegistrationsArgs = {
  experimentalKey: Scalars['String']['input'];
  filter?: InputMaybe<WorkspaceRegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type Workspace_Unstable_SingleRegistrationArgs = {
  experimentalKey: Scalars['String']['input'];
  registrationId: Scalars['ID']['input'];
};


export type Workspace_Unstable_SingleRegistrationsArgs = {
  experimentalKey: Scalars['String']['input'];
  filter?: InputMaybe<WorkspaceSingleRegistrationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type Workspace_Unstable_ValidValueListsArgs = {
  experimentalKey: Scalars['String']['input'];
};


export type WorkspaceCollectionArgs = {
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
};


export type WorkspaceCollectionsArgs = {
  filter?: InputMaybe<CollectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<ContentLocale>;
};


export type WorkspaceDataImportArgs = {
  filter?: InputMaybe<ImportFilterInput>;
  importId: Scalars['ID']['input'];
};


export type WorkspaceDataImportsArgs = {
  filter?: InputMaybe<DataImportFilterInput>;
};


export type WorkspaceELabelArgs = {
  elabelId: Scalars['ID']['input'];
  locale?: InputMaybe<ELabelLocale>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type WorkspaceELabelsArgs = {
  filter?: InputMaybe<ELabelFilterInput>;
  locale?: InputMaybe<ELabelLocale>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type WorkspaceImportToolPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MyPartnerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type WorkspaceMyPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MyPartnerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type WorkspaceProductArgs = {
  locale?: InputMaybe<ContentLocale>;
  productId: Scalars['ID']['input'];
};


export type WorkspaceProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
  useNext?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkspaceConfiguration = {
  /** The configuration of the custom fields for products. */
  customProductFields: Array<CustomField>;
  /** The configuration of the custom fields for profiles. */
  customProfileFields: Array<CustomField>;
  /** The value saved by user as default value for ingredients. */
  showAllELabelIngredients?: Maybe<Scalars['Boolean']['output']>;
  /** The feature is visible or not */
  showAllELabelIngredientsFeature?: Maybe<Scalars['Boolean']['output']>;
  showQrCodeMenuForELabels?: Maybe<Scalars['Boolean']['output']>;
  workspaceId: Scalars['ID']['output'];
};

export type WorkspaceRegistrationFilterInput = {
  collection?: InputMaybe<CollectionFilterInput>;
  collectionId?: InputMaybe<IdQueryOperatorInput>;
  companyId?: InputMaybe<IdQueryOperatorInput>;
  /** The type of registration to support. */
  registrationType?: InputMaybe<RegistrationTypeQueryOperatorInput>;
};

export type WorkspaceSingleRegistrationFilterInput = {
  collection?: InputMaybe<CollectionFilterInput>;
  collectionId?: InputMaybe<IdQueryOperatorInput>;
  companyId?: InputMaybe<IdQueryOperatorInput>;
};

/** The configuration and info about a user within a specific workspace, such as their roles. */
export type WorkspaceUser = Node & {
  /** The globally unique id of the user settings. */
  id: Scalars['ID']['output'];
  /**
   * The user has read-only access to this workspace. This is a utility function to check if the user has the READ_ONLY role.
   * @deprecated This property may be disambiguated for different apps in the future.
   */
  isReadOnly: Scalars['Boolean']['output'];
  /** The user roles. */
  roles: Array<WorkspaceUserRole>;
  /** The user's unique id. */
  userId: Scalars['ID']['output'];
  /** The public profile of the user. */
  userProfile?: Maybe<UserProfile>;
  /** The workspace. */
  workspace?: Maybe<Workspace>;
  /** The workspace id. */
  workspaceId: Scalars['ID']['output'];
};

export type WorkspaceUserRole =
  | 'ADMIN'
  | 'READ_ONLY'
  | 'SUPER_ADMIN'
  | 'USER';

export type YesNo =
  | 'no'
  | 'yes';

export type YesNoFieldValue = FieldValue & {
  /** The text as stored in the database. */
  rawText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type _Unstable_RegistrationToken = {
  token: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type _Unstable_RegistrationWorkflowState =
  | 'HIDDEN'
  | 'INVALID'
  | 'NOT_STARTED'
  | 'VALID';

export type AddPartnerAliasInput = {
  /** The alias to be added. */
  alias: Scalars['String']['input'];
  /** The related Bottlebooks company id when partner is not already defined. */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the import. */
  importId: Scalars['ID']['input'];
  /** The related partner ID. */
  partnerId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateNewVintageResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteDataImportInput = {
  /** The ID of the data import that will be updated. */
  importId: Scalars['ID']['input'];
};

export type DeleteInfoSheetConfigurationInput = {
  /** The id of the file to detach. */
  configurationId: Scalars['ID']['input'];
};

export type DeleteInfoSheetConfigurationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ELabelCertificationValidValue = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logo?: Maybe<CloudinaryAsset>;
  styles?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type ExportFieldsInput = {
  analysis?: InputMaybe<Scalars['Boolean']['input']>;
  basicInfo?: InputMaybe<Scalars['Boolean']['input']>;
  ean?: InputMaybe<Scalars['Boolean']['input']>;
  grapeVarieties?: InputMaybe<Scalars['Boolean']['input']>;
  group_awards?: InputMaybe<Scalars['Boolean']['input']>;
  group_certificates?: InputMaybe<Scalars['Boolean']['input']>;
  pairingDescription?: InputMaybe<Scalars['Boolean']['input']>;
  quality?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription?: InputMaybe<Scalars['Boolean']['input']>;
  temperature?: InputMaybe<Scalars['Boolean']['input']>;
  vineyardInformation?: InputMaybe<Scalars['Boolean']['input']>;
  vinification?: InputMaybe<Scalars['Boolean']['input']>;
  viticulture?: InputMaybe<Scalars['Boolean']['input']>;
  wineDescription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinalizeAliasImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: AliasImportOptionsInput;
};

export type FinalizeELabelsUpdateImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: ELabelDataImportOptionsInput;
};

export type FinalizeELabelsUpdateImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizeProductListImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: ProductListImportOptionsInput;
};

export type FinalizeProductMasterListImportInput = {
  importId: Scalars['ID']['input'];
  importOptions: ProductMasterListImportInput;
};

export type FinalizeProductMasterListImportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinalizeProductMasterListSyncInput = {
  importId: Scalars['ID']['input'];
  importOptions: ProductMasterListSyncImportInput;
};

export type FinalizeProductMasterListSyncResponse = MutationResponse & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PackagingCertificationValidValue = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logo?: Maybe<CloudinaryAsset>;
  styles?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type PackagingMaterialTypeValidValues = {
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  deprecationDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<LocalizedField>;
  isDeprecated: Scalars['Boolean']['output'];
  isHiddenInMainList: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logo?: Maybe<CloudinaryAsset>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type ResponsibleConsumptionValidValues = {
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<LocalizedField>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logo?: Maybe<CloudinaryAsset>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SaveInfoSheetConfigurationInput = {
  brn: Scalars['String']['input'];
  /** The file content type. */
  contentType: FileContentType;
  fields: ExportFieldsInput;
  /** The name of the external file. */
  filename: Scalars['String']['input'];
  /** The languages used in the file. */
  languages: Array<Scalars['String']['input']>;
  /** The id of the node relationship (productId). */
  nodeId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveInfoSheetConfigurationResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The file if successful. */
  file?: Maybe<File>;
  message: Scalars['String']['output'];
  /**
   * The node the file is added to.
   * You can query the files field there to get the new order.
   */
  node?: Maybe<Item>;
  success: Scalars['Boolean']['output'];
};

export type SendMessageInput = {
  /** The collection where the registration is made. */
  collectionId: Scalars['ID']['input'];
  /** The exhibitors that will receive the message. */
  exhibitorIds: Array<Scalars['ID']['input']>;
  /** The message body */
  message: Scalars['String']['input'];
  /** The message subject */
  subject: Scalars['String']['input'];
};

export type SendMessageResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SendMessageToContactsInput = {
  /** The contact IDs that will receive the message. */
  contactIds: Array<Scalars['ID']['input']>;
  /** The message body. */
  message: Scalars['String']['input'];
  /** The registration where the message was triggered. */
  registrationId: Scalars['ID']['input'];
  /** The subject. */
  subject: Scalars['String']['input'];
};

export type SendMessageToMultipleRegistrationContactsInput = {
  /** The list of registration ids and contactIds. */
  contactsData: Array<ContactDataInput>;
  /** The message body. */
  message: Scalars['String']['input'];
  /** The subject. */
  subject: Scalars['String']['input'];
};

export type SendMessageToSupportInput = {
  /** The email of the sender */
  email: Scalars['String']['input'];
  /** The file to attach */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** The message body */
  message: Scalars['String']['input'];
  /** The name of the sender */
  name: Scalars['String']['input'];
  /** The message subject */
  subject: Scalars['String']['input'];
};

export type SendMessageToSupportResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SendSampleRequestInput = {
  /** The collection where the registration is made. */
  collectionId: Scalars['ID']['input'];
  /** The company whose registration the products should be added to */
  companyId: Scalars['ID']['input'];
  /** The message body */
  message: Scalars['String']['input'];
  /** The products to request */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The requester details */
  requesterDetails: RequesterDetailsInput;
};

export type SendSampleRequestResponse = MutationResponse & {
  code: Scalars['String']['output'];
  /** The error or success message. */
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StateField = {
  progress?: Maybe<Scalars['Int']['output']>;
  state: DataImportState;
};

export type UpdateDataImportIdentifierFieldsInput = {
  /** The mapping of identifier source fields to bottlebooks fields. */
  identifierFields: Array<InputMaybe<DataImportBottlebooksFieldInput>>;
  /** The ID of the data import that will be updated. */
  importId: Scalars['ID']['input'];
};

export type UpdateDataImportValueMappingsInput = {
  /** The ID of the data import that will be updated. */
  importId: Scalars['ID']['input'];
  /** The mapping of source value to bottlebooks valid value. */
  valueMappings: Array<InputMaybe<DataImportBottlebooksValueMappingsInput>>;
};

type BrandAddressSection_Profile_Brand_Fragment = (
  { address?: Array<string | null> | null, telephone?: string | null, email?: string | null, website?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null }
  & { ' $fragmentRefs'?: { 'BrandSocialMedia_Profile_Brand_Fragment': BrandSocialMedia_Profile_Brand_Fragment } }
) & { ' $fragmentName'?: 'BrandAddressSection_Profile_Brand_Fragment' };

type BrandAddressSection_Profile_BrandProfile_Fragment = (
  { address?: Array<string | null> | null, telephone?: string | null, email?: string | null, website?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null }
  & { ' $fragmentRefs'?: { 'BrandSocialMedia_Profile_BrandProfile_Fragment': BrandSocialMedia_Profile_BrandProfile_Fragment } }
) & { ' $fragmentName'?: 'BrandAddressSection_Profile_BrandProfile_Fragment' };

type BrandAddressSection_Profile_CompanyProfile_Fragment = (
  { address?: Array<string | null> | null, telephone?: string | null, email?: string | null, website?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null }
  & { ' $fragmentRefs'?: { 'BrandSocialMedia_Profile_CompanyProfile_Fragment': BrandSocialMedia_Profile_CompanyProfile_Fragment } }
) & { ' $fragmentName'?: 'BrandAddressSection_Profile_CompanyProfile_Fragment' };

type BrandAddressSection_Profile_Exhibitor_Fragment = (
  { address?: Array<string | null> | null, telephone?: string | null, email?: string | null, website?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null }
  & { ' $fragmentRefs'?: { 'BrandSocialMedia_Profile_Exhibitor_Fragment': BrandSocialMedia_Profile_Exhibitor_Fragment } }
) & { ' $fragmentName'?: 'BrandAddressSection_Profile_Exhibitor_Fragment' };

type BrandAddressSection_Profile_Producer_Fragment = (
  { address?: Array<string | null> | null, telephone?: string | null, email?: string | null, website?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null }
  & { ' $fragmentRefs'?: { 'BrandSocialMedia_Profile_Producer_Fragment': BrandSocialMedia_Profile_Producer_Fragment } }
) & { ' $fragmentName'?: 'BrandAddressSection_Profile_Producer_Fragment' };

type BrandAddressSection_Profile_RegistrationProfile_Fragment = (
  { address?: Array<string | null> | null, telephone?: string | null, email?: string | null, website?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null }
  & { ' $fragmentRefs'?: { 'BrandSocialMedia_Profile_RegistrationProfile_Fragment': BrandSocialMedia_Profile_RegistrationProfile_Fragment } }
) & { ' $fragmentName'?: 'BrandAddressSection_Profile_RegistrationProfile_Fragment' };

export type BrandAddressSection_ProfileFragment = BrandAddressSection_Profile_Brand_Fragment | BrandAddressSection_Profile_BrandProfile_Fragment | BrandAddressSection_Profile_CompanyProfile_Fragment | BrandAddressSection_Profile_Exhibitor_Fragment | BrandAddressSection_Profile_Producer_Fragment | BrandAddressSection_Profile_RegistrationProfile_Fragment;

export type BrandAnnualProduction_ProfileFragment = { annualProductionWine?: number | null } & { ' $fragmentName'?: 'BrandAnnualProduction_ProfileFragment' };

export type BrandBanner_RegistrationProfileFragment = { name?: string | null, mainImage?: { publicId?: string | null, fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null } & { ' $fragmentName'?: 'BrandBanner_RegistrationProfileFragment' };

export type BrandBanner_BrandProfileFragment = { name?: string | null, mainImage?: { publicId?: string | null, fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null } & { ' $fragmentName'?: 'BrandBanner_BrandProfileFragment' };

type BrandBanner_Brand_Fragment = { name?: string | null, mainImage?: { publicId?: string | null, fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null } & { ' $fragmentName'?: 'BrandBanner_Brand_Fragment' };

type BrandBanner_BrandProfile_Fragment = { name?: string | null, mainImage?: { publicId?: string | null, fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null } & { ' $fragmentName'?: 'BrandBanner_BrandProfile_Fragment' };

type BrandBanner_CompanyProfile_Fragment = { name?: string | null, mainImage?: { publicId?: string | null, fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null } & { ' $fragmentName'?: 'BrandBanner_CompanyProfile_Fragment' };

type BrandBanner_Exhibitor_Fragment = { name?: string | null, mainImage?: { publicId?: string | null, fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null } & { ' $fragmentName'?: 'BrandBanner_Exhibitor_Fragment' };

type BrandBanner_Producer_Fragment = { name?: string | null, mainImage?: { publicId?: string | null, fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null } & { ' $fragmentName'?: 'BrandBanner_Producer_Fragment' };

type BrandBanner_RegistrationProfile_Fragment = { name?: string | null, mainImage?: { publicId?: string | null, fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null } & { ' $fragmentName'?: 'BrandBanner_RegistrationProfile_Fragment' };

export type BrandBannerFragment = BrandBanner_Brand_Fragment | BrandBanner_BrandProfile_Fragment | BrandBanner_CompanyProfile_Fragment | BrandBanner_Exhibitor_Fragment | BrandBanner_Producer_Fragment | BrandBanner_RegistrationProfile_Fragment;

export type BrandContactFragment = { name?: string | null, title?: string | null, skypeId?: string | null, meetingBookingUrl?: string | null, email?: string | null, office?: string | null, mobile?: string | null } & { ' $fragmentName'?: 'BrandContactFragment' };

export type ContactFragment = { contactId: string, fullName?: string | null, contactTypes?: Array<ContactType> | null, title?: string | null, companyName?: string | null, websiteUrl?: string | null, websiteText?: string | null } & { ' $fragmentName'?: 'ContactFragment' };

export type DistributionContactsFragment = { companyId: string, collectionId: string, distributionContacts?: Array<(
    { contactId: string, companyId?: string | null, fullName?: string | null }
    & { ' $fragmentRefs'?: { 'ContactFragment': ContactFragment } }
  )> | null } & { ' $fragmentName'?: 'DistributionContactsFragment' };

type BrandDescription_Profile_Brand_Fragment = { shortDescription?: string | null } & { ' $fragmentName'?: 'BrandDescription_Profile_Brand_Fragment' };

type BrandDescription_Profile_BrandProfile_Fragment = { shortDescription?: string | null } & { ' $fragmentName'?: 'BrandDescription_Profile_BrandProfile_Fragment' };

type BrandDescription_Profile_CompanyProfile_Fragment = { shortDescription?: string | null } & { ' $fragmentName'?: 'BrandDescription_Profile_CompanyProfile_Fragment' };

type BrandDescription_Profile_Exhibitor_Fragment = { shortDescription?: string | null } & { ' $fragmentName'?: 'BrandDescription_Profile_Exhibitor_Fragment' };

type BrandDescription_Profile_Producer_Fragment = { shortDescription?: string | null } & { ' $fragmentName'?: 'BrandDescription_Profile_Producer_Fragment' };

type BrandDescription_Profile_RegistrationProfile_Fragment = { shortDescription?: string | null } & { ' $fragmentName'?: 'BrandDescription_Profile_RegistrationProfile_Fragment' };

export type BrandDescription_ProfileFragment = BrandDescription_Profile_Brand_Fragment | BrandDescription_Profile_BrandProfile_Fragment | BrandDescription_Profile_CompanyProfile_Fragment | BrandDescription_Profile_Exhibitor_Fragment | BrandDescription_Profile_Producer_Fragment | BrandDescription_Profile_RegistrationProfile_Fragment;

type BrandDetailsSection_GroupedRegistration_Fragment = (
  { profile?: (
    { name?: string | null }
    & { ' $fragmentRefs'?: { 'BrandDescription_Profile_RegistrationProfile_Fragment': BrandDescription_Profile_RegistrationProfile_Fragment;'BrandFounded_Profile_RegistrationProfile_Fragment': BrandFounded_Profile_RegistrationProfile_Fragment;'BrandAnnualProduction_ProfileFragment': BrandAnnualProduction_ProfileFragment;'BrandTourism_Profile_RegistrationProfile_Fragment': BrandTourism_Profile_RegistrationProfile_Fragment;'BrandGallery_Profile_RegistrationProfile_Fragment': BrandGallery_Profile_RegistrationProfile_Fragment;'BrandVideos_Profile_RegistrationProfile_Fragment': BrandVideos_Profile_RegistrationProfile_Fragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'BrandWinemaker_GroupedRegistration_Fragment': BrandWinemaker_GroupedRegistration_Fragment;'BrandViticulturist_GroupedRegistration_Fragment': BrandViticulturist_GroupedRegistration_Fragment;'BrandRegionSection_GroupedRegistration_Fragment': BrandRegionSection_GroupedRegistration_Fragment } }
) & { ' $fragmentName'?: 'BrandDetailsSection_GroupedRegistration_Fragment' };

type BrandDetailsSection_SingleRegistration_Fragment = (
  { profile?: (
    { name?: string | null }
    & { ' $fragmentRefs'?: { 'BrandDescription_Profile_RegistrationProfile_Fragment': BrandDescription_Profile_RegistrationProfile_Fragment;'BrandFounded_Profile_RegistrationProfile_Fragment': BrandFounded_Profile_RegistrationProfile_Fragment;'BrandAnnualProduction_ProfileFragment': BrandAnnualProduction_ProfileFragment;'BrandTourism_Profile_RegistrationProfile_Fragment': BrandTourism_Profile_RegistrationProfile_Fragment;'BrandGallery_Profile_RegistrationProfile_Fragment': BrandGallery_Profile_RegistrationProfile_Fragment;'BrandVideos_Profile_RegistrationProfile_Fragment': BrandVideos_Profile_RegistrationProfile_Fragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'BrandWinemaker_SingleRegistration_Fragment': BrandWinemaker_SingleRegistration_Fragment;'BrandViticulturist_SingleRegistration_Fragment': BrandViticulturist_SingleRegistration_Fragment;'BrandRegionSection_SingleRegistration_Fragment': BrandRegionSection_SingleRegistration_Fragment } }
) & { ' $fragmentName'?: 'BrandDetailsSection_SingleRegistration_Fragment' };

export type BrandDetailsSectionFragment = BrandDetailsSection_GroupedRegistration_Fragment | BrandDetailsSection_SingleRegistration_Fragment;

type BrandDetailsSection_Profile_Brand_Fragment = (
  { name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandDescription_Profile_Brand_Fragment': BrandDescription_Profile_Brand_Fragment;'BrandFounded_Profile_Brand_Fragment': BrandFounded_Profile_Brand_Fragment;'BrandTourism_Profile_Brand_Fragment': BrandTourism_Profile_Brand_Fragment;'BrandGallery_Profile_Brand_Fragment': BrandGallery_Profile_Brand_Fragment;'BrandVideos_Profile_Brand_Fragment': BrandVideos_Profile_Brand_Fragment } }
) & { ' $fragmentName'?: 'BrandDetailsSection_Profile_Brand_Fragment' };

type BrandDetailsSection_Profile_BrandProfile_Fragment = (
  { name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandDescription_Profile_BrandProfile_Fragment': BrandDescription_Profile_BrandProfile_Fragment;'BrandFounded_Profile_BrandProfile_Fragment': BrandFounded_Profile_BrandProfile_Fragment;'BrandTourism_Profile_BrandProfile_Fragment': BrandTourism_Profile_BrandProfile_Fragment;'BrandGallery_Profile_BrandProfile_Fragment': BrandGallery_Profile_BrandProfile_Fragment;'BrandVideos_Profile_BrandProfile_Fragment': BrandVideos_Profile_BrandProfile_Fragment } }
) & { ' $fragmentName'?: 'BrandDetailsSection_Profile_BrandProfile_Fragment' };

type BrandDetailsSection_Profile_CompanyProfile_Fragment = (
  { name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandDescription_Profile_CompanyProfile_Fragment': BrandDescription_Profile_CompanyProfile_Fragment;'BrandFounded_Profile_CompanyProfile_Fragment': BrandFounded_Profile_CompanyProfile_Fragment;'BrandTourism_Profile_CompanyProfile_Fragment': BrandTourism_Profile_CompanyProfile_Fragment;'BrandGallery_Profile_CompanyProfile_Fragment': BrandGallery_Profile_CompanyProfile_Fragment;'BrandVideos_Profile_CompanyProfile_Fragment': BrandVideos_Profile_CompanyProfile_Fragment } }
) & { ' $fragmentName'?: 'BrandDetailsSection_Profile_CompanyProfile_Fragment' };

type BrandDetailsSection_Profile_Exhibitor_Fragment = (
  { name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandDescription_Profile_Exhibitor_Fragment': BrandDescription_Profile_Exhibitor_Fragment;'BrandFounded_Profile_Exhibitor_Fragment': BrandFounded_Profile_Exhibitor_Fragment;'BrandTourism_Profile_Exhibitor_Fragment': BrandTourism_Profile_Exhibitor_Fragment;'BrandGallery_Profile_Exhibitor_Fragment': BrandGallery_Profile_Exhibitor_Fragment;'BrandVideos_Profile_Exhibitor_Fragment': BrandVideos_Profile_Exhibitor_Fragment } }
) & { ' $fragmentName'?: 'BrandDetailsSection_Profile_Exhibitor_Fragment' };

type BrandDetailsSection_Profile_Producer_Fragment = (
  { name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandDescription_Profile_Producer_Fragment': BrandDescription_Profile_Producer_Fragment;'BrandFounded_Profile_Producer_Fragment': BrandFounded_Profile_Producer_Fragment;'BrandTourism_Profile_Producer_Fragment': BrandTourism_Profile_Producer_Fragment;'BrandGallery_Profile_Producer_Fragment': BrandGallery_Profile_Producer_Fragment;'BrandVideos_Profile_Producer_Fragment': BrandVideos_Profile_Producer_Fragment } }
) & { ' $fragmentName'?: 'BrandDetailsSection_Profile_Producer_Fragment' };

type BrandDetailsSection_Profile_RegistrationProfile_Fragment = (
  { name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandDescription_Profile_RegistrationProfile_Fragment': BrandDescription_Profile_RegistrationProfile_Fragment;'BrandFounded_Profile_RegistrationProfile_Fragment': BrandFounded_Profile_RegistrationProfile_Fragment;'BrandAnnualProduction_ProfileFragment': BrandAnnualProduction_ProfileFragment;'BrandTourism_Profile_RegistrationProfile_Fragment': BrandTourism_Profile_RegistrationProfile_Fragment;'BrandGallery_Profile_RegistrationProfile_Fragment': BrandGallery_Profile_RegistrationProfile_Fragment;'BrandVideos_Profile_RegistrationProfile_Fragment': BrandVideos_Profile_RegistrationProfile_Fragment } }
) & { ' $fragmentName'?: 'BrandDetailsSection_Profile_RegistrationProfile_Fragment' };

export type BrandDetailsSection_ProfileFragment = BrandDetailsSection_Profile_Brand_Fragment | BrandDetailsSection_Profile_BrandProfile_Fragment | BrandDetailsSection_Profile_CompanyProfile_Fragment | BrandDetailsSection_Profile_Exhibitor_Fragment | BrandDetailsSection_Profile_Producer_Fragment | BrandDetailsSection_Profile_RegistrationProfile_Fragment;

export type BrandDetailsSection_RegisteredBrandFragment = { ' $fragmentRefs'?: { 'PresentedBrandsFragment': PresentedBrandsFragment } } & { ' $fragmentName'?: 'BrandDetailsSection_RegisteredBrandFragment' };

type BrandDistributors_Brand_Fragment = { seekingDistributionInCountries?: Array<string> | null, distributors?: { byCountry: Array<{ country?: string | null, distributors: Array<{ name?: string | null, url?: string | null }> }> } | null } & { ' $fragmentName'?: 'BrandDistributors_Brand_Fragment' };

type BrandDistributors_BrandProfile_Fragment = { seekingDistributionInCountries?: Array<string> | null, distributors?: { byCountry: Array<{ country?: string | null, distributors: Array<{ name?: string | null, url?: string | null }> }> } | null } & { ' $fragmentName'?: 'BrandDistributors_BrandProfile_Fragment' };

type BrandDistributors_CompanyProfile_Fragment = { seekingDistributionInCountries?: Array<string> | null, distributors?: { byCountry: Array<{ country?: string | null, distributors: Array<{ name?: string | null, url?: string | null }> }> } | null } & { ' $fragmentName'?: 'BrandDistributors_CompanyProfile_Fragment' };

type BrandDistributors_Exhibitor_Fragment = { seekingDistributionInCountries?: Array<string> | null, distributors?: { byCountry: Array<{ country?: string | null, distributors: Array<{ name?: string | null, url?: string | null }> }> } | null } & { ' $fragmentName'?: 'BrandDistributors_Exhibitor_Fragment' };

type BrandDistributors_Producer_Fragment = { seekingDistributionInCountries?: Array<string> | null, distributors?: { byCountry: Array<{ country?: string | null, distributors: Array<{ name?: string | null, url?: string | null }> }> } | null } & { ' $fragmentName'?: 'BrandDistributors_Producer_Fragment' };

type BrandDistributors_RegistrationProfile_Fragment = { seekingDistributionInCountries?: Array<string> | null, distributors?: { byCountry: Array<{ country?: string | null, distributors: Array<{ name?: string | null, url?: string | null }> }> } | null } & { ' $fragmentName'?: 'BrandDistributors_RegistrationProfile_Fragment' };

export type BrandDistributorsFragment = BrandDistributors_Brand_Fragment | BrandDistributors_BrandProfile_Fragment | BrandDistributors_CompanyProfile_Fragment | BrandDistributors_Exhibitor_Fragment | BrandDistributors_Producer_Fragment | BrandDistributors_RegistrationProfile_Fragment;

type BrandFounded_Profile_Brand_Fragment = { founded?: string | null } & { ' $fragmentName'?: 'BrandFounded_Profile_Brand_Fragment' };

type BrandFounded_Profile_BrandProfile_Fragment = { founded?: string | null } & { ' $fragmentName'?: 'BrandFounded_Profile_BrandProfile_Fragment' };

type BrandFounded_Profile_CompanyProfile_Fragment = { founded?: string | null } & { ' $fragmentName'?: 'BrandFounded_Profile_CompanyProfile_Fragment' };

type BrandFounded_Profile_Exhibitor_Fragment = { founded?: string | null } & { ' $fragmentName'?: 'BrandFounded_Profile_Exhibitor_Fragment' };

type BrandFounded_Profile_Producer_Fragment = { founded?: string | null } & { ' $fragmentName'?: 'BrandFounded_Profile_Producer_Fragment' };

type BrandFounded_Profile_RegistrationProfile_Fragment = { founded?: string | null } & { ' $fragmentName'?: 'BrandFounded_Profile_RegistrationProfile_Fragment' };

export type BrandFounded_ProfileFragment = BrandFounded_Profile_Brand_Fragment | BrandFounded_Profile_BrandProfile_Fragment | BrandFounded_Profile_CompanyProfile_Fragment | BrandFounded_Profile_Exhibitor_Fragment | BrandFounded_Profile_Producer_Fragment | BrandFounded_Profile_RegistrationProfile_Fragment;

type BrandGallery_Profile_Brand_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'BrandGallery_Profile_Brand_Fragment' };

type BrandGallery_Profile_BrandProfile_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'BrandGallery_Profile_BrandProfile_Fragment' };

type BrandGallery_Profile_CompanyProfile_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'BrandGallery_Profile_CompanyProfile_Fragment' };

type BrandGallery_Profile_Exhibitor_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'BrandGallery_Profile_Exhibitor_Fragment' };

type BrandGallery_Profile_Producer_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'BrandGallery_Profile_Producer_Fragment' };

type BrandGallery_Profile_RegistrationProfile_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'BrandGallery_Profile_RegistrationProfile_Fragment' };

export type BrandGallery_ProfileFragment = BrandGallery_Profile_Brand_Fragment | BrandGallery_Profile_BrandProfile_Fragment | BrandGallery_Profile_CompanyProfile_Fragment | BrandGallery_Profile_Exhibitor_Fragment | BrandGallery_Profile_Producer_Fragment | BrandGallery_Profile_RegistrationProfile_Fragment;

type BrandHeader_Brand_Fragment = { ' $fragmentRefs'?: { 'BrandName_Brand_Fragment': BrandName_Brand_Fragment;'BrandRegion_Brand_Fragment': BrandRegion_Brand_Fragment } } & { ' $fragmentName'?: 'BrandHeader_Brand_Fragment' };

type BrandHeader_BrandProfile_Fragment = { ' $fragmentRefs'?: { 'BrandName_BrandProfile_Fragment': BrandName_BrandProfile_Fragment;'BrandRegion_BrandProfile_Fragment': BrandRegion_BrandProfile_Fragment } } & { ' $fragmentName'?: 'BrandHeader_BrandProfile_Fragment' };

type BrandHeader_CompanyProfile_Fragment = { ' $fragmentRefs'?: { 'BrandName_CompanyProfile_Fragment': BrandName_CompanyProfile_Fragment;'BrandRegion_CompanyProfile_Fragment': BrandRegion_CompanyProfile_Fragment } } & { ' $fragmentName'?: 'BrandHeader_CompanyProfile_Fragment' };

type BrandHeader_Exhibitor_Fragment = { ' $fragmentRefs'?: { 'BrandName_Exhibitor_Fragment': BrandName_Exhibitor_Fragment;'BrandRegion_Exhibitor_Fragment': BrandRegion_Exhibitor_Fragment } } & { ' $fragmentName'?: 'BrandHeader_Exhibitor_Fragment' };

type BrandHeader_Producer_Fragment = { ' $fragmentRefs'?: { 'BrandName_Producer_Fragment': BrandName_Producer_Fragment;'BrandRegion_Producer_Fragment': BrandRegion_Producer_Fragment } } & { ' $fragmentName'?: 'BrandHeader_Producer_Fragment' };

type BrandHeader_RegistrationProfile_Fragment = { ' $fragmentRefs'?: { 'BrandName_RegistrationProfile_Fragment': BrandName_RegistrationProfile_Fragment;'BrandRegion_RegistrationProfile_Fragment': BrandRegion_RegistrationProfile_Fragment } } & { ' $fragmentName'?: 'BrandHeader_RegistrationProfile_Fragment' };

export type BrandHeaderFragment = BrandHeader_Brand_Fragment | BrandHeader_BrandProfile_Fragment | BrandHeader_CompanyProfile_Fragment | BrandHeader_Exhibitor_Fragment | BrandHeader_Producer_Fragment | BrandHeader_RegistrationProfile_Fragment;

export type RegisteredBrand_BrandLogoFragment = { profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null } & { ' $fragmentName'?: 'RegisteredBrand_BrandLogoFragment' };

type BrandLogo_Brand_Fragment = { name?: string | null, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'BrandLogo_Brand_Fragment' };

type BrandLogo_BrandProfile_Fragment = { name?: string | null, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'BrandLogo_BrandProfile_Fragment' };

type BrandLogo_CompanyProfile_Fragment = { name?: string | null, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'BrandLogo_CompanyProfile_Fragment' };

type BrandLogo_Exhibitor_Fragment = { name?: string | null, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'BrandLogo_Exhibitor_Fragment' };

type BrandLogo_Producer_Fragment = { name?: string | null, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'BrandLogo_Producer_Fragment' };

type BrandLogo_RegistrationProfile_Fragment = { name?: string | null, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'BrandLogo_RegistrationProfile_Fragment' };

export type BrandLogoFragment = BrandLogo_Brand_Fragment | BrandLogo_BrandProfile_Fragment | BrandLogo_CompanyProfile_Fragment | BrandLogo_Exhibitor_Fragment | BrandLogo_Producer_Fragment | BrandLogo_RegistrationProfile_Fragment;

type BrandLogoLarge_Brand_Fragment = { name?: string | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, height?: number | null, width?: number | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'BrandLogoLarge_Brand_Fragment' };

type BrandLogoLarge_BrandProfile_Fragment = { name?: string | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, height?: number | null, width?: number | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'BrandLogoLarge_BrandProfile_Fragment' };

type BrandLogoLarge_CompanyProfile_Fragment = { name?: string | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, height?: number | null, width?: number | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'BrandLogoLarge_CompanyProfile_Fragment' };

type BrandLogoLarge_Exhibitor_Fragment = { name?: string | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, height?: number | null, width?: number | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'BrandLogoLarge_Exhibitor_Fragment' };

type BrandLogoLarge_Producer_Fragment = { name?: string | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, height?: number | null, width?: number | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'BrandLogoLarge_Producer_Fragment' };

type BrandLogoLarge_RegistrationProfile_Fragment = { name?: string | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, height?: number | null, width?: number | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'BrandLogoLarge_RegistrationProfile_Fragment' };

export type BrandLogoLargeFragment = BrandLogoLarge_Brand_Fragment | BrandLogoLarge_BrandProfile_Fragment | BrandLogoLarge_CompanyProfile_Fragment | BrandLogoLarge_Exhibitor_Fragment | BrandLogoLarge_Producer_Fragment | BrandLogoLarge_RegistrationProfile_Fragment;

type BrandName_Brand_Fragment = { name?: string | null } & { ' $fragmentName'?: 'BrandName_Brand_Fragment' };

type BrandName_BrandProfile_Fragment = { name?: string | null } & { ' $fragmentName'?: 'BrandName_BrandProfile_Fragment' };

type BrandName_CompanyProfile_Fragment = { name?: string | null } & { ' $fragmentName'?: 'BrandName_CompanyProfile_Fragment' };

type BrandName_Exhibitor_Fragment = { name?: string | null } & { ' $fragmentName'?: 'BrandName_Exhibitor_Fragment' };

type BrandName_Producer_Fragment = { name?: string | null } & { ' $fragmentName'?: 'BrandName_Producer_Fragment' };

type BrandName_RegistrationProfile_Fragment = { name?: string | null } & { ' $fragmentName'?: 'BrandName_RegistrationProfile_Fragment' };

export type BrandNameFragment = BrandName_Brand_Fragment | BrandName_BrandProfile_Fragment | BrandName_CompanyProfile_Fragment | BrandName_Exhibitor_Fragment | BrandName_Producer_Fragment | BrandName_RegistrationProfile_Fragment;

type BrandRegion_Brand_Fragment = { stateProvince?: string | null, region?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'BrandRegion_Brand_Fragment' };

type BrandRegion_BrandProfile_Fragment = { stateProvince?: string | null, region?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'BrandRegion_BrandProfile_Fragment' };

type BrandRegion_CompanyProfile_Fragment = { stateProvince?: string | null, region?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'BrandRegion_CompanyProfile_Fragment' };

type BrandRegion_Exhibitor_Fragment = { stateProvince?: string | null, region?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'BrandRegion_Exhibitor_Fragment' };

type BrandRegion_Producer_Fragment = { stateProvince?: string | null, region?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'BrandRegion_Producer_Fragment' };

type BrandRegion_RegistrationProfile_Fragment = { stateProvince?: string | null, region?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'BrandRegion_RegistrationProfile_Fragment' };

export type BrandRegionFragment = BrandRegion_Brand_Fragment | BrandRegion_BrandProfile_Fragment | BrandRegion_CompanyProfile_Fragment | BrandRegion_Exhibitor_Fragment | BrandRegion_Producer_Fragment | BrandRegion_RegistrationProfile_Fragment;

export type RegisteredBrand_BrandRegionFragment = { profile?: { stateProvince?: string | null, region?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } | null } & { ' $fragmentName'?: 'RegisteredBrand_BrandRegionFragment' };

type BrandRegionSection_GroupedRegistration_Fragment = { profile?: { region?: string | null } | null } & { ' $fragmentName'?: 'BrandRegionSection_GroupedRegistration_Fragment' };

type BrandRegionSection_SingleRegistration_Fragment = { profile?: { region?: string | null } | null } & { ' $fragmentName'?: 'BrandRegionSection_SingleRegistration_Fragment' };

export type BrandRegionSectionFragment = BrandRegionSection_GroupedRegistration_Fragment | BrandRegionSection_SingleRegistration_Fragment;

export type RegisteredBrand_SeekingDistributionFragment = { isSeekingDistribution?: boolean | null } & { ' $fragmentName'?: 'RegisteredBrand_SeekingDistributionFragment' };

type BrandShopsSection_Brand_Fragment = { telephoneOrders?: string | null, onlineShopUrl?: string | null, telephoneOrdersUrl?: string | null, emailOrdersUrl?: string | null, onlineShops?: Array<{ name?: string | null, country?: string | null, url?: string | null, linkText?: string | null }> | null, physicalShops?: Array<{ name?: string | null, url?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, linkText?: string | null }> | null } & { ' $fragmentName'?: 'BrandShopsSection_Brand_Fragment' };

type BrandShopsSection_BrandProfile_Fragment = { telephoneOrders?: string | null, onlineShopUrl?: string | null, telephoneOrdersUrl?: string | null, emailOrdersUrl?: string | null, onlineShops?: Array<{ name?: string | null, country?: string | null, url?: string | null, linkText?: string | null }> | null, physicalShops?: Array<{ name?: string | null, url?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, linkText?: string | null }> | null } & { ' $fragmentName'?: 'BrandShopsSection_BrandProfile_Fragment' };

type BrandShopsSection_CompanyProfile_Fragment = { telephoneOrders?: string | null, onlineShopUrl?: string | null, telephoneOrdersUrl?: string | null, emailOrdersUrl?: string | null, onlineShops?: Array<{ name?: string | null, country?: string | null, url?: string | null, linkText?: string | null }> | null, physicalShops?: Array<{ name?: string | null, url?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, linkText?: string | null }> | null } & { ' $fragmentName'?: 'BrandShopsSection_CompanyProfile_Fragment' };

type BrandShopsSection_Exhibitor_Fragment = { telephoneOrders?: string | null, onlineShopUrl?: string | null, telephoneOrdersUrl?: string | null, emailOrdersUrl?: string | null, onlineShops?: Array<{ name?: string | null, country?: string | null, url?: string | null, linkText?: string | null }> | null, physicalShops?: Array<{ name?: string | null, url?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, linkText?: string | null }> | null } & { ' $fragmentName'?: 'BrandShopsSection_Exhibitor_Fragment' };

type BrandShopsSection_Producer_Fragment = { telephoneOrders?: string | null, onlineShopUrl?: string | null, telephoneOrdersUrl?: string | null, emailOrdersUrl?: string | null, onlineShops?: Array<{ name?: string | null, country?: string | null, url?: string | null, linkText?: string | null }> | null, physicalShops?: Array<{ name?: string | null, url?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, linkText?: string | null }> | null } & { ' $fragmentName'?: 'BrandShopsSection_Producer_Fragment' };

type BrandShopsSection_RegistrationProfile_Fragment = { telephoneOrders?: string | null, onlineShopUrl?: string | null, telephoneOrdersUrl?: string | null, emailOrdersUrl?: string | null, onlineShops?: Array<{ name?: string | null, country?: string | null, url?: string | null, linkText?: string | null }> | null, physicalShops?: Array<{ name?: string | null, url?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, linkText?: string | null }> | null } & { ' $fragmentName'?: 'BrandShopsSection_RegistrationProfile_Fragment' };

export type BrandShopsSectionFragment = BrandShopsSection_Brand_Fragment | BrandShopsSection_BrandProfile_Fragment | BrandShopsSection_CompanyProfile_Fragment | BrandShopsSection_Exhibitor_Fragment | BrandShopsSection_Producer_Fragment | BrandShopsSection_RegistrationProfile_Fragment;

type BrandSocialMedia_Profile_Brand_Fragment = { facebookUrl?: string | null, instagramUrl?: string | null, twitterUrl?: string | null, youtubeUrl?: string | null } & { ' $fragmentName'?: 'BrandSocialMedia_Profile_Brand_Fragment' };

type BrandSocialMedia_Profile_BrandProfile_Fragment = { facebookUrl?: string | null, instagramUrl?: string | null, twitterUrl?: string | null, youtubeUrl?: string | null } & { ' $fragmentName'?: 'BrandSocialMedia_Profile_BrandProfile_Fragment' };

type BrandSocialMedia_Profile_CompanyProfile_Fragment = { facebookUrl?: string | null, instagramUrl?: string | null, twitterUrl?: string | null, youtubeUrl?: string | null } & { ' $fragmentName'?: 'BrandSocialMedia_Profile_CompanyProfile_Fragment' };

type BrandSocialMedia_Profile_Exhibitor_Fragment = { facebookUrl?: string | null, instagramUrl?: string | null, twitterUrl?: string | null, youtubeUrl?: string | null } & { ' $fragmentName'?: 'BrandSocialMedia_Profile_Exhibitor_Fragment' };

type BrandSocialMedia_Profile_Producer_Fragment = { facebookUrl?: string | null, instagramUrl?: string | null, twitterUrl?: string | null, youtubeUrl?: string | null } & { ' $fragmentName'?: 'BrandSocialMedia_Profile_Producer_Fragment' };

type BrandSocialMedia_Profile_RegistrationProfile_Fragment = { facebookUrl?: string | null, instagramUrl?: string | null, twitterUrl?: string | null, youtubeUrl?: string | null } & { ' $fragmentName'?: 'BrandSocialMedia_Profile_RegistrationProfile_Fragment' };

export type BrandSocialMedia_ProfileFragment = BrandSocialMedia_Profile_Brand_Fragment | BrandSocialMedia_Profile_BrandProfile_Fragment | BrandSocialMedia_Profile_CompanyProfile_Fragment | BrandSocialMedia_Profile_Exhibitor_Fragment | BrandSocialMedia_Profile_Producer_Fragment | BrandSocialMedia_Profile_RegistrationProfile_Fragment;

type BrandTourism_Profile_Brand_Fragment = { wineExperienceOfferings?: Array<string> | null, hospitalityOfferings?: Array<string> | null, lifestyleOfferings?: Array<string> | null, outdoorExperienceOfferings?: Array<string> | null, languagesSpoken?: Array<string> | null, bookingUrl?: string | null, openingHours?: Array<{ dayOfWeek: string, openingTime?: string | null, closingTime?: string | null }> | null } & { ' $fragmentName'?: 'BrandTourism_Profile_Brand_Fragment' };

type BrandTourism_Profile_BrandProfile_Fragment = { wineExperienceOfferings?: Array<string> | null, hospitalityOfferings?: Array<string> | null, lifestyleOfferings?: Array<string> | null, outdoorExperienceOfferings?: Array<string> | null, languagesSpoken?: Array<string> | null, bookingUrl?: string | null, openingHours?: Array<{ dayOfWeek: string, openingTime?: string | null, closingTime?: string | null }> | null } & { ' $fragmentName'?: 'BrandTourism_Profile_BrandProfile_Fragment' };

type BrandTourism_Profile_CompanyProfile_Fragment = { wineExperienceOfferings?: Array<string> | null, hospitalityOfferings?: Array<string> | null, lifestyleOfferings?: Array<string> | null, outdoorExperienceOfferings?: Array<string> | null, languagesSpoken?: Array<string> | null, bookingUrl?: string | null, openingHours?: Array<{ dayOfWeek: string, openingTime?: string | null, closingTime?: string | null }> | null } & { ' $fragmentName'?: 'BrandTourism_Profile_CompanyProfile_Fragment' };

type BrandTourism_Profile_Exhibitor_Fragment = { wineExperienceOfferings?: Array<string> | null, hospitalityOfferings?: Array<string> | null, lifestyleOfferings?: Array<string> | null, outdoorExperienceOfferings?: Array<string> | null, languagesSpoken?: Array<string> | null, bookingUrl?: string | null, openingHours?: Array<{ dayOfWeek: string, openingTime?: string | null, closingTime?: string | null }> | null } & { ' $fragmentName'?: 'BrandTourism_Profile_Exhibitor_Fragment' };

type BrandTourism_Profile_Producer_Fragment = { wineExperienceOfferings?: Array<string> | null, hospitalityOfferings?: Array<string> | null, lifestyleOfferings?: Array<string> | null, outdoorExperienceOfferings?: Array<string> | null, languagesSpoken?: Array<string> | null, bookingUrl?: string | null, openingHours?: Array<{ dayOfWeek: string, openingTime?: string | null, closingTime?: string | null }> | null } & { ' $fragmentName'?: 'BrandTourism_Profile_Producer_Fragment' };

type BrandTourism_Profile_RegistrationProfile_Fragment = { wineExperienceOfferings?: Array<string> | null, hospitalityOfferings?: Array<string> | null, lifestyleOfferings?: Array<string> | null, outdoorExperienceOfferings?: Array<string> | null, languagesSpoken?: Array<string> | null, bookingUrl?: string | null, openingHours?: Array<{ dayOfWeek: string, openingTime?: string | null, closingTime?: string | null }> | null } & { ' $fragmentName'?: 'BrandTourism_Profile_RegistrationProfile_Fragment' };

export type BrandTourism_ProfileFragment = BrandTourism_Profile_Brand_Fragment | BrandTourism_Profile_BrandProfile_Fragment | BrandTourism_Profile_CompanyProfile_Fragment | BrandTourism_Profile_Exhibitor_Fragment | BrandTourism_Profile_Producer_Fragment | BrandTourism_Profile_RegistrationProfile_Fragment;

type BrandVideos_Profile_Brand_Fragment = { videos?: Array<(
    { type?: VideoType | null, videoId?: string | null, title?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  )> | null } & { ' $fragmentName'?: 'BrandVideos_Profile_Brand_Fragment' };

type BrandVideos_Profile_BrandProfile_Fragment = { videos?: Array<(
    { type?: VideoType | null, videoId?: string | null, title?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  )> | null } & { ' $fragmentName'?: 'BrandVideos_Profile_BrandProfile_Fragment' };

type BrandVideos_Profile_CompanyProfile_Fragment = { videos?: Array<(
    { type?: VideoType | null, videoId?: string | null, title?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  )> | null } & { ' $fragmentName'?: 'BrandVideos_Profile_CompanyProfile_Fragment' };

type BrandVideos_Profile_Exhibitor_Fragment = { videos?: Array<(
    { type?: VideoType | null, videoId?: string | null, title?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  )> | null } & { ' $fragmentName'?: 'BrandVideos_Profile_Exhibitor_Fragment' };

type BrandVideos_Profile_Producer_Fragment = { videos?: Array<(
    { type?: VideoType | null, videoId?: string | null, title?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  )> | null } & { ' $fragmentName'?: 'BrandVideos_Profile_Producer_Fragment' };

type BrandVideos_Profile_RegistrationProfile_Fragment = { videos?: Array<(
    { type?: VideoType | null, videoId?: string | null, title?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  )> | null } & { ' $fragmentName'?: 'BrandVideos_Profile_RegistrationProfile_Fragment' };

export type BrandVideos_ProfileFragment = BrandVideos_Profile_Brand_Fragment | BrandVideos_Profile_BrandProfile_Fragment | BrandVideos_Profile_CompanyProfile_Fragment | BrandVideos_Profile_Exhibitor_Fragment | BrandVideos_Profile_Producer_Fragment | BrandVideos_Profile_RegistrationProfile_Fragment;

type BrandViticulturist_GroupedRegistration_Fragment = { __typename: 'GroupedRegistration' } & { ' $fragmentName'?: 'BrandViticulturist_GroupedRegistration_Fragment' };

type BrandViticulturist_SingleRegistration_Fragment = { __typename: 'SingleRegistration', viticulturistNames?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, overviewOfViticulturists?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, imageOfViticulturists?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue', value?: { publicId?: string | null } | null } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null } & { ' $fragmentName'?: 'BrandViticulturist_SingleRegistration_Fragment' };

export type BrandViticulturistFragment = BrandViticulturist_GroupedRegistration_Fragment | BrandViticulturist_SingleRegistration_Fragment;

type BrandWinemaker_GroupedRegistration_Fragment = { __typename: 'GroupedRegistration', profile?: { winemakerName?: string | null } | null } & { ' $fragmentName'?: 'BrandWinemaker_GroupedRegistration_Fragment' };

type BrandWinemaker_SingleRegistration_Fragment = { __typename: 'SingleRegistration', overviewOfWinemakers?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, imageOfWinemakers?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue', value?: { publicId?: string | null } | null } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, profile?: { winemakerName?: string | null } | null } & { ' $fragmentName'?: 'BrandWinemaker_SingleRegistration_Fragment' };

export type BrandWinemakerFragment = BrandWinemaker_GroupedRegistration_Fragment | BrandWinemaker_SingleRegistration_Fragment;

type FeaturedBrand_Brand_Fragment = (
  { name?: string | null, region?: string | null, countryName?: string | null, mainImage?: { fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'BrandLogo_Brand_Fragment': BrandLogo_Brand_Fragment } }
) & { ' $fragmentName'?: 'FeaturedBrand_Brand_Fragment' };

type FeaturedBrand_BrandProfile_Fragment = (
  { name?: string | null, region?: string | null, countryName?: string | null, mainImage?: { fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'BrandLogo_BrandProfile_Fragment': BrandLogo_BrandProfile_Fragment } }
) & { ' $fragmentName'?: 'FeaturedBrand_BrandProfile_Fragment' };

type FeaturedBrand_CompanyProfile_Fragment = (
  { name?: string | null, region?: string | null, countryName?: string | null, mainImage?: { fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'BrandLogo_CompanyProfile_Fragment': BrandLogo_CompanyProfile_Fragment } }
) & { ' $fragmentName'?: 'FeaturedBrand_CompanyProfile_Fragment' };

type FeaturedBrand_Exhibitor_Fragment = (
  { name?: string | null, region?: string | null, countryName?: string | null, mainImage?: { fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'BrandLogo_Exhibitor_Fragment': BrandLogo_Exhibitor_Fragment } }
) & { ' $fragmentName'?: 'FeaturedBrand_Exhibitor_Fragment' };

type FeaturedBrand_Producer_Fragment = (
  { name?: string | null, region?: string | null, countryName?: string | null, mainImage?: { fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'BrandLogo_Producer_Fragment': BrandLogo_Producer_Fragment } }
) & { ' $fragmentName'?: 'FeaturedBrand_Producer_Fragment' };

type FeaturedBrand_RegistrationProfile_Fragment = (
  { name?: string | null, region?: string | null, countryName?: string | null, mainImage?: { fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'BrandLogo_RegistrationProfile_Fragment': BrandLogo_RegistrationProfile_Fragment } }
) & { ' $fragmentName'?: 'FeaturedBrand_RegistrationProfile_Fragment' };

export type FeaturedBrandFragment = FeaturedBrand_Brand_Fragment | FeaturedBrand_BrandProfile_Fragment | FeaturedBrand_CompanyProfile_Fragment | FeaturedBrand_Exhibitor_Fragment | FeaturedBrand_Producer_Fragment | FeaturedBrand_RegistrationProfile_Fragment;

export type RegisteredBrand_PresentedBrandFragment = (
  { brandId: string, companyId: string, producerId: string, profile?: { distributorsCount?: { totalCount?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'ProducerCard_RegisteredBrandFragment': ProducerCard_RegisteredBrandFragment;'DistributionContactsFragment': DistributionContactsFragment } }
) & { ' $fragmentName'?: 'RegisteredBrand_PresentedBrandFragment' };

export type PresentedBrandsFragment = (
  { companyId: string, brandId: string }
  & { ' $fragmentRefs'?: { 'DistributionContactsFragment': DistributionContactsFragment;'RegisteredBrand_PresentedBrandFragment': RegisteredBrand_PresentedBrandFragment } }
) & { ' $fragmentName'?: 'PresentedBrandsFragment' };

type BrandCarousel_Brand_Fragment = { ' $fragmentRefs'?: { 'FeaturedBrand_Brand_Fragment': FeaturedBrand_Brand_Fragment } } & { ' $fragmentName'?: 'BrandCarousel_Brand_Fragment' };

type BrandCarousel_BrandProfile_Fragment = { ' $fragmentRefs'?: { 'FeaturedBrand_BrandProfile_Fragment': FeaturedBrand_BrandProfile_Fragment } } & { ' $fragmentName'?: 'BrandCarousel_BrandProfile_Fragment' };

type BrandCarousel_CompanyProfile_Fragment = { ' $fragmentRefs'?: { 'FeaturedBrand_CompanyProfile_Fragment': FeaturedBrand_CompanyProfile_Fragment } } & { ' $fragmentName'?: 'BrandCarousel_CompanyProfile_Fragment' };

type BrandCarousel_Exhibitor_Fragment = { ' $fragmentRefs'?: { 'FeaturedBrand_Exhibitor_Fragment': FeaturedBrand_Exhibitor_Fragment } } & { ' $fragmentName'?: 'BrandCarousel_Exhibitor_Fragment' };

type BrandCarousel_Producer_Fragment = { ' $fragmentRefs'?: { 'FeaturedBrand_Producer_Fragment': FeaturedBrand_Producer_Fragment } } & { ' $fragmentName'?: 'BrandCarousel_Producer_Fragment' };

type BrandCarousel_RegistrationProfile_Fragment = { ' $fragmentRefs'?: { 'FeaturedBrand_RegistrationProfile_Fragment': FeaturedBrand_RegistrationProfile_Fragment } } & { ' $fragmentName'?: 'BrandCarousel_RegistrationProfile_Fragment' };

export type BrandCarouselFragment = BrandCarousel_Brand_Fragment | BrandCarousel_BrandProfile_Fragment | BrandCarousel_CompanyProfile_Fragment | BrandCarousel_Exhibitor_Fragment | BrandCarousel_Producer_Fragment | BrandCarousel_RegistrationProfile_Fragment;

type CollectionLayoutProvider_Event_Fragment = { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }>, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'CollectionLayoutProvider_Event_Fragment' };

type CollectionLayoutProvider_EventGroup_Fragment = { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }>, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'CollectionLayoutProvider_EventGroup_Fragment' };

type CollectionLayoutProvider_Group_Fragment = { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }>, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'CollectionLayoutProvider_Group_Fragment' };

type CollectionLayoutProvider_ProductList_Fragment = { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }>, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'CollectionLayoutProvider_ProductList_Fragment' };

type CollectionLayoutProvider_ShareList_Fragment = { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }>, logo?: { publicId?: string | null } | null } & { ' $fragmentName'?: 'CollectionLayoutProvider_ShareList_Fragment' };

export type CollectionLayoutProviderFragment = CollectionLayoutProvider_Event_Fragment | CollectionLayoutProvider_EventGroup_Fragment | CollectionLayoutProvider_Group_Fragment | CollectionLayoutProvider_ProductList_Fragment | CollectionLayoutProvider_ShareList_Fragment;

export type EventBannerFragment = (
  { name?: string | null }
  & { ' $fragmentRefs'?: { 'EventBannerImageFragment': EventBannerImageFragment } }
) & { ' $fragmentName'?: 'EventBannerFragment' };

export type EventBannerImageFragment = { name?: string | null, mainImage?: { fluid?: { src?: string | null, srcSet?: string | null, sizes?: string | null, base64?: string | null, aspectRatio?: number | null } | null } | null } & { ' $fragmentName'?: 'EventBannerImageFragment' };

export type EventHeaderFragment = { name?: string | null, subtitle?: string | null, htmlDescription?: string | null } & { ' $fragmentName'?: 'EventHeaderFragment' };

export type EventProductPage_RegisteredProductFragment = (
  { exhibitor: { exhibitorId: string, profile?: { ' $fragmentRefs'?: { 'BrandBanner_RegistrationProfileFragment': BrandBanner_RegistrationProfileFragment } } | null }, producer?: (
    { producerId: string, profile?: (
      { name?: string | null, mainImage?: { publicId?: string | null } | null }
      & { ' $fragmentRefs'?: { 'BrandDetailsSection_Profile_BrandProfile_Fragment': BrandDetailsSection_Profile_BrandProfile_Fragment;'BrandAddressSection_Profile_BrandProfile_Fragment': BrandAddressSection_Profile_BrandProfile_Fragment } }
    ) | null, products: { nodes: Array<{ ' $fragmentRefs'?: { 'RelatedProductsSectionFragment': RelatedProductsSectionFragment } }> } }
    & { ' $fragmentRefs'?: { 'BrandDetailsSection_RegisteredBrandFragment': BrandDetailsSection_RegisteredBrandFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'ProductSections_RegisteredProductFragment': ProductSections_RegisteredProductFragment;'ProductActions_RegisteredProductFragment': ProductActions_RegisteredProductFragment;'EventProductPageHeaderRegisteredProductFragment': EventProductPageHeaderRegisteredProductFragment } }
) & { ' $fragmentName'?: 'EventProductPage_RegisteredProductFragment' };

export type EventProductPageHeaderRegisteredProductFragment = (
  { registration: (
    { profile?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductStandFragment': ProductStandFragment } }
  ), product: (
    { productId: string, producer?: { name?: string | null } | null, bottleImage?: { publicId?: string | null, sourceUrl?: string | null } | null, labelImage?: { publicId?: string | null, sourceUrl?: string | null } | null, backLabelImage?: { publicId?: string | null, sourceUrl?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductHeaderProductName_Beer_Fragment': ProductHeaderProductName_Beer_Fragment;'ProductHeaderProducerName_Beer_Fragment': ProductHeaderProducerName_Beer_Fragment;'EventProductPageHeader_Beer_Fragment': EventProductPageHeader_Beer_Fragment;'ProductImageLarge_Beer_Fragment': ProductImageLarge_Beer_Fragment } }
  ) | (
    { productId: string, producer?: { name?: string | null } | null, bottleImage?: { publicId?: string | null, sourceUrl?: string | null } | null, labelImage?: { publicId?: string | null, sourceUrl?: string | null } | null, backLabelImage?: { publicId?: string | null, sourceUrl?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductHeaderProductName_Cider_Fragment': ProductHeaderProductName_Cider_Fragment;'ProductHeaderProducerName_Cider_Fragment': ProductHeaderProducerName_Cider_Fragment;'EventProductPageHeader_Cider_Fragment': EventProductPageHeader_Cider_Fragment;'ProductImageLarge_Cider_Fragment': ProductImageLarge_Cider_Fragment } }
  ) | (
    { productId: string, producer?: { name?: string | null } | null, bottleImage?: { publicId?: string | null, sourceUrl?: string | null } | null, labelImage?: { publicId?: string | null, sourceUrl?: string | null } | null, backLabelImage?: { publicId?: string | null, sourceUrl?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductHeaderProductName_Spirit_Fragment': ProductHeaderProductName_Spirit_Fragment;'ProductHeaderProducerName_Spirit_Fragment': ProductHeaderProducerName_Spirit_Fragment;'EventProductPageHeader_Spirit_Fragment': EventProductPageHeader_Spirit_Fragment;'ProductImageLarge_Spirit_Fragment': ProductImageLarge_Spirit_Fragment } }
  ) | (
    { productId: string, producer?: { name?: string | null } | null, bottleImage?: { publicId?: string | null, sourceUrl?: string | null } | null, labelImage?: { publicId?: string | null, sourceUrl?: string | null } | null, backLabelImage?: { publicId?: string | null, sourceUrl?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductHeaderProductName_Wine_Fragment': ProductHeaderProductName_Wine_Fragment;'ProductHeaderProducerName_Wine_Fragment': ProductHeaderProducerName_Wine_Fragment;'EventProductPageHeader_Wine_Fragment': EventProductPageHeader_Wine_Fragment;'ProductImageLarge_Wine_Fragment': ProductImageLarge_Wine_Fragment } }
  ) }
  & { ' $fragmentRefs'?: { 'ProductLabel_RegisteredProductFragment': ProductLabel_RegisteredProductFragment;'ProductHeaderDetailsFragment': ProductHeaderDetailsFragment;'ProductHeaderDetails_RegisteredProductFragment': ProductHeaderDetails_RegisteredProductFragment;'HasDifferentExhibitorFragment': HasDifferentExhibitorFragment } }
) & { ' $fragmentName'?: 'EventProductPageHeaderRegisteredProductFragment' };

type EventProductPageHeader_Beer_Fragment = { productId: string, producer?: { ' $fragmentRefs'?: { 'UseLink_ProducerFragment': UseLink_ProducerFragment } } | null } & { ' $fragmentName'?: 'EventProductPageHeader_Beer_Fragment' };

type EventProductPageHeader_Cider_Fragment = { productId: string, producer?: { ' $fragmentRefs'?: { 'UseLink_ProducerFragment': UseLink_ProducerFragment } } | null } & { ' $fragmentName'?: 'EventProductPageHeader_Cider_Fragment' };

type EventProductPageHeader_Spirit_Fragment = { productId: string, producer?: { ' $fragmentRefs'?: { 'UseLink_ProducerFragment': UseLink_ProducerFragment } } | null } & { ' $fragmentName'?: 'EventProductPageHeader_Spirit_Fragment' };

type EventProductPageHeader_Wine_Fragment = { productId: string, producer?: { ' $fragmentRefs'?: { 'UseLink_ProducerFragment': UseLink_ProducerFragment } } | null } & { ' $fragmentName'?: 'EventProductPageHeader_Wine_Fragment' };

export type EventProductPageHeaderFragment = EventProductPageHeader_Beer_Fragment | EventProductPageHeader_Cider_Fragment | EventProductPageHeader_Spirit_Fragment | EventProductPageHeader_Wine_Fragment;

export type ExhibitorActions_SingleRegistrationFragment = { ' $fragmentRefs'?: { 'RegistrationInfoSheetButtonFragment': RegistrationInfoSheetButtonFragment } } & { ' $fragmentName'?: 'ExhibitorActions_SingleRegistrationFragment' };

export type RegistrationInfoSheetButtonFragment = { registrationInfoSheet: { url: string } } & { ' $fragmentName'?: 'RegistrationInfoSheetButtonFragment' };

type ExhibitorHeader_Brand_Fragment = { ' $fragmentRefs'?: { 'BrandHeader_Brand_Fragment': BrandHeader_Brand_Fragment } } & { ' $fragmentName'?: 'ExhibitorHeader_Brand_Fragment' };

type ExhibitorHeader_BrandProfile_Fragment = { ' $fragmentRefs'?: { 'BrandHeader_BrandProfile_Fragment': BrandHeader_BrandProfile_Fragment } } & { ' $fragmentName'?: 'ExhibitorHeader_BrandProfile_Fragment' };

type ExhibitorHeader_CompanyProfile_Fragment = { ' $fragmentRefs'?: { 'BrandHeader_CompanyProfile_Fragment': BrandHeader_CompanyProfile_Fragment } } & { ' $fragmentName'?: 'ExhibitorHeader_CompanyProfile_Fragment' };

type ExhibitorHeader_Exhibitor_Fragment = { ' $fragmentRefs'?: { 'BrandHeader_Exhibitor_Fragment': BrandHeader_Exhibitor_Fragment } } & { ' $fragmentName'?: 'ExhibitorHeader_Exhibitor_Fragment' };

type ExhibitorHeader_Producer_Fragment = { ' $fragmentRefs'?: { 'BrandHeader_Producer_Fragment': BrandHeader_Producer_Fragment } } & { ' $fragmentName'?: 'ExhibitorHeader_Producer_Fragment' };

type ExhibitorHeader_RegistrationProfile_Fragment = { ' $fragmentRefs'?: { 'BrandHeader_RegistrationProfile_Fragment': BrandHeader_RegistrationProfile_Fragment } } & { ' $fragmentName'?: 'ExhibitorHeader_RegistrationProfile_Fragment' };

export type ExhibitorHeaderFragment = ExhibitorHeader_Brand_Fragment | ExhibitorHeader_BrandProfile_Fragment | ExhibitorHeader_CompanyProfile_Fragment | ExhibitorHeader_Exhibitor_Fragment | ExhibitorHeader_Producer_Fragment | ExhibitorHeader_RegistrationProfile_Fragment;

export type ExhibitorStand_SingleRegistrationFragment = { stand?: { name: string, standTypeWithNumber?: string | null, roomName?: string | null } | null } & { ' $fragmentName'?: 'ExhibitorStand_SingleRegistrationFragment' };

export type RegistrationContactsFragment = { exhibitorContacts?: Array<{ ' $fragmentRefs'?: { 'ContactFragment': ContactFragment } }> | null } & { ' $fragmentName'?: 'RegistrationContactsFragment' };

type ExhibitorHeaderRow_Brand_Fragment = (
  { __typename: 'Brand', name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandLogoLarge_Brand_Fragment': BrandLogoLarge_Brand_Fragment;'ExhibitorHeader_Brand_Fragment': ExhibitorHeader_Brand_Fragment } }
) & { ' $fragmentName'?: 'ExhibitorHeaderRow_Brand_Fragment' };

type ExhibitorHeaderRow_BrandProfile_Fragment = (
  { __typename: 'BrandProfile', name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandLogoLarge_BrandProfile_Fragment': BrandLogoLarge_BrandProfile_Fragment;'ExhibitorHeader_BrandProfile_Fragment': ExhibitorHeader_BrandProfile_Fragment } }
) & { ' $fragmentName'?: 'ExhibitorHeaderRow_BrandProfile_Fragment' };

type ExhibitorHeaderRow_CompanyProfile_Fragment = (
  { __typename: 'CompanyProfile', companyId: string, name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandLogoLarge_CompanyProfile_Fragment': BrandLogoLarge_CompanyProfile_Fragment;'ExhibitorHeader_CompanyProfile_Fragment': ExhibitorHeader_CompanyProfile_Fragment } }
) & { ' $fragmentName'?: 'ExhibitorHeaderRow_CompanyProfile_Fragment' };

type ExhibitorHeaderRow_Exhibitor_Fragment = (
  { __typename: 'Exhibitor', name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandLogoLarge_Exhibitor_Fragment': BrandLogoLarge_Exhibitor_Fragment;'ExhibitorHeader_Exhibitor_Fragment': ExhibitorHeader_Exhibitor_Fragment;'UseLink_ExhibitorFragment': UseLink_ExhibitorFragment } }
) & { ' $fragmentName'?: 'ExhibitorHeaderRow_Exhibitor_Fragment' };

type ExhibitorHeaderRow_Producer_Fragment = (
  { __typename: 'Producer', name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandLogoLarge_Producer_Fragment': BrandLogoLarge_Producer_Fragment;'ExhibitorHeader_Producer_Fragment': ExhibitorHeader_Producer_Fragment } }
) & { ' $fragmentName'?: 'ExhibitorHeaderRow_Producer_Fragment' };

type ExhibitorHeaderRow_RegistrationProfile_Fragment = (
  { __typename: 'RegistrationProfile', name?: string | null }
  & { ' $fragmentRefs'?: { 'BrandLogoLarge_RegistrationProfile_Fragment': BrandLogoLarge_RegistrationProfile_Fragment;'ExhibitorHeader_RegistrationProfile_Fragment': ExhibitorHeader_RegistrationProfile_Fragment } }
) & { ' $fragmentName'?: 'ExhibitorHeaderRow_RegistrationProfile_Fragment' };

export type ExhibitorHeaderRowFragment = ExhibitorHeaderRow_Brand_Fragment | ExhibitorHeaderRow_BrandProfile_Fragment | ExhibitorHeaderRow_CompanyProfile_Fragment | ExhibitorHeaderRow_Exhibitor_Fragment | ExhibitorHeaderRow_Producer_Fragment | ExhibitorHeaderRow_RegistrationProfile_Fragment;

type ExhibitorPage_GroupedRegistration_Fragment = { __typename: 'GroupedRegistration', registrationId: string, companyId: string, profile?: { ' $fragmentRefs'?: { 'BrandBanner_RegistrationProfile_Fragment': BrandBanner_RegistrationProfile_Fragment;'ExhibitorHeaderRow_RegistrationProfile_Fragment': ExhibitorHeaderRow_RegistrationProfile_Fragment;'BrandAddressSection_Profile_RegistrationProfile_Fragment': BrandAddressSection_Profile_RegistrationProfile_Fragment;'BrandShopsSection_RegistrationProfile_Fragment': BrandShopsSection_RegistrationProfile_Fragment } } | null } & { ' $fragmentName'?: 'ExhibitorPage_GroupedRegistration_Fragment' };

type ExhibitorPage_SingleRegistration_Fragment = (
  { __typename: 'SingleRegistration', registrationId: string, companyId: string, registeredProducts: { nodes: Array<(
      { productId: string, companyId: string, product: (
        { productId: string, slug: string }
        & { ' $fragmentRefs'?: { 'ProductCard_Beer_Fragment': ProductCard_Beer_Fragment;'UseLink_Product_Beer_Fragment': UseLink_Product_Beer_Fragment } }
      ) | (
        { productId: string, slug: string }
        & { ' $fragmentRefs'?: { 'ProductCard_Cider_Fragment': ProductCard_Cider_Fragment;'UseLink_Product_Cider_Fragment': UseLink_Product_Cider_Fragment } }
      ) | (
        { productId: string, slug: string }
        & { ' $fragmentRefs'?: { 'ProductCard_Spirit_Fragment': ProductCard_Spirit_Fragment;'UseLink_Product_Spirit_Fragment': UseLink_Product_Spirit_Fragment } }
      ) | (
        { productId: string, slug: string }
        & { ' $fragmentRefs'?: { 'ProductCard_Wine_Fragment': ProductCard_Wine_Fragment;'UseLink_Product_Wine_Fragment': UseLink_Product_Wine_Fragment } }
      ) }
      & { ' $fragmentRefs'?: { 'ProductCard_RegisteredProductFragment': ProductCard_RegisteredProductFragment;'ProductListRowFragment': ProductListRowFragment } }
    )> }, profile?: { ' $fragmentRefs'?: { 'BrandBanner_RegistrationProfile_Fragment': BrandBanner_RegistrationProfile_Fragment;'ExhibitorHeaderRow_RegistrationProfile_Fragment': ExhibitorHeaderRow_RegistrationProfile_Fragment;'BrandAddressSection_Profile_RegistrationProfile_Fragment': BrandAddressSection_Profile_RegistrationProfile_Fragment;'BrandShopsSection_RegistrationProfile_Fragment': BrandShopsSection_RegistrationProfile_Fragment } } | null }
  & { ' $fragmentRefs'?: { 'ExhibitorSectionsFragment': ExhibitorSectionsFragment;'ExhibitorActions_SingleRegistrationFragment': ExhibitorActions_SingleRegistrationFragment;'ExhibitorStand_SingleRegistrationFragment': ExhibitorStand_SingleRegistrationFragment } }
) & { ' $fragmentName'?: 'ExhibitorPage_SingleRegistration_Fragment' };

export type ExhibitorPageFragment = ExhibitorPage_GroupedRegistration_Fragment | ExhibitorPage_SingleRegistration_Fragment;

export type ExhibitorSectionsFragment = (
  { __typename: 'SingleRegistration', registeredBrands: { nodes: Array<(
      { distributionContacts?: Array<{ ' $fragmentRefs'?: { 'ContactFragment': ContactFragment } }> | null }
      & { ' $fragmentRefs'?: { 'BrandDetailsSection_RegisteredBrandFragment': BrandDetailsSection_RegisteredBrandFragment } }
    )> }, profile?: { ' $fragmentRefs'?: { 'BrandDistributors_RegistrationProfile_Fragment': BrandDistributors_RegistrationProfile_Fragment } } | null }
  & { ' $fragmentRefs'?: { 'BrandDetailsSection_SingleRegistration_Fragment': BrandDetailsSection_SingleRegistration_Fragment;'RepresentativesFragment': RepresentativesFragment } }
) & { ' $fragmentName'?: 'ExhibitorSectionsFragment' };

export type RepresentativesFragment = { representatives?: Array<(
    { uid: string, representativeId?: string | null }
    & { ' $fragmentRefs'?: { 'UserProfileCardHorizontalFragment': UserProfileCardHorizontalFragment } }
  )> | null } & { ' $fragmentName'?: 'RepresentativesFragment' };

export type ExhibitorCard_RegistrationFragment = (
  { registrationId: string, exhibitorId: string, profile?: (
    { name?: string | null, offeringTypes?: Array<string> | null }
    & { ' $fragmentRefs'?: { 'BrandLogo_RegistrationProfile_Fragment': BrandLogo_RegistrationProfile_Fragment;'BrandRegion_RegistrationProfile_Fragment': BrandRegion_RegistrationProfile_Fragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'ExhibitorStand_SingleRegistrationFragment': ExhibitorStand_SingleRegistrationFragment } }
) & { ' $fragmentName'?: 'ExhibitorCard_RegistrationFragment' };

export type ExhibitorCard_RegisteredBrandFragment = { ' $fragmentRefs'?: { 'RegisteredBrand_SeekingDistributionFragment': RegisteredBrand_SeekingDistributionFragment } } & { ' $fragmentName'?: 'ExhibitorCard_RegisteredBrandFragment' };

export type ExhibitorsPage_RegisteredBrandFragment = { ' $fragmentRefs'?: { 'ExhibitorCard_RegisteredBrandFragment': ExhibitorCard_RegisteredBrandFragment } } & { ' $fragmentName'?: 'ExhibitorsPage_RegisteredBrandFragment' };

type ExhibitorsPage_Registration_GroupedRegistration_Fragment = {} & { ' $fragmentName'?: 'ExhibitorsPage_Registration_GroupedRegistration_Fragment' };

type ExhibitorsPage_Registration_SingleRegistration_Fragment = { ' $fragmentRefs'?: { 'ExhibitorCard_RegistrationFragment': ExhibitorCard_RegistrationFragment } } & { ' $fragmentName'?: 'ExhibitorsPage_Registration_SingleRegistration_Fragment' };

export type ExhibitorsPage_RegistrationFragment = ExhibitorsPage_Registration_GroupedRegistration_Fragment | ExhibitorsPage_Registration_SingleRegistration_Fragment;

export type ExhibitorFiltersFragment = { companyId: string, registrationStatus?: RegistrationStatus | null, characteristicsSummary: Array<string | null>, regionSummary: Array<string | null>, priceSummary: Array<number | null>, priceRangeSummary: Array<string | null>, primaryVarietySummary: Array<string | null>, productTypeSummary: Array<string | null>, stand?: { name: string, roomName?: string | null } | null, registeredProducts: { totalCount: number }, profile?: { name?: string | null, sortName?: string | null, region?: string | null, city?: string | null, distributionInCountries?: Array<string> | null, seekingDistributionInCountries?: Array<string> | null, countryName?: string | null, sustainabilityCertifications?: Array<{ name?: string | null }> | null } | null } & { ' $fragmentName'?: 'ExhibitorFiltersFragment' };

export type ExhibitorFilters_RegisteredBrandFragment = { brandId: string, isSeekingDistribution?: boolean | null, profile?: { distributionInCountries?: Array<string> | null, seekingDistributionInCountries?: Array<string> | null } | null } & { ' $fragmentName'?: 'ExhibitorFilters_RegisteredBrandFragment' };

export type Search_ExhibitorFragment = { profile?: { name?: string | null, region?: string | null, city?: string | null, countryName?: string | null } | null, stand?: { name: string } | null } & { ' $fragmentName'?: 'Search_ExhibitorFragment' };

type BrandFilters_Brand_Fragment = { wineExperienceOfferings?: Array<string> | null, hospitalityOfferings?: Array<string> | null, lifestyleOfferings?: Array<string> | null, outdoorExperienceOfferings?: Array<string> | null, offeringTypes?: Array<string> | null, openingHours?: Array<{ dayOfWeek: string }> | null } & { ' $fragmentName'?: 'BrandFilters_Brand_Fragment' };

type BrandFilters_Exhibitor_Fragment = { wineExperienceOfferings?: Array<string> | null, hospitalityOfferings?: Array<string> | null, lifestyleOfferings?: Array<string> | null, outdoorExperienceOfferings?: Array<string> | null, offeringTypes?: Array<string> | null, openingHours?: Array<{ dayOfWeek: string }> | null } & { ' $fragmentName'?: 'BrandFilters_Exhibitor_Fragment' };

type BrandFilters_Producer_Fragment = { wineExperienceOfferings?: Array<string> | null, hospitalityOfferings?: Array<string> | null, lifestyleOfferings?: Array<string> | null, outdoorExperienceOfferings?: Array<string> | null, offeringTypes?: Array<string> | null, openingHours?: Array<{ dayOfWeek: string }> | null } & { ' $fragmentName'?: 'BrandFilters_Producer_Fragment' };

export type BrandFiltersFragment = BrandFilters_Brand_Fragment | BrandFilters_Exhibitor_Fragment | BrandFilters_Producer_Fragment;

export type BrandFilters_RegisteredBrandFragment = { partnerId: string, isSeekingDistribution?: boolean | null, highlights?: { ' $fragmentRefs'?: { 'FieldValue_ChangeoverFieldValue_Fragment': FieldValue_ChangeoverFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_DateFieldValue_Fragment': FieldValue_DateFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_FloatFieldValue_Fragment': FieldValue_FloatFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_ImageFieldValue_Fragment': FieldValue_ImageFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_IntFieldValue_Fragment': FieldValue_IntFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_MultiSelectFieldValue_Fragment': FieldValue_MultiSelectFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_SelectFieldValue_Fragment': FieldValue_SelectFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_TextFieldValue_Fragment': FieldValue_TextFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_YesNoFieldValue_Fragment': FieldValue_YesNoFieldValue_Fragment } } | null } & { ' $fragmentName'?: 'BrandFilters_RegisteredBrandFragment' };

export type ProducerFiltersFragment = { ' $fragmentRefs'?: { 'BrandFilters_Producer_Fragment': BrandFilters_Producer_Fragment } } & { ' $fragmentName'?: 'ProducerFiltersFragment' };

export type ProducerFilters_RegisteredBrandFragment = (
  { profile?: { brandId: string } | null }
  & { ' $fragmentRefs'?: { 'BrandFilters_RegisteredBrandFragment': BrandFilters_RegisteredBrandFragment } }
) & { ' $fragmentName'?: 'ProducerFilters_RegisteredBrandFragment' };

export type ProductFilters_EventFragment = { pricing?: { publicPriceRangeImage?: { fixed?: { src?: string | null, srcSet?: string | null } | null } | null, priceRangeImage?: { fixed?: { src?: string | null, srcSet?: string | null } | null } | null } | null } & { ' $fragmentName'?: 'ProductFilters_EventFragment' };

export type GalleryFragment = (
  { title?: string | null, image?: { src?: string | null, srcSet?: string | null, sizes?: string | null, width?: number | null, height?: number | null, aspectRatio?: number | null } | null }
  & { ' $fragmentRefs'?: { 'GalleryLightboxFragment': GalleryLightboxFragment } }
) & { ' $fragmentName'?: 'GalleryFragment' };

export type GalleryLightboxFragment = { title?: string | null, description?: string | null, fullPreview?: { src?: string | null } | null, full?: { src?: string | null, sizes?: string | null } | null } & { ' $fragmentName'?: 'GalleryLightboxFragment' };

export type EventVideosFragment = (
  { type?: VideoType | null, videoId?: string | null, title?: string | null }
  & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
) & { ' $fragmentName'?: 'EventVideosFragment' };

type FeaturedExhibitorsSection_Brand_Fragment = { ' $fragmentRefs'?: { 'BrandCarousel_Brand_Fragment': BrandCarousel_Brand_Fragment } } & { ' $fragmentName'?: 'FeaturedExhibitorsSection_Brand_Fragment' };

type FeaturedExhibitorsSection_BrandProfile_Fragment = { ' $fragmentRefs'?: { 'BrandCarousel_BrandProfile_Fragment': BrandCarousel_BrandProfile_Fragment } } & { ' $fragmentName'?: 'FeaturedExhibitorsSection_BrandProfile_Fragment' };

type FeaturedExhibitorsSection_CompanyProfile_Fragment = { ' $fragmentRefs'?: { 'BrandCarousel_CompanyProfile_Fragment': BrandCarousel_CompanyProfile_Fragment } } & { ' $fragmentName'?: 'FeaturedExhibitorsSection_CompanyProfile_Fragment' };

type FeaturedExhibitorsSection_Exhibitor_Fragment = { ' $fragmentRefs'?: { 'BrandCarousel_Exhibitor_Fragment': BrandCarousel_Exhibitor_Fragment } } & { ' $fragmentName'?: 'FeaturedExhibitorsSection_Exhibitor_Fragment' };

type FeaturedExhibitorsSection_Producer_Fragment = { ' $fragmentRefs'?: { 'BrandCarousel_Producer_Fragment': BrandCarousel_Producer_Fragment } } & { ' $fragmentName'?: 'FeaturedExhibitorsSection_Producer_Fragment' };

type FeaturedExhibitorsSection_RegistrationProfile_Fragment = { ' $fragmentRefs'?: { 'BrandCarousel_RegistrationProfile_Fragment': BrandCarousel_RegistrationProfile_Fragment } } & { ' $fragmentName'?: 'FeaturedExhibitorsSection_RegistrationProfile_Fragment' };

export type FeaturedExhibitorsSectionFragment = FeaturedExhibitorsSection_Brand_Fragment | FeaturedExhibitorsSection_BrandProfile_Fragment | FeaturedExhibitorsSection_CompanyProfile_Fragment | FeaturedExhibitorsSection_Exhibitor_Fragment | FeaturedExhibitorsSection_Producer_Fragment | FeaturedExhibitorsSection_RegistrationProfile_Fragment;

type FilesSection_LiveInfoSheet_Fragment = { fileId?: string | null, name?: string | null, url: string } & { ' $fragmentName'?: 'FilesSection_LiveInfoSheet_Fragment' };

type FilesSection_UploadedFile_Fragment = { fileId?: string | null, name?: string | null, url: string, thumbnail?: { src?: string | null, srcSet?: string | null, width?: number | null, height?: number | null } | null } & { ' $fragmentName'?: 'FilesSection_UploadedFile_Fragment' };

export type FilesSectionFragment = FilesSection_LiveInfoSheet_Fragment | FilesSection_UploadedFile_Fragment;

export type LandingPageFragment = { ' $fragmentRefs'?: { 'LandingPageSectionsFragment': LandingPageSectionsFragment } } & { ' $fragmentName'?: 'LandingPageFragment' };

type LandingPage_FeaturedExhibitors_Brand_Fragment = { ' $fragmentRefs'?: { 'LandingPageSections_FeaturedExhibitors_Brand_Fragment': LandingPageSections_FeaturedExhibitors_Brand_Fragment } } & { ' $fragmentName'?: 'LandingPage_FeaturedExhibitors_Brand_Fragment' };

type LandingPage_FeaturedExhibitors_BrandProfile_Fragment = { ' $fragmentRefs'?: { 'LandingPageSections_FeaturedExhibitors_BrandProfile_Fragment': LandingPageSections_FeaturedExhibitors_BrandProfile_Fragment } } & { ' $fragmentName'?: 'LandingPage_FeaturedExhibitors_BrandProfile_Fragment' };

type LandingPage_FeaturedExhibitors_CompanyProfile_Fragment = { ' $fragmentRefs'?: { 'LandingPageSections_FeaturedExhibitors_CompanyProfile_Fragment': LandingPageSections_FeaturedExhibitors_CompanyProfile_Fragment } } & { ' $fragmentName'?: 'LandingPage_FeaturedExhibitors_CompanyProfile_Fragment' };

type LandingPage_FeaturedExhibitors_Exhibitor_Fragment = { ' $fragmentRefs'?: { 'LandingPageSections_FeaturedExhibitors_Exhibitor_Fragment': LandingPageSections_FeaturedExhibitors_Exhibitor_Fragment } } & { ' $fragmentName'?: 'LandingPage_FeaturedExhibitors_Exhibitor_Fragment' };

type LandingPage_FeaturedExhibitors_Producer_Fragment = { ' $fragmentRefs'?: { 'LandingPageSections_FeaturedExhibitors_Producer_Fragment': LandingPageSections_FeaturedExhibitors_Producer_Fragment } } & { ' $fragmentName'?: 'LandingPage_FeaturedExhibitors_Producer_Fragment' };

type LandingPage_FeaturedExhibitors_RegistrationProfile_Fragment = { ' $fragmentRefs'?: { 'LandingPageSections_FeaturedExhibitors_RegistrationProfile_Fragment': LandingPageSections_FeaturedExhibitors_RegistrationProfile_Fragment } } & { ' $fragmentName'?: 'LandingPage_FeaturedExhibitors_RegistrationProfile_Fragment' };

export type LandingPage_FeaturedExhibitorsFragment = LandingPage_FeaturedExhibitors_Brand_Fragment | LandingPage_FeaturedExhibitors_BrandProfile_Fragment | LandingPage_FeaturedExhibitors_CompanyProfile_Fragment | LandingPage_FeaturedExhibitors_Exhibitor_Fragment | LandingPage_FeaturedExhibitors_Producer_Fragment | LandingPage_FeaturedExhibitors_RegistrationProfile_Fragment;

export type LandingPageSectionsFragment = (
  { videos?: Array<{ ' $fragmentRefs'?: { 'EventVideosFragment': EventVideosFragment } }> | null, files?: { nodes: Array<{ ' $fragmentRefs'?: { 'FilesSection_LiveInfoSheet_Fragment': FilesSection_LiveInfoSheet_Fragment } } | { ' $fragmentRefs'?: { 'FilesSection_UploadedFile_Fragment': FilesSection_UploadedFile_Fragment } }> } | null }
  & { ' $fragmentRefs'?: { 'EventBannerFragment': EventBannerFragment;'EventHeaderFragment': EventHeaderFragment } }
) & { ' $fragmentName'?: 'LandingPageSectionsFragment' };

type LandingPageSections_FeaturedExhibitors_Brand_Fragment = { ' $fragmentRefs'?: { 'FeaturedExhibitorsSection_Brand_Fragment': FeaturedExhibitorsSection_Brand_Fragment } } & { ' $fragmentName'?: 'LandingPageSections_FeaturedExhibitors_Brand_Fragment' };

type LandingPageSections_FeaturedExhibitors_BrandProfile_Fragment = { ' $fragmentRefs'?: { 'FeaturedExhibitorsSection_BrandProfile_Fragment': FeaturedExhibitorsSection_BrandProfile_Fragment } } & { ' $fragmentName'?: 'LandingPageSections_FeaturedExhibitors_BrandProfile_Fragment' };

type LandingPageSections_FeaturedExhibitors_CompanyProfile_Fragment = { ' $fragmentRefs'?: { 'FeaturedExhibitorsSection_CompanyProfile_Fragment': FeaturedExhibitorsSection_CompanyProfile_Fragment } } & { ' $fragmentName'?: 'LandingPageSections_FeaturedExhibitors_CompanyProfile_Fragment' };

type LandingPageSections_FeaturedExhibitors_Exhibitor_Fragment = { ' $fragmentRefs'?: { 'FeaturedExhibitorsSection_Exhibitor_Fragment': FeaturedExhibitorsSection_Exhibitor_Fragment } } & { ' $fragmentName'?: 'LandingPageSections_FeaturedExhibitors_Exhibitor_Fragment' };

type LandingPageSections_FeaturedExhibitors_Producer_Fragment = { ' $fragmentRefs'?: { 'FeaturedExhibitorsSection_Producer_Fragment': FeaturedExhibitorsSection_Producer_Fragment } } & { ' $fragmentName'?: 'LandingPageSections_FeaturedExhibitors_Producer_Fragment' };

type LandingPageSections_FeaturedExhibitors_RegistrationProfile_Fragment = { ' $fragmentRefs'?: { 'FeaturedExhibitorsSection_RegistrationProfile_Fragment': FeaturedExhibitorsSection_RegistrationProfile_Fragment } } & { ' $fragmentName'?: 'LandingPageSections_FeaturedExhibitors_RegistrationProfile_Fragment' };

export type LandingPageSections_FeaturedExhibitorsFragment = LandingPageSections_FeaturedExhibitors_Brand_Fragment | LandingPageSections_FeaturedExhibitors_BrandProfile_Fragment | LandingPageSections_FeaturedExhibitors_CompanyProfile_Fragment | LandingPageSections_FeaturedExhibitors_Exhibitor_Fragment | LandingPageSections_FeaturedExhibitors_Producer_Fragment | LandingPageSections_FeaturedExhibitors_RegistrationProfile_Fragment;

export type RequestMeetingDialogFragment = (
  { uid: string, displayName?: string | null, jobTitle?: string | null, companyName?: string | null }
  & { ' $fragmentRefs'?: { 'RequestMeetingButtonTimeFormFragment': RequestMeetingButtonTimeFormFragment;'RequestMeetingButtonProfileFormFragment': RequestMeetingButtonProfileFormFragment } }
) & { ' $fragmentName'?: 'RequestMeetingDialogFragment' };

export type RequestMeetingButtonInfoFragment = { displayName?: string | null, profileImage?: { url?: string | null, publicId?: string | null } | null, collection: { meetingTimeslots: Array<(
      { location?: string | null, isAvailable?: boolean | null }
      & { ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }
    )> } | { meetingTimeslots: Array<(
      { location?: string | null, isAvailable?: boolean | null }
      & { ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }
    )> } | { meetingTimeslots: Array<(
      { location?: string | null, isAvailable?: boolean | null }
      & { ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }
    )> } | { meetingTimeslots: Array<(
      { location?: string | null, isAvailable?: boolean | null }
      & { ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }
    )> } | { meetingTimeslots: Array<(
      { location?: string | null, isAvailable?: boolean | null }
      & { ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }
    )> } } & { ' $fragmentName'?: 'RequestMeetingButtonInfoFragment' };

export type RequestMeetingButtonProfileFormFragment = (
  { displayName?: string | null }
  & { ' $fragmentRefs'?: { 'RequestMeetingButtonInfoFragment': RequestMeetingButtonInfoFragment } }
) & { ' $fragmentName'?: 'RequestMeetingButtonProfileFormFragment' };

export type RequestMeetingButtonTimeFormFragment = (
  { displayName?: string | null, collection: { meetingTimeslots: Array<{ ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }> } | { meetingTimeslots: Array<{ ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }> } | { meetingTimeslots: Array<{ ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }> } | { meetingTimeslots: Array<{ ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }> } | { meetingTimeslots: Array<{ ' $fragmentRefs'?: { 'TimeslotFragment': TimeslotFragment } }> } }
  & { ' $fragmentRefs'?: { 'RequestMeetingButtonInfoFragment': RequestMeetingButtonInfoFragment } }
) & { ' $fragmentName'?: 'RequestMeetingButtonTimeFormFragment' };

export type RequestMeetingButtonFragment = { ' $fragmentRefs'?: { 'RequestMeetingDialogFragment': RequestMeetingDialogFragment } } & { ' $fragmentName'?: 'RequestMeetingButtonFragment' };

export type TimeslotFieldFragment = { dateLabel: string, timeslotLabel: string, durationInMinutes: number, isAvailable?: boolean | null, id: string } & { ' $fragmentName'?: 'TimeslotFieldFragment' };

export type TimeslotFragment = (
  { dateLabel: string, durationInMinutes: number }
  & { ' $fragmentRefs'?: { 'TimeslotFieldFragment': TimeslotFieldFragment } }
) & { ' $fragmentName'?: 'TimeslotFragment' };

type Registration_ProducerHeader_GroupedRegistration_Fragment = {} & { ' $fragmentName'?: 'Registration_ProducerHeader_GroupedRegistration_Fragment' };

type Registration_ProducerHeader_SingleRegistration_Fragment = { ' $fragmentRefs'?: { 'Registration_ProducerStandFragment': Registration_ProducerStandFragment } } & { ' $fragmentName'?: 'Registration_ProducerHeader_SingleRegistration_Fragment' };

export type Registration_ProducerHeaderFragment = Registration_ProducerHeader_GroupedRegistration_Fragment | Registration_ProducerHeader_SingleRegistration_Fragment;

export type RegisteredBrand_ProducerHeaderFragment = { ' $fragmentRefs'?: { 'RegisteredBrand_SeekingDistributionFragment': RegisteredBrand_SeekingDistributionFragment } } & { ' $fragmentName'?: 'RegisteredBrand_ProducerHeaderFragment' };

export type Registration_ProducerStandFragment = { exhibitorId: string, stand?: { name: string } | null, profile?: { name?: string | null } | null } & { ' $fragmentName'?: 'Registration_ProducerStandFragment' };

type Registration_ProducerHeaderRow_GroupedRegistration_Fragment = { ' $fragmentRefs'?: { 'Registration_ProducerHeader_GroupedRegistration_Fragment': Registration_ProducerHeader_GroupedRegistration_Fragment } } & { ' $fragmentName'?: 'Registration_ProducerHeaderRow_GroupedRegistration_Fragment' };

type Registration_ProducerHeaderRow_SingleRegistration_Fragment = { ' $fragmentRefs'?: { 'Registration_ProducerHeader_SingleRegistration_Fragment': Registration_ProducerHeader_SingleRegistration_Fragment } } & { ' $fragmentName'?: 'Registration_ProducerHeaderRow_SingleRegistration_Fragment' };

export type Registration_ProducerHeaderRowFragment = Registration_ProducerHeaderRow_GroupedRegistration_Fragment | Registration_ProducerHeaderRow_SingleRegistration_Fragment;

export type RegisteredBrand_ProducerHeaderRowFragment = { ' $fragmentRefs'?: { 'RegisteredBrand_ProducerHeaderFragment': RegisteredBrand_ProducerHeaderFragment } } & { ' $fragmentName'?: 'RegisteredBrand_ProducerHeaderRowFragment' };

export type RegisteredBrand_ProducerPageFragment = (
  { profile?: { ' $fragmentRefs'?: { 'BrandDistributors_BrandProfile_Fragment': BrandDistributors_BrandProfile_Fragment } } | null, products: { nodes: Array<(
      { productId: string }
      & { ' $fragmentRefs'?: { 'ProductCard_RegisteredProductFragment': ProductCard_RegisteredProductFragment;'ProductListRowFragment': ProductListRowFragment } }
    )> }, registration: (
    { profile?: { ' $fragmentRefs'?: { 'BrandDetailsSection_Profile_RegistrationProfile_Fragment': BrandDetailsSection_Profile_RegistrationProfile_Fragment;'BrandDistributors_RegistrationProfile_Fragment': BrandDistributors_RegistrationProfile_Fragment;'BrandAddressSection_Profile_RegistrationProfile_Fragment': BrandAddressSection_Profile_RegistrationProfile_Fragment;'BrandShopsSection_RegistrationProfile_Fragment': BrandShopsSection_RegistrationProfile_Fragment } } | null }
    & { ' $fragmentRefs'?: { 'ExhibitorSectionsFragment': ExhibitorSectionsFragment;'RegistrationContactsFragment': RegistrationContactsFragment;'Registration_ProducerHeaderRow_SingleRegistration_Fragment': Registration_ProducerHeaderRow_SingleRegistration_Fragment } }
  ) }
  & { ' $fragmentRefs'?: { 'RegisteredBrand_ProducerHeaderRowFragment': RegisteredBrand_ProducerHeaderRowFragment;'ProducerFilters_RegisteredBrandFragment': ProducerFilters_RegisteredBrandFragment;'BrandDetailsSection_RegisteredBrandFragment': BrandDetailsSection_RegisteredBrandFragment } }
) & { ' $fragmentName'?: 'RegisteredBrand_ProducerPageFragment' };

export type ProducerCard_RegisteredBrandFragment = (
  { brandId: string, name?: string | null, registrationId: string, exhibitorId: string, registration: { ' $fragmentRefs'?: { 'ExhibitorCard_RegistrationFragment': ExhibitorCard_RegistrationFragment } } }
  & { ' $fragmentRefs'?: { 'RegisteredBrand_SeekingDistributionFragment': RegisteredBrand_SeekingDistributionFragment;'RegisteredBrand_BrandLogoFragment': RegisteredBrand_BrandLogoFragment;'RegisteredBrand_BrandRegionFragment': RegisteredBrand_BrandRegionFragment } }
) & { ' $fragmentName'?: 'ProducerCard_RegisteredBrandFragment' };

export type ProducerListRowFragment = { offeringTypes?: Array<string> | null } & { ' $fragmentName'?: 'ProducerListRowFragment' };

export type ProducerListRow_RegistrationFragment = { registrationId: string, company?: { name?: string | null } | null } & { ' $fragmentName'?: 'ProducerListRow_RegistrationFragment' };

export type ProducersPageFragment = (
  { producerId: string }
  & { ' $fragmentRefs'?: { 'ProducerListRowFragment': ProducerListRowFragment;'ProducerFiltersFragment': ProducerFiltersFragment } }
) & { ' $fragmentName'?: 'ProducersPageFragment' };

export type ProducersPage_RegisteredBrandFragment = { ' $fragmentRefs'?: { 'ProducerCard_RegisteredBrandFragment': ProducerCard_RegisteredBrandFragment;'ProducerFilters_RegisteredBrandFragment': ProducerFilters_RegisteredBrandFragment } } & { ' $fragmentName'?: 'ProducersPage_RegisteredBrandFragment' };

export type ProducersPage_RegistrationFragment = { ' $fragmentRefs'?: { 'ProducerListRow_RegistrationFragment': ProducerListRow_RegistrationFragment } } & { ' $fragmentName'?: 'ProducersPage_RegistrationFragment' };

export type BottleVariantFragment = { GTIN?: string | null, bottleSize?: string | null, bottleNetWeight?: number | null, closureType?: string | null } & { ' $fragmentName'?: 'BottleVariantFragment' };

export type PackagingVariantFragment = { bottlesPerCase?: number | null, GTIN?: string | null } & { ' $fragmentName'?: 'PackagingVariantFragment' };

type ProductActions_Beer_Fragment = { ' $fragmentRefs'?: { 'ProductShopButton_Beer_Fragment': ProductShopButton_Beer_Fragment } } & { ' $fragmentName'?: 'ProductActions_Beer_Fragment' };

type ProductActions_Cider_Fragment = { ' $fragmentRefs'?: { 'ProductShopButton_Cider_Fragment': ProductShopButton_Cider_Fragment } } & { ' $fragmentName'?: 'ProductActions_Cider_Fragment' };

type ProductActions_Spirit_Fragment = { ' $fragmentRefs'?: { 'ProductShopButton_Spirit_Fragment': ProductShopButton_Spirit_Fragment } } & { ' $fragmentName'?: 'ProductActions_Spirit_Fragment' };

type ProductActions_Wine_Fragment = { ' $fragmentRefs'?: { 'ProductShopButton_Wine_Fragment': ProductShopButton_Wine_Fragment } } & { ' $fragmentName'?: 'ProductActions_Wine_Fragment' };

export type ProductActionsFragment = ProductActions_Beer_Fragment | ProductActions_Cider_Fragment | ProductActions_Spirit_Fragment | ProductActions_Wine_Fragment;

export type ProductActions_RegisteredProductFragment = { ' $fragmentRefs'?: { 'ProductInfoSheetButtonFragment': ProductInfoSheetButtonFragment } } & { ' $fragmentName'?: 'ProductActions_RegisteredProductFragment' };

export type ProductInfoSheetButtonFragment = { infoSheet?: { url: string } | null } & { ' $fragmentName'?: 'ProductInfoSheetButtonFragment' };

type ProductShopButton_Beer_Fragment = { ' $fragmentRefs'?: { 'ProductShopExternalButton_Beer_Fragment': ProductShopExternalButton_Beer_Fragment } } & { ' $fragmentName'?: 'ProductShopButton_Beer_Fragment' };

type ProductShopButton_Cider_Fragment = { ' $fragmentRefs'?: { 'ProductShopExternalButton_Cider_Fragment': ProductShopExternalButton_Cider_Fragment } } & { ' $fragmentName'?: 'ProductShopButton_Cider_Fragment' };

type ProductShopButton_Spirit_Fragment = { ' $fragmentRefs'?: { 'ProductShopExternalButton_Spirit_Fragment': ProductShopExternalButton_Spirit_Fragment } } & { ' $fragmentName'?: 'ProductShopButton_Spirit_Fragment' };

type ProductShopButton_Wine_Fragment = { ' $fragmentRefs'?: { 'ProductShopExternalButton_Wine_Fragment': ProductShopExternalButton_Wine_Fragment } } & { ' $fragmentName'?: 'ProductShopButton_Wine_Fragment' };

export type ProductShopButtonFragment = ProductShopButton_Beer_Fragment | ProductShopButton_Cider_Fragment | ProductShopButton_Spirit_Fragment | ProductShopButton_Wine_Fragment;

type ProductShopExternalButton_Beer_Fragment = { onlineShop?: string | null, producer?: { onlineShop?: string | null } | null } & { ' $fragmentName'?: 'ProductShopExternalButton_Beer_Fragment' };

type ProductShopExternalButton_Cider_Fragment = { onlineShop?: string | null, producer?: { onlineShop?: string | null } | null } & { ' $fragmentName'?: 'ProductShopExternalButton_Cider_Fragment' };

type ProductShopExternalButton_Spirit_Fragment = { onlineShop?: string | null, producer?: { onlineShop?: string | null } | null } & { ' $fragmentName'?: 'ProductShopExternalButton_Spirit_Fragment' };

type ProductShopExternalButton_Wine_Fragment = { onlineShop?: string | null, producer?: { onlineShop?: string | null } | null } & { ' $fragmentName'?: 'ProductShopExternalButton_Wine_Fragment' };

export type ProductShopExternalButtonFragment = ProductShopExternalButton_Beer_Fragment | ProductShopExternalButton_Cider_Fragment | ProductShopExternalButton_Spirit_Fragment | ProductShopExternalButton_Wine_Fragment;

type ProductAnalytics_Beer_Fragment = { alcohol?: number | null, residualSugar?: number | null, totalAcidity?: number | null } & { ' $fragmentName'?: 'ProductAnalytics_Beer_Fragment' };

type ProductAnalytics_Cider_Fragment = { alcohol?: number | null, residualSugar?: number | null, totalAcidity?: number | null } & { ' $fragmentName'?: 'ProductAnalytics_Cider_Fragment' };

type ProductAnalytics_Spirit_Fragment = { alcohol?: number | null, residualSugar?: number | null, totalAcidity?: number | null } & { ' $fragmentName'?: 'ProductAnalytics_Spirit_Fragment' };

type ProductAnalytics_Wine_Fragment = { designation?: string | null, pH?: number | null, alcohol?: number | null, residualSugar?: number | null, totalAcidity?: number | null } & { ' $fragmentName'?: 'ProductAnalytics_Wine_Fragment' };

export type ProductAnalyticsFragment = ProductAnalytics_Beer_Fragment | ProductAnalytics_Cider_Fragment | ProductAnalytics_Spirit_Fragment | ProductAnalytics_Wine_Fragment;

type ProductAromas_Beer_Fragment = { aromaIntensity?: string | null, aromaFruit?: string | null, aromaFloral?: string | null, aromaSpice?: string | null, aromaWood?: string | null } & { ' $fragmentName'?: 'ProductAromas_Beer_Fragment' };

type ProductAromas_Cider_Fragment = { aromaIntensity?: string | null, aromaFruit?: string | null, aromaFloral?: string | null, aromaSpice?: string | null, aromaWood?: string | null } & { ' $fragmentName'?: 'ProductAromas_Cider_Fragment' };

type ProductAromas_Spirit_Fragment = { aromaIntensity?: string | null, aromaFruit?: string | null, aromaFloral?: string | null, aromaSpice?: string | null, aromaWood?: string | null } & { ' $fragmentName'?: 'ProductAromas_Spirit_Fragment' };

type ProductAromas_Wine_Fragment = { aromaIntensity?: string | null, aromaFruit?: string | null, aromaFloral?: string | null, aromaSpice?: string | null, aromaWood?: string | null } & { ' $fragmentName'?: 'ProductAromas_Wine_Fragment' };

export type ProductAromasFragment = ProductAromas_Beer_Fragment | ProductAromas_Cider_Fragment | ProductAromas_Spirit_Fragment | ProductAromas_Wine_Fragment;

type ProductAwards_Beer_Fragment = { productId: string, otherAwards?: string | null, awards?: Array<{ award?: string | null, medal?: string | null }> | null } & { ' $fragmentName'?: 'ProductAwards_Beer_Fragment' };

type ProductAwards_Cider_Fragment = { productId: string, otherAwards?: string | null, awards?: Array<{ award?: string | null, medal?: string | null }> | null } & { ' $fragmentName'?: 'ProductAwards_Cider_Fragment' };

type ProductAwards_Spirit_Fragment = { productId: string, otherAwards?: string | null, awards?: Array<{ award?: string | null, medal?: string | null }> | null } & { ' $fragmentName'?: 'ProductAwards_Spirit_Fragment' };

type ProductAwards_Wine_Fragment = { productId: string, otherAwards?: string | null, awards?: Array<{ award?: string | null, medal?: string | null }> | null } & { ' $fragmentName'?: 'ProductAwards_Wine_Fragment' };

export type ProductAwardsFragment = ProductAwards_Beer_Fragment | ProductAwards_Cider_Fragment | ProductAwards_Spirit_Fragment | ProductAwards_Wine_Fragment;

type ProductBottleVariants_Beer_Fragment = { bottleVariants?: Array<{ ' $fragmentRefs'?: { 'BottleVariantFragment': BottleVariantFragment } }> | null } & { ' $fragmentName'?: 'ProductBottleVariants_Beer_Fragment' };

type ProductBottleVariants_Cider_Fragment = { bottleVariants?: Array<{ ' $fragmentRefs'?: { 'BottleVariantFragment': BottleVariantFragment } }> | null } & { ' $fragmentName'?: 'ProductBottleVariants_Cider_Fragment' };

type ProductBottleVariants_Spirit_Fragment = { bottleVariants?: Array<{ ' $fragmentRefs'?: { 'BottleVariantFragment': BottleVariantFragment } }> | null } & { ' $fragmentName'?: 'ProductBottleVariants_Spirit_Fragment' };

type ProductBottleVariants_Wine_Fragment = { bottleVariants?: Array<{ ' $fragmentRefs'?: { 'BottleVariantFragment': BottleVariantFragment } }> | null } & { ' $fragmentName'?: 'ProductBottleVariants_Wine_Fragment' };

export type ProductBottleVariantsFragment = ProductBottleVariants_Beer_Fragment | ProductBottleVariants_Cider_Fragment | ProductBottleVariants_Spirit_Fragment | ProductBottleVariants_Wine_Fragment;

type ProductCertifications_Beer_Fragment = { isVegan?: boolean | null, isVegetarian?: boolean | null, isCertifiedOrganic?: boolean | null, isOrganic?: boolean | null, isGmoFree?: boolean | null, otherSustainabilityCertifications?: string | null, localCertifications?: Array<{ fileUrl?: string | null, name?: string | null, file?: { publicId: string } | { publicId: string } | null }> | null, internationalCertifications?: Array<{ fileUrl?: string | null, name?: string | null, file?: { publicId: string } | { publicId: string } | null }> | null } & { ' $fragmentName'?: 'ProductCertifications_Beer_Fragment' };

type ProductCertifications_Cider_Fragment = { isVegan?: boolean | null, isVegetarian?: boolean | null, isCertifiedOrganic?: boolean | null, isOrganic?: boolean | null, isGmoFree?: boolean | null, otherSustainabilityCertifications?: string | null, localCertifications?: Array<{ fileUrl?: string | null, name?: string | null, file?: { publicId: string } | { publicId: string } | null }> | null, internationalCertifications?: Array<{ fileUrl?: string | null, name?: string | null, file?: { publicId: string } | { publicId: string } | null }> | null } & { ' $fragmentName'?: 'ProductCertifications_Cider_Fragment' };

type ProductCertifications_Spirit_Fragment = { isVegan?: boolean | null, isVegetarian?: boolean | null, isCertifiedOrganic?: boolean | null, isOrganic?: boolean | null, isGmoFree?: boolean | null, otherSustainabilityCertifications?: string | null, localCertifications?: Array<{ fileUrl?: string | null, name?: string | null, file?: { publicId: string } | { publicId: string } | null }> | null, internationalCertifications?: Array<{ fileUrl?: string | null, name?: string | null, file?: { publicId: string } | { publicId: string } | null }> | null } & { ' $fragmentName'?: 'ProductCertifications_Spirit_Fragment' };

type ProductCertifications_Wine_Fragment = { isVegan?: boolean | null, isVegetarian?: boolean | null, isCertifiedOrganic?: boolean | null, isOrganic?: boolean | null, isGmoFree?: boolean | null, otherSustainabilityCertifications?: string | null, localCertifications?: Array<{ fileUrl?: string | null, name?: string | null, file?: { publicId: string } | { publicId: string } | null }> | null, internationalCertifications?: Array<{ fileUrl?: string | null, name?: string | null, file?: { publicId: string } | { publicId: string } | null }> | null } & { ' $fragmentName'?: 'ProductCertifications_Wine_Fragment' };

export type ProductCertificationsFragment = ProductCertifications_Beer_Fragment | ProductCertifications_Cider_Fragment | ProductCertifications_Spirit_Fragment | ProductCertifications_Wine_Fragment;

type ProductColor_Beer_Fragment = { apparentColor?: string | null, appearanceIntensity?: string | null } & { ' $fragmentName'?: 'ProductColor_Beer_Fragment' };

type ProductColor_Cider_Fragment = { apparentColor?: string | null, appearanceIntensity?: string | null } & { ' $fragmentName'?: 'ProductColor_Cider_Fragment' };

type ProductColor_Spirit_Fragment = { apparentColor?: string | null, appearanceIntensity?: string | null } & { ' $fragmentName'?: 'ProductColor_Spirit_Fragment' };

type ProductColor_Wine_Fragment = { apparentColor?: string | null, appearanceIntensity?: string | null } & { ' $fragmentName'?: 'ProductColor_Wine_Fragment' };

export type ProductColorFragment = ProductColor_Beer_Fragment | ProductColor_Cider_Fragment | ProductColor_Spirit_Fragment | ProductColor_Wine_Fragment;

type ProductDescription_Beer_Fragment = { description?: string | null, consumerDescription?: string | null, website?: string | null } & { ' $fragmentName'?: 'ProductDescription_Beer_Fragment' };

type ProductDescription_Cider_Fragment = { description?: string | null, consumerDescription?: string | null, website?: string | null } & { ' $fragmentName'?: 'ProductDescription_Cider_Fragment' };

type ProductDescription_Spirit_Fragment = { description?: string | null, consumerDescription?: string | null, website?: string | null } & { ' $fragmentName'?: 'ProductDescription_Spirit_Fragment' };

type ProductDescription_Wine_Fragment = { description?: string | null, consumerDescription?: string | null, website?: string | null } & { ' $fragmentName'?: 'ProductDescription_Wine_Fragment' };

export type ProductDescriptionFragment = ProductDescription_Beer_Fragment | ProductDescription_Cider_Fragment | ProductDescription_Spirit_Fragment | ProductDescription_Wine_Fragment;

type ProductGallery_Beer_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'ProductGallery_Beer_Fragment' };

type ProductGallery_Cider_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'ProductGallery_Cider_Fragment' };

type ProductGallery_Spirit_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'ProductGallery_Spirit_Fragment' };

type ProductGallery_Wine_Fragment = { galleryImages?: Array<{ ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } } | {}> | null } & { ' $fragmentName'?: 'ProductGallery_Wine_Fragment' };

export type ProductGalleryFragment = ProductGallery_Beer_Fragment | ProductGallery_Cider_Fragment | ProductGallery_Spirit_Fragment | ProductGallery_Wine_Fragment;

export type ProductHeaderDetails_RegisteredProductFragment = (
  { registration: (
    { profile?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductStandFragment': ProductStandFragment } }
  ), pricing?: { priceType?: string | null } | null, product: (
    { producer?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductHeaderProductName_Beer_Fragment': ProductHeaderProductName_Beer_Fragment;'ProductHeaderProductRegion_Beer_Fragment': ProductHeaderProductRegion_Beer_Fragment;'ProductHeaderProducerName_Beer_Fragment': ProductHeaderProducerName_Beer_Fragment;'ProductHeaderProductVarieties_Beer_Fragment': ProductHeaderProductVarieties_Beer_Fragment } }
  ) | (
    { producer?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductHeaderProductName_Cider_Fragment': ProductHeaderProductName_Cider_Fragment;'ProductHeaderProductRegion_Cider_Fragment': ProductHeaderProductRegion_Cider_Fragment;'ProductHeaderProducerName_Cider_Fragment': ProductHeaderProducerName_Cider_Fragment;'ProductHeaderProductVarieties_Cider_Fragment': ProductHeaderProductVarieties_Cider_Fragment } }
  ) | (
    { producer?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductHeaderProductName_Spirit_Fragment': ProductHeaderProductName_Spirit_Fragment;'ProductHeaderProductRegion_Spirit_Fragment': ProductHeaderProductRegion_Spirit_Fragment;'ProductHeaderProducerName_Spirit_Fragment': ProductHeaderProducerName_Spirit_Fragment;'ProductHeaderProductVarieties_Spirit_Fragment': ProductHeaderProductVarieties_Spirit_Fragment } }
  ) | (
    { producer?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductHeaderProductName_Wine_Fragment': ProductHeaderProductName_Wine_Fragment;'ProductHeaderProductRegion_Wine_Fragment': ProductHeaderProductRegion_Wine_Fragment;'ProductHeaderProducerName_Wine_Fragment': ProductHeaderProducerName_Wine_Fragment;'ProductHeaderProductVarieties_Wine_Fragment': ProductHeaderProductVarieties_Wine_Fragment } }
  ) }
  & { ' $fragmentRefs'?: { 'HasDifferentExhibitorFragment': HasDifferentExhibitorFragment;'ProductPriceFragment': ProductPriceFragment } }
) & { ' $fragmentName'?: 'ProductHeaderDetails_RegisteredProductFragment' };

type ProductHeaderProducerName_Beer_Fragment = { ' $fragmentRefs'?: { 'ProductProducerName_Beer_Fragment': ProductProducerName_Beer_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProducerName_Beer_Fragment' };

type ProductHeaderProducerName_Cider_Fragment = { ' $fragmentRefs'?: { 'ProductProducerName_Cider_Fragment': ProductProducerName_Cider_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProducerName_Cider_Fragment' };

type ProductHeaderProducerName_Spirit_Fragment = { ' $fragmentRefs'?: { 'ProductProducerName_Spirit_Fragment': ProductProducerName_Spirit_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProducerName_Spirit_Fragment' };

type ProductHeaderProducerName_Wine_Fragment = { ' $fragmentRefs'?: { 'ProductProducerName_Wine_Fragment': ProductProducerName_Wine_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProducerName_Wine_Fragment' };

export type ProductHeaderProducerNameFragment = ProductHeaderProducerName_Beer_Fragment | ProductHeaderProducerName_Cider_Fragment | ProductHeaderProducerName_Spirit_Fragment | ProductHeaderProducerName_Wine_Fragment;

type ProductHeaderProductName_Beer_Fragment = { ' $fragmentRefs'?: { 'ProductName_Beer_Fragment': ProductName_Beer_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductName_Beer_Fragment' };

type ProductHeaderProductName_Cider_Fragment = { ' $fragmentRefs'?: { 'ProductName_Cider_Fragment': ProductName_Cider_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductName_Cider_Fragment' };

type ProductHeaderProductName_Spirit_Fragment = { ' $fragmentRefs'?: { 'ProductName_Spirit_Fragment': ProductName_Spirit_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductName_Spirit_Fragment' };

type ProductHeaderProductName_Wine_Fragment = { ' $fragmentRefs'?: { 'ProductName_Wine_Fragment': ProductName_Wine_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductName_Wine_Fragment' };

export type ProductHeaderProductNameFragment = ProductHeaderProductName_Beer_Fragment | ProductHeaderProductName_Cider_Fragment | ProductHeaderProductName_Spirit_Fragment | ProductHeaderProductName_Wine_Fragment;

export type ProductHeaderDetailsFragment = (
  { product: { ' $fragmentRefs'?: { 'ProductHeaderProductVarieties_Beer_Fragment': ProductHeaderProductVarieties_Beer_Fragment;'ProductHeaderProductRegion_Beer_Fragment': ProductHeaderProductRegion_Beer_Fragment;'ProductHeaderProductName_Beer_Fragment': ProductHeaderProductName_Beer_Fragment;'ProductProducerName_Beer_Fragment': ProductProducerName_Beer_Fragment } } | { ' $fragmentRefs'?: { 'ProductHeaderProductVarieties_Cider_Fragment': ProductHeaderProductVarieties_Cider_Fragment;'ProductHeaderProductRegion_Cider_Fragment': ProductHeaderProductRegion_Cider_Fragment;'ProductHeaderProductName_Cider_Fragment': ProductHeaderProductName_Cider_Fragment;'ProductProducerName_Cider_Fragment': ProductProducerName_Cider_Fragment } } | { ' $fragmentRefs'?: { 'ProductHeaderProductVarieties_Spirit_Fragment': ProductHeaderProductVarieties_Spirit_Fragment;'ProductHeaderProductRegion_Spirit_Fragment': ProductHeaderProductRegion_Spirit_Fragment;'ProductHeaderProductName_Spirit_Fragment': ProductHeaderProductName_Spirit_Fragment;'ProductProducerName_Spirit_Fragment': ProductProducerName_Spirit_Fragment } } | { ' $fragmentRefs'?: { 'ProductHeaderProductVarieties_Wine_Fragment': ProductHeaderProductVarieties_Wine_Fragment;'ProductHeaderProductRegion_Wine_Fragment': ProductHeaderProductRegion_Wine_Fragment;'ProductHeaderProductName_Wine_Fragment': ProductHeaderProductName_Wine_Fragment;'ProductProducerName_Wine_Fragment': ProductProducerName_Wine_Fragment } } }
  & { ' $fragmentRefs'?: { 'ProductHeaderPriceFragment': ProductHeaderPriceFragment } }
) & { ' $fragmentName'?: 'ProductHeaderDetailsFragment' };

type ProductHeaderProductRegion_Beer_Fragment = { ' $fragmentRefs'?: { 'ProductRegion_Beer_Fragment': ProductRegion_Beer_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductRegion_Beer_Fragment' };

type ProductHeaderProductRegion_Cider_Fragment = { ' $fragmentRefs'?: { 'ProductRegion_Cider_Fragment': ProductRegion_Cider_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductRegion_Cider_Fragment' };

type ProductHeaderProductRegion_Spirit_Fragment = { ' $fragmentRefs'?: { 'ProductRegion_Spirit_Fragment': ProductRegion_Spirit_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductRegion_Spirit_Fragment' };

type ProductHeaderProductRegion_Wine_Fragment = { ' $fragmentRefs'?: { 'ProductRegion_Wine_Fragment': ProductRegion_Wine_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductRegion_Wine_Fragment' };

export type ProductHeaderProductRegionFragment = ProductHeaderProductRegion_Beer_Fragment | ProductHeaderProductRegion_Cider_Fragment | ProductHeaderProductRegion_Spirit_Fragment | ProductHeaderProductRegion_Wine_Fragment;

type ProductHeaderProductVarieties_Beer_Fragment = { ' $fragmentRefs'?: { 'ProductVarieties_Beer_Fragment': ProductVarieties_Beer_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductVarieties_Beer_Fragment' };

type ProductHeaderProductVarieties_Cider_Fragment = { ' $fragmentRefs'?: { 'ProductVarieties_Cider_Fragment': ProductVarieties_Cider_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductVarieties_Cider_Fragment' };

type ProductHeaderProductVarieties_Spirit_Fragment = { ' $fragmentRefs'?: { 'ProductVarieties_Spirit_Fragment': ProductVarieties_Spirit_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductVarieties_Spirit_Fragment' };

type ProductHeaderProductVarieties_Wine_Fragment = { ' $fragmentRefs'?: { 'ProductVarieties_Wine_Fragment': ProductVarieties_Wine_Fragment } } & { ' $fragmentName'?: 'ProductHeaderProductVarieties_Wine_Fragment' };

export type ProductHeaderProductVarietiesFragment = ProductHeaderProductVarieties_Beer_Fragment | ProductHeaderProductVarieties_Cider_Fragment | ProductHeaderProductVarieties_Spirit_Fragment | ProductHeaderProductVarieties_Wine_Fragment;

export type HasDifferentExhibitorFragment = { registration: { profile?: { name?: string | null } | null }, producer?: { name?: string | null } | null } & { ' $fragmentName'?: 'HasDifferentExhibitorFragment' };

export type ProductHeaderPriceFragment = { ' $fragmentRefs'?: { 'ProductPriceFragment': ProductPriceFragment } } & { ' $fragmentName'?: 'ProductHeaderPriceFragment' };

export type ImageFragment = { publicId?: string | null } & { ' $fragmentName'?: 'ImageFragment' };

type ProductImage_Beer_Fragment = { bottleImage?: { ' $fragmentRefs'?: { 'ImageFragment': ImageFragment } } | null } & { ' $fragmentName'?: 'ProductImage_Beer_Fragment' };

type ProductImage_Cider_Fragment = { bottleImage?: { ' $fragmentRefs'?: { 'ImageFragment': ImageFragment } } | null } & { ' $fragmentName'?: 'ProductImage_Cider_Fragment' };

type ProductImage_Spirit_Fragment = { bottleImage?: { ' $fragmentRefs'?: { 'ImageFragment': ImageFragment } } | null } & { ' $fragmentName'?: 'ProductImage_Spirit_Fragment' };

type ProductImage_Wine_Fragment = { bottleImage?: { ' $fragmentRefs'?: { 'ImageFragment': ImageFragment } } | null } & { ' $fragmentName'?: 'ProductImage_Wine_Fragment' };

export type ProductImageFragment = ProductImage_Beer_Fragment | ProductImage_Cider_Fragment | ProductImage_Spirit_Fragment | ProductImage_Wine_Fragment;

type ProductImageSmall_List_Beer_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageSmall_List_Beer_Fragment' };

type ProductImageSmall_List_Cider_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageSmall_List_Cider_Fragment' };

type ProductImageSmall_List_Spirit_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageSmall_List_Spirit_Fragment' };

type ProductImageSmall_List_Wine_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageSmall_List_Wine_Fragment' };

export type ProductImageSmall_ListFragment = ProductImageSmall_List_Beer_Fragment | ProductImageSmall_List_Cider_Fragment | ProductImageSmall_List_Spirit_Fragment | ProductImageSmall_List_Wine_Fragment;

type ProductImage_List_Beer_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImage_List_Beer_Fragment' };

type ProductImage_List_Cider_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImage_List_Cider_Fragment' };

type ProductImage_List_Spirit_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImage_List_Spirit_Fragment' };

type ProductImage_List_Wine_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImage_List_Wine_Fragment' };

export type ProductImage_ListFragment = ProductImage_List_Beer_Fragment | ProductImage_List_Cider_Fragment | ProductImage_List_Spirit_Fragment | ProductImage_List_Wine_Fragment;

type ProductImageLarge_Beer_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageLarge_Beer_Fragment' };

type ProductImageLarge_Cider_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageLarge_Cider_Fragment' };

type ProductImageLarge_Spirit_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageLarge_Spirit_Fragment' };

type ProductImageLarge_Wine_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, base64?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageLarge_Wine_Fragment' };

export type ProductImageLargeFragment = ProductImageLarge_Beer_Fragment | ProductImageLarge_Cider_Fragment | ProductImageLarge_Spirit_Fragment | ProductImageLarge_Wine_Fragment;

type ProductImageLarge_List_Beer_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageLarge_List_Beer_Fragment' };

type ProductImageLarge_List_Cider_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageLarge_List_Cider_Fragment' };

type ProductImageLarge_List_Spirit_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageLarge_List_Spirit_Fragment' };

type ProductImageLarge_List_Wine_Fragment = { bottleImage?: { publicId?: string | null, fixed?: { src?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductImageLarge_List_Wine_Fragment' };

export type ProductImageLarge_ListFragment = ProductImageLarge_List_Beer_Fragment | ProductImageLarge_List_Cider_Fragment | ProductImageLarge_List_Spirit_Fragment | ProductImageLarge_List_Wine_Fragment;

export type ProductLabel_RegisteredProductFragment = { flightName?: string | null, productLabel?: string | null } & { ' $fragmentName'?: 'ProductLabel_RegisteredProductFragment' };

type ProductName_Beer_Fragment = { __typename: 'Beer', shortName: string } & { ' $fragmentName'?: 'ProductName_Beer_Fragment' };

type ProductName_Cider_Fragment = { __typename: 'Cider', shortName: string } & { ' $fragmentName'?: 'ProductName_Cider_Fragment' };

type ProductName_Spirit_Fragment = { __typename: 'Spirit', shortName: string } & { ' $fragmentName'?: 'ProductName_Spirit_Fragment' };

type ProductName_Wine_Fragment = { __typename: 'Wine', vintage?: string | null, shortName: string } & { ' $fragmentName'?: 'ProductName_Wine_Fragment' };

export type ProductNameFragment = ProductName_Beer_Fragment | ProductName_Cider_Fragment | ProductName_Spirit_Fragment | ProductName_Wine_Fragment;

type ProductPackagingVariants_Beer_Fragment = { packagingVariants?: Array<{ ' $fragmentRefs'?: { 'PackagingVariantFragment': PackagingVariantFragment } }> | null } & { ' $fragmentName'?: 'ProductPackagingVariants_Beer_Fragment' };

type ProductPackagingVariants_Cider_Fragment = { packagingVariants?: Array<{ ' $fragmentRefs'?: { 'PackagingVariantFragment': PackagingVariantFragment } }> | null } & { ' $fragmentName'?: 'ProductPackagingVariants_Cider_Fragment' };

type ProductPackagingVariants_Spirit_Fragment = { packagingVariants?: Array<{ ' $fragmentRefs'?: { 'PackagingVariantFragment': PackagingVariantFragment } }> | null } & { ' $fragmentName'?: 'ProductPackagingVariants_Spirit_Fragment' };

type ProductPackagingVariants_Wine_Fragment = { packagingVariants?: Array<{ ' $fragmentRefs'?: { 'PackagingVariantFragment': PackagingVariantFragment } }> | null } & { ' $fragmentName'?: 'ProductPackagingVariants_Wine_Fragment' };

export type ProductPackagingVariantsFragment = ProductPackagingVariants_Beer_Fragment | ProductPackagingVariants_Cider_Fragment | ProductPackagingVariants_Spirit_Fragment | ProductPackagingVariants_Wine_Fragment;

type ProductPairingDescription_Beer_Fragment = { pairingDescription?: string | null } & { ' $fragmentName'?: 'ProductPairingDescription_Beer_Fragment' };

type ProductPairingDescription_Cider_Fragment = { pairingDescription?: string | null } & { ' $fragmentName'?: 'ProductPairingDescription_Cider_Fragment' };

type ProductPairingDescription_Spirit_Fragment = { pairingDescription?: string | null } & { ' $fragmentName'?: 'ProductPairingDescription_Spirit_Fragment' };

type ProductPairingDescription_Wine_Fragment = { pairingDescription?: string | null } & { ' $fragmentName'?: 'ProductPairingDescription_Wine_Fragment' };

export type ProductPairingDescriptionFragment = ProductPairingDescription_Beer_Fragment | ProductPairingDescription_Cider_Fragment | ProductPairingDescription_Spirit_Fragment | ProductPairingDescription_Wine_Fragment;

type ProductPalate_Beer_Fragment = { palateAcidity?: string | null, palateBody?: string | null, palateTannins?: string | null } & { ' $fragmentName'?: 'ProductPalate_Beer_Fragment' };

type ProductPalate_Cider_Fragment = { palateAcidity?: string | null, palateBody?: string | null, palateTannins?: string | null } & { ' $fragmentName'?: 'ProductPalate_Cider_Fragment' };

type ProductPalate_Spirit_Fragment = { palateAcidity?: string | null, palateBody?: string | null, palateTannins?: string | null } & { ' $fragmentName'?: 'ProductPalate_Spirit_Fragment' };

type ProductPalate_Wine_Fragment = { palateAcidity?: string | null, palateBody?: string | null, palateTannins?: string | null } & { ' $fragmentName'?: 'ProductPalate_Wine_Fragment' };

export type ProductPalateFragment = ProductPalate_Beer_Fragment | ProductPalate_Cider_Fragment | ProductPalate_Spirit_Fragment | ProductPalate_Wine_Fragment;

type ProductPalateDescription_Beer_Fragment = { palateDescription?: string | null } & { ' $fragmentName'?: 'ProductPalateDescription_Beer_Fragment' };

type ProductPalateDescription_Cider_Fragment = { palateDescription?: string | null } & { ' $fragmentName'?: 'ProductPalateDescription_Cider_Fragment' };

type ProductPalateDescription_Spirit_Fragment = { palateDescription?: string | null } & { ' $fragmentName'?: 'ProductPalateDescription_Spirit_Fragment' };

type ProductPalateDescription_Wine_Fragment = { palateDescription?: string | null } & { ' $fragmentName'?: 'ProductPalateDescription_Wine_Fragment' };

export type ProductPalateDescriptionFragment = ProductPalateDescription_Beer_Fragment | ProductPalateDescription_Cider_Fragment | ProductPalateDescription_Spirit_Fragment | ProductPalateDescription_Wine_Fragment;

export type ProductPriceFragment = { pricing?: (
    { priceStrategy?: PriceStrategy | null, price?: number | null, priceRange?: string | null }
    & { ' $fragmentRefs'?: { 'ProductPriceExactFragment': ProductPriceExactFragment;'ProductPriceRangeFragment': ProductPriceRangeFragment } }
  ) | null } & { ' $fragmentName'?: 'ProductPriceFragment' };

export type ProductPriceExactFragment = { priceType?: string | null, price?: number | null, currencyCode?: string | null } & { ' $fragmentName'?: 'ProductPriceExactFragment' };

export type ProductPriceRangeFragment = { priceRange?: string | null, publicPriceRangeImage?: { fixed?: { src?: string | null, srcSet?: string | null } | null } | null } & { ' $fragmentName'?: 'ProductPriceRangeFragment' };

type ProductProducerName_Beer_Fragment = { producer?: { name?: string | null } | null } & { ' $fragmentName'?: 'ProductProducerName_Beer_Fragment' };

type ProductProducerName_Cider_Fragment = { producer?: { name?: string | null } | null } & { ' $fragmentName'?: 'ProductProducerName_Cider_Fragment' };

type ProductProducerName_Spirit_Fragment = { producer?: { name?: string | null } | null } & { ' $fragmentName'?: 'ProductProducerName_Spirit_Fragment' };

type ProductProducerName_Wine_Fragment = { producer?: { name?: string | null } | null } & { ' $fragmentName'?: 'ProductProducerName_Wine_Fragment' };

export type ProductProducerNameFragment = ProductProducerName_Beer_Fragment | ProductProducerName_Cider_Fragment | ProductProducerName_Spirit_Fragment | ProductProducerName_Wine_Fragment;

type ProductRange_Beer_Fragment = { productRange?: string | null } & { ' $fragmentName'?: 'ProductRange_Beer_Fragment' };

type ProductRange_Cider_Fragment = { productRange?: string | null } & { ' $fragmentName'?: 'ProductRange_Cider_Fragment' };

type ProductRange_Spirit_Fragment = { productRange?: string | null } & { ' $fragmentName'?: 'ProductRange_Spirit_Fragment' };

type ProductRange_Wine_Fragment = { rangeDescription?: string | null, productRange?: string | null } & { ' $fragmentName'?: 'ProductRange_Wine_Fragment' };

export type ProductRangeFragment = ProductRange_Beer_Fragment | ProductRange_Cider_Fragment | ProductRange_Spirit_Fragment | ProductRange_Wine_Fragment;

type ProductRegion_Beer_Fragment = { denomination?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'ProductRegion_Beer_Fragment' };

type ProductRegion_Cider_Fragment = { denomination?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'ProductRegion_Cider_Fragment' };

type ProductRegion_Spirit_Fragment = { denomination?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'ProductRegion_Spirit_Fragment' };

type ProductRegion_Wine_Fragment = { denomination?: string | null, countryName?: string | null, countryCode?: string | null } & { ' $fragmentName'?: 'ProductRegion_Wine_Fragment' };

export type ProductRegionFragment = ProductRegion_Beer_Fragment | ProductRegion_Cider_Fragment | ProductRegion_Spirit_Fragment | ProductRegion_Wine_Fragment;

type ProductSensory_Beer_Fragment = { ' $fragmentRefs'?: { 'ProductColor_Beer_Fragment': ProductColor_Beer_Fragment;'ProductAromas_Beer_Fragment': ProductAromas_Beer_Fragment;'ProductPalate_Beer_Fragment': ProductPalate_Beer_Fragment } } & { ' $fragmentName'?: 'ProductSensory_Beer_Fragment' };

type ProductSensory_Cider_Fragment = { ' $fragmentRefs'?: { 'ProductColor_Cider_Fragment': ProductColor_Cider_Fragment;'ProductAromas_Cider_Fragment': ProductAromas_Cider_Fragment;'ProductPalate_Cider_Fragment': ProductPalate_Cider_Fragment } } & { ' $fragmentName'?: 'ProductSensory_Cider_Fragment' };

type ProductSensory_Spirit_Fragment = { ' $fragmentRefs'?: { 'ProductColor_Spirit_Fragment': ProductColor_Spirit_Fragment;'ProductAromas_Spirit_Fragment': ProductAromas_Spirit_Fragment;'ProductPalate_Spirit_Fragment': ProductPalate_Spirit_Fragment } } & { ' $fragmentName'?: 'ProductSensory_Spirit_Fragment' };

type ProductSensory_Wine_Fragment = { ' $fragmentRefs'?: { 'ProductColor_Wine_Fragment': ProductColor_Wine_Fragment;'ProductAromas_Wine_Fragment': ProductAromas_Wine_Fragment;'ProductPalate_Wine_Fragment': ProductPalate_Wine_Fragment } } & { ' $fragmentName'?: 'ProductSensory_Wine_Fragment' };

export type ProductSensoryFragment = ProductSensory_Beer_Fragment | ProductSensory_Cider_Fragment | ProductSensory_Spirit_Fragment | ProductSensory_Wine_Fragment;

export type ProductStandFragment = { profile?: { name?: string | null } | null, stand?: { name: string, standTypeWithNumber?: string | null, roomName?: string | null } | null } & { ' $fragmentName'?: 'ProductStandFragment' };

type ProductTastingNotes_Beer_Fragment = { tastingNotes?: Array<{ noteDate?: string | null, note?: string | null, author?: string | null, publication?: string | null, rating?: string | null }> | null } & { ' $fragmentName'?: 'ProductTastingNotes_Beer_Fragment' };

type ProductTastingNotes_Cider_Fragment = { tastingNotes?: Array<{ noteDate?: string | null, note?: string | null, author?: string | null, publication?: string | null, rating?: string | null }> | null } & { ' $fragmentName'?: 'ProductTastingNotes_Cider_Fragment' };

type ProductTastingNotes_Spirit_Fragment = { tastingNotes?: Array<{ noteDate?: string | null, note?: string | null, author?: string | null, publication?: string | null, rating?: string | null }> | null } & { ' $fragmentName'?: 'ProductTastingNotes_Spirit_Fragment' };

type ProductTastingNotes_Wine_Fragment = { tastingNotes?: Array<{ noteDate?: string | null, note?: string | null, author?: string | null, publication?: string | null, rating?: string | null }> | null } & { ' $fragmentName'?: 'ProductTastingNotes_Wine_Fragment' };

export type ProductTastingNotesFragment = ProductTastingNotes_Beer_Fragment | ProductTastingNotes_Cider_Fragment | ProductTastingNotes_Spirit_Fragment | ProductTastingNotes_Wine_Fragment;

type ProductVarieties_Beer_Fragment = {} & { ' $fragmentName'?: 'ProductVarieties_Beer_Fragment' };

type ProductVarieties_Cider_Fragment = {} & { ' $fragmentName'?: 'ProductVarieties_Cider_Fragment' };

type ProductVarieties_Spirit_Fragment = {} & { ' $fragmentName'?: 'ProductVarieties_Spirit_Fragment' };

type ProductVarieties_Wine_Fragment = { grapeVarieties?: Array<{ varietyName: string }> | null } & { ' $fragmentName'?: 'ProductVarieties_Wine_Fragment' };

export type ProductVarietiesFragment = ProductVarieties_Beer_Fragment | ProductVarieties_Cider_Fragment | ProductVarieties_Spirit_Fragment | ProductVarieties_Wine_Fragment;

type ProductVideos_Beer_Fragment = { videos?: Array<(
    { videoId?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'ProductVideos_Beer_Fragment' };

type ProductVideos_Cider_Fragment = { videos?: Array<(
    { videoId?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'ProductVideos_Cider_Fragment' };

type ProductVideos_Spirit_Fragment = { videos?: Array<(
    { videoId?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'ProductVideos_Spirit_Fragment' };

type ProductVideos_Wine_Fragment = { videos?: Array<(
    { videoId?: string | null }
    & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'ProductVideos_Wine_Fragment' };

export type ProductVideosFragment = ProductVideos_Beer_Fragment | ProductVideos_Cider_Fragment | ProductVideos_Spirit_Fragment | ProductVideos_Wine_Fragment;

export type WineHarvestNotesFragment = { harvestNotes?: string | null } & { ' $fragmentName'?: 'WineHarvestNotesFragment' };

export type WineMaturationFragment = { maturation?: string | null, monthsInBottle?: string | null, oakInfluence?: string | null } & { ' $fragmentName'?: 'WineMaturationFragment' };

export type WineSoilTypeFragment = { soilType?: string | null } & { ' $fragmentName'?: 'WineSoilTypeFragment' };

export type WineVineyardFragment = { vineyard?: string | null, vineyardInformation?: string | null, pruning?: string | null, training?: string | null, vineDensity?: string | null, yield?: string | null, vineyardAge?: string | null, vineyardElevation?: string | null, soilType?: string | null, soilTypes?: Array<{ soilType: string, percentage?: number | null }> | null } & { ' $fragmentName'?: 'WineVineyardFragment' };

export type WineVinificationFragment = { vinification?: string | null, malolacticFermentation?: string | null, fermentationType?: string | null, fermentationVesselTypes?: Array<string> | null, wholeClusterPercent?: string | null } & { ' $fragmentName'?: 'WineVinificationFragment' };

export type WineViticultureFragment = { viticulture?: string | null } & { ' $fragmentName'?: 'WineViticultureFragment' };

type WineWinemaker_Beer_Fragment = { __typename: 'Beer' } & { ' $fragmentName'?: 'WineWinemaker_Beer_Fragment' };

type WineWinemaker_Cider_Fragment = { __typename: 'Cider' } & { ' $fragmentName'?: 'WineWinemaker_Cider_Fragment' };

type WineWinemaker_Spirit_Fragment = { __typename: 'Spirit' } & { ' $fragmentName'?: 'WineWinemaker_Spirit_Fragment' };

type WineWinemaker_Wine_Fragment = { __typename: 'Wine', winemaker?: string | null } & { ' $fragmentName'?: 'WineWinemaker_Wine_Fragment' };

export type WineWinemakerFragment = WineWinemaker_Beer_Fragment | WineWinemaker_Cider_Fragment | WineWinemaker_Spirit_Fragment | WineWinemaker_Wine_Fragment;

type ProductCard_Beer_Fragment = { ' $fragmentRefs'?: { 'ProductImage_Beer_Fragment': ProductImage_Beer_Fragment } } & { ' $fragmentName'?: 'ProductCard_Beer_Fragment' };

type ProductCard_Cider_Fragment = { ' $fragmentRefs'?: { 'ProductImage_Cider_Fragment': ProductImage_Cider_Fragment } } & { ' $fragmentName'?: 'ProductCard_Cider_Fragment' };

type ProductCard_Spirit_Fragment = { ' $fragmentRefs'?: { 'ProductImage_Spirit_Fragment': ProductImage_Spirit_Fragment } } & { ' $fragmentName'?: 'ProductCard_Spirit_Fragment' };

type ProductCard_Wine_Fragment = { ' $fragmentRefs'?: { 'ProductImage_Wine_Fragment': ProductImage_Wine_Fragment } } & { ' $fragmentName'?: 'ProductCard_Wine_Fragment' };

export type ProductCardFragment = ProductCard_Beer_Fragment | ProductCard_Cider_Fragment | ProductCard_Spirit_Fragment | ProductCard_Wine_Fragment;

export type ProductCard_RegisteredProductFragment = (
  { productId: string, producerId?: string | null, exhibitorId: string, registration: (
    { profile?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductStandFragment': ProductStandFragment } }
  ), producer?: { name?: string | null } | null, product: (
    { productId: string }
    & { ' $fragmentRefs'?: { 'ProductName_Beer_Fragment': ProductName_Beer_Fragment;'ProductImage_Beer_Fragment': ProductImage_Beer_Fragment } }
  ) | (
    { productId: string }
    & { ' $fragmentRefs'?: { 'ProductName_Cider_Fragment': ProductName_Cider_Fragment;'ProductImage_Cider_Fragment': ProductImage_Cider_Fragment } }
  ) | (
    { productId: string }
    & { ' $fragmentRefs'?: { 'ProductName_Spirit_Fragment': ProductName_Spirit_Fragment;'ProductImage_Spirit_Fragment': ProductImage_Spirit_Fragment } }
  ) | (
    { productId: string }
    & { ' $fragmentRefs'?: { 'ProductName_Wine_Fragment': ProductName_Wine_Fragment;'ProductImage_Wine_Fragment': ProductImage_Wine_Fragment } }
  ) }
  & { ' $fragmentRefs'?: { 'ProductLabel_RegisteredProductFragment': ProductLabel_RegisteredProductFragment;'ProductHeaderDetails_RegisteredProductFragment': ProductHeaderDetails_RegisteredProductFragment;'ProductHeaderDetailsFragment': ProductHeaderDetailsFragment } }
) & { ' $fragmentName'?: 'ProductCard_RegisteredProductFragment' };

type OldVineProjectVineyardFields_Beer_Fragment = { __typename: 'Beer', plantDates?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue', values?: Array<{ value?: string | null }> | null } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, uniqueStoryOverview?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, howAreTheseVineyardsTrellised?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue', values?: Array<{ value?: string | null }> | null } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, areTheseVineyardsIrrigated?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue', value?: string | null } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, plantDatesPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, hectaresPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, interplantingPercentage?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, tonnagePerHectarePerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, rootstockPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null } & { ' $fragmentName'?: 'OldVineProjectVineyardFields_Beer_Fragment' };

type OldVineProjectVineyardFields_Cider_Fragment = { __typename: 'Cider', plantDates?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue', values?: Array<{ value?: string | null }> | null } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, uniqueStoryOverview?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, howAreTheseVineyardsTrellised?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue', values?: Array<{ value?: string | null }> | null } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, areTheseVineyardsIrrigated?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue', value?: string | null } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, plantDatesPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, hectaresPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, interplantingPercentage?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, tonnagePerHectarePerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, rootstockPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null } & { ' $fragmentName'?: 'OldVineProjectVineyardFields_Cider_Fragment' };

type OldVineProjectVineyardFields_Spirit_Fragment = { __typename: 'Spirit', plantDates?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue', values?: Array<{ value?: string | null }> | null } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, uniqueStoryOverview?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, howAreTheseVineyardsTrellised?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue', values?: Array<{ value?: string | null }> | null } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, areTheseVineyardsIrrigated?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue', value?: string | null } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, plantDatesPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, hectaresPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, interplantingPercentage?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, tonnagePerHectarePerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, rootstockPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null } & { ' $fragmentName'?: 'OldVineProjectVineyardFields_Spirit_Fragment' };

type OldVineProjectVineyardFields_Wine_Fragment = { __typename: 'Wine', vineyardElevation?: string | null, plantDates?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue', values?: Array<{ value?: string | null }> | null } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, uniqueStoryOverview?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, howAreTheseVineyardsTrellised?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue', values?: Array<{ value?: string | null }> | null } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, areTheseVineyardsIrrigated?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue', value?: string | null } | { __typename: 'TextFieldValue' } | { __typename: 'YesNoFieldValue' } | null, plantDatesPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, hectaresPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, interplantingPercentage?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, tonnagePerHectarePerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null, rootstockPerVarietal?: { __typename: 'ChangeoverFieldValue' } | { __typename: 'DateFieldValue' } | { __typename: 'FloatFieldValue' } | { __typename: 'ImageFieldValue' } | { __typename: 'IntFieldValue' } | { __typename: 'MultiSelectFieldValue' } | { __typename: 'SelectFieldValue' } | { __typename: 'TextFieldValue', value?: string | null } | { __typename: 'YesNoFieldValue' } | null } & { ' $fragmentName'?: 'OldVineProjectVineyardFields_Wine_Fragment' };

export type OldVineProjectVineyardFieldsFragment = OldVineProjectVineyardFields_Beer_Fragment | OldVineProjectVineyardFields_Cider_Fragment | OldVineProjectVineyardFields_Spirit_Fragment | OldVineProjectVineyardFields_Wine_Fragment;

type ProductDetailsSection_Beer_Fragment = { ' $fragmentRefs'?: { 'ProductDescription_Beer_Fragment': ProductDescription_Beer_Fragment;'ProductAwards_Beer_Fragment': ProductAwards_Beer_Fragment;'ProductTastingNotes_Beer_Fragment': ProductTastingNotes_Beer_Fragment;'ProductCertifications_Beer_Fragment': ProductCertifications_Beer_Fragment;'ProductAnalytics_Beer_Fragment': ProductAnalytics_Beer_Fragment;'ProductGallery_Beer_Fragment': ProductGallery_Beer_Fragment;'ProductVideos_Beer_Fragment': ProductVideos_Beer_Fragment;'ProductRange_Beer_Fragment': ProductRange_Beer_Fragment;'WineWinemaker_Beer_Fragment': WineWinemaker_Beer_Fragment;'OldVineProjectVineyardFields_Beer_Fragment': OldVineProjectVineyardFields_Beer_Fragment;'ProductPalateDescription_Beer_Fragment': ProductPalateDescription_Beer_Fragment;'ProductPairingDescription_Beer_Fragment': ProductPairingDescription_Beer_Fragment;'ProductBottleVariants_Beer_Fragment': ProductBottleVariants_Beer_Fragment;'ProductPackagingVariants_Beer_Fragment': ProductPackagingVariants_Beer_Fragment;'ProductSensory_Beer_Fragment': ProductSensory_Beer_Fragment } } & { ' $fragmentName'?: 'ProductDetailsSection_Beer_Fragment' };

type ProductDetailsSection_Cider_Fragment = { ' $fragmentRefs'?: { 'ProductDescription_Cider_Fragment': ProductDescription_Cider_Fragment;'ProductAwards_Cider_Fragment': ProductAwards_Cider_Fragment;'ProductTastingNotes_Cider_Fragment': ProductTastingNotes_Cider_Fragment;'ProductCertifications_Cider_Fragment': ProductCertifications_Cider_Fragment;'ProductAnalytics_Cider_Fragment': ProductAnalytics_Cider_Fragment;'ProductGallery_Cider_Fragment': ProductGallery_Cider_Fragment;'ProductVideos_Cider_Fragment': ProductVideos_Cider_Fragment;'ProductRange_Cider_Fragment': ProductRange_Cider_Fragment;'WineWinemaker_Cider_Fragment': WineWinemaker_Cider_Fragment;'OldVineProjectVineyardFields_Cider_Fragment': OldVineProjectVineyardFields_Cider_Fragment;'ProductPalateDescription_Cider_Fragment': ProductPalateDescription_Cider_Fragment;'ProductPairingDescription_Cider_Fragment': ProductPairingDescription_Cider_Fragment;'ProductBottleVariants_Cider_Fragment': ProductBottleVariants_Cider_Fragment;'ProductPackagingVariants_Cider_Fragment': ProductPackagingVariants_Cider_Fragment;'ProductSensory_Cider_Fragment': ProductSensory_Cider_Fragment } } & { ' $fragmentName'?: 'ProductDetailsSection_Cider_Fragment' };

type ProductDetailsSection_Spirit_Fragment = { ' $fragmentRefs'?: { 'ProductDescription_Spirit_Fragment': ProductDescription_Spirit_Fragment;'ProductAwards_Spirit_Fragment': ProductAwards_Spirit_Fragment;'ProductTastingNotes_Spirit_Fragment': ProductTastingNotes_Spirit_Fragment;'ProductCertifications_Spirit_Fragment': ProductCertifications_Spirit_Fragment;'ProductAnalytics_Spirit_Fragment': ProductAnalytics_Spirit_Fragment;'ProductGallery_Spirit_Fragment': ProductGallery_Spirit_Fragment;'ProductVideos_Spirit_Fragment': ProductVideos_Spirit_Fragment;'ProductRange_Spirit_Fragment': ProductRange_Spirit_Fragment;'WineWinemaker_Spirit_Fragment': WineWinemaker_Spirit_Fragment;'OldVineProjectVineyardFields_Spirit_Fragment': OldVineProjectVineyardFields_Spirit_Fragment;'ProductPalateDescription_Spirit_Fragment': ProductPalateDescription_Spirit_Fragment;'ProductPairingDescription_Spirit_Fragment': ProductPairingDescription_Spirit_Fragment;'ProductBottleVariants_Spirit_Fragment': ProductBottleVariants_Spirit_Fragment;'ProductPackagingVariants_Spirit_Fragment': ProductPackagingVariants_Spirit_Fragment;'ProductSensory_Spirit_Fragment': ProductSensory_Spirit_Fragment } } & { ' $fragmentName'?: 'ProductDetailsSection_Spirit_Fragment' };

type ProductDetailsSection_Wine_Fragment = { ' $fragmentRefs'?: { 'ProductDescription_Wine_Fragment': ProductDescription_Wine_Fragment;'ProductAwards_Wine_Fragment': ProductAwards_Wine_Fragment;'ProductTastingNotes_Wine_Fragment': ProductTastingNotes_Wine_Fragment;'ProductCertifications_Wine_Fragment': ProductCertifications_Wine_Fragment;'ProductAnalytics_Wine_Fragment': ProductAnalytics_Wine_Fragment;'ProductGallery_Wine_Fragment': ProductGallery_Wine_Fragment;'ProductVideos_Wine_Fragment': ProductVideos_Wine_Fragment;'ProductRange_Wine_Fragment': ProductRange_Wine_Fragment;'WineWinemaker_Wine_Fragment': WineWinemaker_Wine_Fragment;'WineSoilTypeFragment': WineSoilTypeFragment;'WineVineyardFragment': WineVineyardFragment;'OldVineProjectVineyardFields_Wine_Fragment': OldVineProjectVineyardFields_Wine_Fragment;'WineHarvestNotesFragment': WineHarvestNotesFragment;'WineViticultureFragment': WineViticultureFragment;'WineVinificationFragment': WineVinificationFragment;'WineMaturationFragment': WineMaturationFragment;'ProductPalateDescription_Wine_Fragment': ProductPalateDescription_Wine_Fragment;'ProductPairingDescription_Wine_Fragment': ProductPairingDescription_Wine_Fragment;'ProductBottleVariants_Wine_Fragment': ProductBottleVariants_Wine_Fragment;'ProductPackagingVariants_Wine_Fragment': ProductPackagingVariants_Wine_Fragment;'ProductSensory_Wine_Fragment': ProductSensory_Wine_Fragment } } & { ' $fragmentName'?: 'ProductDetailsSection_Wine_Fragment' };

export type ProductDetailsSectionFragment = ProductDetailsSection_Beer_Fragment | ProductDetailsSection_Cider_Fragment | ProductDetailsSection_Spirit_Fragment | ProductDetailsSection_Wine_Fragment;

export type ProductPageHeaderFragment = (
  { product: { ' $fragmentRefs'?: { 'ProductHeaderProductName_Beer_Fragment': ProductHeaderProductName_Beer_Fragment;'ProductHeaderProducerName_Beer_Fragment': ProductHeaderProducerName_Beer_Fragment } } | { ' $fragmentRefs'?: { 'ProductHeaderProductName_Cider_Fragment': ProductHeaderProductName_Cider_Fragment;'ProductHeaderProducerName_Cider_Fragment': ProductHeaderProducerName_Cider_Fragment } } | { ' $fragmentRefs'?: { 'ProductHeaderProductName_Spirit_Fragment': ProductHeaderProductName_Spirit_Fragment;'ProductHeaderProducerName_Spirit_Fragment': ProductHeaderProducerName_Spirit_Fragment } } | { ' $fragmentRefs'?: { 'ProductHeaderProductName_Wine_Fragment': ProductHeaderProductName_Wine_Fragment;'ProductHeaderProducerName_Wine_Fragment': ProductHeaderProducerName_Wine_Fragment } } }
  & { ' $fragmentRefs'?: { 'ProductHeaderDetailsFragment': ProductHeaderDetailsFragment } }
) & { ' $fragmentName'?: 'ProductPageHeaderFragment' };

export type ProductSections_RegisteredProductFragment = { productId: string, registration: { ' $fragmentRefs'?: { 'RegistrationContactsFragment': RegistrationContactsFragment } }, product: { ' $fragmentRefs'?: { 'ProductDetailsSection_Beer_Fragment': ProductDetailsSection_Beer_Fragment } } | { ' $fragmentRefs'?: { 'ProductDetailsSection_Cider_Fragment': ProductDetailsSection_Cider_Fragment } } | { ' $fragmentRefs'?: { 'ProductDetailsSection_Spirit_Fragment': ProductDetailsSection_Spirit_Fragment } } | { ' $fragmentRefs'?: { 'ProductDetailsSection_Wine_Fragment': ProductDetailsSection_Wine_Fragment } } } & { ' $fragmentName'?: 'ProductSections_RegisteredProductFragment' };

export type RelatedProductsSectionFragment = (
  { productId: string }
  & { ' $fragmentRefs'?: { 'RelatedProductFragment': RelatedProductFragment } }
) & { ' $fragmentName'?: 'RelatedProductsSectionFragment' };

type GroupedProductsCard_Beer_Fragment = (
  { producer?: { ' $fragmentRefs'?: { 'BrandLogo_Producer_Fragment': BrandLogo_Producer_Fragment } } | null }
  & { ' $fragmentRefs'?: { 'ProductCard_Beer_Fragment': ProductCard_Beer_Fragment } }
) & { ' $fragmentName'?: 'GroupedProductsCard_Beer_Fragment' };

type GroupedProductsCard_Cider_Fragment = (
  { producer?: { ' $fragmentRefs'?: { 'BrandLogo_Producer_Fragment': BrandLogo_Producer_Fragment } } | null }
  & { ' $fragmentRefs'?: { 'ProductCard_Cider_Fragment': ProductCard_Cider_Fragment } }
) & { ' $fragmentName'?: 'GroupedProductsCard_Cider_Fragment' };

type GroupedProductsCard_Spirit_Fragment = (
  { producer?: { ' $fragmentRefs'?: { 'BrandLogo_Producer_Fragment': BrandLogo_Producer_Fragment } } | null }
  & { ' $fragmentRefs'?: { 'ProductCard_Spirit_Fragment': ProductCard_Spirit_Fragment } }
) & { ' $fragmentName'?: 'GroupedProductsCard_Spirit_Fragment' };

type GroupedProductsCard_Wine_Fragment = (
  { producer?: { ' $fragmentRefs'?: { 'BrandLogo_Producer_Fragment': BrandLogo_Producer_Fragment } } | null }
  & { ' $fragmentRefs'?: { 'ProductCard_Wine_Fragment': ProductCard_Wine_Fragment } }
) & { ' $fragmentName'?: 'GroupedProductsCard_Wine_Fragment' };

export type GroupedProductsCardFragment = GroupedProductsCard_Beer_Fragment | GroupedProductsCard_Cider_Fragment | GroupedProductsCard_Spirit_Fragment | GroupedProductsCard_Wine_Fragment;

export type ProductListRowFragment = { ' $fragmentRefs'?: { 'ProductHeaderDetails_RegisteredProductFragment': ProductHeaderDetails_RegisteredProductFragment } } & { ' $fragmentName'?: 'ProductListRowFragment' };

export type ProductsPageBaseFragment = (
  { registration: { registrationId: string, companyId: string, stand?: { name: string } | null, profile?: { sortName?: string | null, name?: string | null } | null }, product: (
    { productId: string }
    & { ' $fragmentRefs'?: { 'GroupedProductsCard_Beer_Fragment': GroupedProductsCard_Beer_Fragment } }
  ) | (
    { productId: string }
    & { ' $fragmentRefs'?: { 'GroupedProductsCard_Cider_Fragment': GroupedProductsCard_Cider_Fragment } }
  ) | (
    { productId: string }
    & { ' $fragmentRefs'?: { 'GroupedProductsCard_Spirit_Fragment': GroupedProductsCard_Spirit_Fragment } }
  ) | (
    { productId: string }
    & { ' $fragmentRefs'?: { 'GroupedProductsCard_Wine_Fragment': GroupedProductsCard_Wine_Fragment } }
  ) }
  & { ' $fragmentRefs'?: { 'ProductCard_RegisteredProductFragment': ProductCard_RegisteredProductFragment } }
) & { ' $fragmentName'?: 'ProductsPageBaseFragment' };

type ProductsPageBase_Collection_Event_Fragment = (
  { isProductSortingEnabled: boolean }
  & { ' $fragmentRefs'?: { 'ProductFilters_EventFragment': ProductFilters_EventFragment } }
) & { ' $fragmentName'?: 'ProductsPageBase_Collection_Event_Fragment' };

type ProductsPageBase_Collection_EventGroup_Fragment = { isProductSortingEnabled: boolean } & { ' $fragmentName'?: 'ProductsPageBase_Collection_EventGroup_Fragment' };

type ProductsPageBase_Collection_Group_Fragment = { isProductSortingEnabled: boolean } & { ' $fragmentName'?: 'ProductsPageBase_Collection_Group_Fragment' };

type ProductsPageBase_Collection_ProductList_Fragment = { isProductSortingEnabled: boolean } & { ' $fragmentName'?: 'ProductsPageBase_Collection_ProductList_Fragment' };

type ProductsPageBase_Collection_ShareList_Fragment = { isProductSortingEnabled: boolean } & { ' $fragmentName'?: 'ProductsPageBase_Collection_ShareList_Fragment' };

export type ProductsPageBase_CollectionFragment = ProductsPageBase_Collection_Event_Fragment | ProductsPageBase_Collection_EventGroup_Fragment | ProductsPageBase_Collection_Group_Fragment | ProductsPageBase_Collection_ProductList_Fragment | ProductsPageBase_Collection_ShareList_Fragment;

type FieldValue_ChangeoverFieldValue_Fragment = { month?: string | null } & { ' $fragmentName'?: 'FieldValue_ChangeoverFieldValue_Fragment' };

type FieldValue_DateFieldValue_Fragment = {} & { ' $fragmentName'?: 'FieldValue_DateFieldValue_Fragment' };

type FieldValue_FloatFieldValue_Fragment = { number?: number | null } & { ' $fragmentName'?: 'FieldValue_FloatFieldValue_Fragment' };

type FieldValue_ImageFieldValue_Fragment = {} & { ' $fragmentName'?: 'FieldValue_ImageFieldValue_Fragment' };

type FieldValue_IntFieldValue_Fragment = { integer?: number | null } & { ' $fragmentName'?: 'FieldValue_IntFieldValue_Fragment' };

type FieldValue_MultiSelectFieldValue_Fragment = { values?: Array<string> | null } & { ' $fragmentName'?: 'FieldValue_MultiSelectFieldValue_Fragment' };

type FieldValue_SelectFieldValue_Fragment = { text?: string | null } & { ' $fragmentName'?: 'FieldValue_SelectFieldValue_Fragment' };

type FieldValue_TextFieldValue_Fragment = { text?: string | null } & { ' $fragmentName'?: 'FieldValue_TextFieldValue_Fragment' };

type FieldValue_YesNoFieldValue_Fragment = { value?: boolean | null, rawText?: string | null } & { ' $fragmentName'?: 'FieldValue_YesNoFieldValue_Fragment' };

export type FieldValueFragment = FieldValue_ChangeoverFieldValue_Fragment | FieldValue_DateFieldValue_Fragment | FieldValue_FloatFieldValue_Fragment | FieldValue_ImageFieldValue_Fragment | FieldValue_IntFieldValue_Fragment | FieldValue_MultiSelectFieldValue_Fragment | FieldValue_SelectFieldValue_Fragment | FieldValue_TextFieldValue_Fragment | FieldValue_YesNoFieldValue_Fragment;

export type ProductFiltersFragment = { sortIndex?: number | null, flightName?: string | null, productId: string, exhibitorId: string, registration: (
    { registrationId: string, profile?: { sortName?: string | null, name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductStandFragment': ProductStandFragment } }
  ), pricing?: { priceType?: string | null, price?: number | null, priceStrategy?: PriceStrategy | null, priceRange?: string | null, currencyCode?: string | null } | null, product: { name?: string | null, shortName: string, productType: ProductType, regionHierarchy?: Array<string> | null, producer?: { producerId: string, sortName?: string | null, name?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } | null, bottleImage?: { publicId?: string | null } | null } | { name?: string | null, shortName: string, productType: ProductType, regionHierarchy?: Array<string> | null, producer?: { producerId: string, sortName?: string | null, name?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } | null, bottleImage?: { publicId?: string | null } | null } | { spiritType?: string | null, name?: string | null, shortName: string, productType: ProductType, regionHierarchy?: Array<string> | null, producer?: { producerId: string, sortName?: string | null, name?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } | null, bottleImage?: { publicId?: string | null } | null } | { wineType?: string | null, characteristics?: Array<ProductCharacteristicEnum | null> | null, classification?: string | null, vintage?: string | null, denomination?: string | null, name?: string | null, shortName: string, productType: ProductType, regionHierarchy?: Array<string> | null, countryName?: string | null, countryCode?: string | null, grapeVarieties?: Array<{ varietyName: string }> | null, producer?: { producerId: string, sortName?: string | null, name?: string | null, city?: string | null, countryName?: string | null, countryCode?: string | null } | null, bottleImage?: { publicId?: string | null } | null } } & { ' $fragmentName'?: 'ProductFiltersFragment' };

type Search_Product_Beer_Fragment = { regionName?: string | null, shortName: string, producer?: { name?: string | null } | null } & { ' $fragmentName'?: 'Search_Product_Beer_Fragment' };

type Search_Product_Cider_Fragment = { regionName?: string | null, shortName: string, producer?: { name?: string | null } | null } & { ' $fragmentName'?: 'Search_Product_Cider_Fragment' };

type Search_Product_Spirit_Fragment = { regionName?: string | null, shortName: string, producer?: { name?: string | null } | null } & { ' $fragmentName'?: 'Search_Product_Spirit_Fragment' };

type Search_Product_Wine_Fragment = { classification?: string | null, specialClassification?: string | null, vintage?: string | null, regionName?: string | null, shortName: string, grapeVarieties?: Array<{ varietyName: string }> | null, producer?: { name?: string | null } | null } & { ' $fragmentName'?: 'Search_Product_Wine_Fragment' };

export type Search_ProductFragment = Search_Product_Beer_Fragment | Search_Product_Cider_Fragment | Search_Product_Spirit_Fragment | Search_Product_Wine_Fragment;

export type RelatedProductFragment = { product: (
    { bottleImage?: { ' $fragmentRefs'?: { 'ImageFragment': ImageFragment } } | null }
    & { ' $fragmentRefs'?: { 'ProductName_Beer_Fragment': ProductName_Beer_Fragment } }
  ) | (
    { bottleImage?: { ' $fragmentRefs'?: { 'ImageFragment': ImageFragment } } | null }
    & { ' $fragmentRefs'?: { 'ProductName_Cider_Fragment': ProductName_Cider_Fragment } }
  ) | (
    { bottleImage?: { ' $fragmentRefs'?: { 'ImageFragment': ImageFragment } } | null }
    & { ' $fragmentRefs'?: { 'ProductName_Spirit_Fragment': ProductName_Spirit_Fragment } }
  ) | (
    { bottleImage?: { ' $fragmentRefs'?: { 'ImageFragment': ImageFragment } } | null }
    & { ' $fragmentRefs'?: { 'ProductName_Wine_Fragment': ProductName_Wine_Fragment } }
  ) } & { ' $fragmentName'?: 'RelatedProductFragment' };

type UseEventData_Event_Fragment = (
  { collectionId: string, registrations: { nodes: Array<{ ' $fragmentRefs'?: { 'ToExhibitorFragment': ToExhibitorFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ToProductFragment': ToProductFragment } }> } }
  & { ' $fragmentRefs'?: { 'SiteSearch_Event_Fragment': SiteSearch_Event_Fragment } }
) & { ' $fragmentName'?: 'UseEventData_Event_Fragment' };

type UseEventData_EventGroup_Fragment = (
  { collectionId: string, registrations: { nodes: Array<{}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ToExhibitorFragment': ToExhibitorFragment } } | {}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ToExhibitorFragment': ToExhibitorFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ToProductFragment': ToProductFragment } }> } }
  & { ' $fragmentRefs'?: { 'SiteSearch_EventGroup_Fragment': SiteSearch_EventGroup_Fragment } }
) & { ' $fragmentName'?: 'UseEventData_EventGroup_Fragment' };

type UseEventData_Group_Fragment = (
  { collectionId: string, registrations: { nodes: Array<{}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ToExhibitorFragment': ToExhibitorFragment } } | {}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ToExhibitorFragment': ToExhibitorFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ToProductFragment': ToProductFragment } }> } }
  & { ' $fragmentRefs'?: { 'SiteSearch_Group_Fragment': SiteSearch_Group_Fragment } }
) & { ' $fragmentName'?: 'UseEventData_Group_Fragment' };

type UseEventData_ProductList_Fragment = (
  { collectionId: string, registrations: { nodes: Array<{}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ToExhibitorFragment': ToExhibitorFragment } } | {}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ToExhibitorFragment': ToExhibitorFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ToProductFragment': ToProductFragment } }> } }
  & { ' $fragmentRefs'?: { 'SiteSearch_ProductList_Fragment': SiteSearch_ProductList_Fragment } }
) & { ' $fragmentName'?: 'UseEventData_ProductList_Fragment' };

type UseEventData_ShareList_Fragment = (
  { collectionId: string, registrations: { nodes: Array<{}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ToExhibitorFragment': ToExhibitorFragment } } | {}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ToExhibitorFragment': ToExhibitorFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ToProductFragment': ToProductFragment } }> } }
  & { ' $fragmentRefs'?: { 'SiteSearch_ShareList_Fragment': SiteSearch_ShareList_Fragment } }
) & { ' $fragmentName'?: 'UseEventData_ShareList_Fragment' };

export type UseEventDataFragment = UseEventData_Event_Fragment | UseEventData_EventGroup_Fragment | UseEventData_Group_Fragment | UseEventData_ProductList_Fragment | UseEventData_ShareList_Fragment;

export type ToExhibitorFragment = { registrationId: string, exhibitorId: string, profile?: (
    { name?: string | null, stateProvince?: string | null, region?: string | null, city?: string | null, countryCode?: string | null }
    & { ' $fragmentRefs'?: { 'BrandLogoLarge_RegistrationProfile_Fragment': BrandLogoLarge_RegistrationProfile_Fragment } }
  ) | null } & { ' $fragmentName'?: 'ToExhibitorFragment' };

export type ToProductFragment = { productId: string, producerId?: string | null, exhibitorId: string, registration: { stand?: { name: string } | null, profile?: { name?: string | null } | null }, product: (
    { productId: string, shortName: string, region?: string | null, subregion?: string | null, denomination?: string | null, countryName?: string | null, countryCode?: string | null, producer?: { name?: string | null, producerId: string } | null }
    & { ' $fragmentRefs'?: { 'ProductImageLarge_List_Beer_Fragment': ProductImageLarge_List_Beer_Fragment;'Search_Product_Beer_Fragment': Search_Product_Beer_Fragment } }
  ) | (
    { productId: string, shortName: string, region?: string | null, subregion?: string | null, denomination?: string | null, countryName?: string | null, countryCode?: string | null, producer?: { name?: string | null, producerId: string } | null }
    & { ' $fragmentRefs'?: { 'ProductImageLarge_List_Cider_Fragment': ProductImageLarge_List_Cider_Fragment;'Search_Product_Cider_Fragment': Search_Product_Cider_Fragment } }
  ) | (
    { productId: string, shortName: string, region?: string | null, subregion?: string | null, denomination?: string | null, countryName?: string | null, countryCode?: string | null, producer?: { name?: string | null, producerId: string } | null }
    & { ' $fragmentRefs'?: { 'ProductImageLarge_List_Spirit_Fragment': ProductImageLarge_List_Spirit_Fragment;'Search_Product_Spirit_Fragment': Search_Product_Spirit_Fragment } }
  ) | (
    { productId: string, shortName: string, region?: string | null, subregion?: string | null, denomination?: string | null, countryName?: string | null, countryCode?: string | null, producer?: { name?: string | null, producerId: string } | null }
    & { ' $fragmentRefs'?: { 'ProductImageLarge_List_Wine_Fragment': ProductImageLarge_List_Wine_Fragment;'Search_Product_Wine_Fragment': Search_Product_Wine_Fragment } }
  ) } & { ' $fragmentName'?: 'ToProductFragment' };

export type ExhibitorListRowSmallFragment = { stand?: { name: string } | null, profile?: (
    { name?: string | null, region?: string | null, city?: string | null, countryName?: string | null }
    & { ' $fragmentRefs'?: { 'BrandLogo_RegistrationProfile_Fragment': BrandLogo_RegistrationProfile_Fragment } }
  ) | null } & { ' $fragmentName'?: 'ExhibitorListRowSmallFragment' };

export type ProductListRowSmallFragment = { productId: string, registration: { profile?: { name?: string | null } | null }, product: (
    { __typename: 'Beer', shortName: string, producer?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductImageLarge_List_Beer_Fragment': ProductImageLarge_List_Beer_Fragment } }
  ) | (
    { __typename: 'Cider', shortName: string, producer?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductImageLarge_List_Cider_Fragment': ProductImageLarge_List_Cider_Fragment } }
  ) | (
    { __typename: 'Spirit', shortName: string, producer?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductImageLarge_List_Spirit_Fragment': ProductImageLarge_List_Spirit_Fragment } }
  ) | (
    { __typename: 'Wine', vintage?: string | null, shortName: string, producer?: { name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ProductImageLarge_List_Wine_Fragment': ProductImageLarge_List_Wine_Fragment } }
  ) } & { ' $fragmentName'?: 'ProductListRowSmallFragment' };

export type ExhibitorSearchResultsFragment = (
  { exhibitorId: string }
  & { ' $fragmentRefs'?: { 'ExhibitorListRowSmallFragment': ExhibitorListRowSmallFragment } }
) & { ' $fragmentName'?: 'ExhibitorSearchResultsFragment' };

export type ProductSearchResultsFragment = (
  { productId: string, exhibitorId: string }
  & { ' $fragmentRefs'?: { 'ProductListRowSmallFragment': ProductListRowSmallFragment } }
) & { ' $fragmentName'?: 'ProductSearchResultsFragment' };

type SiteSearch_Event_Fragment = (
  { registrations: { nodes: Array<{ ' $fragmentRefs'?: { 'ExhibitorSearchResultsFragment': ExhibitorSearchResultsFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductSearchResultsFragment': ProductSearchResultsFragment } }> } }
  & { ' $fragmentRefs'?: { 'UseSiteSearch_Event_Fragment': UseSiteSearch_Event_Fragment } }
) & { ' $fragmentName'?: 'SiteSearch_Event_Fragment' };

type SiteSearch_EventGroup_Fragment = (
  { registrations: { nodes: Array<{}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ExhibitorSearchResultsFragment': ExhibitorSearchResultsFragment } } | {}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ExhibitorSearchResultsFragment': ExhibitorSearchResultsFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductSearchResultsFragment': ProductSearchResultsFragment } }> } }
  & { ' $fragmentRefs'?: { 'UseSiteSearch_EventGroup_Fragment': UseSiteSearch_EventGroup_Fragment } }
) & { ' $fragmentName'?: 'SiteSearch_EventGroup_Fragment' };

type SiteSearch_Group_Fragment = (
  { registrations: { nodes: Array<{}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ExhibitorSearchResultsFragment': ExhibitorSearchResultsFragment } } | {}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ExhibitorSearchResultsFragment': ExhibitorSearchResultsFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductSearchResultsFragment': ProductSearchResultsFragment } }> } }
  & { ' $fragmentRefs'?: { 'UseSiteSearch_Group_Fragment': UseSiteSearch_Group_Fragment } }
) & { ' $fragmentName'?: 'SiteSearch_Group_Fragment' };

type SiteSearch_ProductList_Fragment = (
  { registrations: { nodes: Array<{}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ExhibitorSearchResultsFragment': ExhibitorSearchResultsFragment } } | {}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ExhibitorSearchResultsFragment': ExhibitorSearchResultsFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductSearchResultsFragment': ProductSearchResultsFragment } }> } }
  & { ' $fragmentRefs'?: { 'UseSiteSearch_ProductList_Fragment': UseSiteSearch_ProductList_Fragment } }
) & { ' $fragmentName'?: 'SiteSearch_ProductList_Fragment' };

type SiteSearch_ShareList_Fragment = (
  { registrations: { nodes: Array<{}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ExhibitorSearchResultsFragment': ExhibitorSearchResultsFragment } } | {}> } | { nodes: Array<{ ' $fragmentRefs'?: { 'ExhibitorSearchResultsFragment': ExhibitorSearchResultsFragment } }> }, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductSearchResultsFragment': ProductSearchResultsFragment } }> } }
  & { ' $fragmentRefs'?: { 'UseSiteSearch_ShareList_Fragment': UseSiteSearch_ShareList_Fragment } }
) & { ' $fragmentName'?: 'SiteSearch_ShareList_Fragment' };

export type SiteSearchFragment = SiteSearch_Event_Fragment | SiteSearch_EventGroup_Fragment | SiteSearch_Group_Fragment | SiteSearch_ProductList_Fragment | SiteSearch_ShareList_Fragment;

type UseSiteSearch_Event_Fragment = { registrations: { nodes: Array<(
      { __typename: 'SingleRegistration', companyId: string, profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'Search_ExhibitorFragment': Search_ExhibitorFragment } }
    )> }, registeredProducts: { nodes: Array<{ companyId: string, productId: string, product: (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Beer_Fragment': Search_Product_Beer_Fragment;'ProductImageLarge_List_Beer_Fragment': ProductImageLarge_List_Beer_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Cider_Fragment': Search_Product_Cider_Fragment;'ProductImageLarge_List_Cider_Fragment': ProductImageLarge_List_Cider_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Spirit_Fragment': Search_Product_Spirit_Fragment;'ProductImageLarge_List_Spirit_Fragment': ProductImageLarge_List_Spirit_Fragment } }
      ) | (
        { vintage?: string | null, shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Wine_Fragment': Search_Product_Wine_Fragment;'ProductImageLarge_List_Wine_Fragment': ProductImageLarge_List_Wine_Fragment } }
      ) }> } } & { ' $fragmentName'?: 'UseSiteSearch_Event_Fragment' };

type UseSiteSearch_EventGroup_Fragment = { registrations: { nodes: Array<{ __typename: 'GroupedRegistration', companyId: string }> } | { nodes: Array<{ __typename: 'GroupedRegistration', companyId: string } | (
      { __typename: 'SingleRegistration', companyId: string, profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'Search_ExhibitorFragment': Search_ExhibitorFragment } }
    )> } | { nodes: Array<(
      { __typename: 'SingleRegistration', companyId: string, profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'Search_ExhibitorFragment': Search_ExhibitorFragment } }
    )> }, registeredProducts: { nodes: Array<{ companyId: string, productId: string, product: (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Beer_Fragment': Search_Product_Beer_Fragment;'ProductImageLarge_List_Beer_Fragment': ProductImageLarge_List_Beer_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Cider_Fragment': Search_Product_Cider_Fragment;'ProductImageLarge_List_Cider_Fragment': ProductImageLarge_List_Cider_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Spirit_Fragment': Search_Product_Spirit_Fragment;'ProductImageLarge_List_Spirit_Fragment': ProductImageLarge_List_Spirit_Fragment } }
      ) | (
        { vintage?: string | null, shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Wine_Fragment': Search_Product_Wine_Fragment;'ProductImageLarge_List_Wine_Fragment': ProductImageLarge_List_Wine_Fragment } }
      ) }> } } & { ' $fragmentName'?: 'UseSiteSearch_EventGroup_Fragment' };

type UseSiteSearch_Group_Fragment = { registrations: { nodes: Array<{ __typename: 'GroupedRegistration', companyId: string }> } | { nodes: Array<{ __typename: 'GroupedRegistration', companyId: string } | (
      { __typename: 'SingleRegistration', companyId: string, profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'Search_ExhibitorFragment': Search_ExhibitorFragment } }
    )> } | { nodes: Array<(
      { __typename: 'SingleRegistration', companyId: string, profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'Search_ExhibitorFragment': Search_ExhibitorFragment } }
    )> }, registeredProducts: { nodes: Array<{ companyId: string, productId: string, product: (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Beer_Fragment': Search_Product_Beer_Fragment;'ProductImageLarge_List_Beer_Fragment': ProductImageLarge_List_Beer_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Cider_Fragment': Search_Product_Cider_Fragment;'ProductImageLarge_List_Cider_Fragment': ProductImageLarge_List_Cider_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Spirit_Fragment': Search_Product_Spirit_Fragment;'ProductImageLarge_List_Spirit_Fragment': ProductImageLarge_List_Spirit_Fragment } }
      ) | (
        { vintage?: string | null, shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Wine_Fragment': Search_Product_Wine_Fragment;'ProductImageLarge_List_Wine_Fragment': ProductImageLarge_List_Wine_Fragment } }
      ) }> } } & { ' $fragmentName'?: 'UseSiteSearch_Group_Fragment' };

type UseSiteSearch_ProductList_Fragment = { registrations: { nodes: Array<{ __typename: 'GroupedRegistration', companyId: string }> } | { nodes: Array<{ __typename: 'GroupedRegistration', companyId: string } | (
      { __typename: 'SingleRegistration', companyId: string, profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'Search_ExhibitorFragment': Search_ExhibitorFragment } }
    )> } | { nodes: Array<(
      { __typename: 'SingleRegistration', companyId: string, profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'Search_ExhibitorFragment': Search_ExhibitorFragment } }
    )> }, registeredProducts: { nodes: Array<{ companyId: string, productId: string, product: (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Beer_Fragment': Search_Product_Beer_Fragment;'ProductImageLarge_List_Beer_Fragment': ProductImageLarge_List_Beer_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Cider_Fragment': Search_Product_Cider_Fragment;'ProductImageLarge_List_Cider_Fragment': ProductImageLarge_List_Cider_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Spirit_Fragment': Search_Product_Spirit_Fragment;'ProductImageLarge_List_Spirit_Fragment': ProductImageLarge_List_Spirit_Fragment } }
      ) | (
        { vintage?: string | null, shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Wine_Fragment': Search_Product_Wine_Fragment;'ProductImageLarge_List_Wine_Fragment': ProductImageLarge_List_Wine_Fragment } }
      ) }> } } & { ' $fragmentName'?: 'UseSiteSearch_ProductList_Fragment' };

type UseSiteSearch_ShareList_Fragment = { registrations: { nodes: Array<{ __typename: 'GroupedRegistration', companyId: string }> } | { nodes: Array<{ __typename: 'GroupedRegistration', companyId: string } | (
      { __typename: 'SingleRegistration', companyId: string, profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'Search_ExhibitorFragment': Search_ExhibitorFragment } }
    )> } | { nodes: Array<(
      { __typename: 'SingleRegistration', companyId: string, profile?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'Search_ExhibitorFragment': Search_ExhibitorFragment } }
    )> }, registeredProducts: { nodes: Array<{ companyId: string, productId: string, product: (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Beer_Fragment': Search_Product_Beer_Fragment;'ProductImageLarge_List_Beer_Fragment': ProductImageLarge_List_Beer_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Cider_Fragment': Search_Product_Cider_Fragment;'ProductImageLarge_List_Cider_Fragment': ProductImageLarge_List_Cider_Fragment } }
      ) | (
        { shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Spirit_Fragment': Search_Product_Spirit_Fragment;'ProductImageLarge_List_Spirit_Fragment': ProductImageLarge_List_Spirit_Fragment } }
      ) | (
        { vintage?: string | null, shortName: string }
        & { ' $fragmentRefs'?: { 'Search_Product_Wine_Fragment': Search_Product_Wine_Fragment;'ProductImageLarge_List_Wine_Fragment': ProductImageLarge_List_Wine_Fragment } }
      ) }> } } & { ' $fragmentName'?: 'UseSiteSearch_ShareList_Fragment' };

export type UseSiteSearchFragment = UseSiteSearch_Event_Fragment | UseSiteSearch_EventGroup_Fragment | UseSiteSearch_Group_Fragment | UseSiteSearch_ProductList_Fragment | UseSiteSearch_ShareList_Fragment;

export type RequestChatButtonDialogFragment = { ' $fragmentRefs'?: { 'RequestChatButtonFormFragment': RequestChatButtonFormFragment } } & { ' $fragmentName'?: 'RequestChatButtonDialogFragment' };

export type RequestChatButtonFormFragment = (
  { uid: string, displayName?: string | null, jobTitle?: string | null, companyName?: string | null, telephone?: string | null, linkedInURL?: string | null, profileImageUrl?: string | null, profileImage?: { url?: string | null, publicId?: string | null, cloudName?: string | null } | null }
  & { ' $fragmentRefs'?: { 'UserProfileCardCompanyFragment': UserProfileCardCompanyFragment } }
) & { ' $fragmentName'?: 'RequestChatButtonFormFragment' };

export type RequestChatButtonFragment = { ' $fragmentRefs'?: { 'RequestChatButtonDialogFragment': RequestChatButtonDialogFragment } } & { ' $fragmentName'?: 'RequestChatButtonFragment' };

export type UserProfileCardAvatarFragment = { displayName?: string | null, profileImage?: { url?: string | null, publicId?: string | null, cloudName?: string | null } | null } & { ' $fragmentName'?: 'UserProfileCardAvatarFragment' };

export type UserProfileCardCompanyFragment = { jobTitle?: string | null, companyName?: string | null, registration?: { companyId: string } | null } & { ' $fragmentName'?: 'UserProfileCardCompanyFragment' };

export type UserProfileCardDisplayNameFragment = { displayName?: string | null } & { ' $fragmentName'?: 'UserProfileCardDisplayNameFragment' };

export type UserProfileCardHorizontalFragment = { ' $fragmentRefs'?: { 'UserProfileCardAvatarFragment': UserProfileCardAvatarFragment;'UserProfileCardDisplayNameFragment': UserProfileCardDisplayNameFragment;'UserProfileCardCompanyFragment': UserProfileCardCompanyFragment;'UserProfileCardLinkedInFragment': UserProfileCardLinkedInFragment;'RequestChatButtonFragment': RequestChatButtonFragment;'RequestMeetingButtonFragment': RequestMeetingButtonFragment } } & { ' $fragmentName'?: 'UserProfileCardHorizontalFragment' };

export type UserProfileCardLinkedInFragment = { linkedInURL?: string | null } & { ' $fragmentName'?: 'UserProfileCardLinkedInFragment' };

export type VideoFragment = { title?: string | null, url?: string | null, type?: VideoType | null, videoId?: string | null } & { ' $fragmentName'?: 'VideoFragment' };

type Seo_Event_Fragment = { name?: string | null, description?: string | null } & { ' $fragmentName'?: 'Seo_Event_Fragment' };

type Seo_EventGroup_Fragment = { name: string, description?: string | null } & { ' $fragmentName'?: 'Seo_EventGroup_Fragment' };

type Seo_Group_Fragment = { name: string, description?: string | null } & { ' $fragmentName'?: 'Seo_Group_Fragment' };

type Seo_ProductList_Fragment = { name?: string | null, description?: string | null } & { ' $fragmentName'?: 'Seo_ProductList_Fragment' };

type Seo_ShareList_Fragment = { name?: string | null, description?: string | null } & { ' $fragmentName'?: 'Seo_ShareList_Fragment' };

export type SeoFragment = Seo_Event_Fragment | Seo_EventGroup_Fragment | Seo_Group_Fragment | Seo_ProductList_Fragment | Seo_ShareList_Fragment;

export type UseLink_Exhibitor_BrandFragment = { exhibitorId: string } & { ' $fragmentName'?: 'UseLink_Exhibitor_BrandFragment' };

type UseLink_Exhibitor_AbstractBrand_Brand_Fragment = { exhibitorId: string } & { ' $fragmentName'?: 'UseLink_Exhibitor_AbstractBrand_Brand_Fragment' };

type UseLink_Exhibitor_AbstractBrand_Exhibitor_Fragment = { exhibitorId: string } & { ' $fragmentName'?: 'UseLink_Exhibitor_AbstractBrand_Exhibitor_Fragment' };

type UseLink_Exhibitor_AbstractBrand_Producer_Fragment = { exhibitorId: string } & { ' $fragmentName'?: 'UseLink_Exhibitor_AbstractBrand_Producer_Fragment' };

export type UseLink_Exhibitor_AbstractBrandFragment = UseLink_Exhibitor_AbstractBrand_Brand_Fragment | UseLink_Exhibitor_AbstractBrand_Exhibitor_Fragment | UseLink_Exhibitor_AbstractBrand_Producer_Fragment;

export type UseLink_ExhibitorFragment = { exhibitorId: string } & { ' $fragmentName'?: 'UseLink_ExhibitorFragment' };

export type UseLink_RegisteredProductFragment = { exhibitorId: string, productId: string } & { ' $fragmentName'?: 'UseLink_RegisteredProductFragment' };

type UseLink_Product_Beer_Fragment = { exhibitorId?: string | null, productId: string } & { ' $fragmentName'?: 'UseLink_Product_Beer_Fragment' };

type UseLink_Product_Cider_Fragment = { exhibitorId?: string | null, productId: string } & { ' $fragmentName'?: 'UseLink_Product_Cider_Fragment' };

type UseLink_Product_Spirit_Fragment = { exhibitorId?: string | null, productId: string } & { ' $fragmentName'?: 'UseLink_Product_Spirit_Fragment' };

type UseLink_Product_Wine_Fragment = { exhibitorId?: string | null, productId: string } & { ' $fragmentName'?: 'UseLink_Product_Wine_Fragment' };

export type UseLink_ProductFragment = UseLink_Product_Beer_Fragment | UseLink_Product_Cider_Fragment | UseLink_Product_Spirit_Fragment | UseLink_Product_Wine_Fragment;

export type UseLink_ProducerFragment = { producerId: string } & { ' $fragmentName'?: 'UseLink_ProducerFragment' };

export type UseLink_RegisteredBrandFragment = { producerId: string } & { ' $fragmentName'?: 'UseLink_RegisteredBrandFragment' };

type ProfilePage_Event_Fragment = { collectionId: string } & { ' $fragmentName'?: 'ProfilePage_Event_Fragment' };

type ProfilePage_EventGroup_Fragment = { collectionId: string } & { ' $fragmentName'?: 'ProfilePage_EventGroup_Fragment' };

type ProfilePage_Group_Fragment = { collectionId: string } & { ' $fragmentName'?: 'ProfilePage_Group_Fragment' };

type ProfilePage_ProductList_Fragment = { collectionId: string } & { ' $fragmentName'?: 'ProfilePage_ProductList_Fragment' };

type ProfilePage_ShareList_Fragment = { collectionId: string } & { ' $fragmentName'?: 'ProfilePage_ShareList_Fragment' };

export type ProfilePageFragment = ProfilePage_Event_Fragment | ProfilePage_EventGroup_Fragment | ProfilePage_Group_Fragment | ProfilePage_ProductList_Fragment | ProfilePage_ShareList_Fragment;

export type UpdateAttendeeProfileMutationVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  input: SiteUserProfileInput;
}>;


export type UpdateAttendeeProfileMutation = { response: { code: string, success: boolean, message: string, profile?: { uid: string, displayName?: string | null, jobTitle?: string | null, companyName?: string | null, profileImageUrl?: string | null } | null } };

export type CmsPageQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type CmsPageQuery = { collection?: { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> } | { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> } | { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> } | { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> } | { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> } | null };

type ThemeFragment_Event_Fragment = (
  { name?: string | null, site?: { menuItems: Array<{ type?: MenuItemType | null, name?: string | null, url?: string | null }> } | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, width?: number | null, height?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'Seo_Event_Fragment': Seo_Event_Fragment } }
) & { ' $fragmentName'?: 'ThemeFragment_Event_Fragment' };

type ThemeFragment_EventGroup_Fragment = (
  { name: string, site?: { menuItems: Array<{ type?: MenuItemType | null, name?: string | null, url?: string | null }> } | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, width?: number | null, height?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'Seo_EventGroup_Fragment': Seo_EventGroup_Fragment } }
) & { ' $fragmentName'?: 'ThemeFragment_EventGroup_Fragment' };

type ThemeFragment_Group_Fragment = (
  { name: string, site?: { menuItems: Array<{ type?: MenuItemType | null, name?: string | null, url?: string | null }> } | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, width?: number | null, height?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'Seo_Group_Fragment': Seo_Group_Fragment } }
) & { ' $fragmentName'?: 'ThemeFragment_Group_Fragment' };

type ThemeFragment_ProductList_Fragment = (
  { name?: string | null, site?: { menuItems: Array<{ type?: MenuItemType | null, name?: string | null, url?: string | null }> } | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, width?: number | null, height?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'Seo_ProductList_Fragment': Seo_ProductList_Fragment } }
) & { ' $fragmentName'?: 'ThemeFragment_ProductList_Fragment' };

type ThemeFragment_ShareList_Fragment = (
  { name?: string | null, site?: { menuItems: Array<{ type?: MenuItemType | null, name?: string | null, url?: string | null }> } | null, logo?: { publicId?: string | null, fixed?: { src?: string | null, srcSet?: string | null, width?: number | null, height?: number | null } | null } | null }
  & { ' $fragmentRefs'?: { 'Seo_ShareList_Fragment': Seo_ShareList_Fragment } }
) & { ' $fragmentName'?: 'ThemeFragment_ShareList_Fragment' };

export type ThemeFragmentFragment = ThemeFragment_Event_Fragment | ThemeFragment_EventGroup_Fragment | ThemeFragment_Group_Fragment | ThemeFragment_ProductList_Fragment | ThemeFragment_ShareList_Fragment;

export type CollectionLayoutQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type CollectionLayoutQuery = { collection?: (
    { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> }
    & { ' $fragmentRefs'?: { 'ThemeFragment_Event_Fragment': ThemeFragment_Event_Fragment } }
  ) | (
    { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> }
    & { ' $fragmentRefs'?: { 'ThemeFragment_EventGroup_Fragment': ThemeFragment_EventGroup_Fragment } }
  ) | (
    { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> }
    & { ' $fragmentRefs'?: { 'ThemeFragment_Group_Fragment': ThemeFragment_Group_Fragment } }
  ) | (
    { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> }
    & { ' $fragmentRefs'?: { 'ThemeFragment_ProductList_Fragment': ThemeFragment_ProductList_Fragment } }
  ) | (
    { collectionId: string, outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> }
    & { ' $fragmentRefs'?: { 'ThemeFragment_ShareList_Fragment': ThemeFragment_ShareList_Fragment } }
  ) | null };

export type CollectionSearchQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type CollectionSearchQuery = { collection?: (
    { collectionId: string }
    & { ' $fragmentRefs'?: { 'UseEventData_Event_Fragment': UseEventData_Event_Fragment } }
  ) | (
    { collectionId: string }
    & { ' $fragmentRefs'?: { 'UseEventData_EventGroup_Fragment': UseEventData_EventGroup_Fragment } }
  ) | (
    { collectionId: string }
    & { ' $fragmentRefs'?: { 'UseEventData_Group_Fragment': UseEventData_Group_Fragment } }
  ) | (
    { collectionId: string }
    & { ' $fragmentRefs'?: { 'UseEventData_ProductList_Fragment': UseEventData_ProductList_Fragment } }
  ) | (
    { collectionId: string }
    & { ' $fragmentRefs'?: { 'UseEventData_ShareList_Fragment': UseEventData_ShareList_Fragment } }
  ) | null };

export type ExhibitorPage_EventFragment = { eventId: string, registrations: { nodes: Array<(
      { __typename: 'SingleRegistration', registrationId: string }
      & { ' $fragmentRefs'?: { 'ExhibitorPage_SingleRegistration_Fragment': ExhibitorPage_SingleRegistration_Fragment } }
    )> } } & { ' $fragmentName'?: 'ExhibitorPage_EventFragment' };

export type ExhibitorPageQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type ExhibitorPageQuery = { collection?: { ' $fragmentRefs'?: { 'ExhibitorPage_EventFragment': ExhibitorPage_EventFragment } } | {} | null };

export type ExhibitorsPage_EventFragment = { registrations: { nodes: Array<(
      { __typename: 'SingleRegistration', registrationId: string, companyId: string }
      & { ' $fragmentRefs'?: { 'ExhibitorDetail_ExhibitorsPageFragment': ExhibitorDetail_ExhibitorsPageFragment } }
    )> }, registeredBrands: { nodes: Array<(
      { partnerId: string }
      & { ' $fragmentRefs'?: { 'ExhibitorFilters_RegisteredBrandFragment': ExhibitorFilters_RegisteredBrandFragment;'ExhibitorsPage_RegisteredBrandFragment': ExhibitorsPage_RegisteredBrandFragment } }
    )> } } & { ' $fragmentName'?: 'ExhibitorsPage_EventFragment' };

export type ExhibitorDetail_ExhibitorsPageFragment = (
  { __typename: 'SingleRegistration', registrationId: string, companyId: string, isHidden?: { ' $fragmentRefs'?: { 'FieldValue_ChangeoverFieldValue_Fragment': FieldValue_ChangeoverFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_DateFieldValue_Fragment': FieldValue_DateFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_FloatFieldValue_Fragment': FieldValue_FloatFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_ImageFieldValue_Fragment': FieldValue_ImageFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_IntFieldValue_Fragment': FieldValue_IntFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_MultiSelectFieldValue_Fragment': FieldValue_MultiSelectFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_SelectFieldValue_Fragment': FieldValue_SelectFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_TextFieldValue_Fragment': FieldValue_TextFieldValue_Fragment } } | { ' $fragmentRefs'?: { 'FieldValue_YesNoFieldValue_Fragment': FieldValue_YesNoFieldValue_Fragment } } | null }
  & { ' $fragmentRefs'?: { 'ExhibitorFiltersFragment': ExhibitorFiltersFragment;'ExhibitorsPage_Registration_SingleRegistration_Fragment': ExhibitorsPage_Registration_SingleRegistration_Fragment } }
) & { ' $fragmentName'?: 'ExhibitorDetail_ExhibitorsPageFragment' };

export type ExhibitorsPageQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type ExhibitorsPageQuery = { event?: (
    { eventId: string }
    & { ' $fragmentRefs'?: { 'ExhibitorsPage_EventFragment': ExhibitorsPage_EventFragment } }
  ) | null };

export type LandingPageQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type LandingPageQuery = { collection?: (
    { outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> }
    & { ' $fragmentRefs'?: { 'LandingPage_EventFragment': LandingPage_EventFragment } }
  ) | { outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> } | { outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> } | { outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> } | { outputConfigurations: Array<{ outputType: CollectionOutputType, vars: Array<{ key: string, value?: string | null }> }> } | null };

export type LandingPage_EventFragment = (
  { registrations: { nodes: Array<{ companyId: string, profile?: { ' $fragmentRefs'?: { 'LandingPage_FeaturedExhibitors_RegistrationProfile_Fragment': LandingPage_FeaturedExhibitors_RegistrationProfile_Fragment } } | null }> } }
  & { ' $fragmentRefs'?: { 'LandingPageFragment': LandingPageFragment } }
) & { ' $fragmentName'?: 'LandingPage_EventFragment' };

export type ListsRouteQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type ListsRouteQuery = { event?: { collectionId: string } | null };

export type Lists_EventFragment = { collectionId: string } & { ' $fragmentName'?: 'Lists_EventFragment' };

export type ProfileRouteQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type ProfileRouteQuery = { event?: { collectionId: string } | null };

export type ProfilePage_EventFragment = { collectionId: string } & { ' $fragmentName'?: 'ProfilePage_EventFragment' };

export type TastingNotesRouteQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type TastingNotesRouteQuery = { event?: { collectionId: string } | null };

export type TastingNotes_EventFragment = { collectionId: string } & { ' $fragmentName'?: 'TastingNotes_EventFragment' };

export type ProducerPage_EventFragment = { eventId: string, registeredBrands: { nodes: Array<(
      { __typename: 'RegisteredBrand', registrationId: string, companyId: string, producerId: string, products: { nodes: Array<{ productId: string, producerId?: string | null, exhibitorId: string }> }, registration: { companyId: string, company?: { name?: string | null } | null }, profile?: (
        { name?: string | null, sortName?: string | null, country?: string | null, region?: string | null, city?: string | null, distributionInCountries?: Array<string> | null, seekingDistributionInCountries?: Array<string> | null, countryName?: string | null, countryCode?: string | null }
        & { ' $fragmentRefs'?: { 'BrandAddressSection_Profile_BrandProfile_Fragment': BrandAddressSection_Profile_BrandProfile_Fragment;'BrandDetailsSection_Profile_BrandProfile_Fragment': BrandDetailsSection_Profile_BrandProfile_Fragment;'BrandLogo_BrandProfile_Fragment': BrandLogo_BrandProfile_Fragment;'BrandHeader_BrandProfile_Fragment': BrandHeader_BrandProfile_Fragment;'BrandBanner_BrandProfile_Fragment': BrandBanner_BrandProfile_Fragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'RegisteredBrand_ProducerPageFragment': RegisteredBrand_ProducerPageFragment } }
    )> } } & { ' $fragmentName'?: 'ProducerPage_EventFragment' };

export type ProducerPageQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  producerId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type ProducerPageQuery = { collection?: { ' $fragmentRefs'?: { 'ProducerPage_EventFragment': ProducerPage_EventFragment } } | {} | null };

export type ProducersPageQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type ProducersPageQuery = { event?: (
    { eventId: string }
    & { ' $fragmentRefs'?: { 'ProducersPage_EventFragment': ProducersPage_EventFragment } }
  ) | null };

export type ProducersPage_EventFragment = { eventId: string, producers: { nodes: Array<(
      { producerId: string }
      & { ' $fragmentRefs'?: { 'ProducersPageFragment': ProducersPageFragment } }
    )> }, registeredBrands: { nodes: Array<(
      { __typename: 'RegisteredBrand', registrationId: string, brandId: string, registration: { ' $fragmentRefs'?: { 'ProducersPage_RegistrationFragment': ProducersPage_RegistrationFragment } } }
      & { ' $fragmentRefs'?: { 'ProducerDetail_ProducersPageFragment': ProducerDetail_ProducersPageFragment } }
    )> } } & { ' $fragmentName'?: 'ProducersPage_EventFragment' };

export type ProducerDetail_ProducersPageFragment = { ' $fragmentRefs'?: { 'ProducersPage_RegisteredBrandFragment': ProducersPage_RegisteredBrandFragment } } & { ' $fragmentName'?: 'ProducerDetail_ProducersPageFragment' };

export type ProductDetailFragment = (
  { exhibitorId: string, producerId?: string | null, productId: string, product: { productId: string, producer?: { name?: string | null, logo?: { publicId?: string | null } | null } | null } | { productId: string, producer?: { name?: string | null, logo?: { publicId?: string | null } | null } | null } | { productId: string, producer?: { name?: string | null, logo?: { publicId?: string | null } | null } | null } | { productId: string, producer?: { name?: string | null, logo?: { publicId?: string | null } | null } | null }, producer?: { profile?: { name?: string | null } | null, products: { nodes: Array<{ productId: string }> } } | null }
  & { ' $fragmentRefs'?: { 'EventProductPage_RegisteredProductFragment': EventProductPage_RegisteredProductFragment } }
) & { ' $fragmentName'?: 'ProductDetailFragment' };

export type ProductPageQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type ProductPageQuery = { collection?: { registrations: { nodes: Array<{ __typename: 'SingleRegistration', registrationId: string, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductDetailFragment': ProductDetailFragment } }> } }> } } | { registrations: { nodes: Array<{ __typename: 'GroupedRegistration', registrationId: string }> } | { nodes: Array<{ __typename: 'GroupedRegistration', registrationId: string } | { __typename: 'SingleRegistration', registrationId: string, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductDetailFragment': ProductDetailFragment } }> } }> } | { nodes: Array<{ __typename: 'SingleRegistration', registrationId: string, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductDetailFragment': ProductDetailFragment } }> } }> } } | { registrations: { nodes: Array<{ __typename: 'GroupedRegistration', registrationId: string }> } | { nodes: Array<{ __typename: 'GroupedRegistration', registrationId: string } | { __typename: 'SingleRegistration', registrationId: string, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductDetailFragment': ProductDetailFragment } }> } }> } | { nodes: Array<{ __typename: 'SingleRegistration', registrationId: string, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductDetailFragment': ProductDetailFragment } }> } }> } } | { registrations: { nodes: Array<{ __typename: 'GroupedRegistration', registrationId: string }> } | { nodes: Array<{ __typename: 'GroupedRegistration', registrationId: string } | { __typename: 'SingleRegistration', registrationId: string, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductDetailFragment': ProductDetailFragment } }> } }> } | { nodes: Array<{ __typename: 'SingleRegistration', registrationId: string, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductDetailFragment': ProductDetailFragment } }> } }> } } | { registrations: { nodes: Array<{ __typename: 'GroupedRegistration', registrationId: string }> } | { nodes: Array<{ __typename: 'GroupedRegistration', registrationId: string } | { __typename: 'SingleRegistration', registrationId: string, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductDetailFragment': ProductDetailFragment } }> } }> } | { nodes: Array<{ __typename: 'SingleRegistration', registrationId: string, registeredProducts: { nodes: Array<{ ' $fragmentRefs'?: { 'ProductDetailFragment': ProductDetailFragment } }> } }> } } | null };

export type ProductsPageFragment = (
  { eventId: string, isProductSortingEnabled: boolean, registeredProducts: { nodes: Array<(
      { productId: string, producerId?: string | null, registration: { stand?: { name: string } | null, profile?: { name?: string | null } | null }, product: { shortName: string, bottleImage?: { publicId?: string | null } | null, producer?: { name?: string | null, logo?: { publicId?: string | null } | null } | null } | { shortName: string, bottleImage?: { publicId?: string | null } | null, producer?: { name?: string | null, logo?: { publicId?: string | null } | null } | null } | { shortName: string, bottleImage?: { publicId?: string | null } | null, producer?: { name?: string | null, logo?: { publicId?: string | null } | null } | null } | { shortName: string, bottleImage?: { publicId?: string | null } | null, producer?: { name?: string | null, logo?: { publicId?: string | null } | null } | null } }
      & { ' $fragmentRefs'?: { 'ProductsPageBaseFragment': ProductsPageBaseFragment;'ProductsPageBaseFragment': ProductsPageBaseFragment;'ProductFiltersFragment': ProductFiltersFragment } }
    )> } }
  & { ' $fragmentRefs'?: { 'ProductsPageBase_Collection_Event_Fragment': ProductsPageBase_Collection_Event_Fragment } }
) & { ' $fragmentName'?: 'ProductsPageFragment' };

export type ProductsPageQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type ProductsPageQuery = { event?: { ' $fragmentRefs'?: { 'ProductsPageFragment': ProductsPageFragment } } | null };

export type WorkspaceCollectionsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  locale?: InputMaybe<ContentLocale>;
}>;


export type WorkspaceCollectionsQuery = { workspace?: { ' $fragmentRefs'?: { 'WorkspaceCollections_WorkspaceFragment': WorkspaceCollections_WorkspaceFragment } } | null };

export type WorkspaceCollections_WorkspaceFragment = { collections: { nodes: Array<{ __typename: 'Event', visibilityStatus: VisibilityStatusType, collectionId: string, name?: string | null, logo?: { publicId?: string | null } | null } | { __typename: 'EventGroup', visibilityStatus: VisibilityStatusType, collectionId: string, name: string, logo?: { publicId?: string | null } | null } | { __typename: 'Group', visibilityStatus: VisibilityStatusType, collectionId: string, name: string, logo?: { publicId?: string | null } | null } | { __typename: 'ProductList', visibilityStatus: VisibilityStatusType, collectionId: string, name?: string | null, logo?: { publicId?: string | null } | null } | { __typename: 'ShareList', visibilityStatus: VisibilityStatusType, collectionId: string, name?: string | null, logo?: { publicId?: string | null } | null }> } } & { ' $fragmentName'?: 'WorkspaceCollections_WorkspaceFragment' };

export type CollectionLocaleQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type CollectionLocaleQuery = { collection?: { collectionId: string, locales: Array<string> } | { collectionId: string, locales: Array<string> } | { collectionId: string, locales: Array<string> } | { collectionId: string, locales: Array<string> } | { collectionId: string, locales: Array<string> } | null };

export type CollectionsListQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type CollectionsListQuery = { workspace?: { collections: { nodes: Array<{ collectionId: string } | { collectionId: string } | { collectionId: string } | { collectionId: string } | { collectionId: string }> } } | null };

export const BrandBanner_BrandProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner_BrandProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BrandProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}}]} as unknown as DocumentNode<BrandBanner_BrandProfileFragment, unknown>;
export const BrandContactFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BrandContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"skypeId"}},{"kind":"Field","name":{"kind":"Name","value":"meetingBookingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"office"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}}]}}]} as unknown as DocumentNode<BrandContactFragment, unknown>;
export const CollectionLayoutProviderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionLayoutProvider"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","alias":{"kind":"Name","value":"outputConfigurations"},"name":{"kind":"Name","value":"_unstable_allOutputConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experimentalKey"},"value":{"kind":"StringValue","value":"jonathan@bottlebooks.me: @bottlebooks/bottlebooks-site-rr/src/pages/[locale]/collections/[collectionId]/_layout.tsx","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputType"}},{"kind":"Field","name":{"kind":"Name","value":"vars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]} as unknown as DocumentNode<CollectionLayoutProviderFragment, unknown>;
export const ProductShopExternalButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductShopExternalButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineShop"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineShop"}}]}}]}}]} as unknown as DocumentNode<ProductShopExternalButtonFragment, unknown>;
export const ProductShopButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductShopButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductShopExternalButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductShopExternalButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineShop"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineShop"}}]}}]}}]} as unknown as DocumentNode<ProductShopButtonFragment, unknown>;
export const ProductActionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductShopButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductShopExternalButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineShop"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineShop"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductShopButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductShopExternalButton"}}]}}]} as unknown as DocumentNode<ProductActionsFragment, unknown>;
export const ProductImageSmall_ListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageSmall_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_120,h_120,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}}]} as unknown as DocumentNode<ProductImageSmall_ListFragment, unknown>;
export const ProductImage_ListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_100,h_150,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}}]} as unknown as DocumentNode<ProductImage_ListFragment, unknown>;
export const ProductPriceExactFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}}]} as unknown as DocumentNode<ProductPriceExactFragment, unknown>;
export const ProductPriceRangeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}}]} as unknown as DocumentNode<ProductPriceRangeFragment, unknown>;
export const ProductPriceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}}]} as unknown as DocumentNode<ProductPriceFragment, unknown>;
export const ProductHeaderPriceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}}]} as unknown as DocumentNode<ProductHeaderPriceFragment, unknown>;
export const ProductVarietiesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}}]} as unknown as DocumentNode<ProductVarietiesFragment, unknown>;
export const ProductHeaderProductVarietiesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}}]} as unknown as DocumentNode<ProductHeaderProductVarietiesFragment, unknown>;
export const ProductRegionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}}]} as unknown as DocumentNode<ProductRegionFragment, unknown>;
export const ProductHeaderProductRegionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}}]} as unknown as DocumentNode<ProductHeaderProductRegionFragment, unknown>;
export const ProductNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}]} as unknown as DocumentNode<ProductNameFragment, unknown>;
export const ProductHeaderProductNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}]} as unknown as DocumentNode<ProductHeaderProductNameFragment, unknown>;
export const ProductProducerNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductProducerNameFragment, unknown>;
export const ProductHeaderDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductHeaderDetailsFragment, unknown>;
export const ProductHeaderProducerNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductHeaderProducerNameFragment, unknown>;
export const ProductPageHeaderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPageHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]} as unknown as DocumentNode<ProductPageHeaderFragment, unknown>;
export const Search_ExhibitorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Search_ExhibitorFragment, unknown>;
export const Search_ProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"specialClassification"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Search_ProductFragment, unknown>;
export const ProductImageLarge_ListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_300,h_600,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}}]} as unknown as DocumentNode<ProductImageLarge_ListFragment, unknown>;
export const UseSiteSearchFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useSiteSearch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Exhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Product"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"specialClassification"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_300,h_600,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}}]} as unknown as DocumentNode<UseSiteSearchFragment, unknown>;
export const BrandLogoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]} as unknown as DocumentNode<BrandLogoFragment, unknown>;
export const ExhibitorListRowSmallFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]} as unknown as DocumentNode<ExhibitorListRowSmallFragment, unknown>;
export const ExhibitorSearchResultsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSearchResults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorListRowSmall"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]} as unknown as DocumentNode<ExhibitorSearchResultsFragment, unknown>;
export const ProductListRowSmallFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_300,h_600,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}}]} as unknown as DocumentNode<ProductListRowSmallFragment, unknown>;
export const ProductSearchResultsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSearchResults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRowSmall"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_300,h_600,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ProductSearchResultsFragment, unknown>;
export const SiteSearchFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteSearch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"useSiteSearch"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorSearchResults"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSearchResults"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"specialClassification"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_300,h_600,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useSiteSearch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Exhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Product"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSearchResults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorListRowSmall"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSearchResults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRowSmall"}}]}}]} as unknown as DocumentNode<SiteSearchFragment, unknown>;
export const BrandLogoLargeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogoLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}}]} as unknown as DocumentNode<BrandLogoLargeFragment, unknown>;
export const ToExhibitorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"toExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogoLarge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogoLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}}]} as unknown as DocumentNode<ToExhibitorFragment, unknown>;
export const ToProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"toProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"subregion"}},{"kind":"Field","name":{"kind":"Name","value":"denomination"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Product"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_300,h_600,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"specialClassification"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ToProductFragment, unknown>;
export const UseEventDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useEventData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteSearch"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"toExhibitor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"toProduct"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"specialClassification"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_300,h_600,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useSiteSearch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Exhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Product"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSearchResults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorListRowSmall"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSearchResults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRowSmall"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogoLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteSearch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"useSiteSearch"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorSearchResults"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSearchResults"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"toExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogoLarge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"toProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"subregion"}},{"kind":"Field","name":{"kind":"Name","value":"denomination"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Product"}}]}}]}}]} as unknown as DocumentNode<UseEventDataFragment, unknown>;
export const UseLink_Exhibitor_BrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_exhibitor_Brand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"brandId"}}]}}]} as unknown as DocumentNode<UseLink_Exhibitor_BrandFragment, unknown>;
export const UseLink_Exhibitor_AbstractBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_exhibitor_AbstractBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbstractBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"brandId"}}]}}]} as unknown as DocumentNode<UseLink_Exhibitor_AbstractBrandFragment, unknown>;
export const UseLink_RegisteredProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}}]} as unknown as DocumentNode<UseLink_RegisteredProductFragment, unknown>;
export const UseLink_RegisteredBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}}]}}]} as unknown as DocumentNode<UseLink_RegisteredBrandFragment, unknown>;
export const ProfilePageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}}]}}]} as unknown as DocumentNode<ProfilePageFragment, unknown>;
export const SeoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SEO"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<SeoFragment, unknown>;
export const ThemeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ThemeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menuItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"60"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SEO"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SEO"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<ThemeFragmentFragment, unknown>;
export const BrandBannerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}}]} as unknown as DocumentNode<BrandBannerFragment, unknown>;
export const BrandNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<BrandNameFragment, unknown>;
export const BrandRegionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]} as unknown as DocumentNode<BrandRegionFragment, unknown>;
export const BrandHeaderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]} as unknown as DocumentNode<BrandHeaderFragment, unknown>;
export const ExhibitorHeaderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}}]}}]} as unknown as DocumentNode<ExhibitorHeaderFragment, unknown>;
export const UseLink_ExhibitorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exhibitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}}]}}]} as unknown as DocumentNode<UseLink_ExhibitorFragment, unknown>;
export const ExhibitorHeaderRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogoLarge"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Exhibitor"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogoLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exhibitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}}]}}]} as unknown as DocumentNode<ExhibitorHeaderRowFragment, unknown>;
export const BrandSocialMedia_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}}]} as unknown as DocumentNode<BrandSocialMedia_ProfileFragment, unknown>;
export const BrandAddressSection_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}}]} as unknown as DocumentNode<BrandAddressSection_ProfileFragment, unknown>;
export const BrandShopsSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandShopsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"onlineShopUrl"},"name":{"kind":"Name","value":"onlineShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"INTERNATIONAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"telephoneOrdersUrl"},"name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"emailOrdersUrl"},"name":{"kind":"Name","value":"emailOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"onlineShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<BrandShopsSectionFragment, unknown>;
export const RegistrationInfoSheetButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationInfoSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<RegistrationInfoSheetButtonFragment, unknown>;
export const ExhibitorActions_SingleRegistrationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorActions_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationInfoSheetButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationInfoSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ExhibitorActions_SingleRegistrationFragment, unknown>;
export const ExhibitorStand_SingleRegistrationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}}]} as unknown as DocumentNode<ExhibitorStand_SingleRegistrationFragment, unknown>;
export const BrandWinemakerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemakerName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"overviewOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandWinemakerFragment, unknown>;
export const BrandViticulturistFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandViticulturist"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viticulturistNames"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"viticulturistNames","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"overviewOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandViticulturistFragment, unknown>;
export const BrandRegionSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegionSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}}]} as unknown as DocumentNode<BrandRegionSectionFragment, unknown>;
export const BrandDescription_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}}]} as unknown as DocumentNode<BrandDescription_ProfileFragment, unknown>;
export const BrandFounded_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}}]} as unknown as DocumentNode<BrandFounded_ProfileFragment, unknown>;
export const BrandAnnualProduction_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}}]} as unknown as DocumentNode<BrandAnnualProduction_ProfileFragment, unknown>;
export const BrandTourism_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}}]} as unknown as DocumentNode<BrandTourism_ProfileFragment, unknown>;
export const GalleryLightboxFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}}]} as unknown as DocumentNode<GalleryLightboxFragment, unknown>;
export const GalleryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}}]} as unknown as DocumentNode<GalleryFragment, unknown>;
export const BrandGallery_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}}]} as unknown as DocumentNode<BrandGallery_ProfileFragment, unknown>;
export const VideoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}}]} as unknown as DocumentNode<VideoFragment, unknown>;
export const BrandVideos_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}}]} as unknown as DocumentNode<BrandVideos_ProfileFragment, unknown>;
export const BrandDetailsSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandViticulturist"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegionSection"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemakerName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"overviewOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandViticulturist"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viticulturistNames"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"viticulturistNames","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"overviewOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegionSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}}]} as unknown as DocumentNode<BrandDetailsSectionFragment, unknown>;
export const UserProfileCardAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}}]} as unknown as DocumentNode<UserProfileCardAvatarFragment, unknown>;
export const UserProfileCardDisplayNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]} as unknown as DocumentNode<UserProfileCardDisplayNameFragment, unknown>;
export const UserProfileCardCompanyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]} as unknown as DocumentNode<UserProfileCardCompanyFragment, unknown>;
export const UserProfileCardLinkedInFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}}]} as unknown as DocumentNode<UserProfileCardLinkedInFragment, unknown>;
export const RequestChatButtonFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]} as unknown as DocumentNode<RequestChatButtonFormFragment, unknown>;
export const RequestChatButtonDialogFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}}]} as unknown as DocumentNode<RequestChatButtonDialogFragment, unknown>;
export const RequestChatButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}}]} as unknown as DocumentNode<RequestChatButtonFragment, unknown>;
export const TimeslotFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}}]} as unknown as DocumentNode<TimeslotFieldFragment, unknown>;
export const TimeslotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}}]} as unknown as DocumentNode<TimeslotFragment, unknown>;
export const RequestMeetingButtonInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}}]} as unknown as DocumentNode<RequestMeetingButtonInfoFragment, unknown>;
export const RequestMeetingButtonTimeFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}}]} as unknown as DocumentNode<RequestMeetingButtonTimeFormFragment, unknown>;
export const RequestMeetingButtonProfileFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}}]} as unknown as DocumentNode<RequestMeetingButtonProfileFormFragment, unknown>;
export const RequestMeetingDialogFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}}]} as unknown as DocumentNode<RequestMeetingDialogFragment, unknown>;
export const RequestMeetingButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}}]} as unknown as DocumentNode<RequestMeetingButtonFragment, unknown>;
export const UserProfileCardHorizontalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardHorizontal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardDisplayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardLinkedIn"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}}]} as unknown as DocumentNode<UserProfileCardHorizontalFragment, unknown>;
export const RepresentativesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Representatives"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"representatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-22","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"representativeId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardHorizontal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardHorizontal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardDisplayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardLinkedIn"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButton"}}]}}]} as unknown as DocumentNode<RepresentativesFragment, unknown>;
export const BrandDistributorsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDistributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"byCountry"},"name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"country"}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"EnumValue","value":"fieldValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"fieldValue"}},{"kind":"Field","alias":{"kind":"Name","value":"distributors"},"name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nin"},"value":{"kind":"ListValue","values":[{"kind":"NullValue"},{"kind":"StringValue","value":"","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}}]} as unknown as DocumentNode<BrandDistributorsFragment, unknown>;
export const ContactFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}}]} as unknown as DocumentNode<ContactFragment, unknown>;
export const DistributionContactsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}}]} as unknown as DocumentNode<DistributionContactsFragment, unknown>;
export const ExhibitorCard_RegistrationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]} as unknown as DocumentNode<ExhibitorCard_RegistrationFragment, unknown>;
export const RegisteredBrand_SeekingDistributionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}}]} as unknown as DocumentNode<RegisteredBrand_SeekingDistributionFragment, unknown>;
export const RegisteredBrand_BrandLogoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]} as unknown as DocumentNode<RegisteredBrand_BrandLogoFragment, unknown>;
export const RegisteredBrand_BrandRegionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]} as unknown as DocumentNode<RegisteredBrand_BrandRegionFragment, unknown>;
export const ProducerCard_RegisteredBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]} as unknown as DocumentNode<ProducerCard_RegisteredBrandFragment, unknown>;
export const RegisteredBrand_PresentedBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}}]} as unknown as DocumentNode<RegisteredBrand_PresentedBrandFragment, unknown>;
export const PresentedBrandsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PresentedBrandsFragment, unknown>;
export const BrandDetailsSection_RegisteredBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}}]} as unknown as DocumentNode<BrandDetailsSection_RegisteredBrandFragment, unknown>;
export const ExhibitorSectionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Representatives"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemakerName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"overviewOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandViticulturist"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viticulturistNames"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"viticulturistNames","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"overviewOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegionSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardHorizontal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardDisplayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardLinkedIn"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandViticulturist"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegionSection"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Representatives"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"representatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-22","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"representativeId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardHorizontal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDistributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"byCountry"},"name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"country"}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"EnumValue","value":"fieldValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"fieldValue"}},{"kind":"Field","alias":{"kind":"Name","value":"distributors"},"name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nin"},"value":{"kind":"ListValue","values":[{"kind":"NullValue"},{"kind":"StringValue","value":"","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}}]} as unknown as DocumentNode<ExhibitorSectionsFragment, unknown>;
export const ProductLabel_RegisteredProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}}]} as unknown as DocumentNode<ProductLabel_RegisteredProductFragment, unknown>;
export const HasDifferentExhibitorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<HasDifferentExhibitorFragment, unknown>;
export const ProductStandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}}]} as unknown as DocumentNode<ProductStandFragment, unknown>;
export const ProductHeaderDetails_RegisteredProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}}]} as unknown as DocumentNode<ProductHeaderDetails_RegisteredProductFragment, unknown>;
export const ImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]} as unknown as DocumentNode<ImageFragment, unknown>;
export const ProductImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]} as unknown as DocumentNode<ProductImageFragment, unknown>;
export const ProductCard_RegisteredProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}}]} as unknown as DocumentNode<ProductCard_RegisteredProductFragment, unknown>;
export const ProductListRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ProductListRowFragment, unknown>;
export const ProductCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}}]} as unknown as DocumentNode<ProductCardFragment, unknown>;
export const UseLink_ProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}}]}}]}}]} as unknown as DocumentNode<UseLink_ProductFragment, unknown>;
export const ExhibitorPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandBanner"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorHeaderRow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandShopsSection"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorActions_SingleRegistration"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorSections"}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRow"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Product"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogoLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exhibitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationInfoSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemakerName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"overviewOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandViticulturist"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viticulturistNames"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"viticulturistNames","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"overviewOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegionSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandViticulturist"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegionSection"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardHorizontal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardDisplayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardLinkedIn"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Representatives"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"representatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-22","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"representativeId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardHorizontal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDistributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"byCountry"},"name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"country"}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"EnumValue","value":"fieldValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"fieldValue"}},{"kind":"Field","alias":{"kind":"Name","value":"distributors"},"name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nin"},"value":{"kind":"ListValue","values":[{"kind":"NullValue"},{"kind":"StringValue","value":"","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogoLarge"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Exhibitor"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandShopsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"onlineShopUrl"},"name":{"kind":"Name","value":"onlineShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"INTERNATIONAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"telephoneOrdersUrl"},"name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"emailOrdersUrl"},"name":{"kind":"Name","value":"emailOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"onlineShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorActions_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationInfoSheetButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Representatives"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}}]}}]}}]} as unknown as DocumentNode<ExhibitorPageFragment, unknown>;
export const ExhibitorPage_EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorPage"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogoLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exhibitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogoLarge"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Exhibitor"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandShopsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"onlineShopUrl"},"name":{"kind":"Name","value":"onlineShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"INTERNATIONAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"telephoneOrdersUrl"},"name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"emailOrdersUrl"},"name":{"kind":"Name","value":"emailOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"onlineShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationInfoSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorActions_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationInfoSheetButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemakerName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"overviewOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandViticulturist"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viticulturistNames"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"viticulturistNames","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"overviewOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegionSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandViticulturist"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegionSection"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardHorizontal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardDisplayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardLinkedIn"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Representatives"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"representatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-22","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"representativeId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardHorizontal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDistributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"byCountry"},"name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"country"}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"EnumValue","value":"fieldValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"fieldValue"}},{"kind":"Field","alias":{"kind":"Name","value":"distributors"},"name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nin"},"value":{"kind":"ListValue","values":[{"kind":"NullValue"},{"kind":"StringValue","value":"","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Representatives"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandBanner"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorHeaderRow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandShopsSection"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorActions_SingleRegistration"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorSections"}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRow"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Product"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExhibitorPage_EventFragment, unknown>;
export const ExhibitorFiltersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"exhibitorFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characteristicsSummary"}},{"kind":"Field","name":{"kind":"Name","value":"regionSummary"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"priceRangeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"primaryVarietySummary"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"distributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ExhibitorFiltersFragment, unknown>;
export const ExhibitorsPage_RegistrationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorsPage_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}}]} as unknown as DocumentNode<ExhibitorsPage_RegistrationFragment, unknown>;
export const FieldValueFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FieldValueFragment, unknown>;
export const ExhibitorDetail_ExhibitorsPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorDetail_ExhibitorsPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"exhibitorFilters"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorsPage_Registration"}},{"kind":"Field","alias":{"kind":"Name","value":"isHidden"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"isHidden","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"exhibitorFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characteristicsSummary"}},{"kind":"Field","name":{"kind":"Name","value":"regionSummary"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"priceRangeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"primaryVarietySummary"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"distributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorsPage_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ExhibitorDetail_ExhibitorsPageFragment, unknown>;
export const ExhibitorFilters_RegisteredBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"exhibitorFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}}]} as unknown as DocumentNode<ExhibitorFilters_RegisteredBrandFragment, unknown>;
export const ExhibitorCard_RegisteredBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}}]} as unknown as DocumentNode<ExhibitorCard_RegisteredBrandFragment, unknown>;
export const ExhibitorsPage_RegisteredBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorsPage_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}}]}}]} as unknown as DocumentNode<ExhibitorsPage_RegisteredBrandFragment, unknown>;
export const ExhibitorsPage_EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorsPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorDetail_ExhibitorsPage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"exhibitorFilters_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorsPage_RegisteredBrand"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"exhibitorFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characteristicsSummary"}},{"kind":"Field","name":{"kind":"Name","value":"regionSummary"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"priceRangeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"primaryVarietySummary"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"distributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorsPage_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorDetail_ExhibitorsPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"exhibitorFilters"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorsPage_Registration"}},{"kind":"Field","alias":{"kind":"Name","value":"isHidden"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"isHidden","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"exhibitorFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorsPage_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_RegisteredBrand"}}]}}]} as unknown as DocumentNode<ExhibitorsPage_EventFragment, unknown>;
export const EventBannerImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBannerImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}}]} as unknown as DocumentNode<EventBannerImageFragment, unknown>;
export const EventBannerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBannerImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBannerImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}}]} as unknown as DocumentNode<EventBannerFragment, unknown>;
export const EventHeaderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","alias":{"kind":"Name","value":"htmlDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"HTML"}}]}]}}]} as unknown as DocumentNode<EventHeaderFragment, unknown>;
export const EventVideosFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}}]} as unknown as DocumentNode<EventVideosFragment, unknown>;
export const FilesSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"208"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"294"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]} as unknown as DocumentNode<FilesSectionFragment, unknown>;
export const LandingPageSectionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPageSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBanner"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventHeader"}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventVideos"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesSection"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBannerImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBannerImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","alias":{"kind":"Name","value":"htmlDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"HTML"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"208"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"294"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]} as unknown as DocumentNode<LandingPageSectionsFragment, unknown>;
export const LandingPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPageSections"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBannerImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBannerImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","alias":{"kind":"Name","value":"htmlDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"HTML"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"208"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"294"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPageSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBanner"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventHeader"}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventVideos"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesSection"}}]}}]}}]}}]} as unknown as DocumentNode<LandingPageFragment, unknown>;
export const FeaturedBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"660"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]} as unknown as DocumentNode<FeaturedBrandFragment, unknown>;
export const BrandCarouselFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"660"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}}]} as unknown as DocumentNode<BrandCarouselFragment, unknown>;
export const FeaturedExhibitorsSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedExhibitorsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandCarousel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"660"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedBrand"}}]}}]} as unknown as DocumentNode<FeaturedExhibitorsSectionFragment, unknown>;
export const LandingPageSections_FeaturedExhibitorsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPageSections_FeaturedExhibitors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedExhibitorsSection"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"660"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedExhibitorsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandCarousel"}}]}}]} as unknown as DocumentNode<LandingPageSections_FeaturedExhibitorsFragment, unknown>;
export const LandingPage_FeaturedExhibitorsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPage_FeaturedExhibitors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPageSections_FeaturedExhibitors"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"660"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedExhibitorsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandCarousel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPageSections_FeaturedExhibitors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedExhibitorsSection"}}]}}]} as unknown as DocumentNode<LandingPage_FeaturedExhibitorsFragment, unknown>;
export const LandingPage_EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPage"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPage_FeaturedExhibitors"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBannerImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBannerImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","alias":{"kind":"Name","value":"htmlDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"HTML"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"208"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"294"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPageSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBanner"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventHeader"}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventVideos"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesSection"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"660"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedExhibitorsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandCarousel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPageSections_FeaturedExhibitors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedExhibitorsSection"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPageSections"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPage_FeaturedExhibitors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPageSections_FeaturedExhibitors"}}]}}]} as unknown as DocumentNode<LandingPage_EventFragment, unknown>;
export const Lists_EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Lists_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectionId"},"name":{"kind":"Name","value":"eventId"}}]}}]} as unknown as DocumentNode<Lists_EventFragment, unknown>;
export const ProfilePage_EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectionId"},"name":{"kind":"Name","value":"eventId"}}]}}]} as unknown as DocumentNode<ProfilePage_EventFragment, unknown>;
export const TastingNotes_EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TastingNotes_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectionId"},"name":{"kind":"Name","value":"eventId"}}]}}]} as unknown as DocumentNode<TastingNotes_EventFragment, unknown>;
export const RegisteredBrand_ProducerHeaderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}}]} as unknown as DocumentNode<RegisteredBrand_ProducerHeaderFragment, unknown>;
export const RegisteredBrand_ProducerHeaderRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}}]}}]} as unknown as DocumentNode<RegisteredBrand_ProducerHeaderRowFragment, unknown>;
export const BrandFilters_RegisteredBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}},{"kind":"Field","alias":{"kind":"Name","value":"highlights"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"highlights","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<BrandFilters_RegisteredBrandFragment, unknown>;
export const ProducerFilters_RegisteredBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}},{"kind":"Field","alias":{"kind":"Name","value":"highlights"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"highlights","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}}]} as unknown as DocumentNode<ProducerFilters_RegisteredBrandFragment, unknown>;
export const RegistrationContactsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorContacts"},"name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}}]} as unknown as DocumentNode<RegistrationContactsFragment, unknown>;
export const Registration_ProducerStandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Registration_ProducerStandFragment, unknown>;
export const Registration_ProducerHeaderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerStand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Registration_ProducerHeaderFragment, unknown>;
export const Registration_ProducerHeaderRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerStand"}}]}}]} as unknown as DocumentNode<Registration_ProducerHeaderRowFragment, unknown>;
export const BrandDetailsSection_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}}]} as unknown as DocumentNode<BrandDetailsSection_ProfileFragment, unknown>;
export const RegisteredBrand_ProducerPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeaderRow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRow"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorSections"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerHeaderRow"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandShopsSection"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}},{"kind":"Field","alias":{"kind":"Name","value":"highlights"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"highlights","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemakerName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"overviewOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandViticulturist"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viticulturistNames"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"viticulturistNames","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"overviewOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegionSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandViticulturist"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegionSection"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardHorizontal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardDisplayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardLinkedIn"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Representatives"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"representatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-22","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"representativeId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardHorizontal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDistributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"byCountry"},"name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"country"}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"EnumValue","value":"fieldValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"fieldValue"}},{"kind":"Field","alias":{"kind":"Name","value":"distributors"},"name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nin"},"value":{"kind":"ListValue","values":[{"kind":"NullValue"},{"kind":"StringValue","value":"","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerStand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Representatives"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorContacts"},"name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandShopsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"onlineShopUrl"},"name":{"kind":"Name","value":"onlineShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"INTERNATIONAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"telephoneOrdersUrl"},"name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"emailOrdersUrl"},"name":{"kind":"Name","value":"emailOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"onlineShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<RegisteredBrand_ProducerPageFragment, unknown>;
export const ProducerPage_EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"producerId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_ProducerPage"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandBanner"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"distributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}},{"kind":"Field","alias":{"kind":"Name","value":"highlights"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"highlights","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDistributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"byCountry"},"name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"country"}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"EnumValue","value":"fieldValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"fieldValue"}},{"kind":"Field","alias":{"kind":"Name","value":"distributors"},"name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nin"},"value":{"kind":"ListValue","values":[{"kind":"NullValue"},{"kind":"StringValue","value":"","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemakerName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"overviewOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandViticulturist"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viticulturistNames"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"viticulturistNames","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"overviewOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegionSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandViticulturist"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegionSection"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardHorizontal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardDisplayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardLinkedIn"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Representatives"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"representatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-22","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"representativeId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardHorizontal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Representatives"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorContacts"},"name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerStand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandShopsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"onlineShopUrl"},"name":{"kind":"Name","value":"onlineShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"INTERNATIONAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"telephoneOrdersUrl"},"name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"emailOrdersUrl"},"name":{"kind":"Name","value":"emailOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"onlineShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeaderRow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRow"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorSections"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerHeaderRow"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandShopsSection"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}}]} as unknown as DocumentNode<ProducerPage_EventFragment, unknown>;
export const ProducerListRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]} as unknown as DocumentNode<ProducerListRowFragment, unknown>;
export const BrandFiltersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbstractBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]} as unknown as DocumentNode<BrandFiltersFragment, unknown>;
export const ProducerFiltersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbstractBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]} as unknown as DocumentNode<ProducerFiltersFragment, unknown>;
export const ProducersPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerListRow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbstractBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters"}}]}}]} as unknown as DocumentNode<ProducersPageFragment, unknown>;
export const ProducersPage_RegisteredBrandFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}},{"kind":"Field","alias":{"kind":"Name","value":"highlights"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"highlights","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"}}]}}]} as unknown as DocumentNode<ProducersPage_RegisteredBrandFragment, unknown>;
export const ProducerDetail_ProducersPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerDetail_ProducersPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducersPage_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}},{"kind":"Field","alias":{"kind":"Name","value":"highlights"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"highlights","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"}}]}}]} as unknown as DocumentNode<ProducerDetail_ProducersPageFragment, unknown>;
export const ProducerListRow_RegistrationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerListRow_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProducerListRow_RegistrationFragment, unknown>;
export const ProducersPage_RegistrationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerListRow_Registration"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerListRow_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProducersPage_RegistrationFragment, unknown>;
export const ProducersPage_EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"producers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducersPage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerDetail_ProducersPage"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducersPage_Registration"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbstractBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}},{"kind":"Field","alias":{"kind":"Name","value":"highlights"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"highlights","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerListRow_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerListRow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerDetail_ProducersPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducersPage_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerListRow_Registration"}}]}}]} as unknown as DocumentNode<ProducersPage_EventFragment, unknown>;
export const ProductDescriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"consumerDescription"}},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}}]} as unknown as DocumentNode<ProductDescriptionFragment, unknown>;
export const ProductAwardsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAwards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"award"}},{"kind":"Field","name":{"kind":"Name","value":"medal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherAwards"}}]}}]} as unknown as DocumentNode<ProductAwardsFragment, unknown>;
export const ProductTastingNotesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTastingNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tastingNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noteDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"publication"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]} as unknown as DocumentNode<ProductTastingNotesFragment, unknown>;
export const ProductCertificationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCertifications"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isVegan"}},{"kind":"Field","name":{"kind":"Name","value":"isVegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"isCertifiedOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isGmoFree"}},{"kind":"Field","name":{"kind":"Name","value":"localCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internationalCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherSustainabilityCertifications"}}]}}]} as unknown as DocumentNode<ProductCertificationsFragment, unknown>;
export const ProductAnalyticsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAnalytics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alcohol"}},{"kind":"Field","name":{"kind":"Name","value":"residualSugar"}},{"kind":"Field","name":{"kind":"Name","value":"totalAcidity"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designation"}},{"kind":"Field","name":{"kind":"Name","value":"pH"}}]}}]}}]} as unknown as DocumentNode<ProductAnalyticsFragment, unknown>;
export const ProductGalleryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductGallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}}]} as unknown as DocumentNode<ProductGalleryFragment, unknown>;
export const ProductVideosFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}}]} as unknown as DocumentNode<ProductVideosFragment, unknown>;
export const ProductRangeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productRange"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rangeDescription"}}]}}]}}]} as unknown as DocumentNode<ProductRangeFragment, unknown>;
export const WineWinemakerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemaker"}}]}}]}}]} as unknown as DocumentNode<WineWinemakerFragment, unknown>;
export const WineSoilTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineSoilType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}}]}}]} as unknown as DocumentNode<WineSoilTypeFragment, unknown>;
export const WineVineyardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVineyard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyard"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardInformation"}},{"kind":"Field","name":{"kind":"Name","value":"pruning"}},{"kind":"Field","name":{"kind":"Name","value":"training"}},{"kind":"Field","name":{"kind":"Name","value":"vineDensity"}},{"kind":"Field","name":{"kind":"Name","value":"yield"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardAge"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}},{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"soilTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]} as unknown as DocumentNode<WineVineyardFragment, unknown>;
export const OldVineProjectVineyardFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OldVineProjectVineyardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"plantDates"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDate","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uniqueStoryOverview"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"uniqueStoryOverviewOrSellingPointsAboutThisWine50WordsMax","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"howAreTheseVineyardsTrellised"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"howAreTheseVineyardsTrellised","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areTheseVineyardsIrrigated"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"areTheseVineyardsIrrigated","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"plantDatesPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDatesPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hectaresPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"hectaresPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"interplantingPercentage"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"interplantingPercentageRoughYoungVinesOfTotalVineyard","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tonnagePerHectarePerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"tonnagePerHectarePerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rootstockPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"rootstockPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<OldVineProjectVineyardFieldsFragment, unknown>;
export const WineHarvestNotesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineHarvestNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"harvestNotes"}}]}}]} as unknown as DocumentNode<WineHarvestNotesFragment, unknown>;
export const WineViticultureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineViticulture"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viticulture"}}]}}]} as unknown as DocumentNode<WineViticultureFragment, unknown>;
export const WineVinificationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVinification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vinification"}},{"kind":"Field","name":{"kind":"Name","value":"malolacticFermentation"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationType"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationVesselTypes"}},{"kind":"Field","name":{"kind":"Name","value":"wholeClusterPercent"}}]}}]} as unknown as DocumentNode<WineVinificationFragment, unknown>;
export const WineMaturationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineMaturation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maturation"}},{"kind":"Field","name":{"kind":"Name","value":"monthsInBottle"}},{"kind":"Field","name":{"kind":"Name","value":"oakInfluence"}}]}}]} as unknown as DocumentNode<WineMaturationFragment, unknown>;
export const ProductPalateDescriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalateDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateDescription"}}]}}]} as unknown as DocumentNode<ProductPalateDescriptionFragment, unknown>;
export const ProductPairingDescriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPairingDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pairingDescription"}}]}}]} as unknown as DocumentNode<ProductPairingDescriptionFragment, unknown>;
export const BottleVariantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BottleVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductBottleVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GTIN"}},{"kind":"Field","name":{"kind":"Name","value":"bottleSize"}},{"kind":"Field","name":{"kind":"Name","value":"bottleNetWeight"}},{"kind":"Field","name":{"kind":"Name","value":"closureType"}}]}}]} as unknown as DocumentNode<BottleVariantFragment, unknown>;
export const ProductBottleVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBottleVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BottleVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BottleVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductBottleVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GTIN"}},{"kind":"Field","name":{"kind":"Name","value":"bottleSize"}},{"kind":"Field","name":{"kind":"Name","value":"bottleNetWeight"}},{"kind":"Field","name":{"kind":"Name","value":"closureType"}}]}}]} as unknown as DocumentNode<ProductBottleVariantsFragment, unknown>;
export const PackagingVariantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackagingVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPackagingVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottlesPerCase"}},{"kind":"Field","name":{"kind":"Name","value":"GTIN"}}]}}]} as unknown as DocumentNode<PackagingVariantFragment, unknown>;
export const ProductPackagingVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPackagingVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packagingVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackagingVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackagingVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPackagingVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottlesPerCase"}},{"kind":"Field","name":{"kind":"Name","value":"GTIN"}}]}}]} as unknown as DocumentNode<ProductPackagingVariantsFragment, unknown>;
export const ProductColorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apparentColor"}},{"kind":"Field","name":{"kind":"Name","value":"appearanceIntensity"}}]}}]} as unknown as DocumentNode<ProductColorFragment, unknown>;
export const ProductAromasFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAromas"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aromaIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFruit"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFloral"}},{"kind":"Field","name":{"kind":"Name","value":"aromaSpice"}},{"kind":"Field","name":{"kind":"Name","value":"aromaWood"}}]}}]} as unknown as DocumentNode<ProductAromasFragment, unknown>;
export const ProductPalateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateAcidity"}},{"kind":"Field","name":{"kind":"Name","value":"palateBody"}},{"kind":"Field","name":{"kind":"Name","value":"palateTannins"}}]}}]} as unknown as DocumentNode<ProductPalateFragment, unknown>;
export const ProductSensoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSensory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductColor"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAromas"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apparentColor"}},{"kind":"Field","name":{"kind":"Name","value":"appearanceIntensity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAromas"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aromaIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFruit"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFloral"}},{"kind":"Field","name":{"kind":"Name","value":"aromaSpice"}},{"kind":"Field","name":{"kind":"Name","value":"aromaWood"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateAcidity"}},{"kind":"Field","name":{"kind":"Name","value":"palateBody"}},{"kind":"Field","name":{"kind":"Name","value":"palateTannins"}}]}}]} as unknown as DocumentNode<ProductSensoryFragment, unknown>;
export const ProductDetailsSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAwards"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTastingNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCertifications"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAnalytics"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductGallery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVideos"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRange"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineSoilType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVineyard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OldVineProjectVineyardFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineHarvestNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineViticulture"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVinification"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineMaturation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalateDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPairingDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBottleVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPackagingVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSensory"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BottleVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductBottleVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GTIN"}},{"kind":"Field","name":{"kind":"Name","value":"bottleSize"}},{"kind":"Field","name":{"kind":"Name","value":"bottleNetWeight"}},{"kind":"Field","name":{"kind":"Name","value":"closureType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackagingVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPackagingVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottlesPerCase"}},{"kind":"Field","name":{"kind":"Name","value":"GTIN"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apparentColor"}},{"kind":"Field","name":{"kind":"Name","value":"appearanceIntensity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAromas"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aromaIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFruit"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFloral"}},{"kind":"Field","name":{"kind":"Name","value":"aromaSpice"}},{"kind":"Field","name":{"kind":"Name","value":"aromaWood"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateAcidity"}},{"kind":"Field","name":{"kind":"Name","value":"palateBody"}},{"kind":"Field","name":{"kind":"Name","value":"palateTannins"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"consumerDescription"}},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAwards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"award"}},{"kind":"Field","name":{"kind":"Name","value":"medal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherAwards"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTastingNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tastingNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noteDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"publication"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCertifications"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isVegan"}},{"kind":"Field","name":{"kind":"Name","value":"isVegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"isCertifiedOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isGmoFree"}},{"kind":"Field","name":{"kind":"Name","value":"localCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internationalCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherSustainabilityCertifications"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAnalytics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alcohol"}},{"kind":"Field","name":{"kind":"Name","value":"residualSugar"}},{"kind":"Field","name":{"kind":"Name","value":"totalAcidity"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designation"}},{"kind":"Field","name":{"kind":"Name","value":"pH"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductGallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productRange"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rangeDescription"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemaker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineSoilType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVineyard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyard"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardInformation"}},{"kind":"Field","name":{"kind":"Name","value":"pruning"}},{"kind":"Field","name":{"kind":"Name","value":"training"}},{"kind":"Field","name":{"kind":"Name","value":"vineDensity"}},{"kind":"Field","name":{"kind":"Name","value":"yield"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardAge"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}},{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"soilTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OldVineProjectVineyardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"plantDates"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDate","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uniqueStoryOverview"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"uniqueStoryOverviewOrSellingPointsAboutThisWine50WordsMax","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"howAreTheseVineyardsTrellised"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"howAreTheseVineyardsTrellised","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areTheseVineyardsIrrigated"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"areTheseVineyardsIrrigated","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"plantDatesPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDatesPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hectaresPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"hectaresPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"interplantingPercentage"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"interplantingPercentageRoughYoungVinesOfTotalVineyard","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tonnagePerHectarePerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"tonnagePerHectarePerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rootstockPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"rootstockPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineHarvestNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"harvestNotes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineViticulture"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viticulture"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVinification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vinification"}},{"kind":"Field","name":{"kind":"Name","value":"malolacticFermentation"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationType"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationVesselTypes"}},{"kind":"Field","name":{"kind":"Name","value":"wholeClusterPercent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineMaturation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maturation"}},{"kind":"Field","name":{"kind":"Name","value":"monthsInBottle"}},{"kind":"Field","name":{"kind":"Name","value":"oakInfluence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalateDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPairingDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pairingDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBottleVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BottleVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPackagingVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packagingVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackagingVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSensory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductColor"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAromas"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalate"}}]}}]} as unknown as DocumentNode<ProductDetailsSectionFragment, unknown>;
export const ProductSections_RegisteredProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSections_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationContacts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetailsSection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"consumerDescription"}},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAwards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"award"}},{"kind":"Field","name":{"kind":"Name","value":"medal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherAwards"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTastingNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tastingNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noteDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"publication"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCertifications"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isVegan"}},{"kind":"Field","name":{"kind":"Name","value":"isVegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"isCertifiedOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isGmoFree"}},{"kind":"Field","name":{"kind":"Name","value":"localCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internationalCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherSustainabilityCertifications"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAnalytics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alcohol"}},{"kind":"Field","name":{"kind":"Name","value":"residualSugar"}},{"kind":"Field","name":{"kind":"Name","value":"totalAcidity"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designation"}},{"kind":"Field","name":{"kind":"Name","value":"pH"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductGallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productRange"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rangeDescription"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemaker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineSoilType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVineyard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyard"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardInformation"}},{"kind":"Field","name":{"kind":"Name","value":"pruning"}},{"kind":"Field","name":{"kind":"Name","value":"training"}},{"kind":"Field","name":{"kind":"Name","value":"vineDensity"}},{"kind":"Field","name":{"kind":"Name","value":"yield"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardAge"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}},{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"soilTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OldVineProjectVineyardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"plantDates"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDate","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uniqueStoryOverview"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"uniqueStoryOverviewOrSellingPointsAboutThisWine50WordsMax","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"howAreTheseVineyardsTrellised"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"howAreTheseVineyardsTrellised","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areTheseVineyardsIrrigated"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"areTheseVineyardsIrrigated","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"plantDatesPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDatesPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hectaresPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"hectaresPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"interplantingPercentage"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"interplantingPercentageRoughYoungVinesOfTotalVineyard","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tonnagePerHectarePerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"tonnagePerHectarePerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rootstockPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"rootstockPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineHarvestNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"harvestNotes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineViticulture"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viticulture"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVinification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vinification"}},{"kind":"Field","name":{"kind":"Name","value":"malolacticFermentation"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationType"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationVesselTypes"}},{"kind":"Field","name":{"kind":"Name","value":"wholeClusterPercent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineMaturation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maturation"}},{"kind":"Field","name":{"kind":"Name","value":"monthsInBottle"}},{"kind":"Field","name":{"kind":"Name","value":"oakInfluence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalateDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPairingDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pairingDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BottleVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductBottleVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GTIN"}},{"kind":"Field","name":{"kind":"Name","value":"bottleSize"}},{"kind":"Field","name":{"kind":"Name","value":"bottleNetWeight"}},{"kind":"Field","name":{"kind":"Name","value":"closureType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBottleVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BottleVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackagingVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPackagingVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottlesPerCase"}},{"kind":"Field","name":{"kind":"Name","value":"GTIN"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPackagingVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packagingVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackagingVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apparentColor"}},{"kind":"Field","name":{"kind":"Name","value":"appearanceIntensity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAromas"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aromaIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFruit"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFloral"}},{"kind":"Field","name":{"kind":"Name","value":"aromaSpice"}},{"kind":"Field","name":{"kind":"Name","value":"aromaWood"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateAcidity"}},{"kind":"Field","name":{"kind":"Name","value":"palateBody"}},{"kind":"Field","name":{"kind":"Name","value":"palateTannins"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSensory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductColor"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAromas"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorContacts"},"name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAwards"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTastingNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCertifications"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAnalytics"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductGallery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVideos"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRange"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineSoilType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVineyard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OldVineProjectVineyardFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineHarvestNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineViticulture"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVinification"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineMaturation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalateDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPairingDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBottleVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPackagingVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSensory"}}]}}]} as unknown as DocumentNode<ProductSections_RegisteredProductFragment, unknown>;
export const ProductInfoSheetButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"templateId"},"value":{"kind":"StringValue","value":"Bottlebooks/InfoSheetWithQRCodes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ProductInfoSheetButtonFragment, unknown>;
export const ProductActions_RegisteredProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductActions_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInfoSheetButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"templateId"},"value":{"kind":"StringValue","value":"Bottlebooks/InfoSheetWithQRCodes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ProductActions_RegisteredProductFragment, unknown>;
export const UseLink_ProducerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Producer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}}]} as unknown as DocumentNode<UseLink_ProducerFragment, unknown>;
export const EventProductPageHeaderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPageHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Producer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Producer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}}]} as unknown as DocumentNode<EventProductPageHeaderFragment, unknown>;
export const ProductImageLargeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_150,h_300,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}}]} as unknown as DocumentNode<ProductImageLargeFragment, unknown>;
export const EventProductPageHeaderRegisteredProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPageHeaderRegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventProductPageHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labelImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backLabelImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Producer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPageHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Producer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_150,h_300,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}}]} as unknown as DocumentNode<EventProductPageHeaderRegisteredProductFragment, unknown>;
export const BrandBanner_RegistrationProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner_RegistrationProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}}]} as unknown as DocumentNode<BrandBanner_RegistrationProfileFragment, unknown>;
export const RelatedProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]} as unknown as DocumentNode<RelatedProductFragment, unknown>;
export const RelatedProductsSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedProductsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}}]}}]} as unknown as DocumentNode<RelatedProductsSectionFragment, unknown>;
export const EventProductPage_RegisteredProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPage_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSections_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductActions_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventProductPageHeaderRegisteredProduct"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitor"},"name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandBanner_RegistrationProfile"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedProductsSection"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorContacts"},"name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"consumerDescription"}},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAwards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"award"}},{"kind":"Field","name":{"kind":"Name","value":"medal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherAwards"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTastingNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tastingNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noteDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"publication"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCertifications"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isVegan"}},{"kind":"Field","name":{"kind":"Name","value":"isVegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"isCertifiedOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isGmoFree"}},{"kind":"Field","name":{"kind":"Name","value":"localCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internationalCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherSustainabilityCertifications"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAnalytics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alcohol"}},{"kind":"Field","name":{"kind":"Name","value":"residualSugar"}},{"kind":"Field","name":{"kind":"Name","value":"totalAcidity"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designation"}},{"kind":"Field","name":{"kind":"Name","value":"pH"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductGallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productRange"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rangeDescription"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemaker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineSoilType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVineyard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyard"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardInformation"}},{"kind":"Field","name":{"kind":"Name","value":"pruning"}},{"kind":"Field","name":{"kind":"Name","value":"training"}},{"kind":"Field","name":{"kind":"Name","value":"vineDensity"}},{"kind":"Field","name":{"kind":"Name","value":"yield"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardAge"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}},{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"soilTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OldVineProjectVineyardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"plantDates"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDate","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uniqueStoryOverview"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"uniqueStoryOverviewOrSellingPointsAboutThisWine50WordsMax","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"howAreTheseVineyardsTrellised"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"howAreTheseVineyardsTrellised","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areTheseVineyardsIrrigated"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"areTheseVineyardsIrrigated","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"plantDatesPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDatesPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hectaresPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"hectaresPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"interplantingPercentage"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"interplantingPercentageRoughYoungVinesOfTotalVineyard","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tonnagePerHectarePerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"tonnagePerHectarePerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rootstockPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"rootstockPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineHarvestNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"harvestNotes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineViticulture"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viticulture"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVinification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vinification"}},{"kind":"Field","name":{"kind":"Name","value":"malolacticFermentation"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationType"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationVesselTypes"}},{"kind":"Field","name":{"kind":"Name","value":"wholeClusterPercent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineMaturation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maturation"}},{"kind":"Field","name":{"kind":"Name","value":"monthsInBottle"}},{"kind":"Field","name":{"kind":"Name","value":"oakInfluence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalateDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPairingDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pairingDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BottleVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductBottleVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GTIN"}},{"kind":"Field","name":{"kind":"Name","value":"bottleSize"}},{"kind":"Field","name":{"kind":"Name","value":"bottleNetWeight"}},{"kind":"Field","name":{"kind":"Name","value":"closureType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBottleVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BottleVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackagingVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPackagingVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottlesPerCase"}},{"kind":"Field","name":{"kind":"Name","value":"GTIN"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPackagingVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packagingVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackagingVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apparentColor"}},{"kind":"Field","name":{"kind":"Name","value":"appearanceIntensity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAromas"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aromaIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFruit"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFloral"}},{"kind":"Field","name":{"kind":"Name","value":"aromaSpice"}},{"kind":"Field","name":{"kind":"Name","value":"aromaWood"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateAcidity"}},{"kind":"Field","name":{"kind":"Name","value":"palateBody"}},{"kind":"Field","name":{"kind":"Name","value":"palateTannins"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSensory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductColor"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAromas"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAwards"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTastingNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCertifications"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAnalytics"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductGallery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVideos"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRange"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineSoilType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVineyard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OldVineProjectVineyardFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineHarvestNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineViticulture"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVinification"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineMaturation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalateDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPairingDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBottleVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPackagingVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSensory"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"templateId"},"value":{"kind":"StringValue","value":"Bottlebooks/InfoSheetWithQRCodes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Producer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPageHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Producer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_150,h_300,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSections_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationContacts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetailsSection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductActions_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInfoSheetButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPageHeaderRegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventProductPageHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labelImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backLabelImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner_RegistrationProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedProductsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedProduct"}}]}}]} as unknown as DocumentNode<EventProductPage_RegisteredProductFragment, unknown>;
export const ProductDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventProductPage_RegisteredProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorContacts"},"name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"consumerDescription"}},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAwards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"award"}},{"kind":"Field","name":{"kind":"Name","value":"medal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherAwards"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTastingNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tastingNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noteDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"publication"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCertifications"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isVegan"}},{"kind":"Field","name":{"kind":"Name","value":"isVegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"isCertifiedOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isGmoFree"}},{"kind":"Field","name":{"kind":"Name","value":"localCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internationalCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherSustainabilityCertifications"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAnalytics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alcohol"}},{"kind":"Field","name":{"kind":"Name","value":"residualSugar"}},{"kind":"Field","name":{"kind":"Name","value":"totalAcidity"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designation"}},{"kind":"Field","name":{"kind":"Name","value":"pH"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductGallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productRange"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rangeDescription"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemaker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineSoilType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVineyard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyard"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardInformation"}},{"kind":"Field","name":{"kind":"Name","value":"pruning"}},{"kind":"Field","name":{"kind":"Name","value":"training"}},{"kind":"Field","name":{"kind":"Name","value":"vineDensity"}},{"kind":"Field","name":{"kind":"Name","value":"yield"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardAge"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}},{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"soilTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OldVineProjectVineyardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"plantDates"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDate","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uniqueStoryOverview"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"uniqueStoryOverviewOrSellingPointsAboutThisWine50WordsMax","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"howAreTheseVineyardsTrellised"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"howAreTheseVineyardsTrellised","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areTheseVineyardsIrrigated"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"areTheseVineyardsIrrigated","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"plantDatesPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDatesPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hectaresPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"hectaresPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"interplantingPercentage"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"interplantingPercentageRoughYoungVinesOfTotalVineyard","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tonnagePerHectarePerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"tonnagePerHectarePerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rootstockPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"rootstockPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineHarvestNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"harvestNotes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineViticulture"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viticulture"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVinification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vinification"}},{"kind":"Field","name":{"kind":"Name","value":"malolacticFermentation"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationType"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationVesselTypes"}},{"kind":"Field","name":{"kind":"Name","value":"wholeClusterPercent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineMaturation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maturation"}},{"kind":"Field","name":{"kind":"Name","value":"monthsInBottle"}},{"kind":"Field","name":{"kind":"Name","value":"oakInfluence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalateDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPairingDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pairingDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BottleVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductBottleVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GTIN"}},{"kind":"Field","name":{"kind":"Name","value":"bottleSize"}},{"kind":"Field","name":{"kind":"Name","value":"bottleNetWeight"}},{"kind":"Field","name":{"kind":"Name","value":"closureType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBottleVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BottleVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackagingVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPackagingVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottlesPerCase"}},{"kind":"Field","name":{"kind":"Name","value":"GTIN"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPackagingVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packagingVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackagingVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apparentColor"}},{"kind":"Field","name":{"kind":"Name","value":"appearanceIntensity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAromas"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aromaIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFruit"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFloral"}},{"kind":"Field","name":{"kind":"Name","value":"aromaSpice"}},{"kind":"Field","name":{"kind":"Name","value":"aromaWood"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateAcidity"}},{"kind":"Field","name":{"kind":"Name","value":"palateBody"}},{"kind":"Field","name":{"kind":"Name","value":"palateTannins"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSensory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductColor"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAromas"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAwards"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTastingNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCertifications"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAnalytics"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductGallery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVideos"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRange"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineSoilType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVineyard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OldVineProjectVineyardFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineHarvestNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineViticulture"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVinification"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineMaturation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalateDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPairingDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBottleVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPackagingVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSensory"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSections_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationContacts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetailsSection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"templateId"},"value":{"kind":"StringValue","value":"Bottlebooks/InfoSheetWithQRCodes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductActions_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInfoSheetButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Producer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPageHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Producer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_150,h_300,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPageHeaderRegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventProductPageHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labelImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backLabelImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner_RegistrationProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedProductsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPage_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSections_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductActions_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventProductPageHeaderRegisteredProduct"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitor"},"name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandBanner_RegistrationProfile"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedProductsSection"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductDetailFragment, unknown>;
export const ProductFilters_EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductFilters_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductFilters_EventFragment, unknown>;
export const ProductsPageBase_CollectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductsPageBase_Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductFilters_Event"}},{"kind":"Field","name":{"kind":"Name","value":"isProductSortingEnabled"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductFilters_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsPageBase_CollectionFragment, unknown>;
export const GroupedProductsCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupedProductsCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]} as unknown as DocumentNode<GroupedProductsCardFragment, unknown>;
export const ProductsPageBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductsPageBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupedProductsCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupedProductsCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}}]}}]}}]} as unknown as DocumentNode<ProductsPageBaseFragment, unknown>;
export const ProductFiltersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regionHierarchy"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineType"}},{"kind":"Field","name":{"kind":"Name","value":"characteristics"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}},{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Spirit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spiritType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}}]} as unknown as DocumentNode<ProductFiltersFragment, unknown>;
export const ProductsPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductsPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"isProductSortingEnabled"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductsPageBase_Collection"}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductsPageBase"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"productFilters"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductFilters_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupedProductsCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductsPageBase_Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductFilters_Event"}},{"kind":"Field","name":{"kind":"Name","value":"isProductSortingEnabled"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductsPageBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupedProductsCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regionHierarchy"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineType"}},{"kind":"Field","name":{"kind":"Name","value":"characteristics"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}},{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Spirit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spiritType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}}]}}]}}]} as unknown as DocumentNode<ProductsPageFragment, unknown>;
export const WorkspaceCollections_WorkspaceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkspaceCollections_Workspace"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workspace"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"visibilityStatus"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkspaceCollections_WorkspaceFragment, unknown>;
export const UpdateAttendeeProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAttendeeProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"response"},"name":{"kind":"Name","value":"updateAttendeeProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAttendeeProfileMutation, UpdateAttendeeProfileMutationVariables>;
export const CmsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CMSPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","alias":{"kind":"Name","value":"outputConfigurations"},"name":{"kind":"Name","value":"_unstable_allOutputConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experimentalKey"},"value":{"kind":"StringValue","value":"jonathan@bottlebooks.me: @bottlebooks/bottlebooks-site-rr/src/pages/[locale]/collections/[collectionId]/_layout.tsx","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputType"}},{"kind":"Field","name":{"kind":"Name","value":"vars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CmsPageQuery, CmsPageQueryVariables>;
export const CollectionLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ThemeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","alias":{"kind":"Name","value":"outputConfigurations"},"name":{"kind":"Name","value":"_unstable_allOutputConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experimentalKey"},"value":{"kind":"StringValue","value":"jonathan@bottlebooks.me: @bottlebooks/bottlebooks-site-rr/src/pages/[locale]/collections/[collectionId]/_layout.tsx","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputType"}},{"kind":"Field","name":{"kind":"Name","value":"vars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SEO"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ThemeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menuItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"60"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"40"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SEO"}}]}}]} as unknown as DocumentNode<CollectionLayoutQuery, CollectionLayoutQueryVariables>;
export const CollectionSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"useEventData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Search_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"specialClassification"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge_list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_300,h_600,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useSiteSearch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Exhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Product"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSearchResults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorListRowSmall"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRowSmall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSearchResults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRowSmall"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteSearch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"useSiteSearch"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorSearchResults"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSearchResults"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogoLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"toExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogoLarge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"toProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"subregion"}},{"kind":"Field","name":{"kind":"Name","value":"denomination"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge_list"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Search_Product"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useEventData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteSearch"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"toExhibitor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"toProduct"}}]}}]}}]}}]} as unknown as DocumentNode<CollectionSearchQuery, CollectionSearchQueryVariables>;
export const ExhibitorPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExhibitorPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorPage_Event"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogoLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"184"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#FFF0","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"quality"},"value":{"kind":"EnumValue","value":"BEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Exhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exhibitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogoLarge"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Exhibitor"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandShopsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"onlineShopUrl"},"name":{"kind":"Name","value":"onlineShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"INTERNATIONAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"telephoneOrdersUrl"},"name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"emailOrdersUrl"},"name":{"kind":"Name","value":"emailOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"onlineShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationInfoSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorActions_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationInfoSheetButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemakerName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"overviewOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandViticulturist"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viticulturistNames"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"viticulturistNames","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"overviewOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegionSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandViticulturist"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegionSection"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardHorizontal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardDisplayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardLinkedIn"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Representatives"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"representatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-22","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"representativeId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardHorizontal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDistributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"byCountry"},"name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"country"}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"EnumValue","value":"fieldValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"fieldValue"}},{"kind":"Field","alias":{"kind":"Name","value":"distributors"},"name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nin"},"value":{"kind":"ListValue","values":[{"kind":"NullValue"},{"kind":"StringValue","value":"","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Representatives"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandBanner"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorHeaderRow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandShopsSection"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorActions_SingleRegistration"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorSections"}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRow"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Product"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorPage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExhibitorPageQuery, ExhibitorPageQueryVariables>;
export const ExhibitorsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExhibitorsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorsPage_Event"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"exhibitorFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characteristicsSummary"}},{"kind":"Field","name":{"kind":"Name","value":"regionSummary"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"priceRangeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"primaryVarietySummary"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"distributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorsPage_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorDetail_ExhibitorsPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"exhibitorFilters"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorsPage_Registration"}},{"kind":"Field","alias":{"kind":"Name","value":"isHidden"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"isHidden","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"exhibitorFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorsPage_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorsPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorDetail_ExhibitorsPage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"exhibitorFilters_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorsPage_RegisteredBrand"}}]}}]}}]}}]} as unknown as DocumentNode<ExhibitorsPageQuery, ExhibitorsPageQueryVariables>;
export const LandingPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LandingPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPage_Event"}},{"kind":"Field","alias":{"kind":"Name","value":"outputConfigurations"},"name":{"kind":"Name","value":"_unstable_allOutputConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experimentalKey"},"value":{"kind":"StringValue","value":"jonathan@bottlebooks.me: @bottlebooks/bottlebooks-site-rr/src/pages/[locale]/collections/[collectionId]/_layout.tsx","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputType"}},{"kind":"Field","name":{"kind":"Name","value":"vars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBannerImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBannerImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","alias":{"kind":"Name","value":"htmlDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"HTML"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"208"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"294"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPageSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBanner"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventHeader"}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventVideos"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesSection"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPageSections"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"660"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeaturedExhibitorsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandCarousel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPageSections_FeaturedExhibitors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeaturedExhibitorsSection"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPage_FeaturedExhibitors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPageSections_FeaturedExhibitors"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPage"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPage_FeaturedExhibitors"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LandingPageQuery, LandingPageQueryVariables>;
export const ListsRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListsRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectionId"},"name":{"kind":"Name","value":"eventId"}}]}}]}}]} as unknown as DocumentNode<ListsRouteQuery, ListsRouteQueryVariables>;
export const ProfileRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectionId"},"name":{"kind":"Name","value":"eventId"}}]}}]}}]} as unknown as DocumentNode<ProfileRouteQuery, ProfileRouteQueryVariables>;
export const TastingNotesRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TastingNotesRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectionId"},"name":{"kind":"Name","value":"eventId"}}]}}]}}]} as unknown as DocumentNode<TastingNotesRouteQuery, TastingNotesRouteQueryVariables>;
export const ProducerPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProducerPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"producerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerPage_Event"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}},{"kind":"Field","alias":{"kind":"Name","value":"highlights"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"highlights","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDistributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"byCountry"},"name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"country"}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"EnumValue","value":"fieldValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"fieldValue"}},{"kind":"Field","alias":{"kind":"Name","value":"distributors"},"name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nin"},"value":{"kind":"ListValue","values":[{"kind":"NullValue"},{"kind":"StringValue","value":"","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemakerName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"overviewOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfWinemakers"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfWinemakers","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandViticulturist"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"viticulturistNames"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"viticulturistNames","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"overviewOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"overviewOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"imageOfViticulturists"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"imageOfViticulturists","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegionSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandViticulturist"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegionSection"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardCompany"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardLinkedIn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInURL"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudName"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButtonDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestChatButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButtonDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeslotField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"timeslotLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Timeslot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeetingTimeslot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMinutes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeslotField"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingTimeslots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-25","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Timeslot"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonTimeForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButtonProfileForm"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestMeetingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingDialog"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileCardHorizontal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteUserProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardDisplayName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardCompany"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardLinkedIn"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestChatButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestMeetingButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Representatives"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"representatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experiment"},"value":{"kind":"StringValue","value":"california-networking","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"experimentToken"},"value":{"kind":"StringValue","value":"Used in @bottlebooks/gatsby-theme-event, added by bernhard@unserwein.at at 2023-02-22","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"representativeId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileCardHorizontal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Representatives"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorContacts"},"name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerStand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Registration_ProducerHeaderRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Registration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerHeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandShopsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"onlineShopUrl"},"name":{"kind":"Name","value":"onlineShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"INTERNATIONAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"telephoneOrdersUrl"},"name":{"kind":"Name","value":"telephoneOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"emailOrdersUrl"},"name":{"kind":"Name","value":"emailOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"onlineShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalShops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"linkText"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_ProducerPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_ProducerHeaderRow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductListRow"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorSections"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Registration_ProducerHeaderRow"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDistributors"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandShopsSection"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"producerId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_ProducerPage"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandBanner"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"distributionInCountries"}},{"kind":"Field","name":{"kind":"Name","value":"seekingDistributionInCountries"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProducerPageQuery, ProducerPageQueryVariables>;
export const ProducersPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProducersPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducersPage_Event"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbstractBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerListRow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"integer"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"YesNoFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"values"},"name":{"kind":"Name","value":"value"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeoverFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerId"}},{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}},{"kind":"Field","alias":{"kind":"Name","value":"highlights"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"highlights","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldValue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerFilters_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerDetail_ProducersPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducersPage_RegisteredBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerListRow_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerListRow_Registration"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducersPage_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"producers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducersPage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerDetail_ProducersPage"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducersPage_Registration"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProducersPageQuery, ProducersPageQueryVariables>;
export const ProductPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetail"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","alias":{"kind":"Name","value":"websiteUrl"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"websiteText"},"name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"TEXT"}}]},{"kind":"Field","name":{"kind":"Name","value":"contactTypes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegistrationContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorContacts"},"name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"consumerDescription"}},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAwards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"award"}},{"kind":"Field","name":{"kind":"Name","value":"medal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherAwards"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTastingNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tastingNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noteDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"publication"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCertifications"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isVegan"}},{"kind":"Field","name":{"kind":"Name","value":"isVegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"isCertifiedOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganic"}},{"kind":"Field","name":{"kind":"Name","value":"isGmoFree"}},{"kind":"Field","name":{"kind":"Name","value":"localCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internationalCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherSustainabilityCertifications"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAnalytics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alcohol"}},{"kind":"Field","name":{"kind":"Name","value":"residualSugar"}},{"kind":"Field","name":{"kind":"Name","value":"totalAcidity"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designation"}},{"kind":"Field","name":{"kind":"Name","value":"pH"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GalleryLightbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"fullPreview"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"full"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"background"},"value":{"kind":"StringValue","value":"#fff","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"image"},"name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"360"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GalleryLightbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductGallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVideos"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productRange"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rangeDescription"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineWinemaker"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winemaker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineSoilType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVineyard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyard"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardInformation"}},{"kind":"Field","name":{"kind":"Name","value":"pruning"}},{"kind":"Field","name":{"kind":"Name","value":"training"}},{"kind":"Field","name":{"kind":"Name","value":"vineDensity"}},{"kind":"Field","name":{"kind":"Name","value":"yield"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardAge"}},{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}},{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"soilTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soilType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OldVineProjectVineyardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"plantDates"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDate","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vineyardElevation"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uniqueStoryOverview"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"uniqueStoryOverviewOrSellingPointsAboutThisWine50WordsMax","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"howAreTheseVineyardsTrellised"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"howAreTheseVineyardsTrellised","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areTheseVineyardsIrrigated"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"areTheseVineyardsIrrigated","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"plantDatesPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"plantDatesPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hectaresPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"hectaresPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"interplantingPercentage"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"interplantingPercentageRoughYoungVinesOfTotalVineyard","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tonnagePerHectarePerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"tonnagePerHectarePerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rootstockPerVarietal"},"name":{"kind":"Name","value":"customFieldValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"rootstockPerVarietalPleaseList","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextFieldValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineHarvestNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"harvestNotes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineViticulture"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viticulture"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineVinification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vinification"}},{"kind":"Field","name":{"kind":"Name","value":"malolacticFermentation"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationType"}},{"kind":"Field","name":{"kind":"Name","value":"fermentationVesselTypes"}},{"kind":"Field","name":{"kind":"Name","value":"wholeClusterPercent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WineMaturation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maturation"}},{"kind":"Field","name":{"kind":"Name","value":"monthsInBottle"}},{"kind":"Field","name":{"kind":"Name","value":"oakInfluence"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalateDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPairingDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pairingDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BottleVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductBottleVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GTIN"}},{"kind":"Field","name":{"kind":"Name","value":"bottleSize"}},{"kind":"Field","name":{"kind":"Name","value":"bottleNetWeight"}},{"kind":"Field","name":{"kind":"Name","value":"closureType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBottleVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BottleVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackagingVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPackagingVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottlesPerCase"}},{"kind":"Field","name":{"kind":"Name","value":"GTIN"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPackagingVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packagingVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackagingVariant"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apparentColor"}},{"kind":"Field","name":{"kind":"Name","value":"appearanceIntensity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAromas"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aromaIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFruit"}},{"kind":"Field","name":{"kind":"Name","value":"aromaFloral"}},{"kind":"Field","name":{"kind":"Name","value":"aromaSpice"}},{"kind":"Field","name":{"kind":"Name","value":"aromaWood"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPalate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"palateAcidity"}},{"kind":"Field","name":{"kind":"Name","value":"palateBody"}},{"kind":"Field","name":{"kind":"Name","value":"palateTannins"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSensory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductColor"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAromas"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetailsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAwards"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTastingNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCertifications"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAnalytics"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductGallery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVideos"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRange"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineWinemaker"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineSoilType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVineyard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OldVineProjectVineyardFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineHarvestNotes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineViticulture"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineVinification"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WineMaturation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPalateDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPairingDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBottleVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPackagingVariants"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSensory"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSections_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationContacts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetailsSection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInfoSheetButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"templateId"},"value":{"kind":"StringValue","value":"Bottlebooks/InfoSheetWithQRCodes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductActions_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInfoSheetButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useLink_Producer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPageHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"useLink_Producer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageLarge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raw_transformation"},"value":{"kind":"StringValue","value":"e_trim:20/w_150,h_300,c_pad,b_rgb:fff0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPageHeaderRegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventProductPageHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageLarge"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labelImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backLabelImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandBanner_RegistrationProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"fluid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2560"}},{"kind":"Argument","name":{"kind":"Name","value":"maxHeight"},"value":{"kind":"IntValue","value":"720"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"FILL"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"FACES_AUTO"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DistributionContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorCard_Registration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorStand_SingleRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandRegion"}},{"kind":"Field","name":{"kind":"Name","value":"offeringTypes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeekingDistribution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorCard_Registration"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_SeekingDistribution"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandLogo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_BrandRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerCard_RegisteredBrand"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"distributorsCount"},"name":{"kind":"Name","value":"distributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PresentedBrands"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DistributionContacts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegisteredBrand_PresentedBrand"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredBrand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PresentedBrands"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDescription_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandFounded_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"founded"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualProductionWine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandTourism_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"hospitalityOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyleOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorExperienceOfferings"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languagesSpoken"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandGallery_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"galleryImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Gallery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandVideos_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandDetailsSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDescription_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandFounded_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAnnualProduction_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandTourism_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandGallery_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandVideos_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandSocialMedia_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookUrl"},"name":{"kind":"Name","value":"facebook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"instagramUrl"},"name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"twitterUrl"},"name":{"kind":"Name","value":"twitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"youtubeUrl"},"name":{"kind":"Name","value":"youtube"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"URL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAddressSection_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandSocialMedia_Profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedProductsSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedProduct"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventProductPage_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSections_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductActions_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventProductPageHeaderRegisteredProduct"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitor"},"name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandBanner_RegistrationProfile"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"producerId"},"name":{"kind":"Name","value":"brandId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_RegisteredBrand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandDetailsSection_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAddressSection_Profile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedProductsSection"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitorId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventProductPage_RegisteredProduct"}}]}}]} as unknown as DocumentNode<ProductPageQuery, ProductPageQueryVariables>;
export const ProductsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductsPage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductFilters_Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductsPageBase_Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductFilters_Event"}},{"kind":"Field","name":{"kind":"Name","value":"isProductSortingEnabled"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HasDifferentExhibitor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductStand"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"standTypeWithNumber"}},{"kind":"Field","name":{"kind":"Name","value":"roomName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceExact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPriceRange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceRangeImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"375"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"PAD"}},{"kind":"Argument","name":{"kind":"Name","value":"gravity"},"value":{"kind":"EnumValue","value":"WEST"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcSet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceExact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPriceRange"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductRegion"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProducerName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderProductVarieties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVarieties"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasDifferentExhibitor"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProducerName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductHeaderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductVarieties"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductRegion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProducerName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudinaryAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductLabel_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails_RegisteredProduct"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductHeaderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupedProductsCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandLogo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductsPageBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCard_RegisteredProduct"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupedProductsCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegisteredProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"flightName"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","alias":{"kind":"Name","value":"exhibitorId"},"name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyCode"},"name":{"kind":"Name","value":"currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"priceStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"sortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regionHierarchy"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Wine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineType"}},{"kind":"Field","name":{"kind":"Name","value":"characteristics"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"removeNonVintage"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryName"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"LOCALIZED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"countryCode"},"name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]},{"kind":"Field","name":{"kind":"Name","value":"denomination"}},{"kind":"Field","name":{"kind":"Name","value":"grapeVarieties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"varietyName"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Spirit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spiritType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductStand"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductsPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"isProductSortingEnabled"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductsPageBase_Collection"}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductsPageBase"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"bottleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"productFilters"}}]}}]}}]}}]} as unknown as DocumentNode<ProductsPageQuery, ProductsPageQueryVariables>;
export const WorkspaceCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceCollections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkspaceCollections_Workspace"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkspaceCollections_Workspace"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workspace"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"visibilityStatus"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkspaceCollectionsQuery, WorkspaceCollectionsQueryVariables>;
export const CollectionLocaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionLocale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"locales"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"EnumValue","value":"RAW"}}]}]}}]}}]} as unknown as DocumentNode<CollectionLocaleQuery, CollectionLocaleQueryVariables>;
export const CollectionsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsListQuery, CollectionsListQueryVariables>;